/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as LandingRouteImport } from './routes/landing'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedSplatRouteImport } from './routes/_authenticated/$'
import { Route as AuthenticatedCustomerPortalRouteRouteImport } from './routes/_authenticated/customer-portal/route'
import { Route as AuthenticatedHomeRouteImport } from './routes/_authenticated/home'
import { Route as AuthenticatedMonitoringRouteRouteImport } from './routes/_authenticated/monitoring/route'
import { Route as AuthenticatedNextRouteRouteImport } from './routes/_authenticated/next/route'
import { Route as AuthenticatedProject_creationRouteImport } from './routes/_authenticated/project_creation'
import { Route as AuthenticatedPurchaseOrdersRouteImport } from './routes/_authenticated/purchase-orders'
import { Route as AuthenticatedRfqsRouteImport } from './routes/_authenticated/rfqs'
import { Route as AuthenticatedRiskManagementRouteRouteImport } from './routes/_authenticated/risk-management/route'
import { Route as AuthenticatedStartRouteImport } from './routes/_authenticated/start'
import { Route as AuthEnterEmailRouteImport } from './routes/auth/enter-email'
import { Route as AuthenticatedAppsSplatRouteImport } from './routes/_authenticated/apps/$'
import { Route as AuthenticatedAssembliesIndexRouteImport } from './routes/_authenticated/assemblies/index'
import { Route as AuthenticatedAssembliesAddAssemblyRouteImport } from './routes/_authenticated/assemblies/add-assembly'
import { Route as AuthenticatedComponentsImportRouteImport } from './routes/_authenticated/components/import'
import { Route as AuthenticatedCustomerPortalIndexRouteImport } from './routes/_authenticated/customer-portal/index'
import { Route as AuthenticatedCustomersIndexRouteImport } from './routes/_authenticated/customers/index'
import { Route as AuthenticatedCustomersCustomerIdRouteImport } from './routes/_authenticated/customers/$customerId'
import { Route as AuthenticatedCustomersImporterRouteImport } from './routes/_authenticated/customers/importer'
import { Route as AuthenticatedManufacturerSplatRouteImport } from './routes/_authenticated/manufacturer/$'
import { Route as AuthenticatedManufacturersManufacturerIdRouteImport } from './routes/_authenticated/manufacturers/$manufacturerId'
import { Route as AuthenticatedManufacturersSidebarRouteRouteImport } from './routes/_authenticated/manufacturers/_sidebar/route'
import { Route as AuthenticatedManufacturersImporterRouteImport } from './routes/_authenticated/manufacturers/importer'
import { Route as AuthenticatedManufacturingIndexRouteImport } from './routes/_authenticated/manufacturing/index'
import { Route as AuthenticatedManufacturingSidebarRouteRouteImport } from './routes/_authenticated/manufacturing/_sidebar/route'
import { Route as AuthenticatedManufacturingAddActivityRouteImport } from './routes/_authenticated/manufacturing/add-activity'
import { Route as AuthenticatedManufacturingAddDriverRouteImport } from './routes/_authenticated/manufacturing/add-driver'
import { Route as AuthenticatedManufacturingAddExpenseRouteImport } from './routes/_authenticated/manufacturing/add-expense'
import { Route as AuthenticatedManufacturingAddResourceRouteImport } from './routes/_authenticated/manufacturing/add-resource'
import { Route as AuthenticatedMonitoringSidebarRouteRouteImport } from './routes/_authenticated/monitoring/_sidebar/route'
import { Route as AuthenticatedMonitoringAnalysisRouteImport } from './routes/_authenticated/monitoring/analysis'
import { Route as AuthenticatedNegotiationsIndexRouteImport } from './routes/_authenticated/negotiations/index'
import { Route as AuthenticatedNegotiationsCreateRouteImport } from './routes/_authenticated/negotiations/create'
import { Route as AuthenticatedNextIndexRouteImport } from './routes/_authenticated/next/index'
import { Route as AuthenticatedNextSplatRouteImport } from './routes/_authenticated/next/$'
import { Route as AuthenticatedNextAlertsRouteImport } from './routes/_authenticated/next/alerts'
import { Route as AuthenticatedNextHomeRouteImport } from './routes/_authenticated/next/home'
import { Route as AuthenticatedNextLumiAgentRouteImport } from './routes/_authenticated/next/lumi-agent'
import { Route as AuthenticatedNextPurchaseOrdersRouteImport } from './routes/_authenticated/next/purchase-orders'
import { Route as AuthenticatedOffersMpnOfferImporterRouteImport } from './routes/_authenticated/offers/mpn-offer-importer'
import { Route as AuthenticatedOrdersUploadRouteImport } from './routes/_authenticated/orders/upload'
import { Route as AuthenticatedOrdersChar123OrderIdChar125RouteImport } from './routes/_authenticated/orders/{-$orderId}'
import { Route as AuthenticatedPartsIndexRouteImport } from './routes/_authenticated/parts/index'
import { Route as AuthenticatedPartsSidebarRouteRouteImport } from './routes/_authenticated/parts/_sidebar/route'
import { Route as AuthenticatedPartsOffTheShelfPartSearchRouteImport } from './routes/_authenticated/parts/off-the-shelf-part-search'
import { Route as AuthenticatedProjectsIndexRouteImport } from './routes/_authenticated/projects/index'
import { Route as AuthenticatedProjectsCreateRouteImport } from './routes/_authenticated/projects/create'
import { Route as AuthenticatedProjectsNewRouteImport } from './routes/_authenticated/projects/new'
import { Route as AuthenticatedQuoteRequestsExcelImporterRouteImport } from './routes/_authenticated/quote-requests/excel-importer'
import { Route as AuthenticatedRiskManagementIndexRouteImport } from './routes/_authenticated/risk-management/index'
import { Route as AuthenticatedRiskManagementGeoRiskRouteImport } from './routes/_authenticated/risk-management/geo-risk'
import { Route as AuthenticatedRiskManagementPcnsRouteImport } from './routes/_authenticated/risk-management/pcns'
import { Route as AuthenticatedRiskManagementRiskDigestRouteImport } from './routes/_authenticated/risk-management/risk-digest'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedSettingsMenuRouteRouteImport } from './routes/_authenticated/settings/_menu/route'
import { Route as AuthenticatedSettingsCompanyRouteImport } from './routes/_authenticated/settings/company'
import { Route as AuthenticatedSupplierPortalIndexRouteImport } from './routes/_authenticated/supplier-portal/index'
import { Route as AuthenticatedSupplierImporterRouteImport } from './routes/_authenticated/supplier/importer'
import { Route as AuthenticatedSuppliersSupplierAndStockLocationIdRouteImport } from './routes/_authenticated/suppliers/$supplierAndStockLocationId'
import { Route as AuthenticatedSuppliersSidebarRouteRouteImport } from './routes/_authenticated/suppliers/_sidebar/route'
import { Route as AuthenticatedSuppliersImporterRouteImport } from './routes/_authenticated/suppliers/importer'
import { Route as AuthenticatedTemplateSplatRouteImport } from './routes/_authenticated/template/$'
import { Route as AuthenticatedTemplatesIndexRouteImport } from './routes/_authenticated/templates/index'
import { Route as AuthenticatedTemplatesSidebarRouteRouteImport } from './routes/_authenticated/templates/_sidebar/route'
import { Route as AuthSignupCustomerRouteImport } from './routes/auth/signup/customer'
import { Route as AuthSignupInviteRouteImport } from './routes/auth/signup/invite'
import { Route as Authenticated3rdpartyDigikeyCallbackRouteImport } from './routes/_authenticated/3rdparty/digikey/callback'
import { Route as AuthenticatedAssembliesAssemblyIdIndexRouteImport } from './routes/_authenticated/assemblies/$assemblyId/index'
import { Route as AuthenticatedAssembliesAssemblyIdDashboardRouteImport } from './routes/_authenticated/assemblies/$assemblyId/dashboard'
import { Route as AuthenticatedAssembliesAssemblyIdDetailsRouteImport } from './routes/_authenticated/assemblies/$assemblyId/details'
import { Route as AuthenticatedAssembliesAssemblyIdEditRouteImport } from './routes/_authenticated/assemblies/$assemblyId/edit'
import { Route as AuthenticatedAssembliesAssemblyIdPcbRouteRouteImport } from './routes/_authenticated/assemblies/$assemblyId/pcb/route'
import { Route as AuthenticatedManufacturersSidebarIndexRouteImport } from './routes/_authenticated/manufacturers/_sidebar/index'
import { Route as AuthenticatedManufacturersSidebarLineCardRouteImport } from './routes/_authenticated/manufacturers/_sidebar/line-card'
import { Route as AuthenticatedManufacturingActivitiesCreateRouteImport } from './routes/_authenticated/manufacturing/activities/create'
import { Route as AuthenticatedManufacturingActivitySplatRouteImport } from './routes/_authenticated/manufacturing/activity/$'
import { Route as AuthenticatedManufacturingDriverSplatRouteImport } from './routes/_authenticated/manufacturing/driver/$'
import { Route as AuthenticatedManufacturingDriversCreateRouteImport } from './routes/_authenticated/manufacturing/drivers/create'
import { Route as AuthenticatedManufacturingExpenseSplatRouteImport } from './routes/_authenticated/manufacturing/expense/$'
import { Route as AuthenticatedManufacturingExpensesCreateRouteImport } from './routes/_authenticated/manufacturing/expenses/create'
import { Route as AuthenticatedManufacturingResourceSplatRouteImport } from './routes/_authenticated/manufacturing/resource/$'
import { Route as AuthenticatedManufacturingResourcesCreateRouteImport } from './routes/_authenticated/manufacturing/resources/create'
import { Route as AuthenticatedManufacturingTemplateSplatRouteImport } from './routes/_authenticated/manufacturing/template/$'
import { Route as AuthenticatedMonitoringSidebarIndexRouteImport } from './routes/_authenticated/monitoring/_sidebar/index'
import { Route as AuthenticatedMonitoringSidebarComponentSavingsRouteImport } from './routes/_authenticated/monitoring/_sidebar/component-savings'
import { Route as AuthenticatedMonitoringSidebarDataHealthRouteImport } from './routes/_authenticated/monitoring/_sidebar/data-health'
import { Route as AuthenticatedMonitoringSidebarOffersRouteImport } from './routes/_authenticated/monitoring/_sidebar/offers'
import { Route as AuthenticatedMonitoringSidebarOnboardingRouteImport } from './routes/_authenticated/monitoring/_sidebar/onboarding'
import { Route as AuthenticatedMonitoringAgentSplatRouteImport } from './routes/_authenticated/monitoring/agent/$'
import { Route as AuthenticatedMonitoringChartsChartIdRouteImport } from './routes/_authenticated/monitoring/charts/$chartId'
import { Route as AuthenticatedNegotiationsNegotiationIdIndexRouteImport } from './routes/_authenticated/negotiations/$negotiationId/index'
import { Route as AuthenticatedNegotiationsNegotiationIdSidebarRouteRouteImport } from './routes/_authenticated/negotiations/$negotiationId/_sidebar/route'
import { Route as AuthenticatedNextAppsSplatRouteImport } from './routes/_authenticated/next/apps/$'
import { Route as AuthenticatedNextAssembliesIndexRouteImport } from './routes/_authenticated/next/assemblies/index'
import { Route as AuthenticatedNextComponentsIndexRouteImport } from './routes/_authenticated/next/components/index'
import { Route as AuthenticatedNextComponentsLinkingRouteImport } from './routes/_authenticated/next/components/linking'
import { Route as AuthenticatedNextCustomersIndexRouteImport } from './routes/_authenticated/next/customers/index'
import { Route as AuthenticatedNextCustomersCustomerIdRouteImport } from './routes/_authenticated/next/customers/$customerId'
import { Route as AuthenticatedNextDemandsIndexRouteImport } from './routes/_authenticated/next/demands/index'
import { Route as AuthenticatedNextDemandsImporterRouteImport } from './routes/_authenticated/next/demands/importer'
import { Route as AuthenticatedNextManufacturersIndexRouteImport } from './routes/_authenticated/next/manufacturers/index'
import { Route as AuthenticatedNextManufacturersManufacturerIdRouteImport } from './routes/_authenticated/next/manufacturers/$manufacturerId'
import { Route as AuthenticatedNextManufacturersLineCardRouteImport } from './routes/_authenticated/next/manufacturers/line-card'
import { Route as AuthenticatedNextNegotiationsIndexRouteImport } from './routes/_authenticated/next/negotiations/index'
import { Route as AuthenticatedNextNegotiationsCreateRouteImport } from './routes/_authenticated/next/negotiations/create'
import { Route as AuthenticatedNextOfferImportsIndexRouteImport } from './routes/_authenticated/next/offer-imports/index'
import { Route as AuthenticatedNextOfferImportsOfferImportIdRouteImport } from './routes/_authenticated/next/offer-imports/$offerImportId'
import { Route as AuthenticatedNextOrdersUploadRouteImport } from './routes/_authenticated/next/orders/upload'
import { Route as AuthenticatedNextOrdersChar123OrderIdChar125RouteImport } from './routes/_authenticated/next/orders/{-$orderId}'
import { Route as AuthenticatedNextPartsIndexRouteImport } from './routes/_authenticated/next/parts/index'
import { Route as AuthenticatedNextPartsPartIdRouteRouteImport } from './routes/_authenticated/next/parts/$partId/route'
import { Route as AuthenticatedNextPartsSearchRouteImport } from './routes/_authenticated/next/parts/search'
import { Route as AuthenticatedNextProjectsIndexRouteImport } from './routes/_authenticated/next/projects/index'
import { Route as AuthenticatedNextProjectsProjectIdRouteRouteImport } from './routes/_authenticated/next/projects/$projectId/route'
import { Route as AuthenticatedNextProjectsCreateRouteImport } from './routes/_authenticated/next/projects/create'
import { Route as AuthenticatedNextQuoteRequestsIndexRouteImport } from './routes/_authenticated/next/quote-requests/index'
import { Route as AuthenticatedNextQuoteRequestsImporterRouteImport } from './routes/_authenticated/next/quote-requests/importer'
import { Route as AuthenticatedNextRiskManagementIndexRouteImport } from './routes/_authenticated/next/risk-management/index'
import { Route as AuthenticatedNextRiskManagementGeoRiskRouteImport } from './routes/_authenticated/next/risk-management/geo-risk'
import { Route as AuthenticatedNextRiskManagementPcnsRouteImport } from './routes/_authenticated/next/risk-management/pcns'
import { Route as AuthenticatedNextRiskManagementRiskDigestRouteImport } from './routes/_authenticated/next/risk-management/risk-digest'
import { Route as AuthenticatedNextSettingsIndexRouteImport } from './routes/_authenticated/next/settings/index'
import { Route as AuthenticatedNextSettingsMenuRouteRouteImport } from './routes/_authenticated/next/settings/_menu/route'
import { Route as AuthenticatedNextSettingsCompanyRouteImport } from './routes/_authenticated/next/settings/company'
import { Route as AuthenticatedNextSuppliersIndexRouteImport } from './routes/_authenticated/next/suppliers/index'
import { Route as AuthenticatedNextSuppliersSupplierAndStockLocationIdRouteImport } from './routes/_authenticated/next/suppliers/$supplierAndStockLocationId'
import { Route as AuthenticatedNextSuppliersStrategyRouteImport } from './routes/_authenticated/next/suppliers/strategy'
import { Route as AuthenticatedNextTemplatesExportRouteImport } from './routes/_authenticated/next/templates/export'
import { Route as AuthenticatedNextTemplatesPcbSpecificationRouteImport } from './routes/_authenticated/next/templates/pcb-specification'
import { Route as AuthenticatedPartsSidebarAlertsRouteImport } from './routes/_authenticated/parts/_sidebar/alerts'
import { Route as AuthenticatedPartsSidebarSearchRouteImport } from './routes/_authenticated/parts/_sidebar/search'
import { Route as AuthenticatedPartsComponentsComponentImporterRouteImport } from './routes/_authenticated/parts/components/component-importer'
import { Route as AuthenticatedPartsComponentsImporterRouteImport } from './routes/_authenticated/parts/components/importer'
import { Route as AuthenticatedPartsComponentsLinkingRouteImport } from './routes/_authenticated/parts/components/linking'
import { Route as AuthenticatedPartsDemandDemandImporterRouteImport } from './routes/_authenticated/parts/demand/demand-importer'
import { Route as AuthenticatedPartsDetailsPartIdRouteRouteImport } from './routes/_authenticated/parts/details/$partId/route'
import { Route as AuthenticatedPartsOffersAddRouteImport } from './routes/_authenticated/parts/offers/add'
import { Route as AuthenticatedPartsOffersCreateRouteImport } from './routes/_authenticated/parts/offers/create'
import { Route as AuthenticatedPartsOffersCsvImporterRouteImport } from './routes/_authenticated/parts/offers/csv-importer'
import { Route as AuthenticatedPartsQuoteRequestsExcelImporterRouteImport } from './routes/_authenticated/parts/quote-requests/excel-importer'
import { Route as AuthenticatedPartsQuoteRequestsImporterRouteImport } from './routes/_authenticated/parts/quote-requests/importer'
import { Route as AuthenticatedProjectsProjectIdIndexRouteImport } from './routes/_authenticated/projects/$projectId/index'
import { Route as AuthenticatedProjectsProjectIdDashboardRouteImport } from './routes/_authenticated/projects/$projectId/dashboard'
import { Route as AuthenticatedProjectsProjectIdEditRouteImport } from './routes/_authenticated/projects/$projectId/edit'
import { Route as AuthenticatedProjectsProjectIdQuotationRouteImport } from './routes/_authenticated/projects/$projectId/quotation'
import { Route as AuthenticatedRiskManagementLibraryHealthIndexRouteImport } from './routes/_authenticated/risk-management/library-health/index'
import { Route as AuthenticatedRiskManagementLibraryHealthAssembliesRouteImport } from './routes/_authenticated/risk-management/library-health/assemblies'
import { Route as AuthenticatedRiskManagementLibraryHealthComponentsRouteImport } from './routes/_authenticated/risk-management/library-health/components'
import { Route as AuthenticatedRiskManagementLibraryHealthPartsRouteImport } from './routes/_authenticated/risk-management/library-health/parts'
import { Route as AuthenticatedSuppliersSidebarIndexRouteImport } from './routes/_authenticated/suppliers/_sidebar/index'
import { Route as AuthenticatedSuppliersSidebarStrategyRouteImport } from './routes/_authenticated/suppliers/_sidebar/strategy'
import { Route as AuthenticatedSuppliersLineCardRulesImporterRouteImport } from './routes/_authenticated/suppliers/line-card-rules/importer'
import { Route as AuthenticatedSuppliersSupplierContactsImporterBulkRouteImport } from './routes/_authenticated/suppliers/supplier-contacts-importer/bulk'
import { Route as AuthenticatedSuppliersSupplierContactsImporterRouteImport } from './routes/_authenticated/suppliers/supplier-contacts/importer'
import { Route as AuthenticatedTemplatesSidebarExportRouteImport } from './routes/_authenticated/templates/_sidebar/export'
import { Route as AuthenticatedTemplatesSidebarPcbSpecificationRouteImport } from './routes/_authenticated/templates/_sidebar/pcb-specification'
import { Route as AuthenticatedTemplatesCalculationAddTemplateRouteImport } from './routes/_authenticated/templates/calculation/add-template'
import { Route as AuthenticatedTemplatesCalculationCreateRouteImport } from './routes/_authenticated/templates/calculation/create'
import { Route as AuthenticatedTemplatesFlexibleCalculationNewRouteImport } from './routes/_authenticated/templates/flexible-calculation/new'
import { Route as AuthenticatedTemplatesQuotationCreateRouteImport } from './routes/_authenticated/templates/quotation/create'
import { Route as AuthenticatedTemplatesQuotationEditRouteImport } from './routes/_authenticated/templates/quotation/edit'
import { Route as AuthenticatedAssembliesAssemblyIdPcbIndexRouteImport } from './routes/_authenticated/assemblies/$assemblyId/pcb/index'
import { Route as AuthenticatedAssembliesAssemblyIdPcbCadViewerRouteImport } from './routes/_authenticated/assemblies/$assemblyId/pcb/cad-viewer'
import { Route as AuthenticatedAssembliesAssemblyIdPcbDfmRouteImport } from './routes/_authenticated/assemblies/$assemblyId/pcb/dfm'
import { Route as AuthenticatedAssembliesAssemblyIdPcbDfmAnalysisRouteImport } from './routes/_authenticated/assemblies/$assemblyId/pcb/dfm-analysis'
import { Route as AuthenticatedAssembliesAssemblyIdPcbDrillsRouteImport } from './routes/_authenticated/assemblies/$assemblyId/pcb/drills'
import { Route as AuthenticatedAssembliesAssemblyIdPcbFilesRouteImport } from './routes/_authenticated/assemblies/$assemblyId/pcb/files'
import { Route as AuthenticatedAssembliesAssemblyIdPcbPanelizationRouteImport } from './routes/_authenticated/assemblies/$assemblyId/pcb/panelization'
import { Route as AuthenticatedAssembliesAssemblyIdPcbSpecificationRouteImport } from './routes/_authenticated/assemblies/$assemblyId/pcb/specification'
import { Route as AuthenticatedAssembliesAssemblyIdPcbStackupRouteImport } from './routes/_authenticated/assemblies/$assemblyId/pcb/stackup'
import { Route as AuthenticatedAssembliesAssemblyIdSubassembliesCreateRouteImport } from './routes/_authenticated/assemblies/$assemblyId/subassemblies/create'
import { Route as AuthenticatedManufacturingSidebarActivitiesIndexRouteImport } from './routes/_authenticated/manufacturing/_sidebar/activities/index'
import { Route as AuthenticatedManufacturingSidebarDriversIndexRouteImport } from './routes/_authenticated/manufacturing/_sidebar/drivers/index'
import { Route as AuthenticatedManufacturingSidebarExpensesIndexRouteImport } from './routes/_authenticated/manufacturing/_sidebar/expenses/index'
import { Route as AuthenticatedManufacturingSidebarResourcesIndexRouteImport } from './routes/_authenticated/manufacturing/_sidebar/resources/index'
import { Route as AuthenticatedManufacturingSidebarTemplatesChar123TemplateIdChar125RouteImport } from './routes/_authenticated/manufacturing/_sidebar/templates/{-$templateId}'
import { Route as AuthenticatedManufacturingActivitiesActivityIdDuplicateRouteImport } from './routes/_authenticated/manufacturing/activities/$activityId/duplicate'
import { Route as AuthenticatedManufacturingActivitiesActivityIdEditRouteImport } from './routes/_authenticated/manufacturing/activities/$activityId/edit'
import { Route as AuthenticatedManufacturingDriversDriverIdDuplicateRouteImport } from './routes/_authenticated/manufacturing/drivers/$driverId/duplicate'
import { Route as AuthenticatedManufacturingDriversDriverIdEditRouteImport } from './routes/_authenticated/manufacturing/drivers/$driverId/edit'
import { Route as AuthenticatedManufacturingExpensesExpenseIdDuplicateRouteImport } from './routes/_authenticated/manufacturing/expenses/$expenseId/duplicate'
import { Route as AuthenticatedManufacturingExpensesExpenseIdEditRouteImport } from './routes/_authenticated/manufacturing/expenses/$expenseId/edit'
import { Route as AuthenticatedManufacturingResourcesResourceIdDuplicateRouteImport } from './routes/_authenticated/manufacturing/resources/$resourceId/duplicate'
import { Route as AuthenticatedManufacturingResourcesResourceIdEditRouteImport } from './routes/_authenticated/manufacturing/resources/$resourceId/edit'
import { Route as AuthenticatedMonitoringSidebarChartsIndexRouteImport } from './routes/_authenticated/monitoring/_sidebar/charts/index'
import { Route as AuthenticatedMonitoringSidebarComponentsPricingRouteImport } from './routes/_authenticated/monitoring/_sidebar/components/pricing'
import { Route as AuthenticatedMonitoringSidebarDashboardsIndexRouteImport } from './routes/_authenticated/monitoring/_sidebar/dashboards/index'
import { Route as AuthenticatedMonitoringSidebarDashboardsDashboardIdRouteImport } from './routes/_authenticated/monitoring/_sidebar/dashboards/$dashboardId'
import { Route as AuthenticatedMonitoringSidebarInsightsAgentChar123ConversationIdChar125RouteImport } from './routes/_authenticated/monitoring/_sidebar/insights-agent/{-$conversationId}'
import { Route as AuthenticatedMonitoringSidebarJobsIndexRouteImport } from './routes/_authenticated/monitoring/_sidebar/jobs/index'
import { Route as AuthenticatedMonitoringSidebarJobsJobIdRouteImport } from './routes/_authenticated/monitoring/_sidebar/jobs/$jobId'
import { Route as AuthenticatedMonitoringSidebarReportsSavingsRouteImport } from './routes/_authenticated/monitoring/_sidebar/reports/savings'
import { Route as AuthenticatedNegotiationsNegotiationIdSidebarOverviewRouteImport } from './routes/_authenticated/negotiations/$negotiationId/_sidebar/overview'
import { Route as AuthenticatedNextAssembliesAssemblyIdIndexRouteImport } from './routes/_authenticated/next/assemblies/$assemblyId/index'
import { Route as AuthenticatedNextAssembliesAssemblyIdDashboardRouteImport } from './routes/_authenticated/next/assemblies/$assemblyId/dashboard'
import { Route as AuthenticatedNextAssembliesAssemblyIdDetailsRouteImport } from './routes/_authenticated/next/assemblies/$assemblyId/details'
import { Route as AuthenticatedNextAssembliesAssemblyIdEditRouteImport } from './routes/_authenticated/next/assemblies/$assemblyId/edit'
import { Route as AuthenticatedNextAssembliesAssemblyIdPcbRouteRouteImport } from './routes/_authenticated/next/assemblies/$assemblyId/pcb/route'
import { Route as AuthenticatedNextComponentsIpnDetailsRouteRouteImport } from './routes/_authenticated/next/components/ipn/_details/route'
import { Route as AuthenticatedNextNegotiationsNegotiationIdIndexRouteImport } from './routes/_authenticated/next/negotiations/$negotiationId/index'
import { Route as AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRouteImport } from './routes/_authenticated/next/negotiations/$negotiationId/_sidebar/route'
import { Route as AuthenticatedNextPartsPartIdIndexRouteImport } from './routes/_authenticated/next/parts/$partId/index'
import { Route as AuthenticatedNextPartsPartIdComplianceRouteImport } from './routes/_authenticated/next/parts/$partId/compliance'
import { Route as AuthenticatedNextPartsPartIdOffersRouteImport } from './routes/_authenticated/next/parts/$partId/offers'
import { Route as AuthenticatedNextPartsPartIdPartAlternativesRouteImport } from './routes/_authenticated/next/parts/$partId/part-alternatives'
import { Route as AuthenticatedNextPartsPartIdSeAlternativesRouteImport } from './routes/_authenticated/next/parts/$partId/se-alternatives'
import { Route as AuthenticatedNextPartsPartIdSeDocumentationRouteImport } from './routes/_authenticated/next/parts/$partId/se-documentation'
import { Route as AuthenticatedNextPartsPartIdSeGeoRiskRouteImport } from './routes/_authenticated/next/parts/$partId/se-geo-risk'
import { Route as AuthenticatedNextPartsPartIdSeSupplyChainRouteImport } from './routes/_authenticated/next/parts/$partId/se-supply-chain'
import { Route as AuthenticatedNextPartsPartIdSeTechnicalRouteImport } from './routes/_authenticated/next/parts/$partId/se-technical'
import { Route as AuthenticatedNextPartsPartIdUsedInRouteImport } from './routes/_authenticated/next/parts/$partId/used-in'
import { Route as AuthenticatedNextPartsCustomCustomPartSpecificationIdRouteRouteImport } from './routes/_authenticated/next/parts/custom/$customPartSpecificationId/route'
import { Route as AuthenticatedNextProjectsProjectIdIndexRouteImport } from './routes/_authenticated/next/projects/$projectId/index'
import { Route as AuthenticatedNextProjectsProjectIdDashboardRouteImport } from './routes/_authenticated/next/projects/$projectId/dashboard'
import { Route as AuthenticatedNextProjectsProjectIdEditRouteImport } from './routes/_authenticated/next/projects/$projectId/edit'
import { Route as AuthenticatedNextProjectsProjectIdQuotationRouteImport } from './routes/_authenticated/next/projects/$projectId/quotation'
import { Route as AuthenticatedNextRiskManagementLibraryHealthIndexRouteImport } from './routes/_authenticated/next/risk-management/library-health/index'
import { Route as AuthenticatedNextRiskManagementLibraryHealthAssembliesRouteImport } from './routes/_authenticated/next/risk-management/library-health/assemblies'
import { Route as AuthenticatedNextRiskManagementLibraryHealthComponentsRouteImport } from './routes/_authenticated/next/risk-management/library-health/components'
import { Route as AuthenticatedNextRiskManagementLibraryHealthPartsRouteImport } from './routes/_authenticated/next/risk-management/library-health/parts'
import { Route as AuthenticatedNextSuppliersSupplierContactsIndexRouteImport } from './routes/_authenticated/next/suppliers/supplier-contacts/index'
import { Route as AuthenticatedNextTemplatesEmailIndexRouteImport } from './routes/_authenticated/next/templates/email/index'
import { Route as AuthenticatedNextTemplatesEmailCreateRouteImport } from './routes/_authenticated/next/templates/email/create'
import { Route as AuthenticatedNextTemplatesFlexibleCalculationIndexRouteImport } from './routes/_authenticated/next/templates/flexible-calculation/index'
import { Route as AuthenticatedNextTemplatesFlexibleCalculationFlexibleCalculationTemplateIdRouteImport } from './routes/_authenticated/next/templates/flexible-calculation/$flexibleCalculationTemplateId'
import { Route as AuthenticatedNextTemplatesFlexibleCalculationCreateRouteImport } from './routes/_authenticated/next/templates/flexible-calculation/create'
import { Route as AuthenticatedNextTemplatesFlexibleCalculationExportedVariablesRouteImport } from './routes/_authenticated/next/templates/flexible-calculation/exported-variables'
import { Route as AuthenticatedNextTemplatesQuotationIndexRouteImport } from './routes/_authenticated/next/templates/quotation/index'
import { Route as AuthenticatedNextTemplatesQuoteRequestIndexRouteImport } from './routes/_authenticated/next/templates/quote-request/index'
import { Route as AuthenticatedNextTemplatesQuoteRequestCreateRouteImport } from './routes/_authenticated/next/templates/quote-request/create'
import { Route as AuthenticatedNextTemplatesSourcingIndexRouteImport } from './routes/_authenticated/next/templates/sourcing/index'
import { Route as AuthenticatedNextTemplatesSourcingCreateRouteImport } from './routes/_authenticated/next/templates/sourcing/create'
import { Route as AuthenticatedPartsSidebarComponentsIndexRouteImport } from './routes/_authenticated/parts/_sidebar/components/index'
import { Route as AuthenticatedPartsSidebarDemandsIndexRouteImport } from './routes/_authenticated/parts/_sidebar/demands/index'
import { Route as AuthenticatedPartsSidebarDemandsImporterRouteImport } from './routes/_authenticated/parts/_sidebar/demands/importer'
import { Route as AuthenticatedPartsSidebarQuoteRequestsIndexRouteImport } from './routes/_authenticated/parts/_sidebar/quote-requests/index'
import { Route as AuthenticatedPartsComponentsIpnDetailsRouteRouteImport } from './routes/_authenticated/parts/components/ipn/_details/route'
import { Route as AuthenticatedPartsCustomDetailsCustomPartSpecificationIdRouteRouteImport } from './routes/_authenticated/parts/custom/details/$customPartSpecificationId/route'
import { Route as AuthenticatedPartsDetailsPartIdIndexRouteImport } from './routes/_authenticated/parts/details/$partId/index'
import { Route as AuthenticatedPartsDetailsPartIdComplianceRouteImport } from './routes/_authenticated/parts/details/$partId/compliance'
import { Route as AuthenticatedPartsDetailsPartIdOffersRouteImport } from './routes/_authenticated/parts/details/$partId/offers'
import { Route as AuthenticatedPartsDetailsPartIdPartAlternativesRouteImport } from './routes/_authenticated/parts/details/$partId/part-alternatives'
import { Route as AuthenticatedPartsDetailsPartIdSeAlternativesRouteImport } from './routes/_authenticated/parts/details/$partId/se-alternatives'
import { Route as AuthenticatedPartsDetailsPartIdSeDocumentationRouteImport } from './routes/_authenticated/parts/details/$partId/se-documentation'
import { Route as AuthenticatedPartsDetailsPartIdSeGeoRiskRouteImport } from './routes/_authenticated/parts/details/$partId/se-geo-risk'
import { Route as AuthenticatedPartsDetailsPartIdSeSupplyChainRouteImport } from './routes/_authenticated/parts/details/$partId/se-supply-chain'
import { Route as AuthenticatedPartsDetailsPartIdSeTechnicalRouteImport } from './routes/_authenticated/parts/details/$partId/se-technical'
import { Route as AuthenticatedPartsDetailsPartIdUsedInRouteImport } from './routes/_authenticated/parts/details/$partId/used-in'
import { Route as AuthenticatedPartsOffersOfferIdDuplicateRouteImport } from './routes/_authenticated/parts/offers/$offerId/duplicate'
import { Route as AuthenticatedPartsOffersOfferIdEditRouteImport } from './routes/_authenticated/parts/offers/$offerId/edit'
import { Route as AuthenticatedProjectsProjectIdBomIndexRouteImport } from './routes/_authenticated/projects/$projectId/bom/index'
import { Route as AuthenticatedProjectsProjectIdCalculationIndexRouteImport } from './routes/_authenticated/projects/$projectId/calculation/index'
import { Route as AuthenticatedProjectsProjectIdCalculationPrintRouteImport } from './routes/_authenticated/projects/$projectId/calculation/print'
import { Route as AuthenticatedProjectsProjectIdFlexibleCalculationIndexRouteImport } from './routes/_authenticated/projects/$projectId/flexible-calculation/index'
import { Route as AuthenticatedProjectsProjectIdFlexibleCalculationFlexibleCalculationIdRouteImport } from './routes/_authenticated/projects/$projectId/flexible-calculation/$flexibleCalculationId'
import { Route as AuthenticatedProjectsProjectIdManufacturingIndexRouteImport } from './routes/_authenticated/projects/$projectId/manufacturing/index'
import { Route as AuthenticatedProjectsProjectIdOrderIndexRouteImport } from './routes/_authenticated/projects/$projectId/order/index'
import { Route as AuthenticatedProjectsProjectIdOrderConfirmationRouteImport } from './routes/_authenticated/projects/$projectId/order/confirmation'
import { Route as AuthenticatedProjectsProjectIdSourcingIndexRouteImport } from './routes/_authenticated/projects/$projectId/sourcing/index'
import { Route as AuthenticatedProjectsProjectIdSourcingSidebarRouteRouteImport } from './routes/_authenticated/projects/$projectId/sourcing/_sidebar/route'
import { Route as AuthenticatedProjectsProjectIdSourcingDemandGroupsRouteImport } from './routes/_authenticated/projects/$projectId/sourcing/demand-groups'
import { Route as AuthenticatedSettingsMenuOrganizationIndexRouteImport } from './routes/_authenticated/settings/_menu/organization/index'
import { Route as AuthenticatedSettingsMenuOrganizationApiIntegrationRouteImport } from './routes/_authenticated/settings/_menu/organization/api-integration'
import { Route as AuthenticatedSettingsMenuOrganizationAssemblySettingsRouteImport } from './routes/_authenticated/settings/_menu/organization/assembly-settings'
import { Route as AuthenticatedSettingsMenuOrganizationAutomaticRfqNumberRouteImport } from './routes/_authenticated/settings/_menu/organization/automatic-rfq-number'
import { Route as AuthenticatedSettingsMenuOrganizationBrandingRouteImport } from './routes/_authenticated/settings/_menu/organization/branding'
import { Route as AuthenticatedSettingsMenuOrganizationCarbonFootprintsRouteImport } from './routes/_authenticated/settings/_menu/organization/carbon-footprints'
import { Route as AuthenticatedSettingsMenuOrganizationComponentSettingsRouteImport } from './routes/_authenticated/settings/_menu/organization/component-settings'
import { Route as AuthenticatedSettingsMenuOrganizationCsvIntegrationRouteImport } from './routes/_authenticated/settings/_menu/organization/csv-integration'
import { Route as AuthenticatedSettingsMenuOrganizationCustomPartCategoriesRouteImport } from './routes/_authenticated/settings/_menu/organization/custom-part-categories'
import { Route as AuthenticatedSettingsMenuOrganizationDataIntegrationsRouteImport } from './routes/_authenticated/settings/_menu/organization/data-integrations'
import { Route as AuthenticatedSettingsMenuOrganizationFeatureFlagsRouteImport } from './routes/_authenticated/settings/_menu/organization/feature-flags'
import { Route as AuthenticatedSettingsMenuOrganizationManufacturerPreferencesRouteImport } from './routes/_authenticated/settings/_menu/organization/manufacturer-preferences'
import { Route as AuthenticatedSettingsMenuOrganizationSitesRouteImport } from './routes/_authenticated/settings/_menu/organization/sites'
import { Route as AuthenticatedSettingsMenuOrganizationSupplierApiIntegrationsRouteImport } from './routes/_authenticated/settings/_menu/organization/supplier-api-integrations'
import { Route as AuthenticatedSettingsMenuUserAccountSecurityRouteImport } from './routes/_authenticated/settings/_menu/user/account-security'
import { Route as AuthenticatedSettingsOrganizationPcbPanelPreferenceIdRouteImport } from './routes/_authenticated/settings/organization/pcb/$panelPreferenceId'
import { Route as AuthenticatedSettingsOrganizationPcbAddPreferenceRouteImport } from './routes/_authenticated/settings/organization/pcb/add-preference'
import { Route as AuthenticatedSettingsOrganizationUsersImporterRouteImport } from './routes/_authenticated/settings/organization/users/importer'
import { Route as AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdIndexRouteImport } from './routes/_authenticated/supplier-portal/quote-requests/$quoteRequestId/index'
import { Route as AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdExcelImporterRouteImport } from './routes/_authenticated/supplier-portal/quote-requests/$quoteRequestId/excel-importer'
import { Route as AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdImportPdfRouteImport } from './routes/_authenticated/supplier-portal/quote-requests/$quoteRequestId/import-pdf'
import { Route as AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdPdfImporterRouteImport } from './routes/_authenticated/supplier-portal/quote-requests/$quoteRequestId/pdf-importer'
import { Route as AuthenticatedSuppliersSupplierIdSupplierContactsImporterSplatRouteImport } from './routes/_authenticated/suppliers/$supplierId/supplier-contacts-importer/$'
import { Route as AuthenticatedSuppliersSupplierIdSupplierContactsImporterRouteImport } from './routes/_authenticated/suppliers/$supplierId/supplier-contacts/importer'
import { Route as AuthenticatedSuppliersSidebarSupplierContactsIndexRouteImport } from './routes/_authenticated/suppliers/_sidebar/supplier-contacts/index'
import { Route as AuthenticatedTemplatesSidebarCalculationIndexRouteImport } from './routes/_authenticated/templates/_sidebar/calculation/index'
import { Route as AuthenticatedTemplatesSidebarEmailIndexRouteImport } from './routes/_authenticated/templates/_sidebar/email/index'
import { Route as AuthenticatedTemplatesSidebarEmailCreateRouteImport } from './routes/_authenticated/templates/_sidebar/email/create'
import { Route as AuthenticatedTemplatesSidebarFlexibleCalculationIndexRouteImport } from './routes/_authenticated/templates/_sidebar/flexible-calculation/index'
import { Route as AuthenticatedTemplatesSidebarFlexibleCalculationFlexibleCalculationTemplateIdRouteImport } from './routes/_authenticated/templates/_sidebar/flexible-calculation/$flexibleCalculationTemplateId'
import { Route as AuthenticatedTemplatesSidebarFlexibleCalculationCreateRouteImport } from './routes/_authenticated/templates/_sidebar/flexible-calculation/create'
import { Route as AuthenticatedTemplatesSidebarFlexibleCalculationExportedVariablesRouteImport } from './routes/_authenticated/templates/_sidebar/flexible-calculation/exported-variables'
import { Route as AuthenticatedTemplatesSidebarQuotationIndexRouteImport } from './routes/_authenticated/templates/_sidebar/quotation/index'
import { Route as AuthenticatedTemplatesSidebarQuoteRequestIndexRouteImport } from './routes/_authenticated/templates/_sidebar/quote-request/index'
import { Route as AuthenticatedTemplatesSidebarQuoteRequestCreateRouteImport } from './routes/_authenticated/templates/_sidebar/quote-request/create'
import { Route as AuthenticatedTemplatesSidebarSourcingIndexRouteImport } from './routes/_authenticated/templates/_sidebar/sourcing/index'
import { Route as AuthenticatedTemplatesSidebarSourcingCreateRouteImport } from './routes/_authenticated/templates/_sidebar/sourcing/create'
import { Route as AuthenticatedTemplatesCalculationTemplateIdEditRouteImport } from './routes/_authenticated/templates/calculation/$templateId/edit'
import { Route as AuthenticatedTemplatesEmailEmailTemplateIdUpdateRouteImport } from './routes/_authenticated/templates/email/$emailTemplateId/update'
import { Route as AuthenticatedManufacturingSidebarAppsAppIdWidgetIdRouteImport } from './routes/_authenticated/manufacturing/_sidebar/apps/$appId/$widgetId'
import { Route as AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsIndexRouteImport } from './routes/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/index'
import { Route as AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsQuoteRequestIdRouteImport } from './routes/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/$quoteRequestId'
import { Route as AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsAssignRouteImport } from './routes/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/assign'
import { Route as AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsAttachmentsRouteImport } from './routes/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/attachments'
import { Route as AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsDeliveryLotSizeRouteImport } from './routes/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/delivery-lot-size'
import { Route as AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsExcelImporterRouteImport } from './routes/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/excel-importer'
import { Route as AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsImporterRouteImport } from './routes/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/importer'
import { Route as AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsLineItemsRouteImport } from './routes/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/line-items'
import { Route as AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsPreviewEmailRouteImport } from './routes/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/preview-email'
import { Route as AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsTargetPriceRouteImport } from './routes/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/target-price'
import { Route as AuthenticatedNegotiationsNegotiationIdSidebarScenariosCompareRouteImport } from './routes/_authenticated/negotiations/$negotiationId/_sidebar/scenarios/compare'
import { Route as AuthenticatedNegotiationsNegotiationIdSidebarScenariosCreateRouteImport } from './routes/_authenticated/negotiations/$negotiationId/_sidebar/scenarios/create'
import { Route as AuthenticatedNextAssembliesAssemblyIdPcbIndexRouteImport } from './routes/_authenticated/next/assemblies/$assemblyId/pcb/index'
import { Route as AuthenticatedNextAssembliesAssemblyIdPcbCadViewerRouteImport } from './routes/_authenticated/next/assemblies/$assemblyId/pcb/cad-viewer'
import { Route as AuthenticatedNextAssembliesAssemblyIdPcbDfmRouteImport } from './routes/_authenticated/next/assemblies/$assemblyId/pcb/dfm'
import { Route as AuthenticatedNextAssembliesAssemblyIdPcbDfmAnalysisRouteImport } from './routes/_authenticated/next/assemblies/$assemblyId/pcb/dfm-analysis'
import { Route as AuthenticatedNextAssembliesAssemblyIdPcbDrillsRouteImport } from './routes/_authenticated/next/assemblies/$assemblyId/pcb/drills'
import { Route as AuthenticatedNextAssembliesAssemblyIdPcbFilesRouteImport } from './routes/_authenticated/next/assemblies/$assemblyId/pcb/files'
import { Route as AuthenticatedNextAssembliesAssemblyIdPcbPanelizationRouteImport } from './routes/_authenticated/next/assemblies/$assemblyId/pcb/panelization'
import { Route as AuthenticatedNextAssembliesAssemblyIdPcbSpecificationRouteImport } from './routes/_authenticated/next/assemblies/$assemblyId/pcb/specification'
import { Route as AuthenticatedNextAssembliesAssemblyIdPcbStackupRouteImport } from './routes/_authenticated/next/assemblies/$assemblyId/pcb/stackup'
import { Route as AuthenticatedNextAssembliesAssemblyIdSubassembliesCreateRouteImport } from './routes/_authenticated/next/assemblies/$assemblyId/subassemblies/create'
import { Route as AuthenticatedNextComponentsIpnDetailsIndexRouteImport } from './routes/_authenticated/next/components/ipn/_details/index'
import { Route as AuthenticatedNextComponentsIpnDetailsCpnsRouteImport } from './routes/_authenticated/next/components/ipn/_details/cpns'
import { Route as AuthenticatedNextComponentsIpnDetailsLinkingRouteImport } from './routes/_authenticated/next/components/ipn/_details/linking'
import { Route as AuthenticatedNextComponentsIpnDetailsUsedInRouteImport } from './routes/_authenticated/next/components/ipn/_details/used-in'
import { Route as AuthenticatedNextNegotiationsNegotiationIdSidebarOverviewRouteImport } from './routes/_authenticated/next/negotiations/$negotiationId/_sidebar/overview'
import { Route as AuthenticatedNextPartsCustomCustomPartSpecificationIdIndexRouteImport } from './routes/_authenticated/next/parts/custom/$customPartSpecificationId/index'
import { Route as AuthenticatedNextPartsCustomCustomPartSpecificationIdOffersRouteImport } from './routes/_authenticated/next/parts/custom/$customPartSpecificationId/offers'
import { Route as AuthenticatedNextPartsCustomCustomPartSpecificationIdUsedInRouteImport } from './routes/_authenticated/next/parts/custom/$customPartSpecificationId/used-in'
import { Route as AuthenticatedNextPartsOffersOfferIdDuplicateRouteImport } from './routes/_authenticated/next/parts/offers/$offerId/duplicate'
import { Route as AuthenticatedNextPartsOffersOfferIdEditRouteImport } from './routes/_authenticated/next/parts/offers/$offerId/edit'
import { Route as AuthenticatedNextProjectsProjectIdAssembliesIndexRouteImport } from './routes/_authenticated/next/projects/$projectId/assemblies/index'
import { Route as AuthenticatedNextProjectsProjectIdFlexibleCalculationIndexRouteImport } from './routes/_authenticated/next/projects/$projectId/flexible-calculation/index'
import { Route as AuthenticatedNextProjectsProjectIdFlexibleCalculationFlexibleCalculationIdRouteImport } from './routes/_authenticated/next/projects/$projectId/flexible-calculation/$flexibleCalculationId'
import { Route as AuthenticatedNextProjectsProjectIdManufacturingIndexRouteImport } from './routes/_authenticated/next/projects/$projectId/manufacturing/index'
import { Route as AuthenticatedNextProjectsProjectIdSourcingIndexRouteImport } from './routes/_authenticated/next/projects/$projectId/sourcing/index'
import { Route as AuthenticatedNextProjectsProjectIdSourcingCompareRouteImport } from './routes/_authenticated/next/projects/$projectId/sourcing/compare'
import { Route as AuthenticatedNextProjectsProjectIdSourcingOverviewRouteRouteImport } from './routes/_authenticated/next/projects/$projectId/sourcing/overview/route'
import { Route as AuthenticatedNextProjectsProjectIdSourcingVersionHistoryRouteImport } from './routes/_authenticated/next/projects/$projectId/sourcing/version-history'
import { Route as AuthenticatedNextSettingsMenuOrganizationIndexRouteImport } from './routes/_authenticated/next/settings/_menu/organization/index'
import { Route as AuthenticatedNextSettingsMenuOrganizationApiIntegrationRouteImport } from './routes/_authenticated/next/settings/_menu/organization/api-integration'
import { Route as AuthenticatedNextSettingsMenuOrganizationAssemblySettingsRouteImport } from './routes/_authenticated/next/settings/_menu/organization/assembly-settings'
import { Route as AuthenticatedNextSettingsMenuOrganizationAutomaticRfqNumberRouteImport } from './routes/_authenticated/next/settings/_menu/organization/automatic-rfq-number'
import { Route as AuthenticatedNextSettingsMenuOrganizationBrandingRouteImport } from './routes/_authenticated/next/settings/_menu/organization/branding'
import { Route as AuthenticatedNextSettingsMenuOrganizationCarbonFootprintsRouteImport } from './routes/_authenticated/next/settings/_menu/organization/carbon-footprints'
import { Route as AuthenticatedNextSettingsMenuOrganizationComponentSettingsRouteImport } from './routes/_authenticated/next/settings/_menu/organization/component-settings'
import { Route as AuthenticatedNextSettingsMenuOrganizationCsvIntegrationRouteImport } from './routes/_authenticated/next/settings/_menu/organization/csv-integration'
import { Route as AuthenticatedNextSettingsMenuOrganizationCustomPartCategoriesRouteImport } from './routes/_authenticated/next/settings/_menu/organization/custom-part-categories'
import { Route as AuthenticatedNextSettingsMenuOrganizationDataIntegrationsRouteImport } from './routes/_authenticated/next/settings/_menu/organization/data-integrations'
import { Route as AuthenticatedNextSettingsMenuOrganizationFeatureFlagsRouteImport } from './routes/_authenticated/next/settings/_menu/organization/feature-flags'
import { Route as AuthenticatedNextSettingsMenuOrganizationManufacturerPreferencesRouteImport } from './routes/_authenticated/next/settings/_menu/organization/manufacturer-preferences'
import { Route as AuthenticatedNextSettingsMenuOrganizationSitesRouteImport } from './routes/_authenticated/next/settings/_menu/organization/sites'
import { Route as AuthenticatedNextSettingsMenuOrganizationSupplierApiIntegrationsRouteImport } from './routes/_authenticated/next/settings/_menu/organization/supplier-api-integrations'
import { Route as AuthenticatedNextSettingsMenuUserAccountSecurityRouteImport } from './routes/_authenticated/next/settings/_menu/user/account-security'
import { Route as AuthenticatedNextSettingsOrganizationUsersImporterRouteImport } from './routes/_authenticated/next/settings/organization/users/importer'
import { Route as AuthenticatedNextTemplatesEmailEmailTemplateIdEditRouteImport } from './routes/_authenticated/next/templates/email/$emailTemplateId/edit'
import { Route as AuthenticatedNextTemplatesManufacturingActivitiesIndexRouteImport } from './routes/_authenticated/next/templates/manufacturing/activities/index'
import { Route as AuthenticatedNextTemplatesManufacturingActivitiesCreateRouteImport } from './routes/_authenticated/next/templates/manufacturing/activities/create'
import { Route as AuthenticatedNextTemplatesManufacturingDriversIndexRouteImport } from './routes/_authenticated/next/templates/manufacturing/drivers/index'
import { Route as AuthenticatedNextTemplatesManufacturingDriversCreateRouteImport } from './routes/_authenticated/next/templates/manufacturing/drivers/create'
import { Route as AuthenticatedNextTemplatesManufacturingExpensesIndexRouteImport } from './routes/_authenticated/next/templates/manufacturing/expenses/index'
import { Route as AuthenticatedNextTemplatesManufacturingExpensesCreateRouteImport } from './routes/_authenticated/next/templates/manufacturing/expenses/create'
import { Route as AuthenticatedNextTemplatesManufacturingResourcesIndexRouteImport } from './routes/_authenticated/next/templates/manufacturing/resources/index'
import { Route as AuthenticatedNextTemplatesManufacturingResourcesCreateRouteImport } from './routes/_authenticated/next/templates/manufacturing/resources/create'
import { Route as AuthenticatedNextTemplatesManufacturingTemplatesChar123TemplateIdChar125RouteImport } from './routes/_authenticated/next/templates/manufacturing/templates/{-$templateId}'
import { Route as AuthenticatedNextTemplatesQuotationBuilderChar123TemplateIdChar125RouteImport } from './routes/_authenticated/next/templates/quotation/builder/{-$templateId}'
import { Route as AuthenticatedNextTemplatesQuoteRequestQuoteRequestTemplateIdEditRouteImport } from './routes/_authenticated/next/templates/quote-request/$quoteRequestTemplateId/edit'
import { Route as AuthenticatedNextTemplatesSourcingSourcingTemplateIdDuplicateRouteImport } from './routes/_authenticated/next/templates/sourcing/$sourcingTemplateId/duplicate'
import { Route as AuthenticatedNextTemplatesSourcingSourcingTemplateIdEditRouteImport } from './routes/_authenticated/next/templates/sourcing/$sourcingTemplateId/edit'
import { Route as AuthenticatedPartsComponentsIpnDetailsIndexRouteImport } from './routes/_authenticated/parts/components/ipn/_details/index'
import { Route as AuthenticatedPartsComponentsIpnDetailsCpnsRouteImport } from './routes/_authenticated/parts/components/ipn/_details/cpns'
import { Route as AuthenticatedPartsComponentsIpnDetailsLinkingRouteImport } from './routes/_authenticated/parts/components/ipn/_details/linking'
import { Route as AuthenticatedPartsComponentsIpnDetailsOffersRouteImport } from './routes/_authenticated/parts/components/ipn/_details/offers'
import { Route as AuthenticatedPartsComponentsIpnDetailsUsedInRouteImport } from './routes/_authenticated/parts/components/ipn/_details/used-in'
import { Route as AuthenticatedPartsCustomDetailsCustomPartSpecificationIdIndexRouteImport } from './routes/_authenticated/parts/custom/details/$customPartSpecificationId/index'
import { Route as AuthenticatedPartsCustomDetailsCustomPartSpecificationIdOffersRouteImport } from './routes/_authenticated/parts/custom/details/$customPartSpecificationId/offers'
import { Route as AuthenticatedPartsCustomDetailsCustomPartSpecificationIdUsedInRouteImport } from './routes/_authenticated/parts/custom/details/$customPartSpecificationId/used-in'
import { Route as AuthenticatedProjectsProjectIdBomAssemblyAddAssemblyRouteImport } from './routes/_authenticated/projects/$projectId/bom/assembly/add-assembly'
import { Route as AuthenticatedProjectsProjectIdCalculationAssemblyIdCalculationRouteImport } from './routes/_authenticated/projects/$projectId/calculation/$assemblyId/calculation'
import { Route as AuthenticatedProjectsProjectIdCalculationAssembliesAssemblyIdRouteImport } from './routes/_authenticated/projects/$projectId/calculation/assemblies/$assemblyId'
import { Route as AuthenticatedProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdIndexRouteImport } from './routes/_authenticated/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/index'
import { Route as AuthenticatedProjectsProjectIdSourcingSidebarCompareRouteImport } from './routes/_authenticated/projects/$projectId/sourcing/_sidebar/compare'
import { Route as AuthenticatedProjectsProjectIdSourcingSidebarVersionHistoryRouteImport } from './routes/_authenticated/projects/$projectId/sourcing/_sidebar/version-history'
import { Route as AuthenticatedProjectsProjectIdSourcingAssemblyAssemblyIdRouteImport } from './routes/_authenticated/projects/$projectId/sourcing/assembly/$assemblyId'
import { Route as AuthenticatedSettingsMenuOrganizationCustomerPortalIndexRouteImport } from './routes/_authenticated/settings/_menu/organization/customer-portal/index'
import { Route as AuthenticatedSettingsMenuOrganizationCustomerPortalAdditionalServicesRouteImport } from './routes/_authenticated/settings/_menu/organization/customer-portal/additional-services'
import { Route as AuthenticatedSettingsMenuOrganizationCustomerPortalCheckoutConditionsRouteImport } from './routes/_authenticated/settings/_menu/organization/customer-portal/checkout-conditions'
import { Route as AuthenticatedSettingsMenuOrganizationCustomerPortalCustomerSpecificSettingsRouteImport } from './routes/_authenticated/settings/_menu/organization/customer-portal/customer-specific-settings'
import { Route as AuthenticatedSettingsMenuOrganizationCustomerPortalLandingPageRouteImport } from './routes/_authenticated/settings/_menu/organization/customer-portal/landing-page'
import { Route as AuthenticatedSettingsMenuOrganizationCustomerPortalPaymentCredentialsRouteImport } from './routes/_authenticated/settings/_menu/organization/customer-portal/payment-credentials'
import { Route as AuthenticatedSettingsMenuOrganizationPcbIndexRouteImport } from './routes/_authenticated/settings/_menu/organization/pcb/index'
import { Route as AuthenticatedSettingsMenuOrganizationUserManagementActionPermissionsRouteImport } from './routes/_authenticated/settings/_menu/organization/user-management/action-permissions'
import { Route as AuthenticatedSettingsMenuOrganizationUserManagementRolesRouteImport } from './routes/_authenticated/settings/_menu/organization/user-management/roles'
import { Route as AuthenticatedSettingsMenuOrganizationUsersIndexRouteImport } from './routes/_authenticated/settings/_menu/organization/users/index'
import { Route as AuthenticatedSettingsOrganizationPcbPanelPreferencesIndexRouteImport } from './routes/_authenticated/settings/organization/pcb/panel-preferences/index'
import { Route as AuthenticatedTemplatesSidebarEmailEmailTemplateIdEditRouteImport } from './routes/_authenticated/templates/_sidebar/email/$emailTemplateId/edit'
import { Route as AuthenticatedTemplatesSidebarQuotationBuilderChar123TemplateIdChar125RouteImport } from './routes/_authenticated/templates/_sidebar/quotation/builder/{-$templateId}'
import { Route as AuthenticatedTemplatesSidebarQuoteRequestQuoteRequestTemplateIdEditRouteImport } from './routes/_authenticated/templates/_sidebar/quote-request/$quoteRequestTemplateId/edit'
import { Route as AuthenticatedTemplatesSidebarSourcingSourcingTemplateIdDuplicateRouteImport } from './routes/_authenticated/templates/_sidebar/sourcing/$sourcingTemplateId/duplicate'
import { Route as AuthenticatedTemplatesSidebarSourcingSourcingTemplateIdEditRouteImport } from './routes/_authenticated/templates/_sidebar/sourcing/$sourcingTemplateId/edit'
import { Route as AuthenticatedMonitoringSidebarComponentsCategoriesCategoryIdPricingRouteImport } from './routes/_authenticated/monitoring/_sidebar/components/categories/$categoryId/pricing'
import { Route as AuthenticatedNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdIndexRouteImport } from './routes/_authenticated/negotiations/$negotiationId/_sidebar/demand-groups/$demandGroupId/index'
import { Route as AuthenticatedNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdAwardingRouteImport } from './routes/_authenticated/negotiations/$negotiationId/_sidebar/demand-groups/$demandGroupId/awarding'
import { Route as AuthenticatedNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdIndexRouteImport } from './routes/_authenticated/negotiations/$negotiationId/_sidebar/scenarios/$sourcingScenarioId/index'
import { Route as AuthenticatedNegotiationsNegotiationIdScenariosSourcingScenarioIdLineSourcingLineItemIdRouteImport } from './routes/_authenticated/negotiations/$negotiationId/scenarios/$sourcingScenarioId/line/$sourcingLineItemId'
import { Route as AuthenticatedNextComponentsIpnDetailsOffersIndexRouteImport } from './routes/_authenticated/next/components/ipn/_details/offers/index'
import { Route as AuthenticatedNextComponentsIpnOffersOfferIdDuplicateRouteImport } from './routes/_authenticated/next/components/ipn/offers/$offerId/duplicate'
import { Route as AuthenticatedNextComponentsIpnOffersOfferIdEditRouteImport } from './routes/_authenticated/next/components/ipn/offers/$offerId/edit'
import { Route as AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsIndexRouteImport } from './routes/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/index'
import { Route as AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsQuoteRequestIdRouteImport } from './routes/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/$quoteRequestId'
import { Route as AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsAssignRouteImport } from './routes/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/assign'
import { Route as AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsAttachmentsRouteImport } from './routes/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/attachments'
import { Route as AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsDeliveryLotSizeRouteImport } from './routes/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/delivery-lot-size'
import { Route as AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsImporterRouteImport } from './routes/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/importer'
import { Route as AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsLineItemsRouteImport } from './routes/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/line-items'
import { Route as AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsPreviewEmailRouteImport } from './routes/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/preview-email'
import { Route as AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsTargetPriceRouteImport } from './routes/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/target-price'
import { Route as AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosCompareRouteImport } from './routes/_authenticated/next/negotiations/$negotiationId/_sidebar/scenarios/compare'
import { Route as AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosCreateRouteImport } from './routes/_authenticated/next/negotiations/$negotiationId/_sidebar/scenarios/create'
import { Route as AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdIndexRouteImport } from './routes/_authenticated/next/projects/$projectId/assemblies/$assemblyId/index'
import { Route as AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdDetailsRouteImport } from './routes/_authenticated/next/projects/$projectId/assemblies/$assemblyId/details'
import { Route as AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdEditRouteImport } from './routes/_authenticated/next/projects/$projectId/assemblies/$assemblyId/edit'
import { Route as AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRouteImport } from './routes/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/route'
import { Route as AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPnpImporterRouteImport } from './routes/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pnp-importer'
import { Route as AuthenticatedNextProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdIndexRouteImport } from './routes/_authenticated/next/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/index'
import { Route as AuthenticatedNextProjectsProjectIdSourcingAssemblyAssemblyIdRouteImport } from './routes/_authenticated/next/projects/$projectId/sourcing/assembly/$assemblyId'
import { Route as AuthenticatedNextProjectsProjectIdSourcingOverviewIndexRouteImport } from './routes/_authenticated/next/projects/$projectId/sourcing/overview/index'
import { Route as AuthenticatedNextProjectsProjectIdSourcingOverviewViewRouteImport } from './routes/_authenticated/next/projects/$projectId/sourcing/overview/$view'
import { Route as AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsIndexRouteImport } from './routes/_authenticated/next/projects/$projectId/sourcing/quote-requests/index'
import { Route as AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsQuoteRequestIdRouteImport } from './routes/_authenticated/next/projects/$projectId/sourcing/quote-requests/$quoteRequestId'
import { Route as AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsAssignRouteImport } from './routes/_authenticated/next/projects/$projectId/sourcing/quote-requests/assign'
import { Route as AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsAttachmentsRouteImport } from './routes/_authenticated/next/projects/$projectId/sourcing/quote-requests/attachments'
import { Route as AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsDeliveryLotSizeRouteImport } from './routes/_authenticated/next/projects/$projectId/sourcing/quote-requests/delivery-lot-size'
import { Route as AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsImporterRouteImport } from './routes/_authenticated/next/projects/$projectId/sourcing/quote-requests/importer'
import { Route as AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsLineItemsRouteImport } from './routes/_authenticated/next/projects/$projectId/sourcing/quote-requests/line-items'
import { Route as AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsPreviewEmailRouteImport } from './routes/_authenticated/next/projects/$projectId/sourcing/quote-requests/preview-email'
import { Route as AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsTargetPriceRouteImport } from './routes/_authenticated/next/projects/$projectId/sourcing/quote-requests/target-price'
import { Route as AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdRouteRouteImport } from './routes/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/route'
import { Route as AuthenticatedNextProjectsProjectIdSourcingScenariosCreateRouteImport } from './routes/_authenticated/next/projects/$projectId/sourcing/scenarios/create'
import { Route as AuthenticatedNextSettingsMenuOrganizationCustomerPortalIndexRouteImport } from './routes/_authenticated/next/settings/_menu/organization/customer-portal/index'
import { Route as AuthenticatedNextSettingsMenuOrganizationCustomerPortalAdditionalServicesRouteImport } from './routes/_authenticated/next/settings/_menu/organization/customer-portal/additional-services'
import { Route as AuthenticatedNextSettingsMenuOrganizationCustomerPortalCheckoutConditionsRouteImport } from './routes/_authenticated/next/settings/_menu/organization/customer-portal/checkout-conditions'
import { Route as AuthenticatedNextSettingsMenuOrganizationCustomerPortalCustomerSpecificSettingsRouteImport } from './routes/_authenticated/next/settings/_menu/organization/customer-portal/customer-specific-settings'
import { Route as AuthenticatedNextSettingsMenuOrganizationCustomerPortalLandingPageRouteImport } from './routes/_authenticated/next/settings/_menu/organization/customer-portal/landing-page'
import { Route as AuthenticatedNextSettingsMenuOrganizationCustomerPortalPaymentCredentialsRouteImport } from './routes/_authenticated/next/settings/_menu/organization/customer-portal/payment-credentials'
import { Route as AuthenticatedNextSettingsMenuOrganizationPcbIndexRouteImport } from './routes/_authenticated/next/settings/_menu/organization/pcb/index'
import { Route as AuthenticatedNextSettingsMenuOrganizationUserManagementActionPermissionsRouteImport } from './routes/_authenticated/next/settings/_menu/organization/user-management/action-permissions'
import { Route as AuthenticatedNextSettingsMenuOrganizationUserManagementRolesRouteImport } from './routes/_authenticated/next/settings/_menu/organization/user-management/roles'
import { Route as AuthenticatedNextSettingsMenuOrganizationUsersIndexRouteImport } from './routes/_authenticated/next/settings/_menu/organization/users/index'
import { Route as AuthenticatedNextSettingsOrganizationPcbPanelPreferencesIndexRouteImport } from './routes/_authenticated/next/settings/organization/pcb/panel-preferences/index'
import { Route as AuthenticatedNextTemplatesFlexibleCalculationAppsAppIdWidgetIdRouteImport } from './routes/_authenticated/next/templates/flexible-calculation/apps/$appId/$widgetId'
import { Route as AuthenticatedNextTemplatesFlexibleCalculationReviewConversionLegacyTemplateIdFlexibleCalculationTemplateIdRouteImport } from './routes/_authenticated/next/templates/flexible-calculation/review-conversion/$legacyTemplateId/$flexibleCalculationTemplateId'
import { Route as AuthenticatedNextTemplatesManufacturingActivitiesActivityIdDuplicateRouteImport } from './routes/_authenticated/next/templates/manufacturing/activities/$activityId/duplicate'
import { Route as AuthenticatedNextTemplatesManufacturingActivitiesActivityIdEditRouteImport } from './routes/_authenticated/next/templates/manufacturing/activities/$activityId/edit'
import { Route as AuthenticatedNextTemplatesManufacturingAppsAppIdWidgetIdRouteImport } from './routes/_authenticated/next/templates/manufacturing/apps/$appId/$widgetId'
import { Route as AuthenticatedNextTemplatesManufacturingDriversDriverIdDuplicateRouteImport } from './routes/_authenticated/next/templates/manufacturing/drivers/$driverId/duplicate'
import { Route as AuthenticatedNextTemplatesManufacturingDriversDriverIdEditRouteImport } from './routes/_authenticated/next/templates/manufacturing/drivers/$driverId/edit'
import { Route as AuthenticatedNextTemplatesManufacturingExpensesExpenseIdDuplicateRouteImport } from './routes/_authenticated/next/templates/manufacturing/expenses/$expenseId/duplicate'
import { Route as AuthenticatedNextTemplatesManufacturingExpensesExpenseIdEditRouteImport } from './routes/_authenticated/next/templates/manufacturing/expenses/$expenseId/edit'
import { Route as AuthenticatedNextTemplatesManufacturingResourcesResourceIdDuplicateRouteImport } from './routes/_authenticated/next/templates/manufacturing/resources/$resourceId/duplicate'
import { Route as AuthenticatedNextTemplatesManufacturingResourcesResourceIdEditRouteImport } from './routes/_authenticated/next/templates/manufacturing/resources/$resourceId/edit'
import { Route as AuthenticatedPartsComponentsIpnOffersOfferIdDuplicateRouteImport } from './routes/_authenticated/parts/components/ipn/offers/$offerId/duplicate'
import { Route as AuthenticatedPartsComponentsIpnOffersOfferIdEditRouteImport } from './routes/_authenticated/parts/components/ipn/offers/$offerId/edit'
import { Route as AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdIndexRouteImport } from './routes/_authenticated/projects/$projectId/bom/assembly/$assemblyId/index'
import { Route as AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdDetailsRouteImport } from './routes/_authenticated/projects/$projectId/bom/assembly/$assemblyId/details'
import { Route as AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdEditRouteImport } from './routes/_authenticated/projects/$projectId/bom/assembly/$assemblyId/edit'
import { Route as AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRouteImport } from './routes/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/route'
import { Route as AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPnpImporterRouteImport } from './routes/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pnp-importer'
import { Route as AuthenticatedProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdActivityRouteImport } from './routes/_authenticated/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/activity'
import { Route as AuthenticatedProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdExpenseRouteImport } from './routes/_authenticated/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/expense'
import { Route as AuthenticatedProjectsProjectIdSourcingSourcingScenarioIdLineSourcingLineItemIdRouteImport } from './routes/_authenticated/projects/$projectId/sourcing/$sourcingScenarioId/line/$sourcingLineItemId'
import { Route as AuthenticatedProjectsProjectIdSourcingSidebarOverviewIndexRouteImport } from './routes/_authenticated/projects/$projectId/sourcing/_sidebar/overview/index'
import { Route as AuthenticatedProjectsProjectIdSourcingSidebarOverviewViewRouteImport } from './routes/_authenticated/projects/$projectId/sourcing/_sidebar/overview/$view'
import { Route as AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsIndexRouteImport } from './routes/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/index'
import { Route as AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsQuoteRequestIdRouteImport } from './routes/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/$quoteRequestId'
import { Route as AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsAssignRouteImport } from './routes/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/assign'
import { Route as AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsAttachmentsRouteImport } from './routes/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/attachments'
import { Route as AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsDeliveryLotSizeRouteImport } from './routes/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/delivery-lot-size'
import { Route as AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsExcelImporterRouteImport } from './routes/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/excel-importer'
import { Route as AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsImporterRouteImport } from './routes/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/importer'
import { Route as AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsLineItemsRouteImport } from './routes/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/line-items'
import { Route as AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsPreviewEmailRouteImport } from './routes/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/preview-email'
import { Route as AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsTargetPriceRouteImport } from './routes/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/target-price'
import { Route as AuthenticatedProjectsProjectIdSourcingSidebarScenariosCreateRouteImport } from './routes/_authenticated/projects/$projectId/sourcing/_sidebar/scenarios/create'
import { Route as AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdIndexRouteImport } from './routes/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/index'
import { Route as AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarRouteRouteImport } from './routes/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/_sidebar/route'
import { Route as AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdPurchaseOrdersRouteImport } from './routes/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/purchase-orders'
import { Route as AuthenticatedSettingsMenuOrganizationPcbPanelPreferencesCreateRouteImport } from './routes/_authenticated/settings/_menu/organization/pcb/panel-preferences/create'
import { Route as AuthenticatedTemplatesSidebarFlexibleCalculationAppsAppIdWidgetIdRouteImport } from './routes/_authenticated/templates/_sidebar/flexible-calculation/apps/$appId/$widgetId'
import { Route as AuthenticatedTemplatesSidebarFlexibleCalculationReviewConversionLegacyTemplateIdFlexibleCalculationTemplateIdRouteImport } from './routes/_authenticated/templates/_sidebar/flexible-calculation/review-conversion/$legacyTemplateId/$flexibleCalculationTemplateId'
import { Route as AuthenticatedNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownIndexRouteImport } from './routes/_authenticated/negotiations/$negotiationId/_sidebar/scenarios/$sourcingScenarioId/cost-breakdown/index'
import { Route as AuthenticatedNextNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdIndexRouteImport } from './routes/_authenticated/next/negotiations/$negotiationId/_sidebar/demand-groups/$demandGroupId/index'
import { Route as AuthenticatedNextNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdAwardingRouteImport } from './routes/_authenticated/next/negotiations/$negotiationId/_sidebar/demand-groups/$demandGroupId/awarding'
import { Route as AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdIndexRouteImport } from './routes/_authenticated/next/negotiations/$negotiationId/_sidebar/scenarios/$sourcingScenarioId/index'
import { Route as AuthenticatedNextNegotiationsNegotiationIdScenariosSourcingScenarioIdLineItemsSourcingLineItemIdRouteImport } from './routes/_authenticated/next/negotiations/$negotiationId/scenarios/$sourcingScenarioId/line-items/$sourcingLineItemId'
import { Route as AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbIndexRouteImport } from './routes/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/index'
import { Route as AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbCadViewerRouteImport } from './routes/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/cad-viewer'
import { Route as AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbDfmRouteImport } from './routes/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/dfm'
import { Route as AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbDfmAnalysisRouteImport } from './routes/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/dfm-analysis'
import { Route as AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbDrillsRouteImport } from './routes/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/drills'
import { Route as AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbFilesRouteImport } from './routes/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/files'
import { Route as AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbPanelizationRouteImport } from './routes/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/panelization'
import { Route as AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbSpecificationRouteImport } from './routes/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/specification'
import { Route as AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbStackupRouteImport } from './routes/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/stackup'
import { Route as AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdSubassembliesCreateRouteImport } from './routes/_authenticated/next/projects/$projectId/assemblies/$assemblyId/subassemblies/create'
import { Route as AuthenticatedNextProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdActivityRouteImport } from './routes/_authenticated/next/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/activity'
import { Route as AuthenticatedNextProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdExpenseRouteImport } from './routes/_authenticated/next/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/expense'
import { Route as AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdIndexRouteImport } from './routes/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/index'
import { Route as AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdPurchaseOrdersRouteImport } from './routes/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/purchase-orders'
import { Route as AuthenticatedNextSettingsMenuOrganizationPcbPanelPreferencesCreateRouteImport } from './routes/_authenticated/next/settings/_menu/organization/pcb/panel-preferences/create'
import { Route as AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbIndexRouteImport } from './routes/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/index'
import { Route as AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbCadViewerRouteImport } from './routes/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/cad-viewer'
import { Route as AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbDfmRouteImport } from './routes/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/dfm'
import { Route as AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbDfmAnalysisRouteImport } from './routes/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/dfm-analysis'
import { Route as AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbDrillsRouteImport } from './routes/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/drills'
import { Route as AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbFilesRouteImport } from './routes/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/files'
import { Route as AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbPanelizationRouteImport } from './routes/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/panelization'
import { Route as AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbSpecificationRouteImport } from './routes/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/specification'
import { Route as AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbStackupRouteImport } from './routes/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/stackup'
import { Route as AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdSubassembliesCreateRouteImport } from './routes/_authenticated/projects/$projectId/bom/assembly/$assemblyId/subassemblies/create'
import { Route as AuthenticatedProjectsProjectIdSourcingOfferCustomPartOfferIdDuplicateRouteImport } from './routes/_authenticated/projects/$projectId/sourcing/offer/custom-part/$offerId/duplicate'
import { Route as AuthenticatedProjectsProjectIdSourcingOfferCustomPartOfferIdEditRouteImport } from './routes/_authenticated/projects/$projectId/sourcing/offer/custom-part/$offerId/edit'
import { Route as AuthenticatedProjectsProjectIdSourcingOfferInternalPartNumberOfferIdDuplicateRouteImport } from './routes/_authenticated/projects/$projectId/sourcing/offer/internal-part-number/$offerId/duplicate'
import { Route as AuthenticatedProjectsProjectIdSourcingOfferInternalPartNumberOfferIdEditRouteImport } from './routes/_authenticated/projects/$projectId/sourcing/offer/internal-part-number/$offerId/edit'
import { Route as AuthenticatedProjectsProjectIdSourcingOfferOffTheShelfOfferIdDuplicateRouteImport } from './routes/_authenticated/projects/$projectId/sourcing/offer/off-the-shelf/$offerId/duplicate'
import { Route as AuthenticatedProjectsProjectIdSourcingOfferOffTheShelfOfferIdEditRouteImport } from './routes/_authenticated/projects/$projectId/sourcing/offer/off-the-shelf/$offerId/edit'
import { Route as AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarLineItemsRouteImport } from './routes/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/_sidebar/line-items'
import { Route as AuthenticatedSettingsMenuOrganizationPcbPanelPreferencesPanelPreferenceIdEditRouteImport } from './routes/_authenticated/settings/_menu/organization/pcb/panel-preferences/$panelPreferenceId/edit'
import { Route as AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownIndexRouteImport } from './routes/_authenticated/next/negotiations/$negotiationId/_sidebar/scenarios/$sourcingScenarioId/cost-breakdown/index'
import { Route as AuthenticatedNextProjectsProjectIdSourcingOffersCustomPartOfferIdDuplicateRouteImport } from './routes/_authenticated/next/projects/$projectId/sourcing/offers/custom-part/$offerId/duplicate'
import { Route as AuthenticatedNextProjectsProjectIdSourcingOffersCustomPartOfferIdEditRouteImport } from './routes/_authenticated/next/projects/$projectId/sourcing/offers/custom-part/$offerId/edit'
import { Route as AuthenticatedNextProjectsProjectIdSourcingOffersInternalPartNumberOfferIdDuplicateRouteImport } from './routes/_authenticated/next/projects/$projectId/sourcing/offers/internal-part-number/$offerId/duplicate'
import { Route as AuthenticatedNextProjectsProjectIdSourcingOffersInternalPartNumberOfferIdEditRouteImport } from './routes/_authenticated/next/projects/$projectId/sourcing/offers/internal-part-number/$offerId/edit'
import { Route as AuthenticatedNextProjectsProjectIdSourcingOffersOffTheShelfOfferIdDuplicateRouteImport } from './routes/_authenticated/next/projects/$projectId/sourcing/offers/off-the-shelf/$offerId/duplicate'
import { Route as AuthenticatedNextProjectsProjectIdSourcingOffersOffTheShelfOfferIdEditRouteImport } from './routes/_authenticated/next/projects/$projectId/sourcing/offers/off-the-shelf/$offerId/edit'
import { Route as AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdCostBreakdownIndexRouteImport } from './routes/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/cost-breakdown/index'
import { Route as AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdLineItemsIndexRouteImport } from './routes/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/line-items/index'
import { Route as AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdLineItemsSourcingLineItemIdRouteImport } from './routes/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/line-items/$sourcingLineItemId'
import { Route as AuthenticatedNextSettingsMenuOrganizationPcbPanelPreferencesPanelPreferenceIdEditRouteImport } from './routes/_authenticated/next/settings/_menu/organization/pcb/panel-preferences/$panelPreferenceId/edit'
import { Route as AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarCostBreakdownIndexRouteImport } from './routes/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/_sidebar/cost-breakdown/index'
import { Route as AuthenticatedNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownAssemblyAssemblyIdDemandDemandIdRouteImport } from './routes/_authenticated/negotiations/$negotiationId/_sidebar/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId'
import { Route as AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownAssemblyAssemblyIdDemandDemandIdRouteImport } from './routes/_authenticated/next/negotiations/$negotiationId/_sidebar/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId'
import { Route as AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdCostBreakdownAssemblyAssemblyIdDemandDemandIdRouteImport } from './routes/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId'
import { Route as AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarCostBreakdownAssemblyAssemblyIdDemandDemandIdRouteImport } from './routes/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/_sidebar/cost-breakdown/assembly/$assemblyId/demand/$demandId'

const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackRoute = CallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const LandingRoute = LandingRouteImport.update({
  id: '/landing',
  path: '/landing',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSplatRoute = AuthenticatedSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedCustomerPortalRouteRoute =
  AuthenticatedCustomerPortalRouteRouteImport.update({
    id: '/customer-portal',
    path: '/customer-portal',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedHomeRoute = AuthenticatedHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedMonitoringRouteRoute =
  AuthenticatedMonitoringRouteRouteImport.update({
    id: '/monitoring',
    path: '/monitoring',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedNextRouteRoute = AuthenticatedNextRouteRouteImport.update({
  id: '/next',
  path: '/next',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedProject_creationRoute =
  AuthenticatedProject_creationRouteImport.update({
    id: '/project_creation',
    path: '/project_creation',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPurchaseOrdersRoute =
  AuthenticatedPurchaseOrdersRouteImport.update({
    id: '/purchase-orders',
    path: '/purchase-orders',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedRfqsRoute = AuthenticatedRfqsRouteImport.update({
  id: '/rfqs',
  path: '/rfqs',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedRiskManagementRouteRoute =
  AuthenticatedRiskManagementRouteRouteImport.update({
    id: '/risk-management',
    path: '/risk-management',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedStartRoute = AuthenticatedStartRouteImport.update({
  id: '/start',
  path: '/start',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthEnterEmailRoute = AuthEnterEmailRouteImport.update({
  id: '/auth/enter-email',
  path: '/auth/enter-email',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAppsSplatRoute = AuthenticatedAppsSplatRouteImport.update({
  id: '/apps/$',
  path: '/apps/$',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAssembliesIndexRoute =
  AuthenticatedAssembliesIndexRouteImport.update({
    id: '/assemblies/',
    path: '/assemblies/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAssembliesAddAssemblyRoute =
  AuthenticatedAssembliesAddAssemblyRouteImport.update({
    id: '/assemblies/add-assembly',
    path: '/assemblies/add-assembly',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedComponentsImportRoute =
  AuthenticatedComponentsImportRouteImport.update({
    id: '/components/import',
    path: '/components/import',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCustomerPortalIndexRoute =
  AuthenticatedCustomerPortalIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCustomerPortalRouteRoute,
  } as any)
const AuthenticatedCustomersIndexRoute =
  AuthenticatedCustomersIndexRouteImport.update({
    id: '/customers/',
    path: '/customers/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCustomersCustomerIdRoute =
  AuthenticatedCustomersCustomerIdRouteImport.update({
    id: '/customers/$customerId',
    path: '/customers/$customerId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCustomersImporterRoute =
  AuthenticatedCustomersImporterRouteImport.update({
    id: '/customers/importer',
    path: '/customers/importer',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedManufacturerSplatRoute =
  AuthenticatedManufacturerSplatRouteImport.update({
    id: '/manufacturer/$',
    path: '/manufacturer/$',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedManufacturersManufacturerIdRoute =
  AuthenticatedManufacturersManufacturerIdRouteImport.update({
    id: '/manufacturers/$manufacturerId',
    path: '/manufacturers/$manufacturerId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedManufacturersSidebarRouteRoute =
  AuthenticatedManufacturersSidebarRouteRouteImport.update({
    id: '/manufacturers/_sidebar',
    path: '/manufacturers',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedManufacturersImporterRoute =
  AuthenticatedManufacturersImporterRouteImport.update({
    id: '/manufacturers/importer',
    path: '/manufacturers/importer',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedManufacturingIndexRoute =
  AuthenticatedManufacturingIndexRouteImport.update({
    id: '/manufacturing/',
    path: '/manufacturing/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedManufacturingSidebarRouteRoute =
  AuthenticatedManufacturingSidebarRouteRouteImport.update({
    id: '/manufacturing/_sidebar',
    path: '/manufacturing',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedManufacturingAddActivityRoute =
  AuthenticatedManufacturingAddActivityRouteImport.update({
    id: '/manufacturing/add-activity',
    path: '/manufacturing/add-activity',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedManufacturingAddDriverRoute =
  AuthenticatedManufacturingAddDriverRouteImport.update({
    id: '/manufacturing/add-driver',
    path: '/manufacturing/add-driver',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedManufacturingAddExpenseRoute =
  AuthenticatedManufacturingAddExpenseRouteImport.update({
    id: '/manufacturing/add-expense',
    path: '/manufacturing/add-expense',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedManufacturingAddResourceRoute =
  AuthenticatedManufacturingAddResourceRouteImport.update({
    id: '/manufacturing/add-resource',
    path: '/manufacturing/add-resource',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMonitoringSidebarRouteRoute =
  AuthenticatedMonitoringSidebarRouteRouteImport.update({
    id: '/_sidebar',
    getParentRoute: () => AuthenticatedMonitoringRouteRoute,
  } as any)
const AuthenticatedMonitoringAnalysisRoute =
  AuthenticatedMonitoringAnalysisRouteImport.update({
    id: '/analysis',
    path: '/analysis',
    getParentRoute: () => AuthenticatedMonitoringRouteRoute,
  } as any)
const AuthenticatedNegotiationsIndexRoute =
  AuthenticatedNegotiationsIndexRouteImport.update({
    id: '/negotiations/',
    path: '/negotiations/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedNegotiationsCreateRoute =
  AuthenticatedNegotiationsCreateRouteImport.update({
    id: '/negotiations/create',
    path: '/negotiations/create',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedNextIndexRoute = AuthenticatedNextIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedNextRouteRoute,
} as any)
const AuthenticatedNextSplatRoute = AuthenticatedNextSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AuthenticatedNextRouteRoute,
} as any)
const AuthenticatedNextAlertsRoute = AuthenticatedNextAlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => AuthenticatedNextRouteRoute,
} as any)
const AuthenticatedNextHomeRoute = AuthenticatedNextHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AuthenticatedNextRouteRoute,
} as any)
const AuthenticatedNextLumiAgentRoute =
  AuthenticatedNextLumiAgentRouteImport.update({
    id: '/lumi-agent',
    path: '/lumi-agent',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextPurchaseOrdersRoute =
  AuthenticatedNextPurchaseOrdersRouteImport.update({
    id: '/purchase-orders',
    path: '/purchase-orders',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedOffersMpnOfferImporterRoute =
  AuthenticatedOffersMpnOfferImporterRouteImport.update({
    id: '/offers/mpn-offer-importer',
    path: '/offers/mpn-offer-importer',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOrdersUploadRoute =
  AuthenticatedOrdersUploadRouteImport.update({
    id: '/orders/upload',
    path: '/orders/upload',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOrdersChar123OrderIdChar125Route =
  AuthenticatedOrdersChar123OrderIdChar125RouteImport.update({
    id: '/orders/{-$orderId}',
    path: '/orders/{-$orderId}',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPartsIndexRoute = AuthenticatedPartsIndexRouteImport.update({
  id: '/parts/',
  path: '/parts/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedPartsSidebarRouteRoute =
  AuthenticatedPartsSidebarRouteRouteImport.update({
    id: '/parts/_sidebar',
    path: '/parts',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPartsOffTheShelfPartSearchRoute =
  AuthenticatedPartsOffTheShelfPartSearchRouteImport.update({
    id: '/parts/off-the-shelf-part-search',
    path: '/parts/off-the-shelf-part-search',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProjectsIndexRoute =
  AuthenticatedProjectsIndexRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProjectsCreateRoute =
  AuthenticatedProjectsCreateRouteImport.update({
    id: '/projects/create',
    path: '/projects/create',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProjectsNewRoute =
  AuthenticatedProjectsNewRouteImport.update({
    id: '/projects/new',
    path: '/projects/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedQuoteRequestsExcelImporterRoute =
  AuthenticatedQuoteRequestsExcelImporterRouteImport.update({
    id: '/quote-requests/excel-importer',
    path: '/quote-requests/excel-importer',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedRiskManagementIndexRoute =
  AuthenticatedRiskManagementIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedRiskManagementRouteRoute,
  } as any)
const AuthenticatedRiskManagementGeoRiskRoute =
  AuthenticatedRiskManagementGeoRiskRouteImport.update({
    id: '/geo-risk',
    path: '/geo-risk',
    getParentRoute: () => AuthenticatedRiskManagementRouteRoute,
  } as any)
const AuthenticatedRiskManagementPcnsRoute =
  AuthenticatedRiskManagementPcnsRouteImport.update({
    id: '/pcns',
    path: '/pcns',
    getParentRoute: () => AuthenticatedRiskManagementRouteRoute,
  } as any)
const AuthenticatedRiskManagementRiskDigestRoute =
  AuthenticatedRiskManagementRiskDigestRouteImport.update({
    id: '/risk-digest',
    path: '/risk-digest',
    getParentRoute: () => AuthenticatedRiskManagementRouteRoute,
  } as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsMenuRouteRoute =
  AuthenticatedSettingsMenuRouteRouteImport.update({
    id: '/settings/_menu',
    path: '/settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsCompanyRoute =
  AuthenticatedSettingsCompanyRouteImport.update({
    id: '/settings/company',
    path: '/settings/company',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSupplierPortalIndexRoute =
  AuthenticatedSupplierPortalIndexRouteImport.update({
    id: '/supplier-portal/',
    path: '/supplier-portal/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSupplierImporterRoute =
  AuthenticatedSupplierImporterRouteImport.update({
    id: '/supplier/importer',
    path: '/supplier/importer',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSuppliersSupplierAndStockLocationIdRoute =
  AuthenticatedSuppliersSupplierAndStockLocationIdRouteImport.update({
    id: '/suppliers/$supplierAndStockLocationId',
    path: '/suppliers/$supplierAndStockLocationId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSuppliersSidebarRouteRoute =
  AuthenticatedSuppliersSidebarRouteRouteImport.update({
    id: '/suppliers/_sidebar',
    path: '/suppliers',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSuppliersImporterRoute =
  AuthenticatedSuppliersImporterRouteImport.update({
    id: '/suppliers/importer',
    path: '/suppliers/importer',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTemplateSplatRoute =
  AuthenticatedTemplateSplatRouteImport.update({
    id: '/template/$',
    path: '/template/$',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTemplatesIndexRoute =
  AuthenticatedTemplatesIndexRouteImport.update({
    id: '/templates/',
    path: '/templates/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTemplatesSidebarRouteRoute =
  AuthenticatedTemplatesSidebarRouteRouteImport.update({
    id: '/templates/_sidebar',
    path: '/templates',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthSignupCustomerRoute = AuthSignupCustomerRouteImport.update({
  id: '/auth/signup/customer',
  path: '/auth/signup/customer',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignupInviteRoute = AuthSignupInviteRouteImport.update({
  id: '/auth/signup/invite',
  path: '/auth/signup/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const Authenticated3rdpartyDigikeyCallbackRoute =
  Authenticated3rdpartyDigikeyCallbackRouteImport.update({
    id: '/3rdparty/digikey/callback',
    path: '/3rdparty/digikey/callback',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAssembliesAssemblyIdIndexRoute =
  AuthenticatedAssembliesAssemblyIdIndexRouteImport.update({
    id: '/assemblies/$assemblyId/',
    path: '/assemblies/$assemblyId/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAssembliesAssemblyIdDashboardRoute =
  AuthenticatedAssembliesAssemblyIdDashboardRouteImport.update({
    id: '/assemblies/$assemblyId/dashboard',
    path: '/assemblies/$assemblyId/dashboard',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAssembliesAssemblyIdDetailsRoute =
  AuthenticatedAssembliesAssemblyIdDetailsRouteImport.update({
    id: '/assemblies/$assemblyId/details',
    path: '/assemblies/$assemblyId/details',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAssembliesAssemblyIdEditRoute =
  AuthenticatedAssembliesAssemblyIdEditRouteImport.update({
    id: '/assemblies/$assemblyId/edit',
    path: '/assemblies/$assemblyId/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAssembliesAssemblyIdPcbRouteRoute =
  AuthenticatedAssembliesAssemblyIdPcbRouteRouteImport.update({
    id: '/assemblies/$assemblyId/pcb',
    path: '/assemblies/$assemblyId/pcb',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedManufacturersSidebarIndexRoute =
  AuthenticatedManufacturersSidebarIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedManufacturersSidebarRouteRoute,
  } as any)
const AuthenticatedManufacturersSidebarLineCardRoute =
  AuthenticatedManufacturersSidebarLineCardRouteImport.update({
    id: '/line-card',
    path: '/line-card',
    getParentRoute: () => AuthenticatedManufacturersSidebarRouteRoute,
  } as any)
const AuthenticatedManufacturingActivitiesCreateRoute =
  AuthenticatedManufacturingActivitiesCreateRouteImport.update({
    id: '/manufacturing/activities/create',
    path: '/manufacturing/activities/create',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedManufacturingActivitySplatRoute =
  AuthenticatedManufacturingActivitySplatRouteImport.update({
    id: '/manufacturing/activity/$',
    path: '/manufacturing/activity/$',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedManufacturingDriverSplatRoute =
  AuthenticatedManufacturingDriverSplatRouteImport.update({
    id: '/manufacturing/driver/$',
    path: '/manufacturing/driver/$',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedManufacturingDriversCreateRoute =
  AuthenticatedManufacturingDriversCreateRouteImport.update({
    id: '/manufacturing/drivers/create',
    path: '/manufacturing/drivers/create',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedManufacturingExpenseSplatRoute =
  AuthenticatedManufacturingExpenseSplatRouteImport.update({
    id: '/manufacturing/expense/$',
    path: '/manufacturing/expense/$',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedManufacturingExpensesCreateRoute =
  AuthenticatedManufacturingExpensesCreateRouteImport.update({
    id: '/manufacturing/expenses/create',
    path: '/manufacturing/expenses/create',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedManufacturingResourceSplatRoute =
  AuthenticatedManufacturingResourceSplatRouteImport.update({
    id: '/manufacturing/resource/$',
    path: '/manufacturing/resource/$',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedManufacturingResourcesCreateRoute =
  AuthenticatedManufacturingResourcesCreateRouteImport.update({
    id: '/manufacturing/resources/create',
    path: '/manufacturing/resources/create',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedManufacturingTemplateSplatRoute =
  AuthenticatedManufacturingTemplateSplatRouteImport.update({
    id: '/manufacturing/template/$',
    path: '/manufacturing/template/$',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMonitoringSidebarIndexRoute =
  AuthenticatedMonitoringSidebarIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedMonitoringSidebarRouteRoute,
  } as any)
const AuthenticatedMonitoringSidebarComponentSavingsRoute =
  AuthenticatedMonitoringSidebarComponentSavingsRouteImport.update({
    id: '/component-savings',
    path: '/component-savings',
    getParentRoute: () => AuthenticatedMonitoringSidebarRouteRoute,
  } as any)
const AuthenticatedMonitoringSidebarDataHealthRoute =
  AuthenticatedMonitoringSidebarDataHealthRouteImport.update({
    id: '/data-health',
    path: '/data-health',
    getParentRoute: () => AuthenticatedMonitoringSidebarRouteRoute,
  } as any)
const AuthenticatedMonitoringSidebarOffersRoute =
  AuthenticatedMonitoringSidebarOffersRouteImport.update({
    id: '/offers',
    path: '/offers',
    getParentRoute: () => AuthenticatedMonitoringSidebarRouteRoute,
  } as any)
const AuthenticatedMonitoringSidebarOnboardingRoute =
  AuthenticatedMonitoringSidebarOnboardingRouteImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => AuthenticatedMonitoringSidebarRouteRoute,
  } as any)
const AuthenticatedMonitoringAgentSplatRoute =
  AuthenticatedMonitoringAgentSplatRouteImport.update({
    id: '/agent/$',
    path: '/agent/$',
    getParentRoute: () => AuthenticatedMonitoringRouteRoute,
  } as any)
const AuthenticatedMonitoringChartsChartIdRoute =
  AuthenticatedMonitoringChartsChartIdRouteImport.update({
    id: '/charts/$chartId',
    path: '/charts/$chartId',
    getParentRoute: () => AuthenticatedMonitoringRouteRoute,
  } as any)
const AuthenticatedNegotiationsNegotiationIdIndexRoute =
  AuthenticatedNegotiationsNegotiationIdIndexRouteImport.update({
    id: '/negotiations/$negotiationId/',
    path: '/negotiations/$negotiationId/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute =
  AuthenticatedNegotiationsNegotiationIdSidebarRouteRouteImport.update({
    id: '/negotiations/$negotiationId/_sidebar',
    path: '/negotiations/$negotiationId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedNextAppsSplatRoute =
  AuthenticatedNextAppsSplatRouteImport.update({
    id: '/apps/$',
    path: '/apps/$',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextAssembliesIndexRoute =
  AuthenticatedNextAssembliesIndexRouteImport.update({
    id: '/assemblies/',
    path: '/assemblies/',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextComponentsIndexRoute =
  AuthenticatedNextComponentsIndexRouteImport.update({
    id: '/components/',
    path: '/components/',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextComponentsLinkingRoute =
  AuthenticatedNextComponentsLinkingRouteImport.update({
    id: '/components/linking',
    path: '/components/linking',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextCustomersIndexRoute =
  AuthenticatedNextCustomersIndexRouteImport.update({
    id: '/customers/',
    path: '/customers/',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextCustomersCustomerIdRoute =
  AuthenticatedNextCustomersCustomerIdRouteImport.update({
    id: '/customers/$customerId',
    path: '/customers/$customerId',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextDemandsIndexRoute =
  AuthenticatedNextDemandsIndexRouteImport.update({
    id: '/demands/',
    path: '/demands/',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextDemandsImporterRoute =
  AuthenticatedNextDemandsImporterRouteImport.update({
    id: '/demands/importer',
    path: '/demands/importer',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextManufacturersIndexRoute =
  AuthenticatedNextManufacturersIndexRouteImport.update({
    id: '/manufacturers/',
    path: '/manufacturers/',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextManufacturersManufacturerIdRoute =
  AuthenticatedNextManufacturersManufacturerIdRouteImport.update({
    id: '/manufacturers/$manufacturerId',
    path: '/manufacturers/$manufacturerId',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextManufacturersLineCardRoute =
  AuthenticatedNextManufacturersLineCardRouteImport.update({
    id: '/manufacturers/line-card',
    path: '/manufacturers/line-card',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextNegotiationsIndexRoute =
  AuthenticatedNextNegotiationsIndexRouteImport.update({
    id: '/negotiations/',
    path: '/negotiations/',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextNegotiationsCreateRoute =
  AuthenticatedNextNegotiationsCreateRouteImport.update({
    id: '/negotiations/create',
    path: '/negotiations/create',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextOfferImportsIndexRoute =
  AuthenticatedNextOfferImportsIndexRouteImport.update({
    id: '/offer-imports/',
    path: '/offer-imports/',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextOfferImportsOfferImportIdRoute =
  AuthenticatedNextOfferImportsOfferImportIdRouteImport.update({
    id: '/offer-imports/$offerImportId',
    path: '/offer-imports/$offerImportId',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextOrdersUploadRoute =
  AuthenticatedNextOrdersUploadRouteImport.update({
    id: '/orders/upload',
    path: '/orders/upload',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextOrdersChar123OrderIdChar125Route =
  AuthenticatedNextOrdersChar123OrderIdChar125RouteImport.update({
    id: '/orders/{-$orderId}',
    path: '/orders/{-$orderId}',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextPartsIndexRoute =
  AuthenticatedNextPartsIndexRouteImport.update({
    id: '/parts/',
    path: '/parts/',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextPartsPartIdRouteRoute =
  AuthenticatedNextPartsPartIdRouteRouteImport.update({
    id: '/parts/$partId',
    path: '/parts/$partId',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextPartsSearchRoute =
  AuthenticatedNextPartsSearchRouteImport.update({
    id: '/parts/search',
    path: '/parts/search',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextProjectsIndexRoute =
  AuthenticatedNextProjectsIndexRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextProjectsProjectIdRouteRoute =
  AuthenticatedNextProjectsProjectIdRouteRouteImport.update({
    id: '/projects/$projectId',
    path: '/projects/$projectId',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextProjectsCreateRoute =
  AuthenticatedNextProjectsCreateRouteImport.update({
    id: '/projects/create',
    path: '/projects/create',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextQuoteRequestsIndexRoute =
  AuthenticatedNextQuoteRequestsIndexRouteImport.update({
    id: '/quote-requests/',
    path: '/quote-requests/',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextQuoteRequestsImporterRoute =
  AuthenticatedNextQuoteRequestsImporterRouteImport.update({
    id: '/quote-requests/importer',
    path: '/quote-requests/importer',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextRiskManagementIndexRoute =
  AuthenticatedNextRiskManagementIndexRouteImport.update({
    id: '/risk-management/',
    path: '/risk-management/',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextRiskManagementGeoRiskRoute =
  AuthenticatedNextRiskManagementGeoRiskRouteImport.update({
    id: '/risk-management/geo-risk',
    path: '/risk-management/geo-risk',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextRiskManagementPcnsRoute =
  AuthenticatedNextRiskManagementPcnsRouteImport.update({
    id: '/risk-management/pcns',
    path: '/risk-management/pcns',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextRiskManagementRiskDigestRoute =
  AuthenticatedNextRiskManagementRiskDigestRouteImport.update({
    id: '/risk-management/risk-digest',
    path: '/risk-management/risk-digest',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextSettingsIndexRoute =
  AuthenticatedNextSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextSettingsMenuRouteRoute =
  AuthenticatedNextSettingsMenuRouteRouteImport.update({
    id: '/settings/_menu',
    path: '/settings',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextSettingsCompanyRoute =
  AuthenticatedNextSettingsCompanyRouteImport.update({
    id: '/settings/company',
    path: '/settings/company',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextSuppliersIndexRoute =
  AuthenticatedNextSuppliersIndexRouteImport.update({
    id: '/suppliers/',
    path: '/suppliers/',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextSuppliersSupplierAndStockLocationIdRoute =
  AuthenticatedNextSuppliersSupplierAndStockLocationIdRouteImport.update({
    id: '/suppliers/$supplierAndStockLocationId',
    path: '/suppliers/$supplierAndStockLocationId',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextSuppliersStrategyRoute =
  AuthenticatedNextSuppliersStrategyRouteImport.update({
    id: '/suppliers/strategy',
    path: '/suppliers/strategy',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextTemplatesExportRoute =
  AuthenticatedNextTemplatesExportRouteImport.update({
    id: '/templates/export',
    path: '/templates/export',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextTemplatesPcbSpecificationRoute =
  AuthenticatedNextTemplatesPcbSpecificationRouteImport.update({
    id: '/templates/pcb-specification',
    path: '/templates/pcb-specification',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedPartsSidebarAlertsRoute =
  AuthenticatedPartsSidebarAlertsRouteImport.update({
    id: '/alerts',
    path: '/alerts',
    getParentRoute: () => AuthenticatedPartsSidebarRouteRoute,
  } as any)
const AuthenticatedPartsSidebarSearchRoute =
  AuthenticatedPartsSidebarSearchRouteImport.update({
    id: '/search',
    path: '/search',
    getParentRoute: () => AuthenticatedPartsSidebarRouteRoute,
  } as any)
const AuthenticatedPartsComponentsComponentImporterRoute =
  AuthenticatedPartsComponentsComponentImporterRouteImport.update({
    id: '/parts/components/component-importer',
    path: '/parts/components/component-importer',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPartsComponentsImporterRoute =
  AuthenticatedPartsComponentsImporterRouteImport.update({
    id: '/parts/components/importer',
    path: '/parts/components/importer',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPartsComponentsLinkingRoute =
  AuthenticatedPartsComponentsLinkingRouteImport.update({
    id: '/parts/components/linking',
    path: '/parts/components/linking',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPartsDemandDemandImporterRoute =
  AuthenticatedPartsDemandDemandImporterRouteImport.update({
    id: '/parts/demand/demand-importer',
    path: '/parts/demand/demand-importer',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPartsDetailsPartIdRouteRoute =
  AuthenticatedPartsDetailsPartIdRouteRouteImport.update({
    id: '/parts/details/$partId',
    path: '/parts/details/$partId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPartsOffersAddRoute =
  AuthenticatedPartsOffersAddRouteImport.update({
    id: '/parts/offers/add',
    path: '/parts/offers/add',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPartsOffersCreateRoute =
  AuthenticatedPartsOffersCreateRouteImport.update({
    id: '/parts/offers/create',
    path: '/parts/offers/create',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPartsOffersCsvImporterRoute =
  AuthenticatedPartsOffersCsvImporterRouteImport.update({
    id: '/parts/offers/csv-importer',
    path: '/parts/offers/csv-importer',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPartsQuoteRequestsExcelImporterRoute =
  AuthenticatedPartsQuoteRequestsExcelImporterRouteImport.update({
    id: '/parts/quote-requests/excel-importer',
    path: '/parts/quote-requests/excel-importer',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPartsQuoteRequestsImporterRoute =
  AuthenticatedPartsQuoteRequestsImporterRouteImport.update({
    id: '/parts/quote-requests/importer',
    path: '/parts/quote-requests/importer',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProjectsProjectIdIndexRoute =
  AuthenticatedProjectsProjectIdIndexRouteImport.update({
    id: '/projects/$projectId/',
    path: '/projects/$projectId/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProjectsProjectIdDashboardRoute =
  AuthenticatedProjectsProjectIdDashboardRouteImport.update({
    id: '/projects/$projectId/dashboard',
    path: '/projects/$projectId/dashboard',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProjectsProjectIdEditRoute =
  AuthenticatedProjectsProjectIdEditRouteImport.update({
    id: '/projects/$projectId/edit',
    path: '/projects/$projectId/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProjectsProjectIdQuotationRoute =
  AuthenticatedProjectsProjectIdQuotationRouteImport.update({
    id: '/projects/$projectId/quotation',
    path: '/projects/$projectId/quotation',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedRiskManagementLibraryHealthIndexRoute =
  AuthenticatedRiskManagementLibraryHealthIndexRouteImport.update({
    id: '/library-health/',
    path: '/library-health/',
    getParentRoute: () => AuthenticatedRiskManagementRouteRoute,
  } as any)
const AuthenticatedRiskManagementLibraryHealthAssembliesRoute =
  AuthenticatedRiskManagementLibraryHealthAssembliesRouteImport.update({
    id: '/library-health/assemblies',
    path: '/library-health/assemblies',
    getParentRoute: () => AuthenticatedRiskManagementRouteRoute,
  } as any)
const AuthenticatedRiskManagementLibraryHealthComponentsRoute =
  AuthenticatedRiskManagementLibraryHealthComponentsRouteImport.update({
    id: '/library-health/components',
    path: '/library-health/components',
    getParentRoute: () => AuthenticatedRiskManagementRouteRoute,
  } as any)
const AuthenticatedRiskManagementLibraryHealthPartsRoute =
  AuthenticatedRiskManagementLibraryHealthPartsRouteImport.update({
    id: '/library-health/parts',
    path: '/library-health/parts',
    getParentRoute: () => AuthenticatedRiskManagementRouteRoute,
  } as any)
const AuthenticatedSuppliersSidebarIndexRoute =
  AuthenticatedSuppliersSidebarIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSuppliersSidebarRouteRoute,
  } as any)
const AuthenticatedSuppliersSidebarStrategyRoute =
  AuthenticatedSuppliersSidebarStrategyRouteImport.update({
    id: '/strategy',
    path: '/strategy',
    getParentRoute: () => AuthenticatedSuppliersSidebarRouteRoute,
  } as any)
const AuthenticatedSuppliersLineCardRulesImporterRoute =
  AuthenticatedSuppliersLineCardRulesImporterRouteImport.update({
    id: '/suppliers/line-card-rules/importer',
    path: '/suppliers/line-card-rules/importer',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSuppliersSupplierContactsImporterBulkRoute =
  AuthenticatedSuppliersSupplierContactsImporterBulkRouteImport.update({
    id: '/suppliers/supplier-contacts-importer/bulk',
    path: '/suppliers/supplier-contacts-importer/bulk',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSuppliersSupplierContactsImporterRoute =
  AuthenticatedSuppliersSupplierContactsImporterRouteImport.update({
    id: '/suppliers/supplier-contacts/importer',
    path: '/suppliers/supplier-contacts/importer',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTemplatesSidebarExportRoute =
  AuthenticatedTemplatesSidebarExportRouteImport.update({
    id: '/export',
    path: '/export',
    getParentRoute: () => AuthenticatedTemplatesSidebarRouteRoute,
  } as any)
const AuthenticatedTemplatesSidebarPcbSpecificationRoute =
  AuthenticatedTemplatesSidebarPcbSpecificationRouteImport.update({
    id: '/pcb-specification',
    path: '/pcb-specification',
    getParentRoute: () => AuthenticatedTemplatesSidebarRouteRoute,
  } as any)
const AuthenticatedTemplatesCalculationAddTemplateRoute =
  AuthenticatedTemplatesCalculationAddTemplateRouteImport.update({
    id: '/templates/calculation/add-template',
    path: '/templates/calculation/add-template',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTemplatesCalculationCreateRoute =
  AuthenticatedTemplatesCalculationCreateRouteImport.update({
    id: '/templates/calculation/create',
    path: '/templates/calculation/create',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTemplatesFlexibleCalculationNewRoute =
  AuthenticatedTemplatesFlexibleCalculationNewRouteImport.update({
    id: '/templates/flexible-calculation/new',
    path: '/templates/flexible-calculation/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTemplatesQuotationCreateRoute =
  AuthenticatedTemplatesQuotationCreateRouteImport.update({
    id: '/templates/quotation/create',
    path: '/templates/quotation/create',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTemplatesQuotationEditRoute =
  AuthenticatedTemplatesQuotationEditRouteImport.update({
    id: '/templates/quotation/edit',
    path: '/templates/quotation/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAssembliesAssemblyIdPcbIndexRoute =
  AuthenticatedAssembliesAssemblyIdPcbIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAssembliesAssemblyIdPcbRouteRoute,
  } as any)
const AuthenticatedAssembliesAssemblyIdPcbCadViewerRoute =
  AuthenticatedAssembliesAssemblyIdPcbCadViewerRouteImport.update({
    id: '/cad-viewer',
    path: '/cad-viewer',
    getParentRoute: () => AuthenticatedAssembliesAssemblyIdPcbRouteRoute,
  } as any)
const AuthenticatedAssembliesAssemblyIdPcbDfmRoute =
  AuthenticatedAssembliesAssemblyIdPcbDfmRouteImport.update({
    id: '/dfm',
    path: '/dfm',
    getParentRoute: () => AuthenticatedAssembliesAssemblyIdPcbRouteRoute,
  } as any)
const AuthenticatedAssembliesAssemblyIdPcbDfmAnalysisRoute =
  AuthenticatedAssembliesAssemblyIdPcbDfmAnalysisRouteImport.update({
    id: '/dfm-analysis',
    path: '/dfm-analysis',
    getParentRoute: () => AuthenticatedAssembliesAssemblyIdPcbRouteRoute,
  } as any)
const AuthenticatedAssembliesAssemblyIdPcbDrillsRoute =
  AuthenticatedAssembliesAssemblyIdPcbDrillsRouteImport.update({
    id: '/drills',
    path: '/drills',
    getParentRoute: () => AuthenticatedAssembliesAssemblyIdPcbRouteRoute,
  } as any)
const AuthenticatedAssembliesAssemblyIdPcbFilesRoute =
  AuthenticatedAssembliesAssemblyIdPcbFilesRouteImport.update({
    id: '/files',
    path: '/files',
    getParentRoute: () => AuthenticatedAssembliesAssemblyIdPcbRouteRoute,
  } as any)
const AuthenticatedAssembliesAssemblyIdPcbPanelizationRoute =
  AuthenticatedAssembliesAssemblyIdPcbPanelizationRouteImport.update({
    id: '/panelization',
    path: '/panelization',
    getParentRoute: () => AuthenticatedAssembliesAssemblyIdPcbRouteRoute,
  } as any)
const AuthenticatedAssembliesAssemblyIdPcbSpecificationRoute =
  AuthenticatedAssembliesAssemblyIdPcbSpecificationRouteImport.update({
    id: '/specification',
    path: '/specification',
    getParentRoute: () => AuthenticatedAssembliesAssemblyIdPcbRouteRoute,
  } as any)
const AuthenticatedAssembliesAssemblyIdPcbStackupRoute =
  AuthenticatedAssembliesAssemblyIdPcbStackupRouteImport.update({
    id: '/stackup',
    path: '/stackup',
    getParentRoute: () => AuthenticatedAssembliesAssemblyIdPcbRouteRoute,
  } as any)
const AuthenticatedAssembliesAssemblyIdSubassembliesCreateRoute =
  AuthenticatedAssembliesAssemblyIdSubassembliesCreateRouteImport.update({
    id: '/assemblies/$assemblyId/subassemblies/create',
    path: '/assemblies/$assemblyId/subassemblies/create',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedManufacturingSidebarActivitiesIndexRoute =
  AuthenticatedManufacturingSidebarActivitiesIndexRouteImport.update({
    id: '/activities/',
    path: '/activities/',
    getParentRoute: () => AuthenticatedManufacturingSidebarRouteRoute,
  } as any)
const AuthenticatedManufacturingSidebarDriversIndexRoute =
  AuthenticatedManufacturingSidebarDriversIndexRouteImport.update({
    id: '/drivers/',
    path: '/drivers/',
    getParentRoute: () => AuthenticatedManufacturingSidebarRouteRoute,
  } as any)
const AuthenticatedManufacturingSidebarExpensesIndexRoute =
  AuthenticatedManufacturingSidebarExpensesIndexRouteImport.update({
    id: '/expenses/',
    path: '/expenses/',
    getParentRoute: () => AuthenticatedManufacturingSidebarRouteRoute,
  } as any)
const AuthenticatedManufacturingSidebarResourcesIndexRoute =
  AuthenticatedManufacturingSidebarResourcesIndexRouteImport.update({
    id: '/resources/',
    path: '/resources/',
    getParentRoute: () => AuthenticatedManufacturingSidebarRouteRoute,
  } as any)
const AuthenticatedManufacturingSidebarTemplatesChar123TemplateIdChar125Route =
  AuthenticatedManufacturingSidebarTemplatesChar123TemplateIdChar125RouteImport.update(
    {
      id: '/templates/{-$templateId}',
      path: '/templates/{-$templateId}',
      getParentRoute: () => AuthenticatedManufacturingSidebarRouteRoute,
    } as any,
  )
const AuthenticatedManufacturingActivitiesActivityIdDuplicateRoute =
  AuthenticatedManufacturingActivitiesActivityIdDuplicateRouteImport.update({
    id: '/manufacturing/activities/$activityId/duplicate',
    path: '/manufacturing/activities/$activityId/duplicate',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedManufacturingActivitiesActivityIdEditRoute =
  AuthenticatedManufacturingActivitiesActivityIdEditRouteImport.update({
    id: '/manufacturing/activities/$activityId/edit',
    path: '/manufacturing/activities/$activityId/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedManufacturingDriversDriverIdDuplicateRoute =
  AuthenticatedManufacturingDriversDriverIdDuplicateRouteImport.update({
    id: '/manufacturing/drivers/$driverId/duplicate',
    path: '/manufacturing/drivers/$driverId/duplicate',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedManufacturingDriversDriverIdEditRoute =
  AuthenticatedManufacturingDriversDriverIdEditRouteImport.update({
    id: '/manufacturing/drivers/$driverId/edit',
    path: '/manufacturing/drivers/$driverId/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedManufacturingExpensesExpenseIdDuplicateRoute =
  AuthenticatedManufacturingExpensesExpenseIdDuplicateRouteImport.update({
    id: '/manufacturing/expenses/$expenseId/duplicate',
    path: '/manufacturing/expenses/$expenseId/duplicate',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedManufacturingExpensesExpenseIdEditRoute =
  AuthenticatedManufacturingExpensesExpenseIdEditRouteImport.update({
    id: '/manufacturing/expenses/$expenseId/edit',
    path: '/manufacturing/expenses/$expenseId/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedManufacturingResourcesResourceIdDuplicateRoute =
  AuthenticatedManufacturingResourcesResourceIdDuplicateRouteImport.update({
    id: '/manufacturing/resources/$resourceId/duplicate',
    path: '/manufacturing/resources/$resourceId/duplicate',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedManufacturingResourcesResourceIdEditRoute =
  AuthenticatedManufacturingResourcesResourceIdEditRouteImport.update({
    id: '/manufacturing/resources/$resourceId/edit',
    path: '/manufacturing/resources/$resourceId/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMonitoringSidebarChartsIndexRoute =
  AuthenticatedMonitoringSidebarChartsIndexRouteImport.update({
    id: '/charts/',
    path: '/charts/',
    getParentRoute: () => AuthenticatedMonitoringSidebarRouteRoute,
  } as any)
const AuthenticatedMonitoringSidebarComponentsPricingRoute =
  AuthenticatedMonitoringSidebarComponentsPricingRouteImport.update({
    id: '/components/pricing',
    path: '/components/pricing',
    getParentRoute: () => AuthenticatedMonitoringSidebarRouteRoute,
  } as any)
const AuthenticatedMonitoringSidebarDashboardsIndexRoute =
  AuthenticatedMonitoringSidebarDashboardsIndexRouteImport.update({
    id: '/dashboards/',
    path: '/dashboards/',
    getParentRoute: () => AuthenticatedMonitoringSidebarRouteRoute,
  } as any)
const AuthenticatedMonitoringSidebarDashboardsDashboardIdRoute =
  AuthenticatedMonitoringSidebarDashboardsDashboardIdRouteImport.update({
    id: '/dashboards/$dashboardId',
    path: '/dashboards/$dashboardId',
    getParentRoute: () => AuthenticatedMonitoringSidebarRouteRoute,
  } as any)
const AuthenticatedMonitoringSidebarInsightsAgentChar123ConversationIdChar125Route =
  AuthenticatedMonitoringSidebarInsightsAgentChar123ConversationIdChar125RouteImport.update(
    {
      id: '/insights-agent/{-$conversationId}',
      path: '/insights-agent/{-$conversationId}',
      getParentRoute: () => AuthenticatedMonitoringSidebarRouteRoute,
    } as any,
  )
const AuthenticatedMonitoringSidebarJobsIndexRoute =
  AuthenticatedMonitoringSidebarJobsIndexRouteImport.update({
    id: '/jobs/',
    path: '/jobs/',
    getParentRoute: () => AuthenticatedMonitoringSidebarRouteRoute,
  } as any)
const AuthenticatedMonitoringSidebarJobsJobIdRoute =
  AuthenticatedMonitoringSidebarJobsJobIdRouteImport.update({
    id: '/jobs/$jobId',
    path: '/jobs/$jobId',
    getParentRoute: () => AuthenticatedMonitoringSidebarRouteRoute,
  } as any)
const AuthenticatedMonitoringSidebarReportsSavingsRoute =
  AuthenticatedMonitoringSidebarReportsSavingsRouteImport.update({
    id: '/reports/savings',
    path: '/reports/savings',
    getParentRoute: () => AuthenticatedMonitoringSidebarRouteRoute,
  } as any)
const AuthenticatedNegotiationsNegotiationIdSidebarOverviewRoute =
  AuthenticatedNegotiationsNegotiationIdSidebarOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () =>
      AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute,
  } as any)
const AuthenticatedNextAssembliesAssemblyIdIndexRoute =
  AuthenticatedNextAssembliesAssemblyIdIndexRouteImport.update({
    id: '/assemblies/$assemblyId/',
    path: '/assemblies/$assemblyId/',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextAssembliesAssemblyIdDashboardRoute =
  AuthenticatedNextAssembliesAssemblyIdDashboardRouteImport.update({
    id: '/assemblies/$assemblyId/dashboard',
    path: '/assemblies/$assemblyId/dashboard',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextAssembliesAssemblyIdDetailsRoute =
  AuthenticatedNextAssembliesAssemblyIdDetailsRouteImport.update({
    id: '/assemblies/$assemblyId/details',
    path: '/assemblies/$assemblyId/details',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextAssembliesAssemblyIdEditRoute =
  AuthenticatedNextAssembliesAssemblyIdEditRouteImport.update({
    id: '/assemblies/$assemblyId/edit',
    path: '/assemblies/$assemblyId/edit',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextAssembliesAssemblyIdPcbRouteRoute =
  AuthenticatedNextAssembliesAssemblyIdPcbRouteRouteImport.update({
    id: '/assemblies/$assemblyId/pcb',
    path: '/assemblies/$assemblyId/pcb',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextComponentsIpnDetailsRouteRoute =
  AuthenticatedNextComponentsIpnDetailsRouteRouteImport.update({
    id: '/components/ipn/_details',
    path: '/components/ipn',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextNegotiationsNegotiationIdIndexRoute =
  AuthenticatedNextNegotiationsNegotiationIdIndexRouteImport.update({
    id: '/negotiations/$negotiationId/',
    path: '/negotiations/$negotiationId/',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute =
  AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRouteImport.update({
    id: '/negotiations/$negotiationId/_sidebar',
    path: '/negotiations/$negotiationId',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextPartsPartIdIndexRoute =
  AuthenticatedNextPartsPartIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedNextPartsPartIdRouteRoute,
  } as any)
const AuthenticatedNextPartsPartIdComplianceRoute =
  AuthenticatedNextPartsPartIdComplianceRouteImport.update({
    id: '/compliance',
    path: '/compliance',
    getParentRoute: () => AuthenticatedNextPartsPartIdRouteRoute,
  } as any)
const AuthenticatedNextPartsPartIdOffersRoute =
  AuthenticatedNextPartsPartIdOffersRouteImport.update({
    id: '/offers',
    path: '/offers',
    getParentRoute: () => AuthenticatedNextPartsPartIdRouteRoute,
  } as any)
const AuthenticatedNextPartsPartIdPartAlternativesRoute =
  AuthenticatedNextPartsPartIdPartAlternativesRouteImport.update({
    id: '/part-alternatives',
    path: '/part-alternatives',
    getParentRoute: () => AuthenticatedNextPartsPartIdRouteRoute,
  } as any)
const AuthenticatedNextPartsPartIdSeAlternativesRoute =
  AuthenticatedNextPartsPartIdSeAlternativesRouteImport.update({
    id: '/se-alternatives',
    path: '/se-alternatives',
    getParentRoute: () => AuthenticatedNextPartsPartIdRouteRoute,
  } as any)
const AuthenticatedNextPartsPartIdSeDocumentationRoute =
  AuthenticatedNextPartsPartIdSeDocumentationRouteImport.update({
    id: '/se-documentation',
    path: '/se-documentation',
    getParentRoute: () => AuthenticatedNextPartsPartIdRouteRoute,
  } as any)
const AuthenticatedNextPartsPartIdSeGeoRiskRoute =
  AuthenticatedNextPartsPartIdSeGeoRiskRouteImport.update({
    id: '/se-geo-risk',
    path: '/se-geo-risk',
    getParentRoute: () => AuthenticatedNextPartsPartIdRouteRoute,
  } as any)
const AuthenticatedNextPartsPartIdSeSupplyChainRoute =
  AuthenticatedNextPartsPartIdSeSupplyChainRouteImport.update({
    id: '/se-supply-chain',
    path: '/se-supply-chain',
    getParentRoute: () => AuthenticatedNextPartsPartIdRouteRoute,
  } as any)
const AuthenticatedNextPartsPartIdSeTechnicalRoute =
  AuthenticatedNextPartsPartIdSeTechnicalRouteImport.update({
    id: '/se-technical',
    path: '/se-technical',
    getParentRoute: () => AuthenticatedNextPartsPartIdRouteRoute,
  } as any)
const AuthenticatedNextPartsPartIdUsedInRoute =
  AuthenticatedNextPartsPartIdUsedInRouteImport.update({
    id: '/used-in',
    path: '/used-in',
    getParentRoute: () => AuthenticatedNextPartsPartIdRouteRoute,
  } as any)
const AuthenticatedNextPartsCustomCustomPartSpecificationIdRouteRoute =
  AuthenticatedNextPartsCustomCustomPartSpecificationIdRouteRouteImport.update({
    id: '/parts/custom/$customPartSpecificationId',
    path: '/parts/custom/$customPartSpecificationId',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextProjectsProjectIdIndexRoute =
  AuthenticatedNextProjectsProjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
  } as any)
const AuthenticatedNextProjectsProjectIdDashboardRoute =
  AuthenticatedNextProjectsProjectIdDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
  } as any)
const AuthenticatedNextProjectsProjectIdEditRoute =
  AuthenticatedNextProjectsProjectIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
  } as any)
const AuthenticatedNextProjectsProjectIdQuotationRoute =
  AuthenticatedNextProjectsProjectIdQuotationRouteImport.update({
    id: '/quotation',
    path: '/quotation',
    getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
  } as any)
const AuthenticatedNextRiskManagementLibraryHealthIndexRoute =
  AuthenticatedNextRiskManagementLibraryHealthIndexRouteImport.update({
    id: '/risk-management/library-health/',
    path: '/risk-management/library-health/',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextRiskManagementLibraryHealthAssembliesRoute =
  AuthenticatedNextRiskManagementLibraryHealthAssembliesRouteImport.update({
    id: '/risk-management/library-health/assemblies',
    path: '/risk-management/library-health/assemblies',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextRiskManagementLibraryHealthComponentsRoute =
  AuthenticatedNextRiskManagementLibraryHealthComponentsRouteImport.update({
    id: '/risk-management/library-health/components',
    path: '/risk-management/library-health/components',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextRiskManagementLibraryHealthPartsRoute =
  AuthenticatedNextRiskManagementLibraryHealthPartsRouteImport.update({
    id: '/risk-management/library-health/parts',
    path: '/risk-management/library-health/parts',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextSuppliersSupplierContactsIndexRoute =
  AuthenticatedNextSuppliersSupplierContactsIndexRouteImport.update({
    id: '/suppliers/supplier-contacts/',
    path: '/suppliers/supplier-contacts/',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextTemplatesEmailIndexRoute =
  AuthenticatedNextTemplatesEmailIndexRouteImport.update({
    id: '/templates/email/',
    path: '/templates/email/',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextTemplatesEmailCreateRoute =
  AuthenticatedNextTemplatesEmailCreateRouteImport.update({
    id: '/templates/email/create',
    path: '/templates/email/create',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextTemplatesFlexibleCalculationIndexRoute =
  AuthenticatedNextTemplatesFlexibleCalculationIndexRouteImport.update({
    id: '/templates/flexible-calculation/',
    path: '/templates/flexible-calculation/',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextTemplatesFlexibleCalculationFlexibleCalculationTemplateIdRoute =
  AuthenticatedNextTemplatesFlexibleCalculationFlexibleCalculationTemplateIdRouteImport.update(
    {
      id: '/templates/flexible-calculation/$flexibleCalculationTemplateId',
      path: '/templates/flexible-calculation/$flexibleCalculationTemplateId',
      getParentRoute: () => AuthenticatedNextRouteRoute,
    } as any,
  )
const AuthenticatedNextTemplatesFlexibleCalculationCreateRoute =
  AuthenticatedNextTemplatesFlexibleCalculationCreateRouteImport.update({
    id: '/templates/flexible-calculation/create',
    path: '/templates/flexible-calculation/create',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextTemplatesFlexibleCalculationExportedVariablesRoute =
  AuthenticatedNextTemplatesFlexibleCalculationExportedVariablesRouteImport.update(
    {
      id: '/templates/flexible-calculation/exported-variables',
      path: '/templates/flexible-calculation/exported-variables',
      getParentRoute: () => AuthenticatedNextRouteRoute,
    } as any,
  )
const AuthenticatedNextTemplatesQuotationIndexRoute =
  AuthenticatedNextTemplatesQuotationIndexRouteImport.update({
    id: '/templates/quotation/',
    path: '/templates/quotation/',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextTemplatesQuoteRequestIndexRoute =
  AuthenticatedNextTemplatesQuoteRequestIndexRouteImport.update({
    id: '/templates/quote-request/',
    path: '/templates/quote-request/',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextTemplatesQuoteRequestCreateRoute =
  AuthenticatedNextTemplatesQuoteRequestCreateRouteImport.update({
    id: '/templates/quote-request/create',
    path: '/templates/quote-request/create',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextTemplatesSourcingIndexRoute =
  AuthenticatedNextTemplatesSourcingIndexRouteImport.update({
    id: '/templates/sourcing/',
    path: '/templates/sourcing/',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextTemplatesSourcingCreateRoute =
  AuthenticatedNextTemplatesSourcingCreateRouteImport.update({
    id: '/templates/sourcing/create',
    path: '/templates/sourcing/create',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedPartsSidebarComponentsIndexRoute =
  AuthenticatedPartsSidebarComponentsIndexRouteImport.update({
    id: '/components/',
    path: '/components/',
    getParentRoute: () => AuthenticatedPartsSidebarRouteRoute,
  } as any)
const AuthenticatedPartsSidebarDemandsIndexRoute =
  AuthenticatedPartsSidebarDemandsIndexRouteImport.update({
    id: '/demands/',
    path: '/demands/',
    getParentRoute: () => AuthenticatedPartsSidebarRouteRoute,
  } as any)
const AuthenticatedPartsSidebarDemandsImporterRoute =
  AuthenticatedPartsSidebarDemandsImporterRouteImport.update({
    id: '/demands/importer',
    path: '/demands/importer',
    getParentRoute: () => AuthenticatedPartsSidebarRouteRoute,
  } as any)
const AuthenticatedPartsSidebarQuoteRequestsIndexRoute =
  AuthenticatedPartsSidebarQuoteRequestsIndexRouteImport.update({
    id: '/quote-requests/',
    path: '/quote-requests/',
    getParentRoute: () => AuthenticatedPartsSidebarRouteRoute,
  } as any)
const AuthenticatedPartsComponentsIpnDetailsRouteRoute =
  AuthenticatedPartsComponentsIpnDetailsRouteRouteImport.update({
    id: '/parts/components/ipn/_details',
    path: '/parts/components/ipn',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPartsCustomDetailsCustomPartSpecificationIdRouteRoute =
  AuthenticatedPartsCustomDetailsCustomPartSpecificationIdRouteRouteImport.update(
    {
      id: '/parts/custom/details/$customPartSpecificationId',
      path: '/parts/custom/details/$customPartSpecificationId',
      getParentRoute: () => AuthenticatedRouteRoute,
    } as any,
  )
const AuthenticatedPartsDetailsPartIdIndexRoute =
  AuthenticatedPartsDetailsPartIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedPartsDetailsPartIdRouteRoute,
  } as any)
const AuthenticatedPartsDetailsPartIdComplianceRoute =
  AuthenticatedPartsDetailsPartIdComplianceRouteImport.update({
    id: '/compliance',
    path: '/compliance',
    getParentRoute: () => AuthenticatedPartsDetailsPartIdRouteRoute,
  } as any)
const AuthenticatedPartsDetailsPartIdOffersRoute =
  AuthenticatedPartsDetailsPartIdOffersRouteImport.update({
    id: '/offers',
    path: '/offers',
    getParentRoute: () => AuthenticatedPartsDetailsPartIdRouteRoute,
  } as any)
const AuthenticatedPartsDetailsPartIdPartAlternativesRoute =
  AuthenticatedPartsDetailsPartIdPartAlternativesRouteImport.update({
    id: '/part-alternatives',
    path: '/part-alternatives',
    getParentRoute: () => AuthenticatedPartsDetailsPartIdRouteRoute,
  } as any)
const AuthenticatedPartsDetailsPartIdSeAlternativesRoute =
  AuthenticatedPartsDetailsPartIdSeAlternativesRouteImport.update({
    id: '/se-alternatives',
    path: '/se-alternatives',
    getParentRoute: () => AuthenticatedPartsDetailsPartIdRouteRoute,
  } as any)
const AuthenticatedPartsDetailsPartIdSeDocumentationRoute =
  AuthenticatedPartsDetailsPartIdSeDocumentationRouteImport.update({
    id: '/se-documentation',
    path: '/se-documentation',
    getParentRoute: () => AuthenticatedPartsDetailsPartIdRouteRoute,
  } as any)
const AuthenticatedPartsDetailsPartIdSeGeoRiskRoute =
  AuthenticatedPartsDetailsPartIdSeGeoRiskRouteImport.update({
    id: '/se-geo-risk',
    path: '/se-geo-risk',
    getParentRoute: () => AuthenticatedPartsDetailsPartIdRouteRoute,
  } as any)
const AuthenticatedPartsDetailsPartIdSeSupplyChainRoute =
  AuthenticatedPartsDetailsPartIdSeSupplyChainRouteImport.update({
    id: '/se-supply-chain',
    path: '/se-supply-chain',
    getParentRoute: () => AuthenticatedPartsDetailsPartIdRouteRoute,
  } as any)
const AuthenticatedPartsDetailsPartIdSeTechnicalRoute =
  AuthenticatedPartsDetailsPartIdSeTechnicalRouteImport.update({
    id: '/se-technical',
    path: '/se-technical',
    getParentRoute: () => AuthenticatedPartsDetailsPartIdRouteRoute,
  } as any)
const AuthenticatedPartsDetailsPartIdUsedInRoute =
  AuthenticatedPartsDetailsPartIdUsedInRouteImport.update({
    id: '/used-in',
    path: '/used-in',
    getParentRoute: () => AuthenticatedPartsDetailsPartIdRouteRoute,
  } as any)
const AuthenticatedPartsOffersOfferIdDuplicateRoute =
  AuthenticatedPartsOffersOfferIdDuplicateRouteImport.update({
    id: '/parts/offers/$offerId/duplicate',
    path: '/parts/offers/$offerId/duplicate',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPartsOffersOfferIdEditRoute =
  AuthenticatedPartsOffersOfferIdEditRouteImport.update({
    id: '/parts/offers/$offerId/edit',
    path: '/parts/offers/$offerId/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProjectsProjectIdBomIndexRoute =
  AuthenticatedProjectsProjectIdBomIndexRouteImport.update({
    id: '/projects/$projectId/bom/',
    path: '/projects/$projectId/bom/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProjectsProjectIdCalculationIndexRoute =
  AuthenticatedProjectsProjectIdCalculationIndexRouteImport.update({
    id: '/projects/$projectId/calculation/',
    path: '/projects/$projectId/calculation/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProjectsProjectIdCalculationPrintRoute =
  AuthenticatedProjectsProjectIdCalculationPrintRouteImport.update({
    id: '/projects/$projectId/calculation/print',
    path: '/projects/$projectId/calculation/print',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProjectsProjectIdFlexibleCalculationIndexRoute =
  AuthenticatedProjectsProjectIdFlexibleCalculationIndexRouteImport.update({
    id: '/projects/$projectId/flexible-calculation/',
    path: '/projects/$projectId/flexible-calculation/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProjectsProjectIdFlexibleCalculationFlexibleCalculationIdRoute =
  AuthenticatedProjectsProjectIdFlexibleCalculationFlexibleCalculationIdRouteImport.update(
    {
      id: '/projects/$projectId/flexible-calculation/$flexibleCalculationId',
      path: '/projects/$projectId/flexible-calculation/$flexibleCalculationId',
      getParentRoute: () => AuthenticatedRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdManufacturingIndexRoute =
  AuthenticatedProjectsProjectIdManufacturingIndexRouteImport.update({
    id: '/projects/$projectId/manufacturing/',
    path: '/projects/$projectId/manufacturing/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProjectsProjectIdOrderIndexRoute =
  AuthenticatedProjectsProjectIdOrderIndexRouteImport.update({
    id: '/projects/$projectId/order/',
    path: '/projects/$projectId/order/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProjectsProjectIdOrderConfirmationRoute =
  AuthenticatedProjectsProjectIdOrderConfirmationRouteImport.update({
    id: '/projects/$projectId/order/confirmation',
    path: '/projects/$projectId/order/confirmation',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProjectsProjectIdSourcingIndexRoute =
  AuthenticatedProjectsProjectIdSourcingIndexRouteImport.update({
    id: '/projects/$projectId/sourcing/',
    path: '/projects/$projectId/sourcing/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute =
  AuthenticatedProjectsProjectIdSourcingSidebarRouteRouteImport.update({
    id: '/projects/$projectId/sourcing/_sidebar',
    path: '/projects/$projectId/sourcing',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProjectsProjectIdSourcingDemandGroupsRoute =
  AuthenticatedProjectsProjectIdSourcingDemandGroupsRouteImport.update({
    id: '/projects/$projectId/sourcing/demand-groups',
    path: '/projects/$projectId/sourcing/demand-groups',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsMenuOrganizationIndexRoute =
  AuthenticatedSettingsMenuOrganizationIndexRouteImport.update({
    id: '/organization/',
    path: '/organization/',
    getParentRoute: () => AuthenticatedSettingsMenuRouteRoute,
  } as any)
const AuthenticatedSettingsMenuOrganizationApiIntegrationRoute =
  AuthenticatedSettingsMenuOrganizationApiIntegrationRouteImport.update({
    id: '/organization/api-integration',
    path: '/organization/api-integration',
    getParentRoute: () => AuthenticatedSettingsMenuRouteRoute,
  } as any)
const AuthenticatedSettingsMenuOrganizationAssemblySettingsRoute =
  AuthenticatedSettingsMenuOrganizationAssemblySettingsRouteImport.update({
    id: '/organization/assembly-settings',
    path: '/organization/assembly-settings',
    getParentRoute: () => AuthenticatedSettingsMenuRouteRoute,
  } as any)
const AuthenticatedSettingsMenuOrganizationAutomaticRfqNumberRoute =
  AuthenticatedSettingsMenuOrganizationAutomaticRfqNumberRouteImport.update({
    id: '/organization/automatic-rfq-number',
    path: '/organization/automatic-rfq-number',
    getParentRoute: () => AuthenticatedSettingsMenuRouteRoute,
  } as any)
const AuthenticatedSettingsMenuOrganizationBrandingRoute =
  AuthenticatedSettingsMenuOrganizationBrandingRouteImport.update({
    id: '/organization/branding',
    path: '/organization/branding',
    getParentRoute: () => AuthenticatedSettingsMenuRouteRoute,
  } as any)
const AuthenticatedSettingsMenuOrganizationCarbonFootprintsRoute =
  AuthenticatedSettingsMenuOrganizationCarbonFootprintsRouteImport.update({
    id: '/organization/carbon-footprints',
    path: '/organization/carbon-footprints',
    getParentRoute: () => AuthenticatedSettingsMenuRouteRoute,
  } as any)
const AuthenticatedSettingsMenuOrganizationComponentSettingsRoute =
  AuthenticatedSettingsMenuOrganizationComponentSettingsRouteImport.update({
    id: '/organization/component-settings',
    path: '/organization/component-settings',
    getParentRoute: () => AuthenticatedSettingsMenuRouteRoute,
  } as any)
const AuthenticatedSettingsMenuOrganizationCsvIntegrationRoute =
  AuthenticatedSettingsMenuOrganizationCsvIntegrationRouteImport.update({
    id: '/organization/csv-integration',
    path: '/organization/csv-integration',
    getParentRoute: () => AuthenticatedSettingsMenuRouteRoute,
  } as any)
const AuthenticatedSettingsMenuOrganizationCustomPartCategoriesRoute =
  AuthenticatedSettingsMenuOrganizationCustomPartCategoriesRouteImport.update({
    id: '/organization/custom-part-categories',
    path: '/organization/custom-part-categories',
    getParentRoute: () => AuthenticatedSettingsMenuRouteRoute,
  } as any)
const AuthenticatedSettingsMenuOrganizationDataIntegrationsRoute =
  AuthenticatedSettingsMenuOrganizationDataIntegrationsRouteImport.update({
    id: '/organization/data-integrations',
    path: '/organization/data-integrations',
    getParentRoute: () => AuthenticatedSettingsMenuRouteRoute,
  } as any)
const AuthenticatedSettingsMenuOrganizationFeatureFlagsRoute =
  AuthenticatedSettingsMenuOrganizationFeatureFlagsRouteImport.update({
    id: '/organization/feature-flags',
    path: '/organization/feature-flags',
    getParentRoute: () => AuthenticatedSettingsMenuRouteRoute,
  } as any)
const AuthenticatedSettingsMenuOrganizationManufacturerPreferencesRoute =
  AuthenticatedSettingsMenuOrganizationManufacturerPreferencesRouteImport.update(
    {
      id: '/organization/manufacturer-preferences',
      path: '/organization/manufacturer-preferences',
      getParentRoute: () => AuthenticatedSettingsMenuRouteRoute,
    } as any,
  )
const AuthenticatedSettingsMenuOrganizationSitesRoute =
  AuthenticatedSettingsMenuOrganizationSitesRouteImport.update({
    id: '/organization/sites',
    path: '/organization/sites',
    getParentRoute: () => AuthenticatedSettingsMenuRouteRoute,
  } as any)
const AuthenticatedSettingsMenuOrganizationSupplierApiIntegrationsRoute =
  AuthenticatedSettingsMenuOrganizationSupplierApiIntegrationsRouteImport.update(
    {
      id: '/organization/supplier-api-integrations',
      path: '/organization/supplier-api-integrations',
      getParentRoute: () => AuthenticatedSettingsMenuRouteRoute,
    } as any,
  )
const AuthenticatedSettingsMenuUserAccountSecurityRoute =
  AuthenticatedSettingsMenuUserAccountSecurityRouteImport.update({
    id: '/user/account-security',
    path: '/user/account-security',
    getParentRoute: () => AuthenticatedSettingsMenuRouteRoute,
  } as any)
const AuthenticatedSettingsOrganizationPcbPanelPreferenceIdRoute =
  AuthenticatedSettingsOrganizationPcbPanelPreferenceIdRouteImport.update({
    id: '/settings/organization/pcb/$panelPreferenceId',
    path: '/settings/organization/pcb/$panelPreferenceId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsOrganizationPcbAddPreferenceRoute =
  AuthenticatedSettingsOrganizationPcbAddPreferenceRouteImport.update({
    id: '/settings/organization/pcb/add-preference',
    path: '/settings/organization/pcb/add-preference',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsOrganizationUsersImporterRoute =
  AuthenticatedSettingsOrganizationUsersImporterRouteImport.update({
    id: '/settings/organization/users/importer',
    path: '/settings/organization/users/importer',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdIndexRoute =
  AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdIndexRouteImport.update(
    {
      id: '/supplier-portal/quote-requests/$quoteRequestId/',
      path: '/supplier-portal/quote-requests/$quoteRequestId/',
      getParentRoute: () => AuthenticatedRouteRoute,
    } as any,
  )
const AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdExcelImporterRoute =
  AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdExcelImporterRouteImport.update(
    {
      id: '/supplier-portal/quote-requests/$quoteRequestId/excel-importer',
      path: '/supplier-portal/quote-requests/$quoteRequestId/excel-importer',
      getParentRoute: () => AuthenticatedRouteRoute,
    } as any,
  )
const AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdImportPdfRoute =
  AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdImportPdfRouteImport.update(
    {
      id: '/supplier-portal/quote-requests/$quoteRequestId/import-pdf',
      path: '/supplier-portal/quote-requests/$quoteRequestId/import-pdf',
      getParentRoute: () => AuthenticatedRouteRoute,
    } as any,
  )
const AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdPdfImporterRoute =
  AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdPdfImporterRouteImport.update(
    {
      id: '/supplier-portal/quote-requests/$quoteRequestId/pdf-importer',
      path: '/supplier-portal/quote-requests/$quoteRequestId/pdf-importer',
      getParentRoute: () => AuthenticatedRouteRoute,
    } as any,
  )
const AuthenticatedSuppliersSupplierIdSupplierContactsImporterSplatRoute =
  AuthenticatedSuppliersSupplierIdSupplierContactsImporterSplatRouteImport.update(
    {
      id: '/suppliers/$supplierId/supplier-contacts-importer/$',
      path: '/suppliers/$supplierId/supplier-contacts-importer/$',
      getParentRoute: () => AuthenticatedRouteRoute,
    } as any,
  )
const AuthenticatedSuppliersSupplierIdSupplierContactsImporterRoute =
  AuthenticatedSuppliersSupplierIdSupplierContactsImporterRouteImport.update({
    id: '/suppliers/$supplierId/supplier-contacts/importer',
    path: '/suppliers/$supplierId/supplier-contacts/importer',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSuppliersSidebarSupplierContactsIndexRoute =
  AuthenticatedSuppliersSidebarSupplierContactsIndexRouteImport.update({
    id: '/supplier-contacts/',
    path: '/supplier-contacts/',
    getParentRoute: () => AuthenticatedSuppliersSidebarRouteRoute,
  } as any)
const AuthenticatedTemplatesSidebarCalculationIndexRoute =
  AuthenticatedTemplatesSidebarCalculationIndexRouteImport.update({
    id: '/calculation/',
    path: '/calculation/',
    getParentRoute: () => AuthenticatedTemplatesSidebarRouteRoute,
  } as any)
const AuthenticatedTemplatesSidebarEmailIndexRoute =
  AuthenticatedTemplatesSidebarEmailIndexRouteImport.update({
    id: '/email/',
    path: '/email/',
    getParentRoute: () => AuthenticatedTemplatesSidebarRouteRoute,
  } as any)
const AuthenticatedTemplatesSidebarEmailCreateRoute =
  AuthenticatedTemplatesSidebarEmailCreateRouteImport.update({
    id: '/email/create',
    path: '/email/create',
    getParentRoute: () => AuthenticatedTemplatesSidebarRouteRoute,
  } as any)
const AuthenticatedTemplatesSidebarFlexibleCalculationIndexRoute =
  AuthenticatedTemplatesSidebarFlexibleCalculationIndexRouteImport.update({
    id: '/flexible-calculation/',
    path: '/flexible-calculation/',
    getParentRoute: () => AuthenticatedTemplatesSidebarRouteRoute,
  } as any)
const AuthenticatedTemplatesSidebarFlexibleCalculationFlexibleCalculationTemplateIdRoute =
  AuthenticatedTemplatesSidebarFlexibleCalculationFlexibleCalculationTemplateIdRouteImport.update(
    {
      id: '/flexible-calculation/$flexibleCalculationTemplateId',
      path: '/flexible-calculation/$flexibleCalculationTemplateId',
      getParentRoute: () => AuthenticatedTemplatesSidebarRouteRoute,
    } as any,
  )
const AuthenticatedTemplatesSidebarFlexibleCalculationCreateRoute =
  AuthenticatedTemplatesSidebarFlexibleCalculationCreateRouteImport.update({
    id: '/flexible-calculation/create',
    path: '/flexible-calculation/create',
    getParentRoute: () => AuthenticatedTemplatesSidebarRouteRoute,
  } as any)
const AuthenticatedTemplatesSidebarFlexibleCalculationExportedVariablesRoute =
  AuthenticatedTemplatesSidebarFlexibleCalculationExportedVariablesRouteImport.update(
    {
      id: '/flexible-calculation/exported-variables',
      path: '/flexible-calculation/exported-variables',
      getParentRoute: () => AuthenticatedTemplatesSidebarRouteRoute,
    } as any,
  )
const AuthenticatedTemplatesSidebarQuotationIndexRoute =
  AuthenticatedTemplatesSidebarQuotationIndexRouteImport.update({
    id: '/quotation/',
    path: '/quotation/',
    getParentRoute: () => AuthenticatedTemplatesSidebarRouteRoute,
  } as any)
const AuthenticatedTemplatesSidebarQuoteRequestIndexRoute =
  AuthenticatedTemplatesSidebarQuoteRequestIndexRouteImport.update({
    id: '/quote-request/',
    path: '/quote-request/',
    getParentRoute: () => AuthenticatedTemplatesSidebarRouteRoute,
  } as any)
const AuthenticatedTemplatesSidebarQuoteRequestCreateRoute =
  AuthenticatedTemplatesSidebarQuoteRequestCreateRouteImport.update({
    id: '/quote-request/create',
    path: '/quote-request/create',
    getParentRoute: () => AuthenticatedTemplatesSidebarRouteRoute,
  } as any)
const AuthenticatedTemplatesSidebarSourcingIndexRoute =
  AuthenticatedTemplatesSidebarSourcingIndexRouteImport.update({
    id: '/sourcing/',
    path: '/sourcing/',
    getParentRoute: () => AuthenticatedTemplatesSidebarRouteRoute,
  } as any)
const AuthenticatedTemplatesSidebarSourcingCreateRoute =
  AuthenticatedTemplatesSidebarSourcingCreateRouteImport.update({
    id: '/sourcing/create',
    path: '/sourcing/create',
    getParentRoute: () => AuthenticatedTemplatesSidebarRouteRoute,
  } as any)
const AuthenticatedTemplatesCalculationTemplateIdEditRoute =
  AuthenticatedTemplatesCalculationTemplateIdEditRouteImport.update({
    id: '/templates/calculation/$templateId/edit',
    path: '/templates/calculation/$templateId/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTemplatesEmailEmailTemplateIdUpdateRoute =
  AuthenticatedTemplatesEmailEmailTemplateIdUpdateRouteImport.update({
    id: '/templates/email/$emailTemplateId/update',
    path: '/templates/email/$emailTemplateId/update',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedManufacturingSidebarAppsAppIdWidgetIdRoute =
  AuthenticatedManufacturingSidebarAppsAppIdWidgetIdRouteImport.update({
    id: '/apps/$appId/$widgetId',
    path: '/apps/$appId/$widgetId',
    getParentRoute: () => AuthenticatedManufacturingSidebarRouteRoute,
  } as any)
const AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsIndexRoute =
  AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsIndexRouteImport.update(
    {
      id: '/quote-requests/',
      path: '/quote-requests/',
      getParentRoute: () =>
        AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsQuoteRequestIdRoute =
  AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsQuoteRequestIdRouteImport.update(
    {
      id: '/quote-requests/$quoteRequestId',
      path: '/quote-requests/$quoteRequestId',
      getParentRoute: () =>
        AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsAssignRoute =
  AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsAssignRouteImport.update(
    {
      id: '/quote-requests/assign',
      path: '/quote-requests/assign',
      getParentRoute: () =>
        AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsAttachmentsRoute =
  AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsAttachmentsRouteImport.update(
    {
      id: '/quote-requests/attachments',
      path: '/quote-requests/attachments',
      getParentRoute: () =>
        AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsDeliveryLotSizeRoute =
  AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsDeliveryLotSizeRouteImport.update(
    {
      id: '/quote-requests/delivery-lot-size',
      path: '/quote-requests/delivery-lot-size',
      getParentRoute: () =>
        AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsExcelImporterRoute =
  AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsExcelImporterRouteImport.update(
    {
      id: '/quote-requests/excel-importer',
      path: '/quote-requests/excel-importer',
      getParentRoute: () =>
        AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsImporterRoute =
  AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsImporterRouteImport.update(
    {
      id: '/quote-requests/importer',
      path: '/quote-requests/importer',
      getParentRoute: () =>
        AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsLineItemsRoute =
  AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsLineItemsRouteImport.update(
    {
      id: '/quote-requests/line-items',
      path: '/quote-requests/line-items',
      getParentRoute: () =>
        AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsPreviewEmailRoute =
  AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsPreviewEmailRouteImport.update(
    {
      id: '/quote-requests/preview-email',
      path: '/quote-requests/preview-email',
      getParentRoute: () =>
        AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsTargetPriceRoute =
  AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsTargetPriceRouteImport.update(
    {
      id: '/quote-requests/target-price',
      path: '/quote-requests/target-price',
      getParentRoute: () =>
        AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNegotiationsNegotiationIdSidebarScenariosCompareRoute =
  AuthenticatedNegotiationsNegotiationIdSidebarScenariosCompareRouteImport.update(
    {
      id: '/scenarios/compare',
      path: '/scenarios/compare',
      getParentRoute: () =>
        AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNegotiationsNegotiationIdSidebarScenariosCreateRoute =
  AuthenticatedNegotiationsNegotiationIdSidebarScenariosCreateRouteImport.update(
    {
      id: '/scenarios/create',
      path: '/scenarios/create',
      getParentRoute: () =>
        AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNextAssembliesAssemblyIdPcbIndexRoute =
  AuthenticatedNextAssembliesAssemblyIdPcbIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedNextAssembliesAssemblyIdPcbRouteRoute,
  } as any)
const AuthenticatedNextAssembliesAssemblyIdPcbCadViewerRoute =
  AuthenticatedNextAssembliesAssemblyIdPcbCadViewerRouteImport.update({
    id: '/cad-viewer',
    path: '/cad-viewer',
    getParentRoute: () => AuthenticatedNextAssembliesAssemblyIdPcbRouteRoute,
  } as any)
const AuthenticatedNextAssembliesAssemblyIdPcbDfmRoute =
  AuthenticatedNextAssembliesAssemblyIdPcbDfmRouteImport.update({
    id: '/dfm',
    path: '/dfm',
    getParentRoute: () => AuthenticatedNextAssembliesAssemblyIdPcbRouteRoute,
  } as any)
const AuthenticatedNextAssembliesAssemblyIdPcbDfmAnalysisRoute =
  AuthenticatedNextAssembliesAssemblyIdPcbDfmAnalysisRouteImport.update({
    id: '/dfm-analysis',
    path: '/dfm-analysis',
    getParentRoute: () => AuthenticatedNextAssembliesAssemblyIdPcbRouteRoute,
  } as any)
const AuthenticatedNextAssembliesAssemblyIdPcbDrillsRoute =
  AuthenticatedNextAssembliesAssemblyIdPcbDrillsRouteImport.update({
    id: '/drills',
    path: '/drills',
    getParentRoute: () => AuthenticatedNextAssembliesAssemblyIdPcbRouteRoute,
  } as any)
const AuthenticatedNextAssembliesAssemblyIdPcbFilesRoute =
  AuthenticatedNextAssembliesAssemblyIdPcbFilesRouteImport.update({
    id: '/files',
    path: '/files',
    getParentRoute: () => AuthenticatedNextAssembliesAssemblyIdPcbRouteRoute,
  } as any)
const AuthenticatedNextAssembliesAssemblyIdPcbPanelizationRoute =
  AuthenticatedNextAssembliesAssemblyIdPcbPanelizationRouteImport.update({
    id: '/panelization',
    path: '/panelization',
    getParentRoute: () => AuthenticatedNextAssembliesAssemblyIdPcbRouteRoute,
  } as any)
const AuthenticatedNextAssembliesAssemblyIdPcbSpecificationRoute =
  AuthenticatedNextAssembliesAssemblyIdPcbSpecificationRouteImport.update({
    id: '/specification',
    path: '/specification',
    getParentRoute: () => AuthenticatedNextAssembliesAssemblyIdPcbRouteRoute,
  } as any)
const AuthenticatedNextAssembliesAssemblyIdPcbStackupRoute =
  AuthenticatedNextAssembliesAssemblyIdPcbStackupRouteImport.update({
    id: '/stackup',
    path: '/stackup',
    getParentRoute: () => AuthenticatedNextAssembliesAssemblyIdPcbRouteRoute,
  } as any)
const AuthenticatedNextAssembliesAssemblyIdSubassembliesCreateRoute =
  AuthenticatedNextAssembliesAssemblyIdSubassembliesCreateRouteImport.update({
    id: '/assemblies/$assemblyId/subassemblies/create',
    path: '/assemblies/$assemblyId/subassemblies/create',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextComponentsIpnDetailsIndexRoute =
  AuthenticatedNextComponentsIpnDetailsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedNextComponentsIpnDetailsRouteRoute,
  } as any)
const AuthenticatedNextComponentsIpnDetailsCpnsRoute =
  AuthenticatedNextComponentsIpnDetailsCpnsRouteImport.update({
    id: '/cpns',
    path: '/cpns',
    getParentRoute: () => AuthenticatedNextComponentsIpnDetailsRouteRoute,
  } as any)
const AuthenticatedNextComponentsIpnDetailsLinkingRoute =
  AuthenticatedNextComponentsIpnDetailsLinkingRouteImport.update({
    id: '/linking',
    path: '/linking',
    getParentRoute: () => AuthenticatedNextComponentsIpnDetailsRouteRoute,
  } as any)
const AuthenticatedNextComponentsIpnDetailsUsedInRoute =
  AuthenticatedNextComponentsIpnDetailsUsedInRouteImport.update({
    id: '/used-in',
    path: '/used-in',
    getParentRoute: () => AuthenticatedNextComponentsIpnDetailsRouteRoute,
  } as any)
const AuthenticatedNextNegotiationsNegotiationIdSidebarOverviewRoute =
  AuthenticatedNextNegotiationsNegotiationIdSidebarOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () =>
      AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute,
  } as any)
const AuthenticatedNextPartsCustomCustomPartSpecificationIdIndexRoute =
  AuthenticatedNextPartsCustomCustomPartSpecificationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedNextPartsCustomCustomPartSpecificationIdRouteRoute,
  } as any)
const AuthenticatedNextPartsCustomCustomPartSpecificationIdOffersRoute =
  AuthenticatedNextPartsCustomCustomPartSpecificationIdOffersRouteImport.update(
    {
      id: '/offers',
      path: '/offers',
      getParentRoute: () =>
        AuthenticatedNextPartsCustomCustomPartSpecificationIdRouteRoute,
    } as any,
  )
const AuthenticatedNextPartsCustomCustomPartSpecificationIdUsedInRoute =
  AuthenticatedNextPartsCustomCustomPartSpecificationIdUsedInRouteImport.update(
    {
      id: '/used-in',
      path: '/used-in',
      getParentRoute: () =>
        AuthenticatedNextPartsCustomCustomPartSpecificationIdRouteRoute,
    } as any,
  )
const AuthenticatedNextPartsOffersOfferIdDuplicateRoute =
  AuthenticatedNextPartsOffersOfferIdDuplicateRouteImport.update({
    id: '/parts/offers/$offerId/duplicate',
    path: '/parts/offers/$offerId/duplicate',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextPartsOffersOfferIdEditRoute =
  AuthenticatedNextPartsOffersOfferIdEditRouteImport.update({
    id: '/parts/offers/$offerId/edit',
    path: '/parts/offers/$offerId/edit',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextProjectsProjectIdAssembliesIndexRoute =
  AuthenticatedNextProjectsProjectIdAssembliesIndexRouteImport.update({
    id: '/assemblies/',
    path: '/assemblies/',
    getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
  } as any)
const AuthenticatedNextProjectsProjectIdFlexibleCalculationIndexRoute =
  AuthenticatedNextProjectsProjectIdFlexibleCalculationIndexRouteImport.update({
    id: '/flexible-calculation/',
    path: '/flexible-calculation/',
    getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
  } as any)
const AuthenticatedNextProjectsProjectIdFlexibleCalculationFlexibleCalculationIdRoute =
  AuthenticatedNextProjectsProjectIdFlexibleCalculationFlexibleCalculationIdRouteImport.update(
    {
      id: '/flexible-calculation/$flexibleCalculationId',
      path: '/flexible-calculation/$flexibleCalculationId',
      getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdManufacturingIndexRoute =
  AuthenticatedNextProjectsProjectIdManufacturingIndexRouteImport.update({
    id: '/manufacturing/',
    path: '/manufacturing/',
    getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
  } as any)
const AuthenticatedNextProjectsProjectIdSourcingIndexRoute =
  AuthenticatedNextProjectsProjectIdSourcingIndexRouteImport.update({
    id: '/sourcing/',
    path: '/sourcing/',
    getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
  } as any)
const AuthenticatedNextProjectsProjectIdSourcingCompareRoute =
  AuthenticatedNextProjectsProjectIdSourcingCompareRouteImport.update({
    id: '/sourcing/compare',
    path: '/sourcing/compare',
    getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
  } as any)
const AuthenticatedNextProjectsProjectIdSourcingOverviewRouteRoute =
  AuthenticatedNextProjectsProjectIdSourcingOverviewRouteRouteImport.update({
    id: '/sourcing/overview',
    path: '/sourcing/overview',
    getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
  } as any)
const AuthenticatedNextProjectsProjectIdSourcingVersionHistoryRoute =
  AuthenticatedNextProjectsProjectIdSourcingVersionHistoryRouteImport.update({
    id: '/sourcing/version-history',
    path: '/sourcing/version-history',
    getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
  } as any)
const AuthenticatedNextSettingsMenuOrganizationIndexRoute =
  AuthenticatedNextSettingsMenuOrganizationIndexRouteImport.update({
    id: '/organization/',
    path: '/organization/',
    getParentRoute: () => AuthenticatedNextSettingsMenuRouteRoute,
  } as any)
const AuthenticatedNextSettingsMenuOrganizationApiIntegrationRoute =
  AuthenticatedNextSettingsMenuOrganizationApiIntegrationRouteImport.update({
    id: '/organization/api-integration',
    path: '/organization/api-integration',
    getParentRoute: () => AuthenticatedNextSettingsMenuRouteRoute,
  } as any)
const AuthenticatedNextSettingsMenuOrganizationAssemblySettingsRoute =
  AuthenticatedNextSettingsMenuOrganizationAssemblySettingsRouteImport.update({
    id: '/organization/assembly-settings',
    path: '/organization/assembly-settings',
    getParentRoute: () => AuthenticatedNextSettingsMenuRouteRoute,
  } as any)
const AuthenticatedNextSettingsMenuOrganizationAutomaticRfqNumberRoute =
  AuthenticatedNextSettingsMenuOrganizationAutomaticRfqNumberRouteImport.update(
    {
      id: '/organization/automatic-rfq-number',
      path: '/organization/automatic-rfq-number',
      getParentRoute: () => AuthenticatedNextSettingsMenuRouteRoute,
    } as any,
  )
const AuthenticatedNextSettingsMenuOrganizationBrandingRoute =
  AuthenticatedNextSettingsMenuOrganizationBrandingRouteImport.update({
    id: '/organization/branding',
    path: '/organization/branding',
    getParentRoute: () => AuthenticatedNextSettingsMenuRouteRoute,
  } as any)
const AuthenticatedNextSettingsMenuOrganizationCarbonFootprintsRoute =
  AuthenticatedNextSettingsMenuOrganizationCarbonFootprintsRouteImport.update({
    id: '/organization/carbon-footprints',
    path: '/organization/carbon-footprints',
    getParentRoute: () => AuthenticatedNextSettingsMenuRouteRoute,
  } as any)
const AuthenticatedNextSettingsMenuOrganizationComponentSettingsRoute =
  AuthenticatedNextSettingsMenuOrganizationComponentSettingsRouteImport.update({
    id: '/organization/component-settings',
    path: '/organization/component-settings',
    getParentRoute: () => AuthenticatedNextSettingsMenuRouteRoute,
  } as any)
const AuthenticatedNextSettingsMenuOrganizationCsvIntegrationRoute =
  AuthenticatedNextSettingsMenuOrganizationCsvIntegrationRouteImport.update({
    id: '/organization/csv-integration',
    path: '/organization/csv-integration',
    getParentRoute: () => AuthenticatedNextSettingsMenuRouteRoute,
  } as any)
const AuthenticatedNextSettingsMenuOrganizationCustomPartCategoriesRoute =
  AuthenticatedNextSettingsMenuOrganizationCustomPartCategoriesRouteImport.update(
    {
      id: '/organization/custom-part-categories',
      path: '/organization/custom-part-categories',
      getParentRoute: () => AuthenticatedNextSettingsMenuRouteRoute,
    } as any,
  )
const AuthenticatedNextSettingsMenuOrganizationDataIntegrationsRoute =
  AuthenticatedNextSettingsMenuOrganizationDataIntegrationsRouteImport.update({
    id: '/organization/data-integrations',
    path: '/organization/data-integrations',
    getParentRoute: () => AuthenticatedNextSettingsMenuRouteRoute,
  } as any)
const AuthenticatedNextSettingsMenuOrganizationFeatureFlagsRoute =
  AuthenticatedNextSettingsMenuOrganizationFeatureFlagsRouteImport.update({
    id: '/organization/feature-flags',
    path: '/organization/feature-flags',
    getParentRoute: () => AuthenticatedNextSettingsMenuRouteRoute,
  } as any)
const AuthenticatedNextSettingsMenuOrganizationManufacturerPreferencesRoute =
  AuthenticatedNextSettingsMenuOrganizationManufacturerPreferencesRouteImport.update(
    {
      id: '/organization/manufacturer-preferences',
      path: '/organization/manufacturer-preferences',
      getParentRoute: () => AuthenticatedNextSettingsMenuRouteRoute,
    } as any,
  )
const AuthenticatedNextSettingsMenuOrganizationSitesRoute =
  AuthenticatedNextSettingsMenuOrganizationSitesRouteImport.update({
    id: '/organization/sites',
    path: '/organization/sites',
    getParentRoute: () => AuthenticatedNextSettingsMenuRouteRoute,
  } as any)
const AuthenticatedNextSettingsMenuOrganizationSupplierApiIntegrationsRoute =
  AuthenticatedNextSettingsMenuOrganizationSupplierApiIntegrationsRouteImport.update(
    {
      id: '/organization/supplier-api-integrations',
      path: '/organization/supplier-api-integrations',
      getParentRoute: () => AuthenticatedNextSettingsMenuRouteRoute,
    } as any,
  )
const AuthenticatedNextSettingsMenuUserAccountSecurityRoute =
  AuthenticatedNextSettingsMenuUserAccountSecurityRouteImport.update({
    id: '/user/account-security',
    path: '/user/account-security',
    getParentRoute: () => AuthenticatedNextSettingsMenuRouteRoute,
  } as any)
const AuthenticatedNextSettingsOrganizationUsersImporterRoute =
  AuthenticatedNextSettingsOrganizationUsersImporterRouteImport.update({
    id: '/settings/organization/users/importer',
    path: '/settings/organization/users/importer',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextTemplatesEmailEmailTemplateIdEditRoute =
  AuthenticatedNextTemplatesEmailEmailTemplateIdEditRouteImport.update({
    id: '/templates/email/$emailTemplateId/edit',
    path: '/templates/email/$emailTemplateId/edit',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextTemplatesManufacturingActivitiesIndexRoute =
  AuthenticatedNextTemplatesManufacturingActivitiesIndexRouteImport.update({
    id: '/templates/manufacturing/activities/',
    path: '/templates/manufacturing/activities/',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextTemplatesManufacturingActivitiesCreateRoute =
  AuthenticatedNextTemplatesManufacturingActivitiesCreateRouteImport.update({
    id: '/templates/manufacturing/activities/create',
    path: '/templates/manufacturing/activities/create',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextTemplatesManufacturingDriversIndexRoute =
  AuthenticatedNextTemplatesManufacturingDriversIndexRouteImport.update({
    id: '/templates/manufacturing/drivers/',
    path: '/templates/manufacturing/drivers/',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextTemplatesManufacturingDriversCreateRoute =
  AuthenticatedNextTemplatesManufacturingDriversCreateRouteImport.update({
    id: '/templates/manufacturing/drivers/create',
    path: '/templates/manufacturing/drivers/create',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextTemplatesManufacturingExpensesIndexRoute =
  AuthenticatedNextTemplatesManufacturingExpensesIndexRouteImport.update({
    id: '/templates/manufacturing/expenses/',
    path: '/templates/manufacturing/expenses/',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextTemplatesManufacturingExpensesCreateRoute =
  AuthenticatedNextTemplatesManufacturingExpensesCreateRouteImport.update({
    id: '/templates/manufacturing/expenses/create',
    path: '/templates/manufacturing/expenses/create',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextTemplatesManufacturingResourcesIndexRoute =
  AuthenticatedNextTemplatesManufacturingResourcesIndexRouteImport.update({
    id: '/templates/manufacturing/resources/',
    path: '/templates/manufacturing/resources/',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextTemplatesManufacturingResourcesCreateRoute =
  AuthenticatedNextTemplatesManufacturingResourcesCreateRouteImport.update({
    id: '/templates/manufacturing/resources/create',
    path: '/templates/manufacturing/resources/create',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextTemplatesManufacturingTemplatesChar123TemplateIdChar125Route =
  AuthenticatedNextTemplatesManufacturingTemplatesChar123TemplateIdChar125RouteImport.update(
    {
      id: '/templates/manufacturing/templates/{-$templateId}',
      path: '/templates/manufacturing/templates/{-$templateId}',
      getParentRoute: () => AuthenticatedNextRouteRoute,
    } as any,
  )
const AuthenticatedNextTemplatesQuotationBuilderChar123TemplateIdChar125Route =
  AuthenticatedNextTemplatesQuotationBuilderChar123TemplateIdChar125RouteImport.update(
    {
      id: '/templates/quotation/builder/{-$templateId}',
      path: '/templates/quotation/builder/{-$templateId}',
      getParentRoute: () => AuthenticatedNextRouteRoute,
    } as any,
  )
const AuthenticatedNextTemplatesQuoteRequestQuoteRequestTemplateIdEditRoute =
  AuthenticatedNextTemplatesQuoteRequestQuoteRequestTemplateIdEditRouteImport.update(
    {
      id: '/templates/quote-request/$quoteRequestTemplateId/edit',
      path: '/templates/quote-request/$quoteRequestTemplateId/edit',
      getParentRoute: () => AuthenticatedNextRouteRoute,
    } as any,
  )
const AuthenticatedNextTemplatesSourcingSourcingTemplateIdDuplicateRoute =
  AuthenticatedNextTemplatesSourcingSourcingTemplateIdDuplicateRouteImport.update(
    {
      id: '/templates/sourcing/$sourcingTemplateId/duplicate',
      path: '/templates/sourcing/$sourcingTemplateId/duplicate',
      getParentRoute: () => AuthenticatedNextRouteRoute,
    } as any,
  )
const AuthenticatedNextTemplatesSourcingSourcingTemplateIdEditRoute =
  AuthenticatedNextTemplatesSourcingSourcingTemplateIdEditRouteImport.update({
    id: '/templates/sourcing/$sourcingTemplateId/edit',
    path: '/templates/sourcing/$sourcingTemplateId/edit',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedPartsComponentsIpnDetailsIndexRoute =
  AuthenticatedPartsComponentsIpnDetailsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedPartsComponentsIpnDetailsRouteRoute,
  } as any)
const AuthenticatedPartsComponentsIpnDetailsCpnsRoute =
  AuthenticatedPartsComponentsIpnDetailsCpnsRouteImport.update({
    id: '/cpns',
    path: '/cpns',
    getParentRoute: () => AuthenticatedPartsComponentsIpnDetailsRouteRoute,
  } as any)
const AuthenticatedPartsComponentsIpnDetailsLinkingRoute =
  AuthenticatedPartsComponentsIpnDetailsLinkingRouteImport.update({
    id: '/linking',
    path: '/linking',
    getParentRoute: () => AuthenticatedPartsComponentsIpnDetailsRouteRoute,
  } as any)
const AuthenticatedPartsComponentsIpnDetailsOffersRoute =
  AuthenticatedPartsComponentsIpnDetailsOffersRouteImport.update({
    id: '/offers',
    path: '/offers',
    getParentRoute: () => AuthenticatedPartsComponentsIpnDetailsRouteRoute,
  } as any)
const AuthenticatedPartsComponentsIpnDetailsUsedInRoute =
  AuthenticatedPartsComponentsIpnDetailsUsedInRouteImport.update({
    id: '/used-in',
    path: '/used-in',
    getParentRoute: () => AuthenticatedPartsComponentsIpnDetailsRouteRoute,
  } as any)
const AuthenticatedPartsCustomDetailsCustomPartSpecificationIdIndexRoute =
  AuthenticatedPartsCustomDetailsCustomPartSpecificationIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedPartsCustomDetailsCustomPartSpecificationIdRouteRoute,
    } as any,
  )
const AuthenticatedPartsCustomDetailsCustomPartSpecificationIdOffersRoute =
  AuthenticatedPartsCustomDetailsCustomPartSpecificationIdOffersRouteImport.update(
    {
      id: '/offers',
      path: '/offers',
      getParentRoute: () =>
        AuthenticatedPartsCustomDetailsCustomPartSpecificationIdRouteRoute,
    } as any,
  )
const AuthenticatedPartsCustomDetailsCustomPartSpecificationIdUsedInRoute =
  AuthenticatedPartsCustomDetailsCustomPartSpecificationIdUsedInRouteImport.update(
    {
      id: '/used-in',
      path: '/used-in',
      getParentRoute: () =>
        AuthenticatedPartsCustomDetailsCustomPartSpecificationIdRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdBomAssemblyAddAssemblyRoute =
  AuthenticatedProjectsProjectIdBomAssemblyAddAssemblyRouteImport.update({
    id: '/projects/$projectId/bom/assembly/add-assembly',
    path: '/projects/$projectId/bom/assembly/add-assembly',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProjectsProjectIdCalculationAssemblyIdCalculationRoute =
  AuthenticatedProjectsProjectIdCalculationAssemblyIdCalculationRouteImport.update(
    {
      id: '/projects/$projectId/calculation/$assemblyId/calculation',
      path: '/projects/$projectId/calculation/$assemblyId/calculation',
      getParentRoute: () => AuthenticatedRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdCalculationAssembliesAssemblyIdRoute =
  AuthenticatedProjectsProjectIdCalculationAssembliesAssemblyIdRouteImport.update(
    {
      id: '/projects/$projectId/calculation/assemblies/$assemblyId',
      path: '/projects/$projectId/calculation/assemblies/$assemblyId',
      getParentRoute: () => AuthenticatedRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdIndexRoute =
  AuthenticatedProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdIndexRouteImport.update(
    {
      id: '/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/',
      path: '/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/',
      getParentRoute: () => AuthenticatedRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdSourcingSidebarCompareRoute =
  AuthenticatedProjectsProjectIdSourcingSidebarCompareRouteImport.update({
    id: '/compare',
    path: '/compare',
    getParentRoute: () =>
      AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute,
  } as any)
const AuthenticatedProjectsProjectIdSourcingSidebarVersionHistoryRoute =
  AuthenticatedProjectsProjectIdSourcingSidebarVersionHistoryRouteImport.update(
    {
      id: '/version-history',
      path: '/version-history',
      getParentRoute: () =>
        AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdSourcingAssemblyAssemblyIdRoute =
  AuthenticatedProjectsProjectIdSourcingAssemblyAssemblyIdRouteImport.update({
    id: '/projects/$projectId/sourcing/assembly/$assemblyId',
    path: '/projects/$projectId/sourcing/assembly/$assemblyId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsMenuOrganizationCustomerPortalIndexRoute =
  AuthenticatedSettingsMenuOrganizationCustomerPortalIndexRouteImport.update({
    id: '/organization/customer-portal/',
    path: '/organization/customer-portal/',
    getParentRoute: () => AuthenticatedSettingsMenuRouteRoute,
  } as any)
const AuthenticatedSettingsMenuOrganizationCustomerPortalAdditionalServicesRoute =
  AuthenticatedSettingsMenuOrganizationCustomerPortalAdditionalServicesRouteImport.update(
    {
      id: '/organization/customer-portal/additional-services',
      path: '/organization/customer-portal/additional-services',
      getParentRoute: () => AuthenticatedSettingsMenuRouteRoute,
    } as any,
  )
const AuthenticatedSettingsMenuOrganizationCustomerPortalCheckoutConditionsRoute =
  AuthenticatedSettingsMenuOrganizationCustomerPortalCheckoutConditionsRouteImport.update(
    {
      id: '/organization/customer-portal/checkout-conditions',
      path: '/organization/customer-portal/checkout-conditions',
      getParentRoute: () => AuthenticatedSettingsMenuRouteRoute,
    } as any,
  )
const AuthenticatedSettingsMenuOrganizationCustomerPortalCustomerSpecificSettingsRoute =
  AuthenticatedSettingsMenuOrganizationCustomerPortalCustomerSpecificSettingsRouteImport.update(
    {
      id: '/organization/customer-portal/customer-specific-settings',
      path: '/organization/customer-portal/customer-specific-settings',
      getParentRoute: () => AuthenticatedSettingsMenuRouteRoute,
    } as any,
  )
const AuthenticatedSettingsMenuOrganizationCustomerPortalLandingPageRoute =
  AuthenticatedSettingsMenuOrganizationCustomerPortalLandingPageRouteImport.update(
    {
      id: '/organization/customer-portal/landing-page',
      path: '/organization/customer-portal/landing-page',
      getParentRoute: () => AuthenticatedSettingsMenuRouteRoute,
    } as any,
  )
const AuthenticatedSettingsMenuOrganizationCustomerPortalPaymentCredentialsRoute =
  AuthenticatedSettingsMenuOrganizationCustomerPortalPaymentCredentialsRouteImport.update(
    {
      id: '/organization/customer-portal/payment-credentials',
      path: '/organization/customer-portal/payment-credentials',
      getParentRoute: () => AuthenticatedSettingsMenuRouteRoute,
    } as any,
  )
const AuthenticatedSettingsMenuOrganizationPcbIndexRoute =
  AuthenticatedSettingsMenuOrganizationPcbIndexRouteImport.update({
    id: '/organization/pcb/',
    path: '/organization/pcb/',
    getParentRoute: () => AuthenticatedSettingsMenuRouteRoute,
  } as any)
const AuthenticatedSettingsMenuOrganizationUserManagementActionPermissionsRoute =
  AuthenticatedSettingsMenuOrganizationUserManagementActionPermissionsRouteImport.update(
    {
      id: '/organization/user-management/action-permissions',
      path: '/organization/user-management/action-permissions',
      getParentRoute: () => AuthenticatedSettingsMenuRouteRoute,
    } as any,
  )
const AuthenticatedSettingsMenuOrganizationUserManagementRolesRoute =
  AuthenticatedSettingsMenuOrganizationUserManagementRolesRouteImport.update({
    id: '/organization/user-management/roles',
    path: '/organization/user-management/roles',
    getParentRoute: () => AuthenticatedSettingsMenuRouteRoute,
  } as any)
const AuthenticatedSettingsMenuOrganizationUsersIndexRoute =
  AuthenticatedSettingsMenuOrganizationUsersIndexRouteImport.update({
    id: '/organization/users/',
    path: '/organization/users/',
    getParentRoute: () => AuthenticatedSettingsMenuRouteRoute,
  } as any)
const AuthenticatedSettingsOrganizationPcbPanelPreferencesIndexRoute =
  AuthenticatedSettingsOrganizationPcbPanelPreferencesIndexRouteImport.update({
    id: '/settings/organization/pcb/panel-preferences/',
    path: '/settings/organization/pcb/panel-preferences/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTemplatesSidebarEmailEmailTemplateIdEditRoute =
  AuthenticatedTemplatesSidebarEmailEmailTemplateIdEditRouteImport.update({
    id: '/email/$emailTemplateId/edit',
    path: '/email/$emailTemplateId/edit',
    getParentRoute: () => AuthenticatedTemplatesSidebarRouteRoute,
  } as any)
const AuthenticatedTemplatesSidebarQuotationBuilderChar123TemplateIdChar125Route =
  AuthenticatedTemplatesSidebarQuotationBuilderChar123TemplateIdChar125RouteImport.update(
    {
      id: '/quotation/builder/{-$templateId}',
      path: '/quotation/builder/{-$templateId}',
      getParentRoute: () => AuthenticatedTemplatesSidebarRouteRoute,
    } as any,
  )
const AuthenticatedTemplatesSidebarQuoteRequestQuoteRequestTemplateIdEditRoute =
  AuthenticatedTemplatesSidebarQuoteRequestQuoteRequestTemplateIdEditRouteImport.update(
    {
      id: '/quote-request/$quoteRequestTemplateId/edit',
      path: '/quote-request/$quoteRequestTemplateId/edit',
      getParentRoute: () => AuthenticatedTemplatesSidebarRouteRoute,
    } as any,
  )
const AuthenticatedTemplatesSidebarSourcingSourcingTemplateIdDuplicateRoute =
  AuthenticatedTemplatesSidebarSourcingSourcingTemplateIdDuplicateRouteImport.update(
    {
      id: '/sourcing/$sourcingTemplateId/duplicate',
      path: '/sourcing/$sourcingTemplateId/duplicate',
      getParentRoute: () => AuthenticatedTemplatesSidebarRouteRoute,
    } as any,
  )
const AuthenticatedTemplatesSidebarSourcingSourcingTemplateIdEditRoute =
  AuthenticatedTemplatesSidebarSourcingSourcingTemplateIdEditRouteImport.update(
    {
      id: '/sourcing/$sourcingTemplateId/edit',
      path: '/sourcing/$sourcingTemplateId/edit',
      getParentRoute: () => AuthenticatedTemplatesSidebarRouteRoute,
    } as any,
  )
const AuthenticatedMonitoringSidebarComponentsCategoriesCategoryIdPricingRoute =
  AuthenticatedMonitoringSidebarComponentsCategoriesCategoryIdPricingRouteImport.update(
    {
      id: '/components/categories/$categoryId/pricing',
      path: '/components/categories/$categoryId/pricing',
      getParentRoute: () => AuthenticatedMonitoringSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdIndexRoute =
  AuthenticatedNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdIndexRouteImport.update(
    {
      id: '/demand-groups/$demandGroupId/',
      path: '/demand-groups/$demandGroupId/',
      getParentRoute: () =>
        AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdAwardingRoute =
  AuthenticatedNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdAwardingRouteImport.update(
    {
      id: '/demand-groups/$demandGroupId/awarding',
      path: '/demand-groups/$demandGroupId/awarding',
      getParentRoute: () =>
        AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdIndexRoute =
  AuthenticatedNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdIndexRouteImport.update(
    {
      id: '/scenarios/$sourcingScenarioId/',
      path: '/scenarios/$sourcingScenarioId/',
      getParentRoute: () =>
        AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNegotiationsNegotiationIdScenariosSourcingScenarioIdLineSourcingLineItemIdRoute =
  AuthenticatedNegotiationsNegotiationIdScenariosSourcingScenarioIdLineSourcingLineItemIdRouteImport.update(
    {
      id: '/negotiations/$negotiationId/scenarios/$sourcingScenarioId/line/$sourcingLineItemId',
      path: '/negotiations/$negotiationId/scenarios/$sourcingScenarioId/line/$sourcingLineItemId',
      getParentRoute: () => AuthenticatedRouteRoute,
    } as any,
  )
const AuthenticatedNextComponentsIpnDetailsOffersIndexRoute =
  AuthenticatedNextComponentsIpnDetailsOffersIndexRouteImport.update({
    id: '/offers/',
    path: '/offers/',
    getParentRoute: () => AuthenticatedNextComponentsIpnDetailsRouteRoute,
  } as any)
const AuthenticatedNextComponentsIpnOffersOfferIdDuplicateRoute =
  AuthenticatedNextComponentsIpnOffersOfferIdDuplicateRouteImport.update({
    id: '/components/ipn/offers/$offerId/duplicate',
    path: '/components/ipn/offers/$offerId/duplicate',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextComponentsIpnOffersOfferIdEditRoute =
  AuthenticatedNextComponentsIpnOffersOfferIdEditRouteImport.update({
    id: '/components/ipn/offers/$offerId/edit',
    path: '/components/ipn/offers/$offerId/edit',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsIndexRoute =
  AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsIndexRouteImport.update(
    {
      id: '/quote-requests/',
      path: '/quote-requests/',
      getParentRoute: () =>
        AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsQuoteRequestIdRoute =
  AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsQuoteRequestIdRouteImport.update(
    {
      id: '/quote-requests/$quoteRequestId',
      path: '/quote-requests/$quoteRequestId',
      getParentRoute: () =>
        AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsAssignRoute =
  AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsAssignRouteImport.update(
    {
      id: '/quote-requests/assign',
      path: '/quote-requests/assign',
      getParentRoute: () =>
        AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsAttachmentsRoute =
  AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsAttachmentsRouteImport.update(
    {
      id: '/quote-requests/attachments',
      path: '/quote-requests/attachments',
      getParentRoute: () =>
        AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsDeliveryLotSizeRoute =
  AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsDeliveryLotSizeRouteImport.update(
    {
      id: '/quote-requests/delivery-lot-size',
      path: '/quote-requests/delivery-lot-size',
      getParentRoute: () =>
        AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsImporterRoute =
  AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsImporterRouteImport.update(
    {
      id: '/quote-requests/importer',
      path: '/quote-requests/importer',
      getParentRoute: () =>
        AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsLineItemsRoute =
  AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsLineItemsRouteImport.update(
    {
      id: '/quote-requests/line-items',
      path: '/quote-requests/line-items',
      getParentRoute: () =>
        AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsPreviewEmailRoute =
  AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsPreviewEmailRouteImport.update(
    {
      id: '/quote-requests/preview-email',
      path: '/quote-requests/preview-email',
      getParentRoute: () =>
        AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsTargetPriceRoute =
  AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsTargetPriceRouteImport.update(
    {
      id: '/quote-requests/target-price',
      path: '/quote-requests/target-price',
      getParentRoute: () =>
        AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosCompareRoute =
  AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosCompareRouteImport.update(
    {
      id: '/scenarios/compare',
      path: '/scenarios/compare',
      getParentRoute: () =>
        AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosCreateRoute =
  AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosCreateRouteImport.update(
    {
      id: '/scenarios/create',
      path: '/scenarios/create',
      getParentRoute: () =>
        AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdIndexRoute =
  AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdIndexRouteImport.update(
    {
      id: '/assemblies/$assemblyId/',
      path: '/assemblies/$assemblyId/',
      getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdDetailsRoute =
  AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdDetailsRouteImport.update(
    {
      id: '/assemblies/$assemblyId/details',
      path: '/assemblies/$assemblyId/details',
      getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdEditRoute =
  AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdEditRouteImport.update({
    id: '/assemblies/$assemblyId/edit',
    path: '/assemblies/$assemblyId/edit',
    getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
  } as any)
const AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRoute =
  AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRouteImport.update(
    {
      id: '/assemblies/$assemblyId/pcb',
      path: '/assemblies/$assemblyId/pcb',
      getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPnpImporterRoute =
  AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPnpImporterRouteImport.update(
    {
      id: '/assemblies/$assemblyId/pnp-importer',
      path: '/assemblies/$assemblyId/pnp-importer',
      getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdIndexRoute =
  AuthenticatedNextProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdIndexRouteImport.update(
    {
      id: '/manufacturing/$manufacturingAssemblyDetailsId/',
      path: '/manufacturing/$manufacturingAssemblyDetailsId/',
      getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdSourcingAssemblyAssemblyIdRoute =
  AuthenticatedNextProjectsProjectIdSourcingAssemblyAssemblyIdRouteImport.update(
    {
      id: '/sourcing/assembly/$assemblyId',
      path: '/sourcing/assembly/$assemblyId',
      getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdSourcingOverviewIndexRoute =
  AuthenticatedNextProjectsProjectIdSourcingOverviewIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedNextProjectsProjectIdSourcingOverviewRouteRoute,
  } as any)
const AuthenticatedNextProjectsProjectIdSourcingOverviewViewRoute =
  AuthenticatedNextProjectsProjectIdSourcingOverviewViewRouteImport.update({
    id: '/$view',
    path: '/$view',
    getParentRoute: () =>
      AuthenticatedNextProjectsProjectIdSourcingOverviewRouteRoute,
  } as any)
const AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsIndexRoute =
  AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsIndexRouteImport.update(
    {
      id: '/sourcing/quote-requests/',
      path: '/sourcing/quote-requests/',
      getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsQuoteRequestIdRoute =
  AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsQuoteRequestIdRouteImport.update(
    {
      id: '/sourcing/quote-requests/$quoteRequestId',
      path: '/sourcing/quote-requests/$quoteRequestId',
      getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsAssignRoute =
  AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsAssignRouteImport.update(
    {
      id: '/sourcing/quote-requests/assign',
      path: '/sourcing/quote-requests/assign',
      getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsAttachmentsRoute =
  AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsAttachmentsRouteImport.update(
    {
      id: '/sourcing/quote-requests/attachments',
      path: '/sourcing/quote-requests/attachments',
      getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsDeliveryLotSizeRoute =
  AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsDeliveryLotSizeRouteImport.update(
    {
      id: '/sourcing/quote-requests/delivery-lot-size',
      path: '/sourcing/quote-requests/delivery-lot-size',
      getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsImporterRoute =
  AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsImporterRouteImport.update(
    {
      id: '/sourcing/quote-requests/importer',
      path: '/sourcing/quote-requests/importer',
      getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsLineItemsRoute =
  AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsLineItemsRouteImport.update(
    {
      id: '/sourcing/quote-requests/line-items',
      path: '/sourcing/quote-requests/line-items',
      getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsPreviewEmailRoute =
  AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsPreviewEmailRouteImport.update(
    {
      id: '/sourcing/quote-requests/preview-email',
      path: '/sourcing/quote-requests/preview-email',
      getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsTargetPriceRoute =
  AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsTargetPriceRouteImport.update(
    {
      id: '/sourcing/quote-requests/target-price',
      path: '/sourcing/quote-requests/target-price',
      getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdRouteRoute =
  AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdRouteRouteImport.update(
    {
      id: '/sourcing/scenarios/$sourcingScenarioId',
      path: '/sourcing/scenarios/$sourcingScenarioId',
      getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdSourcingScenariosCreateRoute =
  AuthenticatedNextProjectsProjectIdSourcingScenariosCreateRouteImport.update({
    id: '/sourcing/scenarios/create',
    path: '/sourcing/scenarios/create',
    getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
  } as any)
const AuthenticatedNextSettingsMenuOrganizationCustomerPortalIndexRoute =
  AuthenticatedNextSettingsMenuOrganizationCustomerPortalIndexRouteImport.update(
    {
      id: '/organization/customer-portal/',
      path: '/organization/customer-portal/',
      getParentRoute: () => AuthenticatedNextSettingsMenuRouteRoute,
    } as any,
  )
const AuthenticatedNextSettingsMenuOrganizationCustomerPortalAdditionalServicesRoute =
  AuthenticatedNextSettingsMenuOrganizationCustomerPortalAdditionalServicesRouteImport.update(
    {
      id: '/organization/customer-portal/additional-services',
      path: '/organization/customer-portal/additional-services',
      getParentRoute: () => AuthenticatedNextSettingsMenuRouteRoute,
    } as any,
  )
const AuthenticatedNextSettingsMenuOrganizationCustomerPortalCheckoutConditionsRoute =
  AuthenticatedNextSettingsMenuOrganizationCustomerPortalCheckoutConditionsRouteImport.update(
    {
      id: '/organization/customer-portal/checkout-conditions',
      path: '/organization/customer-portal/checkout-conditions',
      getParentRoute: () => AuthenticatedNextSettingsMenuRouteRoute,
    } as any,
  )
const AuthenticatedNextSettingsMenuOrganizationCustomerPortalCustomerSpecificSettingsRoute =
  AuthenticatedNextSettingsMenuOrganizationCustomerPortalCustomerSpecificSettingsRouteImport.update(
    {
      id: '/organization/customer-portal/customer-specific-settings',
      path: '/organization/customer-portal/customer-specific-settings',
      getParentRoute: () => AuthenticatedNextSettingsMenuRouteRoute,
    } as any,
  )
const AuthenticatedNextSettingsMenuOrganizationCustomerPortalLandingPageRoute =
  AuthenticatedNextSettingsMenuOrganizationCustomerPortalLandingPageRouteImport.update(
    {
      id: '/organization/customer-portal/landing-page',
      path: '/organization/customer-portal/landing-page',
      getParentRoute: () => AuthenticatedNextSettingsMenuRouteRoute,
    } as any,
  )
const AuthenticatedNextSettingsMenuOrganizationCustomerPortalPaymentCredentialsRoute =
  AuthenticatedNextSettingsMenuOrganizationCustomerPortalPaymentCredentialsRouteImport.update(
    {
      id: '/organization/customer-portal/payment-credentials',
      path: '/organization/customer-portal/payment-credentials',
      getParentRoute: () => AuthenticatedNextSettingsMenuRouteRoute,
    } as any,
  )
const AuthenticatedNextSettingsMenuOrganizationPcbIndexRoute =
  AuthenticatedNextSettingsMenuOrganizationPcbIndexRouteImport.update({
    id: '/organization/pcb/',
    path: '/organization/pcb/',
    getParentRoute: () => AuthenticatedNextSettingsMenuRouteRoute,
  } as any)
const AuthenticatedNextSettingsMenuOrganizationUserManagementActionPermissionsRoute =
  AuthenticatedNextSettingsMenuOrganizationUserManagementActionPermissionsRouteImport.update(
    {
      id: '/organization/user-management/action-permissions',
      path: '/organization/user-management/action-permissions',
      getParentRoute: () => AuthenticatedNextSettingsMenuRouteRoute,
    } as any,
  )
const AuthenticatedNextSettingsMenuOrganizationUserManagementRolesRoute =
  AuthenticatedNextSettingsMenuOrganizationUserManagementRolesRouteImport.update(
    {
      id: '/organization/user-management/roles',
      path: '/organization/user-management/roles',
      getParentRoute: () => AuthenticatedNextSettingsMenuRouteRoute,
    } as any,
  )
const AuthenticatedNextSettingsMenuOrganizationUsersIndexRoute =
  AuthenticatedNextSettingsMenuOrganizationUsersIndexRouteImport.update({
    id: '/organization/users/',
    path: '/organization/users/',
    getParentRoute: () => AuthenticatedNextSettingsMenuRouteRoute,
  } as any)
const AuthenticatedNextSettingsOrganizationPcbPanelPreferencesIndexRoute =
  AuthenticatedNextSettingsOrganizationPcbPanelPreferencesIndexRouteImport.update(
    {
      id: '/settings/organization/pcb/panel-preferences/',
      path: '/settings/organization/pcb/panel-preferences/',
      getParentRoute: () => AuthenticatedNextRouteRoute,
    } as any,
  )
const AuthenticatedNextTemplatesFlexibleCalculationAppsAppIdWidgetIdRoute =
  AuthenticatedNextTemplatesFlexibleCalculationAppsAppIdWidgetIdRouteImport.update(
    {
      id: '/templates/flexible-calculation/apps/$appId/$widgetId',
      path: '/templates/flexible-calculation/apps/$appId/$widgetId',
      getParentRoute: () => AuthenticatedNextRouteRoute,
    } as any,
  )
const AuthenticatedNextTemplatesFlexibleCalculationReviewConversionLegacyTemplateIdFlexibleCalculationTemplateIdRoute =
  AuthenticatedNextTemplatesFlexibleCalculationReviewConversionLegacyTemplateIdFlexibleCalculationTemplateIdRouteImport.update(
    {
      id: '/templates/flexible-calculation/review-conversion/$legacyTemplateId/$flexibleCalculationTemplateId',
      path: '/templates/flexible-calculation/review-conversion/$legacyTemplateId/$flexibleCalculationTemplateId',
      getParentRoute: () => AuthenticatedNextRouteRoute,
    } as any,
  )
const AuthenticatedNextTemplatesManufacturingActivitiesActivityIdDuplicateRoute =
  AuthenticatedNextTemplatesManufacturingActivitiesActivityIdDuplicateRouteImport.update(
    {
      id: '/templates/manufacturing/activities/$activityId/duplicate',
      path: '/templates/manufacturing/activities/$activityId/duplicate',
      getParentRoute: () => AuthenticatedNextRouteRoute,
    } as any,
  )
const AuthenticatedNextTemplatesManufacturingActivitiesActivityIdEditRoute =
  AuthenticatedNextTemplatesManufacturingActivitiesActivityIdEditRouteImport.update(
    {
      id: '/templates/manufacturing/activities/$activityId/edit',
      path: '/templates/manufacturing/activities/$activityId/edit',
      getParentRoute: () => AuthenticatedNextRouteRoute,
    } as any,
  )
const AuthenticatedNextTemplatesManufacturingAppsAppIdWidgetIdRoute =
  AuthenticatedNextTemplatesManufacturingAppsAppIdWidgetIdRouteImport.update({
    id: '/templates/manufacturing/apps/$appId/$widgetId',
    path: '/templates/manufacturing/apps/$appId/$widgetId',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextTemplatesManufacturingDriversDriverIdDuplicateRoute =
  AuthenticatedNextTemplatesManufacturingDriversDriverIdDuplicateRouteImport.update(
    {
      id: '/templates/manufacturing/drivers/$driverId/duplicate',
      path: '/templates/manufacturing/drivers/$driverId/duplicate',
      getParentRoute: () => AuthenticatedNextRouteRoute,
    } as any,
  )
const AuthenticatedNextTemplatesManufacturingDriversDriverIdEditRoute =
  AuthenticatedNextTemplatesManufacturingDriversDriverIdEditRouteImport.update({
    id: '/templates/manufacturing/drivers/$driverId/edit',
    path: '/templates/manufacturing/drivers/$driverId/edit',
    getParentRoute: () => AuthenticatedNextRouteRoute,
  } as any)
const AuthenticatedNextTemplatesManufacturingExpensesExpenseIdDuplicateRoute =
  AuthenticatedNextTemplatesManufacturingExpensesExpenseIdDuplicateRouteImport.update(
    {
      id: '/templates/manufacturing/expenses/$expenseId/duplicate',
      path: '/templates/manufacturing/expenses/$expenseId/duplicate',
      getParentRoute: () => AuthenticatedNextRouteRoute,
    } as any,
  )
const AuthenticatedNextTemplatesManufacturingExpensesExpenseIdEditRoute =
  AuthenticatedNextTemplatesManufacturingExpensesExpenseIdEditRouteImport.update(
    {
      id: '/templates/manufacturing/expenses/$expenseId/edit',
      path: '/templates/manufacturing/expenses/$expenseId/edit',
      getParentRoute: () => AuthenticatedNextRouteRoute,
    } as any,
  )
const AuthenticatedNextTemplatesManufacturingResourcesResourceIdDuplicateRoute =
  AuthenticatedNextTemplatesManufacturingResourcesResourceIdDuplicateRouteImport.update(
    {
      id: '/templates/manufacturing/resources/$resourceId/duplicate',
      path: '/templates/manufacturing/resources/$resourceId/duplicate',
      getParentRoute: () => AuthenticatedNextRouteRoute,
    } as any,
  )
const AuthenticatedNextTemplatesManufacturingResourcesResourceIdEditRoute =
  AuthenticatedNextTemplatesManufacturingResourcesResourceIdEditRouteImport.update(
    {
      id: '/templates/manufacturing/resources/$resourceId/edit',
      path: '/templates/manufacturing/resources/$resourceId/edit',
      getParentRoute: () => AuthenticatedNextRouteRoute,
    } as any,
  )
const AuthenticatedPartsComponentsIpnOffersOfferIdDuplicateRoute =
  AuthenticatedPartsComponentsIpnOffersOfferIdDuplicateRouteImport.update({
    id: '/parts/components/ipn/offers/$offerId/duplicate',
    path: '/parts/components/ipn/offers/$offerId/duplicate',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPartsComponentsIpnOffersOfferIdEditRoute =
  AuthenticatedPartsComponentsIpnOffersOfferIdEditRouteImport.update({
    id: '/parts/components/ipn/offers/$offerId/edit',
    path: '/parts/components/ipn/offers/$offerId/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdIndexRoute =
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdIndexRouteImport.update({
    id: '/projects/$projectId/bom/assembly/$assemblyId/',
    path: '/projects/$projectId/bom/assembly/$assemblyId/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdDetailsRoute =
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdDetailsRouteImport.update({
    id: '/projects/$projectId/bom/assembly/$assemblyId/details',
    path: '/projects/$projectId/bom/assembly/$assemblyId/details',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdEditRoute =
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdEditRouteImport.update({
    id: '/projects/$projectId/bom/assembly/$assemblyId/edit',
    path: '/projects/$projectId/bom/assembly/$assemblyId/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRoute =
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRouteImport.update(
    {
      id: '/projects/$projectId/bom/assembly/$assemblyId/pcb',
      path: '/projects/$projectId/bom/assembly/$assemblyId/pcb',
      getParentRoute: () => AuthenticatedRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPnpImporterRoute =
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPnpImporterRouteImport.update(
    {
      id: '/projects/$projectId/bom/assembly/$assemblyId/pnp-importer',
      path: '/projects/$projectId/bom/assembly/$assemblyId/pnp-importer',
      getParentRoute: () => AuthenticatedRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdActivityRoute =
  AuthenticatedProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdActivityRouteImport.update(
    {
      id: '/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/activity',
      path: '/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/activity',
      getParentRoute: () => AuthenticatedRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdExpenseRoute =
  AuthenticatedProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdExpenseRouteImport.update(
    {
      id: '/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/expense',
      path: '/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/expense',
      getParentRoute: () => AuthenticatedRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdSourcingSourcingScenarioIdLineSourcingLineItemIdRoute =
  AuthenticatedProjectsProjectIdSourcingSourcingScenarioIdLineSourcingLineItemIdRouteImport.update(
    {
      id: '/projects/$projectId/sourcing/$sourcingScenarioId/line/$sourcingLineItemId',
      path: '/projects/$projectId/sourcing/$sourcingScenarioId/line/$sourcingLineItemId',
      getParentRoute: () => AuthenticatedRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdSourcingSidebarOverviewIndexRoute =
  AuthenticatedProjectsProjectIdSourcingSidebarOverviewIndexRouteImport.update({
    id: '/overview/',
    path: '/overview/',
    getParentRoute: () =>
      AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute,
  } as any)
const AuthenticatedProjectsProjectIdSourcingSidebarOverviewViewRoute =
  AuthenticatedProjectsProjectIdSourcingSidebarOverviewViewRouteImport.update({
    id: '/overview/$view',
    path: '/overview/$view',
    getParentRoute: () =>
      AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute,
  } as any)
const AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsIndexRoute =
  AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsIndexRouteImport.update(
    {
      id: '/quote-requests/',
      path: '/quote-requests/',
      getParentRoute: () =>
        AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsQuoteRequestIdRoute =
  AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsQuoteRequestIdRouteImport.update(
    {
      id: '/quote-requests/$quoteRequestId',
      path: '/quote-requests/$quoteRequestId',
      getParentRoute: () =>
        AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsAssignRoute =
  AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsAssignRouteImport.update(
    {
      id: '/quote-requests/assign',
      path: '/quote-requests/assign',
      getParentRoute: () =>
        AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsAttachmentsRoute =
  AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsAttachmentsRouteImport.update(
    {
      id: '/quote-requests/attachments',
      path: '/quote-requests/attachments',
      getParentRoute: () =>
        AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsDeliveryLotSizeRoute =
  AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsDeliveryLotSizeRouteImport.update(
    {
      id: '/quote-requests/delivery-lot-size',
      path: '/quote-requests/delivery-lot-size',
      getParentRoute: () =>
        AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsExcelImporterRoute =
  AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsExcelImporterRouteImport.update(
    {
      id: '/quote-requests/excel-importer',
      path: '/quote-requests/excel-importer',
      getParentRoute: () =>
        AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsImporterRoute =
  AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsImporterRouteImport.update(
    {
      id: '/quote-requests/importer',
      path: '/quote-requests/importer',
      getParentRoute: () =>
        AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsLineItemsRoute =
  AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsLineItemsRouteImport.update(
    {
      id: '/quote-requests/line-items',
      path: '/quote-requests/line-items',
      getParentRoute: () =>
        AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsPreviewEmailRoute =
  AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsPreviewEmailRouteImport.update(
    {
      id: '/quote-requests/preview-email',
      path: '/quote-requests/preview-email',
      getParentRoute: () =>
        AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsTargetPriceRoute =
  AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsTargetPriceRouteImport.update(
    {
      id: '/quote-requests/target-price',
      path: '/quote-requests/target-price',
      getParentRoute: () =>
        AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdSourcingSidebarScenariosCreateRoute =
  AuthenticatedProjectsProjectIdSourcingSidebarScenariosCreateRouteImport.update(
    {
      id: '/scenarios/create',
      path: '/scenarios/create',
      getParentRoute: () =>
        AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdIndexRoute =
  AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdIndexRouteImport.update(
    {
      id: '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/',
      path: '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/',
      getParentRoute: () => AuthenticatedRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarRouteRoute =
  AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarRouteRouteImport.update(
    {
      id: '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/_sidebar',
      path: '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId',
      getParentRoute: () => AuthenticatedRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdPurchaseOrdersRoute =
  AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdPurchaseOrdersRouteImport.update(
    {
      id: '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/purchase-orders',
      path: '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/purchase-orders',
      getParentRoute: () => AuthenticatedRouteRoute,
    } as any,
  )
const AuthenticatedSettingsMenuOrganizationPcbPanelPreferencesCreateRoute =
  AuthenticatedSettingsMenuOrganizationPcbPanelPreferencesCreateRouteImport.update(
    {
      id: '/organization/pcb/panel-preferences/create',
      path: '/organization/pcb/panel-preferences/create',
      getParentRoute: () => AuthenticatedSettingsMenuRouteRoute,
    } as any,
  )
const AuthenticatedTemplatesSidebarFlexibleCalculationAppsAppIdWidgetIdRoute =
  AuthenticatedTemplatesSidebarFlexibleCalculationAppsAppIdWidgetIdRouteImport.update(
    {
      id: '/flexible-calculation/apps/$appId/$widgetId',
      path: '/flexible-calculation/apps/$appId/$widgetId',
      getParentRoute: () => AuthenticatedTemplatesSidebarRouteRoute,
    } as any,
  )
const AuthenticatedTemplatesSidebarFlexibleCalculationReviewConversionLegacyTemplateIdFlexibleCalculationTemplateIdRoute =
  AuthenticatedTemplatesSidebarFlexibleCalculationReviewConversionLegacyTemplateIdFlexibleCalculationTemplateIdRouteImport.update(
    {
      id: '/flexible-calculation/review-conversion/$legacyTemplateId/$flexibleCalculationTemplateId',
      path: '/flexible-calculation/review-conversion/$legacyTemplateId/$flexibleCalculationTemplateId',
      getParentRoute: () => AuthenticatedTemplatesSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownIndexRoute =
  AuthenticatedNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownIndexRouteImport.update(
    {
      id: '/scenarios/$sourcingScenarioId/cost-breakdown/',
      path: '/scenarios/$sourcingScenarioId/cost-breakdown/',
      getParentRoute: () =>
        AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNextNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdIndexRoute =
  AuthenticatedNextNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdIndexRouteImport.update(
    {
      id: '/demand-groups/$demandGroupId/',
      path: '/demand-groups/$demandGroupId/',
      getParentRoute: () =>
        AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNextNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdAwardingRoute =
  AuthenticatedNextNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdAwardingRouteImport.update(
    {
      id: '/demand-groups/$demandGroupId/awarding',
      path: '/demand-groups/$demandGroupId/awarding',
      getParentRoute: () =>
        AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdIndexRoute =
  AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdIndexRouteImport.update(
    {
      id: '/scenarios/$sourcingScenarioId/',
      path: '/scenarios/$sourcingScenarioId/',
      getParentRoute: () =>
        AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNextNegotiationsNegotiationIdScenariosSourcingScenarioIdLineItemsSourcingLineItemIdRoute =
  AuthenticatedNextNegotiationsNegotiationIdScenariosSourcingScenarioIdLineItemsSourcingLineItemIdRouteImport.update(
    {
      id: '/negotiations/$negotiationId/scenarios/$sourcingScenarioId/line-items/$sourcingLineItemId',
      path: '/negotiations/$negotiationId/scenarios/$sourcingScenarioId/line-items/$sourcingLineItemId',
      getParentRoute: () => AuthenticatedNextRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbIndexRoute =
  AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbCadViewerRoute =
  AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbCadViewerRouteImport.update(
    {
      id: '/cad-viewer',
      path: '/cad-viewer',
      getParentRoute: () =>
        AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbDfmRoute =
  AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbDfmRouteImport.update(
    {
      id: '/dfm',
      path: '/dfm',
      getParentRoute: () =>
        AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbDfmAnalysisRoute =
  AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbDfmAnalysisRouteImport.update(
    {
      id: '/dfm-analysis',
      path: '/dfm-analysis',
      getParentRoute: () =>
        AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbDrillsRoute =
  AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbDrillsRouteImport.update(
    {
      id: '/drills',
      path: '/drills',
      getParentRoute: () =>
        AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbFilesRoute =
  AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbFilesRouteImport.update(
    {
      id: '/files',
      path: '/files',
      getParentRoute: () =>
        AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbPanelizationRoute =
  AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbPanelizationRouteImport.update(
    {
      id: '/panelization',
      path: '/panelization',
      getParentRoute: () =>
        AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbSpecificationRoute =
  AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbSpecificationRouteImport.update(
    {
      id: '/specification',
      path: '/specification',
      getParentRoute: () =>
        AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbStackupRoute =
  AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbStackupRouteImport.update(
    {
      id: '/stackup',
      path: '/stackup',
      getParentRoute: () =>
        AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdSubassembliesCreateRoute =
  AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdSubassembliesCreateRouteImport.update(
    {
      id: '/assemblies/$assemblyId/subassemblies/create',
      path: '/assemblies/$assemblyId/subassemblies/create',
      getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdActivityRoute =
  AuthenticatedNextProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdActivityRouteImport.update(
    {
      id: '/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/activity',
      path: '/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/activity',
      getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdExpenseRoute =
  AuthenticatedNextProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdExpenseRouteImport.update(
    {
      id: '/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/expense',
      path: '/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/expense',
      getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdIndexRoute =
  AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdPurchaseOrdersRoute =
  AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdPurchaseOrdersRouteImport.update(
    {
      id: '/purchase-orders',
      path: '/purchase-orders',
      getParentRoute: () =>
        AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdRouteRoute,
    } as any,
  )
const AuthenticatedNextSettingsMenuOrganizationPcbPanelPreferencesCreateRoute =
  AuthenticatedNextSettingsMenuOrganizationPcbPanelPreferencesCreateRouteImport.update(
    {
      id: '/organization/pcb/panel-preferences/create',
      path: '/organization/pcb/panel-preferences/create',
      getParentRoute: () => AuthenticatedNextSettingsMenuRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbIndexRoute =
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbCadViewerRoute =
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbCadViewerRouteImport.update(
    {
      id: '/cad-viewer',
      path: '/cad-viewer',
      getParentRoute: () =>
        AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbDfmRoute =
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbDfmRouteImport.update({
    id: '/dfm',
    path: '/dfm',
    getParentRoute: () =>
      AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRoute,
  } as any)
const AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbDfmAnalysisRoute =
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbDfmAnalysisRouteImport.update(
    {
      id: '/dfm-analysis',
      path: '/dfm-analysis',
      getParentRoute: () =>
        AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbDrillsRoute =
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbDrillsRouteImport.update(
    {
      id: '/drills',
      path: '/drills',
      getParentRoute: () =>
        AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbFilesRoute =
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbFilesRouteImport.update(
    {
      id: '/files',
      path: '/files',
      getParentRoute: () =>
        AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbPanelizationRoute =
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbPanelizationRouteImport.update(
    {
      id: '/panelization',
      path: '/panelization',
      getParentRoute: () =>
        AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbSpecificationRoute =
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbSpecificationRouteImport.update(
    {
      id: '/specification',
      path: '/specification',
      getParentRoute: () =>
        AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbStackupRoute =
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbStackupRouteImport.update(
    {
      id: '/stackup',
      path: '/stackup',
      getParentRoute: () =>
        AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdSubassembliesCreateRoute =
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdSubassembliesCreateRouteImport.update(
    {
      id: '/projects/$projectId/bom/assembly/$assemblyId/subassemblies/create',
      path: '/projects/$projectId/bom/assembly/$assemblyId/subassemblies/create',
      getParentRoute: () => AuthenticatedRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdSourcingOfferCustomPartOfferIdDuplicateRoute =
  AuthenticatedProjectsProjectIdSourcingOfferCustomPartOfferIdDuplicateRouteImport.update(
    {
      id: '/projects/$projectId/sourcing/offer/custom-part/$offerId/duplicate',
      path: '/projects/$projectId/sourcing/offer/custom-part/$offerId/duplicate',
      getParentRoute: () => AuthenticatedRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdSourcingOfferCustomPartOfferIdEditRoute =
  AuthenticatedProjectsProjectIdSourcingOfferCustomPartOfferIdEditRouteImport.update(
    {
      id: '/projects/$projectId/sourcing/offer/custom-part/$offerId/edit',
      path: '/projects/$projectId/sourcing/offer/custom-part/$offerId/edit',
      getParentRoute: () => AuthenticatedRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdSourcingOfferInternalPartNumberOfferIdDuplicateRoute =
  AuthenticatedProjectsProjectIdSourcingOfferInternalPartNumberOfferIdDuplicateRouteImport.update(
    {
      id: '/projects/$projectId/sourcing/offer/internal-part-number/$offerId/duplicate',
      path: '/projects/$projectId/sourcing/offer/internal-part-number/$offerId/duplicate',
      getParentRoute: () => AuthenticatedRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdSourcingOfferInternalPartNumberOfferIdEditRoute =
  AuthenticatedProjectsProjectIdSourcingOfferInternalPartNumberOfferIdEditRouteImport.update(
    {
      id: '/projects/$projectId/sourcing/offer/internal-part-number/$offerId/edit',
      path: '/projects/$projectId/sourcing/offer/internal-part-number/$offerId/edit',
      getParentRoute: () => AuthenticatedRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdSourcingOfferOffTheShelfOfferIdDuplicateRoute =
  AuthenticatedProjectsProjectIdSourcingOfferOffTheShelfOfferIdDuplicateRouteImport.update(
    {
      id: '/projects/$projectId/sourcing/offer/off-the-shelf/$offerId/duplicate',
      path: '/projects/$projectId/sourcing/offer/off-the-shelf/$offerId/duplicate',
      getParentRoute: () => AuthenticatedRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdSourcingOfferOffTheShelfOfferIdEditRoute =
  AuthenticatedProjectsProjectIdSourcingOfferOffTheShelfOfferIdEditRouteImport.update(
    {
      id: '/projects/$projectId/sourcing/offer/off-the-shelf/$offerId/edit',
      path: '/projects/$projectId/sourcing/offer/off-the-shelf/$offerId/edit',
      getParentRoute: () => AuthenticatedRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarLineItemsRoute =
  AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarLineItemsRouteImport.update(
    {
      id: '/line-items',
      path: '/line-items',
      getParentRoute: () =>
        AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedSettingsMenuOrganizationPcbPanelPreferencesPanelPreferenceIdEditRoute =
  AuthenticatedSettingsMenuOrganizationPcbPanelPreferencesPanelPreferenceIdEditRouteImport.update(
    {
      id: '/organization/pcb/panel-preferences/$panelPreferenceId/edit',
      path: '/organization/pcb/panel-preferences/$panelPreferenceId/edit',
      getParentRoute: () => AuthenticatedSettingsMenuRouteRoute,
    } as any,
  )
const AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownIndexRoute =
  AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownIndexRouteImport.update(
    {
      id: '/scenarios/$sourcingScenarioId/cost-breakdown/',
      path: '/scenarios/$sourcingScenarioId/cost-breakdown/',
      getParentRoute: () =>
        AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdSourcingOffersCustomPartOfferIdDuplicateRoute =
  AuthenticatedNextProjectsProjectIdSourcingOffersCustomPartOfferIdDuplicateRouteImport.update(
    {
      id: '/sourcing/offers/custom-part/$offerId/duplicate',
      path: '/sourcing/offers/custom-part/$offerId/duplicate',
      getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdSourcingOffersCustomPartOfferIdEditRoute =
  AuthenticatedNextProjectsProjectIdSourcingOffersCustomPartOfferIdEditRouteImport.update(
    {
      id: '/sourcing/offers/custom-part/$offerId/edit',
      path: '/sourcing/offers/custom-part/$offerId/edit',
      getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdSourcingOffersInternalPartNumberOfferIdDuplicateRoute =
  AuthenticatedNextProjectsProjectIdSourcingOffersInternalPartNumberOfferIdDuplicateRouteImport.update(
    {
      id: '/sourcing/offers/internal-part-number/$offerId/duplicate',
      path: '/sourcing/offers/internal-part-number/$offerId/duplicate',
      getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdSourcingOffersInternalPartNumberOfferIdEditRoute =
  AuthenticatedNextProjectsProjectIdSourcingOffersInternalPartNumberOfferIdEditRouteImport.update(
    {
      id: '/sourcing/offers/internal-part-number/$offerId/edit',
      path: '/sourcing/offers/internal-part-number/$offerId/edit',
      getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdSourcingOffersOffTheShelfOfferIdDuplicateRoute =
  AuthenticatedNextProjectsProjectIdSourcingOffersOffTheShelfOfferIdDuplicateRouteImport.update(
    {
      id: '/sourcing/offers/off-the-shelf/$offerId/duplicate',
      path: '/sourcing/offers/off-the-shelf/$offerId/duplicate',
      getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdSourcingOffersOffTheShelfOfferIdEditRoute =
  AuthenticatedNextProjectsProjectIdSourcingOffersOffTheShelfOfferIdEditRouteImport.update(
    {
      id: '/sourcing/offers/off-the-shelf/$offerId/edit',
      path: '/sourcing/offers/off-the-shelf/$offerId/edit',
      getParentRoute: () => AuthenticatedNextProjectsProjectIdRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdCostBreakdownIndexRoute =
  AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdCostBreakdownIndexRouteImport.update(
    {
      id: '/cost-breakdown/',
      path: '/cost-breakdown/',
      getParentRoute: () =>
        AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdLineItemsIndexRoute =
  AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdLineItemsIndexRouteImport.update(
    {
      id: '/line-items/',
      path: '/line-items/',
      getParentRoute: () =>
        AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdLineItemsSourcingLineItemIdRoute =
  AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdLineItemsSourcingLineItemIdRouteImport.update(
    {
      id: '/line-items/$sourcingLineItemId',
      path: '/line-items/$sourcingLineItemId',
      getParentRoute: () =>
        AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdRouteRoute,
    } as any,
  )
const AuthenticatedNextSettingsMenuOrganizationPcbPanelPreferencesPanelPreferenceIdEditRoute =
  AuthenticatedNextSettingsMenuOrganizationPcbPanelPreferencesPanelPreferenceIdEditRouteImport.update(
    {
      id: '/organization/pcb/panel-preferences/$panelPreferenceId/edit',
      path: '/organization/pcb/panel-preferences/$panelPreferenceId/edit',
      getParentRoute: () => AuthenticatedNextSettingsMenuRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarCostBreakdownIndexRoute =
  AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarCostBreakdownIndexRouteImport.update(
    {
      id: '/cost-breakdown/',
      path: '/cost-breakdown/',
      getParentRoute: () =>
        AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownAssemblyAssemblyIdDemandDemandIdRoute =
  AuthenticatedNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownAssemblyAssemblyIdDemandDemandIdRouteImport.update(
    {
      id: '/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId',
      path: '/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId',
      getParentRoute: () =>
        AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownAssemblyAssemblyIdDemandDemandIdRoute =
  AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownAssemblyAssemblyIdDemandDemandIdRouteImport.update(
    {
      id: '/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId',
      path: '/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId',
      getParentRoute: () =>
        AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute,
    } as any,
  )
const AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdCostBreakdownAssemblyAssemblyIdDemandDemandIdRoute =
  AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdCostBreakdownAssemblyAssemblyIdDemandDemandIdRouteImport.update(
    {
      id: '/cost-breakdown/assembly/$assemblyId/demand/$demandId',
      path: '/cost-breakdown/assembly/$assemblyId/demand/$demandId',
      getParentRoute: () =>
        AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdRouteRoute,
    } as any,
  )
const AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarCostBreakdownAssemblyAssemblyIdDemandDemandIdRoute =
  AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarCostBreakdownAssemblyAssemblyIdDemandDemandIdRouteImport.update(
    {
      id: '/cost-breakdown/assembly/$assemblyId/demand/$demandId',
      path: '/cost-breakdown/assembly/$assemblyId/demand/$demandId',
      getParentRoute: () =>
        AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/callback': typeof CallbackRoute
  '/landing': typeof LandingRoute
  '/customer-portal': typeof AuthenticatedCustomerPortalRouteRouteWithChildren
  '/monitoring': typeof AuthenticatedMonitoringRouteRouteWithChildren
  '/next': typeof AuthenticatedNextRouteRouteWithChildren
  '/risk-management': typeof AuthenticatedRiskManagementRouteRouteWithChildren
  '/$': typeof AuthenticatedSplatRoute
  '/home': typeof AuthenticatedHomeRoute
  '/project_creation': typeof AuthenticatedProject_creationRoute
  '/purchase-orders': typeof AuthenticatedPurchaseOrdersRoute
  '/rfqs': typeof AuthenticatedRfqsRoute
  '/start': typeof AuthenticatedStartRoute
  '/auth/enter-email': typeof AuthEnterEmailRoute
  '/manufacturers': typeof AuthenticatedManufacturersSidebarRouteRouteWithChildren
  '/manufacturing': typeof AuthenticatedManufacturingSidebarRouteRouteWithChildren
  '/parts': typeof AuthenticatedPartsSidebarRouteRouteWithChildren
  '/settings': typeof AuthenticatedSettingsMenuRouteRouteWithChildren
  '/suppliers': typeof AuthenticatedSuppliersSidebarRouteRouteWithChildren
  '/templates': typeof AuthenticatedTemplatesSidebarRouteRouteWithChildren
  '/apps/$': typeof AuthenticatedAppsSplatRoute
  '/assemblies/add-assembly': typeof AuthenticatedAssembliesAddAssemblyRoute
  '/components/import': typeof AuthenticatedComponentsImportRoute
  '/customers/$customerId': typeof AuthenticatedCustomersCustomerIdRoute
  '/customers/importer': typeof AuthenticatedCustomersImporterRoute
  '/manufacturer/$': typeof AuthenticatedManufacturerSplatRoute
  '/manufacturers/$manufacturerId': typeof AuthenticatedManufacturersManufacturerIdRoute
  '/manufacturers/importer': typeof AuthenticatedManufacturersImporterRoute
  '/manufacturing/add-activity': typeof AuthenticatedManufacturingAddActivityRoute
  '/manufacturing/add-driver': typeof AuthenticatedManufacturingAddDriverRoute
  '/manufacturing/add-expense': typeof AuthenticatedManufacturingAddExpenseRoute
  '/manufacturing/add-resource': typeof AuthenticatedManufacturingAddResourceRoute
  '/monitoring/analysis': typeof AuthenticatedMonitoringAnalysisRoute
  '/negotiations/create': typeof AuthenticatedNegotiationsCreateRoute
  '/next/$': typeof AuthenticatedNextSplatRoute
  '/next/alerts': typeof AuthenticatedNextAlertsRoute
  '/next/home': typeof AuthenticatedNextHomeRoute
  '/next/lumi-agent': typeof AuthenticatedNextLumiAgentRoute
  '/next/purchase-orders': typeof AuthenticatedNextPurchaseOrdersRoute
  '/offers/mpn-offer-importer': typeof AuthenticatedOffersMpnOfferImporterRoute
  '/orders/upload': typeof AuthenticatedOrdersUploadRoute
  '/orders/{-$orderId}': typeof AuthenticatedOrdersChar123OrderIdChar125Route
  '/parts/off-the-shelf-part-search': typeof AuthenticatedPartsOffTheShelfPartSearchRoute
  '/projects/create': typeof AuthenticatedProjectsCreateRoute
  '/projects/new': typeof AuthenticatedProjectsNewRoute
  '/quote-requests/excel-importer': typeof AuthenticatedQuoteRequestsExcelImporterRoute
  '/risk-management/geo-risk': typeof AuthenticatedRiskManagementGeoRiskRoute
  '/risk-management/pcns': typeof AuthenticatedRiskManagementPcnsRoute
  '/risk-management/risk-digest': typeof AuthenticatedRiskManagementRiskDigestRoute
  '/settings/company': typeof AuthenticatedSettingsCompanyRoute
  '/supplier/importer': typeof AuthenticatedSupplierImporterRoute
  '/suppliers/$supplierAndStockLocationId': typeof AuthenticatedSuppliersSupplierAndStockLocationIdRoute
  '/suppliers/importer': typeof AuthenticatedSuppliersImporterRoute
  '/template/$': typeof AuthenticatedTemplateSplatRoute
  '/auth/signup/customer': typeof AuthSignupCustomerRoute
  '/auth/signup/invite': typeof AuthSignupInviteRoute
  '/assemblies/': typeof AuthenticatedAssembliesIndexRoute
  '/customer-portal/': typeof AuthenticatedCustomerPortalIndexRoute
  '/customers/': typeof AuthenticatedCustomersIndexRoute
  '/manufacturing/': typeof AuthenticatedManufacturingIndexRoute
  '/negotiations/': typeof AuthenticatedNegotiationsIndexRoute
  '/next/': typeof AuthenticatedNextIndexRoute
  '/parts/': typeof AuthenticatedPartsIndexRoute
  '/projects/': typeof AuthenticatedProjectsIndexRoute
  '/risk-management/': typeof AuthenticatedRiskManagementIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/supplier-portal/': typeof AuthenticatedSupplierPortalIndexRoute
  '/templates/': typeof AuthenticatedTemplatesIndexRoute
  '/assemblies/$assemblyId/pcb': typeof AuthenticatedAssembliesAssemblyIdPcbRouteRouteWithChildren
  '/negotiations/$negotiationId': typeof AuthenticatedNegotiationsNegotiationIdSidebarRouteRouteWithChildren
  '/next/parts/$partId': typeof AuthenticatedNextPartsPartIdRouteRouteWithChildren
  '/next/projects/$projectId': typeof AuthenticatedNextProjectsProjectIdRouteRouteWithChildren
  '/next/settings': typeof AuthenticatedNextSettingsMenuRouteRouteWithChildren
  '/parts/details/$partId': typeof AuthenticatedPartsDetailsPartIdRouteRouteWithChildren
  '/3rdparty/digikey/callback': typeof Authenticated3rdpartyDigikeyCallbackRoute
  '/assemblies/$assemblyId/dashboard': typeof AuthenticatedAssembliesAssemblyIdDashboardRoute
  '/assemblies/$assemblyId/details': typeof AuthenticatedAssembliesAssemblyIdDetailsRoute
  '/assemblies/$assemblyId/edit': typeof AuthenticatedAssembliesAssemblyIdEditRoute
  '/manufacturers/line-card': typeof AuthenticatedManufacturersSidebarLineCardRoute
  '/manufacturing/activities/create': typeof AuthenticatedManufacturingActivitiesCreateRoute
  '/manufacturing/activity/$': typeof AuthenticatedManufacturingActivitySplatRoute
  '/manufacturing/driver/$': typeof AuthenticatedManufacturingDriverSplatRoute
  '/manufacturing/drivers/create': typeof AuthenticatedManufacturingDriversCreateRoute
  '/manufacturing/expense/$': typeof AuthenticatedManufacturingExpenseSplatRoute
  '/manufacturing/expenses/create': typeof AuthenticatedManufacturingExpensesCreateRoute
  '/manufacturing/resource/$': typeof AuthenticatedManufacturingResourceSplatRoute
  '/manufacturing/resources/create': typeof AuthenticatedManufacturingResourcesCreateRoute
  '/manufacturing/template/$': typeof AuthenticatedManufacturingTemplateSplatRoute
  '/monitoring/component-savings': typeof AuthenticatedMonitoringSidebarComponentSavingsRoute
  '/monitoring/data-health': typeof AuthenticatedMonitoringSidebarDataHealthRoute
  '/monitoring/offers': typeof AuthenticatedMonitoringSidebarOffersRoute
  '/monitoring/onboarding': typeof AuthenticatedMonitoringSidebarOnboardingRoute
  '/monitoring/agent/$': typeof AuthenticatedMonitoringAgentSplatRoute
  '/monitoring/charts/$chartId': typeof AuthenticatedMonitoringChartsChartIdRoute
  '/next/apps/$': typeof AuthenticatedNextAppsSplatRoute
  '/next/components/linking': typeof AuthenticatedNextComponentsLinkingRoute
  '/next/customers/$customerId': typeof AuthenticatedNextCustomersCustomerIdRoute
  '/next/demands/importer': typeof AuthenticatedNextDemandsImporterRoute
  '/next/manufacturers/$manufacturerId': typeof AuthenticatedNextManufacturersManufacturerIdRoute
  '/next/manufacturers/line-card': typeof AuthenticatedNextManufacturersLineCardRoute
  '/next/negotiations/create': typeof AuthenticatedNextNegotiationsCreateRoute
  '/next/offer-imports/$offerImportId': typeof AuthenticatedNextOfferImportsOfferImportIdRoute
  '/next/orders/upload': typeof AuthenticatedNextOrdersUploadRoute
  '/next/orders/{-$orderId}': typeof AuthenticatedNextOrdersChar123OrderIdChar125Route
  '/next/parts/search': typeof AuthenticatedNextPartsSearchRoute
  '/next/projects/create': typeof AuthenticatedNextProjectsCreateRoute
  '/next/quote-requests/importer': typeof AuthenticatedNextQuoteRequestsImporterRoute
  '/next/risk-management/geo-risk': typeof AuthenticatedNextRiskManagementGeoRiskRoute
  '/next/risk-management/pcns': typeof AuthenticatedNextRiskManagementPcnsRoute
  '/next/risk-management/risk-digest': typeof AuthenticatedNextRiskManagementRiskDigestRoute
  '/next/settings/company': typeof AuthenticatedNextSettingsCompanyRoute
  '/next/suppliers/$supplierAndStockLocationId': typeof AuthenticatedNextSuppliersSupplierAndStockLocationIdRoute
  '/next/suppliers/strategy': typeof AuthenticatedNextSuppliersStrategyRoute
  '/next/templates/export': typeof AuthenticatedNextTemplatesExportRoute
  '/next/templates/pcb-specification': typeof AuthenticatedNextTemplatesPcbSpecificationRoute
  '/parts/alerts': typeof AuthenticatedPartsSidebarAlertsRoute
  '/parts/search': typeof AuthenticatedPartsSidebarSearchRoute
  '/parts/components/component-importer': typeof AuthenticatedPartsComponentsComponentImporterRoute
  '/parts/components/importer': typeof AuthenticatedPartsComponentsImporterRoute
  '/parts/components/linking': typeof AuthenticatedPartsComponentsLinkingRoute
  '/parts/demand/demand-importer': typeof AuthenticatedPartsDemandDemandImporterRoute
  '/parts/offers/add': typeof AuthenticatedPartsOffersAddRoute
  '/parts/offers/create': typeof AuthenticatedPartsOffersCreateRoute
  '/parts/offers/csv-importer': typeof AuthenticatedPartsOffersCsvImporterRoute
  '/parts/quote-requests/excel-importer': typeof AuthenticatedPartsQuoteRequestsExcelImporterRoute
  '/parts/quote-requests/importer': typeof AuthenticatedPartsQuoteRequestsImporterRoute
  '/projects/$projectId/dashboard': typeof AuthenticatedProjectsProjectIdDashboardRoute
  '/projects/$projectId/edit': typeof AuthenticatedProjectsProjectIdEditRoute
  '/projects/$projectId/quotation': typeof AuthenticatedProjectsProjectIdQuotationRoute
  '/risk-management/library-health/assemblies': typeof AuthenticatedRiskManagementLibraryHealthAssembliesRoute
  '/risk-management/library-health/components': typeof AuthenticatedRiskManagementLibraryHealthComponentsRoute
  '/risk-management/library-health/parts': typeof AuthenticatedRiskManagementLibraryHealthPartsRoute
  '/suppliers/strategy': typeof AuthenticatedSuppliersSidebarStrategyRoute
  '/suppliers/line-card-rules/importer': typeof AuthenticatedSuppliersLineCardRulesImporterRoute
  '/suppliers/supplier-contacts-importer/bulk': typeof AuthenticatedSuppliersSupplierContactsImporterBulkRoute
  '/suppliers/supplier-contacts/importer': typeof AuthenticatedSuppliersSupplierContactsImporterRoute
  '/templates/export': typeof AuthenticatedTemplatesSidebarExportRoute
  '/templates/pcb-specification': typeof AuthenticatedTemplatesSidebarPcbSpecificationRoute
  '/templates/calculation/add-template': typeof AuthenticatedTemplatesCalculationAddTemplateRoute
  '/templates/calculation/create': typeof AuthenticatedTemplatesCalculationCreateRoute
  '/templates/flexible-calculation/new': typeof AuthenticatedTemplatesFlexibleCalculationNewRoute
  '/templates/quotation/create': typeof AuthenticatedTemplatesQuotationCreateRoute
  '/templates/quotation/edit': typeof AuthenticatedTemplatesQuotationEditRoute
  '/assemblies/$assemblyId/': typeof AuthenticatedAssembliesAssemblyIdIndexRoute
  '/manufacturers/': typeof AuthenticatedManufacturersSidebarIndexRoute
  '/monitoring/': typeof AuthenticatedMonitoringSidebarIndexRoute
  '/negotiations/$negotiationId/': typeof AuthenticatedNegotiationsNegotiationIdIndexRoute
  '/next/assemblies/': typeof AuthenticatedNextAssembliesIndexRoute
  '/next/components/': typeof AuthenticatedNextComponentsIndexRoute
  '/next/customers/': typeof AuthenticatedNextCustomersIndexRoute
  '/next/demands/': typeof AuthenticatedNextDemandsIndexRoute
  '/next/manufacturers/': typeof AuthenticatedNextManufacturersIndexRoute
  '/next/negotiations/': typeof AuthenticatedNextNegotiationsIndexRoute
  '/next/offer-imports/': typeof AuthenticatedNextOfferImportsIndexRoute
  '/next/parts/': typeof AuthenticatedNextPartsIndexRoute
  '/next/projects/': typeof AuthenticatedNextProjectsIndexRoute
  '/next/quote-requests/': typeof AuthenticatedNextQuoteRequestsIndexRoute
  '/next/risk-management/': typeof AuthenticatedNextRiskManagementIndexRoute
  '/next/settings/': typeof AuthenticatedNextSettingsIndexRoute
  '/next/suppliers/': typeof AuthenticatedNextSuppliersIndexRoute
  '/projects/$projectId/': typeof AuthenticatedProjectsProjectIdIndexRoute
  '/risk-management/library-health/': typeof AuthenticatedRiskManagementLibraryHealthIndexRoute
  '/suppliers/': typeof AuthenticatedSuppliersSidebarIndexRoute
  '/next/assemblies/$assemblyId/pcb': typeof AuthenticatedNextAssembliesAssemblyIdPcbRouteRouteWithChildren
  '/next/components/ipn': typeof AuthenticatedNextComponentsIpnDetailsRouteRouteWithChildren
  '/next/negotiations/$negotiationId': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRouteWithChildren
  '/next/parts/custom/$customPartSpecificationId': typeof AuthenticatedNextPartsCustomCustomPartSpecificationIdRouteRouteWithChildren
  '/parts/components/ipn': typeof AuthenticatedPartsComponentsIpnDetailsRouteRouteWithChildren
  '/parts/custom/details/$customPartSpecificationId': typeof AuthenticatedPartsCustomDetailsCustomPartSpecificationIdRouteRouteWithChildren
  '/projects/$projectId/sourcing': typeof AuthenticatedProjectsProjectIdSourcingSidebarRouteRouteWithChildren
  '/assemblies/$assemblyId/pcb/cad-viewer': typeof AuthenticatedAssembliesAssemblyIdPcbCadViewerRoute
  '/assemblies/$assemblyId/pcb/dfm': typeof AuthenticatedAssembliesAssemblyIdPcbDfmRoute
  '/assemblies/$assemblyId/pcb/dfm-analysis': typeof AuthenticatedAssembliesAssemblyIdPcbDfmAnalysisRoute
  '/assemblies/$assemblyId/pcb/drills': typeof AuthenticatedAssembliesAssemblyIdPcbDrillsRoute
  '/assemblies/$assemblyId/pcb/files': typeof AuthenticatedAssembliesAssemblyIdPcbFilesRoute
  '/assemblies/$assemblyId/pcb/panelization': typeof AuthenticatedAssembliesAssemblyIdPcbPanelizationRoute
  '/assemblies/$assemblyId/pcb/specification': typeof AuthenticatedAssembliesAssemblyIdPcbSpecificationRoute
  '/assemblies/$assemblyId/pcb/stackup': typeof AuthenticatedAssembliesAssemblyIdPcbStackupRoute
  '/assemblies/$assemblyId/subassemblies/create': typeof AuthenticatedAssembliesAssemblyIdSubassembliesCreateRoute
  '/manufacturing/templates/{-$templateId}': typeof AuthenticatedManufacturingSidebarTemplatesChar123TemplateIdChar125Route
  '/manufacturing/activities/$activityId/duplicate': typeof AuthenticatedManufacturingActivitiesActivityIdDuplicateRoute
  '/manufacturing/activities/$activityId/edit': typeof AuthenticatedManufacturingActivitiesActivityIdEditRoute
  '/manufacturing/drivers/$driverId/duplicate': typeof AuthenticatedManufacturingDriversDriverIdDuplicateRoute
  '/manufacturing/drivers/$driverId/edit': typeof AuthenticatedManufacturingDriversDriverIdEditRoute
  '/manufacturing/expenses/$expenseId/duplicate': typeof AuthenticatedManufacturingExpensesExpenseIdDuplicateRoute
  '/manufacturing/expenses/$expenseId/edit': typeof AuthenticatedManufacturingExpensesExpenseIdEditRoute
  '/manufacturing/resources/$resourceId/duplicate': typeof AuthenticatedManufacturingResourcesResourceIdDuplicateRoute
  '/manufacturing/resources/$resourceId/edit': typeof AuthenticatedManufacturingResourcesResourceIdEditRoute
  '/monitoring/components/pricing': typeof AuthenticatedMonitoringSidebarComponentsPricingRoute
  '/monitoring/dashboards/$dashboardId': typeof AuthenticatedMonitoringSidebarDashboardsDashboardIdRoute
  '/monitoring/insights-agent/{-$conversationId}': typeof AuthenticatedMonitoringSidebarInsightsAgentChar123ConversationIdChar125Route
  '/monitoring/jobs/$jobId': typeof AuthenticatedMonitoringSidebarJobsJobIdRoute
  '/monitoring/reports/savings': typeof AuthenticatedMonitoringSidebarReportsSavingsRoute
  '/negotiations/$negotiationId/overview': typeof AuthenticatedNegotiationsNegotiationIdSidebarOverviewRoute
  '/next/assemblies/$assemblyId/dashboard': typeof AuthenticatedNextAssembliesAssemblyIdDashboardRoute
  '/next/assemblies/$assemblyId/details': typeof AuthenticatedNextAssembliesAssemblyIdDetailsRoute
  '/next/assemblies/$assemblyId/edit': typeof AuthenticatedNextAssembliesAssemblyIdEditRoute
  '/next/parts/$partId/compliance': typeof AuthenticatedNextPartsPartIdComplianceRoute
  '/next/parts/$partId/offers': typeof AuthenticatedNextPartsPartIdOffersRoute
  '/next/parts/$partId/part-alternatives': typeof AuthenticatedNextPartsPartIdPartAlternativesRoute
  '/next/parts/$partId/se-alternatives': typeof AuthenticatedNextPartsPartIdSeAlternativesRoute
  '/next/parts/$partId/se-documentation': typeof AuthenticatedNextPartsPartIdSeDocumentationRoute
  '/next/parts/$partId/se-geo-risk': typeof AuthenticatedNextPartsPartIdSeGeoRiskRoute
  '/next/parts/$partId/se-supply-chain': typeof AuthenticatedNextPartsPartIdSeSupplyChainRoute
  '/next/parts/$partId/se-technical': typeof AuthenticatedNextPartsPartIdSeTechnicalRoute
  '/next/parts/$partId/used-in': typeof AuthenticatedNextPartsPartIdUsedInRoute
  '/next/projects/$projectId/dashboard': typeof AuthenticatedNextProjectsProjectIdDashboardRoute
  '/next/projects/$projectId/edit': typeof AuthenticatedNextProjectsProjectIdEditRoute
  '/next/projects/$projectId/quotation': typeof AuthenticatedNextProjectsProjectIdQuotationRoute
  '/next/risk-management/library-health/assemblies': typeof AuthenticatedNextRiskManagementLibraryHealthAssembliesRoute
  '/next/risk-management/library-health/components': typeof AuthenticatedNextRiskManagementLibraryHealthComponentsRoute
  '/next/risk-management/library-health/parts': typeof AuthenticatedNextRiskManagementLibraryHealthPartsRoute
  '/next/templates/email/create': typeof AuthenticatedNextTemplatesEmailCreateRoute
  '/next/templates/flexible-calculation/$flexibleCalculationTemplateId': typeof AuthenticatedNextTemplatesFlexibleCalculationFlexibleCalculationTemplateIdRoute
  '/next/templates/flexible-calculation/create': typeof AuthenticatedNextTemplatesFlexibleCalculationCreateRoute
  '/next/templates/flexible-calculation/exported-variables': typeof AuthenticatedNextTemplatesFlexibleCalculationExportedVariablesRoute
  '/next/templates/quote-request/create': typeof AuthenticatedNextTemplatesQuoteRequestCreateRoute
  '/next/templates/sourcing/create': typeof AuthenticatedNextTemplatesSourcingCreateRoute
  '/parts/demands/importer': typeof AuthenticatedPartsSidebarDemandsImporterRoute
  '/parts/details/$partId/compliance': typeof AuthenticatedPartsDetailsPartIdComplianceRoute
  '/parts/details/$partId/offers': typeof AuthenticatedPartsDetailsPartIdOffersRoute
  '/parts/details/$partId/part-alternatives': typeof AuthenticatedPartsDetailsPartIdPartAlternativesRoute
  '/parts/details/$partId/se-alternatives': typeof AuthenticatedPartsDetailsPartIdSeAlternativesRoute
  '/parts/details/$partId/se-documentation': typeof AuthenticatedPartsDetailsPartIdSeDocumentationRoute
  '/parts/details/$partId/se-geo-risk': typeof AuthenticatedPartsDetailsPartIdSeGeoRiskRoute
  '/parts/details/$partId/se-supply-chain': typeof AuthenticatedPartsDetailsPartIdSeSupplyChainRoute
  '/parts/details/$partId/se-technical': typeof AuthenticatedPartsDetailsPartIdSeTechnicalRoute
  '/parts/details/$partId/used-in': typeof AuthenticatedPartsDetailsPartIdUsedInRoute
  '/parts/offers/$offerId/duplicate': typeof AuthenticatedPartsOffersOfferIdDuplicateRoute
  '/parts/offers/$offerId/edit': typeof AuthenticatedPartsOffersOfferIdEditRoute
  '/projects/$projectId/calculation/print': typeof AuthenticatedProjectsProjectIdCalculationPrintRoute
  '/projects/$projectId/flexible-calculation/$flexibleCalculationId': typeof AuthenticatedProjectsProjectIdFlexibleCalculationFlexibleCalculationIdRoute
  '/projects/$projectId/order/confirmation': typeof AuthenticatedProjectsProjectIdOrderConfirmationRoute
  '/projects/$projectId/sourcing/demand-groups': typeof AuthenticatedProjectsProjectIdSourcingDemandGroupsRoute
  '/settings/organization/api-integration': typeof AuthenticatedSettingsMenuOrganizationApiIntegrationRoute
  '/settings/organization/assembly-settings': typeof AuthenticatedSettingsMenuOrganizationAssemblySettingsRoute
  '/settings/organization/automatic-rfq-number': typeof AuthenticatedSettingsMenuOrganizationAutomaticRfqNumberRoute
  '/settings/organization/branding': typeof AuthenticatedSettingsMenuOrganizationBrandingRoute
  '/settings/organization/carbon-footprints': typeof AuthenticatedSettingsMenuOrganizationCarbonFootprintsRoute
  '/settings/organization/component-settings': typeof AuthenticatedSettingsMenuOrganizationComponentSettingsRoute
  '/settings/organization/csv-integration': typeof AuthenticatedSettingsMenuOrganizationCsvIntegrationRoute
  '/settings/organization/custom-part-categories': typeof AuthenticatedSettingsMenuOrganizationCustomPartCategoriesRoute
  '/settings/organization/data-integrations': typeof AuthenticatedSettingsMenuOrganizationDataIntegrationsRoute
  '/settings/organization/feature-flags': typeof AuthenticatedSettingsMenuOrganizationFeatureFlagsRoute
  '/settings/organization/manufacturer-preferences': typeof AuthenticatedSettingsMenuOrganizationManufacturerPreferencesRoute
  '/settings/organization/sites': typeof AuthenticatedSettingsMenuOrganizationSitesRoute
  '/settings/organization/supplier-api-integrations': typeof AuthenticatedSettingsMenuOrganizationSupplierApiIntegrationsRoute
  '/settings/user/account-security': typeof AuthenticatedSettingsMenuUserAccountSecurityRoute
  '/settings/organization/pcb/$panelPreferenceId': typeof AuthenticatedSettingsOrganizationPcbPanelPreferenceIdRoute
  '/settings/organization/pcb/add-preference': typeof AuthenticatedSettingsOrganizationPcbAddPreferenceRoute
  '/settings/organization/users/importer': typeof AuthenticatedSettingsOrganizationUsersImporterRoute
  '/supplier-portal/quote-requests/$quoteRequestId/excel-importer': typeof AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdExcelImporterRoute
  '/supplier-portal/quote-requests/$quoteRequestId/import-pdf': typeof AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdImportPdfRoute
  '/supplier-portal/quote-requests/$quoteRequestId/pdf-importer': typeof AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdPdfImporterRoute
  '/suppliers/$supplierId/supplier-contacts-importer/$': typeof AuthenticatedSuppliersSupplierIdSupplierContactsImporterSplatRoute
  '/suppliers/$supplierId/supplier-contacts/importer': typeof AuthenticatedSuppliersSupplierIdSupplierContactsImporterRoute
  '/templates/email/create': typeof AuthenticatedTemplatesSidebarEmailCreateRoute
  '/templates/flexible-calculation/$flexibleCalculationTemplateId': typeof AuthenticatedTemplatesSidebarFlexibleCalculationFlexibleCalculationTemplateIdRoute
  '/templates/flexible-calculation/create': typeof AuthenticatedTemplatesSidebarFlexibleCalculationCreateRoute
  '/templates/flexible-calculation/exported-variables': typeof AuthenticatedTemplatesSidebarFlexibleCalculationExportedVariablesRoute
  '/templates/quote-request/create': typeof AuthenticatedTemplatesSidebarQuoteRequestCreateRoute
  '/templates/sourcing/create': typeof AuthenticatedTemplatesSidebarSourcingCreateRoute
  '/templates/calculation/$templateId/edit': typeof AuthenticatedTemplatesCalculationTemplateIdEditRoute
  '/templates/email/$emailTemplateId/update': typeof AuthenticatedTemplatesEmailEmailTemplateIdUpdateRoute
  '/assemblies/$assemblyId/pcb/': typeof AuthenticatedAssembliesAssemblyIdPcbIndexRoute
  '/manufacturing/activities/': typeof AuthenticatedManufacturingSidebarActivitiesIndexRoute
  '/manufacturing/drivers/': typeof AuthenticatedManufacturingSidebarDriversIndexRoute
  '/manufacturing/expenses/': typeof AuthenticatedManufacturingSidebarExpensesIndexRoute
  '/manufacturing/resources/': typeof AuthenticatedManufacturingSidebarResourcesIndexRoute
  '/monitoring/charts/': typeof AuthenticatedMonitoringSidebarChartsIndexRoute
  '/monitoring/dashboards/': typeof AuthenticatedMonitoringSidebarDashboardsIndexRoute
  '/monitoring/jobs/': typeof AuthenticatedMonitoringSidebarJobsIndexRoute
  '/next/assemblies/$assemblyId/': typeof AuthenticatedNextAssembliesAssemblyIdIndexRoute
  '/next/negotiations/$negotiationId/': typeof AuthenticatedNextNegotiationsNegotiationIdIndexRoute
  '/next/parts/$partId/': typeof AuthenticatedNextPartsPartIdIndexRoute
  '/next/projects/$projectId/': typeof AuthenticatedNextProjectsProjectIdIndexRoute
  '/next/risk-management/library-health/': typeof AuthenticatedNextRiskManagementLibraryHealthIndexRoute
  '/next/suppliers/supplier-contacts/': typeof AuthenticatedNextSuppliersSupplierContactsIndexRoute
  '/next/templates/email/': typeof AuthenticatedNextTemplatesEmailIndexRoute
  '/next/templates/flexible-calculation/': typeof AuthenticatedNextTemplatesFlexibleCalculationIndexRoute
  '/next/templates/quotation/': typeof AuthenticatedNextTemplatesQuotationIndexRoute
  '/next/templates/quote-request/': typeof AuthenticatedNextTemplatesQuoteRequestIndexRoute
  '/next/templates/sourcing/': typeof AuthenticatedNextTemplatesSourcingIndexRoute
  '/parts/components/': typeof AuthenticatedPartsSidebarComponentsIndexRoute
  '/parts/demands/': typeof AuthenticatedPartsSidebarDemandsIndexRoute
  '/parts/quote-requests/': typeof AuthenticatedPartsSidebarQuoteRequestsIndexRoute
  '/parts/details/$partId/': typeof AuthenticatedPartsDetailsPartIdIndexRoute
  '/projects/$projectId/bom/': typeof AuthenticatedProjectsProjectIdBomIndexRoute
  '/projects/$projectId/calculation/': typeof AuthenticatedProjectsProjectIdCalculationIndexRoute
  '/projects/$projectId/flexible-calculation/': typeof AuthenticatedProjectsProjectIdFlexibleCalculationIndexRoute
  '/projects/$projectId/manufacturing/': typeof AuthenticatedProjectsProjectIdManufacturingIndexRoute
  '/projects/$projectId/order/': typeof AuthenticatedProjectsProjectIdOrderIndexRoute
  '/projects/$projectId/sourcing/': typeof AuthenticatedProjectsProjectIdSourcingIndexRoute
  '/settings/organization/': typeof AuthenticatedSettingsMenuOrganizationIndexRoute
  '/supplier-portal/quote-requests/$quoteRequestId/': typeof AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdIndexRoute
  '/suppliers/supplier-contacts/': typeof AuthenticatedSuppliersSidebarSupplierContactsIndexRoute
  '/templates/calculation/': typeof AuthenticatedTemplatesSidebarCalculationIndexRoute
  '/templates/email/': typeof AuthenticatedTemplatesSidebarEmailIndexRoute
  '/templates/flexible-calculation/': typeof AuthenticatedTemplatesSidebarFlexibleCalculationIndexRoute
  '/templates/quotation/': typeof AuthenticatedTemplatesSidebarQuotationIndexRoute
  '/templates/quote-request/': typeof AuthenticatedTemplatesSidebarQuoteRequestIndexRoute
  '/templates/sourcing/': typeof AuthenticatedTemplatesSidebarSourcingIndexRoute
  '/next/projects/$projectId/sourcing/overview': typeof AuthenticatedNextProjectsProjectIdSourcingOverviewRouteRouteWithChildren
  '/manufacturing/apps/$appId/$widgetId': typeof AuthenticatedManufacturingSidebarAppsAppIdWidgetIdRoute
  '/negotiations/$negotiationId/quote-requests/$quoteRequestId': typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsQuoteRequestIdRoute
  '/negotiations/$negotiationId/quote-requests/assign': typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsAssignRoute
  '/negotiations/$negotiationId/quote-requests/attachments': typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsAttachmentsRoute
  '/negotiations/$negotiationId/quote-requests/delivery-lot-size': typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsDeliveryLotSizeRoute
  '/negotiations/$negotiationId/quote-requests/excel-importer': typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsExcelImporterRoute
  '/negotiations/$negotiationId/quote-requests/importer': typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsImporterRoute
  '/negotiations/$negotiationId/quote-requests/line-items': typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsLineItemsRoute
  '/negotiations/$negotiationId/quote-requests/preview-email': typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsPreviewEmailRoute
  '/negotiations/$negotiationId/quote-requests/target-price': typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsTargetPriceRoute
  '/negotiations/$negotiationId/scenarios/compare': typeof AuthenticatedNegotiationsNegotiationIdSidebarScenariosCompareRoute
  '/negotiations/$negotiationId/scenarios/create': typeof AuthenticatedNegotiationsNegotiationIdSidebarScenariosCreateRoute
  '/next/assemblies/$assemblyId/pcb/cad-viewer': typeof AuthenticatedNextAssembliesAssemblyIdPcbCadViewerRoute
  '/next/assemblies/$assemblyId/pcb/dfm': typeof AuthenticatedNextAssembliesAssemblyIdPcbDfmRoute
  '/next/assemblies/$assemblyId/pcb/dfm-analysis': typeof AuthenticatedNextAssembliesAssemblyIdPcbDfmAnalysisRoute
  '/next/assemblies/$assemblyId/pcb/drills': typeof AuthenticatedNextAssembliesAssemblyIdPcbDrillsRoute
  '/next/assemblies/$assemblyId/pcb/files': typeof AuthenticatedNextAssembliesAssemblyIdPcbFilesRoute
  '/next/assemblies/$assemblyId/pcb/panelization': typeof AuthenticatedNextAssembliesAssemblyIdPcbPanelizationRoute
  '/next/assemblies/$assemblyId/pcb/specification': typeof AuthenticatedNextAssembliesAssemblyIdPcbSpecificationRoute
  '/next/assemblies/$assemblyId/pcb/stackup': typeof AuthenticatedNextAssembliesAssemblyIdPcbStackupRoute
  '/next/assemblies/$assemblyId/subassemblies/create': typeof AuthenticatedNextAssembliesAssemblyIdSubassembliesCreateRoute
  '/next/components/ipn/cpns': typeof AuthenticatedNextComponentsIpnDetailsCpnsRoute
  '/next/components/ipn/linking': typeof AuthenticatedNextComponentsIpnDetailsLinkingRoute
  '/next/components/ipn/used-in': typeof AuthenticatedNextComponentsIpnDetailsUsedInRoute
  '/next/negotiations/$negotiationId/overview': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarOverviewRoute
  '/next/parts/custom/$customPartSpecificationId/offers': typeof AuthenticatedNextPartsCustomCustomPartSpecificationIdOffersRoute
  '/next/parts/custom/$customPartSpecificationId/used-in': typeof AuthenticatedNextPartsCustomCustomPartSpecificationIdUsedInRoute
  '/next/parts/offers/$offerId/duplicate': typeof AuthenticatedNextPartsOffersOfferIdDuplicateRoute
  '/next/parts/offers/$offerId/edit': typeof AuthenticatedNextPartsOffersOfferIdEditRoute
  '/next/projects/$projectId/flexible-calculation/$flexibleCalculationId': typeof AuthenticatedNextProjectsProjectIdFlexibleCalculationFlexibleCalculationIdRoute
  '/next/projects/$projectId/sourcing/compare': typeof AuthenticatedNextProjectsProjectIdSourcingCompareRoute
  '/next/projects/$projectId/sourcing/version-history': typeof AuthenticatedNextProjectsProjectIdSourcingVersionHistoryRoute
  '/next/settings/organization/api-integration': typeof AuthenticatedNextSettingsMenuOrganizationApiIntegrationRoute
  '/next/settings/organization/assembly-settings': typeof AuthenticatedNextSettingsMenuOrganizationAssemblySettingsRoute
  '/next/settings/organization/automatic-rfq-number': typeof AuthenticatedNextSettingsMenuOrganizationAutomaticRfqNumberRoute
  '/next/settings/organization/branding': typeof AuthenticatedNextSettingsMenuOrganizationBrandingRoute
  '/next/settings/organization/carbon-footprints': typeof AuthenticatedNextSettingsMenuOrganizationCarbonFootprintsRoute
  '/next/settings/organization/component-settings': typeof AuthenticatedNextSettingsMenuOrganizationComponentSettingsRoute
  '/next/settings/organization/csv-integration': typeof AuthenticatedNextSettingsMenuOrganizationCsvIntegrationRoute
  '/next/settings/organization/custom-part-categories': typeof AuthenticatedNextSettingsMenuOrganizationCustomPartCategoriesRoute
  '/next/settings/organization/data-integrations': typeof AuthenticatedNextSettingsMenuOrganizationDataIntegrationsRoute
  '/next/settings/organization/feature-flags': typeof AuthenticatedNextSettingsMenuOrganizationFeatureFlagsRoute
  '/next/settings/organization/manufacturer-preferences': typeof AuthenticatedNextSettingsMenuOrganizationManufacturerPreferencesRoute
  '/next/settings/organization/sites': typeof AuthenticatedNextSettingsMenuOrganizationSitesRoute
  '/next/settings/organization/supplier-api-integrations': typeof AuthenticatedNextSettingsMenuOrganizationSupplierApiIntegrationsRoute
  '/next/settings/user/account-security': typeof AuthenticatedNextSettingsMenuUserAccountSecurityRoute
  '/next/settings/organization/users/importer': typeof AuthenticatedNextSettingsOrganizationUsersImporterRoute
  '/next/templates/email/$emailTemplateId/edit': typeof AuthenticatedNextTemplatesEmailEmailTemplateIdEditRoute
  '/next/templates/manufacturing/activities/create': typeof AuthenticatedNextTemplatesManufacturingActivitiesCreateRoute
  '/next/templates/manufacturing/drivers/create': typeof AuthenticatedNextTemplatesManufacturingDriversCreateRoute
  '/next/templates/manufacturing/expenses/create': typeof AuthenticatedNextTemplatesManufacturingExpensesCreateRoute
  '/next/templates/manufacturing/resources/create': typeof AuthenticatedNextTemplatesManufacturingResourcesCreateRoute
  '/next/templates/manufacturing/templates/{-$templateId}': typeof AuthenticatedNextTemplatesManufacturingTemplatesChar123TemplateIdChar125Route
  '/next/templates/quotation/builder/{-$templateId}': typeof AuthenticatedNextTemplatesQuotationBuilderChar123TemplateIdChar125Route
  '/next/templates/quote-request/$quoteRequestTemplateId/edit': typeof AuthenticatedNextTemplatesQuoteRequestQuoteRequestTemplateIdEditRoute
  '/next/templates/sourcing/$sourcingTemplateId/duplicate': typeof AuthenticatedNextTemplatesSourcingSourcingTemplateIdDuplicateRoute
  '/next/templates/sourcing/$sourcingTemplateId/edit': typeof AuthenticatedNextTemplatesSourcingSourcingTemplateIdEditRoute
  '/parts/components/ipn/cpns': typeof AuthenticatedPartsComponentsIpnDetailsCpnsRoute
  '/parts/components/ipn/linking': typeof AuthenticatedPartsComponentsIpnDetailsLinkingRoute
  '/parts/components/ipn/offers': typeof AuthenticatedPartsComponentsIpnDetailsOffersRoute
  '/parts/components/ipn/used-in': typeof AuthenticatedPartsComponentsIpnDetailsUsedInRoute
  '/parts/custom/details/$customPartSpecificationId/offers': typeof AuthenticatedPartsCustomDetailsCustomPartSpecificationIdOffersRoute
  '/parts/custom/details/$customPartSpecificationId/used-in': typeof AuthenticatedPartsCustomDetailsCustomPartSpecificationIdUsedInRoute
  '/projects/$projectId/bom/assembly/add-assembly': typeof AuthenticatedProjectsProjectIdBomAssemblyAddAssemblyRoute
  '/projects/$projectId/calculation/$assemblyId/calculation': typeof AuthenticatedProjectsProjectIdCalculationAssemblyIdCalculationRoute
  '/projects/$projectId/calculation/assemblies/$assemblyId': typeof AuthenticatedProjectsProjectIdCalculationAssembliesAssemblyIdRoute
  '/projects/$projectId/sourcing/compare': typeof AuthenticatedProjectsProjectIdSourcingSidebarCompareRoute
  '/projects/$projectId/sourcing/version-history': typeof AuthenticatedProjectsProjectIdSourcingSidebarVersionHistoryRoute
  '/projects/$projectId/sourcing/assembly/$assemblyId': typeof AuthenticatedProjectsProjectIdSourcingAssemblyAssemblyIdRoute
  '/settings/organization/customer-portal/additional-services': typeof AuthenticatedSettingsMenuOrganizationCustomerPortalAdditionalServicesRoute
  '/settings/organization/customer-portal/checkout-conditions': typeof AuthenticatedSettingsMenuOrganizationCustomerPortalCheckoutConditionsRoute
  '/settings/organization/customer-portal/customer-specific-settings': typeof AuthenticatedSettingsMenuOrganizationCustomerPortalCustomerSpecificSettingsRoute
  '/settings/organization/customer-portal/landing-page': typeof AuthenticatedSettingsMenuOrganizationCustomerPortalLandingPageRoute
  '/settings/organization/customer-portal/payment-credentials': typeof AuthenticatedSettingsMenuOrganizationCustomerPortalPaymentCredentialsRoute
  '/settings/organization/user-management/action-permissions': typeof AuthenticatedSettingsMenuOrganizationUserManagementActionPermissionsRoute
  '/settings/organization/user-management/roles': typeof AuthenticatedSettingsMenuOrganizationUserManagementRolesRoute
  '/templates/email/$emailTemplateId/edit': typeof AuthenticatedTemplatesSidebarEmailEmailTemplateIdEditRoute
  '/templates/quotation/builder/{-$templateId}': typeof AuthenticatedTemplatesSidebarQuotationBuilderChar123TemplateIdChar125Route
  '/templates/quote-request/$quoteRequestTemplateId/edit': typeof AuthenticatedTemplatesSidebarQuoteRequestQuoteRequestTemplateIdEditRoute
  '/templates/sourcing/$sourcingTemplateId/duplicate': typeof AuthenticatedTemplatesSidebarSourcingSourcingTemplateIdDuplicateRoute
  '/templates/sourcing/$sourcingTemplateId/edit': typeof AuthenticatedTemplatesSidebarSourcingSourcingTemplateIdEditRoute
  '/negotiations/$negotiationId/quote-requests/': typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsIndexRoute
  '/next/assemblies/$assemblyId/pcb/': typeof AuthenticatedNextAssembliesAssemblyIdPcbIndexRoute
  '/next/components/ipn/': typeof AuthenticatedNextComponentsIpnDetailsIndexRoute
  '/next/parts/custom/$customPartSpecificationId/': typeof AuthenticatedNextPartsCustomCustomPartSpecificationIdIndexRoute
  '/next/projects/$projectId/assemblies/': typeof AuthenticatedNextProjectsProjectIdAssembliesIndexRoute
  '/next/projects/$projectId/flexible-calculation/': typeof AuthenticatedNextProjectsProjectIdFlexibleCalculationIndexRoute
  '/next/projects/$projectId/manufacturing/': typeof AuthenticatedNextProjectsProjectIdManufacturingIndexRoute
  '/next/projects/$projectId/sourcing/': typeof AuthenticatedNextProjectsProjectIdSourcingIndexRoute
  '/next/settings/organization/': typeof AuthenticatedNextSettingsMenuOrganizationIndexRoute
  '/next/templates/manufacturing/activities/': typeof AuthenticatedNextTemplatesManufacturingActivitiesIndexRoute
  '/next/templates/manufacturing/drivers/': typeof AuthenticatedNextTemplatesManufacturingDriversIndexRoute
  '/next/templates/manufacturing/expenses/': typeof AuthenticatedNextTemplatesManufacturingExpensesIndexRoute
  '/next/templates/manufacturing/resources/': typeof AuthenticatedNextTemplatesManufacturingResourcesIndexRoute
  '/parts/components/ipn/': typeof AuthenticatedPartsComponentsIpnDetailsIndexRoute
  '/parts/custom/details/$customPartSpecificationId/': typeof AuthenticatedPartsCustomDetailsCustomPartSpecificationIdIndexRoute
  '/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/': typeof AuthenticatedProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdIndexRoute
  '/settings/organization/customer-portal/': typeof AuthenticatedSettingsMenuOrganizationCustomerPortalIndexRoute
  '/settings/organization/pcb/': typeof AuthenticatedSettingsMenuOrganizationPcbIndexRoute
  '/settings/organization/users/': typeof AuthenticatedSettingsMenuOrganizationUsersIndexRoute
  '/settings/organization/pcb/panel-preferences/': typeof AuthenticatedSettingsOrganizationPcbPanelPreferencesIndexRoute
  '/next/projects/$projectId/assemblies/$assemblyId/pcb': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRouteWithChildren
  '/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId': typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdRouteRouteWithChildren
  '/projects/$projectId/bom/assembly/$assemblyId/pcb': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRouteWithChildren
  '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId': typeof AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarRouteRouteWithChildren
  '/monitoring/components/categories/$categoryId/pricing': typeof AuthenticatedMonitoringSidebarComponentsCategoriesCategoryIdPricingRoute
  '/negotiations/$negotiationId/demand-groups/$demandGroupId/awarding': typeof AuthenticatedNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdAwardingRoute
  '/negotiations/$negotiationId/scenarios/$sourcingScenarioId/line/$sourcingLineItemId': typeof AuthenticatedNegotiationsNegotiationIdScenariosSourcingScenarioIdLineSourcingLineItemIdRoute
  '/next/components/ipn/offers/$offerId/duplicate': typeof AuthenticatedNextComponentsIpnOffersOfferIdDuplicateRoute
  '/next/components/ipn/offers/$offerId/edit': typeof AuthenticatedNextComponentsIpnOffersOfferIdEditRoute
  '/next/negotiations/$negotiationId/quote-requests/$quoteRequestId': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsQuoteRequestIdRoute
  '/next/negotiations/$negotiationId/quote-requests/assign': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsAssignRoute
  '/next/negotiations/$negotiationId/quote-requests/attachments': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsAttachmentsRoute
  '/next/negotiations/$negotiationId/quote-requests/delivery-lot-size': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsDeliveryLotSizeRoute
  '/next/negotiations/$negotiationId/quote-requests/importer': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsImporterRoute
  '/next/negotiations/$negotiationId/quote-requests/line-items': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsLineItemsRoute
  '/next/negotiations/$negotiationId/quote-requests/preview-email': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsPreviewEmailRoute
  '/next/negotiations/$negotiationId/quote-requests/target-price': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsTargetPriceRoute
  '/next/negotiations/$negotiationId/scenarios/compare': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosCompareRoute
  '/next/negotiations/$negotiationId/scenarios/create': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosCreateRoute
  '/next/projects/$projectId/assemblies/$assemblyId/details': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdDetailsRoute
  '/next/projects/$projectId/assemblies/$assemblyId/edit': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdEditRoute
  '/next/projects/$projectId/assemblies/$assemblyId/pnp-importer': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPnpImporterRoute
  '/next/projects/$projectId/sourcing/assembly/$assemblyId': typeof AuthenticatedNextProjectsProjectIdSourcingAssemblyAssemblyIdRoute
  '/next/projects/$projectId/sourcing/overview/$view': typeof AuthenticatedNextProjectsProjectIdSourcingOverviewViewRoute
  '/next/projects/$projectId/sourcing/quote-requests/$quoteRequestId': typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsQuoteRequestIdRoute
  '/next/projects/$projectId/sourcing/quote-requests/assign': typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsAssignRoute
  '/next/projects/$projectId/sourcing/quote-requests/attachments': typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsAttachmentsRoute
  '/next/projects/$projectId/sourcing/quote-requests/delivery-lot-size': typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsDeliveryLotSizeRoute
  '/next/projects/$projectId/sourcing/quote-requests/importer': typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsImporterRoute
  '/next/projects/$projectId/sourcing/quote-requests/line-items': typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsLineItemsRoute
  '/next/projects/$projectId/sourcing/quote-requests/preview-email': typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsPreviewEmailRoute
  '/next/projects/$projectId/sourcing/quote-requests/target-price': typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsTargetPriceRoute
  '/next/projects/$projectId/sourcing/scenarios/create': typeof AuthenticatedNextProjectsProjectIdSourcingScenariosCreateRoute
  '/next/settings/organization/customer-portal/additional-services': typeof AuthenticatedNextSettingsMenuOrganizationCustomerPortalAdditionalServicesRoute
  '/next/settings/organization/customer-portal/checkout-conditions': typeof AuthenticatedNextSettingsMenuOrganizationCustomerPortalCheckoutConditionsRoute
  '/next/settings/organization/customer-portal/customer-specific-settings': typeof AuthenticatedNextSettingsMenuOrganizationCustomerPortalCustomerSpecificSettingsRoute
  '/next/settings/organization/customer-portal/landing-page': typeof AuthenticatedNextSettingsMenuOrganizationCustomerPortalLandingPageRoute
  '/next/settings/organization/customer-portal/payment-credentials': typeof AuthenticatedNextSettingsMenuOrganizationCustomerPortalPaymentCredentialsRoute
  '/next/settings/organization/user-management/action-permissions': typeof AuthenticatedNextSettingsMenuOrganizationUserManagementActionPermissionsRoute
  '/next/settings/organization/user-management/roles': typeof AuthenticatedNextSettingsMenuOrganizationUserManagementRolesRoute
  '/next/templates/flexible-calculation/apps/$appId/$widgetId': typeof AuthenticatedNextTemplatesFlexibleCalculationAppsAppIdWidgetIdRoute
  '/next/templates/flexible-calculation/review-conversion/$legacyTemplateId/$flexibleCalculationTemplateId': typeof AuthenticatedNextTemplatesFlexibleCalculationReviewConversionLegacyTemplateIdFlexibleCalculationTemplateIdRoute
  '/next/templates/manufacturing/activities/$activityId/duplicate': typeof AuthenticatedNextTemplatesManufacturingActivitiesActivityIdDuplicateRoute
  '/next/templates/manufacturing/activities/$activityId/edit': typeof AuthenticatedNextTemplatesManufacturingActivitiesActivityIdEditRoute
  '/next/templates/manufacturing/apps/$appId/$widgetId': typeof AuthenticatedNextTemplatesManufacturingAppsAppIdWidgetIdRoute
  '/next/templates/manufacturing/drivers/$driverId/duplicate': typeof AuthenticatedNextTemplatesManufacturingDriversDriverIdDuplicateRoute
  '/next/templates/manufacturing/drivers/$driverId/edit': typeof AuthenticatedNextTemplatesManufacturingDriversDriverIdEditRoute
  '/next/templates/manufacturing/expenses/$expenseId/duplicate': typeof AuthenticatedNextTemplatesManufacturingExpensesExpenseIdDuplicateRoute
  '/next/templates/manufacturing/expenses/$expenseId/edit': typeof AuthenticatedNextTemplatesManufacturingExpensesExpenseIdEditRoute
  '/next/templates/manufacturing/resources/$resourceId/duplicate': typeof AuthenticatedNextTemplatesManufacturingResourcesResourceIdDuplicateRoute
  '/next/templates/manufacturing/resources/$resourceId/edit': typeof AuthenticatedNextTemplatesManufacturingResourcesResourceIdEditRoute
  '/parts/components/ipn/offers/$offerId/duplicate': typeof AuthenticatedPartsComponentsIpnOffersOfferIdDuplicateRoute
  '/parts/components/ipn/offers/$offerId/edit': typeof AuthenticatedPartsComponentsIpnOffersOfferIdEditRoute
  '/projects/$projectId/bom/assembly/$assemblyId/details': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdDetailsRoute
  '/projects/$projectId/bom/assembly/$assemblyId/edit': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdEditRoute
  '/projects/$projectId/bom/assembly/$assemblyId/pnp-importer': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPnpImporterRoute
  '/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/activity': typeof AuthenticatedProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdActivityRoute
  '/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/expense': typeof AuthenticatedProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdExpenseRoute
  '/projects/$projectId/sourcing/$sourcingScenarioId/line/$sourcingLineItemId': typeof AuthenticatedProjectsProjectIdSourcingSourcingScenarioIdLineSourcingLineItemIdRoute
  '/projects/$projectId/sourcing/overview/$view': typeof AuthenticatedProjectsProjectIdSourcingSidebarOverviewViewRoute
  '/projects/$projectId/sourcing/quote-requests/$quoteRequestId': typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsQuoteRequestIdRoute
  '/projects/$projectId/sourcing/quote-requests/assign': typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsAssignRoute
  '/projects/$projectId/sourcing/quote-requests/attachments': typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsAttachmentsRoute
  '/projects/$projectId/sourcing/quote-requests/delivery-lot-size': typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsDeliveryLotSizeRoute
  '/projects/$projectId/sourcing/quote-requests/excel-importer': typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsExcelImporterRoute
  '/projects/$projectId/sourcing/quote-requests/importer': typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsImporterRoute
  '/projects/$projectId/sourcing/quote-requests/line-items': typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsLineItemsRoute
  '/projects/$projectId/sourcing/quote-requests/preview-email': typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsPreviewEmailRoute
  '/projects/$projectId/sourcing/quote-requests/target-price': typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsTargetPriceRoute
  '/projects/$projectId/sourcing/scenarios/create': typeof AuthenticatedProjectsProjectIdSourcingSidebarScenariosCreateRoute
  '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/purchase-orders': typeof AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdPurchaseOrdersRoute
  '/settings/organization/pcb/panel-preferences/create': typeof AuthenticatedSettingsMenuOrganizationPcbPanelPreferencesCreateRoute
  '/templates/flexible-calculation/apps/$appId/$widgetId': typeof AuthenticatedTemplatesSidebarFlexibleCalculationAppsAppIdWidgetIdRoute
  '/templates/flexible-calculation/review-conversion/$legacyTemplateId/$flexibleCalculationTemplateId': typeof AuthenticatedTemplatesSidebarFlexibleCalculationReviewConversionLegacyTemplateIdFlexibleCalculationTemplateIdRoute
  '/negotiations/$negotiationId/demand-groups/$demandGroupId/': typeof AuthenticatedNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdIndexRoute
  '/negotiations/$negotiationId/scenarios/$sourcingScenarioId/': typeof AuthenticatedNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdIndexRoute
  '/next/components/ipn/offers/': typeof AuthenticatedNextComponentsIpnDetailsOffersIndexRoute
  '/next/negotiations/$negotiationId/quote-requests/': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsIndexRoute
  '/next/projects/$projectId/assemblies/$assemblyId/': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdIndexRoute
  '/next/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/': typeof AuthenticatedNextProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdIndexRoute
  '/next/projects/$projectId/sourcing/overview/': typeof AuthenticatedNextProjectsProjectIdSourcingOverviewIndexRoute
  '/next/projects/$projectId/sourcing/quote-requests/': typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsIndexRoute
  '/next/settings/organization/customer-portal/': typeof AuthenticatedNextSettingsMenuOrganizationCustomerPortalIndexRoute
  '/next/settings/organization/pcb/': typeof AuthenticatedNextSettingsMenuOrganizationPcbIndexRoute
  '/next/settings/organization/users/': typeof AuthenticatedNextSettingsMenuOrganizationUsersIndexRoute
  '/next/settings/organization/pcb/panel-preferences/': typeof AuthenticatedNextSettingsOrganizationPcbPanelPreferencesIndexRoute
  '/projects/$projectId/bom/assembly/$assemblyId/': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdIndexRoute
  '/projects/$projectId/sourcing/overview/': typeof AuthenticatedProjectsProjectIdSourcingSidebarOverviewIndexRoute
  '/projects/$projectId/sourcing/quote-requests/': typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsIndexRoute
  '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/': typeof AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdIndexRoute
  '/next/negotiations/$negotiationId/demand-groups/$demandGroupId/awarding': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdAwardingRoute
  '/next/negotiations/$negotiationId/scenarios/$sourcingScenarioId/line-items/$sourcingLineItemId': typeof AuthenticatedNextNegotiationsNegotiationIdScenariosSourcingScenarioIdLineItemsSourcingLineItemIdRoute
  '/next/projects/$projectId/assemblies/$assemblyId/pcb/cad-viewer': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbCadViewerRoute
  '/next/projects/$projectId/assemblies/$assemblyId/pcb/dfm': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbDfmRoute
  '/next/projects/$projectId/assemblies/$assemblyId/pcb/dfm-analysis': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbDfmAnalysisRoute
  '/next/projects/$projectId/assemblies/$assemblyId/pcb/drills': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbDrillsRoute
  '/next/projects/$projectId/assemblies/$assemblyId/pcb/files': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbFilesRoute
  '/next/projects/$projectId/assemblies/$assemblyId/pcb/panelization': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbPanelizationRoute
  '/next/projects/$projectId/assemblies/$assemblyId/pcb/specification': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbSpecificationRoute
  '/next/projects/$projectId/assemblies/$assemblyId/pcb/stackup': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbStackupRoute
  '/next/projects/$projectId/assemblies/$assemblyId/subassemblies/create': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdSubassembliesCreateRoute
  '/next/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/activity': typeof AuthenticatedNextProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdActivityRoute
  '/next/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/expense': typeof AuthenticatedNextProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdExpenseRoute
  '/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/purchase-orders': typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdPurchaseOrdersRoute
  '/next/settings/organization/pcb/panel-preferences/create': typeof AuthenticatedNextSettingsMenuOrganizationPcbPanelPreferencesCreateRoute
  '/projects/$projectId/bom/assembly/$assemblyId/pcb/cad-viewer': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbCadViewerRoute
  '/projects/$projectId/bom/assembly/$assemblyId/pcb/dfm': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbDfmRoute
  '/projects/$projectId/bom/assembly/$assemblyId/pcb/dfm-analysis': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbDfmAnalysisRoute
  '/projects/$projectId/bom/assembly/$assemblyId/pcb/drills': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbDrillsRoute
  '/projects/$projectId/bom/assembly/$assemblyId/pcb/files': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbFilesRoute
  '/projects/$projectId/bom/assembly/$assemblyId/pcb/panelization': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbPanelizationRoute
  '/projects/$projectId/bom/assembly/$assemblyId/pcb/specification': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbSpecificationRoute
  '/projects/$projectId/bom/assembly/$assemblyId/pcb/stackup': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbStackupRoute
  '/projects/$projectId/bom/assembly/$assemblyId/subassemblies/create': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdSubassembliesCreateRoute
  '/projects/$projectId/sourcing/offer/custom-part/$offerId/duplicate': typeof AuthenticatedProjectsProjectIdSourcingOfferCustomPartOfferIdDuplicateRoute
  '/projects/$projectId/sourcing/offer/custom-part/$offerId/edit': typeof AuthenticatedProjectsProjectIdSourcingOfferCustomPartOfferIdEditRoute
  '/projects/$projectId/sourcing/offer/internal-part-number/$offerId/duplicate': typeof AuthenticatedProjectsProjectIdSourcingOfferInternalPartNumberOfferIdDuplicateRoute
  '/projects/$projectId/sourcing/offer/internal-part-number/$offerId/edit': typeof AuthenticatedProjectsProjectIdSourcingOfferInternalPartNumberOfferIdEditRoute
  '/projects/$projectId/sourcing/offer/off-the-shelf/$offerId/duplicate': typeof AuthenticatedProjectsProjectIdSourcingOfferOffTheShelfOfferIdDuplicateRoute
  '/projects/$projectId/sourcing/offer/off-the-shelf/$offerId/edit': typeof AuthenticatedProjectsProjectIdSourcingOfferOffTheShelfOfferIdEditRoute
  '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/line-items': typeof AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarLineItemsRoute
  '/settings/organization/pcb/panel-preferences/$panelPreferenceId/edit': typeof AuthenticatedSettingsMenuOrganizationPcbPanelPreferencesPanelPreferenceIdEditRoute
  '/negotiations/$negotiationId/scenarios/$sourcingScenarioId/cost-breakdown/': typeof AuthenticatedNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownIndexRoute
  '/next/negotiations/$negotiationId/demand-groups/$demandGroupId/': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdIndexRoute
  '/next/negotiations/$negotiationId/scenarios/$sourcingScenarioId/': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdIndexRoute
  '/next/projects/$projectId/assemblies/$assemblyId/pcb/': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbIndexRoute
  '/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/': typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdIndexRoute
  '/projects/$projectId/bom/assembly/$assemblyId/pcb/': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbIndexRoute
  '/next/projects/$projectId/sourcing/offers/custom-part/$offerId/duplicate': typeof AuthenticatedNextProjectsProjectIdSourcingOffersCustomPartOfferIdDuplicateRoute
  '/next/projects/$projectId/sourcing/offers/custom-part/$offerId/edit': typeof AuthenticatedNextProjectsProjectIdSourcingOffersCustomPartOfferIdEditRoute
  '/next/projects/$projectId/sourcing/offers/internal-part-number/$offerId/duplicate': typeof AuthenticatedNextProjectsProjectIdSourcingOffersInternalPartNumberOfferIdDuplicateRoute
  '/next/projects/$projectId/sourcing/offers/internal-part-number/$offerId/edit': typeof AuthenticatedNextProjectsProjectIdSourcingOffersInternalPartNumberOfferIdEditRoute
  '/next/projects/$projectId/sourcing/offers/off-the-shelf/$offerId/duplicate': typeof AuthenticatedNextProjectsProjectIdSourcingOffersOffTheShelfOfferIdDuplicateRoute
  '/next/projects/$projectId/sourcing/offers/off-the-shelf/$offerId/edit': typeof AuthenticatedNextProjectsProjectIdSourcingOffersOffTheShelfOfferIdEditRoute
  '/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/line-items/$sourcingLineItemId': typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdLineItemsSourcingLineItemIdRoute
  '/next/settings/organization/pcb/panel-preferences/$panelPreferenceId/edit': typeof AuthenticatedNextSettingsMenuOrganizationPcbPanelPreferencesPanelPreferenceIdEditRoute
  '/next/negotiations/$negotiationId/scenarios/$sourcingScenarioId/cost-breakdown/': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownIndexRoute
  '/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/cost-breakdown/': typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdCostBreakdownIndexRoute
  '/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/line-items/': typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdLineItemsIndexRoute
  '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/cost-breakdown/': typeof AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarCostBreakdownIndexRoute
  '/negotiations/$negotiationId/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId': typeof AuthenticatedNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownAssemblyAssemblyIdDemandDemandIdRoute
  '/next/negotiations/$negotiationId/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownAssemblyAssemblyIdDemandDemandIdRoute
  '/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId': typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdCostBreakdownAssemblyAssemblyIdDemandDemandIdRoute
  '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId': typeof AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarCostBreakdownAssemblyAssemblyIdDemandDemandIdRoute
}
export interface FileRoutesByTo {
  '/callback': typeof CallbackRoute
  '/landing': typeof LandingRoute
  '/monitoring': typeof AuthenticatedMonitoringSidebarIndexRoute
  '/$': typeof AuthenticatedSplatRoute
  '/home': typeof AuthenticatedHomeRoute
  '/project_creation': typeof AuthenticatedProject_creationRoute
  '/purchase-orders': typeof AuthenticatedPurchaseOrdersRoute
  '/rfqs': typeof AuthenticatedRfqsRoute
  '/start': typeof AuthenticatedStartRoute
  '/auth/enter-email': typeof AuthEnterEmailRoute
  '/': typeof AuthenticatedIndexRoute
  '/manufacturing': typeof AuthenticatedManufacturingIndexRoute
  '/parts': typeof AuthenticatedPartsIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/templates': typeof AuthenticatedTemplatesIndexRoute
  '/apps/$': typeof AuthenticatedAppsSplatRoute
  '/assemblies/add-assembly': typeof AuthenticatedAssembliesAddAssemblyRoute
  '/components/import': typeof AuthenticatedComponentsImportRoute
  '/customers/$customerId': typeof AuthenticatedCustomersCustomerIdRoute
  '/customers/importer': typeof AuthenticatedCustomersImporterRoute
  '/manufacturer/$': typeof AuthenticatedManufacturerSplatRoute
  '/manufacturers/$manufacturerId': typeof AuthenticatedManufacturersManufacturerIdRoute
  '/manufacturers/importer': typeof AuthenticatedManufacturersImporterRoute
  '/manufacturing/add-activity': typeof AuthenticatedManufacturingAddActivityRoute
  '/manufacturing/add-driver': typeof AuthenticatedManufacturingAddDriverRoute
  '/manufacturing/add-expense': typeof AuthenticatedManufacturingAddExpenseRoute
  '/manufacturing/add-resource': typeof AuthenticatedManufacturingAddResourceRoute
  '/monitoring/analysis': typeof AuthenticatedMonitoringAnalysisRoute
  '/negotiations/create': typeof AuthenticatedNegotiationsCreateRoute
  '/next/$': typeof AuthenticatedNextSplatRoute
  '/next/alerts': typeof AuthenticatedNextAlertsRoute
  '/next/home': typeof AuthenticatedNextHomeRoute
  '/next/lumi-agent': typeof AuthenticatedNextLumiAgentRoute
  '/next/purchase-orders': typeof AuthenticatedNextPurchaseOrdersRoute
  '/offers/mpn-offer-importer': typeof AuthenticatedOffersMpnOfferImporterRoute
  '/orders/upload': typeof AuthenticatedOrdersUploadRoute
  '/orders/{-$orderId}': typeof AuthenticatedOrdersChar123OrderIdChar125Route
  '/parts/off-the-shelf-part-search': typeof AuthenticatedPartsOffTheShelfPartSearchRoute
  '/projects/create': typeof AuthenticatedProjectsCreateRoute
  '/projects/new': typeof AuthenticatedProjectsNewRoute
  '/quote-requests/excel-importer': typeof AuthenticatedQuoteRequestsExcelImporterRoute
  '/risk-management/geo-risk': typeof AuthenticatedRiskManagementGeoRiskRoute
  '/risk-management/pcns': typeof AuthenticatedRiskManagementPcnsRoute
  '/risk-management/risk-digest': typeof AuthenticatedRiskManagementRiskDigestRoute
  '/settings/company': typeof AuthenticatedSettingsCompanyRoute
  '/supplier/importer': typeof AuthenticatedSupplierImporterRoute
  '/suppliers/$supplierAndStockLocationId': typeof AuthenticatedSuppliersSupplierAndStockLocationIdRoute
  '/suppliers/importer': typeof AuthenticatedSuppliersImporterRoute
  '/template/$': typeof AuthenticatedTemplateSplatRoute
  '/auth/signup/customer': typeof AuthSignupCustomerRoute
  '/auth/signup/invite': typeof AuthSignupInviteRoute
  '/assemblies': typeof AuthenticatedAssembliesIndexRoute
  '/customer-portal': typeof AuthenticatedCustomerPortalIndexRoute
  '/customers': typeof AuthenticatedCustomersIndexRoute
  '/negotiations': typeof AuthenticatedNegotiationsIndexRoute
  '/next': typeof AuthenticatedNextIndexRoute
  '/projects': typeof AuthenticatedProjectsIndexRoute
  '/risk-management': typeof AuthenticatedRiskManagementIndexRoute
  '/supplier-portal': typeof AuthenticatedSupplierPortalIndexRoute
  '/negotiations/$negotiationId': typeof AuthenticatedNegotiationsNegotiationIdIndexRoute
  '/next/settings': typeof AuthenticatedNextSettingsIndexRoute
  '/3rdparty/digikey/callback': typeof Authenticated3rdpartyDigikeyCallbackRoute
  '/assemblies/$assemblyId/dashboard': typeof AuthenticatedAssembliesAssemblyIdDashboardRoute
  '/assemblies/$assemblyId/details': typeof AuthenticatedAssembliesAssemblyIdDetailsRoute
  '/assemblies/$assemblyId/edit': typeof AuthenticatedAssembliesAssemblyIdEditRoute
  '/manufacturers/line-card': typeof AuthenticatedManufacturersSidebarLineCardRoute
  '/manufacturing/activities/create': typeof AuthenticatedManufacturingActivitiesCreateRoute
  '/manufacturing/activity/$': typeof AuthenticatedManufacturingActivitySplatRoute
  '/manufacturing/driver/$': typeof AuthenticatedManufacturingDriverSplatRoute
  '/manufacturing/drivers/create': typeof AuthenticatedManufacturingDriversCreateRoute
  '/manufacturing/expense/$': typeof AuthenticatedManufacturingExpenseSplatRoute
  '/manufacturing/expenses/create': typeof AuthenticatedManufacturingExpensesCreateRoute
  '/manufacturing/resource/$': typeof AuthenticatedManufacturingResourceSplatRoute
  '/manufacturing/resources/create': typeof AuthenticatedManufacturingResourcesCreateRoute
  '/manufacturing/template/$': typeof AuthenticatedManufacturingTemplateSplatRoute
  '/monitoring/component-savings': typeof AuthenticatedMonitoringSidebarComponentSavingsRoute
  '/monitoring/data-health': typeof AuthenticatedMonitoringSidebarDataHealthRoute
  '/monitoring/offers': typeof AuthenticatedMonitoringSidebarOffersRoute
  '/monitoring/onboarding': typeof AuthenticatedMonitoringSidebarOnboardingRoute
  '/monitoring/agent/$': typeof AuthenticatedMonitoringAgentSplatRoute
  '/monitoring/charts/$chartId': typeof AuthenticatedMonitoringChartsChartIdRoute
  '/next/apps/$': typeof AuthenticatedNextAppsSplatRoute
  '/next/components/linking': typeof AuthenticatedNextComponentsLinkingRoute
  '/next/customers/$customerId': typeof AuthenticatedNextCustomersCustomerIdRoute
  '/next/demands/importer': typeof AuthenticatedNextDemandsImporterRoute
  '/next/manufacturers/$manufacturerId': typeof AuthenticatedNextManufacturersManufacturerIdRoute
  '/next/manufacturers/line-card': typeof AuthenticatedNextManufacturersLineCardRoute
  '/next/negotiations/create': typeof AuthenticatedNextNegotiationsCreateRoute
  '/next/offer-imports/$offerImportId': typeof AuthenticatedNextOfferImportsOfferImportIdRoute
  '/next/orders/upload': typeof AuthenticatedNextOrdersUploadRoute
  '/next/orders/{-$orderId}': typeof AuthenticatedNextOrdersChar123OrderIdChar125Route
  '/next/parts/search': typeof AuthenticatedNextPartsSearchRoute
  '/next/projects/create': typeof AuthenticatedNextProjectsCreateRoute
  '/next/quote-requests/importer': typeof AuthenticatedNextQuoteRequestsImporterRoute
  '/next/risk-management/geo-risk': typeof AuthenticatedNextRiskManagementGeoRiskRoute
  '/next/risk-management/pcns': typeof AuthenticatedNextRiskManagementPcnsRoute
  '/next/risk-management/risk-digest': typeof AuthenticatedNextRiskManagementRiskDigestRoute
  '/next/settings/company': typeof AuthenticatedNextSettingsCompanyRoute
  '/next/suppliers/$supplierAndStockLocationId': typeof AuthenticatedNextSuppliersSupplierAndStockLocationIdRoute
  '/next/suppliers/strategy': typeof AuthenticatedNextSuppliersStrategyRoute
  '/next/templates/export': typeof AuthenticatedNextTemplatesExportRoute
  '/next/templates/pcb-specification': typeof AuthenticatedNextTemplatesPcbSpecificationRoute
  '/parts/alerts': typeof AuthenticatedPartsSidebarAlertsRoute
  '/parts/search': typeof AuthenticatedPartsSidebarSearchRoute
  '/parts/components/component-importer': typeof AuthenticatedPartsComponentsComponentImporterRoute
  '/parts/components/importer': typeof AuthenticatedPartsComponentsImporterRoute
  '/parts/components/linking': typeof AuthenticatedPartsComponentsLinkingRoute
  '/parts/demand/demand-importer': typeof AuthenticatedPartsDemandDemandImporterRoute
  '/parts/offers/add': typeof AuthenticatedPartsOffersAddRoute
  '/parts/offers/create': typeof AuthenticatedPartsOffersCreateRoute
  '/parts/offers/csv-importer': typeof AuthenticatedPartsOffersCsvImporterRoute
  '/parts/quote-requests/excel-importer': typeof AuthenticatedPartsQuoteRequestsExcelImporterRoute
  '/parts/quote-requests/importer': typeof AuthenticatedPartsQuoteRequestsImporterRoute
  '/projects/$projectId/dashboard': typeof AuthenticatedProjectsProjectIdDashboardRoute
  '/projects/$projectId/edit': typeof AuthenticatedProjectsProjectIdEditRoute
  '/projects/$projectId/quotation': typeof AuthenticatedProjectsProjectIdQuotationRoute
  '/risk-management/library-health/assemblies': typeof AuthenticatedRiskManagementLibraryHealthAssembliesRoute
  '/risk-management/library-health/components': typeof AuthenticatedRiskManagementLibraryHealthComponentsRoute
  '/risk-management/library-health/parts': typeof AuthenticatedRiskManagementLibraryHealthPartsRoute
  '/suppliers/strategy': typeof AuthenticatedSuppliersSidebarStrategyRoute
  '/suppliers/line-card-rules/importer': typeof AuthenticatedSuppliersLineCardRulesImporterRoute
  '/suppliers/supplier-contacts-importer/bulk': typeof AuthenticatedSuppliersSupplierContactsImporterBulkRoute
  '/suppliers/supplier-contacts/importer': typeof AuthenticatedSuppliersSupplierContactsImporterRoute
  '/templates/export': typeof AuthenticatedTemplatesSidebarExportRoute
  '/templates/pcb-specification': typeof AuthenticatedTemplatesSidebarPcbSpecificationRoute
  '/templates/calculation/add-template': typeof AuthenticatedTemplatesCalculationAddTemplateRoute
  '/templates/calculation/create': typeof AuthenticatedTemplatesCalculationCreateRoute
  '/templates/flexible-calculation/new': typeof AuthenticatedTemplatesFlexibleCalculationNewRoute
  '/templates/quotation/create': typeof AuthenticatedTemplatesQuotationCreateRoute
  '/templates/quotation/edit': typeof AuthenticatedTemplatesQuotationEditRoute
  '/assemblies/$assemblyId': typeof AuthenticatedAssembliesAssemblyIdIndexRoute
  '/manufacturers': typeof AuthenticatedManufacturersSidebarIndexRoute
  '/next/assemblies': typeof AuthenticatedNextAssembliesIndexRoute
  '/next/components': typeof AuthenticatedNextComponentsIndexRoute
  '/next/customers': typeof AuthenticatedNextCustomersIndexRoute
  '/next/demands': typeof AuthenticatedNextDemandsIndexRoute
  '/next/manufacturers': typeof AuthenticatedNextManufacturersIndexRoute
  '/next/negotiations': typeof AuthenticatedNextNegotiationsIndexRoute
  '/next/offer-imports': typeof AuthenticatedNextOfferImportsIndexRoute
  '/next/parts': typeof AuthenticatedNextPartsIndexRoute
  '/next/projects': typeof AuthenticatedNextProjectsIndexRoute
  '/next/quote-requests': typeof AuthenticatedNextQuoteRequestsIndexRoute
  '/next/risk-management': typeof AuthenticatedNextRiskManagementIndexRoute
  '/next/suppliers': typeof AuthenticatedNextSuppliersIndexRoute
  '/projects/$projectId': typeof AuthenticatedProjectsProjectIdIndexRoute
  '/risk-management/library-health': typeof AuthenticatedRiskManagementLibraryHealthIndexRoute
  '/suppliers': typeof AuthenticatedSuppliersSidebarIndexRoute
  '/next/negotiations/$negotiationId': typeof AuthenticatedNextNegotiationsNegotiationIdIndexRoute
  '/projects/$projectId/sourcing': typeof AuthenticatedProjectsProjectIdSourcingIndexRoute
  '/assemblies/$assemblyId/pcb/cad-viewer': typeof AuthenticatedAssembliesAssemblyIdPcbCadViewerRoute
  '/assemblies/$assemblyId/pcb/dfm': typeof AuthenticatedAssembliesAssemblyIdPcbDfmRoute
  '/assemblies/$assemblyId/pcb/dfm-analysis': typeof AuthenticatedAssembliesAssemblyIdPcbDfmAnalysisRoute
  '/assemblies/$assemblyId/pcb/drills': typeof AuthenticatedAssembliesAssemblyIdPcbDrillsRoute
  '/assemblies/$assemblyId/pcb/files': typeof AuthenticatedAssembliesAssemblyIdPcbFilesRoute
  '/assemblies/$assemblyId/pcb/panelization': typeof AuthenticatedAssembliesAssemblyIdPcbPanelizationRoute
  '/assemblies/$assemblyId/pcb/specification': typeof AuthenticatedAssembliesAssemblyIdPcbSpecificationRoute
  '/assemblies/$assemblyId/pcb/stackup': typeof AuthenticatedAssembliesAssemblyIdPcbStackupRoute
  '/assemblies/$assemblyId/subassemblies/create': typeof AuthenticatedAssembliesAssemblyIdSubassembliesCreateRoute
  '/manufacturing/templates/{-$templateId}': typeof AuthenticatedManufacturingSidebarTemplatesChar123TemplateIdChar125Route
  '/manufacturing/activities/$activityId/duplicate': typeof AuthenticatedManufacturingActivitiesActivityIdDuplicateRoute
  '/manufacturing/activities/$activityId/edit': typeof AuthenticatedManufacturingActivitiesActivityIdEditRoute
  '/manufacturing/drivers/$driverId/duplicate': typeof AuthenticatedManufacturingDriversDriverIdDuplicateRoute
  '/manufacturing/drivers/$driverId/edit': typeof AuthenticatedManufacturingDriversDriverIdEditRoute
  '/manufacturing/expenses/$expenseId/duplicate': typeof AuthenticatedManufacturingExpensesExpenseIdDuplicateRoute
  '/manufacturing/expenses/$expenseId/edit': typeof AuthenticatedManufacturingExpensesExpenseIdEditRoute
  '/manufacturing/resources/$resourceId/duplicate': typeof AuthenticatedManufacturingResourcesResourceIdDuplicateRoute
  '/manufacturing/resources/$resourceId/edit': typeof AuthenticatedManufacturingResourcesResourceIdEditRoute
  '/monitoring/components/pricing': typeof AuthenticatedMonitoringSidebarComponentsPricingRoute
  '/monitoring/dashboards/$dashboardId': typeof AuthenticatedMonitoringSidebarDashboardsDashboardIdRoute
  '/monitoring/insights-agent/{-$conversationId}': typeof AuthenticatedMonitoringSidebarInsightsAgentChar123ConversationIdChar125Route
  '/monitoring/jobs/$jobId': typeof AuthenticatedMonitoringSidebarJobsJobIdRoute
  '/monitoring/reports/savings': typeof AuthenticatedMonitoringSidebarReportsSavingsRoute
  '/negotiations/$negotiationId/overview': typeof AuthenticatedNegotiationsNegotiationIdSidebarOverviewRoute
  '/next/assemblies/$assemblyId/dashboard': typeof AuthenticatedNextAssembliesAssemblyIdDashboardRoute
  '/next/assemblies/$assemblyId/details': typeof AuthenticatedNextAssembliesAssemblyIdDetailsRoute
  '/next/assemblies/$assemblyId/edit': typeof AuthenticatedNextAssembliesAssemblyIdEditRoute
  '/next/parts/$partId/compliance': typeof AuthenticatedNextPartsPartIdComplianceRoute
  '/next/parts/$partId/offers': typeof AuthenticatedNextPartsPartIdOffersRoute
  '/next/parts/$partId/part-alternatives': typeof AuthenticatedNextPartsPartIdPartAlternativesRoute
  '/next/parts/$partId/se-alternatives': typeof AuthenticatedNextPartsPartIdSeAlternativesRoute
  '/next/parts/$partId/se-documentation': typeof AuthenticatedNextPartsPartIdSeDocumentationRoute
  '/next/parts/$partId/se-geo-risk': typeof AuthenticatedNextPartsPartIdSeGeoRiskRoute
  '/next/parts/$partId/se-supply-chain': typeof AuthenticatedNextPartsPartIdSeSupplyChainRoute
  '/next/parts/$partId/se-technical': typeof AuthenticatedNextPartsPartIdSeTechnicalRoute
  '/next/parts/$partId/used-in': typeof AuthenticatedNextPartsPartIdUsedInRoute
  '/next/projects/$projectId/dashboard': typeof AuthenticatedNextProjectsProjectIdDashboardRoute
  '/next/projects/$projectId/edit': typeof AuthenticatedNextProjectsProjectIdEditRoute
  '/next/projects/$projectId/quotation': typeof AuthenticatedNextProjectsProjectIdQuotationRoute
  '/next/risk-management/library-health/assemblies': typeof AuthenticatedNextRiskManagementLibraryHealthAssembliesRoute
  '/next/risk-management/library-health/components': typeof AuthenticatedNextRiskManagementLibraryHealthComponentsRoute
  '/next/risk-management/library-health/parts': typeof AuthenticatedNextRiskManagementLibraryHealthPartsRoute
  '/next/templates/email/create': typeof AuthenticatedNextTemplatesEmailCreateRoute
  '/next/templates/flexible-calculation/$flexibleCalculationTemplateId': typeof AuthenticatedNextTemplatesFlexibleCalculationFlexibleCalculationTemplateIdRoute
  '/next/templates/flexible-calculation/create': typeof AuthenticatedNextTemplatesFlexibleCalculationCreateRoute
  '/next/templates/flexible-calculation/exported-variables': typeof AuthenticatedNextTemplatesFlexibleCalculationExportedVariablesRoute
  '/next/templates/quote-request/create': typeof AuthenticatedNextTemplatesQuoteRequestCreateRoute
  '/next/templates/sourcing/create': typeof AuthenticatedNextTemplatesSourcingCreateRoute
  '/parts/demands/importer': typeof AuthenticatedPartsSidebarDemandsImporterRoute
  '/parts/details/$partId/compliance': typeof AuthenticatedPartsDetailsPartIdComplianceRoute
  '/parts/details/$partId/offers': typeof AuthenticatedPartsDetailsPartIdOffersRoute
  '/parts/details/$partId/part-alternatives': typeof AuthenticatedPartsDetailsPartIdPartAlternativesRoute
  '/parts/details/$partId/se-alternatives': typeof AuthenticatedPartsDetailsPartIdSeAlternativesRoute
  '/parts/details/$partId/se-documentation': typeof AuthenticatedPartsDetailsPartIdSeDocumentationRoute
  '/parts/details/$partId/se-geo-risk': typeof AuthenticatedPartsDetailsPartIdSeGeoRiskRoute
  '/parts/details/$partId/se-supply-chain': typeof AuthenticatedPartsDetailsPartIdSeSupplyChainRoute
  '/parts/details/$partId/se-technical': typeof AuthenticatedPartsDetailsPartIdSeTechnicalRoute
  '/parts/details/$partId/used-in': typeof AuthenticatedPartsDetailsPartIdUsedInRoute
  '/parts/offers/$offerId/duplicate': typeof AuthenticatedPartsOffersOfferIdDuplicateRoute
  '/parts/offers/$offerId/edit': typeof AuthenticatedPartsOffersOfferIdEditRoute
  '/projects/$projectId/calculation/print': typeof AuthenticatedProjectsProjectIdCalculationPrintRoute
  '/projects/$projectId/flexible-calculation/$flexibleCalculationId': typeof AuthenticatedProjectsProjectIdFlexibleCalculationFlexibleCalculationIdRoute
  '/projects/$projectId/order/confirmation': typeof AuthenticatedProjectsProjectIdOrderConfirmationRoute
  '/projects/$projectId/sourcing/demand-groups': typeof AuthenticatedProjectsProjectIdSourcingDemandGroupsRoute
  '/settings/organization/api-integration': typeof AuthenticatedSettingsMenuOrganizationApiIntegrationRoute
  '/settings/organization/assembly-settings': typeof AuthenticatedSettingsMenuOrganizationAssemblySettingsRoute
  '/settings/organization/automatic-rfq-number': typeof AuthenticatedSettingsMenuOrganizationAutomaticRfqNumberRoute
  '/settings/organization/branding': typeof AuthenticatedSettingsMenuOrganizationBrandingRoute
  '/settings/organization/carbon-footprints': typeof AuthenticatedSettingsMenuOrganizationCarbonFootprintsRoute
  '/settings/organization/component-settings': typeof AuthenticatedSettingsMenuOrganizationComponentSettingsRoute
  '/settings/organization/csv-integration': typeof AuthenticatedSettingsMenuOrganizationCsvIntegrationRoute
  '/settings/organization/custom-part-categories': typeof AuthenticatedSettingsMenuOrganizationCustomPartCategoriesRoute
  '/settings/organization/data-integrations': typeof AuthenticatedSettingsMenuOrganizationDataIntegrationsRoute
  '/settings/organization/feature-flags': typeof AuthenticatedSettingsMenuOrganizationFeatureFlagsRoute
  '/settings/organization/manufacturer-preferences': typeof AuthenticatedSettingsMenuOrganizationManufacturerPreferencesRoute
  '/settings/organization/sites': typeof AuthenticatedSettingsMenuOrganizationSitesRoute
  '/settings/organization/supplier-api-integrations': typeof AuthenticatedSettingsMenuOrganizationSupplierApiIntegrationsRoute
  '/settings/user/account-security': typeof AuthenticatedSettingsMenuUserAccountSecurityRoute
  '/settings/organization/pcb/$panelPreferenceId': typeof AuthenticatedSettingsOrganizationPcbPanelPreferenceIdRoute
  '/settings/organization/pcb/add-preference': typeof AuthenticatedSettingsOrganizationPcbAddPreferenceRoute
  '/settings/organization/users/importer': typeof AuthenticatedSettingsOrganizationUsersImporterRoute
  '/supplier-portal/quote-requests/$quoteRequestId/excel-importer': typeof AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdExcelImporterRoute
  '/supplier-portal/quote-requests/$quoteRequestId/import-pdf': typeof AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdImportPdfRoute
  '/supplier-portal/quote-requests/$quoteRequestId/pdf-importer': typeof AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdPdfImporterRoute
  '/suppliers/$supplierId/supplier-contacts-importer/$': typeof AuthenticatedSuppliersSupplierIdSupplierContactsImporterSplatRoute
  '/suppliers/$supplierId/supplier-contacts/importer': typeof AuthenticatedSuppliersSupplierIdSupplierContactsImporterRoute
  '/templates/email/create': typeof AuthenticatedTemplatesSidebarEmailCreateRoute
  '/templates/flexible-calculation/$flexibleCalculationTemplateId': typeof AuthenticatedTemplatesSidebarFlexibleCalculationFlexibleCalculationTemplateIdRoute
  '/templates/flexible-calculation/create': typeof AuthenticatedTemplatesSidebarFlexibleCalculationCreateRoute
  '/templates/flexible-calculation/exported-variables': typeof AuthenticatedTemplatesSidebarFlexibleCalculationExportedVariablesRoute
  '/templates/quote-request/create': typeof AuthenticatedTemplatesSidebarQuoteRequestCreateRoute
  '/templates/sourcing/create': typeof AuthenticatedTemplatesSidebarSourcingCreateRoute
  '/templates/calculation/$templateId/edit': typeof AuthenticatedTemplatesCalculationTemplateIdEditRoute
  '/templates/email/$emailTemplateId/update': typeof AuthenticatedTemplatesEmailEmailTemplateIdUpdateRoute
  '/assemblies/$assemblyId/pcb': typeof AuthenticatedAssembliesAssemblyIdPcbIndexRoute
  '/manufacturing/activities': typeof AuthenticatedManufacturingSidebarActivitiesIndexRoute
  '/manufacturing/drivers': typeof AuthenticatedManufacturingSidebarDriversIndexRoute
  '/manufacturing/expenses': typeof AuthenticatedManufacturingSidebarExpensesIndexRoute
  '/manufacturing/resources': typeof AuthenticatedManufacturingSidebarResourcesIndexRoute
  '/monitoring/charts': typeof AuthenticatedMonitoringSidebarChartsIndexRoute
  '/monitoring/dashboards': typeof AuthenticatedMonitoringSidebarDashboardsIndexRoute
  '/monitoring/jobs': typeof AuthenticatedMonitoringSidebarJobsIndexRoute
  '/next/assemblies/$assemblyId': typeof AuthenticatedNextAssembliesAssemblyIdIndexRoute
  '/next/parts/$partId': typeof AuthenticatedNextPartsPartIdIndexRoute
  '/next/projects/$projectId': typeof AuthenticatedNextProjectsProjectIdIndexRoute
  '/next/risk-management/library-health': typeof AuthenticatedNextRiskManagementLibraryHealthIndexRoute
  '/next/suppliers/supplier-contacts': typeof AuthenticatedNextSuppliersSupplierContactsIndexRoute
  '/next/templates/email': typeof AuthenticatedNextTemplatesEmailIndexRoute
  '/next/templates/flexible-calculation': typeof AuthenticatedNextTemplatesFlexibleCalculationIndexRoute
  '/next/templates/quotation': typeof AuthenticatedNextTemplatesQuotationIndexRoute
  '/next/templates/quote-request': typeof AuthenticatedNextTemplatesQuoteRequestIndexRoute
  '/next/templates/sourcing': typeof AuthenticatedNextTemplatesSourcingIndexRoute
  '/parts/components': typeof AuthenticatedPartsSidebarComponentsIndexRoute
  '/parts/demands': typeof AuthenticatedPartsSidebarDemandsIndexRoute
  '/parts/quote-requests': typeof AuthenticatedPartsSidebarQuoteRequestsIndexRoute
  '/parts/details/$partId': typeof AuthenticatedPartsDetailsPartIdIndexRoute
  '/projects/$projectId/bom': typeof AuthenticatedProjectsProjectIdBomIndexRoute
  '/projects/$projectId/calculation': typeof AuthenticatedProjectsProjectIdCalculationIndexRoute
  '/projects/$projectId/flexible-calculation': typeof AuthenticatedProjectsProjectIdFlexibleCalculationIndexRoute
  '/projects/$projectId/manufacturing': typeof AuthenticatedProjectsProjectIdManufacturingIndexRoute
  '/projects/$projectId/order': typeof AuthenticatedProjectsProjectIdOrderIndexRoute
  '/settings/organization': typeof AuthenticatedSettingsMenuOrganizationIndexRoute
  '/supplier-portal/quote-requests/$quoteRequestId': typeof AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdIndexRoute
  '/suppliers/supplier-contacts': typeof AuthenticatedSuppliersSidebarSupplierContactsIndexRoute
  '/templates/calculation': typeof AuthenticatedTemplatesSidebarCalculationIndexRoute
  '/templates/email': typeof AuthenticatedTemplatesSidebarEmailIndexRoute
  '/templates/flexible-calculation': typeof AuthenticatedTemplatesSidebarFlexibleCalculationIndexRoute
  '/templates/quotation': typeof AuthenticatedTemplatesSidebarQuotationIndexRoute
  '/templates/quote-request': typeof AuthenticatedTemplatesSidebarQuoteRequestIndexRoute
  '/templates/sourcing': typeof AuthenticatedTemplatesSidebarSourcingIndexRoute
  '/manufacturing/apps/$appId/$widgetId': typeof AuthenticatedManufacturingSidebarAppsAppIdWidgetIdRoute
  '/negotiations/$negotiationId/quote-requests/$quoteRequestId': typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsQuoteRequestIdRoute
  '/negotiations/$negotiationId/quote-requests/assign': typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsAssignRoute
  '/negotiations/$negotiationId/quote-requests/attachments': typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsAttachmentsRoute
  '/negotiations/$negotiationId/quote-requests/delivery-lot-size': typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsDeliveryLotSizeRoute
  '/negotiations/$negotiationId/quote-requests/excel-importer': typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsExcelImporterRoute
  '/negotiations/$negotiationId/quote-requests/importer': typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsImporterRoute
  '/negotiations/$negotiationId/quote-requests/line-items': typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsLineItemsRoute
  '/negotiations/$negotiationId/quote-requests/preview-email': typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsPreviewEmailRoute
  '/negotiations/$negotiationId/quote-requests/target-price': typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsTargetPriceRoute
  '/negotiations/$negotiationId/scenarios/compare': typeof AuthenticatedNegotiationsNegotiationIdSidebarScenariosCompareRoute
  '/negotiations/$negotiationId/scenarios/create': typeof AuthenticatedNegotiationsNegotiationIdSidebarScenariosCreateRoute
  '/next/assemblies/$assemblyId/pcb/cad-viewer': typeof AuthenticatedNextAssembliesAssemblyIdPcbCadViewerRoute
  '/next/assemblies/$assemblyId/pcb/dfm': typeof AuthenticatedNextAssembliesAssemblyIdPcbDfmRoute
  '/next/assemblies/$assemblyId/pcb/dfm-analysis': typeof AuthenticatedNextAssembliesAssemblyIdPcbDfmAnalysisRoute
  '/next/assemblies/$assemblyId/pcb/drills': typeof AuthenticatedNextAssembliesAssemblyIdPcbDrillsRoute
  '/next/assemblies/$assemblyId/pcb/files': typeof AuthenticatedNextAssembliesAssemblyIdPcbFilesRoute
  '/next/assemblies/$assemblyId/pcb/panelization': typeof AuthenticatedNextAssembliesAssemblyIdPcbPanelizationRoute
  '/next/assemblies/$assemblyId/pcb/specification': typeof AuthenticatedNextAssembliesAssemblyIdPcbSpecificationRoute
  '/next/assemblies/$assemblyId/pcb/stackup': typeof AuthenticatedNextAssembliesAssemblyIdPcbStackupRoute
  '/next/assemblies/$assemblyId/subassemblies/create': typeof AuthenticatedNextAssembliesAssemblyIdSubassembliesCreateRoute
  '/next/components/ipn/cpns': typeof AuthenticatedNextComponentsIpnDetailsCpnsRoute
  '/next/components/ipn/linking': typeof AuthenticatedNextComponentsIpnDetailsLinkingRoute
  '/next/components/ipn/used-in': typeof AuthenticatedNextComponentsIpnDetailsUsedInRoute
  '/next/negotiations/$negotiationId/overview': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarOverviewRoute
  '/next/parts/custom/$customPartSpecificationId/offers': typeof AuthenticatedNextPartsCustomCustomPartSpecificationIdOffersRoute
  '/next/parts/custom/$customPartSpecificationId/used-in': typeof AuthenticatedNextPartsCustomCustomPartSpecificationIdUsedInRoute
  '/next/parts/offers/$offerId/duplicate': typeof AuthenticatedNextPartsOffersOfferIdDuplicateRoute
  '/next/parts/offers/$offerId/edit': typeof AuthenticatedNextPartsOffersOfferIdEditRoute
  '/next/projects/$projectId/flexible-calculation/$flexibleCalculationId': typeof AuthenticatedNextProjectsProjectIdFlexibleCalculationFlexibleCalculationIdRoute
  '/next/projects/$projectId/sourcing/compare': typeof AuthenticatedNextProjectsProjectIdSourcingCompareRoute
  '/next/projects/$projectId/sourcing/version-history': typeof AuthenticatedNextProjectsProjectIdSourcingVersionHistoryRoute
  '/next/settings/organization/api-integration': typeof AuthenticatedNextSettingsMenuOrganizationApiIntegrationRoute
  '/next/settings/organization/assembly-settings': typeof AuthenticatedNextSettingsMenuOrganizationAssemblySettingsRoute
  '/next/settings/organization/automatic-rfq-number': typeof AuthenticatedNextSettingsMenuOrganizationAutomaticRfqNumberRoute
  '/next/settings/organization/branding': typeof AuthenticatedNextSettingsMenuOrganizationBrandingRoute
  '/next/settings/organization/carbon-footprints': typeof AuthenticatedNextSettingsMenuOrganizationCarbonFootprintsRoute
  '/next/settings/organization/component-settings': typeof AuthenticatedNextSettingsMenuOrganizationComponentSettingsRoute
  '/next/settings/organization/csv-integration': typeof AuthenticatedNextSettingsMenuOrganizationCsvIntegrationRoute
  '/next/settings/organization/custom-part-categories': typeof AuthenticatedNextSettingsMenuOrganizationCustomPartCategoriesRoute
  '/next/settings/organization/data-integrations': typeof AuthenticatedNextSettingsMenuOrganizationDataIntegrationsRoute
  '/next/settings/organization/feature-flags': typeof AuthenticatedNextSettingsMenuOrganizationFeatureFlagsRoute
  '/next/settings/organization/manufacturer-preferences': typeof AuthenticatedNextSettingsMenuOrganizationManufacturerPreferencesRoute
  '/next/settings/organization/sites': typeof AuthenticatedNextSettingsMenuOrganizationSitesRoute
  '/next/settings/organization/supplier-api-integrations': typeof AuthenticatedNextSettingsMenuOrganizationSupplierApiIntegrationsRoute
  '/next/settings/user/account-security': typeof AuthenticatedNextSettingsMenuUserAccountSecurityRoute
  '/next/settings/organization/users/importer': typeof AuthenticatedNextSettingsOrganizationUsersImporterRoute
  '/next/templates/email/$emailTemplateId/edit': typeof AuthenticatedNextTemplatesEmailEmailTemplateIdEditRoute
  '/next/templates/manufacturing/activities/create': typeof AuthenticatedNextTemplatesManufacturingActivitiesCreateRoute
  '/next/templates/manufacturing/drivers/create': typeof AuthenticatedNextTemplatesManufacturingDriversCreateRoute
  '/next/templates/manufacturing/expenses/create': typeof AuthenticatedNextTemplatesManufacturingExpensesCreateRoute
  '/next/templates/manufacturing/resources/create': typeof AuthenticatedNextTemplatesManufacturingResourcesCreateRoute
  '/next/templates/manufacturing/templates/{-$templateId}': typeof AuthenticatedNextTemplatesManufacturingTemplatesChar123TemplateIdChar125Route
  '/next/templates/quotation/builder/{-$templateId}': typeof AuthenticatedNextTemplatesQuotationBuilderChar123TemplateIdChar125Route
  '/next/templates/quote-request/$quoteRequestTemplateId/edit': typeof AuthenticatedNextTemplatesQuoteRequestQuoteRequestTemplateIdEditRoute
  '/next/templates/sourcing/$sourcingTemplateId/duplicate': typeof AuthenticatedNextTemplatesSourcingSourcingTemplateIdDuplicateRoute
  '/next/templates/sourcing/$sourcingTemplateId/edit': typeof AuthenticatedNextTemplatesSourcingSourcingTemplateIdEditRoute
  '/parts/components/ipn/cpns': typeof AuthenticatedPartsComponentsIpnDetailsCpnsRoute
  '/parts/components/ipn/linking': typeof AuthenticatedPartsComponentsIpnDetailsLinkingRoute
  '/parts/components/ipn/offers': typeof AuthenticatedPartsComponentsIpnDetailsOffersRoute
  '/parts/components/ipn/used-in': typeof AuthenticatedPartsComponentsIpnDetailsUsedInRoute
  '/parts/custom/details/$customPartSpecificationId/offers': typeof AuthenticatedPartsCustomDetailsCustomPartSpecificationIdOffersRoute
  '/parts/custom/details/$customPartSpecificationId/used-in': typeof AuthenticatedPartsCustomDetailsCustomPartSpecificationIdUsedInRoute
  '/projects/$projectId/bom/assembly/add-assembly': typeof AuthenticatedProjectsProjectIdBomAssemblyAddAssemblyRoute
  '/projects/$projectId/calculation/$assemblyId/calculation': typeof AuthenticatedProjectsProjectIdCalculationAssemblyIdCalculationRoute
  '/projects/$projectId/calculation/assemblies/$assemblyId': typeof AuthenticatedProjectsProjectIdCalculationAssembliesAssemblyIdRoute
  '/projects/$projectId/sourcing/compare': typeof AuthenticatedProjectsProjectIdSourcingSidebarCompareRoute
  '/projects/$projectId/sourcing/version-history': typeof AuthenticatedProjectsProjectIdSourcingSidebarVersionHistoryRoute
  '/projects/$projectId/sourcing/assembly/$assemblyId': typeof AuthenticatedProjectsProjectIdSourcingAssemblyAssemblyIdRoute
  '/settings/organization/customer-portal/additional-services': typeof AuthenticatedSettingsMenuOrganizationCustomerPortalAdditionalServicesRoute
  '/settings/organization/customer-portal/checkout-conditions': typeof AuthenticatedSettingsMenuOrganizationCustomerPortalCheckoutConditionsRoute
  '/settings/organization/customer-portal/customer-specific-settings': typeof AuthenticatedSettingsMenuOrganizationCustomerPortalCustomerSpecificSettingsRoute
  '/settings/organization/customer-portal/landing-page': typeof AuthenticatedSettingsMenuOrganizationCustomerPortalLandingPageRoute
  '/settings/organization/customer-portal/payment-credentials': typeof AuthenticatedSettingsMenuOrganizationCustomerPortalPaymentCredentialsRoute
  '/settings/organization/user-management/action-permissions': typeof AuthenticatedSettingsMenuOrganizationUserManagementActionPermissionsRoute
  '/settings/organization/user-management/roles': typeof AuthenticatedSettingsMenuOrganizationUserManagementRolesRoute
  '/templates/email/$emailTemplateId/edit': typeof AuthenticatedTemplatesSidebarEmailEmailTemplateIdEditRoute
  '/templates/quotation/builder/{-$templateId}': typeof AuthenticatedTemplatesSidebarQuotationBuilderChar123TemplateIdChar125Route
  '/templates/quote-request/$quoteRequestTemplateId/edit': typeof AuthenticatedTemplatesSidebarQuoteRequestQuoteRequestTemplateIdEditRoute
  '/templates/sourcing/$sourcingTemplateId/duplicate': typeof AuthenticatedTemplatesSidebarSourcingSourcingTemplateIdDuplicateRoute
  '/templates/sourcing/$sourcingTemplateId/edit': typeof AuthenticatedTemplatesSidebarSourcingSourcingTemplateIdEditRoute
  '/negotiations/$negotiationId/quote-requests': typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsIndexRoute
  '/next/assemblies/$assemblyId/pcb': typeof AuthenticatedNextAssembliesAssemblyIdPcbIndexRoute
  '/next/components/ipn': typeof AuthenticatedNextComponentsIpnDetailsIndexRoute
  '/next/parts/custom/$customPartSpecificationId': typeof AuthenticatedNextPartsCustomCustomPartSpecificationIdIndexRoute
  '/next/projects/$projectId/assemblies': typeof AuthenticatedNextProjectsProjectIdAssembliesIndexRoute
  '/next/projects/$projectId/flexible-calculation': typeof AuthenticatedNextProjectsProjectIdFlexibleCalculationIndexRoute
  '/next/projects/$projectId/manufacturing': typeof AuthenticatedNextProjectsProjectIdManufacturingIndexRoute
  '/next/projects/$projectId/sourcing': typeof AuthenticatedNextProjectsProjectIdSourcingIndexRoute
  '/next/settings/organization': typeof AuthenticatedNextSettingsMenuOrganizationIndexRoute
  '/next/templates/manufacturing/activities': typeof AuthenticatedNextTemplatesManufacturingActivitiesIndexRoute
  '/next/templates/manufacturing/drivers': typeof AuthenticatedNextTemplatesManufacturingDriversIndexRoute
  '/next/templates/manufacturing/expenses': typeof AuthenticatedNextTemplatesManufacturingExpensesIndexRoute
  '/next/templates/manufacturing/resources': typeof AuthenticatedNextTemplatesManufacturingResourcesIndexRoute
  '/parts/components/ipn': typeof AuthenticatedPartsComponentsIpnDetailsIndexRoute
  '/parts/custom/details/$customPartSpecificationId': typeof AuthenticatedPartsCustomDetailsCustomPartSpecificationIdIndexRoute
  '/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId': typeof AuthenticatedProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdIndexRoute
  '/settings/organization/customer-portal': typeof AuthenticatedSettingsMenuOrganizationCustomerPortalIndexRoute
  '/settings/organization/pcb': typeof AuthenticatedSettingsMenuOrganizationPcbIndexRoute
  '/settings/organization/users': typeof AuthenticatedSettingsMenuOrganizationUsersIndexRoute
  '/settings/organization/pcb/panel-preferences': typeof AuthenticatedSettingsOrganizationPcbPanelPreferencesIndexRoute
  '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId': typeof AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdIndexRoute
  '/monitoring/components/categories/$categoryId/pricing': typeof AuthenticatedMonitoringSidebarComponentsCategoriesCategoryIdPricingRoute
  '/negotiations/$negotiationId/demand-groups/$demandGroupId/awarding': typeof AuthenticatedNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdAwardingRoute
  '/negotiations/$negotiationId/scenarios/$sourcingScenarioId/line/$sourcingLineItemId': typeof AuthenticatedNegotiationsNegotiationIdScenariosSourcingScenarioIdLineSourcingLineItemIdRoute
  '/next/components/ipn/offers/$offerId/duplicate': typeof AuthenticatedNextComponentsIpnOffersOfferIdDuplicateRoute
  '/next/components/ipn/offers/$offerId/edit': typeof AuthenticatedNextComponentsIpnOffersOfferIdEditRoute
  '/next/negotiations/$negotiationId/quote-requests/$quoteRequestId': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsQuoteRequestIdRoute
  '/next/negotiations/$negotiationId/quote-requests/assign': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsAssignRoute
  '/next/negotiations/$negotiationId/quote-requests/attachments': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsAttachmentsRoute
  '/next/negotiations/$negotiationId/quote-requests/delivery-lot-size': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsDeliveryLotSizeRoute
  '/next/negotiations/$negotiationId/quote-requests/importer': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsImporterRoute
  '/next/negotiations/$negotiationId/quote-requests/line-items': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsLineItemsRoute
  '/next/negotiations/$negotiationId/quote-requests/preview-email': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsPreviewEmailRoute
  '/next/negotiations/$negotiationId/quote-requests/target-price': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsTargetPriceRoute
  '/next/negotiations/$negotiationId/scenarios/compare': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosCompareRoute
  '/next/negotiations/$negotiationId/scenarios/create': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosCreateRoute
  '/next/projects/$projectId/assemblies/$assemblyId/details': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdDetailsRoute
  '/next/projects/$projectId/assemblies/$assemblyId/edit': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdEditRoute
  '/next/projects/$projectId/assemblies/$assemblyId/pnp-importer': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPnpImporterRoute
  '/next/projects/$projectId/sourcing/assembly/$assemblyId': typeof AuthenticatedNextProjectsProjectIdSourcingAssemblyAssemblyIdRoute
  '/next/projects/$projectId/sourcing/overview/$view': typeof AuthenticatedNextProjectsProjectIdSourcingOverviewViewRoute
  '/next/projects/$projectId/sourcing/quote-requests/$quoteRequestId': typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsQuoteRequestIdRoute
  '/next/projects/$projectId/sourcing/quote-requests/assign': typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsAssignRoute
  '/next/projects/$projectId/sourcing/quote-requests/attachments': typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsAttachmentsRoute
  '/next/projects/$projectId/sourcing/quote-requests/delivery-lot-size': typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsDeliveryLotSizeRoute
  '/next/projects/$projectId/sourcing/quote-requests/importer': typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsImporterRoute
  '/next/projects/$projectId/sourcing/quote-requests/line-items': typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsLineItemsRoute
  '/next/projects/$projectId/sourcing/quote-requests/preview-email': typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsPreviewEmailRoute
  '/next/projects/$projectId/sourcing/quote-requests/target-price': typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsTargetPriceRoute
  '/next/projects/$projectId/sourcing/scenarios/create': typeof AuthenticatedNextProjectsProjectIdSourcingScenariosCreateRoute
  '/next/settings/organization/customer-portal/additional-services': typeof AuthenticatedNextSettingsMenuOrganizationCustomerPortalAdditionalServicesRoute
  '/next/settings/organization/customer-portal/checkout-conditions': typeof AuthenticatedNextSettingsMenuOrganizationCustomerPortalCheckoutConditionsRoute
  '/next/settings/organization/customer-portal/customer-specific-settings': typeof AuthenticatedNextSettingsMenuOrganizationCustomerPortalCustomerSpecificSettingsRoute
  '/next/settings/organization/customer-portal/landing-page': typeof AuthenticatedNextSettingsMenuOrganizationCustomerPortalLandingPageRoute
  '/next/settings/organization/customer-portal/payment-credentials': typeof AuthenticatedNextSettingsMenuOrganizationCustomerPortalPaymentCredentialsRoute
  '/next/settings/organization/user-management/action-permissions': typeof AuthenticatedNextSettingsMenuOrganizationUserManagementActionPermissionsRoute
  '/next/settings/organization/user-management/roles': typeof AuthenticatedNextSettingsMenuOrganizationUserManagementRolesRoute
  '/next/templates/flexible-calculation/apps/$appId/$widgetId': typeof AuthenticatedNextTemplatesFlexibleCalculationAppsAppIdWidgetIdRoute
  '/next/templates/flexible-calculation/review-conversion/$legacyTemplateId/$flexibleCalculationTemplateId': typeof AuthenticatedNextTemplatesFlexibleCalculationReviewConversionLegacyTemplateIdFlexibleCalculationTemplateIdRoute
  '/next/templates/manufacturing/activities/$activityId/duplicate': typeof AuthenticatedNextTemplatesManufacturingActivitiesActivityIdDuplicateRoute
  '/next/templates/manufacturing/activities/$activityId/edit': typeof AuthenticatedNextTemplatesManufacturingActivitiesActivityIdEditRoute
  '/next/templates/manufacturing/apps/$appId/$widgetId': typeof AuthenticatedNextTemplatesManufacturingAppsAppIdWidgetIdRoute
  '/next/templates/manufacturing/drivers/$driverId/duplicate': typeof AuthenticatedNextTemplatesManufacturingDriversDriverIdDuplicateRoute
  '/next/templates/manufacturing/drivers/$driverId/edit': typeof AuthenticatedNextTemplatesManufacturingDriversDriverIdEditRoute
  '/next/templates/manufacturing/expenses/$expenseId/duplicate': typeof AuthenticatedNextTemplatesManufacturingExpensesExpenseIdDuplicateRoute
  '/next/templates/manufacturing/expenses/$expenseId/edit': typeof AuthenticatedNextTemplatesManufacturingExpensesExpenseIdEditRoute
  '/next/templates/manufacturing/resources/$resourceId/duplicate': typeof AuthenticatedNextTemplatesManufacturingResourcesResourceIdDuplicateRoute
  '/next/templates/manufacturing/resources/$resourceId/edit': typeof AuthenticatedNextTemplatesManufacturingResourcesResourceIdEditRoute
  '/parts/components/ipn/offers/$offerId/duplicate': typeof AuthenticatedPartsComponentsIpnOffersOfferIdDuplicateRoute
  '/parts/components/ipn/offers/$offerId/edit': typeof AuthenticatedPartsComponentsIpnOffersOfferIdEditRoute
  '/projects/$projectId/bom/assembly/$assemblyId/details': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdDetailsRoute
  '/projects/$projectId/bom/assembly/$assemblyId/edit': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdEditRoute
  '/projects/$projectId/bom/assembly/$assemblyId/pnp-importer': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPnpImporterRoute
  '/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/activity': typeof AuthenticatedProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdActivityRoute
  '/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/expense': typeof AuthenticatedProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdExpenseRoute
  '/projects/$projectId/sourcing/$sourcingScenarioId/line/$sourcingLineItemId': typeof AuthenticatedProjectsProjectIdSourcingSourcingScenarioIdLineSourcingLineItemIdRoute
  '/projects/$projectId/sourcing/overview/$view': typeof AuthenticatedProjectsProjectIdSourcingSidebarOverviewViewRoute
  '/projects/$projectId/sourcing/quote-requests/$quoteRequestId': typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsQuoteRequestIdRoute
  '/projects/$projectId/sourcing/quote-requests/assign': typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsAssignRoute
  '/projects/$projectId/sourcing/quote-requests/attachments': typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsAttachmentsRoute
  '/projects/$projectId/sourcing/quote-requests/delivery-lot-size': typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsDeliveryLotSizeRoute
  '/projects/$projectId/sourcing/quote-requests/excel-importer': typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsExcelImporterRoute
  '/projects/$projectId/sourcing/quote-requests/importer': typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsImporterRoute
  '/projects/$projectId/sourcing/quote-requests/line-items': typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsLineItemsRoute
  '/projects/$projectId/sourcing/quote-requests/preview-email': typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsPreviewEmailRoute
  '/projects/$projectId/sourcing/quote-requests/target-price': typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsTargetPriceRoute
  '/projects/$projectId/sourcing/scenarios/create': typeof AuthenticatedProjectsProjectIdSourcingSidebarScenariosCreateRoute
  '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/purchase-orders': typeof AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdPurchaseOrdersRoute
  '/settings/organization/pcb/panel-preferences/create': typeof AuthenticatedSettingsMenuOrganizationPcbPanelPreferencesCreateRoute
  '/templates/flexible-calculation/apps/$appId/$widgetId': typeof AuthenticatedTemplatesSidebarFlexibleCalculationAppsAppIdWidgetIdRoute
  '/templates/flexible-calculation/review-conversion/$legacyTemplateId/$flexibleCalculationTemplateId': typeof AuthenticatedTemplatesSidebarFlexibleCalculationReviewConversionLegacyTemplateIdFlexibleCalculationTemplateIdRoute
  '/negotiations/$negotiationId/demand-groups/$demandGroupId': typeof AuthenticatedNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdIndexRoute
  '/negotiations/$negotiationId/scenarios/$sourcingScenarioId': typeof AuthenticatedNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdIndexRoute
  '/next/components/ipn/offers': typeof AuthenticatedNextComponentsIpnDetailsOffersIndexRoute
  '/next/negotiations/$negotiationId/quote-requests': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsIndexRoute
  '/next/projects/$projectId/assemblies/$assemblyId': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdIndexRoute
  '/next/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId': typeof AuthenticatedNextProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdIndexRoute
  '/next/projects/$projectId/sourcing/overview': typeof AuthenticatedNextProjectsProjectIdSourcingOverviewIndexRoute
  '/next/projects/$projectId/sourcing/quote-requests': typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsIndexRoute
  '/next/settings/organization/customer-portal': typeof AuthenticatedNextSettingsMenuOrganizationCustomerPortalIndexRoute
  '/next/settings/organization/pcb': typeof AuthenticatedNextSettingsMenuOrganizationPcbIndexRoute
  '/next/settings/organization/users': typeof AuthenticatedNextSettingsMenuOrganizationUsersIndexRoute
  '/next/settings/organization/pcb/panel-preferences': typeof AuthenticatedNextSettingsOrganizationPcbPanelPreferencesIndexRoute
  '/projects/$projectId/bom/assembly/$assemblyId': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdIndexRoute
  '/projects/$projectId/sourcing/overview': typeof AuthenticatedProjectsProjectIdSourcingSidebarOverviewIndexRoute
  '/projects/$projectId/sourcing/quote-requests': typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsIndexRoute
  '/next/negotiations/$negotiationId/demand-groups/$demandGroupId/awarding': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdAwardingRoute
  '/next/negotiations/$negotiationId/scenarios/$sourcingScenarioId/line-items/$sourcingLineItemId': typeof AuthenticatedNextNegotiationsNegotiationIdScenariosSourcingScenarioIdLineItemsSourcingLineItemIdRoute
  '/next/projects/$projectId/assemblies/$assemblyId/pcb/cad-viewer': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbCadViewerRoute
  '/next/projects/$projectId/assemblies/$assemblyId/pcb/dfm': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbDfmRoute
  '/next/projects/$projectId/assemblies/$assemblyId/pcb/dfm-analysis': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbDfmAnalysisRoute
  '/next/projects/$projectId/assemblies/$assemblyId/pcb/drills': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbDrillsRoute
  '/next/projects/$projectId/assemblies/$assemblyId/pcb/files': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbFilesRoute
  '/next/projects/$projectId/assemblies/$assemblyId/pcb/panelization': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbPanelizationRoute
  '/next/projects/$projectId/assemblies/$assemblyId/pcb/specification': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbSpecificationRoute
  '/next/projects/$projectId/assemblies/$assemblyId/pcb/stackup': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbStackupRoute
  '/next/projects/$projectId/assemblies/$assemblyId/subassemblies/create': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdSubassembliesCreateRoute
  '/next/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/activity': typeof AuthenticatedNextProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdActivityRoute
  '/next/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/expense': typeof AuthenticatedNextProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdExpenseRoute
  '/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/purchase-orders': typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdPurchaseOrdersRoute
  '/next/settings/organization/pcb/panel-preferences/create': typeof AuthenticatedNextSettingsMenuOrganizationPcbPanelPreferencesCreateRoute
  '/projects/$projectId/bom/assembly/$assemblyId/pcb/cad-viewer': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbCadViewerRoute
  '/projects/$projectId/bom/assembly/$assemblyId/pcb/dfm': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbDfmRoute
  '/projects/$projectId/bom/assembly/$assemblyId/pcb/dfm-analysis': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbDfmAnalysisRoute
  '/projects/$projectId/bom/assembly/$assemblyId/pcb/drills': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbDrillsRoute
  '/projects/$projectId/bom/assembly/$assemblyId/pcb/files': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbFilesRoute
  '/projects/$projectId/bom/assembly/$assemblyId/pcb/panelization': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbPanelizationRoute
  '/projects/$projectId/bom/assembly/$assemblyId/pcb/specification': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbSpecificationRoute
  '/projects/$projectId/bom/assembly/$assemblyId/pcb/stackup': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbStackupRoute
  '/projects/$projectId/bom/assembly/$assemblyId/subassemblies/create': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdSubassembliesCreateRoute
  '/projects/$projectId/sourcing/offer/custom-part/$offerId/duplicate': typeof AuthenticatedProjectsProjectIdSourcingOfferCustomPartOfferIdDuplicateRoute
  '/projects/$projectId/sourcing/offer/custom-part/$offerId/edit': typeof AuthenticatedProjectsProjectIdSourcingOfferCustomPartOfferIdEditRoute
  '/projects/$projectId/sourcing/offer/internal-part-number/$offerId/duplicate': typeof AuthenticatedProjectsProjectIdSourcingOfferInternalPartNumberOfferIdDuplicateRoute
  '/projects/$projectId/sourcing/offer/internal-part-number/$offerId/edit': typeof AuthenticatedProjectsProjectIdSourcingOfferInternalPartNumberOfferIdEditRoute
  '/projects/$projectId/sourcing/offer/off-the-shelf/$offerId/duplicate': typeof AuthenticatedProjectsProjectIdSourcingOfferOffTheShelfOfferIdDuplicateRoute
  '/projects/$projectId/sourcing/offer/off-the-shelf/$offerId/edit': typeof AuthenticatedProjectsProjectIdSourcingOfferOffTheShelfOfferIdEditRoute
  '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/line-items': typeof AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarLineItemsRoute
  '/settings/organization/pcb/panel-preferences/$panelPreferenceId/edit': typeof AuthenticatedSettingsMenuOrganizationPcbPanelPreferencesPanelPreferenceIdEditRoute
  '/negotiations/$negotiationId/scenarios/$sourcingScenarioId/cost-breakdown': typeof AuthenticatedNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownIndexRoute
  '/next/negotiations/$negotiationId/demand-groups/$demandGroupId': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdIndexRoute
  '/next/negotiations/$negotiationId/scenarios/$sourcingScenarioId': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdIndexRoute
  '/next/projects/$projectId/assemblies/$assemblyId/pcb': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbIndexRoute
  '/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId': typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdIndexRoute
  '/projects/$projectId/bom/assembly/$assemblyId/pcb': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbIndexRoute
  '/next/projects/$projectId/sourcing/offers/custom-part/$offerId/duplicate': typeof AuthenticatedNextProjectsProjectIdSourcingOffersCustomPartOfferIdDuplicateRoute
  '/next/projects/$projectId/sourcing/offers/custom-part/$offerId/edit': typeof AuthenticatedNextProjectsProjectIdSourcingOffersCustomPartOfferIdEditRoute
  '/next/projects/$projectId/sourcing/offers/internal-part-number/$offerId/duplicate': typeof AuthenticatedNextProjectsProjectIdSourcingOffersInternalPartNumberOfferIdDuplicateRoute
  '/next/projects/$projectId/sourcing/offers/internal-part-number/$offerId/edit': typeof AuthenticatedNextProjectsProjectIdSourcingOffersInternalPartNumberOfferIdEditRoute
  '/next/projects/$projectId/sourcing/offers/off-the-shelf/$offerId/duplicate': typeof AuthenticatedNextProjectsProjectIdSourcingOffersOffTheShelfOfferIdDuplicateRoute
  '/next/projects/$projectId/sourcing/offers/off-the-shelf/$offerId/edit': typeof AuthenticatedNextProjectsProjectIdSourcingOffersOffTheShelfOfferIdEditRoute
  '/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/line-items/$sourcingLineItemId': typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdLineItemsSourcingLineItemIdRoute
  '/next/settings/organization/pcb/panel-preferences/$panelPreferenceId/edit': typeof AuthenticatedNextSettingsMenuOrganizationPcbPanelPreferencesPanelPreferenceIdEditRoute
  '/next/negotiations/$negotiationId/scenarios/$sourcingScenarioId/cost-breakdown': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownIndexRoute
  '/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/cost-breakdown': typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdCostBreakdownIndexRoute
  '/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/line-items': typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdLineItemsIndexRoute
  '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/cost-breakdown': typeof AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarCostBreakdownIndexRoute
  '/negotiations/$negotiationId/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId': typeof AuthenticatedNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownAssemblyAssemblyIdDemandDemandIdRoute
  '/next/negotiations/$negotiationId/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownAssemblyAssemblyIdDemandDemandIdRoute
  '/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId': typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdCostBreakdownAssemblyAssemblyIdDemandDemandIdRoute
  '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId': typeof AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarCostBreakdownAssemblyAssemblyIdDemandDemandIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/callback': typeof CallbackRoute
  '/landing': typeof LandingRoute
  '/_authenticated/customer-portal': typeof AuthenticatedCustomerPortalRouteRouteWithChildren
  '/_authenticated/monitoring': typeof AuthenticatedMonitoringRouteRouteWithChildren
  '/_authenticated/next': typeof AuthenticatedNextRouteRouteWithChildren
  '/_authenticated/risk-management': typeof AuthenticatedRiskManagementRouteRouteWithChildren
  '/_authenticated/$': typeof AuthenticatedSplatRoute
  '/_authenticated/home': typeof AuthenticatedHomeRoute
  '/_authenticated/project_creation': typeof AuthenticatedProject_creationRoute
  '/_authenticated/purchase-orders': typeof AuthenticatedPurchaseOrdersRoute
  '/_authenticated/rfqs': typeof AuthenticatedRfqsRoute
  '/_authenticated/start': typeof AuthenticatedStartRoute
  '/auth/enter-email': typeof AuthEnterEmailRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/manufacturers/_sidebar': typeof AuthenticatedManufacturersSidebarRouteRouteWithChildren
  '/_authenticated/manufacturing/_sidebar': typeof AuthenticatedManufacturingSidebarRouteRouteWithChildren
  '/_authenticated/monitoring/_sidebar': typeof AuthenticatedMonitoringSidebarRouteRouteWithChildren
  '/_authenticated/parts/_sidebar': typeof AuthenticatedPartsSidebarRouteRouteWithChildren
  '/_authenticated/settings/_menu': typeof AuthenticatedSettingsMenuRouteRouteWithChildren
  '/_authenticated/suppliers/_sidebar': typeof AuthenticatedSuppliersSidebarRouteRouteWithChildren
  '/_authenticated/templates/_sidebar': typeof AuthenticatedTemplatesSidebarRouteRouteWithChildren
  '/_authenticated/apps/$': typeof AuthenticatedAppsSplatRoute
  '/_authenticated/assemblies/add-assembly': typeof AuthenticatedAssembliesAddAssemblyRoute
  '/_authenticated/components/import': typeof AuthenticatedComponentsImportRoute
  '/_authenticated/customers/$customerId': typeof AuthenticatedCustomersCustomerIdRoute
  '/_authenticated/customers/importer': typeof AuthenticatedCustomersImporterRoute
  '/_authenticated/manufacturer/$': typeof AuthenticatedManufacturerSplatRoute
  '/_authenticated/manufacturers/$manufacturerId': typeof AuthenticatedManufacturersManufacturerIdRoute
  '/_authenticated/manufacturers/importer': typeof AuthenticatedManufacturersImporterRoute
  '/_authenticated/manufacturing/add-activity': typeof AuthenticatedManufacturingAddActivityRoute
  '/_authenticated/manufacturing/add-driver': typeof AuthenticatedManufacturingAddDriverRoute
  '/_authenticated/manufacturing/add-expense': typeof AuthenticatedManufacturingAddExpenseRoute
  '/_authenticated/manufacturing/add-resource': typeof AuthenticatedManufacturingAddResourceRoute
  '/_authenticated/monitoring/analysis': typeof AuthenticatedMonitoringAnalysisRoute
  '/_authenticated/negotiations/create': typeof AuthenticatedNegotiationsCreateRoute
  '/_authenticated/next/$': typeof AuthenticatedNextSplatRoute
  '/_authenticated/next/alerts': typeof AuthenticatedNextAlertsRoute
  '/_authenticated/next/home': typeof AuthenticatedNextHomeRoute
  '/_authenticated/next/lumi-agent': typeof AuthenticatedNextLumiAgentRoute
  '/_authenticated/next/purchase-orders': typeof AuthenticatedNextPurchaseOrdersRoute
  '/_authenticated/offers/mpn-offer-importer': typeof AuthenticatedOffersMpnOfferImporterRoute
  '/_authenticated/orders/upload': typeof AuthenticatedOrdersUploadRoute
  '/_authenticated/orders/{-$orderId}': typeof AuthenticatedOrdersChar123OrderIdChar125Route
  '/_authenticated/parts/off-the-shelf-part-search': typeof AuthenticatedPartsOffTheShelfPartSearchRoute
  '/_authenticated/projects/create': typeof AuthenticatedProjectsCreateRoute
  '/_authenticated/projects/new': typeof AuthenticatedProjectsNewRoute
  '/_authenticated/quote-requests/excel-importer': typeof AuthenticatedQuoteRequestsExcelImporterRoute
  '/_authenticated/risk-management/geo-risk': typeof AuthenticatedRiskManagementGeoRiskRoute
  '/_authenticated/risk-management/pcns': typeof AuthenticatedRiskManagementPcnsRoute
  '/_authenticated/risk-management/risk-digest': typeof AuthenticatedRiskManagementRiskDigestRoute
  '/_authenticated/settings/company': typeof AuthenticatedSettingsCompanyRoute
  '/_authenticated/supplier/importer': typeof AuthenticatedSupplierImporterRoute
  '/_authenticated/suppliers/$supplierAndStockLocationId': typeof AuthenticatedSuppliersSupplierAndStockLocationIdRoute
  '/_authenticated/suppliers/importer': typeof AuthenticatedSuppliersImporterRoute
  '/_authenticated/template/$': typeof AuthenticatedTemplateSplatRoute
  '/auth/signup/customer': typeof AuthSignupCustomerRoute
  '/auth/signup/invite': typeof AuthSignupInviteRoute
  '/_authenticated/assemblies/': typeof AuthenticatedAssembliesIndexRoute
  '/_authenticated/customer-portal/': typeof AuthenticatedCustomerPortalIndexRoute
  '/_authenticated/customers/': typeof AuthenticatedCustomersIndexRoute
  '/_authenticated/manufacturing/': typeof AuthenticatedManufacturingIndexRoute
  '/_authenticated/negotiations/': typeof AuthenticatedNegotiationsIndexRoute
  '/_authenticated/next/': typeof AuthenticatedNextIndexRoute
  '/_authenticated/parts/': typeof AuthenticatedPartsIndexRoute
  '/_authenticated/projects/': typeof AuthenticatedProjectsIndexRoute
  '/_authenticated/risk-management/': typeof AuthenticatedRiskManagementIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/supplier-portal/': typeof AuthenticatedSupplierPortalIndexRoute
  '/_authenticated/templates/': typeof AuthenticatedTemplatesIndexRoute
  '/_authenticated/assemblies/$assemblyId/pcb': typeof AuthenticatedAssembliesAssemblyIdPcbRouteRouteWithChildren
  '/_authenticated/negotiations/$negotiationId/_sidebar': typeof AuthenticatedNegotiationsNegotiationIdSidebarRouteRouteWithChildren
  '/_authenticated/next/parts/$partId': typeof AuthenticatedNextPartsPartIdRouteRouteWithChildren
  '/_authenticated/next/projects/$projectId': typeof AuthenticatedNextProjectsProjectIdRouteRouteWithChildren
  '/_authenticated/next/settings/_menu': typeof AuthenticatedNextSettingsMenuRouteRouteWithChildren
  '/_authenticated/parts/details/$partId': typeof AuthenticatedPartsDetailsPartIdRouteRouteWithChildren
  '/_authenticated/3rdparty/digikey/callback': typeof Authenticated3rdpartyDigikeyCallbackRoute
  '/_authenticated/assemblies/$assemblyId/dashboard': typeof AuthenticatedAssembliesAssemblyIdDashboardRoute
  '/_authenticated/assemblies/$assemblyId/details': typeof AuthenticatedAssembliesAssemblyIdDetailsRoute
  '/_authenticated/assemblies/$assemblyId/edit': typeof AuthenticatedAssembliesAssemblyIdEditRoute
  '/_authenticated/manufacturers/_sidebar/line-card': typeof AuthenticatedManufacturersSidebarLineCardRoute
  '/_authenticated/manufacturing/activities/create': typeof AuthenticatedManufacturingActivitiesCreateRoute
  '/_authenticated/manufacturing/activity/$': typeof AuthenticatedManufacturingActivitySplatRoute
  '/_authenticated/manufacturing/driver/$': typeof AuthenticatedManufacturingDriverSplatRoute
  '/_authenticated/manufacturing/drivers/create': typeof AuthenticatedManufacturingDriversCreateRoute
  '/_authenticated/manufacturing/expense/$': typeof AuthenticatedManufacturingExpenseSplatRoute
  '/_authenticated/manufacturing/expenses/create': typeof AuthenticatedManufacturingExpensesCreateRoute
  '/_authenticated/manufacturing/resource/$': typeof AuthenticatedManufacturingResourceSplatRoute
  '/_authenticated/manufacturing/resources/create': typeof AuthenticatedManufacturingResourcesCreateRoute
  '/_authenticated/manufacturing/template/$': typeof AuthenticatedManufacturingTemplateSplatRoute
  '/_authenticated/monitoring/_sidebar/component-savings': typeof AuthenticatedMonitoringSidebarComponentSavingsRoute
  '/_authenticated/monitoring/_sidebar/data-health': typeof AuthenticatedMonitoringSidebarDataHealthRoute
  '/_authenticated/monitoring/_sidebar/offers': typeof AuthenticatedMonitoringSidebarOffersRoute
  '/_authenticated/monitoring/_sidebar/onboarding': typeof AuthenticatedMonitoringSidebarOnboardingRoute
  '/_authenticated/monitoring/agent/$': typeof AuthenticatedMonitoringAgentSplatRoute
  '/_authenticated/monitoring/charts/$chartId': typeof AuthenticatedMonitoringChartsChartIdRoute
  '/_authenticated/next/apps/$': typeof AuthenticatedNextAppsSplatRoute
  '/_authenticated/next/components/linking': typeof AuthenticatedNextComponentsLinkingRoute
  '/_authenticated/next/customers/$customerId': typeof AuthenticatedNextCustomersCustomerIdRoute
  '/_authenticated/next/demands/importer': typeof AuthenticatedNextDemandsImporterRoute
  '/_authenticated/next/manufacturers/$manufacturerId': typeof AuthenticatedNextManufacturersManufacturerIdRoute
  '/_authenticated/next/manufacturers/line-card': typeof AuthenticatedNextManufacturersLineCardRoute
  '/_authenticated/next/negotiations/create': typeof AuthenticatedNextNegotiationsCreateRoute
  '/_authenticated/next/offer-imports/$offerImportId': typeof AuthenticatedNextOfferImportsOfferImportIdRoute
  '/_authenticated/next/orders/upload': typeof AuthenticatedNextOrdersUploadRoute
  '/_authenticated/next/orders/{-$orderId}': typeof AuthenticatedNextOrdersChar123OrderIdChar125Route
  '/_authenticated/next/parts/search': typeof AuthenticatedNextPartsSearchRoute
  '/_authenticated/next/projects/create': typeof AuthenticatedNextProjectsCreateRoute
  '/_authenticated/next/quote-requests/importer': typeof AuthenticatedNextQuoteRequestsImporterRoute
  '/_authenticated/next/risk-management/geo-risk': typeof AuthenticatedNextRiskManagementGeoRiskRoute
  '/_authenticated/next/risk-management/pcns': typeof AuthenticatedNextRiskManagementPcnsRoute
  '/_authenticated/next/risk-management/risk-digest': typeof AuthenticatedNextRiskManagementRiskDigestRoute
  '/_authenticated/next/settings/company': typeof AuthenticatedNextSettingsCompanyRoute
  '/_authenticated/next/suppliers/$supplierAndStockLocationId': typeof AuthenticatedNextSuppliersSupplierAndStockLocationIdRoute
  '/_authenticated/next/suppliers/strategy': typeof AuthenticatedNextSuppliersStrategyRoute
  '/_authenticated/next/templates/export': typeof AuthenticatedNextTemplatesExportRoute
  '/_authenticated/next/templates/pcb-specification': typeof AuthenticatedNextTemplatesPcbSpecificationRoute
  '/_authenticated/parts/_sidebar/alerts': typeof AuthenticatedPartsSidebarAlertsRoute
  '/_authenticated/parts/_sidebar/search': typeof AuthenticatedPartsSidebarSearchRoute
  '/_authenticated/parts/components/component-importer': typeof AuthenticatedPartsComponentsComponentImporterRoute
  '/_authenticated/parts/components/importer': typeof AuthenticatedPartsComponentsImporterRoute
  '/_authenticated/parts/components/linking': typeof AuthenticatedPartsComponentsLinkingRoute
  '/_authenticated/parts/demand/demand-importer': typeof AuthenticatedPartsDemandDemandImporterRoute
  '/_authenticated/parts/offers/add': typeof AuthenticatedPartsOffersAddRoute
  '/_authenticated/parts/offers/create': typeof AuthenticatedPartsOffersCreateRoute
  '/_authenticated/parts/offers/csv-importer': typeof AuthenticatedPartsOffersCsvImporterRoute
  '/_authenticated/parts/quote-requests/excel-importer': typeof AuthenticatedPartsQuoteRequestsExcelImporterRoute
  '/_authenticated/parts/quote-requests/importer': typeof AuthenticatedPartsQuoteRequestsImporterRoute
  '/_authenticated/projects/$projectId/dashboard': typeof AuthenticatedProjectsProjectIdDashboardRoute
  '/_authenticated/projects/$projectId/edit': typeof AuthenticatedProjectsProjectIdEditRoute
  '/_authenticated/projects/$projectId/quotation': typeof AuthenticatedProjectsProjectIdQuotationRoute
  '/_authenticated/risk-management/library-health/assemblies': typeof AuthenticatedRiskManagementLibraryHealthAssembliesRoute
  '/_authenticated/risk-management/library-health/components': typeof AuthenticatedRiskManagementLibraryHealthComponentsRoute
  '/_authenticated/risk-management/library-health/parts': typeof AuthenticatedRiskManagementLibraryHealthPartsRoute
  '/_authenticated/suppliers/_sidebar/strategy': typeof AuthenticatedSuppliersSidebarStrategyRoute
  '/_authenticated/suppliers/line-card-rules/importer': typeof AuthenticatedSuppliersLineCardRulesImporterRoute
  '/_authenticated/suppliers/supplier-contacts-importer/bulk': typeof AuthenticatedSuppliersSupplierContactsImporterBulkRoute
  '/_authenticated/suppliers/supplier-contacts/importer': typeof AuthenticatedSuppliersSupplierContactsImporterRoute
  '/_authenticated/templates/_sidebar/export': typeof AuthenticatedTemplatesSidebarExportRoute
  '/_authenticated/templates/_sidebar/pcb-specification': typeof AuthenticatedTemplatesSidebarPcbSpecificationRoute
  '/_authenticated/templates/calculation/add-template': typeof AuthenticatedTemplatesCalculationAddTemplateRoute
  '/_authenticated/templates/calculation/create': typeof AuthenticatedTemplatesCalculationCreateRoute
  '/_authenticated/templates/flexible-calculation/new': typeof AuthenticatedTemplatesFlexibleCalculationNewRoute
  '/_authenticated/templates/quotation/create': typeof AuthenticatedTemplatesQuotationCreateRoute
  '/_authenticated/templates/quotation/edit': typeof AuthenticatedTemplatesQuotationEditRoute
  '/_authenticated/assemblies/$assemblyId/': typeof AuthenticatedAssembliesAssemblyIdIndexRoute
  '/_authenticated/manufacturers/_sidebar/': typeof AuthenticatedManufacturersSidebarIndexRoute
  '/_authenticated/monitoring/_sidebar/': typeof AuthenticatedMonitoringSidebarIndexRoute
  '/_authenticated/negotiations/$negotiationId/': typeof AuthenticatedNegotiationsNegotiationIdIndexRoute
  '/_authenticated/next/assemblies/': typeof AuthenticatedNextAssembliesIndexRoute
  '/_authenticated/next/components/': typeof AuthenticatedNextComponentsIndexRoute
  '/_authenticated/next/customers/': typeof AuthenticatedNextCustomersIndexRoute
  '/_authenticated/next/demands/': typeof AuthenticatedNextDemandsIndexRoute
  '/_authenticated/next/manufacturers/': typeof AuthenticatedNextManufacturersIndexRoute
  '/_authenticated/next/negotiations/': typeof AuthenticatedNextNegotiationsIndexRoute
  '/_authenticated/next/offer-imports/': typeof AuthenticatedNextOfferImportsIndexRoute
  '/_authenticated/next/parts/': typeof AuthenticatedNextPartsIndexRoute
  '/_authenticated/next/projects/': typeof AuthenticatedNextProjectsIndexRoute
  '/_authenticated/next/quote-requests/': typeof AuthenticatedNextQuoteRequestsIndexRoute
  '/_authenticated/next/risk-management/': typeof AuthenticatedNextRiskManagementIndexRoute
  '/_authenticated/next/settings/': typeof AuthenticatedNextSettingsIndexRoute
  '/_authenticated/next/suppliers/': typeof AuthenticatedNextSuppliersIndexRoute
  '/_authenticated/projects/$projectId/': typeof AuthenticatedProjectsProjectIdIndexRoute
  '/_authenticated/risk-management/library-health/': typeof AuthenticatedRiskManagementLibraryHealthIndexRoute
  '/_authenticated/suppliers/_sidebar/': typeof AuthenticatedSuppliersSidebarIndexRoute
  '/_authenticated/next/assemblies/$assemblyId/pcb': typeof AuthenticatedNextAssembliesAssemblyIdPcbRouteRouteWithChildren
  '/_authenticated/next/components/ipn/_details': typeof AuthenticatedNextComponentsIpnDetailsRouteRouteWithChildren
  '/_authenticated/next/negotiations/$negotiationId/_sidebar': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRouteWithChildren
  '/_authenticated/next/parts/custom/$customPartSpecificationId': typeof AuthenticatedNextPartsCustomCustomPartSpecificationIdRouteRouteWithChildren
  '/_authenticated/parts/components/ipn/_details': typeof AuthenticatedPartsComponentsIpnDetailsRouteRouteWithChildren
  '/_authenticated/parts/custom/details/$customPartSpecificationId': typeof AuthenticatedPartsCustomDetailsCustomPartSpecificationIdRouteRouteWithChildren
  '/_authenticated/projects/$projectId/sourcing/_sidebar': typeof AuthenticatedProjectsProjectIdSourcingSidebarRouteRouteWithChildren
  '/_authenticated/assemblies/$assemblyId/pcb/cad-viewer': typeof AuthenticatedAssembliesAssemblyIdPcbCadViewerRoute
  '/_authenticated/assemblies/$assemblyId/pcb/dfm': typeof AuthenticatedAssembliesAssemblyIdPcbDfmRoute
  '/_authenticated/assemblies/$assemblyId/pcb/dfm-analysis': typeof AuthenticatedAssembliesAssemblyIdPcbDfmAnalysisRoute
  '/_authenticated/assemblies/$assemblyId/pcb/drills': typeof AuthenticatedAssembliesAssemblyIdPcbDrillsRoute
  '/_authenticated/assemblies/$assemblyId/pcb/files': typeof AuthenticatedAssembliesAssemblyIdPcbFilesRoute
  '/_authenticated/assemblies/$assemblyId/pcb/panelization': typeof AuthenticatedAssembliesAssemblyIdPcbPanelizationRoute
  '/_authenticated/assemblies/$assemblyId/pcb/specification': typeof AuthenticatedAssembliesAssemblyIdPcbSpecificationRoute
  '/_authenticated/assemblies/$assemblyId/pcb/stackup': typeof AuthenticatedAssembliesAssemblyIdPcbStackupRoute
  '/_authenticated/assemblies/$assemblyId/subassemblies/create': typeof AuthenticatedAssembliesAssemblyIdSubassembliesCreateRoute
  '/_authenticated/manufacturing/_sidebar/templates/{-$templateId}': typeof AuthenticatedManufacturingSidebarTemplatesChar123TemplateIdChar125Route
  '/_authenticated/manufacturing/activities/$activityId/duplicate': typeof AuthenticatedManufacturingActivitiesActivityIdDuplicateRoute
  '/_authenticated/manufacturing/activities/$activityId/edit': typeof AuthenticatedManufacturingActivitiesActivityIdEditRoute
  '/_authenticated/manufacturing/drivers/$driverId/duplicate': typeof AuthenticatedManufacturingDriversDriverIdDuplicateRoute
  '/_authenticated/manufacturing/drivers/$driverId/edit': typeof AuthenticatedManufacturingDriversDriverIdEditRoute
  '/_authenticated/manufacturing/expenses/$expenseId/duplicate': typeof AuthenticatedManufacturingExpensesExpenseIdDuplicateRoute
  '/_authenticated/manufacturing/expenses/$expenseId/edit': typeof AuthenticatedManufacturingExpensesExpenseIdEditRoute
  '/_authenticated/manufacturing/resources/$resourceId/duplicate': typeof AuthenticatedManufacturingResourcesResourceIdDuplicateRoute
  '/_authenticated/manufacturing/resources/$resourceId/edit': typeof AuthenticatedManufacturingResourcesResourceIdEditRoute
  '/_authenticated/monitoring/_sidebar/components/pricing': typeof AuthenticatedMonitoringSidebarComponentsPricingRoute
  '/_authenticated/monitoring/_sidebar/dashboards/$dashboardId': typeof AuthenticatedMonitoringSidebarDashboardsDashboardIdRoute
  '/_authenticated/monitoring/_sidebar/insights-agent/{-$conversationId}': typeof AuthenticatedMonitoringSidebarInsightsAgentChar123ConversationIdChar125Route
  '/_authenticated/monitoring/_sidebar/jobs/$jobId': typeof AuthenticatedMonitoringSidebarJobsJobIdRoute
  '/_authenticated/monitoring/_sidebar/reports/savings': typeof AuthenticatedMonitoringSidebarReportsSavingsRoute
  '/_authenticated/negotiations/$negotiationId/_sidebar/overview': typeof AuthenticatedNegotiationsNegotiationIdSidebarOverviewRoute
  '/_authenticated/next/assemblies/$assemblyId/dashboard': typeof AuthenticatedNextAssembliesAssemblyIdDashboardRoute
  '/_authenticated/next/assemblies/$assemblyId/details': typeof AuthenticatedNextAssembliesAssemblyIdDetailsRoute
  '/_authenticated/next/assemblies/$assemblyId/edit': typeof AuthenticatedNextAssembliesAssemblyIdEditRoute
  '/_authenticated/next/parts/$partId/compliance': typeof AuthenticatedNextPartsPartIdComplianceRoute
  '/_authenticated/next/parts/$partId/offers': typeof AuthenticatedNextPartsPartIdOffersRoute
  '/_authenticated/next/parts/$partId/part-alternatives': typeof AuthenticatedNextPartsPartIdPartAlternativesRoute
  '/_authenticated/next/parts/$partId/se-alternatives': typeof AuthenticatedNextPartsPartIdSeAlternativesRoute
  '/_authenticated/next/parts/$partId/se-documentation': typeof AuthenticatedNextPartsPartIdSeDocumentationRoute
  '/_authenticated/next/parts/$partId/se-geo-risk': typeof AuthenticatedNextPartsPartIdSeGeoRiskRoute
  '/_authenticated/next/parts/$partId/se-supply-chain': typeof AuthenticatedNextPartsPartIdSeSupplyChainRoute
  '/_authenticated/next/parts/$partId/se-technical': typeof AuthenticatedNextPartsPartIdSeTechnicalRoute
  '/_authenticated/next/parts/$partId/used-in': typeof AuthenticatedNextPartsPartIdUsedInRoute
  '/_authenticated/next/projects/$projectId/dashboard': typeof AuthenticatedNextProjectsProjectIdDashboardRoute
  '/_authenticated/next/projects/$projectId/edit': typeof AuthenticatedNextProjectsProjectIdEditRoute
  '/_authenticated/next/projects/$projectId/quotation': typeof AuthenticatedNextProjectsProjectIdQuotationRoute
  '/_authenticated/next/risk-management/library-health/assemblies': typeof AuthenticatedNextRiskManagementLibraryHealthAssembliesRoute
  '/_authenticated/next/risk-management/library-health/components': typeof AuthenticatedNextRiskManagementLibraryHealthComponentsRoute
  '/_authenticated/next/risk-management/library-health/parts': typeof AuthenticatedNextRiskManagementLibraryHealthPartsRoute
  '/_authenticated/next/templates/email/create': typeof AuthenticatedNextTemplatesEmailCreateRoute
  '/_authenticated/next/templates/flexible-calculation/$flexibleCalculationTemplateId': typeof AuthenticatedNextTemplatesFlexibleCalculationFlexibleCalculationTemplateIdRoute
  '/_authenticated/next/templates/flexible-calculation/create': typeof AuthenticatedNextTemplatesFlexibleCalculationCreateRoute
  '/_authenticated/next/templates/flexible-calculation/exported-variables': typeof AuthenticatedNextTemplatesFlexibleCalculationExportedVariablesRoute
  '/_authenticated/next/templates/quote-request/create': typeof AuthenticatedNextTemplatesQuoteRequestCreateRoute
  '/_authenticated/next/templates/sourcing/create': typeof AuthenticatedNextTemplatesSourcingCreateRoute
  '/_authenticated/parts/_sidebar/demands/importer': typeof AuthenticatedPartsSidebarDemandsImporterRoute
  '/_authenticated/parts/details/$partId/compliance': typeof AuthenticatedPartsDetailsPartIdComplianceRoute
  '/_authenticated/parts/details/$partId/offers': typeof AuthenticatedPartsDetailsPartIdOffersRoute
  '/_authenticated/parts/details/$partId/part-alternatives': typeof AuthenticatedPartsDetailsPartIdPartAlternativesRoute
  '/_authenticated/parts/details/$partId/se-alternatives': typeof AuthenticatedPartsDetailsPartIdSeAlternativesRoute
  '/_authenticated/parts/details/$partId/se-documentation': typeof AuthenticatedPartsDetailsPartIdSeDocumentationRoute
  '/_authenticated/parts/details/$partId/se-geo-risk': typeof AuthenticatedPartsDetailsPartIdSeGeoRiskRoute
  '/_authenticated/parts/details/$partId/se-supply-chain': typeof AuthenticatedPartsDetailsPartIdSeSupplyChainRoute
  '/_authenticated/parts/details/$partId/se-technical': typeof AuthenticatedPartsDetailsPartIdSeTechnicalRoute
  '/_authenticated/parts/details/$partId/used-in': typeof AuthenticatedPartsDetailsPartIdUsedInRoute
  '/_authenticated/parts/offers/$offerId/duplicate': typeof AuthenticatedPartsOffersOfferIdDuplicateRoute
  '/_authenticated/parts/offers/$offerId/edit': typeof AuthenticatedPartsOffersOfferIdEditRoute
  '/_authenticated/projects/$projectId/calculation/print': typeof AuthenticatedProjectsProjectIdCalculationPrintRoute
  '/_authenticated/projects/$projectId/flexible-calculation/$flexibleCalculationId': typeof AuthenticatedProjectsProjectIdFlexibleCalculationFlexibleCalculationIdRoute
  '/_authenticated/projects/$projectId/order/confirmation': typeof AuthenticatedProjectsProjectIdOrderConfirmationRoute
  '/_authenticated/projects/$projectId/sourcing/demand-groups': typeof AuthenticatedProjectsProjectIdSourcingDemandGroupsRoute
  '/_authenticated/settings/_menu/organization/api-integration': typeof AuthenticatedSettingsMenuOrganizationApiIntegrationRoute
  '/_authenticated/settings/_menu/organization/assembly-settings': typeof AuthenticatedSettingsMenuOrganizationAssemblySettingsRoute
  '/_authenticated/settings/_menu/organization/automatic-rfq-number': typeof AuthenticatedSettingsMenuOrganizationAutomaticRfqNumberRoute
  '/_authenticated/settings/_menu/organization/branding': typeof AuthenticatedSettingsMenuOrganizationBrandingRoute
  '/_authenticated/settings/_menu/organization/carbon-footprints': typeof AuthenticatedSettingsMenuOrganizationCarbonFootprintsRoute
  '/_authenticated/settings/_menu/organization/component-settings': typeof AuthenticatedSettingsMenuOrganizationComponentSettingsRoute
  '/_authenticated/settings/_menu/organization/csv-integration': typeof AuthenticatedSettingsMenuOrganizationCsvIntegrationRoute
  '/_authenticated/settings/_menu/organization/custom-part-categories': typeof AuthenticatedSettingsMenuOrganizationCustomPartCategoriesRoute
  '/_authenticated/settings/_menu/organization/data-integrations': typeof AuthenticatedSettingsMenuOrganizationDataIntegrationsRoute
  '/_authenticated/settings/_menu/organization/feature-flags': typeof AuthenticatedSettingsMenuOrganizationFeatureFlagsRoute
  '/_authenticated/settings/_menu/organization/manufacturer-preferences': typeof AuthenticatedSettingsMenuOrganizationManufacturerPreferencesRoute
  '/_authenticated/settings/_menu/organization/sites': typeof AuthenticatedSettingsMenuOrganizationSitesRoute
  '/_authenticated/settings/_menu/organization/supplier-api-integrations': typeof AuthenticatedSettingsMenuOrganizationSupplierApiIntegrationsRoute
  '/_authenticated/settings/_menu/user/account-security': typeof AuthenticatedSettingsMenuUserAccountSecurityRoute
  '/_authenticated/settings/organization/pcb/$panelPreferenceId': typeof AuthenticatedSettingsOrganizationPcbPanelPreferenceIdRoute
  '/_authenticated/settings/organization/pcb/add-preference': typeof AuthenticatedSettingsOrganizationPcbAddPreferenceRoute
  '/_authenticated/settings/organization/users/importer': typeof AuthenticatedSettingsOrganizationUsersImporterRoute
  '/_authenticated/supplier-portal/quote-requests/$quoteRequestId/excel-importer': typeof AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdExcelImporterRoute
  '/_authenticated/supplier-portal/quote-requests/$quoteRequestId/import-pdf': typeof AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdImportPdfRoute
  '/_authenticated/supplier-portal/quote-requests/$quoteRequestId/pdf-importer': typeof AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdPdfImporterRoute
  '/_authenticated/suppliers/$supplierId/supplier-contacts-importer/$': typeof AuthenticatedSuppliersSupplierIdSupplierContactsImporterSplatRoute
  '/_authenticated/suppliers/$supplierId/supplier-contacts/importer': typeof AuthenticatedSuppliersSupplierIdSupplierContactsImporterRoute
  '/_authenticated/templates/_sidebar/email/create': typeof AuthenticatedTemplatesSidebarEmailCreateRoute
  '/_authenticated/templates/_sidebar/flexible-calculation/$flexibleCalculationTemplateId': typeof AuthenticatedTemplatesSidebarFlexibleCalculationFlexibleCalculationTemplateIdRoute
  '/_authenticated/templates/_sidebar/flexible-calculation/create': typeof AuthenticatedTemplatesSidebarFlexibleCalculationCreateRoute
  '/_authenticated/templates/_sidebar/flexible-calculation/exported-variables': typeof AuthenticatedTemplatesSidebarFlexibleCalculationExportedVariablesRoute
  '/_authenticated/templates/_sidebar/quote-request/create': typeof AuthenticatedTemplatesSidebarQuoteRequestCreateRoute
  '/_authenticated/templates/_sidebar/sourcing/create': typeof AuthenticatedTemplatesSidebarSourcingCreateRoute
  '/_authenticated/templates/calculation/$templateId/edit': typeof AuthenticatedTemplatesCalculationTemplateIdEditRoute
  '/_authenticated/templates/email/$emailTemplateId/update': typeof AuthenticatedTemplatesEmailEmailTemplateIdUpdateRoute
  '/_authenticated/assemblies/$assemblyId/pcb/': typeof AuthenticatedAssembliesAssemblyIdPcbIndexRoute
  '/_authenticated/manufacturing/_sidebar/activities/': typeof AuthenticatedManufacturingSidebarActivitiesIndexRoute
  '/_authenticated/manufacturing/_sidebar/drivers/': typeof AuthenticatedManufacturingSidebarDriversIndexRoute
  '/_authenticated/manufacturing/_sidebar/expenses/': typeof AuthenticatedManufacturingSidebarExpensesIndexRoute
  '/_authenticated/manufacturing/_sidebar/resources/': typeof AuthenticatedManufacturingSidebarResourcesIndexRoute
  '/_authenticated/monitoring/_sidebar/charts/': typeof AuthenticatedMonitoringSidebarChartsIndexRoute
  '/_authenticated/monitoring/_sidebar/dashboards/': typeof AuthenticatedMonitoringSidebarDashboardsIndexRoute
  '/_authenticated/monitoring/_sidebar/jobs/': typeof AuthenticatedMonitoringSidebarJobsIndexRoute
  '/_authenticated/next/assemblies/$assemblyId/': typeof AuthenticatedNextAssembliesAssemblyIdIndexRoute
  '/_authenticated/next/negotiations/$negotiationId/': typeof AuthenticatedNextNegotiationsNegotiationIdIndexRoute
  '/_authenticated/next/parts/$partId/': typeof AuthenticatedNextPartsPartIdIndexRoute
  '/_authenticated/next/projects/$projectId/': typeof AuthenticatedNextProjectsProjectIdIndexRoute
  '/_authenticated/next/risk-management/library-health/': typeof AuthenticatedNextRiskManagementLibraryHealthIndexRoute
  '/_authenticated/next/suppliers/supplier-contacts/': typeof AuthenticatedNextSuppliersSupplierContactsIndexRoute
  '/_authenticated/next/templates/email/': typeof AuthenticatedNextTemplatesEmailIndexRoute
  '/_authenticated/next/templates/flexible-calculation/': typeof AuthenticatedNextTemplatesFlexibleCalculationIndexRoute
  '/_authenticated/next/templates/quotation/': typeof AuthenticatedNextTemplatesQuotationIndexRoute
  '/_authenticated/next/templates/quote-request/': typeof AuthenticatedNextTemplatesQuoteRequestIndexRoute
  '/_authenticated/next/templates/sourcing/': typeof AuthenticatedNextTemplatesSourcingIndexRoute
  '/_authenticated/parts/_sidebar/components/': typeof AuthenticatedPartsSidebarComponentsIndexRoute
  '/_authenticated/parts/_sidebar/demands/': typeof AuthenticatedPartsSidebarDemandsIndexRoute
  '/_authenticated/parts/_sidebar/quote-requests/': typeof AuthenticatedPartsSidebarQuoteRequestsIndexRoute
  '/_authenticated/parts/details/$partId/': typeof AuthenticatedPartsDetailsPartIdIndexRoute
  '/_authenticated/projects/$projectId/bom/': typeof AuthenticatedProjectsProjectIdBomIndexRoute
  '/_authenticated/projects/$projectId/calculation/': typeof AuthenticatedProjectsProjectIdCalculationIndexRoute
  '/_authenticated/projects/$projectId/flexible-calculation/': typeof AuthenticatedProjectsProjectIdFlexibleCalculationIndexRoute
  '/_authenticated/projects/$projectId/manufacturing/': typeof AuthenticatedProjectsProjectIdManufacturingIndexRoute
  '/_authenticated/projects/$projectId/order/': typeof AuthenticatedProjectsProjectIdOrderIndexRoute
  '/_authenticated/projects/$projectId/sourcing/': typeof AuthenticatedProjectsProjectIdSourcingIndexRoute
  '/_authenticated/settings/_menu/organization/': typeof AuthenticatedSettingsMenuOrganizationIndexRoute
  '/_authenticated/supplier-portal/quote-requests/$quoteRequestId/': typeof AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdIndexRoute
  '/_authenticated/suppliers/_sidebar/supplier-contacts/': typeof AuthenticatedSuppliersSidebarSupplierContactsIndexRoute
  '/_authenticated/templates/_sidebar/calculation/': typeof AuthenticatedTemplatesSidebarCalculationIndexRoute
  '/_authenticated/templates/_sidebar/email/': typeof AuthenticatedTemplatesSidebarEmailIndexRoute
  '/_authenticated/templates/_sidebar/flexible-calculation/': typeof AuthenticatedTemplatesSidebarFlexibleCalculationIndexRoute
  '/_authenticated/templates/_sidebar/quotation/': typeof AuthenticatedTemplatesSidebarQuotationIndexRoute
  '/_authenticated/templates/_sidebar/quote-request/': typeof AuthenticatedTemplatesSidebarQuoteRequestIndexRoute
  '/_authenticated/templates/_sidebar/sourcing/': typeof AuthenticatedTemplatesSidebarSourcingIndexRoute
  '/_authenticated/next/projects/$projectId/sourcing/overview': typeof AuthenticatedNextProjectsProjectIdSourcingOverviewRouteRouteWithChildren
  '/_authenticated/manufacturing/_sidebar/apps/$appId/$widgetId': typeof AuthenticatedManufacturingSidebarAppsAppIdWidgetIdRoute
  '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/$quoteRequestId': typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsQuoteRequestIdRoute
  '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/assign': typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsAssignRoute
  '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/attachments': typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsAttachmentsRoute
  '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/delivery-lot-size': typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsDeliveryLotSizeRoute
  '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/excel-importer': typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsExcelImporterRoute
  '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/importer': typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsImporterRoute
  '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/line-items': typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsLineItemsRoute
  '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/preview-email': typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsPreviewEmailRoute
  '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/target-price': typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsTargetPriceRoute
  '/_authenticated/negotiations/$negotiationId/_sidebar/scenarios/compare': typeof AuthenticatedNegotiationsNegotiationIdSidebarScenariosCompareRoute
  '/_authenticated/negotiations/$negotiationId/_sidebar/scenarios/create': typeof AuthenticatedNegotiationsNegotiationIdSidebarScenariosCreateRoute
  '/_authenticated/next/assemblies/$assemblyId/pcb/cad-viewer': typeof AuthenticatedNextAssembliesAssemblyIdPcbCadViewerRoute
  '/_authenticated/next/assemblies/$assemblyId/pcb/dfm': typeof AuthenticatedNextAssembliesAssemblyIdPcbDfmRoute
  '/_authenticated/next/assemblies/$assemblyId/pcb/dfm-analysis': typeof AuthenticatedNextAssembliesAssemblyIdPcbDfmAnalysisRoute
  '/_authenticated/next/assemblies/$assemblyId/pcb/drills': typeof AuthenticatedNextAssembliesAssemblyIdPcbDrillsRoute
  '/_authenticated/next/assemblies/$assemblyId/pcb/files': typeof AuthenticatedNextAssembliesAssemblyIdPcbFilesRoute
  '/_authenticated/next/assemblies/$assemblyId/pcb/panelization': typeof AuthenticatedNextAssembliesAssemblyIdPcbPanelizationRoute
  '/_authenticated/next/assemblies/$assemblyId/pcb/specification': typeof AuthenticatedNextAssembliesAssemblyIdPcbSpecificationRoute
  '/_authenticated/next/assemblies/$assemblyId/pcb/stackup': typeof AuthenticatedNextAssembliesAssemblyIdPcbStackupRoute
  '/_authenticated/next/assemblies/$assemblyId/subassemblies/create': typeof AuthenticatedNextAssembliesAssemblyIdSubassembliesCreateRoute
  '/_authenticated/next/components/ipn/_details/cpns': typeof AuthenticatedNextComponentsIpnDetailsCpnsRoute
  '/_authenticated/next/components/ipn/_details/linking': typeof AuthenticatedNextComponentsIpnDetailsLinkingRoute
  '/_authenticated/next/components/ipn/_details/used-in': typeof AuthenticatedNextComponentsIpnDetailsUsedInRoute
  '/_authenticated/next/negotiations/$negotiationId/_sidebar/overview': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarOverviewRoute
  '/_authenticated/next/parts/custom/$customPartSpecificationId/offers': typeof AuthenticatedNextPartsCustomCustomPartSpecificationIdOffersRoute
  '/_authenticated/next/parts/custom/$customPartSpecificationId/used-in': typeof AuthenticatedNextPartsCustomCustomPartSpecificationIdUsedInRoute
  '/_authenticated/next/parts/offers/$offerId/duplicate': typeof AuthenticatedNextPartsOffersOfferIdDuplicateRoute
  '/_authenticated/next/parts/offers/$offerId/edit': typeof AuthenticatedNextPartsOffersOfferIdEditRoute
  '/_authenticated/next/projects/$projectId/flexible-calculation/$flexibleCalculationId': typeof AuthenticatedNextProjectsProjectIdFlexibleCalculationFlexibleCalculationIdRoute
  '/_authenticated/next/projects/$projectId/sourcing/compare': typeof AuthenticatedNextProjectsProjectIdSourcingCompareRoute
  '/_authenticated/next/projects/$projectId/sourcing/version-history': typeof AuthenticatedNextProjectsProjectIdSourcingVersionHistoryRoute
  '/_authenticated/next/settings/_menu/organization/api-integration': typeof AuthenticatedNextSettingsMenuOrganizationApiIntegrationRoute
  '/_authenticated/next/settings/_menu/organization/assembly-settings': typeof AuthenticatedNextSettingsMenuOrganizationAssemblySettingsRoute
  '/_authenticated/next/settings/_menu/organization/automatic-rfq-number': typeof AuthenticatedNextSettingsMenuOrganizationAutomaticRfqNumberRoute
  '/_authenticated/next/settings/_menu/organization/branding': typeof AuthenticatedNextSettingsMenuOrganizationBrandingRoute
  '/_authenticated/next/settings/_menu/organization/carbon-footprints': typeof AuthenticatedNextSettingsMenuOrganizationCarbonFootprintsRoute
  '/_authenticated/next/settings/_menu/organization/component-settings': typeof AuthenticatedNextSettingsMenuOrganizationComponentSettingsRoute
  '/_authenticated/next/settings/_menu/organization/csv-integration': typeof AuthenticatedNextSettingsMenuOrganizationCsvIntegrationRoute
  '/_authenticated/next/settings/_menu/organization/custom-part-categories': typeof AuthenticatedNextSettingsMenuOrganizationCustomPartCategoriesRoute
  '/_authenticated/next/settings/_menu/organization/data-integrations': typeof AuthenticatedNextSettingsMenuOrganizationDataIntegrationsRoute
  '/_authenticated/next/settings/_menu/organization/feature-flags': typeof AuthenticatedNextSettingsMenuOrganizationFeatureFlagsRoute
  '/_authenticated/next/settings/_menu/organization/manufacturer-preferences': typeof AuthenticatedNextSettingsMenuOrganizationManufacturerPreferencesRoute
  '/_authenticated/next/settings/_menu/organization/sites': typeof AuthenticatedNextSettingsMenuOrganizationSitesRoute
  '/_authenticated/next/settings/_menu/organization/supplier-api-integrations': typeof AuthenticatedNextSettingsMenuOrganizationSupplierApiIntegrationsRoute
  '/_authenticated/next/settings/_menu/user/account-security': typeof AuthenticatedNextSettingsMenuUserAccountSecurityRoute
  '/_authenticated/next/settings/organization/users/importer': typeof AuthenticatedNextSettingsOrganizationUsersImporterRoute
  '/_authenticated/next/templates/email/$emailTemplateId/edit': typeof AuthenticatedNextTemplatesEmailEmailTemplateIdEditRoute
  '/_authenticated/next/templates/manufacturing/activities/create': typeof AuthenticatedNextTemplatesManufacturingActivitiesCreateRoute
  '/_authenticated/next/templates/manufacturing/drivers/create': typeof AuthenticatedNextTemplatesManufacturingDriversCreateRoute
  '/_authenticated/next/templates/manufacturing/expenses/create': typeof AuthenticatedNextTemplatesManufacturingExpensesCreateRoute
  '/_authenticated/next/templates/manufacturing/resources/create': typeof AuthenticatedNextTemplatesManufacturingResourcesCreateRoute
  '/_authenticated/next/templates/manufacturing/templates/{-$templateId}': typeof AuthenticatedNextTemplatesManufacturingTemplatesChar123TemplateIdChar125Route
  '/_authenticated/next/templates/quotation/builder/{-$templateId}': typeof AuthenticatedNextTemplatesQuotationBuilderChar123TemplateIdChar125Route
  '/_authenticated/next/templates/quote-request/$quoteRequestTemplateId/edit': typeof AuthenticatedNextTemplatesQuoteRequestQuoteRequestTemplateIdEditRoute
  '/_authenticated/next/templates/sourcing/$sourcingTemplateId/duplicate': typeof AuthenticatedNextTemplatesSourcingSourcingTemplateIdDuplicateRoute
  '/_authenticated/next/templates/sourcing/$sourcingTemplateId/edit': typeof AuthenticatedNextTemplatesSourcingSourcingTemplateIdEditRoute
  '/_authenticated/parts/components/ipn/_details/cpns': typeof AuthenticatedPartsComponentsIpnDetailsCpnsRoute
  '/_authenticated/parts/components/ipn/_details/linking': typeof AuthenticatedPartsComponentsIpnDetailsLinkingRoute
  '/_authenticated/parts/components/ipn/_details/offers': typeof AuthenticatedPartsComponentsIpnDetailsOffersRoute
  '/_authenticated/parts/components/ipn/_details/used-in': typeof AuthenticatedPartsComponentsIpnDetailsUsedInRoute
  '/_authenticated/parts/custom/details/$customPartSpecificationId/offers': typeof AuthenticatedPartsCustomDetailsCustomPartSpecificationIdOffersRoute
  '/_authenticated/parts/custom/details/$customPartSpecificationId/used-in': typeof AuthenticatedPartsCustomDetailsCustomPartSpecificationIdUsedInRoute
  '/_authenticated/projects/$projectId/bom/assembly/add-assembly': typeof AuthenticatedProjectsProjectIdBomAssemblyAddAssemblyRoute
  '/_authenticated/projects/$projectId/calculation/$assemblyId/calculation': typeof AuthenticatedProjectsProjectIdCalculationAssemblyIdCalculationRoute
  '/_authenticated/projects/$projectId/calculation/assemblies/$assemblyId': typeof AuthenticatedProjectsProjectIdCalculationAssembliesAssemblyIdRoute
  '/_authenticated/projects/$projectId/sourcing/_sidebar/compare': typeof AuthenticatedProjectsProjectIdSourcingSidebarCompareRoute
  '/_authenticated/projects/$projectId/sourcing/_sidebar/version-history': typeof AuthenticatedProjectsProjectIdSourcingSidebarVersionHistoryRoute
  '/_authenticated/projects/$projectId/sourcing/assembly/$assemblyId': typeof AuthenticatedProjectsProjectIdSourcingAssemblyAssemblyIdRoute
  '/_authenticated/settings/_menu/organization/customer-portal/additional-services': typeof AuthenticatedSettingsMenuOrganizationCustomerPortalAdditionalServicesRoute
  '/_authenticated/settings/_menu/organization/customer-portal/checkout-conditions': typeof AuthenticatedSettingsMenuOrganizationCustomerPortalCheckoutConditionsRoute
  '/_authenticated/settings/_menu/organization/customer-portal/customer-specific-settings': typeof AuthenticatedSettingsMenuOrganizationCustomerPortalCustomerSpecificSettingsRoute
  '/_authenticated/settings/_menu/organization/customer-portal/landing-page': typeof AuthenticatedSettingsMenuOrganizationCustomerPortalLandingPageRoute
  '/_authenticated/settings/_menu/organization/customer-portal/payment-credentials': typeof AuthenticatedSettingsMenuOrganizationCustomerPortalPaymentCredentialsRoute
  '/_authenticated/settings/_menu/organization/user-management/action-permissions': typeof AuthenticatedSettingsMenuOrganizationUserManagementActionPermissionsRoute
  '/_authenticated/settings/_menu/organization/user-management/roles': typeof AuthenticatedSettingsMenuOrganizationUserManagementRolesRoute
  '/_authenticated/templates/_sidebar/email/$emailTemplateId/edit': typeof AuthenticatedTemplatesSidebarEmailEmailTemplateIdEditRoute
  '/_authenticated/templates/_sidebar/quotation/builder/{-$templateId}': typeof AuthenticatedTemplatesSidebarQuotationBuilderChar123TemplateIdChar125Route
  '/_authenticated/templates/_sidebar/quote-request/$quoteRequestTemplateId/edit': typeof AuthenticatedTemplatesSidebarQuoteRequestQuoteRequestTemplateIdEditRoute
  '/_authenticated/templates/_sidebar/sourcing/$sourcingTemplateId/duplicate': typeof AuthenticatedTemplatesSidebarSourcingSourcingTemplateIdDuplicateRoute
  '/_authenticated/templates/_sidebar/sourcing/$sourcingTemplateId/edit': typeof AuthenticatedTemplatesSidebarSourcingSourcingTemplateIdEditRoute
  '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/': typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsIndexRoute
  '/_authenticated/next/assemblies/$assemblyId/pcb/': typeof AuthenticatedNextAssembliesAssemblyIdPcbIndexRoute
  '/_authenticated/next/components/ipn/_details/': typeof AuthenticatedNextComponentsIpnDetailsIndexRoute
  '/_authenticated/next/parts/custom/$customPartSpecificationId/': typeof AuthenticatedNextPartsCustomCustomPartSpecificationIdIndexRoute
  '/_authenticated/next/projects/$projectId/assemblies/': typeof AuthenticatedNextProjectsProjectIdAssembliesIndexRoute
  '/_authenticated/next/projects/$projectId/flexible-calculation/': typeof AuthenticatedNextProjectsProjectIdFlexibleCalculationIndexRoute
  '/_authenticated/next/projects/$projectId/manufacturing/': typeof AuthenticatedNextProjectsProjectIdManufacturingIndexRoute
  '/_authenticated/next/projects/$projectId/sourcing/': typeof AuthenticatedNextProjectsProjectIdSourcingIndexRoute
  '/_authenticated/next/settings/_menu/organization/': typeof AuthenticatedNextSettingsMenuOrganizationIndexRoute
  '/_authenticated/next/templates/manufacturing/activities/': typeof AuthenticatedNextTemplatesManufacturingActivitiesIndexRoute
  '/_authenticated/next/templates/manufacturing/drivers/': typeof AuthenticatedNextTemplatesManufacturingDriversIndexRoute
  '/_authenticated/next/templates/manufacturing/expenses/': typeof AuthenticatedNextTemplatesManufacturingExpensesIndexRoute
  '/_authenticated/next/templates/manufacturing/resources/': typeof AuthenticatedNextTemplatesManufacturingResourcesIndexRoute
  '/_authenticated/parts/components/ipn/_details/': typeof AuthenticatedPartsComponentsIpnDetailsIndexRoute
  '/_authenticated/parts/custom/details/$customPartSpecificationId/': typeof AuthenticatedPartsCustomDetailsCustomPartSpecificationIdIndexRoute
  '/_authenticated/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/': typeof AuthenticatedProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdIndexRoute
  '/_authenticated/settings/_menu/organization/customer-portal/': typeof AuthenticatedSettingsMenuOrganizationCustomerPortalIndexRoute
  '/_authenticated/settings/_menu/organization/pcb/': typeof AuthenticatedSettingsMenuOrganizationPcbIndexRoute
  '/_authenticated/settings/_menu/organization/users/': typeof AuthenticatedSettingsMenuOrganizationUsersIndexRoute
  '/_authenticated/settings/organization/pcb/panel-preferences/': typeof AuthenticatedSettingsOrganizationPcbPanelPreferencesIndexRoute
  '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRouteWithChildren
  '/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId': typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdRouteRouteWithChildren
  '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRouteWithChildren
  '/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/_sidebar': typeof AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarRouteRouteWithChildren
  '/_authenticated/monitoring/_sidebar/components/categories/$categoryId/pricing': typeof AuthenticatedMonitoringSidebarComponentsCategoriesCategoryIdPricingRoute
  '/_authenticated/negotiations/$negotiationId/_sidebar/demand-groups/$demandGroupId/awarding': typeof AuthenticatedNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdAwardingRoute
  '/_authenticated/negotiations/$negotiationId/scenarios/$sourcingScenarioId/line/$sourcingLineItemId': typeof AuthenticatedNegotiationsNegotiationIdScenariosSourcingScenarioIdLineSourcingLineItemIdRoute
  '/_authenticated/next/components/ipn/offers/$offerId/duplicate': typeof AuthenticatedNextComponentsIpnOffersOfferIdDuplicateRoute
  '/_authenticated/next/components/ipn/offers/$offerId/edit': typeof AuthenticatedNextComponentsIpnOffersOfferIdEditRoute
  '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/$quoteRequestId': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsQuoteRequestIdRoute
  '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/assign': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsAssignRoute
  '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/attachments': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsAttachmentsRoute
  '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/delivery-lot-size': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsDeliveryLotSizeRoute
  '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/importer': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsImporterRoute
  '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/line-items': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsLineItemsRoute
  '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/preview-email': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsPreviewEmailRoute
  '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/target-price': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsTargetPriceRoute
  '/_authenticated/next/negotiations/$negotiationId/_sidebar/scenarios/compare': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosCompareRoute
  '/_authenticated/next/negotiations/$negotiationId/_sidebar/scenarios/create': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosCreateRoute
  '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/details': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdDetailsRoute
  '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/edit': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdEditRoute
  '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pnp-importer': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPnpImporterRoute
  '/_authenticated/next/projects/$projectId/sourcing/assembly/$assemblyId': typeof AuthenticatedNextProjectsProjectIdSourcingAssemblyAssemblyIdRoute
  '/_authenticated/next/projects/$projectId/sourcing/overview/$view': typeof AuthenticatedNextProjectsProjectIdSourcingOverviewViewRoute
  '/_authenticated/next/projects/$projectId/sourcing/quote-requests/$quoteRequestId': typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsQuoteRequestIdRoute
  '/_authenticated/next/projects/$projectId/sourcing/quote-requests/assign': typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsAssignRoute
  '/_authenticated/next/projects/$projectId/sourcing/quote-requests/attachments': typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsAttachmentsRoute
  '/_authenticated/next/projects/$projectId/sourcing/quote-requests/delivery-lot-size': typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsDeliveryLotSizeRoute
  '/_authenticated/next/projects/$projectId/sourcing/quote-requests/importer': typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsImporterRoute
  '/_authenticated/next/projects/$projectId/sourcing/quote-requests/line-items': typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsLineItemsRoute
  '/_authenticated/next/projects/$projectId/sourcing/quote-requests/preview-email': typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsPreviewEmailRoute
  '/_authenticated/next/projects/$projectId/sourcing/quote-requests/target-price': typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsTargetPriceRoute
  '/_authenticated/next/projects/$projectId/sourcing/scenarios/create': typeof AuthenticatedNextProjectsProjectIdSourcingScenariosCreateRoute
  '/_authenticated/next/settings/_menu/organization/customer-portal/additional-services': typeof AuthenticatedNextSettingsMenuOrganizationCustomerPortalAdditionalServicesRoute
  '/_authenticated/next/settings/_menu/organization/customer-portal/checkout-conditions': typeof AuthenticatedNextSettingsMenuOrganizationCustomerPortalCheckoutConditionsRoute
  '/_authenticated/next/settings/_menu/organization/customer-portal/customer-specific-settings': typeof AuthenticatedNextSettingsMenuOrganizationCustomerPortalCustomerSpecificSettingsRoute
  '/_authenticated/next/settings/_menu/organization/customer-portal/landing-page': typeof AuthenticatedNextSettingsMenuOrganizationCustomerPortalLandingPageRoute
  '/_authenticated/next/settings/_menu/organization/customer-portal/payment-credentials': typeof AuthenticatedNextSettingsMenuOrganizationCustomerPortalPaymentCredentialsRoute
  '/_authenticated/next/settings/_menu/organization/user-management/action-permissions': typeof AuthenticatedNextSettingsMenuOrganizationUserManagementActionPermissionsRoute
  '/_authenticated/next/settings/_menu/organization/user-management/roles': typeof AuthenticatedNextSettingsMenuOrganizationUserManagementRolesRoute
  '/_authenticated/next/templates/flexible-calculation/apps/$appId/$widgetId': typeof AuthenticatedNextTemplatesFlexibleCalculationAppsAppIdWidgetIdRoute
  '/_authenticated/next/templates/flexible-calculation/review-conversion/$legacyTemplateId/$flexibleCalculationTemplateId': typeof AuthenticatedNextTemplatesFlexibleCalculationReviewConversionLegacyTemplateIdFlexibleCalculationTemplateIdRoute
  '/_authenticated/next/templates/manufacturing/activities/$activityId/duplicate': typeof AuthenticatedNextTemplatesManufacturingActivitiesActivityIdDuplicateRoute
  '/_authenticated/next/templates/manufacturing/activities/$activityId/edit': typeof AuthenticatedNextTemplatesManufacturingActivitiesActivityIdEditRoute
  '/_authenticated/next/templates/manufacturing/apps/$appId/$widgetId': typeof AuthenticatedNextTemplatesManufacturingAppsAppIdWidgetIdRoute
  '/_authenticated/next/templates/manufacturing/drivers/$driverId/duplicate': typeof AuthenticatedNextTemplatesManufacturingDriversDriverIdDuplicateRoute
  '/_authenticated/next/templates/manufacturing/drivers/$driverId/edit': typeof AuthenticatedNextTemplatesManufacturingDriversDriverIdEditRoute
  '/_authenticated/next/templates/manufacturing/expenses/$expenseId/duplicate': typeof AuthenticatedNextTemplatesManufacturingExpensesExpenseIdDuplicateRoute
  '/_authenticated/next/templates/manufacturing/expenses/$expenseId/edit': typeof AuthenticatedNextTemplatesManufacturingExpensesExpenseIdEditRoute
  '/_authenticated/next/templates/manufacturing/resources/$resourceId/duplicate': typeof AuthenticatedNextTemplatesManufacturingResourcesResourceIdDuplicateRoute
  '/_authenticated/next/templates/manufacturing/resources/$resourceId/edit': typeof AuthenticatedNextTemplatesManufacturingResourcesResourceIdEditRoute
  '/_authenticated/parts/components/ipn/offers/$offerId/duplicate': typeof AuthenticatedPartsComponentsIpnOffersOfferIdDuplicateRoute
  '/_authenticated/parts/components/ipn/offers/$offerId/edit': typeof AuthenticatedPartsComponentsIpnOffersOfferIdEditRoute
  '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/details': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdDetailsRoute
  '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/edit': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdEditRoute
  '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pnp-importer': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPnpImporterRoute
  '/_authenticated/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/activity': typeof AuthenticatedProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdActivityRoute
  '/_authenticated/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/expense': typeof AuthenticatedProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdExpenseRoute
  '/_authenticated/projects/$projectId/sourcing/$sourcingScenarioId/line/$sourcingLineItemId': typeof AuthenticatedProjectsProjectIdSourcingSourcingScenarioIdLineSourcingLineItemIdRoute
  '/_authenticated/projects/$projectId/sourcing/_sidebar/overview/$view': typeof AuthenticatedProjectsProjectIdSourcingSidebarOverviewViewRoute
  '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/$quoteRequestId': typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsQuoteRequestIdRoute
  '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/assign': typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsAssignRoute
  '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/attachments': typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsAttachmentsRoute
  '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/delivery-lot-size': typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsDeliveryLotSizeRoute
  '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/excel-importer': typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsExcelImporterRoute
  '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/importer': typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsImporterRoute
  '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/line-items': typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsLineItemsRoute
  '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/preview-email': typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsPreviewEmailRoute
  '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/target-price': typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsTargetPriceRoute
  '/_authenticated/projects/$projectId/sourcing/_sidebar/scenarios/create': typeof AuthenticatedProjectsProjectIdSourcingSidebarScenariosCreateRoute
  '/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/purchase-orders': typeof AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdPurchaseOrdersRoute
  '/_authenticated/settings/_menu/organization/pcb/panel-preferences/create': typeof AuthenticatedSettingsMenuOrganizationPcbPanelPreferencesCreateRoute
  '/_authenticated/templates/_sidebar/flexible-calculation/apps/$appId/$widgetId': typeof AuthenticatedTemplatesSidebarFlexibleCalculationAppsAppIdWidgetIdRoute
  '/_authenticated/templates/_sidebar/flexible-calculation/review-conversion/$legacyTemplateId/$flexibleCalculationTemplateId': typeof AuthenticatedTemplatesSidebarFlexibleCalculationReviewConversionLegacyTemplateIdFlexibleCalculationTemplateIdRoute
  '/_authenticated/negotiations/$negotiationId/_sidebar/demand-groups/$demandGroupId/': typeof AuthenticatedNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdIndexRoute
  '/_authenticated/negotiations/$negotiationId/_sidebar/scenarios/$sourcingScenarioId/': typeof AuthenticatedNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdIndexRoute
  '/_authenticated/next/components/ipn/_details/offers/': typeof AuthenticatedNextComponentsIpnDetailsOffersIndexRoute
  '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsIndexRoute
  '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdIndexRoute
  '/_authenticated/next/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/': typeof AuthenticatedNextProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdIndexRoute
  '/_authenticated/next/projects/$projectId/sourcing/overview/': typeof AuthenticatedNextProjectsProjectIdSourcingOverviewIndexRoute
  '/_authenticated/next/projects/$projectId/sourcing/quote-requests/': typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsIndexRoute
  '/_authenticated/next/settings/_menu/organization/customer-portal/': typeof AuthenticatedNextSettingsMenuOrganizationCustomerPortalIndexRoute
  '/_authenticated/next/settings/_menu/organization/pcb/': typeof AuthenticatedNextSettingsMenuOrganizationPcbIndexRoute
  '/_authenticated/next/settings/_menu/organization/users/': typeof AuthenticatedNextSettingsMenuOrganizationUsersIndexRoute
  '/_authenticated/next/settings/organization/pcb/panel-preferences/': typeof AuthenticatedNextSettingsOrganizationPcbPanelPreferencesIndexRoute
  '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdIndexRoute
  '/_authenticated/projects/$projectId/sourcing/_sidebar/overview/': typeof AuthenticatedProjectsProjectIdSourcingSidebarOverviewIndexRoute
  '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/': typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsIndexRoute
  '/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/': typeof AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdIndexRoute
  '/_authenticated/next/negotiations/$negotiationId/_sidebar/demand-groups/$demandGroupId/awarding': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdAwardingRoute
  '/_authenticated/next/negotiations/$negotiationId/scenarios/$sourcingScenarioId/line-items/$sourcingLineItemId': typeof AuthenticatedNextNegotiationsNegotiationIdScenariosSourcingScenarioIdLineItemsSourcingLineItemIdRoute
  '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/cad-viewer': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbCadViewerRoute
  '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/dfm': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbDfmRoute
  '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/dfm-analysis': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbDfmAnalysisRoute
  '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/drills': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbDrillsRoute
  '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/files': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbFilesRoute
  '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/panelization': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbPanelizationRoute
  '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/specification': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbSpecificationRoute
  '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/stackup': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbStackupRoute
  '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/subassemblies/create': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdSubassembliesCreateRoute
  '/_authenticated/next/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/activity': typeof AuthenticatedNextProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdActivityRoute
  '/_authenticated/next/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/expense': typeof AuthenticatedNextProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdExpenseRoute
  '/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/purchase-orders': typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdPurchaseOrdersRoute
  '/_authenticated/next/settings/_menu/organization/pcb/panel-preferences/create': typeof AuthenticatedNextSettingsMenuOrganizationPcbPanelPreferencesCreateRoute
  '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/cad-viewer': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbCadViewerRoute
  '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/dfm': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbDfmRoute
  '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/dfm-analysis': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbDfmAnalysisRoute
  '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/drills': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbDrillsRoute
  '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/files': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbFilesRoute
  '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/panelization': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbPanelizationRoute
  '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/specification': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbSpecificationRoute
  '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/stackup': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbStackupRoute
  '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/subassemblies/create': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdSubassembliesCreateRoute
  '/_authenticated/projects/$projectId/sourcing/offer/custom-part/$offerId/duplicate': typeof AuthenticatedProjectsProjectIdSourcingOfferCustomPartOfferIdDuplicateRoute
  '/_authenticated/projects/$projectId/sourcing/offer/custom-part/$offerId/edit': typeof AuthenticatedProjectsProjectIdSourcingOfferCustomPartOfferIdEditRoute
  '/_authenticated/projects/$projectId/sourcing/offer/internal-part-number/$offerId/duplicate': typeof AuthenticatedProjectsProjectIdSourcingOfferInternalPartNumberOfferIdDuplicateRoute
  '/_authenticated/projects/$projectId/sourcing/offer/internal-part-number/$offerId/edit': typeof AuthenticatedProjectsProjectIdSourcingOfferInternalPartNumberOfferIdEditRoute
  '/_authenticated/projects/$projectId/sourcing/offer/off-the-shelf/$offerId/duplicate': typeof AuthenticatedProjectsProjectIdSourcingOfferOffTheShelfOfferIdDuplicateRoute
  '/_authenticated/projects/$projectId/sourcing/offer/off-the-shelf/$offerId/edit': typeof AuthenticatedProjectsProjectIdSourcingOfferOffTheShelfOfferIdEditRoute
  '/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/_sidebar/line-items': typeof AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarLineItemsRoute
  '/_authenticated/settings/_menu/organization/pcb/panel-preferences/$panelPreferenceId/edit': typeof AuthenticatedSettingsMenuOrganizationPcbPanelPreferencesPanelPreferenceIdEditRoute
  '/_authenticated/negotiations/$negotiationId/_sidebar/scenarios/$sourcingScenarioId/cost-breakdown/': typeof AuthenticatedNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownIndexRoute
  '/_authenticated/next/negotiations/$negotiationId/_sidebar/demand-groups/$demandGroupId/': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdIndexRoute
  '/_authenticated/next/negotiations/$negotiationId/_sidebar/scenarios/$sourcingScenarioId/': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdIndexRoute
  '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/': typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbIndexRoute
  '/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/': typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdIndexRoute
  '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/': typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbIndexRoute
  '/_authenticated/next/projects/$projectId/sourcing/offers/custom-part/$offerId/duplicate': typeof AuthenticatedNextProjectsProjectIdSourcingOffersCustomPartOfferIdDuplicateRoute
  '/_authenticated/next/projects/$projectId/sourcing/offers/custom-part/$offerId/edit': typeof AuthenticatedNextProjectsProjectIdSourcingOffersCustomPartOfferIdEditRoute
  '/_authenticated/next/projects/$projectId/sourcing/offers/internal-part-number/$offerId/duplicate': typeof AuthenticatedNextProjectsProjectIdSourcingOffersInternalPartNumberOfferIdDuplicateRoute
  '/_authenticated/next/projects/$projectId/sourcing/offers/internal-part-number/$offerId/edit': typeof AuthenticatedNextProjectsProjectIdSourcingOffersInternalPartNumberOfferIdEditRoute
  '/_authenticated/next/projects/$projectId/sourcing/offers/off-the-shelf/$offerId/duplicate': typeof AuthenticatedNextProjectsProjectIdSourcingOffersOffTheShelfOfferIdDuplicateRoute
  '/_authenticated/next/projects/$projectId/sourcing/offers/off-the-shelf/$offerId/edit': typeof AuthenticatedNextProjectsProjectIdSourcingOffersOffTheShelfOfferIdEditRoute
  '/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/line-items/$sourcingLineItemId': typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdLineItemsSourcingLineItemIdRoute
  '/_authenticated/next/settings/_menu/organization/pcb/panel-preferences/$panelPreferenceId/edit': typeof AuthenticatedNextSettingsMenuOrganizationPcbPanelPreferencesPanelPreferenceIdEditRoute
  '/_authenticated/next/negotiations/$negotiationId/_sidebar/scenarios/$sourcingScenarioId/cost-breakdown/': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownIndexRoute
  '/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/cost-breakdown/': typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdCostBreakdownIndexRoute
  '/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/line-items/': typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdLineItemsIndexRoute
  '/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/_sidebar/cost-breakdown/': typeof AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarCostBreakdownIndexRoute
  '/_authenticated/negotiations/$negotiationId/_sidebar/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId': typeof AuthenticatedNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownAssemblyAssemblyIdDemandDemandIdRoute
  '/_authenticated/next/negotiations/$negotiationId/_sidebar/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId': typeof AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownAssemblyAssemblyIdDemandDemandIdRoute
  '/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId': typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdCostBreakdownAssemblyAssemblyIdDemandDemandIdRoute
  '/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/_sidebar/cost-breakdown/assembly/$assemblyId/demand/$demandId': typeof AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarCostBreakdownAssemblyAssemblyIdDemandDemandIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/callback'
    | '/landing'
    | '/customer-portal'
    | '/monitoring'
    | '/next'
    | '/risk-management'
    | '/$'
    | '/home'
    | '/project_creation'
    | '/purchase-orders'
    | '/rfqs'
    | '/start'
    | '/auth/enter-email'
    | '/manufacturers'
    | '/manufacturing'
    | '/parts'
    | '/settings'
    | '/suppliers'
    | '/templates'
    | '/apps/$'
    | '/assemblies/add-assembly'
    | '/components/import'
    | '/customers/$customerId'
    | '/customers/importer'
    | '/manufacturer/$'
    | '/manufacturers/$manufacturerId'
    | '/manufacturers/importer'
    | '/manufacturing/add-activity'
    | '/manufacturing/add-driver'
    | '/manufacturing/add-expense'
    | '/manufacturing/add-resource'
    | '/monitoring/analysis'
    | '/negotiations/create'
    | '/next/$'
    | '/next/alerts'
    | '/next/home'
    | '/next/lumi-agent'
    | '/next/purchase-orders'
    | '/offers/mpn-offer-importer'
    | '/orders/upload'
    | '/orders/{-$orderId}'
    | '/parts/off-the-shelf-part-search'
    | '/projects/create'
    | '/projects/new'
    | '/quote-requests/excel-importer'
    | '/risk-management/geo-risk'
    | '/risk-management/pcns'
    | '/risk-management/risk-digest'
    | '/settings/company'
    | '/supplier/importer'
    | '/suppliers/$supplierAndStockLocationId'
    | '/suppliers/importer'
    | '/template/$'
    | '/auth/signup/customer'
    | '/auth/signup/invite'
    | '/assemblies/'
    | '/customer-portal/'
    | '/customers/'
    | '/manufacturing/'
    | '/negotiations/'
    | '/next/'
    | '/parts/'
    | '/projects/'
    | '/risk-management/'
    | '/settings/'
    | '/supplier-portal/'
    | '/templates/'
    | '/assemblies/$assemblyId/pcb'
    | '/negotiations/$negotiationId'
    | '/next/parts/$partId'
    | '/next/projects/$projectId'
    | '/next/settings'
    | '/parts/details/$partId'
    | '/3rdparty/digikey/callback'
    | '/assemblies/$assemblyId/dashboard'
    | '/assemblies/$assemblyId/details'
    | '/assemblies/$assemblyId/edit'
    | '/manufacturers/line-card'
    | '/manufacturing/activities/create'
    | '/manufacturing/activity/$'
    | '/manufacturing/driver/$'
    | '/manufacturing/drivers/create'
    | '/manufacturing/expense/$'
    | '/manufacturing/expenses/create'
    | '/manufacturing/resource/$'
    | '/manufacturing/resources/create'
    | '/manufacturing/template/$'
    | '/monitoring/component-savings'
    | '/monitoring/data-health'
    | '/monitoring/offers'
    | '/monitoring/onboarding'
    | '/monitoring/agent/$'
    | '/monitoring/charts/$chartId'
    | '/next/apps/$'
    | '/next/components/linking'
    | '/next/customers/$customerId'
    | '/next/demands/importer'
    | '/next/manufacturers/$manufacturerId'
    | '/next/manufacturers/line-card'
    | '/next/negotiations/create'
    | '/next/offer-imports/$offerImportId'
    | '/next/orders/upload'
    | '/next/orders/{-$orderId}'
    | '/next/parts/search'
    | '/next/projects/create'
    | '/next/quote-requests/importer'
    | '/next/risk-management/geo-risk'
    | '/next/risk-management/pcns'
    | '/next/risk-management/risk-digest'
    | '/next/settings/company'
    | '/next/suppliers/$supplierAndStockLocationId'
    | '/next/suppliers/strategy'
    | '/next/templates/export'
    | '/next/templates/pcb-specification'
    | '/parts/alerts'
    | '/parts/search'
    | '/parts/components/component-importer'
    | '/parts/components/importer'
    | '/parts/components/linking'
    | '/parts/demand/demand-importer'
    | '/parts/offers/add'
    | '/parts/offers/create'
    | '/parts/offers/csv-importer'
    | '/parts/quote-requests/excel-importer'
    | '/parts/quote-requests/importer'
    | '/projects/$projectId/dashboard'
    | '/projects/$projectId/edit'
    | '/projects/$projectId/quotation'
    | '/risk-management/library-health/assemblies'
    | '/risk-management/library-health/components'
    | '/risk-management/library-health/parts'
    | '/suppliers/strategy'
    | '/suppliers/line-card-rules/importer'
    | '/suppliers/supplier-contacts-importer/bulk'
    | '/suppliers/supplier-contacts/importer'
    | '/templates/export'
    | '/templates/pcb-specification'
    | '/templates/calculation/add-template'
    | '/templates/calculation/create'
    | '/templates/flexible-calculation/new'
    | '/templates/quotation/create'
    | '/templates/quotation/edit'
    | '/assemblies/$assemblyId/'
    | '/manufacturers/'
    | '/monitoring/'
    | '/negotiations/$negotiationId/'
    | '/next/assemblies/'
    | '/next/components/'
    | '/next/customers/'
    | '/next/demands/'
    | '/next/manufacturers/'
    | '/next/negotiations/'
    | '/next/offer-imports/'
    | '/next/parts/'
    | '/next/projects/'
    | '/next/quote-requests/'
    | '/next/risk-management/'
    | '/next/settings/'
    | '/next/suppliers/'
    | '/projects/$projectId/'
    | '/risk-management/library-health/'
    | '/suppliers/'
    | '/next/assemblies/$assemblyId/pcb'
    | '/next/components/ipn'
    | '/next/negotiations/$negotiationId'
    | '/next/parts/custom/$customPartSpecificationId'
    | '/parts/components/ipn'
    | '/parts/custom/details/$customPartSpecificationId'
    | '/projects/$projectId/sourcing'
    | '/assemblies/$assemblyId/pcb/cad-viewer'
    | '/assemblies/$assemblyId/pcb/dfm'
    | '/assemblies/$assemblyId/pcb/dfm-analysis'
    | '/assemblies/$assemblyId/pcb/drills'
    | '/assemblies/$assemblyId/pcb/files'
    | '/assemblies/$assemblyId/pcb/panelization'
    | '/assemblies/$assemblyId/pcb/specification'
    | '/assemblies/$assemblyId/pcb/stackup'
    | '/assemblies/$assemblyId/subassemblies/create'
    | '/manufacturing/templates/{-$templateId}'
    | '/manufacturing/activities/$activityId/duplicate'
    | '/manufacturing/activities/$activityId/edit'
    | '/manufacturing/drivers/$driverId/duplicate'
    | '/manufacturing/drivers/$driverId/edit'
    | '/manufacturing/expenses/$expenseId/duplicate'
    | '/manufacturing/expenses/$expenseId/edit'
    | '/manufacturing/resources/$resourceId/duplicate'
    | '/manufacturing/resources/$resourceId/edit'
    | '/monitoring/components/pricing'
    | '/monitoring/dashboards/$dashboardId'
    | '/monitoring/insights-agent/{-$conversationId}'
    | '/monitoring/jobs/$jobId'
    | '/monitoring/reports/savings'
    | '/negotiations/$negotiationId/overview'
    | '/next/assemblies/$assemblyId/dashboard'
    | '/next/assemblies/$assemblyId/details'
    | '/next/assemblies/$assemblyId/edit'
    | '/next/parts/$partId/compliance'
    | '/next/parts/$partId/offers'
    | '/next/parts/$partId/part-alternatives'
    | '/next/parts/$partId/se-alternatives'
    | '/next/parts/$partId/se-documentation'
    | '/next/parts/$partId/se-geo-risk'
    | '/next/parts/$partId/se-supply-chain'
    | '/next/parts/$partId/se-technical'
    | '/next/parts/$partId/used-in'
    | '/next/projects/$projectId/dashboard'
    | '/next/projects/$projectId/edit'
    | '/next/projects/$projectId/quotation'
    | '/next/risk-management/library-health/assemblies'
    | '/next/risk-management/library-health/components'
    | '/next/risk-management/library-health/parts'
    | '/next/templates/email/create'
    | '/next/templates/flexible-calculation/$flexibleCalculationTemplateId'
    | '/next/templates/flexible-calculation/create'
    | '/next/templates/flexible-calculation/exported-variables'
    | '/next/templates/quote-request/create'
    | '/next/templates/sourcing/create'
    | '/parts/demands/importer'
    | '/parts/details/$partId/compliance'
    | '/parts/details/$partId/offers'
    | '/parts/details/$partId/part-alternatives'
    | '/parts/details/$partId/se-alternatives'
    | '/parts/details/$partId/se-documentation'
    | '/parts/details/$partId/se-geo-risk'
    | '/parts/details/$partId/se-supply-chain'
    | '/parts/details/$partId/se-technical'
    | '/parts/details/$partId/used-in'
    | '/parts/offers/$offerId/duplicate'
    | '/parts/offers/$offerId/edit'
    | '/projects/$projectId/calculation/print'
    | '/projects/$projectId/flexible-calculation/$flexibleCalculationId'
    | '/projects/$projectId/order/confirmation'
    | '/projects/$projectId/sourcing/demand-groups'
    | '/settings/organization/api-integration'
    | '/settings/organization/assembly-settings'
    | '/settings/organization/automatic-rfq-number'
    | '/settings/organization/branding'
    | '/settings/organization/carbon-footprints'
    | '/settings/organization/component-settings'
    | '/settings/organization/csv-integration'
    | '/settings/organization/custom-part-categories'
    | '/settings/organization/data-integrations'
    | '/settings/organization/feature-flags'
    | '/settings/organization/manufacturer-preferences'
    | '/settings/organization/sites'
    | '/settings/organization/supplier-api-integrations'
    | '/settings/user/account-security'
    | '/settings/organization/pcb/$panelPreferenceId'
    | '/settings/organization/pcb/add-preference'
    | '/settings/organization/users/importer'
    | '/supplier-portal/quote-requests/$quoteRequestId/excel-importer'
    | '/supplier-portal/quote-requests/$quoteRequestId/import-pdf'
    | '/supplier-portal/quote-requests/$quoteRequestId/pdf-importer'
    | '/suppliers/$supplierId/supplier-contacts-importer/$'
    | '/suppliers/$supplierId/supplier-contacts/importer'
    | '/templates/email/create'
    | '/templates/flexible-calculation/$flexibleCalculationTemplateId'
    | '/templates/flexible-calculation/create'
    | '/templates/flexible-calculation/exported-variables'
    | '/templates/quote-request/create'
    | '/templates/sourcing/create'
    | '/templates/calculation/$templateId/edit'
    | '/templates/email/$emailTemplateId/update'
    | '/assemblies/$assemblyId/pcb/'
    | '/manufacturing/activities/'
    | '/manufacturing/drivers/'
    | '/manufacturing/expenses/'
    | '/manufacturing/resources/'
    | '/monitoring/charts/'
    | '/monitoring/dashboards/'
    | '/monitoring/jobs/'
    | '/next/assemblies/$assemblyId/'
    | '/next/negotiations/$negotiationId/'
    | '/next/parts/$partId/'
    | '/next/projects/$projectId/'
    | '/next/risk-management/library-health/'
    | '/next/suppliers/supplier-contacts/'
    | '/next/templates/email/'
    | '/next/templates/flexible-calculation/'
    | '/next/templates/quotation/'
    | '/next/templates/quote-request/'
    | '/next/templates/sourcing/'
    | '/parts/components/'
    | '/parts/demands/'
    | '/parts/quote-requests/'
    | '/parts/details/$partId/'
    | '/projects/$projectId/bom/'
    | '/projects/$projectId/calculation/'
    | '/projects/$projectId/flexible-calculation/'
    | '/projects/$projectId/manufacturing/'
    | '/projects/$projectId/order/'
    | '/projects/$projectId/sourcing/'
    | '/settings/organization/'
    | '/supplier-portal/quote-requests/$quoteRequestId/'
    | '/suppliers/supplier-contacts/'
    | '/templates/calculation/'
    | '/templates/email/'
    | '/templates/flexible-calculation/'
    | '/templates/quotation/'
    | '/templates/quote-request/'
    | '/templates/sourcing/'
    | '/next/projects/$projectId/sourcing/overview'
    | '/manufacturing/apps/$appId/$widgetId'
    | '/negotiations/$negotiationId/quote-requests/$quoteRequestId'
    | '/negotiations/$negotiationId/quote-requests/assign'
    | '/negotiations/$negotiationId/quote-requests/attachments'
    | '/negotiations/$negotiationId/quote-requests/delivery-lot-size'
    | '/negotiations/$negotiationId/quote-requests/excel-importer'
    | '/negotiations/$negotiationId/quote-requests/importer'
    | '/negotiations/$negotiationId/quote-requests/line-items'
    | '/negotiations/$negotiationId/quote-requests/preview-email'
    | '/negotiations/$negotiationId/quote-requests/target-price'
    | '/negotiations/$negotiationId/scenarios/compare'
    | '/negotiations/$negotiationId/scenarios/create'
    | '/next/assemblies/$assemblyId/pcb/cad-viewer'
    | '/next/assemblies/$assemblyId/pcb/dfm'
    | '/next/assemblies/$assemblyId/pcb/dfm-analysis'
    | '/next/assemblies/$assemblyId/pcb/drills'
    | '/next/assemblies/$assemblyId/pcb/files'
    | '/next/assemblies/$assemblyId/pcb/panelization'
    | '/next/assemblies/$assemblyId/pcb/specification'
    | '/next/assemblies/$assemblyId/pcb/stackup'
    | '/next/assemblies/$assemblyId/subassemblies/create'
    | '/next/components/ipn/cpns'
    | '/next/components/ipn/linking'
    | '/next/components/ipn/used-in'
    | '/next/negotiations/$negotiationId/overview'
    | '/next/parts/custom/$customPartSpecificationId/offers'
    | '/next/parts/custom/$customPartSpecificationId/used-in'
    | '/next/parts/offers/$offerId/duplicate'
    | '/next/parts/offers/$offerId/edit'
    | '/next/projects/$projectId/flexible-calculation/$flexibleCalculationId'
    | '/next/projects/$projectId/sourcing/compare'
    | '/next/projects/$projectId/sourcing/version-history'
    | '/next/settings/organization/api-integration'
    | '/next/settings/organization/assembly-settings'
    | '/next/settings/organization/automatic-rfq-number'
    | '/next/settings/organization/branding'
    | '/next/settings/organization/carbon-footprints'
    | '/next/settings/organization/component-settings'
    | '/next/settings/organization/csv-integration'
    | '/next/settings/organization/custom-part-categories'
    | '/next/settings/organization/data-integrations'
    | '/next/settings/organization/feature-flags'
    | '/next/settings/organization/manufacturer-preferences'
    | '/next/settings/organization/sites'
    | '/next/settings/organization/supplier-api-integrations'
    | '/next/settings/user/account-security'
    | '/next/settings/organization/users/importer'
    | '/next/templates/email/$emailTemplateId/edit'
    | '/next/templates/manufacturing/activities/create'
    | '/next/templates/manufacturing/drivers/create'
    | '/next/templates/manufacturing/expenses/create'
    | '/next/templates/manufacturing/resources/create'
    | '/next/templates/manufacturing/templates/{-$templateId}'
    | '/next/templates/quotation/builder/{-$templateId}'
    | '/next/templates/quote-request/$quoteRequestTemplateId/edit'
    | '/next/templates/sourcing/$sourcingTemplateId/duplicate'
    | '/next/templates/sourcing/$sourcingTemplateId/edit'
    | '/parts/components/ipn/cpns'
    | '/parts/components/ipn/linking'
    | '/parts/components/ipn/offers'
    | '/parts/components/ipn/used-in'
    | '/parts/custom/details/$customPartSpecificationId/offers'
    | '/parts/custom/details/$customPartSpecificationId/used-in'
    | '/projects/$projectId/bom/assembly/add-assembly'
    | '/projects/$projectId/calculation/$assemblyId/calculation'
    | '/projects/$projectId/calculation/assemblies/$assemblyId'
    | '/projects/$projectId/sourcing/compare'
    | '/projects/$projectId/sourcing/version-history'
    | '/projects/$projectId/sourcing/assembly/$assemblyId'
    | '/settings/organization/customer-portal/additional-services'
    | '/settings/organization/customer-portal/checkout-conditions'
    | '/settings/organization/customer-portal/customer-specific-settings'
    | '/settings/organization/customer-portal/landing-page'
    | '/settings/organization/customer-portal/payment-credentials'
    | '/settings/organization/user-management/action-permissions'
    | '/settings/organization/user-management/roles'
    | '/templates/email/$emailTemplateId/edit'
    | '/templates/quotation/builder/{-$templateId}'
    | '/templates/quote-request/$quoteRequestTemplateId/edit'
    | '/templates/sourcing/$sourcingTemplateId/duplicate'
    | '/templates/sourcing/$sourcingTemplateId/edit'
    | '/negotiations/$negotiationId/quote-requests/'
    | '/next/assemblies/$assemblyId/pcb/'
    | '/next/components/ipn/'
    | '/next/parts/custom/$customPartSpecificationId/'
    | '/next/projects/$projectId/assemblies/'
    | '/next/projects/$projectId/flexible-calculation/'
    | '/next/projects/$projectId/manufacturing/'
    | '/next/projects/$projectId/sourcing/'
    | '/next/settings/organization/'
    | '/next/templates/manufacturing/activities/'
    | '/next/templates/manufacturing/drivers/'
    | '/next/templates/manufacturing/expenses/'
    | '/next/templates/manufacturing/resources/'
    | '/parts/components/ipn/'
    | '/parts/custom/details/$customPartSpecificationId/'
    | '/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/'
    | '/settings/organization/customer-portal/'
    | '/settings/organization/pcb/'
    | '/settings/organization/users/'
    | '/settings/organization/pcb/panel-preferences/'
    | '/next/projects/$projectId/assemblies/$assemblyId/pcb'
    | '/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId'
    | '/projects/$projectId/bom/assembly/$assemblyId/pcb'
    | '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId'
    | '/monitoring/components/categories/$categoryId/pricing'
    | '/negotiations/$negotiationId/demand-groups/$demandGroupId/awarding'
    | '/negotiations/$negotiationId/scenarios/$sourcingScenarioId/line/$sourcingLineItemId'
    | '/next/components/ipn/offers/$offerId/duplicate'
    | '/next/components/ipn/offers/$offerId/edit'
    | '/next/negotiations/$negotiationId/quote-requests/$quoteRequestId'
    | '/next/negotiations/$negotiationId/quote-requests/assign'
    | '/next/negotiations/$negotiationId/quote-requests/attachments'
    | '/next/negotiations/$negotiationId/quote-requests/delivery-lot-size'
    | '/next/negotiations/$negotiationId/quote-requests/importer'
    | '/next/negotiations/$negotiationId/quote-requests/line-items'
    | '/next/negotiations/$negotiationId/quote-requests/preview-email'
    | '/next/negotiations/$negotiationId/quote-requests/target-price'
    | '/next/negotiations/$negotiationId/scenarios/compare'
    | '/next/negotiations/$negotiationId/scenarios/create'
    | '/next/projects/$projectId/assemblies/$assemblyId/details'
    | '/next/projects/$projectId/assemblies/$assemblyId/edit'
    | '/next/projects/$projectId/assemblies/$assemblyId/pnp-importer'
    | '/next/projects/$projectId/sourcing/assembly/$assemblyId'
    | '/next/projects/$projectId/sourcing/overview/$view'
    | '/next/projects/$projectId/sourcing/quote-requests/$quoteRequestId'
    | '/next/projects/$projectId/sourcing/quote-requests/assign'
    | '/next/projects/$projectId/sourcing/quote-requests/attachments'
    | '/next/projects/$projectId/sourcing/quote-requests/delivery-lot-size'
    | '/next/projects/$projectId/sourcing/quote-requests/importer'
    | '/next/projects/$projectId/sourcing/quote-requests/line-items'
    | '/next/projects/$projectId/sourcing/quote-requests/preview-email'
    | '/next/projects/$projectId/sourcing/quote-requests/target-price'
    | '/next/projects/$projectId/sourcing/scenarios/create'
    | '/next/settings/organization/customer-portal/additional-services'
    | '/next/settings/organization/customer-portal/checkout-conditions'
    | '/next/settings/organization/customer-portal/customer-specific-settings'
    | '/next/settings/organization/customer-portal/landing-page'
    | '/next/settings/organization/customer-portal/payment-credentials'
    | '/next/settings/organization/user-management/action-permissions'
    | '/next/settings/organization/user-management/roles'
    | '/next/templates/flexible-calculation/apps/$appId/$widgetId'
    | '/next/templates/flexible-calculation/review-conversion/$legacyTemplateId/$flexibleCalculationTemplateId'
    | '/next/templates/manufacturing/activities/$activityId/duplicate'
    | '/next/templates/manufacturing/activities/$activityId/edit'
    | '/next/templates/manufacturing/apps/$appId/$widgetId'
    | '/next/templates/manufacturing/drivers/$driverId/duplicate'
    | '/next/templates/manufacturing/drivers/$driverId/edit'
    | '/next/templates/manufacturing/expenses/$expenseId/duplicate'
    | '/next/templates/manufacturing/expenses/$expenseId/edit'
    | '/next/templates/manufacturing/resources/$resourceId/duplicate'
    | '/next/templates/manufacturing/resources/$resourceId/edit'
    | '/parts/components/ipn/offers/$offerId/duplicate'
    | '/parts/components/ipn/offers/$offerId/edit'
    | '/projects/$projectId/bom/assembly/$assemblyId/details'
    | '/projects/$projectId/bom/assembly/$assemblyId/edit'
    | '/projects/$projectId/bom/assembly/$assemblyId/pnp-importer'
    | '/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/activity'
    | '/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/expense'
    | '/projects/$projectId/sourcing/$sourcingScenarioId/line/$sourcingLineItemId'
    | '/projects/$projectId/sourcing/overview/$view'
    | '/projects/$projectId/sourcing/quote-requests/$quoteRequestId'
    | '/projects/$projectId/sourcing/quote-requests/assign'
    | '/projects/$projectId/sourcing/quote-requests/attachments'
    | '/projects/$projectId/sourcing/quote-requests/delivery-lot-size'
    | '/projects/$projectId/sourcing/quote-requests/excel-importer'
    | '/projects/$projectId/sourcing/quote-requests/importer'
    | '/projects/$projectId/sourcing/quote-requests/line-items'
    | '/projects/$projectId/sourcing/quote-requests/preview-email'
    | '/projects/$projectId/sourcing/quote-requests/target-price'
    | '/projects/$projectId/sourcing/scenarios/create'
    | '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/purchase-orders'
    | '/settings/organization/pcb/panel-preferences/create'
    | '/templates/flexible-calculation/apps/$appId/$widgetId'
    | '/templates/flexible-calculation/review-conversion/$legacyTemplateId/$flexibleCalculationTemplateId'
    | '/negotiations/$negotiationId/demand-groups/$demandGroupId/'
    | '/negotiations/$negotiationId/scenarios/$sourcingScenarioId/'
    | '/next/components/ipn/offers/'
    | '/next/negotiations/$negotiationId/quote-requests/'
    | '/next/projects/$projectId/assemblies/$assemblyId/'
    | '/next/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/'
    | '/next/projects/$projectId/sourcing/overview/'
    | '/next/projects/$projectId/sourcing/quote-requests/'
    | '/next/settings/organization/customer-portal/'
    | '/next/settings/organization/pcb/'
    | '/next/settings/organization/users/'
    | '/next/settings/organization/pcb/panel-preferences/'
    | '/projects/$projectId/bom/assembly/$assemblyId/'
    | '/projects/$projectId/sourcing/overview/'
    | '/projects/$projectId/sourcing/quote-requests/'
    | '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/'
    | '/next/negotiations/$negotiationId/demand-groups/$demandGroupId/awarding'
    | '/next/negotiations/$negotiationId/scenarios/$sourcingScenarioId/line-items/$sourcingLineItemId'
    | '/next/projects/$projectId/assemblies/$assemblyId/pcb/cad-viewer'
    | '/next/projects/$projectId/assemblies/$assemblyId/pcb/dfm'
    | '/next/projects/$projectId/assemblies/$assemblyId/pcb/dfm-analysis'
    | '/next/projects/$projectId/assemblies/$assemblyId/pcb/drills'
    | '/next/projects/$projectId/assemblies/$assemblyId/pcb/files'
    | '/next/projects/$projectId/assemblies/$assemblyId/pcb/panelization'
    | '/next/projects/$projectId/assemblies/$assemblyId/pcb/specification'
    | '/next/projects/$projectId/assemblies/$assemblyId/pcb/stackup'
    | '/next/projects/$projectId/assemblies/$assemblyId/subassemblies/create'
    | '/next/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/activity'
    | '/next/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/expense'
    | '/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/purchase-orders'
    | '/next/settings/organization/pcb/panel-preferences/create'
    | '/projects/$projectId/bom/assembly/$assemblyId/pcb/cad-viewer'
    | '/projects/$projectId/bom/assembly/$assemblyId/pcb/dfm'
    | '/projects/$projectId/bom/assembly/$assemblyId/pcb/dfm-analysis'
    | '/projects/$projectId/bom/assembly/$assemblyId/pcb/drills'
    | '/projects/$projectId/bom/assembly/$assemblyId/pcb/files'
    | '/projects/$projectId/bom/assembly/$assemblyId/pcb/panelization'
    | '/projects/$projectId/bom/assembly/$assemblyId/pcb/specification'
    | '/projects/$projectId/bom/assembly/$assemblyId/pcb/stackup'
    | '/projects/$projectId/bom/assembly/$assemblyId/subassemblies/create'
    | '/projects/$projectId/sourcing/offer/custom-part/$offerId/duplicate'
    | '/projects/$projectId/sourcing/offer/custom-part/$offerId/edit'
    | '/projects/$projectId/sourcing/offer/internal-part-number/$offerId/duplicate'
    | '/projects/$projectId/sourcing/offer/internal-part-number/$offerId/edit'
    | '/projects/$projectId/sourcing/offer/off-the-shelf/$offerId/duplicate'
    | '/projects/$projectId/sourcing/offer/off-the-shelf/$offerId/edit'
    | '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/line-items'
    | '/settings/organization/pcb/panel-preferences/$panelPreferenceId/edit'
    | '/negotiations/$negotiationId/scenarios/$sourcingScenarioId/cost-breakdown/'
    | '/next/negotiations/$negotiationId/demand-groups/$demandGroupId/'
    | '/next/negotiations/$negotiationId/scenarios/$sourcingScenarioId/'
    | '/next/projects/$projectId/assemblies/$assemblyId/pcb/'
    | '/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/'
    | '/projects/$projectId/bom/assembly/$assemblyId/pcb/'
    | '/next/projects/$projectId/sourcing/offers/custom-part/$offerId/duplicate'
    | '/next/projects/$projectId/sourcing/offers/custom-part/$offerId/edit'
    | '/next/projects/$projectId/sourcing/offers/internal-part-number/$offerId/duplicate'
    | '/next/projects/$projectId/sourcing/offers/internal-part-number/$offerId/edit'
    | '/next/projects/$projectId/sourcing/offers/off-the-shelf/$offerId/duplicate'
    | '/next/projects/$projectId/sourcing/offers/off-the-shelf/$offerId/edit'
    | '/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/line-items/$sourcingLineItemId'
    | '/next/settings/organization/pcb/panel-preferences/$panelPreferenceId/edit'
    | '/next/negotiations/$negotiationId/scenarios/$sourcingScenarioId/cost-breakdown/'
    | '/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/cost-breakdown/'
    | '/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/line-items/'
    | '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/cost-breakdown/'
    | '/negotiations/$negotiationId/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId'
    | '/next/negotiations/$negotiationId/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId'
    | '/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId'
    | '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/callback'
    | '/landing'
    | '/monitoring'
    | '/$'
    | '/home'
    | '/project_creation'
    | '/purchase-orders'
    | '/rfqs'
    | '/start'
    | '/auth/enter-email'
    | '/'
    | '/manufacturing'
    | '/parts'
    | '/settings'
    | '/templates'
    | '/apps/$'
    | '/assemblies/add-assembly'
    | '/components/import'
    | '/customers/$customerId'
    | '/customers/importer'
    | '/manufacturer/$'
    | '/manufacturers/$manufacturerId'
    | '/manufacturers/importer'
    | '/manufacturing/add-activity'
    | '/manufacturing/add-driver'
    | '/manufacturing/add-expense'
    | '/manufacturing/add-resource'
    | '/monitoring/analysis'
    | '/negotiations/create'
    | '/next/$'
    | '/next/alerts'
    | '/next/home'
    | '/next/lumi-agent'
    | '/next/purchase-orders'
    | '/offers/mpn-offer-importer'
    | '/orders/upload'
    | '/orders/{-$orderId}'
    | '/parts/off-the-shelf-part-search'
    | '/projects/create'
    | '/projects/new'
    | '/quote-requests/excel-importer'
    | '/risk-management/geo-risk'
    | '/risk-management/pcns'
    | '/risk-management/risk-digest'
    | '/settings/company'
    | '/supplier/importer'
    | '/suppliers/$supplierAndStockLocationId'
    | '/suppliers/importer'
    | '/template/$'
    | '/auth/signup/customer'
    | '/auth/signup/invite'
    | '/assemblies'
    | '/customer-portal'
    | '/customers'
    | '/negotiations'
    | '/next'
    | '/projects'
    | '/risk-management'
    | '/supplier-portal'
    | '/negotiations/$negotiationId'
    | '/next/settings'
    | '/3rdparty/digikey/callback'
    | '/assemblies/$assemblyId/dashboard'
    | '/assemblies/$assemblyId/details'
    | '/assemblies/$assemblyId/edit'
    | '/manufacturers/line-card'
    | '/manufacturing/activities/create'
    | '/manufacturing/activity/$'
    | '/manufacturing/driver/$'
    | '/manufacturing/drivers/create'
    | '/manufacturing/expense/$'
    | '/manufacturing/expenses/create'
    | '/manufacturing/resource/$'
    | '/manufacturing/resources/create'
    | '/manufacturing/template/$'
    | '/monitoring/component-savings'
    | '/monitoring/data-health'
    | '/monitoring/offers'
    | '/monitoring/onboarding'
    | '/monitoring/agent/$'
    | '/monitoring/charts/$chartId'
    | '/next/apps/$'
    | '/next/components/linking'
    | '/next/customers/$customerId'
    | '/next/demands/importer'
    | '/next/manufacturers/$manufacturerId'
    | '/next/manufacturers/line-card'
    | '/next/negotiations/create'
    | '/next/offer-imports/$offerImportId'
    | '/next/orders/upload'
    | '/next/orders/{-$orderId}'
    | '/next/parts/search'
    | '/next/projects/create'
    | '/next/quote-requests/importer'
    | '/next/risk-management/geo-risk'
    | '/next/risk-management/pcns'
    | '/next/risk-management/risk-digest'
    | '/next/settings/company'
    | '/next/suppliers/$supplierAndStockLocationId'
    | '/next/suppliers/strategy'
    | '/next/templates/export'
    | '/next/templates/pcb-specification'
    | '/parts/alerts'
    | '/parts/search'
    | '/parts/components/component-importer'
    | '/parts/components/importer'
    | '/parts/components/linking'
    | '/parts/demand/demand-importer'
    | '/parts/offers/add'
    | '/parts/offers/create'
    | '/parts/offers/csv-importer'
    | '/parts/quote-requests/excel-importer'
    | '/parts/quote-requests/importer'
    | '/projects/$projectId/dashboard'
    | '/projects/$projectId/edit'
    | '/projects/$projectId/quotation'
    | '/risk-management/library-health/assemblies'
    | '/risk-management/library-health/components'
    | '/risk-management/library-health/parts'
    | '/suppliers/strategy'
    | '/suppliers/line-card-rules/importer'
    | '/suppliers/supplier-contacts-importer/bulk'
    | '/suppliers/supplier-contacts/importer'
    | '/templates/export'
    | '/templates/pcb-specification'
    | '/templates/calculation/add-template'
    | '/templates/calculation/create'
    | '/templates/flexible-calculation/new'
    | '/templates/quotation/create'
    | '/templates/quotation/edit'
    | '/assemblies/$assemblyId'
    | '/manufacturers'
    | '/next/assemblies'
    | '/next/components'
    | '/next/customers'
    | '/next/demands'
    | '/next/manufacturers'
    | '/next/negotiations'
    | '/next/offer-imports'
    | '/next/parts'
    | '/next/projects'
    | '/next/quote-requests'
    | '/next/risk-management'
    | '/next/suppliers'
    | '/projects/$projectId'
    | '/risk-management/library-health'
    | '/suppliers'
    | '/next/negotiations/$negotiationId'
    | '/projects/$projectId/sourcing'
    | '/assemblies/$assemblyId/pcb/cad-viewer'
    | '/assemblies/$assemblyId/pcb/dfm'
    | '/assemblies/$assemblyId/pcb/dfm-analysis'
    | '/assemblies/$assemblyId/pcb/drills'
    | '/assemblies/$assemblyId/pcb/files'
    | '/assemblies/$assemblyId/pcb/panelization'
    | '/assemblies/$assemblyId/pcb/specification'
    | '/assemblies/$assemblyId/pcb/stackup'
    | '/assemblies/$assemblyId/subassemblies/create'
    | '/manufacturing/templates/{-$templateId}'
    | '/manufacturing/activities/$activityId/duplicate'
    | '/manufacturing/activities/$activityId/edit'
    | '/manufacturing/drivers/$driverId/duplicate'
    | '/manufacturing/drivers/$driverId/edit'
    | '/manufacturing/expenses/$expenseId/duplicate'
    | '/manufacturing/expenses/$expenseId/edit'
    | '/manufacturing/resources/$resourceId/duplicate'
    | '/manufacturing/resources/$resourceId/edit'
    | '/monitoring/components/pricing'
    | '/monitoring/dashboards/$dashboardId'
    | '/monitoring/insights-agent/{-$conversationId}'
    | '/monitoring/jobs/$jobId'
    | '/monitoring/reports/savings'
    | '/negotiations/$negotiationId/overview'
    | '/next/assemblies/$assemblyId/dashboard'
    | '/next/assemblies/$assemblyId/details'
    | '/next/assemblies/$assemblyId/edit'
    | '/next/parts/$partId/compliance'
    | '/next/parts/$partId/offers'
    | '/next/parts/$partId/part-alternatives'
    | '/next/parts/$partId/se-alternatives'
    | '/next/parts/$partId/se-documentation'
    | '/next/parts/$partId/se-geo-risk'
    | '/next/parts/$partId/se-supply-chain'
    | '/next/parts/$partId/se-technical'
    | '/next/parts/$partId/used-in'
    | '/next/projects/$projectId/dashboard'
    | '/next/projects/$projectId/edit'
    | '/next/projects/$projectId/quotation'
    | '/next/risk-management/library-health/assemblies'
    | '/next/risk-management/library-health/components'
    | '/next/risk-management/library-health/parts'
    | '/next/templates/email/create'
    | '/next/templates/flexible-calculation/$flexibleCalculationTemplateId'
    | '/next/templates/flexible-calculation/create'
    | '/next/templates/flexible-calculation/exported-variables'
    | '/next/templates/quote-request/create'
    | '/next/templates/sourcing/create'
    | '/parts/demands/importer'
    | '/parts/details/$partId/compliance'
    | '/parts/details/$partId/offers'
    | '/parts/details/$partId/part-alternatives'
    | '/parts/details/$partId/se-alternatives'
    | '/parts/details/$partId/se-documentation'
    | '/parts/details/$partId/se-geo-risk'
    | '/parts/details/$partId/se-supply-chain'
    | '/parts/details/$partId/se-technical'
    | '/parts/details/$partId/used-in'
    | '/parts/offers/$offerId/duplicate'
    | '/parts/offers/$offerId/edit'
    | '/projects/$projectId/calculation/print'
    | '/projects/$projectId/flexible-calculation/$flexibleCalculationId'
    | '/projects/$projectId/order/confirmation'
    | '/projects/$projectId/sourcing/demand-groups'
    | '/settings/organization/api-integration'
    | '/settings/organization/assembly-settings'
    | '/settings/organization/automatic-rfq-number'
    | '/settings/organization/branding'
    | '/settings/organization/carbon-footprints'
    | '/settings/organization/component-settings'
    | '/settings/organization/csv-integration'
    | '/settings/organization/custom-part-categories'
    | '/settings/organization/data-integrations'
    | '/settings/organization/feature-flags'
    | '/settings/organization/manufacturer-preferences'
    | '/settings/organization/sites'
    | '/settings/organization/supplier-api-integrations'
    | '/settings/user/account-security'
    | '/settings/organization/pcb/$panelPreferenceId'
    | '/settings/organization/pcb/add-preference'
    | '/settings/organization/users/importer'
    | '/supplier-portal/quote-requests/$quoteRequestId/excel-importer'
    | '/supplier-portal/quote-requests/$quoteRequestId/import-pdf'
    | '/supplier-portal/quote-requests/$quoteRequestId/pdf-importer'
    | '/suppliers/$supplierId/supplier-contacts-importer/$'
    | '/suppliers/$supplierId/supplier-contacts/importer'
    | '/templates/email/create'
    | '/templates/flexible-calculation/$flexibleCalculationTemplateId'
    | '/templates/flexible-calculation/create'
    | '/templates/flexible-calculation/exported-variables'
    | '/templates/quote-request/create'
    | '/templates/sourcing/create'
    | '/templates/calculation/$templateId/edit'
    | '/templates/email/$emailTemplateId/update'
    | '/assemblies/$assemblyId/pcb'
    | '/manufacturing/activities'
    | '/manufacturing/drivers'
    | '/manufacturing/expenses'
    | '/manufacturing/resources'
    | '/monitoring/charts'
    | '/monitoring/dashboards'
    | '/monitoring/jobs'
    | '/next/assemblies/$assemblyId'
    | '/next/parts/$partId'
    | '/next/projects/$projectId'
    | '/next/risk-management/library-health'
    | '/next/suppliers/supplier-contacts'
    | '/next/templates/email'
    | '/next/templates/flexible-calculation'
    | '/next/templates/quotation'
    | '/next/templates/quote-request'
    | '/next/templates/sourcing'
    | '/parts/components'
    | '/parts/demands'
    | '/parts/quote-requests'
    | '/parts/details/$partId'
    | '/projects/$projectId/bom'
    | '/projects/$projectId/calculation'
    | '/projects/$projectId/flexible-calculation'
    | '/projects/$projectId/manufacturing'
    | '/projects/$projectId/order'
    | '/settings/organization'
    | '/supplier-portal/quote-requests/$quoteRequestId'
    | '/suppliers/supplier-contacts'
    | '/templates/calculation'
    | '/templates/email'
    | '/templates/flexible-calculation'
    | '/templates/quotation'
    | '/templates/quote-request'
    | '/templates/sourcing'
    | '/manufacturing/apps/$appId/$widgetId'
    | '/negotiations/$negotiationId/quote-requests/$quoteRequestId'
    | '/negotiations/$negotiationId/quote-requests/assign'
    | '/negotiations/$negotiationId/quote-requests/attachments'
    | '/negotiations/$negotiationId/quote-requests/delivery-lot-size'
    | '/negotiations/$negotiationId/quote-requests/excel-importer'
    | '/negotiations/$negotiationId/quote-requests/importer'
    | '/negotiations/$negotiationId/quote-requests/line-items'
    | '/negotiations/$negotiationId/quote-requests/preview-email'
    | '/negotiations/$negotiationId/quote-requests/target-price'
    | '/negotiations/$negotiationId/scenarios/compare'
    | '/negotiations/$negotiationId/scenarios/create'
    | '/next/assemblies/$assemblyId/pcb/cad-viewer'
    | '/next/assemblies/$assemblyId/pcb/dfm'
    | '/next/assemblies/$assemblyId/pcb/dfm-analysis'
    | '/next/assemblies/$assemblyId/pcb/drills'
    | '/next/assemblies/$assemblyId/pcb/files'
    | '/next/assemblies/$assemblyId/pcb/panelization'
    | '/next/assemblies/$assemblyId/pcb/specification'
    | '/next/assemblies/$assemblyId/pcb/stackup'
    | '/next/assemblies/$assemblyId/subassemblies/create'
    | '/next/components/ipn/cpns'
    | '/next/components/ipn/linking'
    | '/next/components/ipn/used-in'
    | '/next/negotiations/$negotiationId/overview'
    | '/next/parts/custom/$customPartSpecificationId/offers'
    | '/next/parts/custom/$customPartSpecificationId/used-in'
    | '/next/parts/offers/$offerId/duplicate'
    | '/next/parts/offers/$offerId/edit'
    | '/next/projects/$projectId/flexible-calculation/$flexibleCalculationId'
    | '/next/projects/$projectId/sourcing/compare'
    | '/next/projects/$projectId/sourcing/version-history'
    | '/next/settings/organization/api-integration'
    | '/next/settings/organization/assembly-settings'
    | '/next/settings/organization/automatic-rfq-number'
    | '/next/settings/organization/branding'
    | '/next/settings/organization/carbon-footprints'
    | '/next/settings/organization/component-settings'
    | '/next/settings/organization/csv-integration'
    | '/next/settings/organization/custom-part-categories'
    | '/next/settings/organization/data-integrations'
    | '/next/settings/organization/feature-flags'
    | '/next/settings/organization/manufacturer-preferences'
    | '/next/settings/organization/sites'
    | '/next/settings/organization/supplier-api-integrations'
    | '/next/settings/user/account-security'
    | '/next/settings/organization/users/importer'
    | '/next/templates/email/$emailTemplateId/edit'
    | '/next/templates/manufacturing/activities/create'
    | '/next/templates/manufacturing/drivers/create'
    | '/next/templates/manufacturing/expenses/create'
    | '/next/templates/manufacturing/resources/create'
    | '/next/templates/manufacturing/templates/{-$templateId}'
    | '/next/templates/quotation/builder/{-$templateId}'
    | '/next/templates/quote-request/$quoteRequestTemplateId/edit'
    | '/next/templates/sourcing/$sourcingTemplateId/duplicate'
    | '/next/templates/sourcing/$sourcingTemplateId/edit'
    | '/parts/components/ipn/cpns'
    | '/parts/components/ipn/linking'
    | '/parts/components/ipn/offers'
    | '/parts/components/ipn/used-in'
    | '/parts/custom/details/$customPartSpecificationId/offers'
    | '/parts/custom/details/$customPartSpecificationId/used-in'
    | '/projects/$projectId/bom/assembly/add-assembly'
    | '/projects/$projectId/calculation/$assemblyId/calculation'
    | '/projects/$projectId/calculation/assemblies/$assemblyId'
    | '/projects/$projectId/sourcing/compare'
    | '/projects/$projectId/sourcing/version-history'
    | '/projects/$projectId/sourcing/assembly/$assemblyId'
    | '/settings/organization/customer-portal/additional-services'
    | '/settings/organization/customer-portal/checkout-conditions'
    | '/settings/organization/customer-portal/customer-specific-settings'
    | '/settings/organization/customer-portal/landing-page'
    | '/settings/organization/customer-portal/payment-credentials'
    | '/settings/organization/user-management/action-permissions'
    | '/settings/organization/user-management/roles'
    | '/templates/email/$emailTemplateId/edit'
    | '/templates/quotation/builder/{-$templateId}'
    | '/templates/quote-request/$quoteRequestTemplateId/edit'
    | '/templates/sourcing/$sourcingTemplateId/duplicate'
    | '/templates/sourcing/$sourcingTemplateId/edit'
    | '/negotiations/$negotiationId/quote-requests'
    | '/next/assemblies/$assemblyId/pcb'
    | '/next/components/ipn'
    | '/next/parts/custom/$customPartSpecificationId'
    | '/next/projects/$projectId/assemblies'
    | '/next/projects/$projectId/flexible-calculation'
    | '/next/projects/$projectId/manufacturing'
    | '/next/projects/$projectId/sourcing'
    | '/next/settings/organization'
    | '/next/templates/manufacturing/activities'
    | '/next/templates/manufacturing/drivers'
    | '/next/templates/manufacturing/expenses'
    | '/next/templates/manufacturing/resources'
    | '/parts/components/ipn'
    | '/parts/custom/details/$customPartSpecificationId'
    | '/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId'
    | '/settings/organization/customer-portal'
    | '/settings/organization/pcb'
    | '/settings/organization/users'
    | '/settings/organization/pcb/panel-preferences'
    | '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId'
    | '/monitoring/components/categories/$categoryId/pricing'
    | '/negotiations/$negotiationId/demand-groups/$demandGroupId/awarding'
    | '/negotiations/$negotiationId/scenarios/$sourcingScenarioId/line/$sourcingLineItemId'
    | '/next/components/ipn/offers/$offerId/duplicate'
    | '/next/components/ipn/offers/$offerId/edit'
    | '/next/negotiations/$negotiationId/quote-requests/$quoteRequestId'
    | '/next/negotiations/$negotiationId/quote-requests/assign'
    | '/next/negotiations/$negotiationId/quote-requests/attachments'
    | '/next/negotiations/$negotiationId/quote-requests/delivery-lot-size'
    | '/next/negotiations/$negotiationId/quote-requests/importer'
    | '/next/negotiations/$negotiationId/quote-requests/line-items'
    | '/next/negotiations/$negotiationId/quote-requests/preview-email'
    | '/next/negotiations/$negotiationId/quote-requests/target-price'
    | '/next/negotiations/$negotiationId/scenarios/compare'
    | '/next/negotiations/$negotiationId/scenarios/create'
    | '/next/projects/$projectId/assemblies/$assemblyId/details'
    | '/next/projects/$projectId/assemblies/$assemblyId/edit'
    | '/next/projects/$projectId/assemblies/$assemblyId/pnp-importer'
    | '/next/projects/$projectId/sourcing/assembly/$assemblyId'
    | '/next/projects/$projectId/sourcing/overview/$view'
    | '/next/projects/$projectId/sourcing/quote-requests/$quoteRequestId'
    | '/next/projects/$projectId/sourcing/quote-requests/assign'
    | '/next/projects/$projectId/sourcing/quote-requests/attachments'
    | '/next/projects/$projectId/sourcing/quote-requests/delivery-lot-size'
    | '/next/projects/$projectId/sourcing/quote-requests/importer'
    | '/next/projects/$projectId/sourcing/quote-requests/line-items'
    | '/next/projects/$projectId/sourcing/quote-requests/preview-email'
    | '/next/projects/$projectId/sourcing/quote-requests/target-price'
    | '/next/projects/$projectId/sourcing/scenarios/create'
    | '/next/settings/organization/customer-portal/additional-services'
    | '/next/settings/organization/customer-portal/checkout-conditions'
    | '/next/settings/organization/customer-portal/customer-specific-settings'
    | '/next/settings/organization/customer-portal/landing-page'
    | '/next/settings/organization/customer-portal/payment-credentials'
    | '/next/settings/organization/user-management/action-permissions'
    | '/next/settings/organization/user-management/roles'
    | '/next/templates/flexible-calculation/apps/$appId/$widgetId'
    | '/next/templates/flexible-calculation/review-conversion/$legacyTemplateId/$flexibleCalculationTemplateId'
    | '/next/templates/manufacturing/activities/$activityId/duplicate'
    | '/next/templates/manufacturing/activities/$activityId/edit'
    | '/next/templates/manufacturing/apps/$appId/$widgetId'
    | '/next/templates/manufacturing/drivers/$driverId/duplicate'
    | '/next/templates/manufacturing/drivers/$driverId/edit'
    | '/next/templates/manufacturing/expenses/$expenseId/duplicate'
    | '/next/templates/manufacturing/expenses/$expenseId/edit'
    | '/next/templates/manufacturing/resources/$resourceId/duplicate'
    | '/next/templates/manufacturing/resources/$resourceId/edit'
    | '/parts/components/ipn/offers/$offerId/duplicate'
    | '/parts/components/ipn/offers/$offerId/edit'
    | '/projects/$projectId/bom/assembly/$assemblyId/details'
    | '/projects/$projectId/bom/assembly/$assemblyId/edit'
    | '/projects/$projectId/bom/assembly/$assemblyId/pnp-importer'
    | '/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/activity'
    | '/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/expense'
    | '/projects/$projectId/sourcing/$sourcingScenarioId/line/$sourcingLineItemId'
    | '/projects/$projectId/sourcing/overview/$view'
    | '/projects/$projectId/sourcing/quote-requests/$quoteRequestId'
    | '/projects/$projectId/sourcing/quote-requests/assign'
    | '/projects/$projectId/sourcing/quote-requests/attachments'
    | '/projects/$projectId/sourcing/quote-requests/delivery-lot-size'
    | '/projects/$projectId/sourcing/quote-requests/excel-importer'
    | '/projects/$projectId/sourcing/quote-requests/importer'
    | '/projects/$projectId/sourcing/quote-requests/line-items'
    | '/projects/$projectId/sourcing/quote-requests/preview-email'
    | '/projects/$projectId/sourcing/quote-requests/target-price'
    | '/projects/$projectId/sourcing/scenarios/create'
    | '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/purchase-orders'
    | '/settings/organization/pcb/panel-preferences/create'
    | '/templates/flexible-calculation/apps/$appId/$widgetId'
    | '/templates/flexible-calculation/review-conversion/$legacyTemplateId/$flexibleCalculationTemplateId'
    | '/negotiations/$negotiationId/demand-groups/$demandGroupId'
    | '/negotiations/$negotiationId/scenarios/$sourcingScenarioId'
    | '/next/components/ipn/offers'
    | '/next/negotiations/$negotiationId/quote-requests'
    | '/next/projects/$projectId/assemblies/$assemblyId'
    | '/next/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId'
    | '/next/projects/$projectId/sourcing/overview'
    | '/next/projects/$projectId/sourcing/quote-requests'
    | '/next/settings/organization/customer-portal'
    | '/next/settings/organization/pcb'
    | '/next/settings/organization/users'
    | '/next/settings/organization/pcb/panel-preferences'
    | '/projects/$projectId/bom/assembly/$assemblyId'
    | '/projects/$projectId/sourcing/overview'
    | '/projects/$projectId/sourcing/quote-requests'
    | '/next/negotiations/$negotiationId/demand-groups/$demandGroupId/awarding'
    | '/next/negotiations/$negotiationId/scenarios/$sourcingScenarioId/line-items/$sourcingLineItemId'
    | '/next/projects/$projectId/assemblies/$assemblyId/pcb/cad-viewer'
    | '/next/projects/$projectId/assemblies/$assemblyId/pcb/dfm'
    | '/next/projects/$projectId/assemblies/$assemblyId/pcb/dfm-analysis'
    | '/next/projects/$projectId/assemblies/$assemblyId/pcb/drills'
    | '/next/projects/$projectId/assemblies/$assemblyId/pcb/files'
    | '/next/projects/$projectId/assemblies/$assemblyId/pcb/panelization'
    | '/next/projects/$projectId/assemblies/$assemblyId/pcb/specification'
    | '/next/projects/$projectId/assemblies/$assemblyId/pcb/stackup'
    | '/next/projects/$projectId/assemblies/$assemblyId/subassemblies/create'
    | '/next/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/activity'
    | '/next/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/expense'
    | '/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/purchase-orders'
    | '/next/settings/organization/pcb/panel-preferences/create'
    | '/projects/$projectId/bom/assembly/$assemblyId/pcb/cad-viewer'
    | '/projects/$projectId/bom/assembly/$assemblyId/pcb/dfm'
    | '/projects/$projectId/bom/assembly/$assemblyId/pcb/dfm-analysis'
    | '/projects/$projectId/bom/assembly/$assemblyId/pcb/drills'
    | '/projects/$projectId/bom/assembly/$assemblyId/pcb/files'
    | '/projects/$projectId/bom/assembly/$assemblyId/pcb/panelization'
    | '/projects/$projectId/bom/assembly/$assemblyId/pcb/specification'
    | '/projects/$projectId/bom/assembly/$assemblyId/pcb/stackup'
    | '/projects/$projectId/bom/assembly/$assemblyId/subassemblies/create'
    | '/projects/$projectId/sourcing/offer/custom-part/$offerId/duplicate'
    | '/projects/$projectId/sourcing/offer/custom-part/$offerId/edit'
    | '/projects/$projectId/sourcing/offer/internal-part-number/$offerId/duplicate'
    | '/projects/$projectId/sourcing/offer/internal-part-number/$offerId/edit'
    | '/projects/$projectId/sourcing/offer/off-the-shelf/$offerId/duplicate'
    | '/projects/$projectId/sourcing/offer/off-the-shelf/$offerId/edit'
    | '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/line-items'
    | '/settings/organization/pcb/panel-preferences/$panelPreferenceId/edit'
    | '/negotiations/$negotiationId/scenarios/$sourcingScenarioId/cost-breakdown'
    | '/next/negotiations/$negotiationId/demand-groups/$demandGroupId'
    | '/next/negotiations/$negotiationId/scenarios/$sourcingScenarioId'
    | '/next/projects/$projectId/assemblies/$assemblyId/pcb'
    | '/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId'
    | '/projects/$projectId/bom/assembly/$assemblyId/pcb'
    | '/next/projects/$projectId/sourcing/offers/custom-part/$offerId/duplicate'
    | '/next/projects/$projectId/sourcing/offers/custom-part/$offerId/edit'
    | '/next/projects/$projectId/sourcing/offers/internal-part-number/$offerId/duplicate'
    | '/next/projects/$projectId/sourcing/offers/internal-part-number/$offerId/edit'
    | '/next/projects/$projectId/sourcing/offers/off-the-shelf/$offerId/duplicate'
    | '/next/projects/$projectId/sourcing/offers/off-the-shelf/$offerId/edit'
    | '/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/line-items/$sourcingLineItemId'
    | '/next/settings/organization/pcb/panel-preferences/$panelPreferenceId/edit'
    | '/next/negotiations/$negotiationId/scenarios/$sourcingScenarioId/cost-breakdown'
    | '/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/cost-breakdown'
    | '/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/line-items'
    | '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/cost-breakdown'
    | '/negotiations/$negotiationId/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId'
    | '/next/negotiations/$negotiationId/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId'
    | '/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId'
    | '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/callback'
    | '/landing'
    | '/_authenticated/customer-portal'
    | '/_authenticated/monitoring'
    | '/_authenticated/next'
    | '/_authenticated/risk-management'
    | '/_authenticated/$'
    | '/_authenticated/home'
    | '/_authenticated/project_creation'
    | '/_authenticated/purchase-orders'
    | '/_authenticated/rfqs'
    | '/_authenticated/start'
    | '/auth/enter-email'
    | '/_authenticated/'
    | '/_authenticated/manufacturers/_sidebar'
    | '/_authenticated/manufacturing/_sidebar'
    | '/_authenticated/monitoring/_sidebar'
    | '/_authenticated/parts/_sidebar'
    | '/_authenticated/settings/_menu'
    | '/_authenticated/suppliers/_sidebar'
    | '/_authenticated/templates/_sidebar'
    | '/_authenticated/apps/$'
    | '/_authenticated/assemblies/add-assembly'
    | '/_authenticated/components/import'
    | '/_authenticated/customers/$customerId'
    | '/_authenticated/customers/importer'
    | '/_authenticated/manufacturer/$'
    | '/_authenticated/manufacturers/$manufacturerId'
    | '/_authenticated/manufacturers/importer'
    | '/_authenticated/manufacturing/add-activity'
    | '/_authenticated/manufacturing/add-driver'
    | '/_authenticated/manufacturing/add-expense'
    | '/_authenticated/manufacturing/add-resource'
    | '/_authenticated/monitoring/analysis'
    | '/_authenticated/negotiations/create'
    | '/_authenticated/next/$'
    | '/_authenticated/next/alerts'
    | '/_authenticated/next/home'
    | '/_authenticated/next/lumi-agent'
    | '/_authenticated/next/purchase-orders'
    | '/_authenticated/offers/mpn-offer-importer'
    | '/_authenticated/orders/upload'
    | '/_authenticated/orders/{-$orderId}'
    | '/_authenticated/parts/off-the-shelf-part-search'
    | '/_authenticated/projects/create'
    | '/_authenticated/projects/new'
    | '/_authenticated/quote-requests/excel-importer'
    | '/_authenticated/risk-management/geo-risk'
    | '/_authenticated/risk-management/pcns'
    | '/_authenticated/risk-management/risk-digest'
    | '/_authenticated/settings/company'
    | '/_authenticated/supplier/importer'
    | '/_authenticated/suppliers/$supplierAndStockLocationId'
    | '/_authenticated/suppliers/importer'
    | '/_authenticated/template/$'
    | '/auth/signup/customer'
    | '/auth/signup/invite'
    | '/_authenticated/assemblies/'
    | '/_authenticated/customer-portal/'
    | '/_authenticated/customers/'
    | '/_authenticated/manufacturing/'
    | '/_authenticated/negotiations/'
    | '/_authenticated/next/'
    | '/_authenticated/parts/'
    | '/_authenticated/projects/'
    | '/_authenticated/risk-management/'
    | '/_authenticated/settings/'
    | '/_authenticated/supplier-portal/'
    | '/_authenticated/templates/'
    | '/_authenticated/assemblies/$assemblyId/pcb'
    | '/_authenticated/negotiations/$negotiationId/_sidebar'
    | '/_authenticated/next/parts/$partId'
    | '/_authenticated/next/projects/$projectId'
    | '/_authenticated/next/settings/_menu'
    | '/_authenticated/parts/details/$partId'
    | '/_authenticated/3rdparty/digikey/callback'
    | '/_authenticated/assemblies/$assemblyId/dashboard'
    | '/_authenticated/assemblies/$assemblyId/details'
    | '/_authenticated/assemblies/$assemblyId/edit'
    | '/_authenticated/manufacturers/_sidebar/line-card'
    | '/_authenticated/manufacturing/activities/create'
    | '/_authenticated/manufacturing/activity/$'
    | '/_authenticated/manufacturing/driver/$'
    | '/_authenticated/manufacturing/drivers/create'
    | '/_authenticated/manufacturing/expense/$'
    | '/_authenticated/manufacturing/expenses/create'
    | '/_authenticated/manufacturing/resource/$'
    | '/_authenticated/manufacturing/resources/create'
    | '/_authenticated/manufacturing/template/$'
    | '/_authenticated/monitoring/_sidebar/component-savings'
    | '/_authenticated/monitoring/_sidebar/data-health'
    | '/_authenticated/monitoring/_sidebar/offers'
    | '/_authenticated/monitoring/_sidebar/onboarding'
    | '/_authenticated/monitoring/agent/$'
    | '/_authenticated/monitoring/charts/$chartId'
    | '/_authenticated/next/apps/$'
    | '/_authenticated/next/components/linking'
    | '/_authenticated/next/customers/$customerId'
    | '/_authenticated/next/demands/importer'
    | '/_authenticated/next/manufacturers/$manufacturerId'
    | '/_authenticated/next/manufacturers/line-card'
    | '/_authenticated/next/negotiations/create'
    | '/_authenticated/next/offer-imports/$offerImportId'
    | '/_authenticated/next/orders/upload'
    | '/_authenticated/next/orders/{-$orderId}'
    | '/_authenticated/next/parts/search'
    | '/_authenticated/next/projects/create'
    | '/_authenticated/next/quote-requests/importer'
    | '/_authenticated/next/risk-management/geo-risk'
    | '/_authenticated/next/risk-management/pcns'
    | '/_authenticated/next/risk-management/risk-digest'
    | '/_authenticated/next/settings/company'
    | '/_authenticated/next/suppliers/$supplierAndStockLocationId'
    | '/_authenticated/next/suppliers/strategy'
    | '/_authenticated/next/templates/export'
    | '/_authenticated/next/templates/pcb-specification'
    | '/_authenticated/parts/_sidebar/alerts'
    | '/_authenticated/parts/_sidebar/search'
    | '/_authenticated/parts/components/component-importer'
    | '/_authenticated/parts/components/importer'
    | '/_authenticated/parts/components/linking'
    | '/_authenticated/parts/demand/demand-importer'
    | '/_authenticated/parts/offers/add'
    | '/_authenticated/parts/offers/create'
    | '/_authenticated/parts/offers/csv-importer'
    | '/_authenticated/parts/quote-requests/excel-importer'
    | '/_authenticated/parts/quote-requests/importer'
    | '/_authenticated/projects/$projectId/dashboard'
    | '/_authenticated/projects/$projectId/edit'
    | '/_authenticated/projects/$projectId/quotation'
    | '/_authenticated/risk-management/library-health/assemblies'
    | '/_authenticated/risk-management/library-health/components'
    | '/_authenticated/risk-management/library-health/parts'
    | '/_authenticated/suppliers/_sidebar/strategy'
    | '/_authenticated/suppliers/line-card-rules/importer'
    | '/_authenticated/suppliers/supplier-contacts-importer/bulk'
    | '/_authenticated/suppliers/supplier-contacts/importer'
    | '/_authenticated/templates/_sidebar/export'
    | '/_authenticated/templates/_sidebar/pcb-specification'
    | '/_authenticated/templates/calculation/add-template'
    | '/_authenticated/templates/calculation/create'
    | '/_authenticated/templates/flexible-calculation/new'
    | '/_authenticated/templates/quotation/create'
    | '/_authenticated/templates/quotation/edit'
    | '/_authenticated/assemblies/$assemblyId/'
    | '/_authenticated/manufacturers/_sidebar/'
    | '/_authenticated/monitoring/_sidebar/'
    | '/_authenticated/negotiations/$negotiationId/'
    | '/_authenticated/next/assemblies/'
    | '/_authenticated/next/components/'
    | '/_authenticated/next/customers/'
    | '/_authenticated/next/demands/'
    | '/_authenticated/next/manufacturers/'
    | '/_authenticated/next/negotiations/'
    | '/_authenticated/next/offer-imports/'
    | '/_authenticated/next/parts/'
    | '/_authenticated/next/projects/'
    | '/_authenticated/next/quote-requests/'
    | '/_authenticated/next/risk-management/'
    | '/_authenticated/next/settings/'
    | '/_authenticated/next/suppliers/'
    | '/_authenticated/projects/$projectId/'
    | '/_authenticated/risk-management/library-health/'
    | '/_authenticated/suppliers/_sidebar/'
    | '/_authenticated/next/assemblies/$assemblyId/pcb'
    | '/_authenticated/next/components/ipn/_details'
    | '/_authenticated/next/negotiations/$negotiationId/_sidebar'
    | '/_authenticated/next/parts/custom/$customPartSpecificationId'
    | '/_authenticated/parts/components/ipn/_details'
    | '/_authenticated/parts/custom/details/$customPartSpecificationId'
    | '/_authenticated/projects/$projectId/sourcing/_sidebar'
    | '/_authenticated/assemblies/$assemblyId/pcb/cad-viewer'
    | '/_authenticated/assemblies/$assemblyId/pcb/dfm'
    | '/_authenticated/assemblies/$assemblyId/pcb/dfm-analysis'
    | '/_authenticated/assemblies/$assemblyId/pcb/drills'
    | '/_authenticated/assemblies/$assemblyId/pcb/files'
    | '/_authenticated/assemblies/$assemblyId/pcb/panelization'
    | '/_authenticated/assemblies/$assemblyId/pcb/specification'
    | '/_authenticated/assemblies/$assemblyId/pcb/stackup'
    | '/_authenticated/assemblies/$assemblyId/subassemblies/create'
    | '/_authenticated/manufacturing/_sidebar/templates/{-$templateId}'
    | '/_authenticated/manufacturing/activities/$activityId/duplicate'
    | '/_authenticated/manufacturing/activities/$activityId/edit'
    | '/_authenticated/manufacturing/drivers/$driverId/duplicate'
    | '/_authenticated/manufacturing/drivers/$driverId/edit'
    | '/_authenticated/manufacturing/expenses/$expenseId/duplicate'
    | '/_authenticated/manufacturing/expenses/$expenseId/edit'
    | '/_authenticated/manufacturing/resources/$resourceId/duplicate'
    | '/_authenticated/manufacturing/resources/$resourceId/edit'
    | '/_authenticated/monitoring/_sidebar/components/pricing'
    | '/_authenticated/monitoring/_sidebar/dashboards/$dashboardId'
    | '/_authenticated/monitoring/_sidebar/insights-agent/{-$conversationId}'
    | '/_authenticated/monitoring/_sidebar/jobs/$jobId'
    | '/_authenticated/monitoring/_sidebar/reports/savings'
    | '/_authenticated/negotiations/$negotiationId/_sidebar/overview'
    | '/_authenticated/next/assemblies/$assemblyId/dashboard'
    | '/_authenticated/next/assemblies/$assemblyId/details'
    | '/_authenticated/next/assemblies/$assemblyId/edit'
    | '/_authenticated/next/parts/$partId/compliance'
    | '/_authenticated/next/parts/$partId/offers'
    | '/_authenticated/next/parts/$partId/part-alternatives'
    | '/_authenticated/next/parts/$partId/se-alternatives'
    | '/_authenticated/next/parts/$partId/se-documentation'
    | '/_authenticated/next/parts/$partId/se-geo-risk'
    | '/_authenticated/next/parts/$partId/se-supply-chain'
    | '/_authenticated/next/parts/$partId/se-technical'
    | '/_authenticated/next/parts/$partId/used-in'
    | '/_authenticated/next/projects/$projectId/dashboard'
    | '/_authenticated/next/projects/$projectId/edit'
    | '/_authenticated/next/projects/$projectId/quotation'
    | '/_authenticated/next/risk-management/library-health/assemblies'
    | '/_authenticated/next/risk-management/library-health/components'
    | '/_authenticated/next/risk-management/library-health/parts'
    | '/_authenticated/next/templates/email/create'
    | '/_authenticated/next/templates/flexible-calculation/$flexibleCalculationTemplateId'
    | '/_authenticated/next/templates/flexible-calculation/create'
    | '/_authenticated/next/templates/flexible-calculation/exported-variables'
    | '/_authenticated/next/templates/quote-request/create'
    | '/_authenticated/next/templates/sourcing/create'
    | '/_authenticated/parts/_sidebar/demands/importer'
    | '/_authenticated/parts/details/$partId/compliance'
    | '/_authenticated/parts/details/$partId/offers'
    | '/_authenticated/parts/details/$partId/part-alternatives'
    | '/_authenticated/parts/details/$partId/se-alternatives'
    | '/_authenticated/parts/details/$partId/se-documentation'
    | '/_authenticated/parts/details/$partId/se-geo-risk'
    | '/_authenticated/parts/details/$partId/se-supply-chain'
    | '/_authenticated/parts/details/$partId/se-technical'
    | '/_authenticated/parts/details/$partId/used-in'
    | '/_authenticated/parts/offers/$offerId/duplicate'
    | '/_authenticated/parts/offers/$offerId/edit'
    | '/_authenticated/projects/$projectId/calculation/print'
    | '/_authenticated/projects/$projectId/flexible-calculation/$flexibleCalculationId'
    | '/_authenticated/projects/$projectId/order/confirmation'
    | '/_authenticated/projects/$projectId/sourcing/demand-groups'
    | '/_authenticated/settings/_menu/organization/api-integration'
    | '/_authenticated/settings/_menu/organization/assembly-settings'
    | '/_authenticated/settings/_menu/organization/automatic-rfq-number'
    | '/_authenticated/settings/_menu/organization/branding'
    | '/_authenticated/settings/_menu/organization/carbon-footprints'
    | '/_authenticated/settings/_menu/organization/component-settings'
    | '/_authenticated/settings/_menu/organization/csv-integration'
    | '/_authenticated/settings/_menu/organization/custom-part-categories'
    | '/_authenticated/settings/_menu/organization/data-integrations'
    | '/_authenticated/settings/_menu/organization/feature-flags'
    | '/_authenticated/settings/_menu/organization/manufacturer-preferences'
    | '/_authenticated/settings/_menu/organization/sites'
    | '/_authenticated/settings/_menu/organization/supplier-api-integrations'
    | '/_authenticated/settings/_menu/user/account-security'
    | '/_authenticated/settings/organization/pcb/$panelPreferenceId'
    | '/_authenticated/settings/organization/pcb/add-preference'
    | '/_authenticated/settings/organization/users/importer'
    | '/_authenticated/supplier-portal/quote-requests/$quoteRequestId/excel-importer'
    | '/_authenticated/supplier-portal/quote-requests/$quoteRequestId/import-pdf'
    | '/_authenticated/supplier-portal/quote-requests/$quoteRequestId/pdf-importer'
    | '/_authenticated/suppliers/$supplierId/supplier-contacts-importer/$'
    | '/_authenticated/suppliers/$supplierId/supplier-contacts/importer'
    | '/_authenticated/templates/_sidebar/email/create'
    | '/_authenticated/templates/_sidebar/flexible-calculation/$flexibleCalculationTemplateId'
    | '/_authenticated/templates/_sidebar/flexible-calculation/create'
    | '/_authenticated/templates/_sidebar/flexible-calculation/exported-variables'
    | '/_authenticated/templates/_sidebar/quote-request/create'
    | '/_authenticated/templates/_sidebar/sourcing/create'
    | '/_authenticated/templates/calculation/$templateId/edit'
    | '/_authenticated/templates/email/$emailTemplateId/update'
    | '/_authenticated/assemblies/$assemblyId/pcb/'
    | '/_authenticated/manufacturing/_sidebar/activities/'
    | '/_authenticated/manufacturing/_sidebar/drivers/'
    | '/_authenticated/manufacturing/_sidebar/expenses/'
    | '/_authenticated/manufacturing/_sidebar/resources/'
    | '/_authenticated/monitoring/_sidebar/charts/'
    | '/_authenticated/monitoring/_sidebar/dashboards/'
    | '/_authenticated/monitoring/_sidebar/jobs/'
    | '/_authenticated/next/assemblies/$assemblyId/'
    | '/_authenticated/next/negotiations/$negotiationId/'
    | '/_authenticated/next/parts/$partId/'
    | '/_authenticated/next/projects/$projectId/'
    | '/_authenticated/next/risk-management/library-health/'
    | '/_authenticated/next/suppliers/supplier-contacts/'
    | '/_authenticated/next/templates/email/'
    | '/_authenticated/next/templates/flexible-calculation/'
    | '/_authenticated/next/templates/quotation/'
    | '/_authenticated/next/templates/quote-request/'
    | '/_authenticated/next/templates/sourcing/'
    | '/_authenticated/parts/_sidebar/components/'
    | '/_authenticated/parts/_sidebar/demands/'
    | '/_authenticated/parts/_sidebar/quote-requests/'
    | '/_authenticated/parts/details/$partId/'
    | '/_authenticated/projects/$projectId/bom/'
    | '/_authenticated/projects/$projectId/calculation/'
    | '/_authenticated/projects/$projectId/flexible-calculation/'
    | '/_authenticated/projects/$projectId/manufacturing/'
    | '/_authenticated/projects/$projectId/order/'
    | '/_authenticated/projects/$projectId/sourcing/'
    | '/_authenticated/settings/_menu/organization/'
    | '/_authenticated/supplier-portal/quote-requests/$quoteRequestId/'
    | '/_authenticated/suppliers/_sidebar/supplier-contacts/'
    | '/_authenticated/templates/_sidebar/calculation/'
    | '/_authenticated/templates/_sidebar/email/'
    | '/_authenticated/templates/_sidebar/flexible-calculation/'
    | '/_authenticated/templates/_sidebar/quotation/'
    | '/_authenticated/templates/_sidebar/quote-request/'
    | '/_authenticated/templates/_sidebar/sourcing/'
    | '/_authenticated/next/projects/$projectId/sourcing/overview'
    | '/_authenticated/manufacturing/_sidebar/apps/$appId/$widgetId'
    | '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/$quoteRequestId'
    | '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/assign'
    | '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/attachments'
    | '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/delivery-lot-size'
    | '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/excel-importer'
    | '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/importer'
    | '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/line-items'
    | '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/preview-email'
    | '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/target-price'
    | '/_authenticated/negotiations/$negotiationId/_sidebar/scenarios/compare'
    | '/_authenticated/negotiations/$negotiationId/_sidebar/scenarios/create'
    | '/_authenticated/next/assemblies/$assemblyId/pcb/cad-viewer'
    | '/_authenticated/next/assemblies/$assemblyId/pcb/dfm'
    | '/_authenticated/next/assemblies/$assemblyId/pcb/dfm-analysis'
    | '/_authenticated/next/assemblies/$assemblyId/pcb/drills'
    | '/_authenticated/next/assemblies/$assemblyId/pcb/files'
    | '/_authenticated/next/assemblies/$assemblyId/pcb/panelization'
    | '/_authenticated/next/assemblies/$assemblyId/pcb/specification'
    | '/_authenticated/next/assemblies/$assemblyId/pcb/stackup'
    | '/_authenticated/next/assemblies/$assemblyId/subassemblies/create'
    | '/_authenticated/next/components/ipn/_details/cpns'
    | '/_authenticated/next/components/ipn/_details/linking'
    | '/_authenticated/next/components/ipn/_details/used-in'
    | '/_authenticated/next/negotiations/$negotiationId/_sidebar/overview'
    | '/_authenticated/next/parts/custom/$customPartSpecificationId/offers'
    | '/_authenticated/next/parts/custom/$customPartSpecificationId/used-in'
    | '/_authenticated/next/parts/offers/$offerId/duplicate'
    | '/_authenticated/next/parts/offers/$offerId/edit'
    | '/_authenticated/next/projects/$projectId/flexible-calculation/$flexibleCalculationId'
    | '/_authenticated/next/projects/$projectId/sourcing/compare'
    | '/_authenticated/next/projects/$projectId/sourcing/version-history'
    | '/_authenticated/next/settings/_menu/organization/api-integration'
    | '/_authenticated/next/settings/_menu/organization/assembly-settings'
    | '/_authenticated/next/settings/_menu/organization/automatic-rfq-number'
    | '/_authenticated/next/settings/_menu/organization/branding'
    | '/_authenticated/next/settings/_menu/organization/carbon-footprints'
    | '/_authenticated/next/settings/_menu/organization/component-settings'
    | '/_authenticated/next/settings/_menu/organization/csv-integration'
    | '/_authenticated/next/settings/_menu/organization/custom-part-categories'
    | '/_authenticated/next/settings/_menu/organization/data-integrations'
    | '/_authenticated/next/settings/_menu/organization/feature-flags'
    | '/_authenticated/next/settings/_menu/organization/manufacturer-preferences'
    | '/_authenticated/next/settings/_menu/organization/sites'
    | '/_authenticated/next/settings/_menu/organization/supplier-api-integrations'
    | '/_authenticated/next/settings/_menu/user/account-security'
    | '/_authenticated/next/settings/organization/users/importer'
    | '/_authenticated/next/templates/email/$emailTemplateId/edit'
    | '/_authenticated/next/templates/manufacturing/activities/create'
    | '/_authenticated/next/templates/manufacturing/drivers/create'
    | '/_authenticated/next/templates/manufacturing/expenses/create'
    | '/_authenticated/next/templates/manufacturing/resources/create'
    | '/_authenticated/next/templates/manufacturing/templates/{-$templateId}'
    | '/_authenticated/next/templates/quotation/builder/{-$templateId}'
    | '/_authenticated/next/templates/quote-request/$quoteRequestTemplateId/edit'
    | '/_authenticated/next/templates/sourcing/$sourcingTemplateId/duplicate'
    | '/_authenticated/next/templates/sourcing/$sourcingTemplateId/edit'
    | '/_authenticated/parts/components/ipn/_details/cpns'
    | '/_authenticated/parts/components/ipn/_details/linking'
    | '/_authenticated/parts/components/ipn/_details/offers'
    | '/_authenticated/parts/components/ipn/_details/used-in'
    | '/_authenticated/parts/custom/details/$customPartSpecificationId/offers'
    | '/_authenticated/parts/custom/details/$customPartSpecificationId/used-in'
    | '/_authenticated/projects/$projectId/bom/assembly/add-assembly'
    | '/_authenticated/projects/$projectId/calculation/$assemblyId/calculation'
    | '/_authenticated/projects/$projectId/calculation/assemblies/$assemblyId'
    | '/_authenticated/projects/$projectId/sourcing/_sidebar/compare'
    | '/_authenticated/projects/$projectId/sourcing/_sidebar/version-history'
    | '/_authenticated/projects/$projectId/sourcing/assembly/$assemblyId'
    | '/_authenticated/settings/_menu/organization/customer-portal/additional-services'
    | '/_authenticated/settings/_menu/organization/customer-portal/checkout-conditions'
    | '/_authenticated/settings/_menu/organization/customer-portal/customer-specific-settings'
    | '/_authenticated/settings/_menu/organization/customer-portal/landing-page'
    | '/_authenticated/settings/_menu/organization/customer-portal/payment-credentials'
    | '/_authenticated/settings/_menu/organization/user-management/action-permissions'
    | '/_authenticated/settings/_menu/organization/user-management/roles'
    | '/_authenticated/templates/_sidebar/email/$emailTemplateId/edit'
    | '/_authenticated/templates/_sidebar/quotation/builder/{-$templateId}'
    | '/_authenticated/templates/_sidebar/quote-request/$quoteRequestTemplateId/edit'
    | '/_authenticated/templates/_sidebar/sourcing/$sourcingTemplateId/duplicate'
    | '/_authenticated/templates/_sidebar/sourcing/$sourcingTemplateId/edit'
    | '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/'
    | '/_authenticated/next/assemblies/$assemblyId/pcb/'
    | '/_authenticated/next/components/ipn/_details/'
    | '/_authenticated/next/parts/custom/$customPartSpecificationId/'
    | '/_authenticated/next/projects/$projectId/assemblies/'
    | '/_authenticated/next/projects/$projectId/flexible-calculation/'
    | '/_authenticated/next/projects/$projectId/manufacturing/'
    | '/_authenticated/next/projects/$projectId/sourcing/'
    | '/_authenticated/next/settings/_menu/organization/'
    | '/_authenticated/next/templates/manufacturing/activities/'
    | '/_authenticated/next/templates/manufacturing/drivers/'
    | '/_authenticated/next/templates/manufacturing/expenses/'
    | '/_authenticated/next/templates/manufacturing/resources/'
    | '/_authenticated/parts/components/ipn/_details/'
    | '/_authenticated/parts/custom/details/$customPartSpecificationId/'
    | '/_authenticated/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/'
    | '/_authenticated/settings/_menu/organization/customer-portal/'
    | '/_authenticated/settings/_menu/organization/pcb/'
    | '/_authenticated/settings/_menu/organization/users/'
    | '/_authenticated/settings/organization/pcb/panel-preferences/'
    | '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb'
    | '/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId'
    | '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb'
    | '/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/_sidebar'
    | '/_authenticated/monitoring/_sidebar/components/categories/$categoryId/pricing'
    | '/_authenticated/negotiations/$negotiationId/_sidebar/demand-groups/$demandGroupId/awarding'
    | '/_authenticated/negotiations/$negotiationId/scenarios/$sourcingScenarioId/line/$sourcingLineItemId'
    | '/_authenticated/next/components/ipn/offers/$offerId/duplicate'
    | '/_authenticated/next/components/ipn/offers/$offerId/edit'
    | '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/$quoteRequestId'
    | '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/assign'
    | '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/attachments'
    | '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/delivery-lot-size'
    | '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/importer'
    | '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/line-items'
    | '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/preview-email'
    | '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/target-price'
    | '/_authenticated/next/negotiations/$negotiationId/_sidebar/scenarios/compare'
    | '/_authenticated/next/negotiations/$negotiationId/_sidebar/scenarios/create'
    | '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/details'
    | '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/edit'
    | '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pnp-importer'
    | '/_authenticated/next/projects/$projectId/sourcing/assembly/$assemblyId'
    | '/_authenticated/next/projects/$projectId/sourcing/overview/$view'
    | '/_authenticated/next/projects/$projectId/sourcing/quote-requests/$quoteRequestId'
    | '/_authenticated/next/projects/$projectId/sourcing/quote-requests/assign'
    | '/_authenticated/next/projects/$projectId/sourcing/quote-requests/attachments'
    | '/_authenticated/next/projects/$projectId/sourcing/quote-requests/delivery-lot-size'
    | '/_authenticated/next/projects/$projectId/sourcing/quote-requests/importer'
    | '/_authenticated/next/projects/$projectId/sourcing/quote-requests/line-items'
    | '/_authenticated/next/projects/$projectId/sourcing/quote-requests/preview-email'
    | '/_authenticated/next/projects/$projectId/sourcing/quote-requests/target-price'
    | '/_authenticated/next/projects/$projectId/sourcing/scenarios/create'
    | '/_authenticated/next/settings/_menu/organization/customer-portal/additional-services'
    | '/_authenticated/next/settings/_menu/organization/customer-portal/checkout-conditions'
    | '/_authenticated/next/settings/_menu/organization/customer-portal/customer-specific-settings'
    | '/_authenticated/next/settings/_menu/organization/customer-portal/landing-page'
    | '/_authenticated/next/settings/_menu/organization/customer-portal/payment-credentials'
    | '/_authenticated/next/settings/_menu/organization/user-management/action-permissions'
    | '/_authenticated/next/settings/_menu/organization/user-management/roles'
    | '/_authenticated/next/templates/flexible-calculation/apps/$appId/$widgetId'
    | '/_authenticated/next/templates/flexible-calculation/review-conversion/$legacyTemplateId/$flexibleCalculationTemplateId'
    | '/_authenticated/next/templates/manufacturing/activities/$activityId/duplicate'
    | '/_authenticated/next/templates/manufacturing/activities/$activityId/edit'
    | '/_authenticated/next/templates/manufacturing/apps/$appId/$widgetId'
    | '/_authenticated/next/templates/manufacturing/drivers/$driverId/duplicate'
    | '/_authenticated/next/templates/manufacturing/drivers/$driverId/edit'
    | '/_authenticated/next/templates/manufacturing/expenses/$expenseId/duplicate'
    | '/_authenticated/next/templates/manufacturing/expenses/$expenseId/edit'
    | '/_authenticated/next/templates/manufacturing/resources/$resourceId/duplicate'
    | '/_authenticated/next/templates/manufacturing/resources/$resourceId/edit'
    | '/_authenticated/parts/components/ipn/offers/$offerId/duplicate'
    | '/_authenticated/parts/components/ipn/offers/$offerId/edit'
    | '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/details'
    | '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/edit'
    | '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pnp-importer'
    | '/_authenticated/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/activity'
    | '/_authenticated/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/expense'
    | '/_authenticated/projects/$projectId/sourcing/$sourcingScenarioId/line/$sourcingLineItemId'
    | '/_authenticated/projects/$projectId/sourcing/_sidebar/overview/$view'
    | '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/$quoteRequestId'
    | '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/assign'
    | '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/attachments'
    | '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/delivery-lot-size'
    | '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/excel-importer'
    | '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/importer'
    | '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/line-items'
    | '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/preview-email'
    | '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/target-price'
    | '/_authenticated/projects/$projectId/sourcing/_sidebar/scenarios/create'
    | '/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/purchase-orders'
    | '/_authenticated/settings/_menu/organization/pcb/panel-preferences/create'
    | '/_authenticated/templates/_sidebar/flexible-calculation/apps/$appId/$widgetId'
    | '/_authenticated/templates/_sidebar/flexible-calculation/review-conversion/$legacyTemplateId/$flexibleCalculationTemplateId'
    | '/_authenticated/negotiations/$negotiationId/_sidebar/demand-groups/$demandGroupId/'
    | '/_authenticated/negotiations/$negotiationId/_sidebar/scenarios/$sourcingScenarioId/'
    | '/_authenticated/next/components/ipn/_details/offers/'
    | '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/'
    | '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/'
    | '/_authenticated/next/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/'
    | '/_authenticated/next/projects/$projectId/sourcing/overview/'
    | '/_authenticated/next/projects/$projectId/sourcing/quote-requests/'
    | '/_authenticated/next/settings/_menu/organization/customer-portal/'
    | '/_authenticated/next/settings/_menu/organization/pcb/'
    | '/_authenticated/next/settings/_menu/organization/users/'
    | '/_authenticated/next/settings/organization/pcb/panel-preferences/'
    | '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/'
    | '/_authenticated/projects/$projectId/sourcing/_sidebar/overview/'
    | '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/'
    | '/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/'
    | '/_authenticated/next/negotiations/$negotiationId/_sidebar/demand-groups/$demandGroupId/awarding'
    | '/_authenticated/next/negotiations/$negotiationId/scenarios/$sourcingScenarioId/line-items/$sourcingLineItemId'
    | '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/cad-viewer'
    | '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/dfm'
    | '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/dfm-analysis'
    | '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/drills'
    | '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/files'
    | '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/panelization'
    | '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/specification'
    | '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/stackup'
    | '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/subassemblies/create'
    | '/_authenticated/next/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/activity'
    | '/_authenticated/next/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/expense'
    | '/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/purchase-orders'
    | '/_authenticated/next/settings/_menu/organization/pcb/panel-preferences/create'
    | '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/cad-viewer'
    | '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/dfm'
    | '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/dfm-analysis'
    | '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/drills'
    | '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/files'
    | '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/panelization'
    | '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/specification'
    | '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/stackup'
    | '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/subassemblies/create'
    | '/_authenticated/projects/$projectId/sourcing/offer/custom-part/$offerId/duplicate'
    | '/_authenticated/projects/$projectId/sourcing/offer/custom-part/$offerId/edit'
    | '/_authenticated/projects/$projectId/sourcing/offer/internal-part-number/$offerId/duplicate'
    | '/_authenticated/projects/$projectId/sourcing/offer/internal-part-number/$offerId/edit'
    | '/_authenticated/projects/$projectId/sourcing/offer/off-the-shelf/$offerId/duplicate'
    | '/_authenticated/projects/$projectId/sourcing/offer/off-the-shelf/$offerId/edit'
    | '/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/_sidebar/line-items'
    | '/_authenticated/settings/_menu/organization/pcb/panel-preferences/$panelPreferenceId/edit'
    | '/_authenticated/negotiations/$negotiationId/_sidebar/scenarios/$sourcingScenarioId/cost-breakdown/'
    | '/_authenticated/next/negotiations/$negotiationId/_sidebar/demand-groups/$demandGroupId/'
    | '/_authenticated/next/negotiations/$negotiationId/_sidebar/scenarios/$sourcingScenarioId/'
    | '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/'
    | '/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/'
    | '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/'
    | '/_authenticated/next/projects/$projectId/sourcing/offers/custom-part/$offerId/duplicate'
    | '/_authenticated/next/projects/$projectId/sourcing/offers/custom-part/$offerId/edit'
    | '/_authenticated/next/projects/$projectId/sourcing/offers/internal-part-number/$offerId/duplicate'
    | '/_authenticated/next/projects/$projectId/sourcing/offers/internal-part-number/$offerId/edit'
    | '/_authenticated/next/projects/$projectId/sourcing/offers/off-the-shelf/$offerId/duplicate'
    | '/_authenticated/next/projects/$projectId/sourcing/offers/off-the-shelf/$offerId/edit'
    | '/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/line-items/$sourcingLineItemId'
    | '/_authenticated/next/settings/_menu/organization/pcb/panel-preferences/$panelPreferenceId/edit'
    | '/_authenticated/next/negotiations/$negotiationId/_sidebar/scenarios/$sourcingScenarioId/cost-breakdown/'
    | '/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/cost-breakdown/'
    | '/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/line-items/'
    | '/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/_sidebar/cost-breakdown/'
    | '/_authenticated/negotiations/$negotiationId/_sidebar/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId'
    | '/_authenticated/next/negotiations/$negotiationId/_sidebar/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId'
    | '/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId'
    | '/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/_sidebar/cost-breakdown/assembly/$assemblyId/demand/$demandId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  CallbackRoute: typeof CallbackRoute
  LandingRoute: typeof LandingRoute
  AuthEnterEmailRoute: typeof AuthEnterEmailRoute
  AuthSignupCustomerRoute: typeof AuthSignupCustomerRoute
  AuthSignupInviteRoute: typeof AuthSignupInviteRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/landing': {
      id: '/landing'
      path: '/landing'
      fullPath: '/landing'
      preLoaderRoute: typeof LandingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/$': {
      id: '/_authenticated/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof AuthenticatedSplatRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/customer-portal': {
      id: '/_authenticated/customer-portal'
      path: '/customer-portal'
      fullPath: '/customer-portal'
      preLoaderRoute: typeof AuthenticatedCustomerPortalRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/home': {
      id: '/_authenticated/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthenticatedHomeRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/monitoring': {
      id: '/_authenticated/monitoring'
      path: '/monitoring'
      fullPath: '/monitoring'
      preLoaderRoute: typeof AuthenticatedMonitoringRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/next': {
      id: '/_authenticated/next'
      path: '/next'
      fullPath: '/next'
      preLoaderRoute: typeof AuthenticatedNextRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/project_creation': {
      id: '/_authenticated/project_creation'
      path: '/project_creation'
      fullPath: '/project_creation'
      preLoaderRoute: typeof AuthenticatedProject_creationRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/purchase-orders': {
      id: '/_authenticated/purchase-orders'
      path: '/purchase-orders'
      fullPath: '/purchase-orders'
      preLoaderRoute: typeof AuthenticatedPurchaseOrdersRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/rfqs': {
      id: '/_authenticated/rfqs'
      path: '/rfqs'
      fullPath: '/rfqs'
      preLoaderRoute: typeof AuthenticatedRfqsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/risk-management': {
      id: '/_authenticated/risk-management'
      path: '/risk-management'
      fullPath: '/risk-management'
      preLoaderRoute: typeof AuthenticatedRiskManagementRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/start': {
      id: '/_authenticated/start'
      path: '/start'
      fullPath: '/start'
      preLoaderRoute: typeof AuthenticatedStartRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/auth/enter-email': {
      id: '/auth/enter-email'
      path: '/auth/enter-email'
      fullPath: '/auth/enter-email'
      preLoaderRoute: typeof AuthEnterEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/apps/$': {
      id: '/_authenticated/apps/$'
      path: '/apps/$'
      fullPath: '/apps/$'
      preLoaderRoute: typeof AuthenticatedAppsSplatRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/assemblies/': {
      id: '/_authenticated/assemblies/'
      path: '/assemblies'
      fullPath: '/assemblies/'
      preLoaderRoute: typeof AuthenticatedAssembliesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/assemblies/add-assembly': {
      id: '/_authenticated/assemblies/add-assembly'
      path: '/assemblies/add-assembly'
      fullPath: '/assemblies/add-assembly'
      preLoaderRoute: typeof AuthenticatedAssembliesAddAssemblyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/components/import': {
      id: '/_authenticated/components/import'
      path: '/components/import'
      fullPath: '/components/import'
      preLoaderRoute: typeof AuthenticatedComponentsImportRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/customer-portal/': {
      id: '/_authenticated/customer-portal/'
      path: '/'
      fullPath: '/customer-portal/'
      preLoaderRoute: typeof AuthenticatedCustomerPortalIndexRouteImport
      parentRoute: typeof AuthenticatedCustomerPortalRouteRoute
    }
    '/_authenticated/customers/': {
      id: '/_authenticated/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof AuthenticatedCustomersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/customers/$customerId': {
      id: '/_authenticated/customers/$customerId'
      path: '/customers/$customerId'
      fullPath: '/customers/$customerId'
      preLoaderRoute: typeof AuthenticatedCustomersCustomerIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/customers/importer': {
      id: '/_authenticated/customers/importer'
      path: '/customers/importer'
      fullPath: '/customers/importer'
      preLoaderRoute: typeof AuthenticatedCustomersImporterRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/manufacturer/$': {
      id: '/_authenticated/manufacturer/$'
      path: '/manufacturer/$'
      fullPath: '/manufacturer/$'
      preLoaderRoute: typeof AuthenticatedManufacturerSplatRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/manufacturers/$manufacturerId': {
      id: '/_authenticated/manufacturers/$manufacturerId'
      path: '/manufacturers/$manufacturerId'
      fullPath: '/manufacturers/$manufacturerId'
      preLoaderRoute: typeof AuthenticatedManufacturersManufacturerIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/manufacturers/_sidebar': {
      id: '/_authenticated/manufacturers/_sidebar'
      path: '/manufacturers'
      fullPath: '/manufacturers'
      preLoaderRoute: typeof AuthenticatedManufacturersSidebarRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/manufacturers/importer': {
      id: '/_authenticated/manufacturers/importer'
      path: '/manufacturers/importer'
      fullPath: '/manufacturers/importer'
      preLoaderRoute: typeof AuthenticatedManufacturersImporterRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/manufacturing/': {
      id: '/_authenticated/manufacturing/'
      path: '/manufacturing'
      fullPath: '/manufacturing/'
      preLoaderRoute: typeof AuthenticatedManufacturingIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/manufacturing/_sidebar': {
      id: '/_authenticated/manufacturing/_sidebar'
      path: '/manufacturing'
      fullPath: '/manufacturing'
      preLoaderRoute: typeof AuthenticatedManufacturingSidebarRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/manufacturing/add-activity': {
      id: '/_authenticated/manufacturing/add-activity'
      path: '/manufacturing/add-activity'
      fullPath: '/manufacturing/add-activity'
      preLoaderRoute: typeof AuthenticatedManufacturingAddActivityRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/manufacturing/add-driver': {
      id: '/_authenticated/manufacturing/add-driver'
      path: '/manufacturing/add-driver'
      fullPath: '/manufacturing/add-driver'
      preLoaderRoute: typeof AuthenticatedManufacturingAddDriverRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/manufacturing/add-expense': {
      id: '/_authenticated/manufacturing/add-expense'
      path: '/manufacturing/add-expense'
      fullPath: '/manufacturing/add-expense'
      preLoaderRoute: typeof AuthenticatedManufacturingAddExpenseRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/manufacturing/add-resource': {
      id: '/_authenticated/manufacturing/add-resource'
      path: '/manufacturing/add-resource'
      fullPath: '/manufacturing/add-resource'
      preLoaderRoute: typeof AuthenticatedManufacturingAddResourceRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/monitoring/_sidebar': {
      id: '/_authenticated/monitoring/_sidebar'
      path: ''
      fullPath: '/monitoring'
      preLoaderRoute: typeof AuthenticatedMonitoringSidebarRouteRouteImport
      parentRoute: typeof AuthenticatedMonitoringRouteRoute
    }
    '/_authenticated/monitoring/analysis': {
      id: '/_authenticated/monitoring/analysis'
      path: '/analysis'
      fullPath: '/monitoring/analysis'
      preLoaderRoute: typeof AuthenticatedMonitoringAnalysisRouteImport
      parentRoute: typeof AuthenticatedMonitoringRouteRoute
    }
    '/_authenticated/negotiations/': {
      id: '/_authenticated/negotiations/'
      path: '/negotiations'
      fullPath: '/negotiations/'
      preLoaderRoute: typeof AuthenticatedNegotiationsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/negotiations/create': {
      id: '/_authenticated/negotiations/create'
      path: '/negotiations/create'
      fullPath: '/negotiations/create'
      preLoaderRoute: typeof AuthenticatedNegotiationsCreateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/next/': {
      id: '/_authenticated/next/'
      path: '/'
      fullPath: '/next/'
      preLoaderRoute: typeof AuthenticatedNextIndexRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/$': {
      id: '/_authenticated/next/$'
      path: '/$'
      fullPath: '/next/$'
      preLoaderRoute: typeof AuthenticatedNextSplatRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/alerts': {
      id: '/_authenticated/next/alerts'
      path: '/alerts'
      fullPath: '/next/alerts'
      preLoaderRoute: typeof AuthenticatedNextAlertsRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/home': {
      id: '/_authenticated/next/home'
      path: '/home'
      fullPath: '/next/home'
      preLoaderRoute: typeof AuthenticatedNextHomeRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/lumi-agent': {
      id: '/_authenticated/next/lumi-agent'
      path: '/lumi-agent'
      fullPath: '/next/lumi-agent'
      preLoaderRoute: typeof AuthenticatedNextLumiAgentRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/purchase-orders': {
      id: '/_authenticated/next/purchase-orders'
      path: '/purchase-orders'
      fullPath: '/next/purchase-orders'
      preLoaderRoute: typeof AuthenticatedNextPurchaseOrdersRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/offers/mpn-offer-importer': {
      id: '/_authenticated/offers/mpn-offer-importer'
      path: '/offers/mpn-offer-importer'
      fullPath: '/offers/mpn-offer-importer'
      preLoaderRoute: typeof AuthenticatedOffersMpnOfferImporterRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/orders/upload': {
      id: '/_authenticated/orders/upload'
      path: '/orders/upload'
      fullPath: '/orders/upload'
      preLoaderRoute: typeof AuthenticatedOrdersUploadRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/orders/{-$orderId}': {
      id: '/_authenticated/orders/{-$orderId}'
      path: '/orders/{-$orderId}'
      fullPath: '/orders/{-$orderId}'
      preLoaderRoute: typeof AuthenticatedOrdersChar123OrderIdChar125RouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/parts/': {
      id: '/_authenticated/parts/'
      path: '/parts'
      fullPath: '/parts/'
      preLoaderRoute: typeof AuthenticatedPartsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/parts/_sidebar': {
      id: '/_authenticated/parts/_sidebar'
      path: '/parts'
      fullPath: '/parts'
      preLoaderRoute: typeof AuthenticatedPartsSidebarRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/parts/off-the-shelf-part-search': {
      id: '/_authenticated/parts/off-the-shelf-part-search'
      path: '/parts/off-the-shelf-part-search'
      fullPath: '/parts/off-the-shelf-part-search'
      preLoaderRoute: typeof AuthenticatedPartsOffTheShelfPartSearchRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/': {
      id: '/_authenticated/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AuthenticatedProjectsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/create': {
      id: '/_authenticated/projects/create'
      path: '/projects/create'
      fullPath: '/projects/create'
      preLoaderRoute: typeof AuthenticatedProjectsCreateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/new': {
      id: '/_authenticated/projects/new'
      path: '/projects/new'
      fullPath: '/projects/new'
      preLoaderRoute: typeof AuthenticatedProjectsNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/quote-requests/excel-importer': {
      id: '/_authenticated/quote-requests/excel-importer'
      path: '/quote-requests/excel-importer'
      fullPath: '/quote-requests/excel-importer'
      preLoaderRoute: typeof AuthenticatedQuoteRequestsExcelImporterRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/risk-management/': {
      id: '/_authenticated/risk-management/'
      path: '/'
      fullPath: '/risk-management/'
      preLoaderRoute: typeof AuthenticatedRiskManagementIndexRouteImport
      parentRoute: typeof AuthenticatedRiskManagementRouteRoute
    }
    '/_authenticated/risk-management/geo-risk': {
      id: '/_authenticated/risk-management/geo-risk'
      path: '/geo-risk'
      fullPath: '/risk-management/geo-risk'
      preLoaderRoute: typeof AuthenticatedRiskManagementGeoRiskRouteImport
      parentRoute: typeof AuthenticatedRiskManagementRouteRoute
    }
    '/_authenticated/risk-management/pcns': {
      id: '/_authenticated/risk-management/pcns'
      path: '/pcns'
      fullPath: '/risk-management/pcns'
      preLoaderRoute: typeof AuthenticatedRiskManagementPcnsRouteImport
      parentRoute: typeof AuthenticatedRiskManagementRouteRoute
    }
    '/_authenticated/risk-management/risk-digest': {
      id: '/_authenticated/risk-management/risk-digest'
      path: '/risk-digest'
      fullPath: '/risk-management/risk-digest'
      preLoaderRoute: typeof AuthenticatedRiskManagementRiskDigestRouteImport
      parentRoute: typeof AuthenticatedRiskManagementRouteRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/_menu': {
      id: '/_authenticated/settings/_menu'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsMenuRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/company': {
      id: '/_authenticated/settings/company'
      path: '/settings/company'
      fullPath: '/settings/company'
      preLoaderRoute: typeof AuthenticatedSettingsCompanyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/supplier-portal/': {
      id: '/_authenticated/supplier-portal/'
      path: '/supplier-portal'
      fullPath: '/supplier-portal/'
      preLoaderRoute: typeof AuthenticatedSupplierPortalIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/supplier/importer': {
      id: '/_authenticated/supplier/importer'
      path: '/supplier/importer'
      fullPath: '/supplier/importer'
      preLoaderRoute: typeof AuthenticatedSupplierImporterRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/suppliers/$supplierAndStockLocationId': {
      id: '/_authenticated/suppliers/$supplierAndStockLocationId'
      path: '/suppliers/$supplierAndStockLocationId'
      fullPath: '/suppliers/$supplierAndStockLocationId'
      preLoaderRoute: typeof AuthenticatedSuppliersSupplierAndStockLocationIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/suppliers/_sidebar': {
      id: '/_authenticated/suppliers/_sidebar'
      path: '/suppliers'
      fullPath: '/suppliers'
      preLoaderRoute: typeof AuthenticatedSuppliersSidebarRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/suppliers/importer': {
      id: '/_authenticated/suppliers/importer'
      path: '/suppliers/importer'
      fullPath: '/suppliers/importer'
      preLoaderRoute: typeof AuthenticatedSuppliersImporterRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/template/$': {
      id: '/_authenticated/template/$'
      path: '/template/$'
      fullPath: '/template/$'
      preLoaderRoute: typeof AuthenticatedTemplateSplatRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/templates/': {
      id: '/_authenticated/templates/'
      path: '/templates'
      fullPath: '/templates/'
      preLoaderRoute: typeof AuthenticatedTemplatesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/templates/_sidebar': {
      id: '/_authenticated/templates/_sidebar'
      path: '/templates'
      fullPath: '/templates'
      preLoaderRoute: typeof AuthenticatedTemplatesSidebarRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/auth/signup/customer': {
      id: '/auth/signup/customer'
      path: '/auth/signup/customer'
      fullPath: '/auth/signup/customer'
      preLoaderRoute: typeof AuthSignupCustomerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/signup/invite': {
      id: '/auth/signup/invite'
      path: '/auth/signup/invite'
      fullPath: '/auth/signup/invite'
      preLoaderRoute: typeof AuthSignupInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/3rdparty/digikey/callback': {
      id: '/_authenticated/3rdparty/digikey/callback'
      path: '/3rdparty/digikey/callback'
      fullPath: '/3rdparty/digikey/callback'
      preLoaderRoute: typeof Authenticated3rdpartyDigikeyCallbackRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/assemblies/$assemblyId/': {
      id: '/_authenticated/assemblies/$assemblyId/'
      path: '/assemblies/$assemblyId'
      fullPath: '/assemblies/$assemblyId/'
      preLoaderRoute: typeof AuthenticatedAssembliesAssemblyIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/assemblies/$assemblyId/dashboard': {
      id: '/_authenticated/assemblies/$assemblyId/dashboard'
      path: '/assemblies/$assemblyId/dashboard'
      fullPath: '/assemblies/$assemblyId/dashboard'
      preLoaderRoute: typeof AuthenticatedAssembliesAssemblyIdDashboardRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/assemblies/$assemblyId/details': {
      id: '/_authenticated/assemblies/$assemblyId/details'
      path: '/assemblies/$assemblyId/details'
      fullPath: '/assemblies/$assemblyId/details'
      preLoaderRoute: typeof AuthenticatedAssembliesAssemblyIdDetailsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/assemblies/$assemblyId/edit': {
      id: '/_authenticated/assemblies/$assemblyId/edit'
      path: '/assemblies/$assemblyId/edit'
      fullPath: '/assemblies/$assemblyId/edit'
      preLoaderRoute: typeof AuthenticatedAssembliesAssemblyIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/assemblies/$assemblyId/pcb': {
      id: '/_authenticated/assemblies/$assemblyId/pcb'
      path: '/assemblies/$assemblyId/pcb'
      fullPath: '/assemblies/$assemblyId/pcb'
      preLoaderRoute: typeof AuthenticatedAssembliesAssemblyIdPcbRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/manufacturers/_sidebar/': {
      id: '/_authenticated/manufacturers/_sidebar/'
      path: '/'
      fullPath: '/manufacturers/'
      preLoaderRoute: typeof AuthenticatedManufacturersSidebarIndexRouteImport
      parentRoute: typeof AuthenticatedManufacturersSidebarRouteRoute
    }
    '/_authenticated/manufacturers/_sidebar/line-card': {
      id: '/_authenticated/manufacturers/_sidebar/line-card'
      path: '/line-card'
      fullPath: '/manufacturers/line-card'
      preLoaderRoute: typeof AuthenticatedManufacturersSidebarLineCardRouteImport
      parentRoute: typeof AuthenticatedManufacturersSidebarRouteRoute
    }
    '/_authenticated/manufacturing/activities/create': {
      id: '/_authenticated/manufacturing/activities/create'
      path: '/manufacturing/activities/create'
      fullPath: '/manufacturing/activities/create'
      preLoaderRoute: typeof AuthenticatedManufacturingActivitiesCreateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/manufacturing/activity/$': {
      id: '/_authenticated/manufacturing/activity/$'
      path: '/manufacturing/activity/$'
      fullPath: '/manufacturing/activity/$'
      preLoaderRoute: typeof AuthenticatedManufacturingActivitySplatRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/manufacturing/driver/$': {
      id: '/_authenticated/manufacturing/driver/$'
      path: '/manufacturing/driver/$'
      fullPath: '/manufacturing/driver/$'
      preLoaderRoute: typeof AuthenticatedManufacturingDriverSplatRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/manufacturing/drivers/create': {
      id: '/_authenticated/manufacturing/drivers/create'
      path: '/manufacturing/drivers/create'
      fullPath: '/manufacturing/drivers/create'
      preLoaderRoute: typeof AuthenticatedManufacturingDriversCreateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/manufacturing/expense/$': {
      id: '/_authenticated/manufacturing/expense/$'
      path: '/manufacturing/expense/$'
      fullPath: '/manufacturing/expense/$'
      preLoaderRoute: typeof AuthenticatedManufacturingExpenseSplatRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/manufacturing/expenses/create': {
      id: '/_authenticated/manufacturing/expenses/create'
      path: '/manufacturing/expenses/create'
      fullPath: '/manufacturing/expenses/create'
      preLoaderRoute: typeof AuthenticatedManufacturingExpensesCreateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/manufacturing/resource/$': {
      id: '/_authenticated/manufacturing/resource/$'
      path: '/manufacturing/resource/$'
      fullPath: '/manufacturing/resource/$'
      preLoaderRoute: typeof AuthenticatedManufacturingResourceSplatRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/manufacturing/resources/create': {
      id: '/_authenticated/manufacturing/resources/create'
      path: '/manufacturing/resources/create'
      fullPath: '/manufacturing/resources/create'
      preLoaderRoute: typeof AuthenticatedManufacturingResourcesCreateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/manufacturing/template/$': {
      id: '/_authenticated/manufacturing/template/$'
      path: '/manufacturing/template/$'
      fullPath: '/manufacturing/template/$'
      preLoaderRoute: typeof AuthenticatedManufacturingTemplateSplatRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/monitoring/_sidebar/': {
      id: '/_authenticated/monitoring/_sidebar/'
      path: '/'
      fullPath: '/monitoring/'
      preLoaderRoute: typeof AuthenticatedMonitoringSidebarIndexRouteImport
      parentRoute: typeof AuthenticatedMonitoringSidebarRouteRoute
    }
    '/_authenticated/monitoring/_sidebar/component-savings': {
      id: '/_authenticated/monitoring/_sidebar/component-savings'
      path: '/component-savings'
      fullPath: '/monitoring/component-savings'
      preLoaderRoute: typeof AuthenticatedMonitoringSidebarComponentSavingsRouteImport
      parentRoute: typeof AuthenticatedMonitoringSidebarRouteRoute
    }
    '/_authenticated/monitoring/_sidebar/data-health': {
      id: '/_authenticated/monitoring/_sidebar/data-health'
      path: '/data-health'
      fullPath: '/monitoring/data-health'
      preLoaderRoute: typeof AuthenticatedMonitoringSidebarDataHealthRouteImport
      parentRoute: typeof AuthenticatedMonitoringSidebarRouteRoute
    }
    '/_authenticated/monitoring/_sidebar/offers': {
      id: '/_authenticated/monitoring/_sidebar/offers'
      path: '/offers'
      fullPath: '/monitoring/offers'
      preLoaderRoute: typeof AuthenticatedMonitoringSidebarOffersRouteImport
      parentRoute: typeof AuthenticatedMonitoringSidebarRouteRoute
    }
    '/_authenticated/monitoring/_sidebar/onboarding': {
      id: '/_authenticated/monitoring/_sidebar/onboarding'
      path: '/onboarding'
      fullPath: '/monitoring/onboarding'
      preLoaderRoute: typeof AuthenticatedMonitoringSidebarOnboardingRouteImport
      parentRoute: typeof AuthenticatedMonitoringSidebarRouteRoute
    }
    '/_authenticated/monitoring/agent/$': {
      id: '/_authenticated/monitoring/agent/$'
      path: '/agent/$'
      fullPath: '/monitoring/agent/$'
      preLoaderRoute: typeof AuthenticatedMonitoringAgentSplatRouteImport
      parentRoute: typeof AuthenticatedMonitoringRouteRoute
    }
    '/_authenticated/monitoring/charts/$chartId': {
      id: '/_authenticated/monitoring/charts/$chartId'
      path: '/charts/$chartId'
      fullPath: '/monitoring/charts/$chartId'
      preLoaderRoute: typeof AuthenticatedMonitoringChartsChartIdRouteImport
      parentRoute: typeof AuthenticatedMonitoringRouteRoute
    }
    '/_authenticated/negotiations/$negotiationId/': {
      id: '/_authenticated/negotiations/$negotiationId/'
      path: '/negotiations/$negotiationId'
      fullPath: '/negotiations/$negotiationId/'
      preLoaderRoute: typeof AuthenticatedNegotiationsNegotiationIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/negotiations/$negotiationId/_sidebar': {
      id: '/_authenticated/negotiations/$negotiationId/_sidebar'
      path: '/negotiations/$negotiationId'
      fullPath: '/negotiations/$negotiationId'
      preLoaderRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/next/apps/$': {
      id: '/_authenticated/next/apps/$'
      path: '/apps/$'
      fullPath: '/next/apps/$'
      preLoaderRoute: typeof AuthenticatedNextAppsSplatRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/assemblies/': {
      id: '/_authenticated/next/assemblies/'
      path: '/assemblies'
      fullPath: '/next/assemblies/'
      preLoaderRoute: typeof AuthenticatedNextAssembliesIndexRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/components/': {
      id: '/_authenticated/next/components/'
      path: '/components'
      fullPath: '/next/components/'
      preLoaderRoute: typeof AuthenticatedNextComponentsIndexRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/components/linking': {
      id: '/_authenticated/next/components/linking'
      path: '/components/linking'
      fullPath: '/next/components/linking'
      preLoaderRoute: typeof AuthenticatedNextComponentsLinkingRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/customers/': {
      id: '/_authenticated/next/customers/'
      path: '/customers'
      fullPath: '/next/customers/'
      preLoaderRoute: typeof AuthenticatedNextCustomersIndexRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/customers/$customerId': {
      id: '/_authenticated/next/customers/$customerId'
      path: '/customers/$customerId'
      fullPath: '/next/customers/$customerId'
      preLoaderRoute: typeof AuthenticatedNextCustomersCustomerIdRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/demands/': {
      id: '/_authenticated/next/demands/'
      path: '/demands'
      fullPath: '/next/demands/'
      preLoaderRoute: typeof AuthenticatedNextDemandsIndexRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/demands/importer': {
      id: '/_authenticated/next/demands/importer'
      path: '/demands/importer'
      fullPath: '/next/demands/importer'
      preLoaderRoute: typeof AuthenticatedNextDemandsImporterRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/manufacturers/': {
      id: '/_authenticated/next/manufacturers/'
      path: '/manufacturers'
      fullPath: '/next/manufacturers/'
      preLoaderRoute: typeof AuthenticatedNextManufacturersIndexRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/manufacturers/$manufacturerId': {
      id: '/_authenticated/next/manufacturers/$manufacturerId'
      path: '/manufacturers/$manufacturerId'
      fullPath: '/next/manufacturers/$manufacturerId'
      preLoaderRoute: typeof AuthenticatedNextManufacturersManufacturerIdRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/manufacturers/line-card': {
      id: '/_authenticated/next/manufacturers/line-card'
      path: '/manufacturers/line-card'
      fullPath: '/next/manufacturers/line-card'
      preLoaderRoute: typeof AuthenticatedNextManufacturersLineCardRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/negotiations/': {
      id: '/_authenticated/next/negotiations/'
      path: '/negotiations'
      fullPath: '/next/negotiations/'
      preLoaderRoute: typeof AuthenticatedNextNegotiationsIndexRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/negotiations/create': {
      id: '/_authenticated/next/negotiations/create'
      path: '/negotiations/create'
      fullPath: '/next/negotiations/create'
      preLoaderRoute: typeof AuthenticatedNextNegotiationsCreateRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/offer-imports/': {
      id: '/_authenticated/next/offer-imports/'
      path: '/offer-imports'
      fullPath: '/next/offer-imports/'
      preLoaderRoute: typeof AuthenticatedNextOfferImportsIndexRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/offer-imports/$offerImportId': {
      id: '/_authenticated/next/offer-imports/$offerImportId'
      path: '/offer-imports/$offerImportId'
      fullPath: '/next/offer-imports/$offerImportId'
      preLoaderRoute: typeof AuthenticatedNextOfferImportsOfferImportIdRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/orders/upload': {
      id: '/_authenticated/next/orders/upload'
      path: '/orders/upload'
      fullPath: '/next/orders/upload'
      preLoaderRoute: typeof AuthenticatedNextOrdersUploadRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/orders/{-$orderId}': {
      id: '/_authenticated/next/orders/{-$orderId}'
      path: '/orders/{-$orderId}'
      fullPath: '/next/orders/{-$orderId}'
      preLoaderRoute: typeof AuthenticatedNextOrdersChar123OrderIdChar125RouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/parts/': {
      id: '/_authenticated/next/parts/'
      path: '/parts'
      fullPath: '/next/parts/'
      preLoaderRoute: typeof AuthenticatedNextPartsIndexRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/parts/$partId': {
      id: '/_authenticated/next/parts/$partId'
      path: '/parts/$partId'
      fullPath: '/next/parts/$partId'
      preLoaderRoute: typeof AuthenticatedNextPartsPartIdRouteRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/parts/search': {
      id: '/_authenticated/next/parts/search'
      path: '/parts/search'
      fullPath: '/next/parts/search'
      preLoaderRoute: typeof AuthenticatedNextPartsSearchRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/projects/': {
      id: '/_authenticated/next/projects/'
      path: '/projects'
      fullPath: '/next/projects/'
      preLoaderRoute: typeof AuthenticatedNextProjectsIndexRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/projects/$projectId': {
      id: '/_authenticated/next/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/next/projects/$projectId'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdRouteRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/projects/create': {
      id: '/_authenticated/next/projects/create'
      path: '/projects/create'
      fullPath: '/next/projects/create'
      preLoaderRoute: typeof AuthenticatedNextProjectsCreateRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/quote-requests/': {
      id: '/_authenticated/next/quote-requests/'
      path: '/quote-requests'
      fullPath: '/next/quote-requests/'
      preLoaderRoute: typeof AuthenticatedNextQuoteRequestsIndexRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/quote-requests/importer': {
      id: '/_authenticated/next/quote-requests/importer'
      path: '/quote-requests/importer'
      fullPath: '/next/quote-requests/importer'
      preLoaderRoute: typeof AuthenticatedNextQuoteRequestsImporterRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/risk-management/': {
      id: '/_authenticated/next/risk-management/'
      path: '/risk-management'
      fullPath: '/next/risk-management/'
      preLoaderRoute: typeof AuthenticatedNextRiskManagementIndexRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/risk-management/geo-risk': {
      id: '/_authenticated/next/risk-management/geo-risk'
      path: '/risk-management/geo-risk'
      fullPath: '/next/risk-management/geo-risk'
      preLoaderRoute: typeof AuthenticatedNextRiskManagementGeoRiskRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/risk-management/pcns': {
      id: '/_authenticated/next/risk-management/pcns'
      path: '/risk-management/pcns'
      fullPath: '/next/risk-management/pcns'
      preLoaderRoute: typeof AuthenticatedNextRiskManagementPcnsRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/risk-management/risk-digest': {
      id: '/_authenticated/next/risk-management/risk-digest'
      path: '/risk-management/risk-digest'
      fullPath: '/next/risk-management/risk-digest'
      preLoaderRoute: typeof AuthenticatedNextRiskManagementRiskDigestRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/settings/': {
      id: '/_authenticated/next/settings/'
      path: '/settings'
      fullPath: '/next/settings/'
      preLoaderRoute: typeof AuthenticatedNextSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/settings/_menu': {
      id: '/_authenticated/next/settings/_menu'
      path: '/settings'
      fullPath: '/next/settings'
      preLoaderRoute: typeof AuthenticatedNextSettingsMenuRouteRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/settings/company': {
      id: '/_authenticated/next/settings/company'
      path: '/settings/company'
      fullPath: '/next/settings/company'
      preLoaderRoute: typeof AuthenticatedNextSettingsCompanyRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/suppliers/': {
      id: '/_authenticated/next/suppliers/'
      path: '/suppliers'
      fullPath: '/next/suppliers/'
      preLoaderRoute: typeof AuthenticatedNextSuppliersIndexRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/suppliers/$supplierAndStockLocationId': {
      id: '/_authenticated/next/suppliers/$supplierAndStockLocationId'
      path: '/suppliers/$supplierAndStockLocationId'
      fullPath: '/next/suppliers/$supplierAndStockLocationId'
      preLoaderRoute: typeof AuthenticatedNextSuppliersSupplierAndStockLocationIdRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/suppliers/strategy': {
      id: '/_authenticated/next/suppliers/strategy'
      path: '/suppliers/strategy'
      fullPath: '/next/suppliers/strategy'
      preLoaderRoute: typeof AuthenticatedNextSuppliersStrategyRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/export': {
      id: '/_authenticated/next/templates/export'
      path: '/templates/export'
      fullPath: '/next/templates/export'
      preLoaderRoute: typeof AuthenticatedNextTemplatesExportRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/pcb-specification': {
      id: '/_authenticated/next/templates/pcb-specification'
      path: '/templates/pcb-specification'
      fullPath: '/next/templates/pcb-specification'
      preLoaderRoute: typeof AuthenticatedNextTemplatesPcbSpecificationRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/parts/_sidebar/alerts': {
      id: '/_authenticated/parts/_sidebar/alerts'
      path: '/alerts'
      fullPath: '/parts/alerts'
      preLoaderRoute: typeof AuthenticatedPartsSidebarAlertsRouteImport
      parentRoute: typeof AuthenticatedPartsSidebarRouteRoute
    }
    '/_authenticated/parts/_sidebar/search': {
      id: '/_authenticated/parts/_sidebar/search'
      path: '/search'
      fullPath: '/parts/search'
      preLoaderRoute: typeof AuthenticatedPartsSidebarSearchRouteImport
      parentRoute: typeof AuthenticatedPartsSidebarRouteRoute
    }
    '/_authenticated/parts/components/component-importer': {
      id: '/_authenticated/parts/components/component-importer'
      path: '/parts/components/component-importer'
      fullPath: '/parts/components/component-importer'
      preLoaderRoute: typeof AuthenticatedPartsComponentsComponentImporterRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/parts/components/importer': {
      id: '/_authenticated/parts/components/importer'
      path: '/parts/components/importer'
      fullPath: '/parts/components/importer'
      preLoaderRoute: typeof AuthenticatedPartsComponentsImporterRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/parts/components/linking': {
      id: '/_authenticated/parts/components/linking'
      path: '/parts/components/linking'
      fullPath: '/parts/components/linking'
      preLoaderRoute: typeof AuthenticatedPartsComponentsLinkingRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/parts/demand/demand-importer': {
      id: '/_authenticated/parts/demand/demand-importer'
      path: '/parts/demand/demand-importer'
      fullPath: '/parts/demand/demand-importer'
      preLoaderRoute: typeof AuthenticatedPartsDemandDemandImporterRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/parts/details/$partId': {
      id: '/_authenticated/parts/details/$partId'
      path: '/parts/details/$partId'
      fullPath: '/parts/details/$partId'
      preLoaderRoute: typeof AuthenticatedPartsDetailsPartIdRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/parts/offers/add': {
      id: '/_authenticated/parts/offers/add'
      path: '/parts/offers/add'
      fullPath: '/parts/offers/add'
      preLoaderRoute: typeof AuthenticatedPartsOffersAddRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/parts/offers/create': {
      id: '/_authenticated/parts/offers/create'
      path: '/parts/offers/create'
      fullPath: '/parts/offers/create'
      preLoaderRoute: typeof AuthenticatedPartsOffersCreateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/parts/offers/csv-importer': {
      id: '/_authenticated/parts/offers/csv-importer'
      path: '/parts/offers/csv-importer'
      fullPath: '/parts/offers/csv-importer'
      preLoaderRoute: typeof AuthenticatedPartsOffersCsvImporterRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/parts/quote-requests/excel-importer': {
      id: '/_authenticated/parts/quote-requests/excel-importer'
      path: '/parts/quote-requests/excel-importer'
      fullPath: '/parts/quote-requests/excel-importer'
      preLoaderRoute: typeof AuthenticatedPartsQuoteRequestsExcelImporterRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/parts/quote-requests/importer': {
      id: '/_authenticated/parts/quote-requests/importer'
      path: '/parts/quote-requests/importer'
      fullPath: '/parts/quote-requests/importer'
      preLoaderRoute: typeof AuthenticatedPartsQuoteRequestsImporterRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/': {
      id: '/_authenticated/projects/$projectId/'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId/'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/dashboard': {
      id: '/_authenticated/projects/$projectId/dashboard'
      path: '/projects/$projectId/dashboard'
      fullPath: '/projects/$projectId/dashboard'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdDashboardRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/edit': {
      id: '/_authenticated/projects/$projectId/edit'
      path: '/projects/$projectId/edit'
      fullPath: '/projects/$projectId/edit'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/quotation': {
      id: '/_authenticated/projects/$projectId/quotation'
      path: '/projects/$projectId/quotation'
      fullPath: '/projects/$projectId/quotation'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdQuotationRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/risk-management/library-health/': {
      id: '/_authenticated/risk-management/library-health/'
      path: '/library-health'
      fullPath: '/risk-management/library-health/'
      preLoaderRoute: typeof AuthenticatedRiskManagementLibraryHealthIndexRouteImport
      parentRoute: typeof AuthenticatedRiskManagementRouteRoute
    }
    '/_authenticated/risk-management/library-health/assemblies': {
      id: '/_authenticated/risk-management/library-health/assemblies'
      path: '/library-health/assemblies'
      fullPath: '/risk-management/library-health/assemblies'
      preLoaderRoute: typeof AuthenticatedRiskManagementLibraryHealthAssembliesRouteImport
      parentRoute: typeof AuthenticatedRiskManagementRouteRoute
    }
    '/_authenticated/risk-management/library-health/components': {
      id: '/_authenticated/risk-management/library-health/components'
      path: '/library-health/components'
      fullPath: '/risk-management/library-health/components'
      preLoaderRoute: typeof AuthenticatedRiskManagementLibraryHealthComponentsRouteImport
      parentRoute: typeof AuthenticatedRiskManagementRouteRoute
    }
    '/_authenticated/risk-management/library-health/parts': {
      id: '/_authenticated/risk-management/library-health/parts'
      path: '/library-health/parts'
      fullPath: '/risk-management/library-health/parts'
      preLoaderRoute: typeof AuthenticatedRiskManagementLibraryHealthPartsRouteImport
      parentRoute: typeof AuthenticatedRiskManagementRouteRoute
    }
    '/_authenticated/suppliers/_sidebar/': {
      id: '/_authenticated/suppliers/_sidebar/'
      path: '/'
      fullPath: '/suppliers/'
      preLoaderRoute: typeof AuthenticatedSuppliersSidebarIndexRouteImport
      parentRoute: typeof AuthenticatedSuppliersSidebarRouteRoute
    }
    '/_authenticated/suppliers/_sidebar/strategy': {
      id: '/_authenticated/suppliers/_sidebar/strategy'
      path: '/strategy'
      fullPath: '/suppliers/strategy'
      preLoaderRoute: typeof AuthenticatedSuppliersSidebarStrategyRouteImport
      parentRoute: typeof AuthenticatedSuppliersSidebarRouteRoute
    }
    '/_authenticated/suppliers/line-card-rules/importer': {
      id: '/_authenticated/suppliers/line-card-rules/importer'
      path: '/suppliers/line-card-rules/importer'
      fullPath: '/suppliers/line-card-rules/importer'
      preLoaderRoute: typeof AuthenticatedSuppliersLineCardRulesImporterRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/suppliers/supplier-contacts-importer/bulk': {
      id: '/_authenticated/suppliers/supplier-contacts-importer/bulk'
      path: '/suppliers/supplier-contacts-importer/bulk'
      fullPath: '/suppliers/supplier-contacts-importer/bulk'
      preLoaderRoute: typeof AuthenticatedSuppliersSupplierContactsImporterBulkRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/suppliers/supplier-contacts/importer': {
      id: '/_authenticated/suppliers/supplier-contacts/importer'
      path: '/suppliers/supplier-contacts/importer'
      fullPath: '/suppliers/supplier-contacts/importer'
      preLoaderRoute: typeof AuthenticatedSuppliersSupplierContactsImporterRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/templates/_sidebar/export': {
      id: '/_authenticated/templates/_sidebar/export'
      path: '/export'
      fullPath: '/templates/export'
      preLoaderRoute: typeof AuthenticatedTemplatesSidebarExportRouteImport
      parentRoute: typeof AuthenticatedTemplatesSidebarRouteRoute
    }
    '/_authenticated/templates/_sidebar/pcb-specification': {
      id: '/_authenticated/templates/_sidebar/pcb-specification'
      path: '/pcb-specification'
      fullPath: '/templates/pcb-specification'
      preLoaderRoute: typeof AuthenticatedTemplatesSidebarPcbSpecificationRouteImport
      parentRoute: typeof AuthenticatedTemplatesSidebarRouteRoute
    }
    '/_authenticated/templates/calculation/add-template': {
      id: '/_authenticated/templates/calculation/add-template'
      path: '/templates/calculation/add-template'
      fullPath: '/templates/calculation/add-template'
      preLoaderRoute: typeof AuthenticatedTemplatesCalculationAddTemplateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/templates/calculation/create': {
      id: '/_authenticated/templates/calculation/create'
      path: '/templates/calculation/create'
      fullPath: '/templates/calculation/create'
      preLoaderRoute: typeof AuthenticatedTemplatesCalculationCreateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/templates/flexible-calculation/new': {
      id: '/_authenticated/templates/flexible-calculation/new'
      path: '/templates/flexible-calculation/new'
      fullPath: '/templates/flexible-calculation/new'
      preLoaderRoute: typeof AuthenticatedTemplatesFlexibleCalculationNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/templates/quotation/create': {
      id: '/_authenticated/templates/quotation/create'
      path: '/templates/quotation/create'
      fullPath: '/templates/quotation/create'
      preLoaderRoute: typeof AuthenticatedTemplatesQuotationCreateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/templates/quotation/edit': {
      id: '/_authenticated/templates/quotation/edit'
      path: '/templates/quotation/edit'
      fullPath: '/templates/quotation/edit'
      preLoaderRoute: typeof AuthenticatedTemplatesQuotationEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/assemblies/$assemblyId/pcb/': {
      id: '/_authenticated/assemblies/$assemblyId/pcb/'
      path: '/'
      fullPath: '/assemblies/$assemblyId/pcb/'
      preLoaderRoute: typeof AuthenticatedAssembliesAssemblyIdPcbIndexRouteImport
      parentRoute: typeof AuthenticatedAssembliesAssemblyIdPcbRouteRoute
    }
    '/_authenticated/assemblies/$assemblyId/pcb/cad-viewer': {
      id: '/_authenticated/assemblies/$assemblyId/pcb/cad-viewer'
      path: '/cad-viewer'
      fullPath: '/assemblies/$assemblyId/pcb/cad-viewer'
      preLoaderRoute: typeof AuthenticatedAssembliesAssemblyIdPcbCadViewerRouteImport
      parentRoute: typeof AuthenticatedAssembliesAssemblyIdPcbRouteRoute
    }
    '/_authenticated/assemblies/$assemblyId/pcb/dfm': {
      id: '/_authenticated/assemblies/$assemblyId/pcb/dfm'
      path: '/dfm'
      fullPath: '/assemblies/$assemblyId/pcb/dfm'
      preLoaderRoute: typeof AuthenticatedAssembliesAssemblyIdPcbDfmRouteImport
      parentRoute: typeof AuthenticatedAssembliesAssemblyIdPcbRouteRoute
    }
    '/_authenticated/assemblies/$assemblyId/pcb/dfm-analysis': {
      id: '/_authenticated/assemblies/$assemblyId/pcb/dfm-analysis'
      path: '/dfm-analysis'
      fullPath: '/assemblies/$assemblyId/pcb/dfm-analysis'
      preLoaderRoute: typeof AuthenticatedAssembliesAssemblyIdPcbDfmAnalysisRouteImport
      parentRoute: typeof AuthenticatedAssembliesAssemblyIdPcbRouteRoute
    }
    '/_authenticated/assemblies/$assemblyId/pcb/drills': {
      id: '/_authenticated/assemblies/$assemblyId/pcb/drills'
      path: '/drills'
      fullPath: '/assemblies/$assemblyId/pcb/drills'
      preLoaderRoute: typeof AuthenticatedAssembliesAssemblyIdPcbDrillsRouteImport
      parentRoute: typeof AuthenticatedAssembliesAssemblyIdPcbRouteRoute
    }
    '/_authenticated/assemblies/$assemblyId/pcb/files': {
      id: '/_authenticated/assemblies/$assemblyId/pcb/files'
      path: '/files'
      fullPath: '/assemblies/$assemblyId/pcb/files'
      preLoaderRoute: typeof AuthenticatedAssembliesAssemblyIdPcbFilesRouteImport
      parentRoute: typeof AuthenticatedAssembliesAssemblyIdPcbRouteRoute
    }
    '/_authenticated/assemblies/$assemblyId/pcb/panelization': {
      id: '/_authenticated/assemblies/$assemblyId/pcb/panelization'
      path: '/panelization'
      fullPath: '/assemblies/$assemblyId/pcb/panelization'
      preLoaderRoute: typeof AuthenticatedAssembliesAssemblyIdPcbPanelizationRouteImport
      parentRoute: typeof AuthenticatedAssembliesAssemblyIdPcbRouteRoute
    }
    '/_authenticated/assemblies/$assemblyId/pcb/specification': {
      id: '/_authenticated/assemblies/$assemblyId/pcb/specification'
      path: '/specification'
      fullPath: '/assemblies/$assemblyId/pcb/specification'
      preLoaderRoute: typeof AuthenticatedAssembliesAssemblyIdPcbSpecificationRouteImport
      parentRoute: typeof AuthenticatedAssembliesAssemblyIdPcbRouteRoute
    }
    '/_authenticated/assemblies/$assemblyId/pcb/stackup': {
      id: '/_authenticated/assemblies/$assemblyId/pcb/stackup'
      path: '/stackup'
      fullPath: '/assemblies/$assemblyId/pcb/stackup'
      preLoaderRoute: typeof AuthenticatedAssembliesAssemblyIdPcbStackupRouteImport
      parentRoute: typeof AuthenticatedAssembliesAssemblyIdPcbRouteRoute
    }
    '/_authenticated/assemblies/$assemblyId/subassemblies/create': {
      id: '/_authenticated/assemblies/$assemblyId/subassemblies/create'
      path: '/assemblies/$assemblyId/subassemblies/create'
      fullPath: '/assemblies/$assemblyId/subassemblies/create'
      preLoaderRoute: typeof AuthenticatedAssembliesAssemblyIdSubassembliesCreateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/manufacturing/_sidebar/activities/': {
      id: '/_authenticated/manufacturing/_sidebar/activities/'
      path: '/activities'
      fullPath: '/manufacturing/activities/'
      preLoaderRoute: typeof AuthenticatedManufacturingSidebarActivitiesIndexRouteImport
      parentRoute: typeof AuthenticatedManufacturingSidebarRouteRoute
    }
    '/_authenticated/manufacturing/_sidebar/drivers/': {
      id: '/_authenticated/manufacturing/_sidebar/drivers/'
      path: '/drivers'
      fullPath: '/manufacturing/drivers/'
      preLoaderRoute: typeof AuthenticatedManufacturingSidebarDriversIndexRouteImport
      parentRoute: typeof AuthenticatedManufacturingSidebarRouteRoute
    }
    '/_authenticated/manufacturing/_sidebar/expenses/': {
      id: '/_authenticated/manufacturing/_sidebar/expenses/'
      path: '/expenses'
      fullPath: '/manufacturing/expenses/'
      preLoaderRoute: typeof AuthenticatedManufacturingSidebarExpensesIndexRouteImport
      parentRoute: typeof AuthenticatedManufacturingSidebarRouteRoute
    }
    '/_authenticated/manufacturing/_sidebar/resources/': {
      id: '/_authenticated/manufacturing/_sidebar/resources/'
      path: '/resources'
      fullPath: '/manufacturing/resources/'
      preLoaderRoute: typeof AuthenticatedManufacturingSidebarResourcesIndexRouteImport
      parentRoute: typeof AuthenticatedManufacturingSidebarRouteRoute
    }
    '/_authenticated/manufacturing/_sidebar/templates/{-$templateId}': {
      id: '/_authenticated/manufacturing/_sidebar/templates/{-$templateId}'
      path: '/templates/{-$templateId}'
      fullPath: '/manufacturing/templates/{-$templateId}'
      preLoaderRoute: typeof AuthenticatedManufacturingSidebarTemplatesChar123TemplateIdChar125RouteImport
      parentRoute: typeof AuthenticatedManufacturingSidebarRouteRoute
    }
    '/_authenticated/manufacturing/activities/$activityId/duplicate': {
      id: '/_authenticated/manufacturing/activities/$activityId/duplicate'
      path: '/manufacturing/activities/$activityId/duplicate'
      fullPath: '/manufacturing/activities/$activityId/duplicate'
      preLoaderRoute: typeof AuthenticatedManufacturingActivitiesActivityIdDuplicateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/manufacturing/activities/$activityId/edit': {
      id: '/_authenticated/manufacturing/activities/$activityId/edit'
      path: '/manufacturing/activities/$activityId/edit'
      fullPath: '/manufacturing/activities/$activityId/edit'
      preLoaderRoute: typeof AuthenticatedManufacturingActivitiesActivityIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/manufacturing/drivers/$driverId/duplicate': {
      id: '/_authenticated/manufacturing/drivers/$driverId/duplicate'
      path: '/manufacturing/drivers/$driverId/duplicate'
      fullPath: '/manufacturing/drivers/$driverId/duplicate'
      preLoaderRoute: typeof AuthenticatedManufacturingDriversDriverIdDuplicateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/manufacturing/drivers/$driverId/edit': {
      id: '/_authenticated/manufacturing/drivers/$driverId/edit'
      path: '/manufacturing/drivers/$driverId/edit'
      fullPath: '/manufacturing/drivers/$driverId/edit'
      preLoaderRoute: typeof AuthenticatedManufacturingDriversDriverIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/manufacturing/expenses/$expenseId/duplicate': {
      id: '/_authenticated/manufacturing/expenses/$expenseId/duplicate'
      path: '/manufacturing/expenses/$expenseId/duplicate'
      fullPath: '/manufacturing/expenses/$expenseId/duplicate'
      preLoaderRoute: typeof AuthenticatedManufacturingExpensesExpenseIdDuplicateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/manufacturing/expenses/$expenseId/edit': {
      id: '/_authenticated/manufacturing/expenses/$expenseId/edit'
      path: '/manufacturing/expenses/$expenseId/edit'
      fullPath: '/manufacturing/expenses/$expenseId/edit'
      preLoaderRoute: typeof AuthenticatedManufacturingExpensesExpenseIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/manufacturing/resources/$resourceId/duplicate': {
      id: '/_authenticated/manufacturing/resources/$resourceId/duplicate'
      path: '/manufacturing/resources/$resourceId/duplicate'
      fullPath: '/manufacturing/resources/$resourceId/duplicate'
      preLoaderRoute: typeof AuthenticatedManufacturingResourcesResourceIdDuplicateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/manufacturing/resources/$resourceId/edit': {
      id: '/_authenticated/manufacturing/resources/$resourceId/edit'
      path: '/manufacturing/resources/$resourceId/edit'
      fullPath: '/manufacturing/resources/$resourceId/edit'
      preLoaderRoute: typeof AuthenticatedManufacturingResourcesResourceIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/monitoring/_sidebar/charts/': {
      id: '/_authenticated/monitoring/_sidebar/charts/'
      path: '/charts'
      fullPath: '/monitoring/charts/'
      preLoaderRoute: typeof AuthenticatedMonitoringSidebarChartsIndexRouteImport
      parentRoute: typeof AuthenticatedMonitoringSidebarRouteRoute
    }
    '/_authenticated/monitoring/_sidebar/components/pricing': {
      id: '/_authenticated/monitoring/_sidebar/components/pricing'
      path: '/components/pricing'
      fullPath: '/monitoring/components/pricing'
      preLoaderRoute: typeof AuthenticatedMonitoringSidebarComponentsPricingRouteImport
      parentRoute: typeof AuthenticatedMonitoringSidebarRouteRoute
    }
    '/_authenticated/monitoring/_sidebar/dashboards/': {
      id: '/_authenticated/monitoring/_sidebar/dashboards/'
      path: '/dashboards'
      fullPath: '/monitoring/dashboards/'
      preLoaderRoute: typeof AuthenticatedMonitoringSidebarDashboardsIndexRouteImport
      parentRoute: typeof AuthenticatedMonitoringSidebarRouteRoute
    }
    '/_authenticated/monitoring/_sidebar/dashboards/$dashboardId': {
      id: '/_authenticated/monitoring/_sidebar/dashboards/$dashboardId'
      path: '/dashboards/$dashboardId'
      fullPath: '/monitoring/dashboards/$dashboardId'
      preLoaderRoute: typeof AuthenticatedMonitoringSidebarDashboardsDashboardIdRouteImport
      parentRoute: typeof AuthenticatedMonitoringSidebarRouteRoute
    }
    '/_authenticated/monitoring/_sidebar/insights-agent/{-$conversationId}': {
      id: '/_authenticated/monitoring/_sidebar/insights-agent/{-$conversationId}'
      path: '/insights-agent/{-$conversationId}'
      fullPath: '/monitoring/insights-agent/{-$conversationId}'
      preLoaderRoute: typeof AuthenticatedMonitoringSidebarInsightsAgentChar123ConversationIdChar125RouteImport
      parentRoute: typeof AuthenticatedMonitoringSidebarRouteRoute
    }
    '/_authenticated/monitoring/_sidebar/jobs/': {
      id: '/_authenticated/monitoring/_sidebar/jobs/'
      path: '/jobs'
      fullPath: '/monitoring/jobs/'
      preLoaderRoute: typeof AuthenticatedMonitoringSidebarJobsIndexRouteImport
      parentRoute: typeof AuthenticatedMonitoringSidebarRouteRoute
    }
    '/_authenticated/monitoring/_sidebar/jobs/$jobId': {
      id: '/_authenticated/monitoring/_sidebar/jobs/$jobId'
      path: '/jobs/$jobId'
      fullPath: '/monitoring/jobs/$jobId'
      preLoaderRoute: typeof AuthenticatedMonitoringSidebarJobsJobIdRouteImport
      parentRoute: typeof AuthenticatedMonitoringSidebarRouteRoute
    }
    '/_authenticated/monitoring/_sidebar/reports/savings': {
      id: '/_authenticated/monitoring/_sidebar/reports/savings'
      path: '/reports/savings'
      fullPath: '/monitoring/reports/savings'
      preLoaderRoute: typeof AuthenticatedMonitoringSidebarReportsSavingsRouteImport
      parentRoute: typeof AuthenticatedMonitoringSidebarRouteRoute
    }
    '/_authenticated/negotiations/$negotiationId/_sidebar/overview': {
      id: '/_authenticated/negotiations/$negotiationId/_sidebar/overview'
      path: '/overview'
      fullPath: '/negotiations/$negotiationId/overview'
      preLoaderRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarOverviewRouteImport
      parentRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/next/assemblies/$assemblyId/': {
      id: '/_authenticated/next/assemblies/$assemblyId/'
      path: '/assemblies/$assemblyId'
      fullPath: '/next/assemblies/$assemblyId/'
      preLoaderRoute: typeof AuthenticatedNextAssembliesAssemblyIdIndexRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/assemblies/$assemblyId/dashboard': {
      id: '/_authenticated/next/assemblies/$assemblyId/dashboard'
      path: '/assemblies/$assemblyId/dashboard'
      fullPath: '/next/assemblies/$assemblyId/dashboard'
      preLoaderRoute: typeof AuthenticatedNextAssembliesAssemblyIdDashboardRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/assemblies/$assemblyId/details': {
      id: '/_authenticated/next/assemblies/$assemblyId/details'
      path: '/assemblies/$assemblyId/details'
      fullPath: '/next/assemblies/$assemblyId/details'
      preLoaderRoute: typeof AuthenticatedNextAssembliesAssemblyIdDetailsRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/assemblies/$assemblyId/edit': {
      id: '/_authenticated/next/assemblies/$assemblyId/edit'
      path: '/assemblies/$assemblyId/edit'
      fullPath: '/next/assemblies/$assemblyId/edit'
      preLoaderRoute: typeof AuthenticatedNextAssembliesAssemblyIdEditRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/assemblies/$assemblyId/pcb': {
      id: '/_authenticated/next/assemblies/$assemblyId/pcb'
      path: '/assemblies/$assemblyId/pcb'
      fullPath: '/next/assemblies/$assemblyId/pcb'
      preLoaderRoute: typeof AuthenticatedNextAssembliesAssemblyIdPcbRouteRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/components/ipn/_details': {
      id: '/_authenticated/next/components/ipn/_details'
      path: '/components/ipn'
      fullPath: '/next/components/ipn'
      preLoaderRoute: typeof AuthenticatedNextComponentsIpnDetailsRouteRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/negotiations/$negotiationId/': {
      id: '/_authenticated/next/negotiations/$negotiationId/'
      path: '/negotiations/$negotiationId'
      fullPath: '/next/negotiations/$negotiationId/'
      preLoaderRoute: typeof AuthenticatedNextNegotiationsNegotiationIdIndexRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/negotiations/$negotiationId/_sidebar': {
      id: '/_authenticated/next/negotiations/$negotiationId/_sidebar'
      path: '/negotiations/$negotiationId'
      fullPath: '/next/negotiations/$negotiationId'
      preLoaderRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/parts/$partId/': {
      id: '/_authenticated/next/parts/$partId/'
      path: '/'
      fullPath: '/next/parts/$partId/'
      preLoaderRoute: typeof AuthenticatedNextPartsPartIdIndexRouteImport
      parentRoute: typeof AuthenticatedNextPartsPartIdRouteRoute
    }
    '/_authenticated/next/parts/$partId/compliance': {
      id: '/_authenticated/next/parts/$partId/compliance'
      path: '/compliance'
      fullPath: '/next/parts/$partId/compliance'
      preLoaderRoute: typeof AuthenticatedNextPartsPartIdComplianceRouteImport
      parentRoute: typeof AuthenticatedNextPartsPartIdRouteRoute
    }
    '/_authenticated/next/parts/$partId/offers': {
      id: '/_authenticated/next/parts/$partId/offers'
      path: '/offers'
      fullPath: '/next/parts/$partId/offers'
      preLoaderRoute: typeof AuthenticatedNextPartsPartIdOffersRouteImport
      parentRoute: typeof AuthenticatedNextPartsPartIdRouteRoute
    }
    '/_authenticated/next/parts/$partId/part-alternatives': {
      id: '/_authenticated/next/parts/$partId/part-alternatives'
      path: '/part-alternatives'
      fullPath: '/next/parts/$partId/part-alternatives'
      preLoaderRoute: typeof AuthenticatedNextPartsPartIdPartAlternativesRouteImport
      parentRoute: typeof AuthenticatedNextPartsPartIdRouteRoute
    }
    '/_authenticated/next/parts/$partId/se-alternatives': {
      id: '/_authenticated/next/parts/$partId/se-alternatives'
      path: '/se-alternatives'
      fullPath: '/next/parts/$partId/se-alternatives'
      preLoaderRoute: typeof AuthenticatedNextPartsPartIdSeAlternativesRouteImport
      parentRoute: typeof AuthenticatedNextPartsPartIdRouteRoute
    }
    '/_authenticated/next/parts/$partId/se-documentation': {
      id: '/_authenticated/next/parts/$partId/se-documentation'
      path: '/se-documentation'
      fullPath: '/next/parts/$partId/se-documentation'
      preLoaderRoute: typeof AuthenticatedNextPartsPartIdSeDocumentationRouteImport
      parentRoute: typeof AuthenticatedNextPartsPartIdRouteRoute
    }
    '/_authenticated/next/parts/$partId/se-geo-risk': {
      id: '/_authenticated/next/parts/$partId/se-geo-risk'
      path: '/se-geo-risk'
      fullPath: '/next/parts/$partId/se-geo-risk'
      preLoaderRoute: typeof AuthenticatedNextPartsPartIdSeGeoRiskRouteImport
      parentRoute: typeof AuthenticatedNextPartsPartIdRouteRoute
    }
    '/_authenticated/next/parts/$partId/se-supply-chain': {
      id: '/_authenticated/next/parts/$partId/se-supply-chain'
      path: '/se-supply-chain'
      fullPath: '/next/parts/$partId/se-supply-chain'
      preLoaderRoute: typeof AuthenticatedNextPartsPartIdSeSupplyChainRouteImport
      parentRoute: typeof AuthenticatedNextPartsPartIdRouteRoute
    }
    '/_authenticated/next/parts/$partId/se-technical': {
      id: '/_authenticated/next/parts/$partId/se-technical'
      path: '/se-technical'
      fullPath: '/next/parts/$partId/se-technical'
      preLoaderRoute: typeof AuthenticatedNextPartsPartIdSeTechnicalRouteImport
      parentRoute: typeof AuthenticatedNextPartsPartIdRouteRoute
    }
    '/_authenticated/next/parts/$partId/used-in': {
      id: '/_authenticated/next/parts/$partId/used-in'
      path: '/used-in'
      fullPath: '/next/parts/$partId/used-in'
      preLoaderRoute: typeof AuthenticatedNextPartsPartIdUsedInRouteImport
      parentRoute: typeof AuthenticatedNextPartsPartIdRouteRoute
    }
    '/_authenticated/next/parts/custom/$customPartSpecificationId': {
      id: '/_authenticated/next/parts/custom/$customPartSpecificationId'
      path: '/parts/custom/$customPartSpecificationId'
      fullPath: '/next/parts/custom/$customPartSpecificationId'
      preLoaderRoute: typeof AuthenticatedNextPartsCustomCustomPartSpecificationIdRouteRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/projects/$projectId/': {
      id: '/_authenticated/next/projects/$projectId/'
      path: '/'
      fullPath: '/next/projects/$projectId/'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdIndexRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/dashboard': {
      id: '/_authenticated/next/projects/$projectId/dashboard'
      path: '/dashboard'
      fullPath: '/next/projects/$projectId/dashboard'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdDashboardRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/edit': {
      id: '/_authenticated/next/projects/$projectId/edit'
      path: '/edit'
      fullPath: '/next/projects/$projectId/edit'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdEditRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/quotation': {
      id: '/_authenticated/next/projects/$projectId/quotation'
      path: '/quotation'
      fullPath: '/next/projects/$projectId/quotation'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdQuotationRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/risk-management/library-health/': {
      id: '/_authenticated/next/risk-management/library-health/'
      path: '/risk-management/library-health'
      fullPath: '/next/risk-management/library-health/'
      preLoaderRoute: typeof AuthenticatedNextRiskManagementLibraryHealthIndexRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/risk-management/library-health/assemblies': {
      id: '/_authenticated/next/risk-management/library-health/assemblies'
      path: '/risk-management/library-health/assemblies'
      fullPath: '/next/risk-management/library-health/assemblies'
      preLoaderRoute: typeof AuthenticatedNextRiskManagementLibraryHealthAssembliesRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/risk-management/library-health/components': {
      id: '/_authenticated/next/risk-management/library-health/components'
      path: '/risk-management/library-health/components'
      fullPath: '/next/risk-management/library-health/components'
      preLoaderRoute: typeof AuthenticatedNextRiskManagementLibraryHealthComponentsRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/risk-management/library-health/parts': {
      id: '/_authenticated/next/risk-management/library-health/parts'
      path: '/risk-management/library-health/parts'
      fullPath: '/next/risk-management/library-health/parts'
      preLoaderRoute: typeof AuthenticatedNextRiskManagementLibraryHealthPartsRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/suppliers/supplier-contacts/': {
      id: '/_authenticated/next/suppliers/supplier-contacts/'
      path: '/suppliers/supplier-contacts'
      fullPath: '/next/suppliers/supplier-contacts/'
      preLoaderRoute: typeof AuthenticatedNextSuppliersSupplierContactsIndexRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/email/': {
      id: '/_authenticated/next/templates/email/'
      path: '/templates/email'
      fullPath: '/next/templates/email/'
      preLoaderRoute: typeof AuthenticatedNextTemplatesEmailIndexRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/email/create': {
      id: '/_authenticated/next/templates/email/create'
      path: '/templates/email/create'
      fullPath: '/next/templates/email/create'
      preLoaderRoute: typeof AuthenticatedNextTemplatesEmailCreateRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/flexible-calculation/': {
      id: '/_authenticated/next/templates/flexible-calculation/'
      path: '/templates/flexible-calculation'
      fullPath: '/next/templates/flexible-calculation/'
      preLoaderRoute: typeof AuthenticatedNextTemplatesFlexibleCalculationIndexRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/flexible-calculation/$flexibleCalculationTemplateId': {
      id: '/_authenticated/next/templates/flexible-calculation/$flexibleCalculationTemplateId'
      path: '/templates/flexible-calculation/$flexibleCalculationTemplateId'
      fullPath: '/next/templates/flexible-calculation/$flexibleCalculationTemplateId'
      preLoaderRoute: typeof AuthenticatedNextTemplatesFlexibleCalculationFlexibleCalculationTemplateIdRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/flexible-calculation/create': {
      id: '/_authenticated/next/templates/flexible-calculation/create'
      path: '/templates/flexible-calculation/create'
      fullPath: '/next/templates/flexible-calculation/create'
      preLoaderRoute: typeof AuthenticatedNextTemplatesFlexibleCalculationCreateRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/flexible-calculation/exported-variables': {
      id: '/_authenticated/next/templates/flexible-calculation/exported-variables'
      path: '/templates/flexible-calculation/exported-variables'
      fullPath: '/next/templates/flexible-calculation/exported-variables'
      preLoaderRoute: typeof AuthenticatedNextTemplatesFlexibleCalculationExportedVariablesRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/quotation/': {
      id: '/_authenticated/next/templates/quotation/'
      path: '/templates/quotation'
      fullPath: '/next/templates/quotation/'
      preLoaderRoute: typeof AuthenticatedNextTemplatesQuotationIndexRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/quote-request/': {
      id: '/_authenticated/next/templates/quote-request/'
      path: '/templates/quote-request'
      fullPath: '/next/templates/quote-request/'
      preLoaderRoute: typeof AuthenticatedNextTemplatesQuoteRequestIndexRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/quote-request/create': {
      id: '/_authenticated/next/templates/quote-request/create'
      path: '/templates/quote-request/create'
      fullPath: '/next/templates/quote-request/create'
      preLoaderRoute: typeof AuthenticatedNextTemplatesQuoteRequestCreateRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/sourcing/': {
      id: '/_authenticated/next/templates/sourcing/'
      path: '/templates/sourcing'
      fullPath: '/next/templates/sourcing/'
      preLoaderRoute: typeof AuthenticatedNextTemplatesSourcingIndexRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/sourcing/create': {
      id: '/_authenticated/next/templates/sourcing/create'
      path: '/templates/sourcing/create'
      fullPath: '/next/templates/sourcing/create'
      preLoaderRoute: typeof AuthenticatedNextTemplatesSourcingCreateRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/parts/_sidebar/components/': {
      id: '/_authenticated/parts/_sidebar/components/'
      path: '/components'
      fullPath: '/parts/components/'
      preLoaderRoute: typeof AuthenticatedPartsSidebarComponentsIndexRouteImport
      parentRoute: typeof AuthenticatedPartsSidebarRouteRoute
    }
    '/_authenticated/parts/_sidebar/demands/': {
      id: '/_authenticated/parts/_sidebar/demands/'
      path: '/demands'
      fullPath: '/parts/demands/'
      preLoaderRoute: typeof AuthenticatedPartsSidebarDemandsIndexRouteImport
      parentRoute: typeof AuthenticatedPartsSidebarRouteRoute
    }
    '/_authenticated/parts/_sidebar/demands/importer': {
      id: '/_authenticated/parts/_sidebar/demands/importer'
      path: '/demands/importer'
      fullPath: '/parts/demands/importer'
      preLoaderRoute: typeof AuthenticatedPartsSidebarDemandsImporterRouteImport
      parentRoute: typeof AuthenticatedPartsSidebarRouteRoute
    }
    '/_authenticated/parts/_sidebar/quote-requests/': {
      id: '/_authenticated/parts/_sidebar/quote-requests/'
      path: '/quote-requests'
      fullPath: '/parts/quote-requests/'
      preLoaderRoute: typeof AuthenticatedPartsSidebarQuoteRequestsIndexRouteImport
      parentRoute: typeof AuthenticatedPartsSidebarRouteRoute
    }
    '/_authenticated/parts/components/ipn/_details': {
      id: '/_authenticated/parts/components/ipn/_details'
      path: '/parts/components/ipn'
      fullPath: '/parts/components/ipn'
      preLoaderRoute: typeof AuthenticatedPartsComponentsIpnDetailsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/parts/custom/details/$customPartSpecificationId': {
      id: '/_authenticated/parts/custom/details/$customPartSpecificationId'
      path: '/parts/custom/details/$customPartSpecificationId'
      fullPath: '/parts/custom/details/$customPartSpecificationId'
      preLoaderRoute: typeof AuthenticatedPartsCustomDetailsCustomPartSpecificationIdRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/parts/details/$partId/': {
      id: '/_authenticated/parts/details/$partId/'
      path: '/'
      fullPath: '/parts/details/$partId/'
      preLoaderRoute: typeof AuthenticatedPartsDetailsPartIdIndexRouteImport
      parentRoute: typeof AuthenticatedPartsDetailsPartIdRouteRoute
    }
    '/_authenticated/parts/details/$partId/compliance': {
      id: '/_authenticated/parts/details/$partId/compliance'
      path: '/compliance'
      fullPath: '/parts/details/$partId/compliance'
      preLoaderRoute: typeof AuthenticatedPartsDetailsPartIdComplianceRouteImport
      parentRoute: typeof AuthenticatedPartsDetailsPartIdRouteRoute
    }
    '/_authenticated/parts/details/$partId/offers': {
      id: '/_authenticated/parts/details/$partId/offers'
      path: '/offers'
      fullPath: '/parts/details/$partId/offers'
      preLoaderRoute: typeof AuthenticatedPartsDetailsPartIdOffersRouteImport
      parentRoute: typeof AuthenticatedPartsDetailsPartIdRouteRoute
    }
    '/_authenticated/parts/details/$partId/part-alternatives': {
      id: '/_authenticated/parts/details/$partId/part-alternatives'
      path: '/part-alternatives'
      fullPath: '/parts/details/$partId/part-alternatives'
      preLoaderRoute: typeof AuthenticatedPartsDetailsPartIdPartAlternativesRouteImport
      parentRoute: typeof AuthenticatedPartsDetailsPartIdRouteRoute
    }
    '/_authenticated/parts/details/$partId/se-alternatives': {
      id: '/_authenticated/parts/details/$partId/se-alternatives'
      path: '/se-alternatives'
      fullPath: '/parts/details/$partId/se-alternatives'
      preLoaderRoute: typeof AuthenticatedPartsDetailsPartIdSeAlternativesRouteImport
      parentRoute: typeof AuthenticatedPartsDetailsPartIdRouteRoute
    }
    '/_authenticated/parts/details/$partId/se-documentation': {
      id: '/_authenticated/parts/details/$partId/se-documentation'
      path: '/se-documentation'
      fullPath: '/parts/details/$partId/se-documentation'
      preLoaderRoute: typeof AuthenticatedPartsDetailsPartIdSeDocumentationRouteImport
      parentRoute: typeof AuthenticatedPartsDetailsPartIdRouteRoute
    }
    '/_authenticated/parts/details/$partId/se-geo-risk': {
      id: '/_authenticated/parts/details/$partId/se-geo-risk'
      path: '/se-geo-risk'
      fullPath: '/parts/details/$partId/se-geo-risk'
      preLoaderRoute: typeof AuthenticatedPartsDetailsPartIdSeGeoRiskRouteImport
      parentRoute: typeof AuthenticatedPartsDetailsPartIdRouteRoute
    }
    '/_authenticated/parts/details/$partId/se-supply-chain': {
      id: '/_authenticated/parts/details/$partId/se-supply-chain'
      path: '/se-supply-chain'
      fullPath: '/parts/details/$partId/se-supply-chain'
      preLoaderRoute: typeof AuthenticatedPartsDetailsPartIdSeSupplyChainRouteImport
      parentRoute: typeof AuthenticatedPartsDetailsPartIdRouteRoute
    }
    '/_authenticated/parts/details/$partId/se-technical': {
      id: '/_authenticated/parts/details/$partId/se-technical'
      path: '/se-technical'
      fullPath: '/parts/details/$partId/se-technical'
      preLoaderRoute: typeof AuthenticatedPartsDetailsPartIdSeTechnicalRouteImport
      parentRoute: typeof AuthenticatedPartsDetailsPartIdRouteRoute
    }
    '/_authenticated/parts/details/$partId/used-in': {
      id: '/_authenticated/parts/details/$partId/used-in'
      path: '/used-in'
      fullPath: '/parts/details/$partId/used-in'
      preLoaderRoute: typeof AuthenticatedPartsDetailsPartIdUsedInRouteImport
      parentRoute: typeof AuthenticatedPartsDetailsPartIdRouteRoute
    }
    '/_authenticated/parts/offers/$offerId/duplicate': {
      id: '/_authenticated/parts/offers/$offerId/duplicate'
      path: '/parts/offers/$offerId/duplicate'
      fullPath: '/parts/offers/$offerId/duplicate'
      preLoaderRoute: typeof AuthenticatedPartsOffersOfferIdDuplicateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/parts/offers/$offerId/edit': {
      id: '/_authenticated/parts/offers/$offerId/edit'
      path: '/parts/offers/$offerId/edit'
      fullPath: '/parts/offers/$offerId/edit'
      preLoaderRoute: typeof AuthenticatedPartsOffersOfferIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/bom/': {
      id: '/_authenticated/projects/$projectId/bom/'
      path: '/projects/$projectId/bom'
      fullPath: '/projects/$projectId/bom/'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdBomIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/calculation/': {
      id: '/_authenticated/projects/$projectId/calculation/'
      path: '/projects/$projectId/calculation'
      fullPath: '/projects/$projectId/calculation/'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdCalculationIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/calculation/print': {
      id: '/_authenticated/projects/$projectId/calculation/print'
      path: '/projects/$projectId/calculation/print'
      fullPath: '/projects/$projectId/calculation/print'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdCalculationPrintRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/flexible-calculation/': {
      id: '/_authenticated/projects/$projectId/flexible-calculation/'
      path: '/projects/$projectId/flexible-calculation'
      fullPath: '/projects/$projectId/flexible-calculation/'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdFlexibleCalculationIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/flexible-calculation/$flexibleCalculationId': {
      id: '/_authenticated/projects/$projectId/flexible-calculation/$flexibleCalculationId'
      path: '/projects/$projectId/flexible-calculation/$flexibleCalculationId'
      fullPath: '/projects/$projectId/flexible-calculation/$flexibleCalculationId'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdFlexibleCalculationFlexibleCalculationIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/manufacturing/': {
      id: '/_authenticated/projects/$projectId/manufacturing/'
      path: '/projects/$projectId/manufacturing'
      fullPath: '/projects/$projectId/manufacturing/'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdManufacturingIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/order/': {
      id: '/_authenticated/projects/$projectId/order/'
      path: '/projects/$projectId/order'
      fullPath: '/projects/$projectId/order/'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdOrderIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/order/confirmation': {
      id: '/_authenticated/projects/$projectId/order/confirmation'
      path: '/projects/$projectId/order/confirmation'
      fullPath: '/projects/$projectId/order/confirmation'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdOrderConfirmationRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/sourcing/': {
      id: '/_authenticated/projects/$projectId/sourcing/'
      path: '/projects/$projectId/sourcing'
      fullPath: '/projects/$projectId/sourcing/'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSourcingIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/sourcing/_sidebar': {
      id: '/_authenticated/projects/$projectId/sourcing/_sidebar'
      path: '/projects/$projectId/sourcing'
      fullPath: '/projects/$projectId/sourcing'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/sourcing/demand-groups': {
      id: '/_authenticated/projects/$projectId/sourcing/demand-groups'
      path: '/projects/$projectId/sourcing/demand-groups'
      fullPath: '/projects/$projectId/sourcing/demand-groups'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSourcingDemandGroupsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/_menu/organization/': {
      id: '/_authenticated/settings/_menu/organization/'
      path: '/organization'
      fullPath: '/settings/organization/'
      preLoaderRoute: typeof AuthenticatedSettingsMenuOrganizationIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsMenuRouteRoute
    }
    '/_authenticated/settings/_menu/organization/api-integration': {
      id: '/_authenticated/settings/_menu/organization/api-integration'
      path: '/organization/api-integration'
      fullPath: '/settings/organization/api-integration'
      preLoaderRoute: typeof AuthenticatedSettingsMenuOrganizationApiIntegrationRouteImport
      parentRoute: typeof AuthenticatedSettingsMenuRouteRoute
    }
    '/_authenticated/settings/_menu/organization/assembly-settings': {
      id: '/_authenticated/settings/_menu/organization/assembly-settings'
      path: '/organization/assembly-settings'
      fullPath: '/settings/organization/assembly-settings'
      preLoaderRoute: typeof AuthenticatedSettingsMenuOrganizationAssemblySettingsRouteImport
      parentRoute: typeof AuthenticatedSettingsMenuRouteRoute
    }
    '/_authenticated/settings/_menu/organization/automatic-rfq-number': {
      id: '/_authenticated/settings/_menu/organization/automatic-rfq-number'
      path: '/organization/automatic-rfq-number'
      fullPath: '/settings/organization/automatic-rfq-number'
      preLoaderRoute: typeof AuthenticatedSettingsMenuOrganizationAutomaticRfqNumberRouteImport
      parentRoute: typeof AuthenticatedSettingsMenuRouteRoute
    }
    '/_authenticated/settings/_menu/organization/branding': {
      id: '/_authenticated/settings/_menu/organization/branding'
      path: '/organization/branding'
      fullPath: '/settings/organization/branding'
      preLoaderRoute: typeof AuthenticatedSettingsMenuOrganizationBrandingRouteImport
      parentRoute: typeof AuthenticatedSettingsMenuRouteRoute
    }
    '/_authenticated/settings/_menu/organization/carbon-footprints': {
      id: '/_authenticated/settings/_menu/organization/carbon-footprints'
      path: '/organization/carbon-footprints'
      fullPath: '/settings/organization/carbon-footprints'
      preLoaderRoute: typeof AuthenticatedSettingsMenuOrganizationCarbonFootprintsRouteImport
      parentRoute: typeof AuthenticatedSettingsMenuRouteRoute
    }
    '/_authenticated/settings/_menu/organization/component-settings': {
      id: '/_authenticated/settings/_menu/organization/component-settings'
      path: '/organization/component-settings'
      fullPath: '/settings/organization/component-settings'
      preLoaderRoute: typeof AuthenticatedSettingsMenuOrganizationComponentSettingsRouteImport
      parentRoute: typeof AuthenticatedSettingsMenuRouteRoute
    }
    '/_authenticated/settings/_menu/organization/csv-integration': {
      id: '/_authenticated/settings/_menu/organization/csv-integration'
      path: '/organization/csv-integration'
      fullPath: '/settings/organization/csv-integration'
      preLoaderRoute: typeof AuthenticatedSettingsMenuOrganizationCsvIntegrationRouteImport
      parentRoute: typeof AuthenticatedSettingsMenuRouteRoute
    }
    '/_authenticated/settings/_menu/organization/custom-part-categories': {
      id: '/_authenticated/settings/_menu/organization/custom-part-categories'
      path: '/organization/custom-part-categories'
      fullPath: '/settings/organization/custom-part-categories'
      preLoaderRoute: typeof AuthenticatedSettingsMenuOrganizationCustomPartCategoriesRouteImport
      parentRoute: typeof AuthenticatedSettingsMenuRouteRoute
    }
    '/_authenticated/settings/_menu/organization/data-integrations': {
      id: '/_authenticated/settings/_menu/organization/data-integrations'
      path: '/organization/data-integrations'
      fullPath: '/settings/organization/data-integrations'
      preLoaderRoute: typeof AuthenticatedSettingsMenuOrganizationDataIntegrationsRouteImport
      parentRoute: typeof AuthenticatedSettingsMenuRouteRoute
    }
    '/_authenticated/settings/_menu/organization/feature-flags': {
      id: '/_authenticated/settings/_menu/organization/feature-flags'
      path: '/organization/feature-flags'
      fullPath: '/settings/organization/feature-flags'
      preLoaderRoute: typeof AuthenticatedSettingsMenuOrganizationFeatureFlagsRouteImport
      parentRoute: typeof AuthenticatedSettingsMenuRouteRoute
    }
    '/_authenticated/settings/_menu/organization/manufacturer-preferences': {
      id: '/_authenticated/settings/_menu/organization/manufacturer-preferences'
      path: '/organization/manufacturer-preferences'
      fullPath: '/settings/organization/manufacturer-preferences'
      preLoaderRoute: typeof AuthenticatedSettingsMenuOrganizationManufacturerPreferencesRouteImport
      parentRoute: typeof AuthenticatedSettingsMenuRouteRoute
    }
    '/_authenticated/settings/_menu/organization/sites': {
      id: '/_authenticated/settings/_menu/organization/sites'
      path: '/organization/sites'
      fullPath: '/settings/organization/sites'
      preLoaderRoute: typeof AuthenticatedSettingsMenuOrganizationSitesRouteImport
      parentRoute: typeof AuthenticatedSettingsMenuRouteRoute
    }
    '/_authenticated/settings/_menu/organization/supplier-api-integrations': {
      id: '/_authenticated/settings/_menu/organization/supplier-api-integrations'
      path: '/organization/supplier-api-integrations'
      fullPath: '/settings/organization/supplier-api-integrations'
      preLoaderRoute: typeof AuthenticatedSettingsMenuOrganizationSupplierApiIntegrationsRouteImport
      parentRoute: typeof AuthenticatedSettingsMenuRouteRoute
    }
    '/_authenticated/settings/_menu/user/account-security': {
      id: '/_authenticated/settings/_menu/user/account-security'
      path: '/user/account-security'
      fullPath: '/settings/user/account-security'
      preLoaderRoute: typeof AuthenticatedSettingsMenuUserAccountSecurityRouteImport
      parentRoute: typeof AuthenticatedSettingsMenuRouteRoute
    }
    '/_authenticated/settings/organization/pcb/$panelPreferenceId': {
      id: '/_authenticated/settings/organization/pcb/$panelPreferenceId'
      path: '/settings/organization/pcb/$panelPreferenceId'
      fullPath: '/settings/organization/pcb/$panelPreferenceId'
      preLoaderRoute: typeof AuthenticatedSettingsOrganizationPcbPanelPreferenceIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/organization/pcb/add-preference': {
      id: '/_authenticated/settings/organization/pcb/add-preference'
      path: '/settings/organization/pcb/add-preference'
      fullPath: '/settings/organization/pcb/add-preference'
      preLoaderRoute: typeof AuthenticatedSettingsOrganizationPcbAddPreferenceRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/organization/users/importer': {
      id: '/_authenticated/settings/organization/users/importer'
      path: '/settings/organization/users/importer'
      fullPath: '/settings/organization/users/importer'
      preLoaderRoute: typeof AuthenticatedSettingsOrganizationUsersImporterRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/supplier-portal/quote-requests/$quoteRequestId/': {
      id: '/_authenticated/supplier-portal/quote-requests/$quoteRequestId/'
      path: '/supplier-portal/quote-requests/$quoteRequestId'
      fullPath: '/supplier-portal/quote-requests/$quoteRequestId/'
      preLoaderRoute: typeof AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/supplier-portal/quote-requests/$quoteRequestId/excel-importer': {
      id: '/_authenticated/supplier-portal/quote-requests/$quoteRequestId/excel-importer'
      path: '/supplier-portal/quote-requests/$quoteRequestId/excel-importer'
      fullPath: '/supplier-portal/quote-requests/$quoteRequestId/excel-importer'
      preLoaderRoute: typeof AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdExcelImporterRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/supplier-portal/quote-requests/$quoteRequestId/import-pdf': {
      id: '/_authenticated/supplier-portal/quote-requests/$quoteRequestId/import-pdf'
      path: '/supplier-portal/quote-requests/$quoteRequestId/import-pdf'
      fullPath: '/supplier-portal/quote-requests/$quoteRequestId/import-pdf'
      preLoaderRoute: typeof AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdImportPdfRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/supplier-portal/quote-requests/$quoteRequestId/pdf-importer': {
      id: '/_authenticated/supplier-portal/quote-requests/$quoteRequestId/pdf-importer'
      path: '/supplier-portal/quote-requests/$quoteRequestId/pdf-importer'
      fullPath: '/supplier-portal/quote-requests/$quoteRequestId/pdf-importer'
      preLoaderRoute: typeof AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdPdfImporterRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/suppliers/$supplierId/supplier-contacts-importer/$': {
      id: '/_authenticated/suppliers/$supplierId/supplier-contacts-importer/$'
      path: '/suppliers/$supplierId/supplier-contacts-importer/$'
      fullPath: '/suppliers/$supplierId/supplier-contacts-importer/$'
      preLoaderRoute: typeof AuthenticatedSuppliersSupplierIdSupplierContactsImporterSplatRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/suppliers/$supplierId/supplier-contacts/importer': {
      id: '/_authenticated/suppliers/$supplierId/supplier-contacts/importer'
      path: '/suppliers/$supplierId/supplier-contacts/importer'
      fullPath: '/suppliers/$supplierId/supplier-contacts/importer'
      preLoaderRoute: typeof AuthenticatedSuppliersSupplierIdSupplierContactsImporterRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/suppliers/_sidebar/supplier-contacts/': {
      id: '/_authenticated/suppliers/_sidebar/supplier-contacts/'
      path: '/supplier-contacts'
      fullPath: '/suppliers/supplier-contacts/'
      preLoaderRoute: typeof AuthenticatedSuppliersSidebarSupplierContactsIndexRouteImport
      parentRoute: typeof AuthenticatedSuppliersSidebarRouteRoute
    }
    '/_authenticated/templates/_sidebar/calculation/': {
      id: '/_authenticated/templates/_sidebar/calculation/'
      path: '/calculation'
      fullPath: '/templates/calculation/'
      preLoaderRoute: typeof AuthenticatedTemplatesSidebarCalculationIndexRouteImport
      parentRoute: typeof AuthenticatedTemplatesSidebarRouteRoute
    }
    '/_authenticated/templates/_sidebar/email/': {
      id: '/_authenticated/templates/_sidebar/email/'
      path: '/email'
      fullPath: '/templates/email/'
      preLoaderRoute: typeof AuthenticatedTemplatesSidebarEmailIndexRouteImport
      parentRoute: typeof AuthenticatedTemplatesSidebarRouteRoute
    }
    '/_authenticated/templates/_sidebar/email/create': {
      id: '/_authenticated/templates/_sidebar/email/create'
      path: '/email/create'
      fullPath: '/templates/email/create'
      preLoaderRoute: typeof AuthenticatedTemplatesSidebarEmailCreateRouteImport
      parentRoute: typeof AuthenticatedTemplatesSidebarRouteRoute
    }
    '/_authenticated/templates/_sidebar/flexible-calculation/': {
      id: '/_authenticated/templates/_sidebar/flexible-calculation/'
      path: '/flexible-calculation'
      fullPath: '/templates/flexible-calculation/'
      preLoaderRoute: typeof AuthenticatedTemplatesSidebarFlexibleCalculationIndexRouteImport
      parentRoute: typeof AuthenticatedTemplatesSidebarRouteRoute
    }
    '/_authenticated/templates/_sidebar/flexible-calculation/$flexibleCalculationTemplateId': {
      id: '/_authenticated/templates/_sidebar/flexible-calculation/$flexibleCalculationTemplateId'
      path: '/flexible-calculation/$flexibleCalculationTemplateId'
      fullPath: '/templates/flexible-calculation/$flexibleCalculationTemplateId'
      preLoaderRoute: typeof AuthenticatedTemplatesSidebarFlexibleCalculationFlexibleCalculationTemplateIdRouteImport
      parentRoute: typeof AuthenticatedTemplatesSidebarRouteRoute
    }
    '/_authenticated/templates/_sidebar/flexible-calculation/create': {
      id: '/_authenticated/templates/_sidebar/flexible-calculation/create'
      path: '/flexible-calculation/create'
      fullPath: '/templates/flexible-calculation/create'
      preLoaderRoute: typeof AuthenticatedTemplatesSidebarFlexibleCalculationCreateRouteImport
      parentRoute: typeof AuthenticatedTemplatesSidebarRouteRoute
    }
    '/_authenticated/templates/_sidebar/flexible-calculation/exported-variables': {
      id: '/_authenticated/templates/_sidebar/flexible-calculation/exported-variables'
      path: '/flexible-calculation/exported-variables'
      fullPath: '/templates/flexible-calculation/exported-variables'
      preLoaderRoute: typeof AuthenticatedTemplatesSidebarFlexibleCalculationExportedVariablesRouteImport
      parentRoute: typeof AuthenticatedTemplatesSidebarRouteRoute
    }
    '/_authenticated/templates/_sidebar/quotation/': {
      id: '/_authenticated/templates/_sidebar/quotation/'
      path: '/quotation'
      fullPath: '/templates/quotation/'
      preLoaderRoute: typeof AuthenticatedTemplatesSidebarQuotationIndexRouteImport
      parentRoute: typeof AuthenticatedTemplatesSidebarRouteRoute
    }
    '/_authenticated/templates/_sidebar/quote-request/': {
      id: '/_authenticated/templates/_sidebar/quote-request/'
      path: '/quote-request'
      fullPath: '/templates/quote-request/'
      preLoaderRoute: typeof AuthenticatedTemplatesSidebarQuoteRequestIndexRouteImport
      parentRoute: typeof AuthenticatedTemplatesSidebarRouteRoute
    }
    '/_authenticated/templates/_sidebar/quote-request/create': {
      id: '/_authenticated/templates/_sidebar/quote-request/create'
      path: '/quote-request/create'
      fullPath: '/templates/quote-request/create'
      preLoaderRoute: typeof AuthenticatedTemplatesSidebarQuoteRequestCreateRouteImport
      parentRoute: typeof AuthenticatedTemplatesSidebarRouteRoute
    }
    '/_authenticated/templates/_sidebar/sourcing/': {
      id: '/_authenticated/templates/_sidebar/sourcing/'
      path: '/sourcing'
      fullPath: '/templates/sourcing/'
      preLoaderRoute: typeof AuthenticatedTemplatesSidebarSourcingIndexRouteImport
      parentRoute: typeof AuthenticatedTemplatesSidebarRouteRoute
    }
    '/_authenticated/templates/_sidebar/sourcing/create': {
      id: '/_authenticated/templates/_sidebar/sourcing/create'
      path: '/sourcing/create'
      fullPath: '/templates/sourcing/create'
      preLoaderRoute: typeof AuthenticatedTemplatesSidebarSourcingCreateRouteImport
      parentRoute: typeof AuthenticatedTemplatesSidebarRouteRoute
    }
    '/_authenticated/templates/calculation/$templateId/edit': {
      id: '/_authenticated/templates/calculation/$templateId/edit'
      path: '/templates/calculation/$templateId/edit'
      fullPath: '/templates/calculation/$templateId/edit'
      preLoaderRoute: typeof AuthenticatedTemplatesCalculationTemplateIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/templates/email/$emailTemplateId/update': {
      id: '/_authenticated/templates/email/$emailTemplateId/update'
      path: '/templates/email/$emailTemplateId/update'
      fullPath: '/templates/email/$emailTemplateId/update'
      preLoaderRoute: typeof AuthenticatedTemplatesEmailEmailTemplateIdUpdateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/manufacturing/_sidebar/apps/$appId/$widgetId': {
      id: '/_authenticated/manufacturing/_sidebar/apps/$appId/$widgetId'
      path: '/apps/$appId/$widgetId'
      fullPath: '/manufacturing/apps/$appId/$widgetId'
      preLoaderRoute: typeof AuthenticatedManufacturingSidebarAppsAppIdWidgetIdRouteImport
      parentRoute: typeof AuthenticatedManufacturingSidebarRouteRoute
    }
    '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/': {
      id: '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/'
      path: '/quote-requests'
      fullPath: '/negotiations/$negotiationId/quote-requests/'
      preLoaderRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsIndexRouteImport
      parentRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/$quoteRequestId': {
      id: '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/$quoteRequestId'
      path: '/quote-requests/$quoteRequestId'
      fullPath: '/negotiations/$negotiationId/quote-requests/$quoteRequestId'
      preLoaderRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsQuoteRequestIdRouteImport
      parentRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/assign': {
      id: '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/assign'
      path: '/quote-requests/assign'
      fullPath: '/negotiations/$negotiationId/quote-requests/assign'
      preLoaderRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsAssignRouteImport
      parentRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/attachments': {
      id: '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/attachments'
      path: '/quote-requests/attachments'
      fullPath: '/negotiations/$negotiationId/quote-requests/attachments'
      preLoaderRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsAttachmentsRouteImport
      parentRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/delivery-lot-size': {
      id: '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/delivery-lot-size'
      path: '/quote-requests/delivery-lot-size'
      fullPath: '/negotiations/$negotiationId/quote-requests/delivery-lot-size'
      preLoaderRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsDeliveryLotSizeRouteImport
      parentRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/excel-importer': {
      id: '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/excel-importer'
      path: '/quote-requests/excel-importer'
      fullPath: '/negotiations/$negotiationId/quote-requests/excel-importer'
      preLoaderRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsExcelImporterRouteImport
      parentRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/importer': {
      id: '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/importer'
      path: '/quote-requests/importer'
      fullPath: '/negotiations/$negotiationId/quote-requests/importer'
      preLoaderRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsImporterRouteImport
      parentRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/line-items': {
      id: '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/line-items'
      path: '/quote-requests/line-items'
      fullPath: '/negotiations/$negotiationId/quote-requests/line-items'
      preLoaderRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsLineItemsRouteImport
      parentRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/preview-email': {
      id: '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/preview-email'
      path: '/quote-requests/preview-email'
      fullPath: '/negotiations/$negotiationId/quote-requests/preview-email'
      preLoaderRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsPreviewEmailRouteImport
      parentRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/target-price': {
      id: '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/target-price'
      path: '/quote-requests/target-price'
      fullPath: '/negotiations/$negotiationId/quote-requests/target-price'
      preLoaderRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsTargetPriceRouteImport
      parentRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/negotiations/$negotiationId/_sidebar/scenarios/compare': {
      id: '/_authenticated/negotiations/$negotiationId/_sidebar/scenarios/compare'
      path: '/scenarios/compare'
      fullPath: '/negotiations/$negotiationId/scenarios/compare'
      preLoaderRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarScenariosCompareRouteImport
      parentRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/negotiations/$negotiationId/_sidebar/scenarios/create': {
      id: '/_authenticated/negotiations/$negotiationId/_sidebar/scenarios/create'
      path: '/scenarios/create'
      fullPath: '/negotiations/$negotiationId/scenarios/create'
      preLoaderRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarScenariosCreateRouteImport
      parentRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/next/assemblies/$assemblyId/pcb/': {
      id: '/_authenticated/next/assemblies/$assemblyId/pcb/'
      path: '/'
      fullPath: '/next/assemblies/$assemblyId/pcb/'
      preLoaderRoute: typeof AuthenticatedNextAssembliesAssemblyIdPcbIndexRouteImport
      parentRoute: typeof AuthenticatedNextAssembliesAssemblyIdPcbRouteRoute
    }
    '/_authenticated/next/assemblies/$assemblyId/pcb/cad-viewer': {
      id: '/_authenticated/next/assemblies/$assemblyId/pcb/cad-viewer'
      path: '/cad-viewer'
      fullPath: '/next/assemblies/$assemblyId/pcb/cad-viewer'
      preLoaderRoute: typeof AuthenticatedNextAssembliesAssemblyIdPcbCadViewerRouteImport
      parentRoute: typeof AuthenticatedNextAssembliesAssemblyIdPcbRouteRoute
    }
    '/_authenticated/next/assemblies/$assemblyId/pcb/dfm': {
      id: '/_authenticated/next/assemblies/$assemblyId/pcb/dfm'
      path: '/dfm'
      fullPath: '/next/assemblies/$assemblyId/pcb/dfm'
      preLoaderRoute: typeof AuthenticatedNextAssembliesAssemblyIdPcbDfmRouteImport
      parentRoute: typeof AuthenticatedNextAssembliesAssemblyIdPcbRouteRoute
    }
    '/_authenticated/next/assemblies/$assemblyId/pcb/dfm-analysis': {
      id: '/_authenticated/next/assemblies/$assemblyId/pcb/dfm-analysis'
      path: '/dfm-analysis'
      fullPath: '/next/assemblies/$assemblyId/pcb/dfm-analysis'
      preLoaderRoute: typeof AuthenticatedNextAssembliesAssemblyIdPcbDfmAnalysisRouteImport
      parentRoute: typeof AuthenticatedNextAssembliesAssemblyIdPcbRouteRoute
    }
    '/_authenticated/next/assemblies/$assemblyId/pcb/drills': {
      id: '/_authenticated/next/assemblies/$assemblyId/pcb/drills'
      path: '/drills'
      fullPath: '/next/assemblies/$assemblyId/pcb/drills'
      preLoaderRoute: typeof AuthenticatedNextAssembliesAssemblyIdPcbDrillsRouteImport
      parentRoute: typeof AuthenticatedNextAssembliesAssemblyIdPcbRouteRoute
    }
    '/_authenticated/next/assemblies/$assemblyId/pcb/files': {
      id: '/_authenticated/next/assemblies/$assemblyId/pcb/files'
      path: '/files'
      fullPath: '/next/assemblies/$assemblyId/pcb/files'
      preLoaderRoute: typeof AuthenticatedNextAssembliesAssemblyIdPcbFilesRouteImport
      parentRoute: typeof AuthenticatedNextAssembliesAssemblyIdPcbRouteRoute
    }
    '/_authenticated/next/assemblies/$assemblyId/pcb/panelization': {
      id: '/_authenticated/next/assemblies/$assemblyId/pcb/panelization'
      path: '/panelization'
      fullPath: '/next/assemblies/$assemblyId/pcb/panelization'
      preLoaderRoute: typeof AuthenticatedNextAssembliesAssemblyIdPcbPanelizationRouteImport
      parentRoute: typeof AuthenticatedNextAssembliesAssemblyIdPcbRouteRoute
    }
    '/_authenticated/next/assemblies/$assemblyId/pcb/specification': {
      id: '/_authenticated/next/assemblies/$assemblyId/pcb/specification'
      path: '/specification'
      fullPath: '/next/assemblies/$assemblyId/pcb/specification'
      preLoaderRoute: typeof AuthenticatedNextAssembliesAssemblyIdPcbSpecificationRouteImport
      parentRoute: typeof AuthenticatedNextAssembliesAssemblyIdPcbRouteRoute
    }
    '/_authenticated/next/assemblies/$assemblyId/pcb/stackup': {
      id: '/_authenticated/next/assemblies/$assemblyId/pcb/stackup'
      path: '/stackup'
      fullPath: '/next/assemblies/$assemblyId/pcb/stackup'
      preLoaderRoute: typeof AuthenticatedNextAssembliesAssemblyIdPcbStackupRouteImport
      parentRoute: typeof AuthenticatedNextAssembliesAssemblyIdPcbRouteRoute
    }
    '/_authenticated/next/assemblies/$assemblyId/subassemblies/create': {
      id: '/_authenticated/next/assemblies/$assemblyId/subassemblies/create'
      path: '/assemblies/$assemblyId/subassemblies/create'
      fullPath: '/next/assemblies/$assemblyId/subassemblies/create'
      preLoaderRoute: typeof AuthenticatedNextAssembliesAssemblyIdSubassembliesCreateRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/components/ipn/_details/': {
      id: '/_authenticated/next/components/ipn/_details/'
      path: '/'
      fullPath: '/next/components/ipn/'
      preLoaderRoute: typeof AuthenticatedNextComponentsIpnDetailsIndexRouteImport
      parentRoute: typeof AuthenticatedNextComponentsIpnDetailsRouteRoute
    }
    '/_authenticated/next/components/ipn/_details/cpns': {
      id: '/_authenticated/next/components/ipn/_details/cpns'
      path: '/cpns'
      fullPath: '/next/components/ipn/cpns'
      preLoaderRoute: typeof AuthenticatedNextComponentsIpnDetailsCpnsRouteImport
      parentRoute: typeof AuthenticatedNextComponentsIpnDetailsRouteRoute
    }
    '/_authenticated/next/components/ipn/_details/linking': {
      id: '/_authenticated/next/components/ipn/_details/linking'
      path: '/linking'
      fullPath: '/next/components/ipn/linking'
      preLoaderRoute: typeof AuthenticatedNextComponentsIpnDetailsLinkingRouteImport
      parentRoute: typeof AuthenticatedNextComponentsIpnDetailsRouteRoute
    }
    '/_authenticated/next/components/ipn/_details/used-in': {
      id: '/_authenticated/next/components/ipn/_details/used-in'
      path: '/used-in'
      fullPath: '/next/components/ipn/used-in'
      preLoaderRoute: typeof AuthenticatedNextComponentsIpnDetailsUsedInRouteImport
      parentRoute: typeof AuthenticatedNextComponentsIpnDetailsRouteRoute
    }
    '/_authenticated/next/negotiations/$negotiationId/_sidebar/overview': {
      id: '/_authenticated/next/negotiations/$negotiationId/_sidebar/overview'
      path: '/overview'
      fullPath: '/next/negotiations/$negotiationId/overview'
      preLoaderRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarOverviewRouteImport
      parentRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/next/parts/custom/$customPartSpecificationId/': {
      id: '/_authenticated/next/parts/custom/$customPartSpecificationId/'
      path: '/'
      fullPath: '/next/parts/custom/$customPartSpecificationId/'
      preLoaderRoute: typeof AuthenticatedNextPartsCustomCustomPartSpecificationIdIndexRouteImport
      parentRoute: typeof AuthenticatedNextPartsCustomCustomPartSpecificationIdRouteRoute
    }
    '/_authenticated/next/parts/custom/$customPartSpecificationId/offers': {
      id: '/_authenticated/next/parts/custom/$customPartSpecificationId/offers'
      path: '/offers'
      fullPath: '/next/parts/custom/$customPartSpecificationId/offers'
      preLoaderRoute: typeof AuthenticatedNextPartsCustomCustomPartSpecificationIdOffersRouteImport
      parentRoute: typeof AuthenticatedNextPartsCustomCustomPartSpecificationIdRouteRoute
    }
    '/_authenticated/next/parts/custom/$customPartSpecificationId/used-in': {
      id: '/_authenticated/next/parts/custom/$customPartSpecificationId/used-in'
      path: '/used-in'
      fullPath: '/next/parts/custom/$customPartSpecificationId/used-in'
      preLoaderRoute: typeof AuthenticatedNextPartsCustomCustomPartSpecificationIdUsedInRouteImport
      parentRoute: typeof AuthenticatedNextPartsCustomCustomPartSpecificationIdRouteRoute
    }
    '/_authenticated/next/parts/offers/$offerId/duplicate': {
      id: '/_authenticated/next/parts/offers/$offerId/duplicate'
      path: '/parts/offers/$offerId/duplicate'
      fullPath: '/next/parts/offers/$offerId/duplicate'
      preLoaderRoute: typeof AuthenticatedNextPartsOffersOfferIdDuplicateRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/parts/offers/$offerId/edit': {
      id: '/_authenticated/next/parts/offers/$offerId/edit'
      path: '/parts/offers/$offerId/edit'
      fullPath: '/next/parts/offers/$offerId/edit'
      preLoaderRoute: typeof AuthenticatedNextPartsOffersOfferIdEditRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/projects/$projectId/assemblies/': {
      id: '/_authenticated/next/projects/$projectId/assemblies/'
      path: '/assemblies'
      fullPath: '/next/projects/$projectId/assemblies/'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesIndexRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/flexible-calculation/': {
      id: '/_authenticated/next/projects/$projectId/flexible-calculation/'
      path: '/flexible-calculation'
      fullPath: '/next/projects/$projectId/flexible-calculation/'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdFlexibleCalculationIndexRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/flexible-calculation/$flexibleCalculationId': {
      id: '/_authenticated/next/projects/$projectId/flexible-calculation/$flexibleCalculationId'
      path: '/flexible-calculation/$flexibleCalculationId'
      fullPath: '/next/projects/$projectId/flexible-calculation/$flexibleCalculationId'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdFlexibleCalculationFlexibleCalculationIdRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/manufacturing/': {
      id: '/_authenticated/next/projects/$projectId/manufacturing/'
      path: '/manufacturing'
      fullPath: '/next/projects/$projectId/manufacturing/'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdManufacturingIndexRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/sourcing/': {
      id: '/_authenticated/next/projects/$projectId/sourcing/'
      path: '/sourcing'
      fullPath: '/next/projects/$projectId/sourcing/'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdSourcingIndexRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/sourcing/compare': {
      id: '/_authenticated/next/projects/$projectId/sourcing/compare'
      path: '/sourcing/compare'
      fullPath: '/next/projects/$projectId/sourcing/compare'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdSourcingCompareRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/sourcing/overview': {
      id: '/_authenticated/next/projects/$projectId/sourcing/overview'
      path: '/sourcing/overview'
      fullPath: '/next/projects/$projectId/sourcing/overview'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdSourcingOverviewRouteRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/sourcing/version-history': {
      id: '/_authenticated/next/projects/$projectId/sourcing/version-history'
      path: '/sourcing/version-history'
      fullPath: '/next/projects/$projectId/sourcing/version-history'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdSourcingVersionHistoryRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/settings/_menu/organization/': {
      id: '/_authenticated/next/settings/_menu/organization/'
      path: '/organization'
      fullPath: '/next/settings/organization/'
      preLoaderRoute: typeof AuthenticatedNextSettingsMenuOrganizationIndexRouteImport
      parentRoute: typeof AuthenticatedNextSettingsMenuRouteRoute
    }
    '/_authenticated/next/settings/_menu/organization/api-integration': {
      id: '/_authenticated/next/settings/_menu/organization/api-integration'
      path: '/organization/api-integration'
      fullPath: '/next/settings/organization/api-integration'
      preLoaderRoute: typeof AuthenticatedNextSettingsMenuOrganizationApiIntegrationRouteImport
      parentRoute: typeof AuthenticatedNextSettingsMenuRouteRoute
    }
    '/_authenticated/next/settings/_menu/organization/assembly-settings': {
      id: '/_authenticated/next/settings/_menu/organization/assembly-settings'
      path: '/organization/assembly-settings'
      fullPath: '/next/settings/organization/assembly-settings'
      preLoaderRoute: typeof AuthenticatedNextSettingsMenuOrganizationAssemblySettingsRouteImport
      parentRoute: typeof AuthenticatedNextSettingsMenuRouteRoute
    }
    '/_authenticated/next/settings/_menu/organization/automatic-rfq-number': {
      id: '/_authenticated/next/settings/_menu/organization/automatic-rfq-number'
      path: '/organization/automatic-rfq-number'
      fullPath: '/next/settings/organization/automatic-rfq-number'
      preLoaderRoute: typeof AuthenticatedNextSettingsMenuOrganizationAutomaticRfqNumberRouteImport
      parentRoute: typeof AuthenticatedNextSettingsMenuRouteRoute
    }
    '/_authenticated/next/settings/_menu/organization/branding': {
      id: '/_authenticated/next/settings/_menu/organization/branding'
      path: '/organization/branding'
      fullPath: '/next/settings/organization/branding'
      preLoaderRoute: typeof AuthenticatedNextSettingsMenuOrganizationBrandingRouteImport
      parentRoute: typeof AuthenticatedNextSettingsMenuRouteRoute
    }
    '/_authenticated/next/settings/_menu/organization/carbon-footprints': {
      id: '/_authenticated/next/settings/_menu/organization/carbon-footprints'
      path: '/organization/carbon-footprints'
      fullPath: '/next/settings/organization/carbon-footprints'
      preLoaderRoute: typeof AuthenticatedNextSettingsMenuOrganizationCarbonFootprintsRouteImport
      parentRoute: typeof AuthenticatedNextSettingsMenuRouteRoute
    }
    '/_authenticated/next/settings/_menu/organization/component-settings': {
      id: '/_authenticated/next/settings/_menu/organization/component-settings'
      path: '/organization/component-settings'
      fullPath: '/next/settings/organization/component-settings'
      preLoaderRoute: typeof AuthenticatedNextSettingsMenuOrganizationComponentSettingsRouteImport
      parentRoute: typeof AuthenticatedNextSettingsMenuRouteRoute
    }
    '/_authenticated/next/settings/_menu/organization/csv-integration': {
      id: '/_authenticated/next/settings/_menu/organization/csv-integration'
      path: '/organization/csv-integration'
      fullPath: '/next/settings/organization/csv-integration'
      preLoaderRoute: typeof AuthenticatedNextSettingsMenuOrganizationCsvIntegrationRouteImport
      parentRoute: typeof AuthenticatedNextSettingsMenuRouteRoute
    }
    '/_authenticated/next/settings/_menu/organization/custom-part-categories': {
      id: '/_authenticated/next/settings/_menu/organization/custom-part-categories'
      path: '/organization/custom-part-categories'
      fullPath: '/next/settings/organization/custom-part-categories'
      preLoaderRoute: typeof AuthenticatedNextSettingsMenuOrganizationCustomPartCategoriesRouteImport
      parentRoute: typeof AuthenticatedNextSettingsMenuRouteRoute
    }
    '/_authenticated/next/settings/_menu/organization/data-integrations': {
      id: '/_authenticated/next/settings/_menu/organization/data-integrations'
      path: '/organization/data-integrations'
      fullPath: '/next/settings/organization/data-integrations'
      preLoaderRoute: typeof AuthenticatedNextSettingsMenuOrganizationDataIntegrationsRouteImport
      parentRoute: typeof AuthenticatedNextSettingsMenuRouteRoute
    }
    '/_authenticated/next/settings/_menu/organization/feature-flags': {
      id: '/_authenticated/next/settings/_menu/organization/feature-flags'
      path: '/organization/feature-flags'
      fullPath: '/next/settings/organization/feature-flags'
      preLoaderRoute: typeof AuthenticatedNextSettingsMenuOrganizationFeatureFlagsRouteImport
      parentRoute: typeof AuthenticatedNextSettingsMenuRouteRoute
    }
    '/_authenticated/next/settings/_menu/organization/manufacturer-preferences': {
      id: '/_authenticated/next/settings/_menu/organization/manufacturer-preferences'
      path: '/organization/manufacturer-preferences'
      fullPath: '/next/settings/organization/manufacturer-preferences'
      preLoaderRoute: typeof AuthenticatedNextSettingsMenuOrganizationManufacturerPreferencesRouteImport
      parentRoute: typeof AuthenticatedNextSettingsMenuRouteRoute
    }
    '/_authenticated/next/settings/_menu/organization/sites': {
      id: '/_authenticated/next/settings/_menu/organization/sites'
      path: '/organization/sites'
      fullPath: '/next/settings/organization/sites'
      preLoaderRoute: typeof AuthenticatedNextSettingsMenuOrganizationSitesRouteImport
      parentRoute: typeof AuthenticatedNextSettingsMenuRouteRoute
    }
    '/_authenticated/next/settings/_menu/organization/supplier-api-integrations': {
      id: '/_authenticated/next/settings/_menu/organization/supplier-api-integrations'
      path: '/organization/supplier-api-integrations'
      fullPath: '/next/settings/organization/supplier-api-integrations'
      preLoaderRoute: typeof AuthenticatedNextSettingsMenuOrganizationSupplierApiIntegrationsRouteImport
      parentRoute: typeof AuthenticatedNextSettingsMenuRouteRoute
    }
    '/_authenticated/next/settings/_menu/user/account-security': {
      id: '/_authenticated/next/settings/_menu/user/account-security'
      path: '/user/account-security'
      fullPath: '/next/settings/user/account-security'
      preLoaderRoute: typeof AuthenticatedNextSettingsMenuUserAccountSecurityRouteImport
      parentRoute: typeof AuthenticatedNextSettingsMenuRouteRoute
    }
    '/_authenticated/next/settings/organization/users/importer': {
      id: '/_authenticated/next/settings/organization/users/importer'
      path: '/settings/organization/users/importer'
      fullPath: '/next/settings/organization/users/importer'
      preLoaderRoute: typeof AuthenticatedNextSettingsOrganizationUsersImporterRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/email/$emailTemplateId/edit': {
      id: '/_authenticated/next/templates/email/$emailTemplateId/edit'
      path: '/templates/email/$emailTemplateId/edit'
      fullPath: '/next/templates/email/$emailTemplateId/edit'
      preLoaderRoute: typeof AuthenticatedNextTemplatesEmailEmailTemplateIdEditRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/manufacturing/activities/': {
      id: '/_authenticated/next/templates/manufacturing/activities/'
      path: '/templates/manufacturing/activities'
      fullPath: '/next/templates/manufacturing/activities/'
      preLoaderRoute: typeof AuthenticatedNextTemplatesManufacturingActivitiesIndexRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/manufacturing/activities/create': {
      id: '/_authenticated/next/templates/manufacturing/activities/create'
      path: '/templates/manufacturing/activities/create'
      fullPath: '/next/templates/manufacturing/activities/create'
      preLoaderRoute: typeof AuthenticatedNextTemplatesManufacturingActivitiesCreateRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/manufacturing/drivers/': {
      id: '/_authenticated/next/templates/manufacturing/drivers/'
      path: '/templates/manufacturing/drivers'
      fullPath: '/next/templates/manufacturing/drivers/'
      preLoaderRoute: typeof AuthenticatedNextTemplatesManufacturingDriversIndexRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/manufacturing/drivers/create': {
      id: '/_authenticated/next/templates/manufacturing/drivers/create'
      path: '/templates/manufacturing/drivers/create'
      fullPath: '/next/templates/manufacturing/drivers/create'
      preLoaderRoute: typeof AuthenticatedNextTemplatesManufacturingDriversCreateRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/manufacturing/expenses/': {
      id: '/_authenticated/next/templates/manufacturing/expenses/'
      path: '/templates/manufacturing/expenses'
      fullPath: '/next/templates/manufacturing/expenses/'
      preLoaderRoute: typeof AuthenticatedNextTemplatesManufacturingExpensesIndexRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/manufacturing/expenses/create': {
      id: '/_authenticated/next/templates/manufacturing/expenses/create'
      path: '/templates/manufacturing/expenses/create'
      fullPath: '/next/templates/manufacturing/expenses/create'
      preLoaderRoute: typeof AuthenticatedNextTemplatesManufacturingExpensesCreateRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/manufacturing/resources/': {
      id: '/_authenticated/next/templates/manufacturing/resources/'
      path: '/templates/manufacturing/resources'
      fullPath: '/next/templates/manufacturing/resources/'
      preLoaderRoute: typeof AuthenticatedNextTemplatesManufacturingResourcesIndexRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/manufacturing/resources/create': {
      id: '/_authenticated/next/templates/manufacturing/resources/create'
      path: '/templates/manufacturing/resources/create'
      fullPath: '/next/templates/manufacturing/resources/create'
      preLoaderRoute: typeof AuthenticatedNextTemplatesManufacturingResourcesCreateRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/manufacturing/templates/{-$templateId}': {
      id: '/_authenticated/next/templates/manufacturing/templates/{-$templateId}'
      path: '/templates/manufacturing/templates/{-$templateId}'
      fullPath: '/next/templates/manufacturing/templates/{-$templateId}'
      preLoaderRoute: typeof AuthenticatedNextTemplatesManufacturingTemplatesChar123TemplateIdChar125RouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/quotation/builder/{-$templateId}': {
      id: '/_authenticated/next/templates/quotation/builder/{-$templateId}'
      path: '/templates/quotation/builder/{-$templateId}'
      fullPath: '/next/templates/quotation/builder/{-$templateId}'
      preLoaderRoute: typeof AuthenticatedNextTemplatesQuotationBuilderChar123TemplateIdChar125RouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/quote-request/$quoteRequestTemplateId/edit': {
      id: '/_authenticated/next/templates/quote-request/$quoteRequestTemplateId/edit'
      path: '/templates/quote-request/$quoteRequestTemplateId/edit'
      fullPath: '/next/templates/quote-request/$quoteRequestTemplateId/edit'
      preLoaderRoute: typeof AuthenticatedNextTemplatesQuoteRequestQuoteRequestTemplateIdEditRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/sourcing/$sourcingTemplateId/duplicate': {
      id: '/_authenticated/next/templates/sourcing/$sourcingTemplateId/duplicate'
      path: '/templates/sourcing/$sourcingTemplateId/duplicate'
      fullPath: '/next/templates/sourcing/$sourcingTemplateId/duplicate'
      preLoaderRoute: typeof AuthenticatedNextTemplatesSourcingSourcingTemplateIdDuplicateRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/sourcing/$sourcingTemplateId/edit': {
      id: '/_authenticated/next/templates/sourcing/$sourcingTemplateId/edit'
      path: '/templates/sourcing/$sourcingTemplateId/edit'
      fullPath: '/next/templates/sourcing/$sourcingTemplateId/edit'
      preLoaderRoute: typeof AuthenticatedNextTemplatesSourcingSourcingTemplateIdEditRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/parts/components/ipn/_details/': {
      id: '/_authenticated/parts/components/ipn/_details/'
      path: '/'
      fullPath: '/parts/components/ipn/'
      preLoaderRoute: typeof AuthenticatedPartsComponentsIpnDetailsIndexRouteImport
      parentRoute: typeof AuthenticatedPartsComponentsIpnDetailsRouteRoute
    }
    '/_authenticated/parts/components/ipn/_details/cpns': {
      id: '/_authenticated/parts/components/ipn/_details/cpns'
      path: '/cpns'
      fullPath: '/parts/components/ipn/cpns'
      preLoaderRoute: typeof AuthenticatedPartsComponentsIpnDetailsCpnsRouteImport
      parentRoute: typeof AuthenticatedPartsComponentsIpnDetailsRouteRoute
    }
    '/_authenticated/parts/components/ipn/_details/linking': {
      id: '/_authenticated/parts/components/ipn/_details/linking'
      path: '/linking'
      fullPath: '/parts/components/ipn/linking'
      preLoaderRoute: typeof AuthenticatedPartsComponentsIpnDetailsLinkingRouteImport
      parentRoute: typeof AuthenticatedPartsComponentsIpnDetailsRouteRoute
    }
    '/_authenticated/parts/components/ipn/_details/offers': {
      id: '/_authenticated/parts/components/ipn/_details/offers'
      path: '/offers'
      fullPath: '/parts/components/ipn/offers'
      preLoaderRoute: typeof AuthenticatedPartsComponentsIpnDetailsOffersRouteImport
      parentRoute: typeof AuthenticatedPartsComponentsIpnDetailsRouteRoute
    }
    '/_authenticated/parts/components/ipn/_details/used-in': {
      id: '/_authenticated/parts/components/ipn/_details/used-in'
      path: '/used-in'
      fullPath: '/parts/components/ipn/used-in'
      preLoaderRoute: typeof AuthenticatedPartsComponentsIpnDetailsUsedInRouteImport
      parentRoute: typeof AuthenticatedPartsComponentsIpnDetailsRouteRoute
    }
    '/_authenticated/parts/custom/details/$customPartSpecificationId/': {
      id: '/_authenticated/parts/custom/details/$customPartSpecificationId/'
      path: '/'
      fullPath: '/parts/custom/details/$customPartSpecificationId/'
      preLoaderRoute: typeof AuthenticatedPartsCustomDetailsCustomPartSpecificationIdIndexRouteImport
      parentRoute: typeof AuthenticatedPartsCustomDetailsCustomPartSpecificationIdRouteRoute
    }
    '/_authenticated/parts/custom/details/$customPartSpecificationId/offers': {
      id: '/_authenticated/parts/custom/details/$customPartSpecificationId/offers'
      path: '/offers'
      fullPath: '/parts/custom/details/$customPartSpecificationId/offers'
      preLoaderRoute: typeof AuthenticatedPartsCustomDetailsCustomPartSpecificationIdOffersRouteImport
      parentRoute: typeof AuthenticatedPartsCustomDetailsCustomPartSpecificationIdRouteRoute
    }
    '/_authenticated/parts/custom/details/$customPartSpecificationId/used-in': {
      id: '/_authenticated/parts/custom/details/$customPartSpecificationId/used-in'
      path: '/used-in'
      fullPath: '/parts/custom/details/$customPartSpecificationId/used-in'
      preLoaderRoute: typeof AuthenticatedPartsCustomDetailsCustomPartSpecificationIdUsedInRouteImport
      parentRoute: typeof AuthenticatedPartsCustomDetailsCustomPartSpecificationIdRouteRoute
    }
    '/_authenticated/projects/$projectId/bom/assembly/add-assembly': {
      id: '/_authenticated/projects/$projectId/bom/assembly/add-assembly'
      path: '/projects/$projectId/bom/assembly/add-assembly'
      fullPath: '/projects/$projectId/bom/assembly/add-assembly'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAddAssemblyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/calculation/$assemblyId/calculation': {
      id: '/_authenticated/projects/$projectId/calculation/$assemblyId/calculation'
      path: '/projects/$projectId/calculation/$assemblyId/calculation'
      fullPath: '/projects/$projectId/calculation/$assemblyId/calculation'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdCalculationAssemblyIdCalculationRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/calculation/assemblies/$assemblyId': {
      id: '/_authenticated/projects/$projectId/calculation/assemblies/$assemblyId'
      path: '/projects/$projectId/calculation/assemblies/$assemblyId'
      fullPath: '/projects/$projectId/calculation/assemblies/$assemblyId'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdCalculationAssembliesAssemblyIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/': {
      id: '/_authenticated/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/'
      path: '/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId'
      fullPath: '/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/sourcing/_sidebar/compare': {
      id: '/_authenticated/projects/$projectId/sourcing/_sidebar/compare'
      path: '/compare'
      fullPath: '/projects/$projectId/sourcing/compare'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarCompareRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute
    }
    '/_authenticated/projects/$projectId/sourcing/_sidebar/version-history': {
      id: '/_authenticated/projects/$projectId/sourcing/_sidebar/version-history'
      path: '/version-history'
      fullPath: '/projects/$projectId/sourcing/version-history'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarVersionHistoryRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute
    }
    '/_authenticated/projects/$projectId/sourcing/assembly/$assemblyId': {
      id: '/_authenticated/projects/$projectId/sourcing/assembly/$assemblyId'
      path: '/projects/$projectId/sourcing/assembly/$assemblyId'
      fullPath: '/projects/$projectId/sourcing/assembly/$assemblyId'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSourcingAssemblyAssemblyIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/_menu/organization/customer-portal/': {
      id: '/_authenticated/settings/_menu/organization/customer-portal/'
      path: '/organization/customer-portal'
      fullPath: '/settings/organization/customer-portal/'
      preLoaderRoute: typeof AuthenticatedSettingsMenuOrganizationCustomerPortalIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsMenuRouteRoute
    }
    '/_authenticated/settings/_menu/organization/customer-portal/additional-services': {
      id: '/_authenticated/settings/_menu/organization/customer-portal/additional-services'
      path: '/organization/customer-portal/additional-services'
      fullPath: '/settings/organization/customer-portal/additional-services'
      preLoaderRoute: typeof AuthenticatedSettingsMenuOrganizationCustomerPortalAdditionalServicesRouteImport
      parentRoute: typeof AuthenticatedSettingsMenuRouteRoute
    }
    '/_authenticated/settings/_menu/organization/customer-portal/checkout-conditions': {
      id: '/_authenticated/settings/_menu/organization/customer-portal/checkout-conditions'
      path: '/organization/customer-portal/checkout-conditions'
      fullPath: '/settings/organization/customer-portal/checkout-conditions'
      preLoaderRoute: typeof AuthenticatedSettingsMenuOrganizationCustomerPortalCheckoutConditionsRouteImport
      parentRoute: typeof AuthenticatedSettingsMenuRouteRoute
    }
    '/_authenticated/settings/_menu/organization/customer-portal/customer-specific-settings': {
      id: '/_authenticated/settings/_menu/organization/customer-portal/customer-specific-settings'
      path: '/organization/customer-portal/customer-specific-settings'
      fullPath: '/settings/organization/customer-portal/customer-specific-settings'
      preLoaderRoute: typeof AuthenticatedSettingsMenuOrganizationCustomerPortalCustomerSpecificSettingsRouteImport
      parentRoute: typeof AuthenticatedSettingsMenuRouteRoute
    }
    '/_authenticated/settings/_menu/organization/customer-portal/landing-page': {
      id: '/_authenticated/settings/_menu/organization/customer-portal/landing-page'
      path: '/organization/customer-portal/landing-page'
      fullPath: '/settings/organization/customer-portal/landing-page'
      preLoaderRoute: typeof AuthenticatedSettingsMenuOrganizationCustomerPortalLandingPageRouteImport
      parentRoute: typeof AuthenticatedSettingsMenuRouteRoute
    }
    '/_authenticated/settings/_menu/organization/customer-portal/payment-credentials': {
      id: '/_authenticated/settings/_menu/organization/customer-portal/payment-credentials'
      path: '/organization/customer-portal/payment-credentials'
      fullPath: '/settings/organization/customer-portal/payment-credentials'
      preLoaderRoute: typeof AuthenticatedSettingsMenuOrganizationCustomerPortalPaymentCredentialsRouteImport
      parentRoute: typeof AuthenticatedSettingsMenuRouteRoute
    }
    '/_authenticated/settings/_menu/organization/pcb/': {
      id: '/_authenticated/settings/_menu/organization/pcb/'
      path: '/organization/pcb'
      fullPath: '/settings/organization/pcb/'
      preLoaderRoute: typeof AuthenticatedSettingsMenuOrganizationPcbIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsMenuRouteRoute
    }
    '/_authenticated/settings/_menu/organization/user-management/action-permissions': {
      id: '/_authenticated/settings/_menu/organization/user-management/action-permissions'
      path: '/organization/user-management/action-permissions'
      fullPath: '/settings/organization/user-management/action-permissions'
      preLoaderRoute: typeof AuthenticatedSettingsMenuOrganizationUserManagementActionPermissionsRouteImport
      parentRoute: typeof AuthenticatedSettingsMenuRouteRoute
    }
    '/_authenticated/settings/_menu/organization/user-management/roles': {
      id: '/_authenticated/settings/_menu/organization/user-management/roles'
      path: '/organization/user-management/roles'
      fullPath: '/settings/organization/user-management/roles'
      preLoaderRoute: typeof AuthenticatedSettingsMenuOrganizationUserManagementRolesRouteImport
      parentRoute: typeof AuthenticatedSettingsMenuRouteRoute
    }
    '/_authenticated/settings/_menu/organization/users/': {
      id: '/_authenticated/settings/_menu/organization/users/'
      path: '/organization/users'
      fullPath: '/settings/organization/users/'
      preLoaderRoute: typeof AuthenticatedSettingsMenuOrganizationUsersIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsMenuRouteRoute
    }
    '/_authenticated/settings/organization/pcb/panel-preferences/': {
      id: '/_authenticated/settings/organization/pcb/panel-preferences/'
      path: '/settings/organization/pcb/panel-preferences'
      fullPath: '/settings/organization/pcb/panel-preferences/'
      preLoaderRoute: typeof AuthenticatedSettingsOrganizationPcbPanelPreferencesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/templates/_sidebar/email/$emailTemplateId/edit': {
      id: '/_authenticated/templates/_sidebar/email/$emailTemplateId/edit'
      path: '/email/$emailTemplateId/edit'
      fullPath: '/templates/email/$emailTemplateId/edit'
      preLoaderRoute: typeof AuthenticatedTemplatesSidebarEmailEmailTemplateIdEditRouteImport
      parentRoute: typeof AuthenticatedTemplatesSidebarRouteRoute
    }
    '/_authenticated/templates/_sidebar/quotation/builder/{-$templateId}': {
      id: '/_authenticated/templates/_sidebar/quotation/builder/{-$templateId}'
      path: '/quotation/builder/{-$templateId}'
      fullPath: '/templates/quotation/builder/{-$templateId}'
      preLoaderRoute: typeof AuthenticatedTemplatesSidebarQuotationBuilderChar123TemplateIdChar125RouteImport
      parentRoute: typeof AuthenticatedTemplatesSidebarRouteRoute
    }
    '/_authenticated/templates/_sidebar/quote-request/$quoteRequestTemplateId/edit': {
      id: '/_authenticated/templates/_sidebar/quote-request/$quoteRequestTemplateId/edit'
      path: '/quote-request/$quoteRequestTemplateId/edit'
      fullPath: '/templates/quote-request/$quoteRequestTemplateId/edit'
      preLoaderRoute: typeof AuthenticatedTemplatesSidebarQuoteRequestQuoteRequestTemplateIdEditRouteImport
      parentRoute: typeof AuthenticatedTemplatesSidebarRouteRoute
    }
    '/_authenticated/templates/_sidebar/sourcing/$sourcingTemplateId/duplicate': {
      id: '/_authenticated/templates/_sidebar/sourcing/$sourcingTemplateId/duplicate'
      path: '/sourcing/$sourcingTemplateId/duplicate'
      fullPath: '/templates/sourcing/$sourcingTemplateId/duplicate'
      preLoaderRoute: typeof AuthenticatedTemplatesSidebarSourcingSourcingTemplateIdDuplicateRouteImport
      parentRoute: typeof AuthenticatedTemplatesSidebarRouteRoute
    }
    '/_authenticated/templates/_sidebar/sourcing/$sourcingTemplateId/edit': {
      id: '/_authenticated/templates/_sidebar/sourcing/$sourcingTemplateId/edit'
      path: '/sourcing/$sourcingTemplateId/edit'
      fullPath: '/templates/sourcing/$sourcingTemplateId/edit'
      preLoaderRoute: typeof AuthenticatedTemplatesSidebarSourcingSourcingTemplateIdEditRouteImport
      parentRoute: typeof AuthenticatedTemplatesSidebarRouteRoute
    }
    '/_authenticated/monitoring/_sidebar/components/categories/$categoryId/pricing': {
      id: '/_authenticated/monitoring/_sidebar/components/categories/$categoryId/pricing'
      path: '/components/categories/$categoryId/pricing'
      fullPath: '/monitoring/components/categories/$categoryId/pricing'
      preLoaderRoute: typeof AuthenticatedMonitoringSidebarComponentsCategoriesCategoryIdPricingRouteImport
      parentRoute: typeof AuthenticatedMonitoringSidebarRouteRoute
    }
    '/_authenticated/negotiations/$negotiationId/_sidebar/demand-groups/$demandGroupId/': {
      id: '/_authenticated/negotiations/$negotiationId/_sidebar/demand-groups/$demandGroupId/'
      path: '/demand-groups/$demandGroupId'
      fullPath: '/negotiations/$negotiationId/demand-groups/$demandGroupId/'
      preLoaderRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdIndexRouteImport
      parentRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/negotiations/$negotiationId/_sidebar/demand-groups/$demandGroupId/awarding': {
      id: '/_authenticated/negotiations/$negotiationId/_sidebar/demand-groups/$demandGroupId/awarding'
      path: '/demand-groups/$demandGroupId/awarding'
      fullPath: '/negotiations/$negotiationId/demand-groups/$demandGroupId/awarding'
      preLoaderRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdAwardingRouteImport
      parentRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/negotiations/$negotiationId/_sidebar/scenarios/$sourcingScenarioId/': {
      id: '/_authenticated/negotiations/$negotiationId/_sidebar/scenarios/$sourcingScenarioId/'
      path: '/scenarios/$sourcingScenarioId'
      fullPath: '/negotiations/$negotiationId/scenarios/$sourcingScenarioId/'
      preLoaderRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdIndexRouteImport
      parentRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/negotiations/$negotiationId/scenarios/$sourcingScenarioId/line/$sourcingLineItemId': {
      id: '/_authenticated/negotiations/$negotiationId/scenarios/$sourcingScenarioId/line/$sourcingLineItemId'
      path: '/negotiations/$negotiationId/scenarios/$sourcingScenarioId/line/$sourcingLineItemId'
      fullPath: '/negotiations/$negotiationId/scenarios/$sourcingScenarioId/line/$sourcingLineItemId'
      preLoaderRoute: typeof AuthenticatedNegotiationsNegotiationIdScenariosSourcingScenarioIdLineSourcingLineItemIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/next/components/ipn/_details/offers/': {
      id: '/_authenticated/next/components/ipn/_details/offers/'
      path: '/offers'
      fullPath: '/next/components/ipn/offers/'
      preLoaderRoute: typeof AuthenticatedNextComponentsIpnDetailsOffersIndexRouteImport
      parentRoute: typeof AuthenticatedNextComponentsIpnDetailsRouteRoute
    }
    '/_authenticated/next/components/ipn/offers/$offerId/duplicate': {
      id: '/_authenticated/next/components/ipn/offers/$offerId/duplicate'
      path: '/components/ipn/offers/$offerId/duplicate'
      fullPath: '/next/components/ipn/offers/$offerId/duplicate'
      preLoaderRoute: typeof AuthenticatedNextComponentsIpnOffersOfferIdDuplicateRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/components/ipn/offers/$offerId/edit': {
      id: '/_authenticated/next/components/ipn/offers/$offerId/edit'
      path: '/components/ipn/offers/$offerId/edit'
      fullPath: '/next/components/ipn/offers/$offerId/edit'
      preLoaderRoute: typeof AuthenticatedNextComponentsIpnOffersOfferIdEditRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/': {
      id: '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/'
      path: '/quote-requests'
      fullPath: '/next/negotiations/$negotiationId/quote-requests/'
      preLoaderRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsIndexRouteImport
      parentRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/$quoteRequestId': {
      id: '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/$quoteRequestId'
      path: '/quote-requests/$quoteRequestId'
      fullPath: '/next/negotiations/$negotiationId/quote-requests/$quoteRequestId'
      preLoaderRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsQuoteRequestIdRouteImport
      parentRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/assign': {
      id: '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/assign'
      path: '/quote-requests/assign'
      fullPath: '/next/negotiations/$negotiationId/quote-requests/assign'
      preLoaderRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsAssignRouteImport
      parentRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/attachments': {
      id: '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/attachments'
      path: '/quote-requests/attachments'
      fullPath: '/next/negotiations/$negotiationId/quote-requests/attachments'
      preLoaderRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsAttachmentsRouteImport
      parentRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/delivery-lot-size': {
      id: '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/delivery-lot-size'
      path: '/quote-requests/delivery-lot-size'
      fullPath: '/next/negotiations/$negotiationId/quote-requests/delivery-lot-size'
      preLoaderRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsDeliveryLotSizeRouteImport
      parentRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/importer': {
      id: '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/importer'
      path: '/quote-requests/importer'
      fullPath: '/next/negotiations/$negotiationId/quote-requests/importer'
      preLoaderRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsImporterRouteImport
      parentRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/line-items': {
      id: '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/line-items'
      path: '/quote-requests/line-items'
      fullPath: '/next/negotiations/$negotiationId/quote-requests/line-items'
      preLoaderRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsLineItemsRouteImport
      parentRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/preview-email': {
      id: '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/preview-email'
      path: '/quote-requests/preview-email'
      fullPath: '/next/negotiations/$negotiationId/quote-requests/preview-email'
      preLoaderRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsPreviewEmailRouteImport
      parentRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/target-price': {
      id: '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/target-price'
      path: '/quote-requests/target-price'
      fullPath: '/next/negotiations/$negotiationId/quote-requests/target-price'
      preLoaderRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsTargetPriceRouteImport
      parentRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/next/negotiations/$negotiationId/_sidebar/scenarios/compare': {
      id: '/_authenticated/next/negotiations/$negotiationId/_sidebar/scenarios/compare'
      path: '/scenarios/compare'
      fullPath: '/next/negotiations/$negotiationId/scenarios/compare'
      preLoaderRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosCompareRouteImport
      parentRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/next/negotiations/$negotiationId/_sidebar/scenarios/create': {
      id: '/_authenticated/next/negotiations/$negotiationId/_sidebar/scenarios/create'
      path: '/scenarios/create'
      fullPath: '/next/negotiations/$negotiationId/scenarios/create'
      preLoaderRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosCreateRouteImport
      parentRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/': {
      id: '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/'
      path: '/assemblies/$assemblyId'
      fullPath: '/next/projects/$projectId/assemblies/$assemblyId/'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdIndexRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/details': {
      id: '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/details'
      path: '/assemblies/$assemblyId/details'
      fullPath: '/next/projects/$projectId/assemblies/$assemblyId/details'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdDetailsRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/edit': {
      id: '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/edit'
      path: '/assemblies/$assemblyId/edit'
      fullPath: '/next/projects/$projectId/assemblies/$assemblyId/edit'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdEditRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb': {
      id: '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb'
      path: '/assemblies/$assemblyId/pcb'
      fullPath: '/next/projects/$projectId/assemblies/$assemblyId/pcb'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pnp-importer': {
      id: '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pnp-importer'
      path: '/assemblies/$assemblyId/pnp-importer'
      fullPath: '/next/projects/$projectId/assemblies/$assemblyId/pnp-importer'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPnpImporterRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/': {
      id: '/_authenticated/next/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/'
      path: '/manufacturing/$manufacturingAssemblyDetailsId'
      fullPath: '/next/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdIndexRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/sourcing/assembly/$assemblyId': {
      id: '/_authenticated/next/projects/$projectId/sourcing/assembly/$assemblyId'
      path: '/sourcing/assembly/$assemblyId'
      fullPath: '/next/projects/$projectId/sourcing/assembly/$assemblyId'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdSourcingAssemblyAssemblyIdRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/sourcing/overview/': {
      id: '/_authenticated/next/projects/$projectId/sourcing/overview/'
      path: '/'
      fullPath: '/next/projects/$projectId/sourcing/overview/'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdSourcingOverviewIndexRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdSourcingOverviewRouteRoute
    }
    '/_authenticated/next/projects/$projectId/sourcing/overview/$view': {
      id: '/_authenticated/next/projects/$projectId/sourcing/overview/$view'
      path: '/$view'
      fullPath: '/next/projects/$projectId/sourcing/overview/$view'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdSourcingOverviewViewRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdSourcingOverviewRouteRoute
    }
    '/_authenticated/next/projects/$projectId/sourcing/quote-requests/': {
      id: '/_authenticated/next/projects/$projectId/sourcing/quote-requests/'
      path: '/sourcing/quote-requests'
      fullPath: '/next/projects/$projectId/sourcing/quote-requests/'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsIndexRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/sourcing/quote-requests/$quoteRequestId': {
      id: '/_authenticated/next/projects/$projectId/sourcing/quote-requests/$quoteRequestId'
      path: '/sourcing/quote-requests/$quoteRequestId'
      fullPath: '/next/projects/$projectId/sourcing/quote-requests/$quoteRequestId'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsQuoteRequestIdRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/sourcing/quote-requests/assign': {
      id: '/_authenticated/next/projects/$projectId/sourcing/quote-requests/assign'
      path: '/sourcing/quote-requests/assign'
      fullPath: '/next/projects/$projectId/sourcing/quote-requests/assign'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsAssignRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/sourcing/quote-requests/attachments': {
      id: '/_authenticated/next/projects/$projectId/sourcing/quote-requests/attachments'
      path: '/sourcing/quote-requests/attachments'
      fullPath: '/next/projects/$projectId/sourcing/quote-requests/attachments'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsAttachmentsRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/sourcing/quote-requests/delivery-lot-size': {
      id: '/_authenticated/next/projects/$projectId/sourcing/quote-requests/delivery-lot-size'
      path: '/sourcing/quote-requests/delivery-lot-size'
      fullPath: '/next/projects/$projectId/sourcing/quote-requests/delivery-lot-size'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsDeliveryLotSizeRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/sourcing/quote-requests/importer': {
      id: '/_authenticated/next/projects/$projectId/sourcing/quote-requests/importer'
      path: '/sourcing/quote-requests/importer'
      fullPath: '/next/projects/$projectId/sourcing/quote-requests/importer'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsImporterRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/sourcing/quote-requests/line-items': {
      id: '/_authenticated/next/projects/$projectId/sourcing/quote-requests/line-items'
      path: '/sourcing/quote-requests/line-items'
      fullPath: '/next/projects/$projectId/sourcing/quote-requests/line-items'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsLineItemsRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/sourcing/quote-requests/preview-email': {
      id: '/_authenticated/next/projects/$projectId/sourcing/quote-requests/preview-email'
      path: '/sourcing/quote-requests/preview-email'
      fullPath: '/next/projects/$projectId/sourcing/quote-requests/preview-email'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsPreviewEmailRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/sourcing/quote-requests/target-price': {
      id: '/_authenticated/next/projects/$projectId/sourcing/quote-requests/target-price'
      path: '/sourcing/quote-requests/target-price'
      fullPath: '/next/projects/$projectId/sourcing/quote-requests/target-price'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsTargetPriceRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId': {
      id: '/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId'
      path: '/sourcing/scenarios/$sourcingScenarioId'
      fullPath: '/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdRouteRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/sourcing/scenarios/create': {
      id: '/_authenticated/next/projects/$projectId/sourcing/scenarios/create'
      path: '/sourcing/scenarios/create'
      fullPath: '/next/projects/$projectId/sourcing/scenarios/create'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdSourcingScenariosCreateRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/settings/_menu/organization/customer-portal/': {
      id: '/_authenticated/next/settings/_menu/organization/customer-portal/'
      path: '/organization/customer-portal'
      fullPath: '/next/settings/organization/customer-portal/'
      preLoaderRoute: typeof AuthenticatedNextSettingsMenuOrganizationCustomerPortalIndexRouteImport
      parentRoute: typeof AuthenticatedNextSettingsMenuRouteRoute
    }
    '/_authenticated/next/settings/_menu/organization/customer-portal/additional-services': {
      id: '/_authenticated/next/settings/_menu/organization/customer-portal/additional-services'
      path: '/organization/customer-portal/additional-services'
      fullPath: '/next/settings/organization/customer-portal/additional-services'
      preLoaderRoute: typeof AuthenticatedNextSettingsMenuOrganizationCustomerPortalAdditionalServicesRouteImport
      parentRoute: typeof AuthenticatedNextSettingsMenuRouteRoute
    }
    '/_authenticated/next/settings/_menu/organization/customer-portal/checkout-conditions': {
      id: '/_authenticated/next/settings/_menu/organization/customer-portal/checkout-conditions'
      path: '/organization/customer-portal/checkout-conditions'
      fullPath: '/next/settings/organization/customer-portal/checkout-conditions'
      preLoaderRoute: typeof AuthenticatedNextSettingsMenuOrganizationCustomerPortalCheckoutConditionsRouteImport
      parentRoute: typeof AuthenticatedNextSettingsMenuRouteRoute
    }
    '/_authenticated/next/settings/_menu/organization/customer-portal/customer-specific-settings': {
      id: '/_authenticated/next/settings/_menu/organization/customer-portal/customer-specific-settings'
      path: '/organization/customer-portal/customer-specific-settings'
      fullPath: '/next/settings/organization/customer-portal/customer-specific-settings'
      preLoaderRoute: typeof AuthenticatedNextSettingsMenuOrganizationCustomerPortalCustomerSpecificSettingsRouteImport
      parentRoute: typeof AuthenticatedNextSettingsMenuRouteRoute
    }
    '/_authenticated/next/settings/_menu/organization/customer-portal/landing-page': {
      id: '/_authenticated/next/settings/_menu/organization/customer-portal/landing-page'
      path: '/organization/customer-portal/landing-page'
      fullPath: '/next/settings/organization/customer-portal/landing-page'
      preLoaderRoute: typeof AuthenticatedNextSettingsMenuOrganizationCustomerPortalLandingPageRouteImport
      parentRoute: typeof AuthenticatedNextSettingsMenuRouteRoute
    }
    '/_authenticated/next/settings/_menu/organization/customer-portal/payment-credentials': {
      id: '/_authenticated/next/settings/_menu/organization/customer-portal/payment-credentials'
      path: '/organization/customer-portal/payment-credentials'
      fullPath: '/next/settings/organization/customer-portal/payment-credentials'
      preLoaderRoute: typeof AuthenticatedNextSettingsMenuOrganizationCustomerPortalPaymentCredentialsRouteImport
      parentRoute: typeof AuthenticatedNextSettingsMenuRouteRoute
    }
    '/_authenticated/next/settings/_menu/organization/pcb/': {
      id: '/_authenticated/next/settings/_menu/organization/pcb/'
      path: '/organization/pcb'
      fullPath: '/next/settings/organization/pcb/'
      preLoaderRoute: typeof AuthenticatedNextSettingsMenuOrganizationPcbIndexRouteImport
      parentRoute: typeof AuthenticatedNextSettingsMenuRouteRoute
    }
    '/_authenticated/next/settings/_menu/organization/user-management/action-permissions': {
      id: '/_authenticated/next/settings/_menu/organization/user-management/action-permissions'
      path: '/organization/user-management/action-permissions'
      fullPath: '/next/settings/organization/user-management/action-permissions'
      preLoaderRoute: typeof AuthenticatedNextSettingsMenuOrganizationUserManagementActionPermissionsRouteImport
      parentRoute: typeof AuthenticatedNextSettingsMenuRouteRoute
    }
    '/_authenticated/next/settings/_menu/organization/user-management/roles': {
      id: '/_authenticated/next/settings/_menu/organization/user-management/roles'
      path: '/organization/user-management/roles'
      fullPath: '/next/settings/organization/user-management/roles'
      preLoaderRoute: typeof AuthenticatedNextSettingsMenuOrganizationUserManagementRolesRouteImport
      parentRoute: typeof AuthenticatedNextSettingsMenuRouteRoute
    }
    '/_authenticated/next/settings/_menu/organization/users/': {
      id: '/_authenticated/next/settings/_menu/organization/users/'
      path: '/organization/users'
      fullPath: '/next/settings/organization/users/'
      preLoaderRoute: typeof AuthenticatedNextSettingsMenuOrganizationUsersIndexRouteImport
      parentRoute: typeof AuthenticatedNextSettingsMenuRouteRoute
    }
    '/_authenticated/next/settings/organization/pcb/panel-preferences/': {
      id: '/_authenticated/next/settings/organization/pcb/panel-preferences/'
      path: '/settings/organization/pcb/panel-preferences'
      fullPath: '/next/settings/organization/pcb/panel-preferences/'
      preLoaderRoute: typeof AuthenticatedNextSettingsOrganizationPcbPanelPreferencesIndexRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/flexible-calculation/apps/$appId/$widgetId': {
      id: '/_authenticated/next/templates/flexible-calculation/apps/$appId/$widgetId'
      path: '/templates/flexible-calculation/apps/$appId/$widgetId'
      fullPath: '/next/templates/flexible-calculation/apps/$appId/$widgetId'
      preLoaderRoute: typeof AuthenticatedNextTemplatesFlexibleCalculationAppsAppIdWidgetIdRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/flexible-calculation/review-conversion/$legacyTemplateId/$flexibleCalculationTemplateId': {
      id: '/_authenticated/next/templates/flexible-calculation/review-conversion/$legacyTemplateId/$flexibleCalculationTemplateId'
      path: '/templates/flexible-calculation/review-conversion/$legacyTemplateId/$flexibleCalculationTemplateId'
      fullPath: '/next/templates/flexible-calculation/review-conversion/$legacyTemplateId/$flexibleCalculationTemplateId'
      preLoaderRoute: typeof AuthenticatedNextTemplatesFlexibleCalculationReviewConversionLegacyTemplateIdFlexibleCalculationTemplateIdRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/manufacturing/activities/$activityId/duplicate': {
      id: '/_authenticated/next/templates/manufacturing/activities/$activityId/duplicate'
      path: '/templates/manufacturing/activities/$activityId/duplicate'
      fullPath: '/next/templates/manufacturing/activities/$activityId/duplicate'
      preLoaderRoute: typeof AuthenticatedNextTemplatesManufacturingActivitiesActivityIdDuplicateRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/manufacturing/activities/$activityId/edit': {
      id: '/_authenticated/next/templates/manufacturing/activities/$activityId/edit'
      path: '/templates/manufacturing/activities/$activityId/edit'
      fullPath: '/next/templates/manufacturing/activities/$activityId/edit'
      preLoaderRoute: typeof AuthenticatedNextTemplatesManufacturingActivitiesActivityIdEditRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/manufacturing/apps/$appId/$widgetId': {
      id: '/_authenticated/next/templates/manufacturing/apps/$appId/$widgetId'
      path: '/templates/manufacturing/apps/$appId/$widgetId'
      fullPath: '/next/templates/manufacturing/apps/$appId/$widgetId'
      preLoaderRoute: typeof AuthenticatedNextTemplatesManufacturingAppsAppIdWidgetIdRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/manufacturing/drivers/$driverId/duplicate': {
      id: '/_authenticated/next/templates/manufacturing/drivers/$driverId/duplicate'
      path: '/templates/manufacturing/drivers/$driverId/duplicate'
      fullPath: '/next/templates/manufacturing/drivers/$driverId/duplicate'
      preLoaderRoute: typeof AuthenticatedNextTemplatesManufacturingDriversDriverIdDuplicateRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/manufacturing/drivers/$driverId/edit': {
      id: '/_authenticated/next/templates/manufacturing/drivers/$driverId/edit'
      path: '/templates/manufacturing/drivers/$driverId/edit'
      fullPath: '/next/templates/manufacturing/drivers/$driverId/edit'
      preLoaderRoute: typeof AuthenticatedNextTemplatesManufacturingDriversDriverIdEditRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/manufacturing/expenses/$expenseId/duplicate': {
      id: '/_authenticated/next/templates/manufacturing/expenses/$expenseId/duplicate'
      path: '/templates/manufacturing/expenses/$expenseId/duplicate'
      fullPath: '/next/templates/manufacturing/expenses/$expenseId/duplicate'
      preLoaderRoute: typeof AuthenticatedNextTemplatesManufacturingExpensesExpenseIdDuplicateRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/manufacturing/expenses/$expenseId/edit': {
      id: '/_authenticated/next/templates/manufacturing/expenses/$expenseId/edit'
      path: '/templates/manufacturing/expenses/$expenseId/edit'
      fullPath: '/next/templates/manufacturing/expenses/$expenseId/edit'
      preLoaderRoute: typeof AuthenticatedNextTemplatesManufacturingExpensesExpenseIdEditRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/manufacturing/resources/$resourceId/duplicate': {
      id: '/_authenticated/next/templates/manufacturing/resources/$resourceId/duplicate'
      path: '/templates/manufacturing/resources/$resourceId/duplicate'
      fullPath: '/next/templates/manufacturing/resources/$resourceId/duplicate'
      preLoaderRoute: typeof AuthenticatedNextTemplatesManufacturingResourcesResourceIdDuplicateRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/templates/manufacturing/resources/$resourceId/edit': {
      id: '/_authenticated/next/templates/manufacturing/resources/$resourceId/edit'
      path: '/templates/manufacturing/resources/$resourceId/edit'
      fullPath: '/next/templates/manufacturing/resources/$resourceId/edit'
      preLoaderRoute: typeof AuthenticatedNextTemplatesManufacturingResourcesResourceIdEditRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/parts/components/ipn/offers/$offerId/duplicate': {
      id: '/_authenticated/parts/components/ipn/offers/$offerId/duplicate'
      path: '/parts/components/ipn/offers/$offerId/duplicate'
      fullPath: '/parts/components/ipn/offers/$offerId/duplicate'
      preLoaderRoute: typeof AuthenticatedPartsComponentsIpnOffersOfferIdDuplicateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/parts/components/ipn/offers/$offerId/edit': {
      id: '/_authenticated/parts/components/ipn/offers/$offerId/edit'
      path: '/parts/components/ipn/offers/$offerId/edit'
      fullPath: '/parts/components/ipn/offers/$offerId/edit'
      preLoaderRoute: typeof AuthenticatedPartsComponentsIpnOffersOfferIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/': {
      id: '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/'
      path: '/projects/$projectId/bom/assembly/$assemblyId'
      fullPath: '/projects/$projectId/bom/assembly/$assemblyId/'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/details': {
      id: '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/details'
      path: '/projects/$projectId/bom/assembly/$assemblyId/details'
      fullPath: '/projects/$projectId/bom/assembly/$assemblyId/details'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdDetailsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/edit': {
      id: '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/edit'
      path: '/projects/$projectId/bom/assembly/$assemblyId/edit'
      fullPath: '/projects/$projectId/bom/assembly/$assemblyId/edit'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb': {
      id: '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb'
      path: '/projects/$projectId/bom/assembly/$assemblyId/pcb'
      fullPath: '/projects/$projectId/bom/assembly/$assemblyId/pcb'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pnp-importer': {
      id: '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pnp-importer'
      path: '/projects/$projectId/bom/assembly/$assemblyId/pnp-importer'
      fullPath: '/projects/$projectId/bom/assembly/$assemblyId/pnp-importer'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPnpImporterRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/activity': {
      id: '/_authenticated/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/activity'
      path: '/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/activity'
      fullPath: '/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/activity'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdActivityRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/expense': {
      id: '/_authenticated/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/expense'
      path: '/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/expense'
      fullPath: '/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/expense'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdExpenseRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/sourcing/$sourcingScenarioId/line/$sourcingLineItemId': {
      id: '/_authenticated/projects/$projectId/sourcing/$sourcingScenarioId/line/$sourcingLineItemId'
      path: '/projects/$projectId/sourcing/$sourcingScenarioId/line/$sourcingLineItemId'
      fullPath: '/projects/$projectId/sourcing/$sourcingScenarioId/line/$sourcingLineItemId'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSourcingSourcingScenarioIdLineSourcingLineItemIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/sourcing/_sidebar/overview/': {
      id: '/_authenticated/projects/$projectId/sourcing/_sidebar/overview/'
      path: '/overview'
      fullPath: '/projects/$projectId/sourcing/overview/'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarOverviewIndexRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute
    }
    '/_authenticated/projects/$projectId/sourcing/_sidebar/overview/$view': {
      id: '/_authenticated/projects/$projectId/sourcing/_sidebar/overview/$view'
      path: '/overview/$view'
      fullPath: '/projects/$projectId/sourcing/overview/$view'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarOverviewViewRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute
    }
    '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/': {
      id: '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/'
      path: '/quote-requests'
      fullPath: '/projects/$projectId/sourcing/quote-requests/'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsIndexRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute
    }
    '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/$quoteRequestId': {
      id: '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/$quoteRequestId'
      path: '/quote-requests/$quoteRequestId'
      fullPath: '/projects/$projectId/sourcing/quote-requests/$quoteRequestId'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsQuoteRequestIdRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute
    }
    '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/assign': {
      id: '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/assign'
      path: '/quote-requests/assign'
      fullPath: '/projects/$projectId/sourcing/quote-requests/assign'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsAssignRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute
    }
    '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/attachments': {
      id: '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/attachments'
      path: '/quote-requests/attachments'
      fullPath: '/projects/$projectId/sourcing/quote-requests/attachments'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsAttachmentsRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute
    }
    '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/delivery-lot-size': {
      id: '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/delivery-lot-size'
      path: '/quote-requests/delivery-lot-size'
      fullPath: '/projects/$projectId/sourcing/quote-requests/delivery-lot-size'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsDeliveryLotSizeRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute
    }
    '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/excel-importer': {
      id: '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/excel-importer'
      path: '/quote-requests/excel-importer'
      fullPath: '/projects/$projectId/sourcing/quote-requests/excel-importer'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsExcelImporterRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute
    }
    '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/importer': {
      id: '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/importer'
      path: '/quote-requests/importer'
      fullPath: '/projects/$projectId/sourcing/quote-requests/importer'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsImporterRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute
    }
    '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/line-items': {
      id: '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/line-items'
      path: '/quote-requests/line-items'
      fullPath: '/projects/$projectId/sourcing/quote-requests/line-items'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsLineItemsRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute
    }
    '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/preview-email': {
      id: '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/preview-email'
      path: '/quote-requests/preview-email'
      fullPath: '/projects/$projectId/sourcing/quote-requests/preview-email'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsPreviewEmailRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute
    }
    '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/target-price': {
      id: '/_authenticated/projects/$projectId/sourcing/_sidebar/quote-requests/target-price'
      path: '/quote-requests/target-price'
      fullPath: '/projects/$projectId/sourcing/quote-requests/target-price'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsTargetPriceRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute
    }
    '/_authenticated/projects/$projectId/sourcing/_sidebar/scenarios/create': {
      id: '/_authenticated/projects/$projectId/sourcing/_sidebar/scenarios/create'
      path: '/scenarios/create'
      fullPath: '/projects/$projectId/sourcing/scenarios/create'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarScenariosCreateRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute
    }
    '/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/': {
      id: '/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/'
      path: '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId'
      fullPath: '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/_sidebar': {
      id: '/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/_sidebar'
      path: '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId'
      fullPath: '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/purchase-orders': {
      id: '/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/purchase-orders'
      path: '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/purchase-orders'
      fullPath: '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/purchase-orders'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdPurchaseOrdersRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/_menu/organization/pcb/panel-preferences/create': {
      id: '/_authenticated/settings/_menu/organization/pcb/panel-preferences/create'
      path: '/organization/pcb/panel-preferences/create'
      fullPath: '/settings/organization/pcb/panel-preferences/create'
      preLoaderRoute: typeof AuthenticatedSettingsMenuOrganizationPcbPanelPreferencesCreateRouteImport
      parentRoute: typeof AuthenticatedSettingsMenuRouteRoute
    }
    '/_authenticated/templates/_sidebar/flexible-calculation/apps/$appId/$widgetId': {
      id: '/_authenticated/templates/_sidebar/flexible-calculation/apps/$appId/$widgetId'
      path: '/flexible-calculation/apps/$appId/$widgetId'
      fullPath: '/templates/flexible-calculation/apps/$appId/$widgetId'
      preLoaderRoute: typeof AuthenticatedTemplatesSidebarFlexibleCalculationAppsAppIdWidgetIdRouteImport
      parentRoute: typeof AuthenticatedTemplatesSidebarRouteRoute
    }
    '/_authenticated/templates/_sidebar/flexible-calculation/review-conversion/$legacyTemplateId/$flexibleCalculationTemplateId': {
      id: '/_authenticated/templates/_sidebar/flexible-calculation/review-conversion/$legacyTemplateId/$flexibleCalculationTemplateId'
      path: '/flexible-calculation/review-conversion/$legacyTemplateId/$flexibleCalculationTemplateId'
      fullPath: '/templates/flexible-calculation/review-conversion/$legacyTemplateId/$flexibleCalculationTemplateId'
      preLoaderRoute: typeof AuthenticatedTemplatesSidebarFlexibleCalculationReviewConversionLegacyTemplateIdFlexibleCalculationTemplateIdRouteImport
      parentRoute: typeof AuthenticatedTemplatesSidebarRouteRoute
    }
    '/_authenticated/negotiations/$negotiationId/_sidebar/scenarios/$sourcingScenarioId/cost-breakdown/': {
      id: '/_authenticated/negotiations/$negotiationId/_sidebar/scenarios/$sourcingScenarioId/cost-breakdown/'
      path: '/scenarios/$sourcingScenarioId/cost-breakdown'
      fullPath: '/negotiations/$negotiationId/scenarios/$sourcingScenarioId/cost-breakdown/'
      preLoaderRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownIndexRouteImport
      parentRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/next/negotiations/$negotiationId/_sidebar/demand-groups/$demandGroupId/': {
      id: '/_authenticated/next/negotiations/$negotiationId/_sidebar/demand-groups/$demandGroupId/'
      path: '/demand-groups/$demandGroupId'
      fullPath: '/next/negotiations/$negotiationId/demand-groups/$demandGroupId/'
      preLoaderRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdIndexRouteImport
      parentRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/next/negotiations/$negotiationId/_sidebar/demand-groups/$demandGroupId/awarding': {
      id: '/_authenticated/next/negotiations/$negotiationId/_sidebar/demand-groups/$demandGroupId/awarding'
      path: '/demand-groups/$demandGroupId/awarding'
      fullPath: '/next/negotiations/$negotiationId/demand-groups/$demandGroupId/awarding'
      preLoaderRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdAwardingRouteImport
      parentRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/next/negotiations/$negotiationId/_sidebar/scenarios/$sourcingScenarioId/': {
      id: '/_authenticated/next/negotiations/$negotiationId/_sidebar/scenarios/$sourcingScenarioId/'
      path: '/scenarios/$sourcingScenarioId'
      fullPath: '/next/negotiations/$negotiationId/scenarios/$sourcingScenarioId/'
      preLoaderRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdIndexRouteImport
      parentRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/next/negotiations/$negotiationId/scenarios/$sourcingScenarioId/line-items/$sourcingLineItemId': {
      id: '/_authenticated/next/negotiations/$negotiationId/scenarios/$sourcingScenarioId/line-items/$sourcingLineItemId'
      path: '/negotiations/$negotiationId/scenarios/$sourcingScenarioId/line-items/$sourcingLineItemId'
      fullPath: '/next/negotiations/$negotiationId/scenarios/$sourcingScenarioId/line-items/$sourcingLineItemId'
      preLoaderRoute: typeof AuthenticatedNextNegotiationsNegotiationIdScenariosSourcingScenarioIdLineItemsSourcingLineItemIdRouteImport
      parentRoute: typeof AuthenticatedNextRouteRoute
    }
    '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/': {
      id: '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/'
      path: '/'
      fullPath: '/next/projects/$projectId/assemblies/$assemblyId/pcb/'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbIndexRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRoute
    }
    '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/cad-viewer': {
      id: '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/cad-viewer'
      path: '/cad-viewer'
      fullPath: '/next/projects/$projectId/assemblies/$assemblyId/pcb/cad-viewer'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbCadViewerRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRoute
    }
    '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/dfm': {
      id: '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/dfm'
      path: '/dfm'
      fullPath: '/next/projects/$projectId/assemblies/$assemblyId/pcb/dfm'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbDfmRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRoute
    }
    '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/dfm-analysis': {
      id: '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/dfm-analysis'
      path: '/dfm-analysis'
      fullPath: '/next/projects/$projectId/assemblies/$assemblyId/pcb/dfm-analysis'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbDfmAnalysisRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRoute
    }
    '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/drills': {
      id: '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/drills'
      path: '/drills'
      fullPath: '/next/projects/$projectId/assemblies/$assemblyId/pcb/drills'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbDrillsRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRoute
    }
    '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/files': {
      id: '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/files'
      path: '/files'
      fullPath: '/next/projects/$projectId/assemblies/$assemblyId/pcb/files'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbFilesRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRoute
    }
    '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/panelization': {
      id: '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/panelization'
      path: '/panelization'
      fullPath: '/next/projects/$projectId/assemblies/$assemblyId/pcb/panelization'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbPanelizationRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRoute
    }
    '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/specification': {
      id: '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/specification'
      path: '/specification'
      fullPath: '/next/projects/$projectId/assemblies/$assemblyId/pcb/specification'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbSpecificationRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRoute
    }
    '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/stackup': {
      id: '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/stackup'
      path: '/stackup'
      fullPath: '/next/projects/$projectId/assemblies/$assemblyId/pcb/stackup'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbStackupRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRoute
    }
    '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/subassemblies/create': {
      id: '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/subassemblies/create'
      path: '/assemblies/$assemblyId/subassemblies/create'
      fullPath: '/next/projects/$projectId/assemblies/$assemblyId/subassemblies/create'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdSubassembliesCreateRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/activity': {
      id: '/_authenticated/next/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/activity'
      path: '/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/activity'
      fullPath: '/next/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/activity'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdActivityRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/expense': {
      id: '/_authenticated/next/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/expense'
      path: '/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/expense'
      fullPath: '/next/projects/$projectId/manufacturing/$manufacturingAssemblyDetailsId/$manufacturingScenarioId/expense'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdExpenseRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/': {
      id: '/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/'
      path: '/'
      fullPath: '/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdIndexRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/purchase-orders': {
      id: '/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/purchase-orders'
      path: '/purchase-orders'
      fullPath: '/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/purchase-orders'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdPurchaseOrdersRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdRouteRoute
    }
    '/_authenticated/next/settings/_menu/organization/pcb/panel-preferences/create': {
      id: '/_authenticated/next/settings/_menu/organization/pcb/panel-preferences/create'
      path: '/organization/pcb/panel-preferences/create'
      fullPath: '/next/settings/organization/pcb/panel-preferences/create'
      preLoaderRoute: typeof AuthenticatedNextSettingsMenuOrganizationPcbPanelPreferencesCreateRouteImport
      parentRoute: typeof AuthenticatedNextSettingsMenuRouteRoute
    }
    '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/': {
      id: '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/'
      path: '/'
      fullPath: '/projects/$projectId/bom/assembly/$assemblyId/pcb/'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbIndexRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRoute
    }
    '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/cad-viewer': {
      id: '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/cad-viewer'
      path: '/cad-viewer'
      fullPath: '/projects/$projectId/bom/assembly/$assemblyId/pcb/cad-viewer'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbCadViewerRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRoute
    }
    '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/dfm': {
      id: '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/dfm'
      path: '/dfm'
      fullPath: '/projects/$projectId/bom/assembly/$assemblyId/pcb/dfm'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbDfmRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRoute
    }
    '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/dfm-analysis': {
      id: '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/dfm-analysis'
      path: '/dfm-analysis'
      fullPath: '/projects/$projectId/bom/assembly/$assemblyId/pcb/dfm-analysis'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbDfmAnalysisRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRoute
    }
    '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/drills': {
      id: '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/drills'
      path: '/drills'
      fullPath: '/projects/$projectId/bom/assembly/$assemblyId/pcb/drills'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbDrillsRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRoute
    }
    '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/files': {
      id: '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/files'
      path: '/files'
      fullPath: '/projects/$projectId/bom/assembly/$assemblyId/pcb/files'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbFilesRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRoute
    }
    '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/panelization': {
      id: '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/panelization'
      path: '/panelization'
      fullPath: '/projects/$projectId/bom/assembly/$assemblyId/pcb/panelization'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbPanelizationRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRoute
    }
    '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/specification': {
      id: '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/specification'
      path: '/specification'
      fullPath: '/projects/$projectId/bom/assembly/$assemblyId/pcb/specification'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbSpecificationRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRoute
    }
    '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/stackup': {
      id: '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/pcb/stackup'
      path: '/stackup'
      fullPath: '/projects/$projectId/bom/assembly/$assemblyId/pcb/stackup'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbStackupRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRoute
    }
    '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/subassemblies/create': {
      id: '/_authenticated/projects/$projectId/bom/assembly/$assemblyId/subassemblies/create'
      path: '/projects/$projectId/bom/assembly/$assemblyId/subassemblies/create'
      fullPath: '/projects/$projectId/bom/assembly/$assemblyId/subassemblies/create'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdSubassembliesCreateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/sourcing/offer/custom-part/$offerId/duplicate': {
      id: '/_authenticated/projects/$projectId/sourcing/offer/custom-part/$offerId/duplicate'
      path: '/projects/$projectId/sourcing/offer/custom-part/$offerId/duplicate'
      fullPath: '/projects/$projectId/sourcing/offer/custom-part/$offerId/duplicate'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSourcingOfferCustomPartOfferIdDuplicateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/sourcing/offer/custom-part/$offerId/edit': {
      id: '/_authenticated/projects/$projectId/sourcing/offer/custom-part/$offerId/edit'
      path: '/projects/$projectId/sourcing/offer/custom-part/$offerId/edit'
      fullPath: '/projects/$projectId/sourcing/offer/custom-part/$offerId/edit'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSourcingOfferCustomPartOfferIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/sourcing/offer/internal-part-number/$offerId/duplicate': {
      id: '/_authenticated/projects/$projectId/sourcing/offer/internal-part-number/$offerId/duplicate'
      path: '/projects/$projectId/sourcing/offer/internal-part-number/$offerId/duplicate'
      fullPath: '/projects/$projectId/sourcing/offer/internal-part-number/$offerId/duplicate'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSourcingOfferInternalPartNumberOfferIdDuplicateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/sourcing/offer/internal-part-number/$offerId/edit': {
      id: '/_authenticated/projects/$projectId/sourcing/offer/internal-part-number/$offerId/edit'
      path: '/projects/$projectId/sourcing/offer/internal-part-number/$offerId/edit'
      fullPath: '/projects/$projectId/sourcing/offer/internal-part-number/$offerId/edit'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSourcingOfferInternalPartNumberOfferIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/sourcing/offer/off-the-shelf/$offerId/duplicate': {
      id: '/_authenticated/projects/$projectId/sourcing/offer/off-the-shelf/$offerId/duplicate'
      path: '/projects/$projectId/sourcing/offer/off-the-shelf/$offerId/duplicate'
      fullPath: '/projects/$projectId/sourcing/offer/off-the-shelf/$offerId/duplicate'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSourcingOfferOffTheShelfOfferIdDuplicateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/sourcing/offer/off-the-shelf/$offerId/edit': {
      id: '/_authenticated/projects/$projectId/sourcing/offer/off-the-shelf/$offerId/edit'
      path: '/projects/$projectId/sourcing/offer/off-the-shelf/$offerId/edit'
      fullPath: '/projects/$projectId/sourcing/offer/off-the-shelf/$offerId/edit'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSourcingOfferOffTheShelfOfferIdEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/_sidebar/line-items': {
      id: '/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/_sidebar/line-items'
      path: '/line-items'
      fullPath: '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/line-items'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarLineItemsRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarRouteRoute
    }
    '/_authenticated/settings/_menu/organization/pcb/panel-preferences/$panelPreferenceId/edit': {
      id: '/_authenticated/settings/_menu/organization/pcb/panel-preferences/$panelPreferenceId/edit'
      path: '/organization/pcb/panel-preferences/$panelPreferenceId/edit'
      fullPath: '/settings/organization/pcb/panel-preferences/$panelPreferenceId/edit'
      preLoaderRoute: typeof AuthenticatedSettingsMenuOrganizationPcbPanelPreferencesPanelPreferenceIdEditRouteImport
      parentRoute: typeof AuthenticatedSettingsMenuRouteRoute
    }
    '/_authenticated/next/negotiations/$negotiationId/_sidebar/scenarios/$sourcingScenarioId/cost-breakdown/': {
      id: '/_authenticated/next/negotiations/$negotiationId/_sidebar/scenarios/$sourcingScenarioId/cost-breakdown/'
      path: '/scenarios/$sourcingScenarioId/cost-breakdown'
      fullPath: '/next/negotiations/$negotiationId/scenarios/$sourcingScenarioId/cost-breakdown/'
      preLoaderRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownIndexRouteImport
      parentRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/next/projects/$projectId/sourcing/offers/custom-part/$offerId/duplicate': {
      id: '/_authenticated/next/projects/$projectId/sourcing/offers/custom-part/$offerId/duplicate'
      path: '/sourcing/offers/custom-part/$offerId/duplicate'
      fullPath: '/next/projects/$projectId/sourcing/offers/custom-part/$offerId/duplicate'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdSourcingOffersCustomPartOfferIdDuplicateRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/sourcing/offers/custom-part/$offerId/edit': {
      id: '/_authenticated/next/projects/$projectId/sourcing/offers/custom-part/$offerId/edit'
      path: '/sourcing/offers/custom-part/$offerId/edit'
      fullPath: '/next/projects/$projectId/sourcing/offers/custom-part/$offerId/edit'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdSourcingOffersCustomPartOfferIdEditRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/sourcing/offers/internal-part-number/$offerId/duplicate': {
      id: '/_authenticated/next/projects/$projectId/sourcing/offers/internal-part-number/$offerId/duplicate'
      path: '/sourcing/offers/internal-part-number/$offerId/duplicate'
      fullPath: '/next/projects/$projectId/sourcing/offers/internal-part-number/$offerId/duplicate'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdSourcingOffersInternalPartNumberOfferIdDuplicateRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/sourcing/offers/internal-part-number/$offerId/edit': {
      id: '/_authenticated/next/projects/$projectId/sourcing/offers/internal-part-number/$offerId/edit'
      path: '/sourcing/offers/internal-part-number/$offerId/edit'
      fullPath: '/next/projects/$projectId/sourcing/offers/internal-part-number/$offerId/edit'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdSourcingOffersInternalPartNumberOfferIdEditRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/sourcing/offers/off-the-shelf/$offerId/duplicate': {
      id: '/_authenticated/next/projects/$projectId/sourcing/offers/off-the-shelf/$offerId/duplicate'
      path: '/sourcing/offers/off-the-shelf/$offerId/duplicate'
      fullPath: '/next/projects/$projectId/sourcing/offers/off-the-shelf/$offerId/duplicate'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdSourcingOffersOffTheShelfOfferIdDuplicateRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/sourcing/offers/off-the-shelf/$offerId/edit': {
      id: '/_authenticated/next/projects/$projectId/sourcing/offers/off-the-shelf/$offerId/edit'
      path: '/sourcing/offers/off-the-shelf/$offerId/edit'
      fullPath: '/next/projects/$projectId/sourcing/offers/off-the-shelf/$offerId/edit'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdSourcingOffersOffTheShelfOfferIdEditRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/cost-breakdown/': {
      id: '/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/cost-breakdown/'
      path: '/cost-breakdown'
      fullPath: '/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/cost-breakdown/'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdCostBreakdownIndexRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/line-items/': {
      id: '/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/line-items/'
      path: '/line-items'
      fullPath: '/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/line-items/'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdLineItemsIndexRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdRouteRoute
    }
    '/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/line-items/$sourcingLineItemId': {
      id: '/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/line-items/$sourcingLineItemId'
      path: '/line-items/$sourcingLineItemId'
      fullPath: '/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/line-items/$sourcingLineItemId'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdLineItemsSourcingLineItemIdRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdRouteRoute
    }
    '/_authenticated/next/settings/_menu/organization/pcb/panel-preferences/$panelPreferenceId/edit': {
      id: '/_authenticated/next/settings/_menu/organization/pcb/panel-preferences/$panelPreferenceId/edit'
      path: '/organization/pcb/panel-preferences/$panelPreferenceId/edit'
      fullPath: '/next/settings/organization/pcb/panel-preferences/$panelPreferenceId/edit'
      preLoaderRoute: typeof AuthenticatedNextSettingsMenuOrganizationPcbPanelPreferencesPanelPreferenceIdEditRouteImport
      parentRoute: typeof AuthenticatedNextSettingsMenuRouteRoute
    }
    '/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/_sidebar/cost-breakdown/': {
      id: '/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/_sidebar/cost-breakdown/'
      path: '/cost-breakdown'
      fullPath: '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/cost-breakdown/'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarCostBreakdownIndexRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarRouteRoute
    }
    '/_authenticated/negotiations/$negotiationId/_sidebar/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId': {
      id: '/_authenticated/negotiations/$negotiationId/_sidebar/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId'
      path: '/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId'
      fullPath: '/negotiations/$negotiationId/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId'
      preLoaderRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownAssemblyAssemblyIdDemandDemandIdRouteImport
      parentRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/next/negotiations/$negotiationId/_sidebar/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId': {
      id: '/_authenticated/next/negotiations/$negotiationId/_sidebar/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId'
      path: '/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId'
      fullPath: '/next/negotiations/$negotiationId/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId'
      preLoaderRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownAssemblyAssemblyIdDemandDemandIdRouteImport
      parentRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute
    }
    '/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId': {
      id: '/_authenticated/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId'
      path: '/cost-breakdown/assembly/$assemblyId/demand/$demandId'
      fullPath: '/next/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId'
      preLoaderRoute: typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdCostBreakdownAssemblyAssemblyIdDemandDemandIdRouteImport
      parentRoute: typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdRouteRoute
    }
    '/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/_sidebar/cost-breakdown/assembly/$assemblyId/demand/$demandId': {
      id: '/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/_sidebar/cost-breakdown/assembly/$assemblyId/demand/$demandId'
      path: '/cost-breakdown/assembly/$assemblyId/demand/$demandId'
      fullPath: '/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/cost-breakdown/assembly/$assemblyId/demand/$demandId'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarCostBreakdownAssemblyAssemblyIdDemandDemandIdRouteImport
      parentRoute: typeof AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarRouteRoute
    }
  }
}

interface AuthenticatedCustomerPortalRouteRouteChildren {
  AuthenticatedCustomerPortalIndexRoute: typeof AuthenticatedCustomerPortalIndexRoute
}

const AuthenticatedCustomerPortalRouteRouteChildren: AuthenticatedCustomerPortalRouteRouteChildren =
  {
    AuthenticatedCustomerPortalIndexRoute:
      AuthenticatedCustomerPortalIndexRoute,
  }

const AuthenticatedCustomerPortalRouteRouteWithChildren =
  AuthenticatedCustomerPortalRouteRoute._addFileChildren(
    AuthenticatedCustomerPortalRouteRouteChildren,
  )

interface AuthenticatedMonitoringSidebarRouteRouteChildren {
  AuthenticatedMonitoringSidebarComponentSavingsRoute: typeof AuthenticatedMonitoringSidebarComponentSavingsRoute
  AuthenticatedMonitoringSidebarDataHealthRoute: typeof AuthenticatedMonitoringSidebarDataHealthRoute
  AuthenticatedMonitoringSidebarOffersRoute: typeof AuthenticatedMonitoringSidebarOffersRoute
  AuthenticatedMonitoringSidebarOnboardingRoute: typeof AuthenticatedMonitoringSidebarOnboardingRoute
  AuthenticatedMonitoringSidebarIndexRoute: typeof AuthenticatedMonitoringSidebarIndexRoute
  AuthenticatedMonitoringSidebarComponentsPricingRoute: typeof AuthenticatedMonitoringSidebarComponentsPricingRoute
  AuthenticatedMonitoringSidebarDashboardsDashboardIdRoute: typeof AuthenticatedMonitoringSidebarDashboardsDashboardIdRoute
  AuthenticatedMonitoringSidebarInsightsAgentChar123ConversationIdChar125Route: typeof AuthenticatedMonitoringSidebarInsightsAgentChar123ConversationIdChar125Route
  AuthenticatedMonitoringSidebarJobsJobIdRoute: typeof AuthenticatedMonitoringSidebarJobsJobIdRoute
  AuthenticatedMonitoringSidebarReportsSavingsRoute: typeof AuthenticatedMonitoringSidebarReportsSavingsRoute
  AuthenticatedMonitoringSidebarChartsIndexRoute: typeof AuthenticatedMonitoringSidebarChartsIndexRoute
  AuthenticatedMonitoringSidebarDashboardsIndexRoute: typeof AuthenticatedMonitoringSidebarDashboardsIndexRoute
  AuthenticatedMonitoringSidebarJobsIndexRoute: typeof AuthenticatedMonitoringSidebarJobsIndexRoute
  AuthenticatedMonitoringSidebarComponentsCategoriesCategoryIdPricingRoute: typeof AuthenticatedMonitoringSidebarComponentsCategoriesCategoryIdPricingRoute
}

const AuthenticatedMonitoringSidebarRouteRouteChildren: AuthenticatedMonitoringSidebarRouteRouteChildren =
  {
    AuthenticatedMonitoringSidebarComponentSavingsRoute:
      AuthenticatedMonitoringSidebarComponentSavingsRoute,
    AuthenticatedMonitoringSidebarDataHealthRoute:
      AuthenticatedMonitoringSidebarDataHealthRoute,
    AuthenticatedMonitoringSidebarOffersRoute:
      AuthenticatedMonitoringSidebarOffersRoute,
    AuthenticatedMonitoringSidebarOnboardingRoute:
      AuthenticatedMonitoringSidebarOnboardingRoute,
    AuthenticatedMonitoringSidebarIndexRoute:
      AuthenticatedMonitoringSidebarIndexRoute,
    AuthenticatedMonitoringSidebarComponentsPricingRoute:
      AuthenticatedMonitoringSidebarComponentsPricingRoute,
    AuthenticatedMonitoringSidebarDashboardsDashboardIdRoute:
      AuthenticatedMonitoringSidebarDashboardsDashboardIdRoute,
    AuthenticatedMonitoringSidebarInsightsAgentChar123ConversationIdChar125Route:
      AuthenticatedMonitoringSidebarInsightsAgentChar123ConversationIdChar125Route,
    AuthenticatedMonitoringSidebarJobsJobIdRoute:
      AuthenticatedMonitoringSidebarJobsJobIdRoute,
    AuthenticatedMonitoringSidebarReportsSavingsRoute:
      AuthenticatedMonitoringSidebarReportsSavingsRoute,
    AuthenticatedMonitoringSidebarChartsIndexRoute:
      AuthenticatedMonitoringSidebarChartsIndexRoute,
    AuthenticatedMonitoringSidebarDashboardsIndexRoute:
      AuthenticatedMonitoringSidebarDashboardsIndexRoute,
    AuthenticatedMonitoringSidebarJobsIndexRoute:
      AuthenticatedMonitoringSidebarJobsIndexRoute,
    AuthenticatedMonitoringSidebarComponentsCategoriesCategoryIdPricingRoute:
      AuthenticatedMonitoringSidebarComponentsCategoriesCategoryIdPricingRoute,
  }

const AuthenticatedMonitoringSidebarRouteRouteWithChildren =
  AuthenticatedMonitoringSidebarRouteRoute._addFileChildren(
    AuthenticatedMonitoringSidebarRouteRouteChildren,
  )

interface AuthenticatedMonitoringRouteRouteChildren {
  AuthenticatedMonitoringSidebarRouteRoute: typeof AuthenticatedMonitoringSidebarRouteRouteWithChildren
  AuthenticatedMonitoringAnalysisRoute: typeof AuthenticatedMonitoringAnalysisRoute
  AuthenticatedMonitoringAgentSplatRoute: typeof AuthenticatedMonitoringAgentSplatRoute
  AuthenticatedMonitoringChartsChartIdRoute: typeof AuthenticatedMonitoringChartsChartIdRoute
}

const AuthenticatedMonitoringRouteRouteChildren: AuthenticatedMonitoringRouteRouteChildren =
  {
    AuthenticatedMonitoringSidebarRouteRoute:
      AuthenticatedMonitoringSidebarRouteRouteWithChildren,
    AuthenticatedMonitoringAnalysisRoute: AuthenticatedMonitoringAnalysisRoute,
    AuthenticatedMonitoringAgentSplatRoute:
      AuthenticatedMonitoringAgentSplatRoute,
    AuthenticatedMonitoringChartsChartIdRoute:
      AuthenticatedMonitoringChartsChartIdRoute,
  }

const AuthenticatedMonitoringRouteRouteWithChildren =
  AuthenticatedMonitoringRouteRoute._addFileChildren(
    AuthenticatedMonitoringRouteRouteChildren,
  )

interface AuthenticatedNextPartsPartIdRouteRouteChildren {
  AuthenticatedNextPartsPartIdComplianceRoute: typeof AuthenticatedNextPartsPartIdComplianceRoute
  AuthenticatedNextPartsPartIdOffersRoute: typeof AuthenticatedNextPartsPartIdOffersRoute
  AuthenticatedNextPartsPartIdPartAlternativesRoute: typeof AuthenticatedNextPartsPartIdPartAlternativesRoute
  AuthenticatedNextPartsPartIdSeAlternativesRoute: typeof AuthenticatedNextPartsPartIdSeAlternativesRoute
  AuthenticatedNextPartsPartIdSeDocumentationRoute: typeof AuthenticatedNextPartsPartIdSeDocumentationRoute
  AuthenticatedNextPartsPartIdSeGeoRiskRoute: typeof AuthenticatedNextPartsPartIdSeGeoRiskRoute
  AuthenticatedNextPartsPartIdSeSupplyChainRoute: typeof AuthenticatedNextPartsPartIdSeSupplyChainRoute
  AuthenticatedNextPartsPartIdSeTechnicalRoute: typeof AuthenticatedNextPartsPartIdSeTechnicalRoute
  AuthenticatedNextPartsPartIdUsedInRoute: typeof AuthenticatedNextPartsPartIdUsedInRoute
  AuthenticatedNextPartsPartIdIndexRoute: typeof AuthenticatedNextPartsPartIdIndexRoute
}

const AuthenticatedNextPartsPartIdRouteRouteChildren: AuthenticatedNextPartsPartIdRouteRouteChildren =
  {
    AuthenticatedNextPartsPartIdComplianceRoute:
      AuthenticatedNextPartsPartIdComplianceRoute,
    AuthenticatedNextPartsPartIdOffersRoute:
      AuthenticatedNextPartsPartIdOffersRoute,
    AuthenticatedNextPartsPartIdPartAlternativesRoute:
      AuthenticatedNextPartsPartIdPartAlternativesRoute,
    AuthenticatedNextPartsPartIdSeAlternativesRoute:
      AuthenticatedNextPartsPartIdSeAlternativesRoute,
    AuthenticatedNextPartsPartIdSeDocumentationRoute:
      AuthenticatedNextPartsPartIdSeDocumentationRoute,
    AuthenticatedNextPartsPartIdSeGeoRiskRoute:
      AuthenticatedNextPartsPartIdSeGeoRiskRoute,
    AuthenticatedNextPartsPartIdSeSupplyChainRoute:
      AuthenticatedNextPartsPartIdSeSupplyChainRoute,
    AuthenticatedNextPartsPartIdSeTechnicalRoute:
      AuthenticatedNextPartsPartIdSeTechnicalRoute,
    AuthenticatedNextPartsPartIdUsedInRoute:
      AuthenticatedNextPartsPartIdUsedInRoute,
    AuthenticatedNextPartsPartIdIndexRoute:
      AuthenticatedNextPartsPartIdIndexRoute,
  }

const AuthenticatedNextPartsPartIdRouteRouteWithChildren =
  AuthenticatedNextPartsPartIdRouteRoute._addFileChildren(
    AuthenticatedNextPartsPartIdRouteRouteChildren,
  )

interface AuthenticatedNextProjectsProjectIdSourcingOverviewRouteRouteChildren {
  AuthenticatedNextProjectsProjectIdSourcingOverviewViewRoute: typeof AuthenticatedNextProjectsProjectIdSourcingOverviewViewRoute
  AuthenticatedNextProjectsProjectIdSourcingOverviewIndexRoute: typeof AuthenticatedNextProjectsProjectIdSourcingOverviewIndexRoute
}

const AuthenticatedNextProjectsProjectIdSourcingOverviewRouteRouteChildren: AuthenticatedNextProjectsProjectIdSourcingOverviewRouteRouteChildren =
  {
    AuthenticatedNextProjectsProjectIdSourcingOverviewViewRoute:
      AuthenticatedNextProjectsProjectIdSourcingOverviewViewRoute,
    AuthenticatedNextProjectsProjectIdSourcingOverviewIndexRoute:
      AuthenticatedNextProjectsProjectIdSourcingOverviewIndexRoute,
  }

const AuthenticatedNextProjectsProjectIdSourcingOverviewRouteRouteWithChildren =
  AuthenticatedNextProjectsProjectIdSourcingOverviewRouteRoute._addFileChildren(
    AuthenticatedNextProjectsProjectIdSourcingOverviewRouteRouteChildren,
  )

interface AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRouteChildren {
  AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbCadViewerRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbCadViewerRoute
  AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbDfmRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbDfmRoute
  AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbDfmAnalysisRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbDfmAnalysisRoute
  AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbDrillsRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbDrillsRoute
  AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbFilesRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbFilesRoute
  AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbPanelizationRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbPanelizationRoute
  AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbSpecificationRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbSpecificationRoute
  AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbStackupRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbStackupRoute
  AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbIndexRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbIndexRoute
}

const AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRouteChildren: AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRouteChildren =
  {
    AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbCadViewerRoute:
      AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbCadViewerRoute,
    AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbDfmRoute:
      AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbDfmRoute,
    AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbDfmAnalysisRoute:
      AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbDfmAnalysisRoute,
    AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbDrillsRoute:
      AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbDrillsRoute,
    AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbFilesRoute:
      AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbFilesRoute,
    AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbPanelizationRoute:
      AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbPanelizationRoute,
    AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbSpecificationRoute:
      AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbSpecificationRoute,
    AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbStackupRoute:
      AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbStackupRoute,
    AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbIndexRoute:
      AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbIndexRoute,
  }

const AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRouteWithChildren =
  AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRoute._addFileChildren(
    AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRouteChildren,
  )

interface AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdRouteRouteChildren {
  AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdPurchaseOrdersRoute: typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdPurchaseOrdersRoute
  AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdIndexRoute: typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdIndexRoute
  AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdLineItemsSourcingLineItemIdRoute: typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdLineItemsSourcingLineItemIdRoute
  AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdCostBreakdownIndexRoute: typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdCostBreakdownIndexRoute
  AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdLineItemsIndexRoute: typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdLineItemsIndexRoute
  AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdCostBreakdownAssemblyAssemblyIdDemandDemandIdRoute: typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdCostBreakdownAssemblyAssemblyIdDemandDemandIdRoute
}

const AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdRouteRouteChildren: AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdRouteRouteChildren =
  {
    AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdPurchaseOrdersRoute:
      AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdPurchaseOrdersRoute,
    AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdIndexRoute:
      AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdIndexRoute,
    AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdLineItemsSourcingLineItemIdRoute:
      AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdLineItemsSourcingLineItemIdRoute,
    AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdCostBreakdownIndexRoute:
      AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdCostBreakdownIndexRoute,
    AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdLineItemsIndexRoute:
      AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdLineItemsIndexRoute,
    AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdCostBreakdownAssemblyAssemblyIdDemandDemandIdRoute:
      AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdCostBreakdownAssemblyAssemblyIdDemandDemandIdRoute,
  }

const AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdRouteRouteWithChildren =
  AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdRouteRoute._addFileChildren(
    AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdRouteRouteChildren,
  )

interface AuthenticatedNextProjectsProjectIdRouteRouteChildren {
  AuthenticatedNextProjectsProjectIdDashboardRoute: typeof AuthenticatedNextProjectsProjectIdDashboardRoute
  AuthenticatedNextProjectsProjectIdEditRoute: typeof AuthenticatedNextProjectsProjectIdEditRoute
  AuthenticatedNextProjectsProjectIdQuotationRoute: typeof AuthenticatedNextProjectsProjectIdQuotationRoute
  AuthenticatedNextProjectsProjectIdIndexRoute: typeof AuthenticatedNextProjectsProjectIdIndexRoute
  AuthenticatedNextProjectsProjectIdSourcingOverviewRouteRoute: typeof AuthenticatedNextProjectsProjectIdSourcingOverviewRouteRouteWithChildren
  AuthenticatedNextProjectsProjectIdFlexibleCalculationFlexibleCalculationIdRoute: typeof AuthenticatedNextProjectsProjectIdFlexibleCalculationFlexibleCalculationIdRoute
  AuthenticatedNextProjectsProjectIdSourcingCompareRoute: typeof AuthenticatedNextProjectsProjectIdSourcingCompareRoute
  AuthenticatedNextProjectsProjectIdSourcingVersionHistoryRoute: typeof AuthenticatedNextProjectsProjectIdSourcingVersionHistoryRoute
  AuthenticatedNextProjectsProjectIdAssembliesIndexRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesIndexRoute
  AuthenticatedNextProjectsProjectIdFlexibleCalculationIndexRoute: typeof AuthenticatedNextProjectsProjectIdFlexibleCalculationIndexRoute
  AuthenticatedNextProjectsProjectIdManufacturingIndexRoute: typeof AuthenticatedNextProjectsProjectIdManufacturingIndexRoute
  AuthenticatedNextProjectsProjectIdSourcingIndexRoute: typeof AuthenticatedNextProjectsProjectIdSourcingIndexRoute
  AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRouteWithChildren
  AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdRouteRoute: typeof AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdRouteRouteWithChildren
  AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdDetailsRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdDetailsRoute
  AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdEditRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdEditRoute
  AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPnpImporterRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPnpImporterRoute
  AuthenticatedNextProjectsProjectIdSourcingAssemblyAssemblyIdRoute: typeof AuthenticatedNextProjectsProjectIdSourcingAssemblyAssemblyIdRoute
  AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsQuoteRequestIdRoute: typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsQuoteRequestIdRoute
  AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsAssignRoute: typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsAssignRoute
  AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsAttachmentsRoute: typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsAttachmentsRoute
  AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsDeliveryLotSizeRoute: typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsDeliveryLotSizeRoute
  AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsImporterRoute: typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsImporterRoute
  AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsLineItemsRoute: typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsLineItemsRoute
  AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsPreviewEmailRoute: typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsPreviewEmailRoute
  AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsTargetPriceRoute: typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsTargetPriceRoute
  AuthenticatedNextProjectsProjectIdSourcingScenariosCreateRoute: typeof AuthenticatedNextProjectsProjectIdSourcingScenariosCreateRoute
  AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdIndexRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdIndexRoute
  AuthenticatedNextProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdIndexRoute: typeof AuthenticatedNextProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdIndexRoute
  AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsIndexRoute: typeof AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsIndexRoute
  AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdSubassembliesCreateRoute: typeof AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdSubassembliesCreateRoute
  AuthenticatedNextProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdActivityRoute: typeof AuthenticatedNextProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdActivityRoute
  AuthenticatedNextProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdExpenseRoute: typeof AuthenticatedNextProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdExpenseRoute
  AuthenticatedNextProjectsProjectIdSourcingOffersCustomPartOfferIdDuplicateRoute: typeof AuthenticatedNextProjectsProjectIdSourcingOffersCustomPartOfferIdDuplicateRoute
  AuthenticatedNextProjectsProjectIdSourcingOffersCustomPartOfferIdEditRoute: typeof AuthenticatedNextProjectsProjectIdSourcingOffersCustomPartOfferIdEditRoute
  AuthenticatedNextProjectsProjectIdSourcingOffersInternalPartNumberOfferIdDuplicateRoute: typeof AuthenticatedNextProjectsProjectIdSourcingOffersInternalPartNumberOfferIdDuplicateRoute
  AuthenticatedNextProjectsProjectIdSourcingOffersInternalPartNumberOfferIdEditRoute: typeof AuthenticatedNextProjectsProjectIdSourcingOffersInternalPartNumberOfferIdEditRoute
  AuthenticatedNextProjectsProjectIdSourcingOffersOffTheShelfOfferIdDuplicateRoute: typeof AuthenticatedNextProjectsProjectIdSourcingOffersOffTheShelfOfferIdDuplicateRoute
  AuthenticatedNextProjectsProjectIdSourcingOffersOffTheShelfOfferIdEditRoute: typeof AuthenticatedNextProjectsProjectIdSourcingOffersOffTheShelfOfferIdEditRoute
}

const AuthenticatedNextProjectsProjectIdRouteRouteChildren: AuthenticatedNextProjectsProjectIdRouteRouteChildren =
  {
    AuthenticatedNextProjectsProjectIdDashboardRoute:
      AuthenticatedNextProjectsProjectIdDashboardRoute,
    AuthenticatedNextProjectsProjectIdEditRoute:
      AuthenticatedNextProjectsProjectIdEditRoute,
    AuthenticatedNextProjectsProjectIdQuotationRoute:
      AuthenticatedNextProjectsProjectIdQuotationRoute,
    AuthenticatedNextProjectsProjectIdIndexRoute:
      AuthenticatedNextProjectsProjectIdIndexRoute,
    AuthenticatedNextProjectsProjectIdSourcingOverviewRouteRoute:
      AuthenticatedNextProjectsProjectIdSourcingOverviewRouteRouteWithChildren,
    AuthenticatedNextProjectsProjectIdFlexibleCalculationFlexibleCalculationIdRoute:
      AuthenticatedNextProjectsProjectIdFlexibleCalculationFlexibleCalculationIdRoute,
    AuthenticatedNextProjectsProjectIdSourcingCompareRoute:
      AuthenticatedNextProjectsProjectIdSourcingCompareRoute,
    AuthenticatedNextProjectsProjectIdSourcingVersionHistoryRoute:
      AuthenticatedNextProjectsProjectIdSourcingVersionHistoryRoute,
    AuthenticatedNextProjectsProjectIdAssembliesIndexRoute:
      AuthenticatedNextProjectsProjectIdAssembliesIndexRoute,
    AuthenticatedNextProjectsProjectIdFlexibleCalculationIndexRoute:
      AuthenticatedNextProjectsProjectIdFlexibleCalculationIndexRoute,
    AuthenticatedNextProjectsProjectIdManufacturingIndexRoute:
      AuthenticatedNextProjectsProjectIdManufacturingIndexRoute,
    AuthenticatedNextProjectsProjectIdSourcingIndexRoute:
      AuthenticatedNextProjectsProjectIdSourcingIndexRoute,
    AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRoute:
      AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPcbRouteRouteWithChildren,
    AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdRouteRoute:
      AuthenticatedNextProjectsProjectIdSourcingScenariosSourcingScenarioIdRouteRouteWithChildren,
    AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdDetailsRoute:
      AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdDetailsRoute,
    AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdEditRoute:
      AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdEditRoute,
    AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPnpImporterRoute:
      AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdPnpImporterRoute,
    AuthenticatedNextProjectsProjectIdSourcingAssemblyAssemblyIdRoute:
      AuthenticatedNextProjectsProjectIdSourcingAssemblyAssemblyIdRoute,
    AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsQuoteRequestIdRoute:
      AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsQuoteRequestIdRoute,
    AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsAssignRoute:
      AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsAssignRoute,
    AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsAttachmentsRoute:
      AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsAttachmentsRoute,
    AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsDeliveryLotSizeRoute:
      AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsDeliveryLotSizeRoute,
    AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsImporterRoute:
      AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsImporterRoute,
    AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsLineItemsRoute:
      AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsLineItemsRoute,
    AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsPreviewEmailRoute:
      AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsPreviewEmailRoute,
    AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsTargetPriceRoute:
      AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsTargetPriceRoute,
    AuthenticatedNextProjectsProjectIdSourcingScenariosCreateRoute:
      AuthenticatedNextProjectsProjectIdSourcingScenariosCreateRoute,
    AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdIndexRoute:
      AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdIndexRoute,
    AuthenticatedNextProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdIndexRoute:
      AuthenticatedNextProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdIndexRoute,
    AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsIndexRoute:
      AuthenticatedNextProjectsProjectIdSourcingQuoteRequestsIndexRoute,
    AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdSubassembliesCreateRoute:
      AuthenticatedNextProjectsProjectIdAssembliesAssemblyIdSubassembliesCreateRoute,
    AuthenticatedNextProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdActivityRoute:
      AuthenticatedNextProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdActivityRoute,
    AuthenticatedNextProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdExpenseRoute:
      AuthenticatedNextProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdExpenseRoute,
    AuthenticatedNextProjectsProjectIdSourcingOffersCustomPartOfferIdDuplicateRoute:
      AuthenticatedNextProjectsProjectIdSourcingOffersCustomPartOfferIdDuplicateRoute,
    AuthenticatedNextProjectsProjectIdSourcingOffersCustomPartOfferIdEditRoute:
      AuthenticatedNextProjectsProjectIdSourcingOffersCustomPartOfferIdEditRoute,
    AuthenticatedNextProjectsProjectIdSourcingOffersInternalPartNumberOfferIdDuplicateRoute:
      AuthenticatedNextProjectsProjectIdSourcingOffersInternalPartNumberOfferIdDuplicateRoute,
    AuthenticatedNextProjectsProjectIdSourcingOffersInternalPartNumberOfferIdEditRoute:
      AuthenticatedNextProjectsProjectIdSourcingOffersInternalPartNumberOfferIdEditRoute,
    AuthenticatedNextProjectsProjectIdSourcingOffersOffTheShelfOfferIdDuplicateRoute:
      AuthenticatedNextProjectsProjectIdSourcingOffersOffTheShelfOfferIdDuplicateRoute,
    AuthenticatedNextProjectsProjectIdSourcingOffersOffTheShelfOfferIdEditRoute:
      AuthenticatedNextProjectsProjectIdSourcingOffersOffTheShelfOfferIdEditRoute,
  }

const AuthenticatedNextProjectsProjectIdRouteRouteWithChildren =
  AuthenticatedNextProjectsProjectIdRouteRoute._addFileChildren(
    AuthenticatedNextProjectsProjectIdRouteRouteChildren,
  )

interface AuthenticatedNextSettingsMenuRouteRouteChildren {
  AuthenticatedNextSettingsMenuOrganizationApiIntegrationRoute: typeof AuthenticatedNextSettingsMenuOrganizationApiIntegrationRoute
  AuthenticatedNextSettingsMenuOrganizationAssemblySettingsRoute: typeof AuthenticatedNextSettingsMenuOrganizationAssemblySettingsRoute
  AuthenticatedNextSettingsMenuOrganizationAutomaticRfqNumberRoute: typeof AuthenticatedNextSettingsMenuOrganizationAutomaticRfqNumberRoute
  AuthenticatedNextSettingsMenuOrganizationBrandingRoute: typeof AuthenticatedNextSettingsMenuOrganizationBrandingRoute
  AuthenticatedNextSettingsMenuOrganizationCarbonFootprintsRoute: typeof AuthenticatedNextSettingsMenuOrganizationCarbonFootprintsRoute
  AuthenticatedNextSettingsMenuOrganizationComponentSettingsRoute: typeof AuthenticatedNextSettingsMenuOrganizationComponentSettingsRoute
  AuthenticatedNextSettingsMenuOrganizationCsvIntegrationRoute: typeof AuthenticatedNextSettingsMenuOrganizationCsvIntegrationRoute
  AuthenticatedNextSettingsMenuOrganizationCustomPartCategoriesRoute: typeof AuthenticatedNextSettingsMenuOrganizationCustomPartCategoriesRoute
  AuthenticatedNextSettingsMenuOrganizationDataIntegrationsRoute: typeof AuthenticatedNextSettingsMenuOrganizationDataIntegrationsRoute
  AuthenticatedNextSettingsMenuOrganizationFeatureFlagsRoute: typeof AuthenticatedNextSettingsMenuOrganizationFeatureFlagsRoute
  AuthenticatedNextSettingsMenuOrganizationManufacturerPreferencesRoute: typeof AuthenticatedNextSettingsMenuOrganizationManufacturerPreferencesRoute
  AuthenticatedNextSettingsMenuOrganizationSitesRoute: typeof AuthenticatedNextSettingsMenuOrganizationSitesRoute
  AuthenticatedNextSettingsMenuOrganizationSupplierApiIntegrationsRoute: typeof AuthenticatedNextSettingsMenuOrganizationSupplierApiIntegrationsRoute
  AuthenticatedNextSettingsMenuUserAccountSecurityRoute: typeof AuthenticatedNextSettingsMenuUserAccountSecurityRoute
  AuthenticatedNextSettingsMenuOrganizationIndexRoute: typeof AuthenticatedNextSettingsMenuOrganizationIndexRoute
  AuthenticatedNextSettingsMenuOrganizationCustomerPortalAdditionalServicesRoute: typeof AuthenticatedNextSettingsMenuOrganizationCustomerPortalAdditionalServicesRoute
  AuthenticatedNextSettingsMenuOrganizationCustomerPortalCheckoutConditionsRoute: typeof AuthenticatedNextSettingsMenuOrganizationCustomerPortalCheckoutConditionsRoute
  AuthenticatedNextSettingsMenuOrganizationCustomerPortalCustomerSpecificSettingsRoute: typeof AuthenticatedNextSettingsMenuOrganizationCustomerPortalCustomerSpecificSettingsRoute
  AuthenticatedNextSettingsMenuOrganizationCustomerPortalLandingPageRoute: typeof AuthenticatedNextSettingsMenuOrganizationCustomerPortalLandingPageRoute
  AuthenticatedNextSettingsMenuOrganizationCustomerPortalPaymentCredentialsRoute: typeof AuthenticatedNextSettingsMenuOrganizationCustomerPortalPaymentCredentialsRoute
  AuthenticatedNextSettingsMenuOrganizationUserManagementActionPermissionsRoute: typeof AuthenticatedNextSettingsMenuOrganizationUserManagementActionPermissionsRoute
  AuthenticatedNextSettingsMenuOrganizationUserManagementRolesRoute: typeof AuthenticatedNextSettingsMenuOrganizationUserManagementRolesRoute
  AuthenticatedNextSettingsMenuOrganizationCustomerPortalIndexRoute: typeof AuthenticatedNextSettingsMenuOrganizationCustomerPortalIndexRoute
  AuthenticatedNextSettingsMenuOrganizationPcbIndexRoute: typeof AuthenticatedNextSettingsMenuOrganizationPcbIndexRoute
  AuthenticatedNextSettingsMenuOrganizationUsersIndexRoute: typeof AuthenticatedNextSettingsMenuOrganizationUsersIndexRoute
  AuthenticatedNextSettingsMenuOrganizationPcbPanelPreferencesCreateRoute: typeof AuthenticatedNextSettingsMenuOrganizationPcbPanelPreferencesCreateRoute
  AuthenticatedNextSettingsMenuOrganizationPcbPanelPreferencesPanelPreferenceIdEditRoute: typeof AuthenticatedNextSettingsMenuOrganizationPcbPanelPreferencesPanelPreferenceIdEditRoute
}

const AuthenticatedNextSettingsMenuRouteRouteChildren: AuthenticatedNextSettingsMenuRouteRouteChildren =
  {
    AuthenticatedNextSettingsMenuOrganizationApiIntegrationRoute:
      AuthenticatedNextSettingsMenuOrganizationApiIntegrationRoute,
    AuthenticatedNextSettingsMenuOrganizationAssemblySettingsRoute:
      AuthenticatedNextSettingsMenuOrganizationAssemblySettingsRoute,
    AuthenticatedNextSettingsMenuOrganizationAutomaticRfqNumberRoute:
      AuthenticatedNextSettingsMenuOrganizationAutomaticRfqNumberRoute,
    AuthenticatedNextSettingsMenuOrganizationBrandingRoute:
      AuthenticatedNextSettingsMenuOrganizationBrandingRoute,
    AuthenticatedNextSettingsMenuOrganizationCarbonFootprintsRoute:
      AuthenticatedNextSettingsMenuOrganizationCarbonFootprintsRoute,
    AuthenticatedNextSettingsMenuOrganizationComponentSettingsRoute:
      AuthenticatedNextSettingsMenuOrganizationComponentSettingsRoute,
    AuthenticatedNextSettingsMenuOrganizationCsvIntegrationRoute:
      AuthenticatedNextSettingsMenuOrganizationCsvIntegrationRoute,
    AuthenticatedNextSettingsMenuOrganizationCustomPartCategoriesRoute:
      AuthenticatedNextSettingsMenuOrganizationCustomPartCategoriesRoute,
    AuthenticatedNextSettingsMenuOrganizationDataIntegrationsRoute:
      AuthenticatedNextSettingsMenuOrganizationDataIntegrationsRoute,
    AuthenticatedNextSettingsMenuOrganizationFeatureFlagsRoute:
      AuthenticatedNextSettingsMenuOrganizationFeatureFlagsRoute,
    AuthenticatedNextSettingsMenuOrganizationManufacturerPreferencesRoute:
      AuthenticatedNextSettingsMenuOrganizationManufacturerPreferencesRoute,
    AuthenticatedNextSettingsMenuOrganizationSitesRoute:
      AuthenticatedNextSettingsMenuOrganizationSitesRoute,
    AuthenticatedNextSettingsMenuOrganizationSupplierApiIntegrationsRoute:
      AuthenticatedNextSettingsMenuOrganizationSupplierApiIntegrationsRoute,
    AuthenticatedNextSettingsMenuUserAccountSecurityRoute:
      AuthenticatedNextSettingsMenuUserAccountSecurityRoute,
    AuthenticatedNextSettingsMenuOrganizationIndexRoute:
      AuthenticatedNextSettingsMenuOrganizationIndexRoute,
    AuthenticatedNextSettingsMenuOrganizationCustomerPortalAdditionalServicesRoute:
      AuthenticatedNextSettingsMenuOrganizationCustomerPortalAdditionalServicesRoute,
    AuthenticatedNextSettingsMenuOrganizationCustomerPortalCheckoutConditionsRoute:
      AuthenticatedNextSettingsMenuOrganizationCustomerPortalCheckoutConditionsRoute,
    AuthenticatedNextSettingsMenuOrganizationCustomerPortalCustomerSpecificSettingsRoute:
      AuthenticatedNextSettingsMenuOrganizationCustomerPortalCustomerSpecificSettingsRoute,
    AuthenticatedNextSettingsMenuOrganizationCustomerPortalLandingPageRoute:
      AuthenticatedNextSettingsMenuOrganizationCustomerPortalLandingPageRoute,
    AuthenticatedNextSettingsMenuOrganizationCustomerPortalPaymentCredentialsRoute:
      AuthenticatedNextSettingsMenuOrganizationCustomerPortalPaymentCredentialsRoute,
    AuthenticatedNextSettingsMenuOrganizationUserManagementActionPermissionsRoute:
      AuthenticatedNextSettingsMenuOrganizationUserManagementActionPermissionsRoute,
    AuthenticatedNextSettingsMenuOrganizationUserManagementRolesRoute:
      AuthenticatedNextSettingsMenuOrganizationUserManagementRolesRoute,
    AuthenticatedNextSettingsMenuOrganizationCustomerPortalIndexRoute:
      AuthenticatedNextSettingsMenuOrganizationCustomerPortalIndexRoute,
    AuthenticatedNextSettingsMenuOrganizationPcbIndexRoute:
      AuthenticatedNextSettingsMenuOrganizationPcbIndexRoute,
    AuthenticatedNextSettingsMenuOrganizationUsersIndexRoute:
      AuthenticatedNextSettingsMenuOrganizationUsersIndexRoute,
    AuthenticatedNextSettingsMenuOrganizationPcbPanelPreferencesCreateRoute:
      AuthenticatedNextSettingsMenuOrganizationPcbPanelPreferencesCreateRoute,
    AuthenticatedNextSettingsMenuOrganizationPcbPanelPreferencesPanelPreferenceIdEditRoute:
      AuthenticatedNextSettingsMenuOrganizationPcbPanelPreferencesPanelPreferenceIdEditRoute,
  }

const AuthenticatedNextSettingsMenuRouteRouteWithChildren =
  AuthenticatedNextSettingsMenuRouteRoute._addFileChildren(
    AuthenticatedNextSettingsMenuRouteRouteChildren,
  )

interface AuthenticatedNextAssembliesAssemblyIdPcbRouteRouteChildren {
  AuthenticatedNextAssembliesAssemblyIdPcbCadViewerRoute: typeof AuthenticatedNextAssembliesAssemblyIdPcbCadViewerRoute
  AuthenticatedNextAssembliesAssemblyIdPcbDfmRoute: typeof AuthenticatedNextAssembliesAssemblyIdPcbDfmRoute
  AuthenticatedNextAssembliesAssemblyIdPcbDfmAnalysisRoute: typeof AuthenticatedNextAssembliesAssemblyIdPcbDfmAnalysisRoute
  AuthenticatedNextAssembliesAssemblyIdPcbDrillsRoute: typeof AuthenticatedNextAssembliesAssemblyIdPcbDrillsRoute
  AuthenticatedNextAssembliesAssemblyIdPcbFilesRoute: typeof AuthenticatedNextAssembliesAssemblyIdPcbFilesRoute
  AuthenticatedNextAssembliesAssemblyIdPcbPanelizationRoute: typeof AuthenticatedNextAssembliesAssemblyIdPcbPanelizationRoute
  AuthenticatedNextAssembliesAssemblyIdPcbSpecificationRoute: typeof AuthenticatedNextAssembliesAssemblyIdPcbSpecificationRoute
  AuthenticatedNextAssembliesAssemblyIdPcbStackupRoute: typeof AuthenticatedNextAssembliesAssemblyIdPcbStackupRoute
  AuthenticatedNextAssembliesAssemblyIdPcbIndexRoute: typeof AuthenticatedNextAssembliesAssemblyIdPcbIndexRoute
}

const AuthenticatedNextAssembliesAssemblyIdPcbRouteRouteChildren: AuthenticatedNextAssembliesAssemblyIdPcbRouteRouteChildren =
  {
    AuthenticatedNextAssembliesAssemblyIdPcbCadViewerRoute:
      AuthenticatedNextAssembliesAssemblyIdPcbCadViewerRoute,
    AuthenticatedNextAssembliesAssemblyIdPcbDfmRoute:
      AuthenticatedNextAssembliesAssemblyIdPcbDfmRoute,
    AuthenticatedNextAssembliesAssemblyIdPcbDfmAnalysisRoute:
      AuthenticatedNextAssembliesAssemblyIdPcbDfmAnalysisRoute,
    AuthenticatedNextAssembliesAssemblyIdPcbDrillsRoute:
      AuthenticatedNextAssembliesAssemblyIdPcbDrillsRoute,
    AuthenticatedNextAssembliesAssemblyIdPcbFilesRoute:
      AuthenticatedNextAssembliesAssemblyIdPcbFilesRoute,
    AuthenticatedNextAssembliesAssemblyIdPcbPanelizationRoute:
      AuthenticatedNextAssembliesAssemblyIdPcbPanelizationRoute,
    AuthenticatedNextAssembliesAssemblyIdPcbSpecificationRoute:
      AuthenticatedNextAssembliesAssemblyIdPcbSpecificationRoute,
    AuthenticatedNextAssembliesAssemblyIdPcbStackupRoute:
      AuthenticatedNextAssembliesAssemblyIdPcbStackupRoute,
    AuthenticatedNextAssembliesAssemblyIdPcbIndexRoute:
      AuthenticatedNextAssembliesAssemblyIdPcbIndexRoute,
  }

const AuthenticatedNextAssembliesAssemblyIdPcbRouteRouteWithChildren =
  AuthenticatedNextAssembliesAssemblyIdPcbRouteRoute._addFileChildren(
    AuthenticatedNextAssembliesAssemblyIdPcbRouteRouteChildren,
  )

interface AuthenticatedNextComponentsIpnDetailsRouteRouteChildren {
  AuthenticatedNextComponentsIpnDetailsCpnsRoute: typeof AuthenticatedNextComponentsIpnDetailsCpnsRoute
  AuthenticatedNextComponentsIpnDetailsLinkingRoute: typeof AuthenticatedNextComponentsIpnDetailsLinkingRoute
  AuthenticatedNextComponentsIpnDetailsUsedInRoute: typeof AuthenticatedNextComponentsIpnDetailsUsedInRoute
  AuthenticatedNextComponentsIpnDetailsIndexRoute: typeof AuthenticatedNextComponentsIpnDetailsIndexRoute
  AuthenticatedNextComponentsIpnDetailsOffersIndexRoute: typeof AuthenticatedNextComponentsIpnDetailsOffersIndexRoute
}

const AuthenticatedNextComponentsIpnDetailsRouteRouteChildren: AuthenticatedNextComponentsIpnDetailsRouteRouteChildren =
  {
    AuthenticatedNextComponentsIpnDetailsCpnsRoute:
      AuthenticatedNextComponentsIpnDetailsCpnsRoute,
    AuthenticatedNextComponentsIpnDetailsLinkingRoute:
      AuthenticatedNextComponentsIpnDetailsLinkingRoute,
    AuthenticatedNextComponentsIpnDetailsUsedInRoute:
      AuthenticatedNextComponentsIpnDetailsUsedInRoute,
    AuthenticatedNextComponentsIpnDetailsIndexRoute:
      AuthenticatedNextComponentsIpnDetailsIndexRoute,
    AuthenticatedNextComponentsIpnDetailsOffersIndexRoute:
      AuthenticatedNextComponentsIpnDetailsOffersIndexRoute,
  }

const AuthenticatedNextComponentsIpnDetailsRouteRouteWithChildren =
  AuthenticatedNextComponentsIpnDetailsRouteRoute._addFileChildren(
    AuthenticatedNextComponentsIpnDetailsRouteRouteChildren,
  )

interface AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRouteChildren {
  AuthenticatedNextNegotiationsNegotiationIdSidebarOverviewRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarOverviewRoute
  AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsQuoteRequestIdRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsQuoteRequestIdRoute
  AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsAssignRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsAssignRoute
  AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsAttachmentsRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsAttachmentsRoute
  AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsDeliveryLotSizeRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsDeliveryLotSizeRoute
  AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsImporterRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsImporterRoute
  AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsLineItemsRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsLineItemsRoute
  AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsPreviewEmailRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsPreviewEmailRoute
  AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsTargetPriceRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsTargetPriceRoute
  AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosCompareRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosCompareRoute
  AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosCreateRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosCreateRoute
  AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsIndexRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsIndexRoute
  AuthenticatedNextNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdAwardingRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdAwardingRoute
  AuthenticatedNextNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdIndexRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdIndexRoute
  AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdIndexRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdIndexRoute
  AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownIndexRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownIndexRoute
  AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownAssemblyAssemblyIdDemandDemandIdRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownAssemblyAssemblyIdDemandDemandIdRoute
}

const AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRouteChildren: AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRouteChildren =
  {
    AuthenticatedNextNegotiationsNegotiationIdSidebarOverviewRoute:
      AuthenticatedNextNegotiationsNegotiationIdSidebarOverviewRoute,
    AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsQuoteRequestIdRoute:
      AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsQuoteRequestIdRoute,
    AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsAssignRoute:
      AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsAssignRoute,
    AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsAttachmentsRoute:
      AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsAttachmentsRoute,
    AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsDeliveryLotSizeRoute:
      AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsDeliveryLotSizeRoute,
    AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsImporterRoute:
      AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsImporterRoute,
    AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsLineItemsRoute:
      AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsLineItemsRoute,
    AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsPreviewEmailRoute:
      AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsPreviewEmailRoute,
    AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsTargetPriceRoute:
      AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsTargetPriceRoute,
    AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosCompareRoute:
      AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosCompareRoute,
    AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosCreateRoute:
      AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosCreateRoute,
    AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsIndexRoute:
      AuthenticatedNextNegotiationsNegotiationIdSidebarQuoteRequestsIndexRoute,
    AuthenticatedNextNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdAwardingRoute:
      AuthenticatedNextNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdAwardingRoute,
    AuthenticatedNextNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdIndexRoute:
      AuthenticatedNextNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdIndexRoute,
    AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdIndexRoute:
      AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdIndexRoute,
    AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownIndexRoute:
      AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownIndexRoute,
    AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownAssemblyAssemblyIdDemandDemandIdRoute:
      AuthenticatedNextNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownAssemblyAssemblyIdDemandDemandIdRoute,
  }

const AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRouteWithChildren =
  AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute._addFileChildren(
    AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRouteChildren,
  )

interface AuthenticatedNextPartsCustomCustomPartSpecificationIdRouteRouteChildren {
  AuthenticatedNextPartsCustomCustomPartSpecificationIdOffersRoute: typeof AuthenticatedNextPartsCustomCustomPartSpecificationIdOffersRoute
  AuthenticatedNextPartsCustomCustomPartSpecificationIdUsedInRoute: typeof AuthenticatedNextPartsCustomCustomPartSpecificationIdUsedInRoute
  AuthenticatedNextPartsCustomCustomPartSpecificationIdIndexRoute: typeof AuthenticatedNextPartsCustomCustomPartSpecificationIdIndexRoute
}

const AuthenticatedNextPartsCustomCustomPartSpecificationIdRouteRouteChildren: AuthenticatedNextPartsCustomCustomPartSpecificationIdRouteRouteChildren =
  {
    AuthenticatedNextPartsCustomCustomPartSpecificationIdOffersRoute:
      AuthenticatedNextPartsCustomCustomPartSpecificationIdOffersRoute,
    AuthenticatedNextPartsCustomCustomPartSpecificationIdUsedInRoute:
      AuthenticatedNextPartsCustomCustomPartSpecificationIdUsedInRoute,
    AuthenticatedNextPartsCustomCustomPartSpecificationIdIndexRoute:
      AuthenticatedNextPartsCustomCustomPartSpecificationIdIndexRoute,
  }

const AuthenticatedNextPartsCustomCustomPartSpecificationIdRouteRouteWithChildren =
  AuthenticatedNextPartsCustomCustomPartSpecificationIdRouteRoute._addFileChildren(
    AuthenticatedNextPartsCustomCustomPartSpecificationIdRouteRouteChildren,
  )

interface AuthenticatedNextRouteRouteChildren {
  AuthenticatedNextSplatRoute: typeof AuthenticatedNextSplatRoute
  AuthenticatedNextAlertsRoute: typeof AuthenticatedNextAlertsRoute
  AuthenticatedNextHomeRoute: typeof AuthenticatedNextHomeRoute
  AuthenticatedNextLumiAgentRoute: typeof AuthenticatedNextLumiAgentRoute
  AuthenticatedNextPurchaseOrdersRoute: typeof AuthenticatedNextPurchaseOrdersRoute
  AuthenticatedNextIndexRoute: typeof AuthenticatedNextIndexRoute
  AuthenticatedNextPartsPartIdRouteRoute: typeof AuthenticatedNextPartsPartIdRouteRouteWithChildren
  AuthenticatedNextProjectsProjectIdRouteRoute: typeof AuthenticatedNextProjectsProjectIdRouteRouteWithChildren
  AuthenticatedNextSettingsMenuRouteRoute: typeof AuthenticatedNextSettingsMenuRouteRouteWithChildren
  AuthenticatedNextAppsSplatRoute: typeof AuthenticatedNextAppsSplatRoute
  AuthenticatedNextComponentsLinkingRoute: typeof AuthenticatedNextComponentsLinkingRoute
  AuthenticatedNextCustomersCustomerIdRoute: typeof AuthenticatedNextCustomersCustomerIdRoute
  AuthenticatedNextDemandsImporterRoute: typeof AuthenticatedNextDemandsImporterRoute
  AuthenticatedNextManufacturersManufacturerIdRoute: typeof AuthenticatedNextManufacturersManufacturerIdRoute
  AuthenticatedNextManufacturersLineCardRoute: typeof AuthenticatedNextManufacturersLineCardRoute
  AuthenticatedNextNegotiationsCreateRoute: typeof AuthenticatedNextNegotiationsCreateRoute
  AuthenticatedNextOfferImportsOfferImportIdRoute: typeof AuthenticatedNextOfferImportsOfferImportIdRoute
  AuthenticatedNextOrdersUploadRoute: typeof AuthenticatedNextOrdersUploadRoute
  AuthenticatedNextOrdersChar123OrderIdChar125Route: typeof AuthenticatedNextOrdersChar123OrderIdChar125Route
  AuthenticatedNextPartsSearchRoute: typeof AuthenticatedNextPartsSearchRoute
  AuthenticatedNextProjectsCreateRoute: typeof AuthenticatedNextProjectsCreateRoute
  AuthenticatedNextQuoteRequestsImporterRoute: typeof AuthenticatedNextQuoteRequestsImporterRoute
  AuthenticatedNextRiskManagementGeoRiskRoute: typeof AuthenticatedNextRiskManagementGeoRiskRoute
  AuthenticatedNextRiskManagementPcnsRoute: typeof AuthenticatedNextRiskManagementPcnsRoute
  AuthenticatedNextRiskManagementRiskDigestRoute: typeof AuthenticatedNextRiskManagementRiskDigestRoute
  AuthenticatedNextSettingsCompanyRoute: typeof AuthenticatedNextSettingsCompanyRoute
  AuthenticatedNextSuppliersSupplierAndStockLocationIdRoute: typeof AuthenticatedNextSuppliersSupplierAndStockLocationIdRoute
  AuthenticatedNextSuppliersStrategyRoute: typeof AuthenticatedNextSuppliersStrategyRoute
  AuthenticatedNextTemplatesExportRoute: typeof AuthenticatedNextTemplatesExportRoute
  AuthenticatedNextTemplatesPcbSpecificationRoute: typeof AuthenticatedNextTemplatesPcbSpecificationRoute
  AuthenticatedNextAssembliesIndexRoute: typeof AuthenticatedNextAssembliesIndexRoute
  AuthenticatedNextComponentsIndexRoute: typeof AuthenticatedNextComponentsIndexRoute
  AuthenticatedNextCustomersIndexRoute: typeof AuthenticatedNextCustomersIndexRoute
  AuthenticatedNextDemandsIndexRoute: typeof AuthenticatedNextDemandsIndexRoute
  AuthenticatedNextManufacturersIndexRoute: typeof AuthenticatedNextManufacturersIndexRoute
  AuthenticatedNextNegotiationsIndexRoute: typeof AuthenticatedNextNegotiationsIndexRoute
  AuthenticatedNextOfferImportsIndexRoute: typeof AuthenticatedNextOfferImportsIndexRoute
  AuthenticatedNextPartsIndexRoute: typeof AuthenticatedNextPartsIndexRoute
  AuthenticatedNextProjectsIndexRoute: typeof AuthenticatedNextProjectsIndexRoute
  AuthenticatedNextQuoteRequestsIndexRoute: typeof AuthenticatedNextQuoteRequestsIndexRoute
  AuthenticatedNextRiskManagementIndexRoute: typeof AuthenticatedNextRiskManagementIndexRoute
  AuthenticatedNextSettingsIndexRoute: typeof AuthenticatedNextSettingsIndexRoute
  AuthenticatedNextSuppliersIndexRoute: typeof AuthenticatedNextSuppliersIndexRoute
  AuthenticatedNextAssembliesAssemblyIdPcbRouteRoute: typeof AuthenticatedNextAssembliesAssemblyIdPcbRouteRouteWithChildren
  AuthenticatedNextComponentsIpnDetailsRouteRoute: typeof AuthenticatedNextComponentsIpnDetailsRouteRouteWithChildren
  AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute: typeof AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRouteWithChildren
  AuthenticatedNextPartsCustomCustomPartSpecificationIdRouteRoute: typeof AuthenticatedNextPartsCustomCustomPartSpecificationIdRouteRouteWithChildren
  AuthenticatedNextAssembliesAssemblyIdDashboardRoute: typeof AuthenticatedNextAssembliesAssemblyIdDashboardRoute
  AuthenticatedNextAssembliesAssemblyIdDetailsRoute: typeof AuthenticatedNextAssembliesAssemblyIdDetailsRoute
  AuthenticatedNextAssembliesAssemblyIdEditRoute: typeof AuthenticatedNextAssembliesAssemblyIdEditRoute
  AuthenticatedNextRiskManagementLibraryHealthAssembliesRoute: typeof AuthenticatedNextRiskManagementLibraryHealthAssembliesRoute
  AuthenticatedNextRiskManagementLibraryHealthComponentsRoute: typeof AuthenticatedNextRiskManagementLibraryHealthComponentsRoute
  AuthenticatedNextRiskManagementLibraryHealthPartsRoute: typeof AuthenticatedNextRiskManagementLibraryHealthPartsRoute
  AuthenticatedNextTemplatesEmailCreateRoute: typeof AuthenticatedNextTemplatesEmailCreateRoute
  AuthenticatedNextTemplatesFlexibleCalculationFlexibleCalculationTemplateIdRoute: typeof AuthenticatedNextTemplatesFlexibleCalculationFlexibleCalculationTemplateIdRoute
  AuthenticatedNextTemplatesFlexibleCalculationCreateRoute: typeof AuthenticatedNextTemplatesFlexibleCalculationCreateRoute
  AuthenticatedNextTemplatesFlexibleCalculationExportedVariablesRoute: typeof AuthenticatedNextTemplatesFlexibleCalculationExportedVariablesRoute
  AuthenticatedNextTemplatesQuoteRequestCreateRoute: typeof AuthenticatedNextTemplatesQuoteRequestCreateRoute
  AuthenticatedNextTemplatesSourcingCreateRoute: typeof AuthenticatedNextTemplatesSourcingCreateRoute
  AuthenticatedNextAssembliesAssemblyIdIndexRoute: typeof AuthenticatedNextAssembliesAssemblyIdIndexRoute
  AuthenticatedNextNegotiationsNegotiationIdIndexRoute: typeof AuthenticatedNextNegotiationsNegotiationIdIndexRoute
  AuthenticatedNextRiskManagementLibraryHealthIndexRoute: typeof AuthenticatedNextRiskManagementLibraryHealthIndexRoute
  AuthenticatedNextSuppliersSupplierContactsIndexRoute: typeof AuthenticatedNextSuppliersSupplierContactsIndexRoute
  AuthenticatedNextTemplatesEmailIndexRoute: typeof AuthenticatedNextTemplatesEmailIndexRoute
  AuthenticatedNextTemplatesFlexibleCalculationIndexRoute: typeof AuthenticatedNextTemplatesFlexibleCalculationIndexRoute
  AuthenticatedNextTemplatesQuotationIndexRoute: typeof AuthenticatedNextTemplatesQuotationIndexRoute
  AuthenticatedNextTemplatesQuoteRequestIndexRoute: typeof AuthenticatedNextTemplatesQuoteRequestIndexRoute
  AuthenticatedNextTemplatesSourcingIndexRoute: typeof AuthenticatedNextTemplatesSourcingIndexRoute
  AuthenticatedNextAssembliesAssemblyIdSubassembliesCreateRoute: typeof AuthenticatedNextAssembliesAssemblyIdSubassembliesCreateRoute
  AuthenticatedNextPartsOffersOfferIdDuplicateRoute: typeof AuthenticatedNextPartsOffersOfferIdDuplicateRoute
  AuthenticatedNextPartsOffersOfferIdEditRoute: typeof AuthenticatedNextPartsOffersOfferIdEditRoute
  AuthenticatedNextSettingsOrganizationUsersImporterRoute: typeof AuthenticatedNextSettingsOrganizationUsersImporterRoute
  AuthenticatedNextTemplatesEmailEmailTemplateIdEditRoute: typeof AuthenticatedNextTemplatesEmailEmailTemplateIdEditRoute
  AuthenticatedNextTemplatesManufacturingActivitiesCreateRoute: typeof AuthenticatedNextTemplatesManufacturingActivitiesCreateRoute
  AuthenticatedNextTemplatesManufacturingDriversCreateRoute: typeof AuthenticatedNextTemplatesManufacturingDriversCreateRoute
  AuthenticatedNextTemplatesManufacturingExpensesCreateRoute: typeof AuthenticatedNextTemplatesManufacturingExpensesCreateRoute
  AuthenticatedNextTemplatesManufacturingResourcesCreateRoute: typeof AuthenticatedNextTemplatesManufacturingResourcesCreateRoute
  AuthenticatedNextTemplatesManufacturingTemplatesChar123TemplateIdChar125Route: typeof AuthenticatedNextTemplatesManufacturingTemplatesChar123TemplateIdChar125Route
  AuthenticatedNextTemplatesQuotationBuilderChar123TemplateIdChar125Route: typeof AuthenticatedNextTemplatesQuotationBuilderChar123TemplateIdChar125Route
  AuthenticatedNextTemplatesQuoteRequestQuoteRequestTemplateIdEditRoute: typeof AuthenticatedNextTemplatesQuoteRequestQuoteRequestTemplateIdEditRoute
  AuthenticatedNextTemplatesSourcingSourcingTemplateIdDuplicateRoute: typeof AuthenticatedNextTemplatesSourcingSourcingTemplateIdDuplicateRoute
  AuthenticatedNextTemplatesSourcingSourcingTemplateIdEditRoute: typeof AuthenticatedNextTemplatesSourcingSourcingTemplateIdEditRoute
  AuthenticatedNextTemplatesManufacturingActivitiesIndexRoute: typeof AuthenticatedNextTemplatesManufacturingActivitiesIndexRoute
  AuthenticatedNextTemplatesManufacturingDriversIndexRoute: typeof AuthenticatedNextTemplatesManufacturingDriversIndexRoute
  AuthenticatedNextTemplatesManufacturingExpensesIndexRoute: typeof AuthenticatedNextTemplatesManufacturingExpensesIndexRoute
  AuthenticatedNextTemplatesManufacturingResourcesIndexRoute: typeof AuthenticatedNextTemplatesManufacturingResourcesIndexRoute
  AuthenticatedNextComponentsIpnOffersOfferIdDuplicateRoute: typeof AuthenticatedNextComponentsIpnOffersOfferIdDuplicateRoute
  AuthenticatedNextComponentsIpnOffersOfferIdEditRoute: typeof AuthenticatedNextComponentsIpnOffersOfferIdEditRoute
  AuthenticatedNextTemplatesFlexibleCalculationAppsAppIdWidgetIdRoute: typeof AuthenticatedNextTemplatesFlexibleCalculationAppsAppIdWidgetIdRoute
  AuthenticatedNextTemplatesFlexibleCalculationReviewConversionLegacyTemplateIdFlexibleCalculationTemplateIdRoute: typeof AuthenticatedNextTemplatesFlexibleCalculationReviewConversionLegacyTemplateIdFlexibleCalculationTemplateIdRoute
  AuthenticatedNextTemplatesManufacturingActivitiesActivityIdDuplicateRoute: typeof AuthenticatedNextTemplatesManufacturingActivitiesActivityIdDuplicateRoute
  AuthenticatedNextTemplatesManufacturingActivitiesActivityIdEditRoute: typeof AuthenticatedNextTemplatesManufacturingActivitiesActivityIdEditRoute
  AuthenticatedNextTemplatesManufacturingAppsAppIdWidgetIdRoute: typeof AuthenticatedNextTemplatesManufacturingAppsAppIdWidgetIdRoute
  AuthenticatedNextTemplatesManufacturingDriversDriverIdDuplicateRoute: typeof AuthenticatedNextTemplatesManufacturingDriversDriverIdDuplicateRoute
  AuthenticatedNextTemplatesManufacturingDriversDriverIdEditRoute: typeof AuthenticatedNextTemplatesManufacturingDriversDriverIdEditRoute
  AuthenticatedNextTemplatesManufacturingExpensesExpenseIdDuplicateRoute: typeof AuthenticatedNextTemplatesManufacturingExpensesExpenseIdDuplicateRoute
  AuthenticatedNextTemplatesManufacturingExpensesExpenseIdEditRoute: typeof AuthenticatedNextTemplatesManufacturingExpensesExpenseIdEditRoute
  AuthenticatedNextTemplatesManufacturingResourcesResourceIdDuplicateRoute: typeof AuthenticatedNextTemplatesManufacturingResourcesResourceIdDuplicateRoute
  AuthenticatedNextTemplatesManufacturingResourcesResourceIdEditRoute: typeof AuthenticatedNextTemplatesManufacturingResourcesResourceIdEditRoute
  AuthenticatedNextSettingsOrganizationPcbPanelPreferencesIndexRoute: typeof AuthenticatedNextSettingsOrganizationPcbPanelPreferencesIndexRoute
  AuthenticatedNextNegotiationsNegotiationIdScenariosSourcingScenarioIdLineItemsSourcingLineItemIdRoute: typeof AuthenticatedNextNegotiationsNegotiationIdScenariosSourcingScenarioIdLineItemsSourcingLineItemIdRoute
}

const AuthenticatedNextRouteRouteChildren: AuthenticatedNextRouteRouteChildren =
  {
    AuthenticatedNextSplatRoute: AuthenticatedNextSplatRoute,
    AuthenticatedNextAlertsRoute: AuthenticatedNextAlertsRoute,
    AuthenticatedNextHomeRoute: AuthenticatedNextHomeRoute,
    AuthenticatedNextLumiAgentRoute: AuthenticatedNextLumiAgentRoute,
    AuthenticatedNextPurchaseOrdersRoute: AuthenticatedNextPurchaseOrdersRoute,
    AuthenticatedNextIndexRoute: AuthenticatedNextIndexRoute,
    AuthenticatedNextPartsPartIdRouteRoute:
      AuthenticatedNextPartsPartIdRouteRouteWithChildren,
    AuthenticatedNextProjectsProjectIdRouteRoute:
      AuthenticatedNextProjectsProjectIdRouteRouteWithChildren,
    AuthenticatedNextSettingsMenuRouteRoute:
      AuthenticatedNextSettingsMenuRouteRouteWithChildren,
    AuthenticatedNextAppsSplatRoute: AuthenticatedNextAppsSplatRoute,
    AuthenticatedNextComponentsLinkingRoute:
      AuthenticatedNextComponentsLinkingRoute,
    AuthenticatedNextCustomersCustomerIdRoute:
      AuthenticatedNextCustomersCustomerIdRoute,
    AuthenticatedNextDemandsImporterRoute:
      AuthenticatedNextDemandsImporterRoute,
    AuthenticatedNextManufacturersManufacturerIdRoute:
      AuthenticatedNextManufacturersManufacturerIdRoute,
    AuthenticatedNextManufacturersLineCardRoute:
      AuthenticatedNextManufacturersLineCardRoute,
    AuthenticatedNextNegotiationsCreateRoute:
      AuthenticatedNextNegotiationsCreateRoute,
    AuthenticatedNextOfferImportsOfferImportIdRoute:
      AuthenticatedNextOfferImportsOfferImportIdRoute,
    AuthenticatedNextOrdersUploadRoute: AuthenticatedNextOrdersUploadRoute,
    AuthenticatedNextOrdersChar123OrderIdChar125Route:
      AuthenticatedNextOrdersChar123OrderIdChar125Route,
    AuthenticatedNextPartsSearchRoute: AuthenticatedNextPartsSearchRoute,
    AuthenticatedNextProjectsCreateRoute: AuthenticatedNextProjectsCreateRoute,
    AuthenticatedNextQuoteRequestsImporterRoute:
      AuthenticatedNextQuoteRequestsImporterRoute,
    AuthenticatedNextRiskManagementGeoRiskRoute:
      AuthenticatedNextRiskManagementGeoRiskRoute,
    AuthenticatedNextRiskManagementPcnsRoute:
      AuthenticatedNextRiskManagementPcnsRoute,
    AuthenticatedNextRiskManagementRiskDigestRoute:
      AuthenticatedNextRiskManagementRiskDigestRoute,
    AuthenticatedNextSettingsCompanyRoute:
      AuthenticatedNextSettingsCompanyRoute,
    AuthenticatedNextSuppliersSupplierAndStockLocationIdRoute:
      AuthenticatedNextSuppliersSupplierAndStockLocationIdRoute,
    AuthenticatedNextSuppliersStrategyRoute:
      AuthenticatedNextSuppliersStrategyRoute,
    AuthenticatedNextTemplatesExportRoute:
      AuthenticatedNextTemplatesExportRoute,
    AuthenticatedNextTemplatesPcbSpecificationRoute:
      AuthenticatedNextTemplatesPcbSpecificationRoute,
    AuthenticatedNextAssembliesIndexRoute:
      AuthenticatedNextAssembliesIndexRoute,
    AuthenticatedNextComponentsIndexRoute:
      AuthenticatedNextComponentsIndexRoute,
    AuthenticatedNextCustomersIndexRoute: AuthenticatedNextCustomersIndexRoute,
    AuthenticatedNextDemandsIndexRoute: AuthenticatedNextDemandsIndexRoute,
    AuthenticatedNextManufacturersIndexRoute:
      AuthenticatedNextManufacturersIndexRoute,
    AuthenticatedNextNegotiationsIndexRoute:
      AuthenticatedNextNegotiationsIndexRoute,
    AuthenticatedNextOfferImportsIndexRoute:
      AuthenticatedNextOfferImportsIndexRoute,
    AuthenticatedNextPartsIndexRoute: AuthenticatedNextPartsIndexRoute,
    AuthenticatedNextProjectsIndexRoute: AuthenticatedNextProjectsIndexRoute,
    AuthenticatedNextQuoteRequestsIndexRoute:
      AuthenticatedNextQuoteRequestsIndexRoute,
    AuthenticatedNextRiskManagementIndexRoute:
      AuthenticatedNextRiskManagementIndexRoute,
    AuthenticatedNextSettingsIndexRoute: AuthenticatedNextSettingsIndexRoute,
    AuthenticatedNextSuppliersIndexRoute: AuthenticatedNextSuppliersIndexRoute,
    AuthenticatedNextAssembliesAssemblyIdPcbRouteRoute:
      AuthenticatedNextAssembliesAssemblyIdPcbRouteRouteWithChildren,
    AuthenticatedNextComponentsIpnDetailsRouteRoute:
      AuthenticatedNextComponentsIpnDetailsRouteRouteWithChildren,
    AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRoute:
      AuthenticatedNextNegotiationsNegotiationIdSidebarRouteRouteWithChildren,
    AuthenticatedNextPartsCustomCustomPartSpecificationIdRouteRoute:
      AuthenticatedNextPartsCustomCustomPartSpecificationIdRouteRouteWithChildren,
    AuthenticatedNextAssembliesAssemblyIdDashboardRoute:
      AuthenticatedNextAssembliesAssemblyIdDashboardRoute,
    AuthenticatedNextAssembliesAssemblyIdDetailsRoute:
      AuthenticatedNextAssembliesAssemblyIdDetailsRoute,
    AuthenticatedNextAssembliesAssemblyIdEditRoute:
      AuthenticatedNextAssembliesAssemblyIdEditRoute,
    AuthenticatedNextRiskManagementLibraryHealthAssembliesRoute:
      AuthenticatedNextRiskManagementLibraryHealthAssembliesRoute,
    AuthenticatedNextRiskManagementLibraryHealthComponentsRoute:
      AuthenticatedNextRiskManagementLibraryHealthComponentsRoute,
    AuthenticatedNextRiskManagementLibraryHealthPartsRoute:
      AuthenticatedNextRiskManagementLibraryHealthPartsRoute,
    AuthenticatedNextTemplatesEmailCreateRoute:
      AuthenticatedNextTemplatesEmailCreateRoute,
    AuthenticatedNextTemplatesFlexibleCalculationFlexibleCalculationTemplateIdRoute:
      AuthenticatedNextTemplatesFlexibleCalculationFlexibleCalculationTemplateIdRoute,
    AuthenticatedNextTemplatesFlexibleCalculationCreateRoute:
      AuthenticatedNextTemplatesFlexibleCalculationCreateRoute,
    AuthenticatedNextTemplatesFlexibleCalculationExportedVariablesRoute:
      AuthenticatedNextTemplatesFlexibleCalculationExportedVariablesRoute,
    AuthenticatedNextTemplatesQuoteRequestCreateRoute:
      AuthenticatedNextTemplatesQuoteRequestCreateRoute,
    AuthenticatedNextTemplatesSourcingCreateRoute:
      AuthenticatedNextTemplatesSourcingCreateRoute,
    AuthenticatedNextAssembliesAssemblyIdIndexRoute:
      AuthenticatedNextAssembliesAssemblyIdIndexRoute,
    AuthenticatedNextNegotiationsNegotiationIdIndexRoute:
      AuthenticatedNextNegotiationsNegotiationIdIndexRoute,
    AuthenticatedNextRiskManagementLibraryHealthIndexRoute:
      AuthenticatedNextRiskManagementLibraryHealthIndexRoute,
    AuthenticatedNextSuppliersSupplierContactsIndexRoute:
      AuthenticatedNextSuppliersSupplierContactsIndexRoute,
    AuthenticatedNextTemplatesEmailIndexRoute:
      AuthenticatedNextTemplatesEmailIndexRoute,
    AuthenticatedNextTemplatesFlexibleCalculationIndexRoute:
      AuthenticatedNextTemplatesFlexibleCalculationIndexRoute,
    AuthenticatedNextTemplatesQuotationIndexRoute:
      AuthenticatedNextTemplatesQuotationIndexRoute,
    AuthenticatedNextTemplatesQuoteRequestIndexRoute:
      AuthenticatedNextTemplatesQuoteRequestIndexRoute,
    AuthenticatedNextTemplatesSourcingIndexRoute:
      AuthenticatedNextTemplatesSourcingIndexRoute,
    AuthenticatedNextAssembliesAssemblyIdSubassembliesCreateRoute:
      AuthenticatedNextAssembliesAssemblyIdSubassembliesCreateRoute,
    AuthenticatedNextPartsOffersOfferIdDuplicateRoute:
      AuthenticatedNextPartsOffersOfferIdDuplicateRoute,
    AuthenticatedNextPartsOffersOfferIdEditRoute:
      AuthenticatedNextPartsOffersOfferIdEditRoute,
    AuthenticatedNextSettingsOrganizationUsersImporterRoute:
      AuthenticatedNextSettingsOrganizationUsersImporterRoute,
    AuthenticatedNextTemplatesEmailEmailTemplateIdEditRoute:
      AuthenticatedNextTemplatesEmailEmailTemplateIdEditRoute,
    AuthenticatedNextTemplatesManufacturingActivitiesCreateRoute:
      AuthenticatedNextTemplatesManufacturingActivitiesCreateRoute,
    AuthenticatedNextTemplatesManufacturingDriversCreateRoute:
      AuthenticatedNextTemplatesManufacturingDriversCreateRoute,
    AuthenticatedNextTemplatesManufacturingExpensesCreateRoute:
      AuthenticatedNextTemplatesManufacturingExpensesCreateRoute,
    AuthenticatedNextTemplatesManufacturingResourcesCreateRoute:
      AuthenticatedNextTemplatesManufacturingResourcesCreateRoute,
    AuthenticatedNextTemplatesManufacturingTemplatesChar123TemplateIdChar125Route:
      AuthenticatedNextTemplatesManufacturingTemplatesChar123TemplateIdChar125Route,
    AuthenticatedNextTemplatesQuotationBuilderChar123TemplateIdChar125Route:
      AuthenticatedNextTemplatesQuotationBuilderChar123TemplateIdChar125Route,
    AuthenticatedNextTemplatesQuoteRequestQuoteRequestTemplateIdEditRoute:
      AuthenticatedNextTemplatesQuoteRequestQuoteRequestTemplateIdEditRoute,
    AuthenticatedNextTemplatesSourcingSourcingTemplateIdDuplicateRoute:
      AuthenticatedNextTemplatesSourcingSourcingTemplateIdDuplicateRoute,
    AuthenticatedNextTemplatesSourcingSourcingTemplateIdEditRoute:
      AuthenticatedNextTemplatesSourcingSourcingTemplateIdEditRoute,
    AuthenticatedNextTemplatesManufacturingActivitiesIndexRoute:
      AuthenticatedNextTemplatesManufacturingActivitiesIndexRoute,
    AuthenticatedNextTemplatesManufacturingDriversIndexRoute:
      AuthenticatedNextTemplatesManufacturingDriversIndexRoute,
    AuthenticatedNextTemplatesManufacturingExpensesIndexRoute:
      AuthenticatedNextTemplatesManufacturingExpensesIndexRoute,
    AuthenticatedNextTemplatesManufacturingResourcesIndexRoute:
      AuthenticatedNextTemplatesManufacturingResourcesIndexRoute,
    AuthenticatedNextComponentsIpnOffersOfferIdDuplicateRoute:
      AuthenticatedNextComponentsIpnOffersOfferIdDuplicateRoute,
    AuthenticatedNextComponentsIpnOffersOfferIdEditRoute:
      AuthenticatedNextComponentsIpnOffersOfferIdEditRoute,
    AuthenticatedNextTemplatesFlexibleCalculationAppsAppIdWidgetIdRoute:
      AuthenticatedNextTemplatesFlexibleCalculationAppsAppIdWidgetIdRoute,
    AuthenticatedNextTemplatesFlexibleCalculationReviewConversionLegacyTemplateIdFlexibleCalculationTemplateIdRoute:
      AuthenticatedNextTemplatesFlexibleCalculationReviewConversionLegacyTemplateIdFlexibleCalculationTemplateIdRoute,
    AuthenticatedNextTemplatesManufacturingActivitiesActivityIdDuplicateRoute:
      AuthenticatedNextTemplatesManufacturingActivitiesActivityIdDuplicateRoute,
    AuthenticatedNextTemplatesManufacturingActivitiesActivityIdEditRoute:
      AuthenticatedNextTemplatesManufacturingActivitiesActivityIdEditRoute,
    AuthenticatedNextTemplatesManufacturingAppsAppIdWidgetIdRoute:
      AuthenticatedNextTemplatesManufacturingAppsAppIdWidgetIdRoute,
    AuthenticatedNextTemplatesManufacturingDriversDriverIdDuplicateRoute:
      AuthenticatedNextTemplatesManufacturingDriversDriverIdDuplicateRoute,
    AuthenticatedNextTemplatesManufacturingDriversDriverIdEditRoute:
      AuthenticatedNextTemplatesManufacturingDriversDriverIdEditRoute,
    AuthenticatedNextTemplatesManufacturingExpensesExpenseIdDuplicateRoute:
      AuthenticatedNextTemplatesManufacturingExpensesExpenseIdDuplicateRoute,
    AuthenticatedNextTemplatesManufacturingExpensesExpenseIdEditRoute:
      AuthenticatedNextTemplatesManufacturingExpensesExpenseIdEditRoute,
    AuthenticatedNextTemplatesManufacturingResourcesResourceIdDuplicateRoute:
      AuthenticatedNextTemplatesManufacturingResourcesResourceIdDuplicateRoute,
    AuthenticatedNextTemplatesManufacturingResourcesResourceIdEditRoute:
      AuthenticatedNextTemplatesManufacturingResourcesResourceIdEditRoute,
    AuthenticatedNextSettingsOrganizationPcbPanelPreferencesIndexRoute:
      AuthenticatedNextSettingsOrganizationPcbPanelPreferencesIndexRoute,
    AuthenticatedNextNegotiationsNegotiationIdScenariosSourcingScenarioIdLineItemsSourcingLineItemIdRoute:
      AuthenticatedNextNegotiationsNegotiationIdScenariosSourcingScenarioIdLineItemsSourcingLineItemIdRoute,
  }

const AuthenticatedNextRouteRouteWithChildren =
  AuthenticatedNextRouteRoute._addFileChildren(
    AuthenticatedNextRouteRouteChildren,
  )

interface AuthenticatedRiskManagementRouteRouteChildren {
  AuthenticatedRiskManagementGeoRiskRoute: typeof AuthenticatedRiskManagementGeoRiskRoute
  AuthenticatedRiskManagementPcnsRoute: typeof AuthenticatedRiskManagementPcnsRoute
  AuthenticatedRiskManagementRiskDigestRoute: typeof AuthenticatedRiskManagementRiskDigestRoute
  AuthenticatedRiskManagementIndexRoute: typeof AuthenticatedRiskManagementIndexRoute
  AuthenticatedRiskManagementLibraryHealthAssembliesRoute: typeof AuthenticatedRiskManagementLibraryHealthAssembliesRoute
  AuthenticatedRiskManagementLibraryHealthComponentsRoute: typeof AuthenticatedRiskManagementLibraryHealthComponentsRoute
  AuthenticatedRiskManagementLibraryHealthPartsRoute: typeof AuthenticatedRiskManagementLibraryHealthPartsRoute
  AuthenticatedRiskManagementLibraryHealthIndexRoute: typeof AuthenticatedRiskManagementLibraryHealthIndexRoute
}

const AuthenticatedRiskManagementRouteRouteChildren: AuthenticatedRiskManagementRouteRouteChildren =
  {
    AuthenticatedRiskManagementGeoRiskRoute:
      AuthenticatedRiskManagementGeoRiskRoute,
    AuthenticatedRiskManagementPcnsRoute: AuthenticatedRiskManagementPcnsRoute,
    AuthenticatedRiskManagementRiskDigestRoute:
      AuthenticatedRiskManagementRiskDigestRoute,
    AuthenticatedRiskManagementIndexRoute:
      AuthenticatedRiskManagementIndexRoute,
    AuthenticatedRiskManagementLibraryHealthAssembliesRoute:
      AuthenticatedRiskManagementLibraryHealthAssembliesRoute,
    AuthenticatedRiskManagementLibraryHealthComponentsRoute:
      AuthenticatedRiskManagementLibraryHealthComponentsRoute,
    AuthenticatedRiskManagementLibraryHealthPartsRoute:
      AuthenticatedRiskManagementLibraryHealthPartsRoute,
    AuthenticatedRiskManagementLibraryHealthIndexRoute:
      AuthenticatedRiskManagementLibraryHealthIndexRoute,
  }

const AuthenticatedRiskManagementRouteRouteWithChildren =
  AuthenticatedRiskManagementRouteRoute._addFileChildren(
    AuthenticatedRiskManagementRouteRouteChildren,
  )

interface AuthenticatedManufacturersSidebarRouteRouteChildren {
  AuthenticatedManufacturersSidebarLineCardRoute: typeof AuthenticatedManufacturersSidebarLineCardRoute
  AuthenticatedManufacturersSidebarIndexRoute: typeof AuthenticatedManufacturersSidebarIndexRoute
}

const AuthenticatedManufacturersSidebarRouteRouteChildren: AuthenticatedManufacturersSidebarRouteRouteChildren =
  {
    AuthenticatedManufacturersSidebarLineCardRoute:
      AuthenticatedManufacturersSidebarLineCardRoute,
    AuthenticatedManufacturersSidebarIndexRoute:
      AuthenticatedManufacturersSidebarIndexRoute,
  }

const AuthenticatedManufacturersSidebarRouteRouteWithChildren =
  AuthenticatedManufacturersSidebarRouteRoute._addFileChildren(
    AuthenticatedManufacturersSidebarRouteRouteChildren,
  )

interface AuthenticatedManufacturingSidebarRouteRouteChildren {
  AuthenticatedManufacturingSidebarTemplatesChar123TemplateIdChar125Route: typeof AuthenticatedManufacturingSidebarTemplatesChar123TemplateIdChar125Route
  AuthenticatedManufacturingSidebarActivitiesIndexRoute: typeof AuthenticatedManufacturingSidebarActivitiesIndexRoute
  AuthenticatedManufacturingSidebarDriversIndexRoute: typeof AuthenticatedManufacturingSidebarDriversIndexRoute
  AuthenticatedManufacturingSidebarExpensesIndexRoute: typeof AuthenticatedManufacturingSidebarExpensesIndexRoute
  AuthenticatedManufacturingSidebarResourcesIndexRoute: typeof AuthenticatedManufacturingSidebarResourcesIndexRoute
  AuthenticatedManufacturingSidebarAppsAppIdWidgetIdRoute: typeof AuthenticatedManufacturingSidebarAppsAppIdWidgetIdRoute
}

const AuthenticatedManufacturingSidebarRouteRouteChildren: AuthenticatedManufacturingSidebarRouteRouteChildren =
  {
    AuthenticatedManufacturingSidebarTemplatesChar123TemplateIdChar125Route:
      AuthenticatedManufacturingSidebarTemplatesChar123TemplateIdChar125Route,
    AuthenticatedManufacturingSidebarActivitiesIndexRoute:
      AuthenticatedManufacturingSidebarActivitiesIndexRoute,
    AuthenticatedManufacturingSidebarDriversIndexRoute:
      AuthenticatedManufacturingSidebarDriversIndexRoute,
    AuthenticatedManufacturingSidebarExpensesIndexRoute:
      AuthenticatedManufacturingSidebarExpensesIndexRoute,
    AuthenticatedManufacturingSidebarResourcesIndexRoute:
      AuthenticatedManufacturingSidebarResourcesIndexRoute,
    AuthenticatedManufacturingSidebarAppsAppIdWidgetIdRoute:
      AuthenticatedManufacturingSidebarAppsAppIdWidgetIdRoute,
  }

const AuthenticatedManufacturingSidebarRouteRouteWithChildren =
  AuthenticatedManufacturingSidebarRouteRoute._addFileChildren(
    AuthenticatedManufacturingSidebarRouteRouteChildren,
  )

interface AuthenticatedPartsSidebarRouteRouteChildren {
  AuthenticatedPartsSidebarAlertsRoute: typeof AuthenticatedPartsSidebarAlertsRoute
  AuthenticatedPartsSidebarSearchRoute: typeof AuthenticatedPartsSidebarSearchRoute
  AuthenticatedPartsSidebarDemandsImporterRoute: typeof AuthenticatedPartsSidebarDemandsImporterRoute
  AuthenticatedPartsSidebarComponentsIndexRoute: typeof AuthenticatedPartsSidebarComponentsIndexRoute
  AuthenticatedPartsSidebarDemandsIndexRoute: typeof AuthenticatedPartsSidebarDemandsIndexRoute
  AuthenticatedPartsSidebarQuoteRequestsIndexRoute: typeof AuthenticatedPartsSidebarQuoteRequestsIndexRoute
}

const AuthenticatedPartsSidebarRouteRouteChildren: AuthenticatedPartsSidebarRouteRouteChildren =
  {
    AuthenticatedPartsSidebarAlertsRoute: AuthenticatedPartsSidebarAlertsRoute,
    AuthenticatedPartsSidebarSearchRoute: AuthenticatedPartsSidebarSearchRoute,
    AuthenticatedPartsSidebarDemandsImporterRoute:
      AuthenticatedPartsSidebarDemandsImporterRoute,
    AuthenticatedPartsSidebarComponentsIndexRoute:
      AuthenticatedPartsSidebarComponentsIndexRoute,
    AuthenticatedPartsSidebarDemandsIndexRoute:
      AuthenticatedPartsSidebarDemandsIndexRoute,
    AuthenticatedPartsSidebarQuoteRequestsIndexRoute:
      AuthenticatedPartsSidebarQuoteRequestsIndexRoute,
  }

const AuthenticatedPartsSidebarRouteRouteWithChildren =
  AuthenticatedPartsSidebarRouteRoute._addFileChildren(
    AuthenticatedPartsSidebarRouteRouteChildren,
  )

interface AuthenticatedSettingsMenuRouteRouteChildren {
  AuthenticatedSettingsMenuOrganizationApiIntegrationRoute: typeof AuthenticatedSettingsMenuOrganizationApiIntegrationRoute
  AuthenticatedSettingsMenuOrganizationAssemblySettingsRoute: typeof AuthenticatedSettingsMenuOrganizationAssemblySettingsRoute
  AuthenticatedSettingsMenuOrganizationAutomaticRfqNumberRoute: typeof AuthenticatedSettingsMenuOrganizationAutomaticRfqNumberRoute
  AuthenticatedSettingsMenuOrganizationBrandingRoute: typeof AuthenticatedSettingsMenuOrganizationBrandingRoute
  AuthenticatedSettingsMenuOrganizationCarbonFootprintsRoute: typeof AuthenticatedSettingsMenuOrganizationCarbonFootprintsRoute
  AuthenticatedSettingsMenuOrganizationComponentSettingsRoute: typeof AuthenticatedSettingsMenuOrganizationComponentSettingsRoute
  AuthenticatedSettingsMenuOrganizationCsvIntegrationRoute: typeof AuthenticatedSettingsMenuOrganizationCsvIntegrationRoute
  AuthenticatedSettingsMenuOrganizationCustomPartCategoriesRoute: typeof AuthenticatedSettingsMenuOrganizationCustomPartCategoriesRoute
  AuthenticatedSettingsMenuOrganizationDataIntegrationsRoute: typeof AuthenticatedSettingsMenuOrganizationDataIntegrationsRoute
  AuthenticatedSettingsMenuOrganizationFeatureFlagsRoute: typeof AuthenticatedSettingsMenuOrganizationFeatureFlagsRoute
  AuthenticatedSettingsMenuOrganizationManufacturerPreferencesRoute: typeof AuthenticatedSettingsMenuOrganizationManufacturerPreferencesRoute
  AuthenticatedSettingsMenuOrganizationSitesRoute: typeof AuthenticatedSettingsMenuOrganizationSitesRoute
  AuthenticatedSettingsMenuOrganizationSupplierApiIntegrationsRoute: typeof AuthenticatedSettingsMenuOrganizationSupplierApiIntegrationsRoute
  AuthenticatedSettingsMenuUserAccountSecurityRoute: typeof AuthenticatedSettingsMenuUserAccountSecurityRoute
  AuthenticatedSettingsMenuOrganizationIndexRoute: typeof AuthenticatedSettingsMenuOrganizationIndexRoute
  AuthenticatedSettingsMenuOrganizationCustomerPortalAdditionalServicesRoute: typeof AuthenticatedSettingsMenuOrganizationCustomerPortalAdditionalServicesRoute
  AuthenticatedSettingsMenuOrganizationCustomerPortalCheckoutConditionsRoute: typeof AuthenticatedSettingsMenuOrganizationCustomerPortalCheckoutConditionsRoute
  AuthenticatedSettingsMenuOrganizationCustomerPortalCustomerSpecificSettingsRoute: typeof AuthenticatedSettingsMenuOrganizationCustomerPortalCustomerSpecificSettingsRoute
  AuthenticatedSettingsMenuOrganizationCustomerPortalLandingPageRoute: typeof AuthenticatedSettingsMenuOrganizationCustomerPortalLandingPageRoute
  AuthenticatedSettingsMenuOrganizationCustomerPortalPaymentCredentialsRoute: typeof AuthenticatedSettingsMenuOrganizationCustomerPortalPaymentCredentialsRoute
  AuthenticatedSettingsMenuOrganizationUserManagementActionPermissionsRoute: typeof AuthenticatedSettingsMenuOrganizationUserManagementActionPermissionsRoute
  AuthenticatedSettingsMenuOrganizationUserManagementRolesRoute: typeof AuthenticatedSettingsMenuOrganizationUserManagementRolesRoute
  AuthenticatedSettingsMenuOrganizationCustomerPortalIndexRoute: typeof AuthenticatedSettingsMenuOrganizationCustomerPortalIndexRoute
  AuthenticatedSettingsMenuOrganizationPcbIndexRoute: typeof AuthenticatedSettingsMenuOrganizationPcbIndexRoute
  AuthenticatedSettingsMenuOrganizationUsersIndexRoute: typeof AuthenticatedSettingsMenuOrganizationUsersIndexRoute
  AuthenticatedSettingsMenuOrganizationPcbPanelPreferencesCreateRoute: typeof AuthenticatedSettingsMenuOrganizationPcbPanelPreferencesCreateRoute
  AuthenticatedSettingsMenuOrganizationPcbPanelPreferencesPanelPreferenceIdEditRoute: typeof AuthenticatedSettingsMenuOrganizationPcbPanelPreferencesPanelPreferenceIdEditRoute
}

const AuthenticatedSettingsMenuRouteRouteChildren: AuthenticatedSettingsMenuRouteRouteChildren =
  {
    AuthenticatedSettingsMenuOrganizationApiIntegrationRoute:
      AuthenticatedSettingsMenuOrganizationApiIntegrationRoute,
    AuthenticatedSettingsMenuOrganizationAssemblySettingsRoute:
      AuthenticatedSettingsMenuOrganizationAssemblySettingsRoute,
    AuthenticatedSettingsMenuOrganizationAutomaticRfqNumberRoute:
      AuthenticatedSettingsMenuOrganizationAutomaticRfqNumberRoute,
    AuthenticatedSettingsMenuOrganizationBrandingRoute:
      AuthenticatedSettingsMenuOrganizationBrandingRoute,
    AuthenticatedSettingsMenuOrganizationCarbonFootprintsRoute:
      AuthenticatedSettingsMenuOrganizationCarbonFootprintsRoute,
    AuthenticatedSettingsMenuOrganizationComponentSettingsRoute:
      AuthenticatedSettingsMenuOrganizationComponentSettingsRoute,
    AuthenticatedSettingsMenuOrganizationCsvIntegrationRoute:
      AuthenticatedSettingsMenuOrganizationCsvIntegrationRoute,
    AuthenticatedSettingsMenuOrganizationCustomPartCategoriesRoute:
      AuthenticatedSettingsMenuOrganizationCustomPartCategoriesRoute,
    AuthenticatedSettingsMenuOrganizationDataIntegrationsRoute:
      AuthenticatedSettingsMenuOrganizationDataIntegrationsRoute,
    AuthenticatedSettingsMenuOrganizationFeatureFlagsRoute:
      AuthenticatedSettingsMenuOrganizationFeatureFlagsRoute,
    AuthenticatedSettingsMenuOrganizationManufacturerPreferencesRoute:
      AuthenticatedSettingsMenuOrganizationManufacturerPreferencesRoute,
    AuthenticatedSettingsMenuOrganizationSitesRoute:
      AuthenticatedSettingsMenuOrganizationSitesRoute,
    AuthenticatedSettingsMenuOrganizationSupplierApiIntegrationsRoute:
      AuthenticatedSettingsMenuOrganizationSupplierApiIntegrationsRoute,
    AuthenticatedSettingsMenuUserAccountSecurityRoute:
      AuthenticatedSettingsMenuUserAccountSecurityRoute,
    AuthenticatedSettingsMenuOrganizationIndexRoute:
      AuthenticatedSettingsMenuOrganizationIndexRoute,
    AuthenticatedSettingsMenuOrganizationCustomerPortalAdditionalServicesRoute:
      AuthenticatedSettingsMenuOrganizationCustomerPortalAdditionalServicesRoute,
    AuthenticatedSettingsMenuOrganizationCustomerPortalCheckoutConditionsRoute:
      AuthenticatedSettingsMenuOrganizationCustomerPortalCheckoutConditionsRoute,
    AuthenticatedSettingsMenuOrganizationCustomerPortalCustomerSpecificSettingsRoute:
      AuthenticatedSettingsMenuOrganizationCustomerPortalCustomerSpecificSettingsRoute,
    AuthenticatedSettingsMenuOrganizationCustomerPortalLandingPageRoute:
      AuthenticatedSettingsMenuOrganizationCustomerPortalLandingPageRoute,
    AuthenticatedSettingsMenuOrganizationCustomerPortalPaymentCredentialsRoute:
      AuthenticatedSettingsMenuOrganizationCustomerPortalPaymentCredentialsRoute,
    AuthenticatedSettingsMenuOrganizationUserManagementActionPermissionsRoute:
      AuthenticatedSettingsMenuOrganizationUserManagementActionPermissionsRoute,
    AuthenticatedSettingsMenuOrganizationUserManagementRolesRoute:
      AuthenticatedSettingsMenuOrganizationUserManagementRolesRoute,
    AuthenticatedSettingsMenuOrganizationCustomerPortalIndexRoute:
      AuthenticatedSettingsMenuOrganizationCustomerPortalIndexRoute,
    AuthenticatedSettingsMenuOrganizationPcbIndexRoute:
      AuthenticatedSettingsMenuOrganizationPcbIndexRoute,
    AuthenticatedSettingsMenuOrganizationUsersIndexRoute:
      AuthenticatedSettingsMenuOrganizationUsersIndexRoute,
    AuthenticatedSettingsMenuOrganizationPcbPanelPreferencesCreateRoute:
      AuthenticatedSettingsMenuOrganizationPcbPanelPreferencesCreateRoute,
    AuthenticatedSettingsMenuOrganizationPcbPanelPreferencesPanelPreferenceIdEditRoute:
      AuthenticatedSettingsMenuOrganizationPcbPanelPreferencesPanelPreferenceIdEditRoute,
  }

const AuthenticatedSettingsMenuRouteRouteWithChildren =
  AuthenticatedSettingsMenuRouteRoute._addFileChildren(
    AuthenticatedSettingsMenuRouteRouteChildren,
  )

interface AuthenticatedSuppliersSidebarRouteRouteChildren {
  AuthenticatedSuppliersSidebarStrategyRoute: typeof AuthenticatedSuppliersSidebarStrategyRoute
  AuthenticatedSuppliersSidebarIndexRoute: typeof AuthenticatedSuppliersSidebarIndexRoute
  AuthenticatedSuppliersSidebarSupplierContactsIndexRoute: typeof AuthenticatedSuppliersSidebarSupplierContactsIndexRoute
}

const AuthenticatedSuppliersSidebarRouteRouteChildren: AuthenticatedSuppliersSidebarRouteRouteChildren =
  {
    AuthenticatedSuppliersSidebarStrategyRoute:
      AuthenticatedSuppliersSidebarStrategyRoute,
    AuthenticatedSuppliersSidebarIndexRoute:
      AuthenticatedSuppliersSidebarIndexRoute,
    AuthenticatedSuppliersSidebarSupplierContactsIndexRoute:
      AuthenticatedSuppliersSidebarSupplierContactsIndexRoute,
  }

const AuthenticatedSuppliersSidebarRouteRouteWithChildren =
  AuthenticatedSuppliersSidebarRouteRoute._addFileChildren(
    AuthenticatedSuppliersSidebarRouteRouteChildren,
  )

interface AuthenticatedTemplatesSidebarRouteRouteChildren {
  AuthenticatedTemplatesSidebarExportRoute: typeof AuthenticatedTemplatesSidebarExportRoute
  AuthenticatedTemplatesSidebarPcbSpecificationRoute: typeof AuthenticatedTemplatesSidebarPcbSpecificationRoute
  AuthenticatedTemplatesSidebarEmailCreateRoute: typeof AuthenticatedTemplatesSidebarEmailCreateRoute
  AuthenticatedTemplatesSidebarFlexibleCalculationFlexibleCalculationTemplateIdRoute: typeof AuthenticatedTemplatesSidebarFlexibleCalculationFlexibleCalculationTemplateIdRoute
  AuthenticatedTemplatesSidebarFlexibleCalculationCreateRoute: typeof AuthenticatedTemplatesSidebarFlexibleCalculationCreateRoute
  AuthenticatedTemplatesSidebarFlexibleCalculationExportedVariablesRoute: typeof AuthenticatedTemplatesSidebarFlexibleCalculationExportedVariablesRoute
  AuthenticatedTemplatesSidebarQuoteRequestCreateRoute: typeof AuthenticatedTemplatesSidebarQuoteRequestCreateRoute
  AuthenticatedTemplatesSidebarSourcingCreateRoute: typeof AuthenticatedTemplatesSidebarSourcingCreateRoute
  AuthenticatedTemplatesSidebarCalculationIndexRoute: typeof AuthenticatedTemplatesSidebarCalculationIndexRoute
  AuthenticatedTemplatesSidebarEmailIndexRoute: typeof AuthenticatedTemplatesSidebarEmailIndexRoute
  AuthenticatedTemplatesSidebarFlexibleCalculationIndexRoute: typeof AuthenticatedTemplatesSidebarFlexibleCalculationIndexRoute
  AuthenticatedTemplatesSidebarQuotationIndexRoute: typeof AuthenticatedTemplatesSidebarQuotationIndexRoute
  AuthenticatedTemplatesSidebarQuoteRequestIndexRoute: typeof AuthenticatedTemplatesSidebarQuoteRequestIndexRoute
  AuthenticatedTemplatesSidebarSourcingIndexRoute: typeof AuthenticatedTemplatesSidebarSourcingIndexRoute
  AuthenticatedTemplatesSidebarEmailEmailTemplateIdEditRoute: typeof AuthenticatedTemplatesSidebarEmailEmailTemplateIdEditRoute
  AuthenticatedTemplatesSidebarQuotationBuilderChar123TemplateIdChar125Route: typeof AuthenticatedTemplatesSidebarQuotationBuilderChar123TemplateIdChar125Route
  AuthenticatedTemplatesSidebarQuoteRequestQuoteRequestTemplateIdEditRoute: typeof AuthenticatedTemplatesSidebarQuoteRequestQuoteRequestTemplateIdEditRoute
  AuthenticatedTemplatesSidebarSourcingSourcingTemplateIdDuplicateRoute: typeof AuthenticatedTemplatesSidebarSourcingSourcingTemplateIdDuplicateRoute
  AuthenticatedTemplatesSidebarSourcingSourcingTemplateIdEditRoute: typeof AuthenticatedTemplatesSidebarSourcingSourcingTemplateIdEditRoute
  AuthenticatedTemplatesSidebarFlexibleCalculationAppsAppIdWidgetIdRoute: typeof AuthenticatedTemplatesSidebarFlexibleCalculationAppsAppIdWidgetIdRoute
  AuthenticatedTemplatesSidebarFlexibleCalculationReviewConversionLegacyTemplateIdFlexibleCalculationTemplateIdRoute: typeof AuthenticatedTemplatesSidebarFlexibleCalculationReviewConversionLegacyTemplateIdFlexibleCalculationTemplateIdRoute
}

const AuthenticatedTemplatesSidebarRouteRouteChildren: AuthenticatedTemplatesSidebarRouteRouteChildren =
  {
    AuthenticatedTemplatesSidebarExportRoute:
      AuthenticatedTemplatesSidebarExportRoute,
    AuthenticatedTemplatesSidebarPcbSpecificationRoute:
      AuthenticatedTemplatesSidebarPcbSpecificationRoute,
    AuthenticatedTemplatesSidebarEmailCreateRoute:
      AuthenticatedTemplatesSidebarEmailCreateRoute,
    AuthenticatedTemplatesSidebarFlexibleCalculationFlexibleCalculationTemplateIdRoute:
      AuthenticatedTemplatesSidebarFlexibleCalculationFlexibleCalculationTemplateIdRoute,
    AuthenticatedTemplatesSidebarFlexibleCalculationCreateRoute:
      AuthenticatedTemplatesSidebarFlexibleCalculationCreateRoute,
    AuthenticatedTemplatesSidebarFlexibleCalculationExportedVariablesRoute:
      AuthenticatedTemplatesSidebarFlexibleCalculationExportedVariablesRoute,
    AuthenticatedTemplatesSidebarQuoteRequestCreateRoute:
      AuthenticatedTemplatesSidebarQuoteRequestCreateRoute,
    AuthenticatedTemplatesSidebarSourcingCreateRoute:
      AuthenticatedTemplatesSidebarSourcingCreateRoute,
    AuthenticatedTemplatesSidebarCalculationIndexRoute:
      AuthenticatedTemplatesSidebarCalculationIndexRoute,
    AuthenticatedTemplatesSidebarEmailIndexRoute:
      AuthenticatedTemplatesSidebarEmailIndexRoute,
    AuthenticatedTemplatesSidebarFlexibleCalculationIndexRoute:
      AuthenticatedTemplatesSidebarFlexibleCalculationIndexRoute,
    AuthenticatedTemplatesSidebarQuotationIndexRoute:
      AuthenticatedTemplatesSidebarQuotationIndexRoute,
    AuthenticatedTemplatesSidebarQuoteRequestIndexRoute:
      AuthenticatedTemplatesSidebarQuoteRequestIndexRoute,
    AuthenticatedTemplatesSidebarSourcingIndexRoute:
      AuthenticatedTemplatesSidebarSourcingIndexRoute,
    AuthenticatedTemplatesSidebarEmailEmailTemplateIdEditRoute:
      AuthenticatedTemplatesSidebarEmailEmailTemplateIdEditRoute,
    AuthenticatedTemplatesSidebarQuotationBuilderChar123TemplateIdChar125Route:
      AuthenticatedTemplatesSidebarQuotationBuilderChar123TemplateIdChar125Route,
    AuthenticatedTemplatesSidebarQuoteRequestQuoteRequestTemplateIdEditRoute:
      AuthenticatedTemplatesSidebarQuoteRequestQuoteRequestTemplateIdEditRoute,
    AuthenticatedTemplatesSidebarSourcingSourcingTemplateIdDuplicateRoute:
      AuthenticatedTemplatesSidebarSourcingSourcingTemplateIdDuplicateRoute,
    AuthenticatedTemplatesSidebarSourcingSourcingTemplateIdEditRoute:
      AuthenticatedTemplatesSidebarSourcingSourcingTemplateIdEditRoute,
    AuthenticatedTemplatesSidebarFlexibleCalculationAppsAppIdWidgetIdRoute:
      AuthenticatedTemplatesSidebarFlexibleCalculationAppsAppIdWidgetIdRoute,
    AuthenticatedTemplatesSidebarFlexibleCalculationReviewConversionLegacyTemplateIdFlexibleCalculationTemplateIdRoute:
      AuthenticatedTemplatesSidebarFlexibleCalculationReviewConversionLegacyTemplateIdFlexibleCalculationTemplateIdRoute,
  }

const AuthenticatedTemplatesSidebarRouteRouteWithChildren =
  AuthenticatedTemplatesSidebarRouteRoute._addFileChildren(
    AuthenticatedTemplatesSidebarRouteRouteChildren,
  )

interface AuthenticatedAssembliesAssemblyIdPcbRouteRouteChildren {
  AuthenticatedAssembliesAssemblyIdPcbCadViewerRoute: typeof AuthenticatedAssembliesAssemblyIdPcbCadViewerRoute
  AuthenticatedAssembliesAssemblyIdPcbDfmRoute: typeof AuthenticatedAssembliesAssemblyIdPcbDfmRoute
  AuthenticatedAssembliesAssemblyIdPcbDfmAnalysisRoute: typeof AuthenticatedAssembliesAssemblyIdPcbDfmAnalysisRoute
  AuthenticatedAssembliesAssemblyIdPcbDrillsRoute: typeof AuthenticatedAssembliesAssemblyIdPcbDrillsRoute
  AuthenticatedAssembliesAssemblyIdPcbFilesRoute: typeof AuthenticatedAssembliesAssemblyIdPcbFilesRoute
  AuthenticatedAssembliesAssemblyIdPcbPanelizationRoute: typeof AuthenticatedAssembliesAssemblyIdPcbPanelizationRoute
  AuthenticatedAssembliesAssemblyIdPcbSpecificationRoute: typeof AuthenticatedAssembliesAssemblyIdPcbSpecificationRoute
  AuthenticatedAssembliesAssemblyIdPcbStackupRoute: typeof AuthenticatedAssembliesAssemblyIdPcbStackupRoute
  AuthenticatedAssembliesAssemblyIdPcbIndexRoute: typeof AuthenticatedAssembliesAssemblyIdPcbIndexRoute
}

const AuthenticatedAssembliesAssemblyIdPcbRouteRouteChildren: AuthenticatedAssembliesAssemblyIdPcbRouteRouteChildren =
  {
    AuthenticatedAssembliesAssemblyIdPcbCadViewerRoute:
      AuthenticatedAssembliesAssemblyIdPcbCadViewerRoute,
    AuthenticatedAssembliesAssemblyIdPcbDfmRoute:
      AuthenticatedAssembliesAssemblyIdPcbDfmRoute,
    AuthenticatedAssembliesAssemblyIdPcbDfmAnalysisRoute:
      AuthenticatedAssembliesAssemblyIdPcbDfmAnalysisRoute,
    AuthenticatedAssembliesAssemblyIdPcbDrillsRoute:
      AuthenticatedAssembliesAssemblyIdPcbDrillsRoute,
    AuthenticatedAssembliesAssemblyIdPcbFilesRoute:
      AuthenticatedAssembliesAssemblyIdPcbFilesRoute,
    AuthenticatedAssembliesAssemblyIdPcbPanelizationRoute:
      AuthenticatedAssembliesAssemblyIdPcbPanelizationRoute,
    AuthenticatedAssembliesAssemblyIdPcbSpecificationRoute:
      AuthenticatedAssembliesAssemblyIdPcbSpecificationRoute,
    AuthenticatedAssembliesAssemblyIdPcbStackupRoute:
      AuthenticatedAssembliesAssemblyIdPcbStackupRoute,
    AuthenticatedAssembliesAssemblyIdPcbIndexRoute:
      AuthenticatedAssembliesAssemblyIdPcbIndexRoute,
  }

const AuthenticatedAssembliesAssemblyIdPcbRouteRouteWithChildren =
  AuthenticatedAssembliesAssemblyIdPcbRouteRoute._addFileChildren(
    AuthenticatedAssembliesAssemblyIdPcbRouteRouteChildren,
  )

interface AuthenticatedNegotiationsNegotiationIdSidebarRouteRouteChildren {
  AuthenticatedNegotiationsNegotiationIdSidebarOverviewRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarOverviewRoute
  AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsQuoteRequestIdRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsQuoteRequestIdRoute
  AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsAssignRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsAssignRoute
  AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsAttachmentsRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsAttachmentsRoute
  AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsDeliveryLotSizeRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsDeliveryLotSizeRoute
  AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsExcelImporterRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsExcelImporterRoute
  AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsImporterRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsImporterRoute
  AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsLineItemsRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsLineItemsRoute
  AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsPreviewEmailRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsPreviewEmailRoute
  AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsTargetPriceRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsTargetPriceRoute
  AuthenticatedNegotiationsNegotiationIdSidebarScenariosCompareRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarScenariosCompareRoute
  AuthenticatedNegotiationsNegotiationIdSidebarScenariosCreateRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarScenariosCreateRoute
  AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsIndexRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsIndexRoute
  AuthenticatedNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdAwardingRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdAwardingRoute
  AuthenticatedNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdIndexRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdIndexRoute
  AuthenticatedNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdIndexRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdIndexRoute
  AuthenticatedNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownIndexRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownIndexRoute
  AuthenticatedNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownAssemblyAssemblyIdDemandDemandIdRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownAssemblyAssemblyIdDemandDemandIdRoute
}

const AuthenticatedNegotiationsNegotiationIdSidebarRouteRouteChildren: AuthenticatedNegotiationsNegotiationIdSidebarRouteRouteChildren =
  {
    AuthenticatedNegotiationsNegotiationIdSidebarOverviewRoute:
      AuthenticatedNegotiationsNegotiationIdSidebarOverviewRoute,
    AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsQuoteRequestIdRoute:
      AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsQuoteRequestIdRoute,
    AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsAssignRoute:
      AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsAssignRoute,
    AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsAttachmentsRoute:
      AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsAttachmentsRoute,
    AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsDeliveryLotSizeRoute:
      AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsDeliveryLotSizeRoute,
    AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsExcelImporterRoute:
      AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsExcelImporterRoute,
    AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsImporterRoute:
      AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsImporterRoute,
    AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsLineItemsRoute:
      AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsLineItemsRoute,
    AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsPreviewEmailRoute:
      AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsPreviewEmailRoute,
    AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsTargetPriceRoute:
      AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsTargetPriceRoute,
    AuthenticatedNegotiationsNegotiationIdSidebarScenariosCompareRoute:
      AuthenticatedNegotiationsNegotiationIdSidebarScenariosCompareRoute,
    AuthenticatedNegotiationsNegotiationIdSidebarScenariosCreateRoute:
      AuthenticatedNegotiationsNegotiationIdSidebarScenariosCreateRoute,
    AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsIndexRoute:
      AuthenticatedNegotiationsNegotiationIdSidebarQuoteRequestsIndexRoute,
    AuthenticatedNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdAwardingRoute:
      AuthenticatedNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdAwardingRoute,
    AuthenticatedNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdIndexRoute:
      AuthenticatedNegotiationsNegotiationIdSidebarDemandGroupsDemandGroupIdIndexRoute,
    AuthenticatedNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdIndexRoute:
      AuthenticatedNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdIndexRoute,
    AuthenticatedNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownIndexRoute:
      AuthenticatedNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownIndexRoute,
    AuthenticatedNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownAssemblyAssemblyIdDemandDemandIdRoute:
      AuthenticatedNegotiationsNegotiationIdSidebarScenariosSourcingScenarioIdCostBreakdownAssemblyAssemblyIdDemandDemandIdRoute,
  }

const AuthenticatedNegotiationsNegotiationIdSidebarRouteRouteWithChildren =
  AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute._addFileChildren(
    AuthenticatedNegotiationsNegotiationIdSidebarRouteRouteChildren,
  )

interface AuthenticatedPartsDetailsPartIdRouteRouteChildren {
  AuthenticatedPartsDetailsPartIdComplianceRoute: typeof AuthenticatedPartsDetailsPartIdComplianceRoute
  AuthenticatedPartsDetailsPartIdOffersRoute: typeof AuthenticatedPartsDetailsPartIdOffersRoute
  AuthenticatedPartsDetailsPartIdPartAlternativesRoute: typeof AuthenticatedPartsDetailsPartIdPartAlternativesRoute
  AuthenticatedPartsDetailsPartIdSeAlternativesRoute: typeof AuthenticatedPartsDetailsPartIdSeAlternativesRoute
  AuthenticatedPartsDetailsPartIdSeDocumentationRoute: typeof AuthenticatedPartsDetailsPartIdSeDocumentationRoute
  AuthenticatedPartsDetailsPartIdSeGeoRiskRoute: typeof AuthenticatedPartsDetailsPartIdSeGeoRiskRoute
  AuthenticatedPartsDetailsPartIdSeSupplyChainRoute: typeof AuthenticatedPartsDetailsPartIdSeSupplyChainRoute
  AuthenticatedPartsDetailsPartIdSeTechnicalRoute: typeof AuthenticatedPartsDetailsPartIdSeTechnicalRoute
  AuthenticatedPartsDetailsPartIdUsedInRoute: typeof AuthenticatedPartsDetailsPartIdUsedInRoute
  AuthenticatedPartsDetailsPartIdIndexRoute: typeof AuthenticatedPartsDetailsPartIdIndexRoute
}

const AuthenticatedPartsDetailsPartIdRouteRouteChildren: AuthenticatedPartsDetailsPartIdRouteRouteChildren =
  {
    AuthenticatedPartsDetailsPartIdComplianceRoute:
      AuthenticatedPartsDetailsPartIdComplianceRoute,
    AuthenticatedPartsDetailsPartIdOffersRoute:
      AuthenticatedPartsDetailsPartIdOffersRoute,
    AuthenticatedPartsDetailsPartIdPartAlternativesRoute:
      AuthenticatedPartsDetailsPartIdPartAlternativesRoute,
    AuthenticatedPartsDetailsPartIdSeAlternativesRoute:
      AuthenticatedPartsDetailsPartIdSeAlternativesRoute,
    AuthenticatedPartsDetailsPartIdSeDocumentationRoute:
      AuthenticatedPartsDetailsPartIdSeDocumentationRoute,
    AuthenticatedPartsDetailsPartIdSeGeoRiskRoute:
      AuthenticatedPartsDetailsPartIdSeGeoRiskRoute,
    AuthenticatedPartsDetailsPartIdSeSupplyChainRoute:
      AuthenticatedPartsDetailsPartIdSeSupplyChainRoute,
    AuthenticatedPartsDetailsPartIdSeTechnicalRoute:
      AuthenticatedPartsDetailsPartIdSeTechnicalRoute,
    AuthenticatedPartsDetailsPartIdUsedInRoute:
      AuthenticatedPartsDetailsPartIdUsedInRoute,
    AuthenticatedPartsDetailsPartIdIndexRoute:
      AuthenticatedPartsDetailsPartIdIndexRoute,
  }

const AuthenticatedPartsDetailsPartIdRouteRouteWithChildren =
  AuthenticatedPartsDetailsPartIdRouteRoute._addFileChildren(
    AuthenticatedPartsDetailsPartIdRouteRouteChildren,
  )

interface AuthenticatedPartsComponentsIpnDetailsRouteRouteChildren {
  AuthenticatedPartsComponentsIpnDetailsCpnsRoute: typeof AuthenticatedPartsComponentsIpnDetailsCpnsRoute
  AuthenticatedPartsComponentsIpnDetailsLinkingRoute: typeof AuthenticatedPartsComponentsIpnDetailsLinkingRoute
  AuthenticatedPartsComponentsIpnDetailsOffersRoute: typeof AuthenticatedPartsComponentsIpnDetailsOffersRoute
  AuthenticatedPartsComponentsIpnDetailsUsedInRoute: typeof AuthenticatedPartsComponentsIpnDetailsUsedInRoute
  AuthenticatedPartsComponentsIpnDetailsIndexRoute: typeof AuthenticatedPartsComponentsIpnDetailsIndexRoute
}

const AuthenticatedPartsComponentsIpnDetailsRouteRouteChildren: AuthenticatedPartsComponentsIpnDetailsRouteRouteChildren =
  {
    AuthenticatedPartsComponentsIpnDetailsCpnsRoute:
      AuthenticatedPartsComponentsIpnDetailsCpnsRoute,
    AuthenticatedPartsComponentsIpnDetailsLinkingRoute:
      AuthenticatedPartsComponentsIpnDetailsLinkingRoute,
    AuthenticatedPartsComponentsIpnDetailsOffersRoute:
      AuthenticatedPartsComponentsIpnDetailsOffersRoute,
    AuthenticatedPartsComponentsIpnDetailsUsedInRoute:
      AuthenticatedPartsComponentsIpnDetailsUsedInRoute,
    AuthenticatedPartsComponentsIpnDetailsIndexRoute:
      AuthenticatedPartsComponentsIpnDetailsIndexRoute,
  }

const AuthenticatedPartsComponentsIpnDetailsRouteRouteWithChildren =
  AuthenticatedPartsComponentsIpnDetailsRouteRoute._addFileChildren(
    AuthenticatedPartsComponentsIpnDetailsRouteRouteChildren,
  )

interface AuthenticatedPartsCustomDetailsCustomPartSpecificationIdRouteRouteChildren {
  AuthenticatedPartsCustomDetailsCustomPartSpecificationIdOffersRoute: typeof AuthenticatedPartsCustomDetailsCustomPartSpecificationIdOffersRoute
  AuthenticatedPartsCustomDetailsCustomPartSpecificationIdUsedInRoute: typeof AuthenticatedPartsCustomDetailsCustomPartSpecificationIdUsedInRoute
  AuthenticatedPartsCustomDetailsCustomPartSpecificationIdIndexRoute: typeof AuthenticatedPartsCustomDetailsCustomPartSpecificationIdIndexRoute
}

const AuthenticatedPartsCustomDetailsCustomPartSpecificationIdRouteRouteChildren: AuthenticatedPartsCustomDetailsCustomPartSpecificationIdRouteRouteChildren =
  {
    AuthenticatedPartsCustomDetailsCustomPartSpecificationIdOffersRoute:
      AuthenticatedPartsCustomDetailsCustomPartSpecificationIdOffersRoute,
    AuthenticatedPartsCustomDetailsCustomPartSpecificationIdUsedInRoute:
      AuthenticatedPartsCustomDetailsCustomPartSpecificationIdUsedInRoute,
    AuthenticatedPartsCustomDetailsCustomPartSpecificationIdIndexRoute:
      AuthenticatedPartsCustomDetailsCustomPartSpecificationIdIndexRoute,
  }

const AuthenticatedPartsCustomDetailsCustomPartSpecificationIdRouteRouteWithChildren =
  AuthenticatedPartsCustomDetailsCustomPartSpecificationIdRouteRoute._addFileChildren(
    AuthenticatedPartsCustomDetailsCustomPartSpecificationIdRouteRouteChildren,
  )

interface AuthenticatedProjectsProjectIdSourcingSidebarRouteRouteChildren {
  AuthenticatedProjectsProjectIdSourcingSidebarCompareRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarCompareRoute
  AuthenticatedProjectsProjectIdSourcingSidebarVersionHistoryRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarVersionHistoryRoute
  AuthenticatedProjectsProjectIdSourcingSidebarOverviewViewRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarOverviewViewRoute
  AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsQuoteRequestIdRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsQuoteRequestIdRoute
  AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsAssignRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsAssignRoute
  AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsAttachmentsRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsAttachmentsRoute
  AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsDeliveryLotSizeRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsDeliveryLotSizeRoute
  AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsExcelImporterRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsExcelImporterRoute
  AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsImporterRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsImporterRoute
  AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsLineItemsRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsLineItemsRoute
  AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsPreviewEmailRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsPreviewEmailRoute
  AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsTargetPriceRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsTargetPriceRoute
  AuthenticatedProjectsProjectIdSourcingSidebarScenariosCreateRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarScenariosCreateRoute
  AuthenticatedProjectsProjectIdSourcingSidebarOverviewIndexRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarOverviewIndexRoute
  AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsIndexRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsIndexRoute
}

const AuthenticatedProjectsProjectIdSourcingSidebarRouteRouteChildren: AuthenticatedProjectsProjectIdSourcingSidebarRouteRouteChildren =
  {
    AuthenticatedProjectsProjectIdSourcingSidebarCompareRoute:
      AuthenticatedProjectsProjectIdSourcingSidebarCompareRoute,
    AuthenticatedProjectsProjectIdSourcingSidebarVersionHistoryRoute:
      AuthenticatedProjectsProjectIdSourcingSidebarVersionHistoryRoute,
    AuthenticatedProjectsProjectIdSourcingSidebarOverviewViewRoute:
      AuthenticatedProjectsProjectIdSourcingSidebarOverviewViewRoute,
    AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsQuoteRequestIdRoute:
      AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsQuoteRequestIdRoute,
    AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsAssignRoute:
      AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsAssignRoute,
    AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsAttachmentsRoute:
      AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsAttachmentsRoute,
    AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsDeliveryLotSizeRoute:
      AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsDeliveryLotSizeRoute,
    AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsExcelImporterRoute:
      AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsExcelImporterRoute,
    AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsImporterRoute:
      AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsImporterRoute,
    AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsLineItemsRoute:
      AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsLineItemsRoute,
    AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsPreviewEmailRoute:
      AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsPreviewEmailRoute,
    AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsTargetPriceRoute:
      AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsTargetPriceRoute,
    AuthenticatedProjectsProjectIdSourcingSidebarScenariosCreateRoute:
      AuthenticatedProjectsProjectIdSourcingSidebarScenariosCreateRoute,
    AuthenticatedProjectsProjectIdSourcingSidebarOverviewIndexRoute:
      AuthenticatedProjectsProjectIdSourcingSidebarOverviewIndexRoute,
    AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsIndexRoute:
      AuthenticatedProjectsProjectIdSourcingSidebarQuoteRequestsIndexRoute,
  }

const AuthenticatedProjectsProjectIdSourcingSidebarRouteRouteWithChildren =
  AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute._addFileChildren(
    AuthenticatedProjectsProjectIdSourcingSidebarRouteRouteChildren,
  )

interface AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRouteChildren {
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbCadViewerRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbCadViewerRoute
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbDfmRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbDfmRoute
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbDfmAnalysisRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbDfmAnalysisRoute
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbDrillsRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbDrillsRoute
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbFilesRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbFilesRoute
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbPanelizationRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbPanelizationRoute
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbSpecificationRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbSpecificationRoute
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbStackupRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbStackupRoute
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbIndexRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbIndexRoute
}

const AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRouteChildren: AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRouteChildren =
  {
    AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbCadViewerRoute:
      AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbCadViewerRoute,
    AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbDfmRoute:
      AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbDfmRoute,
    AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbDfmAnalysisRoute:
      AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbDfmAnalysisRoute,
    AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbDrillsRoute:
      AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbDrillsRoute,
    AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbFilesRoute:
      AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbFilesRoute,
    AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbPanelizationRoute:
      AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbPanelizationRoute,
    AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbSpecificationRoute:
      AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbSpecificationRoute,
    AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbStackupRoute:
      AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbStackupRoute,
    AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbIndexRoute:
      AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbIndexRoute,
  }

const AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRouteWithChildren =
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRoute._addFileChildren(
    AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRouteChildren,
  )

interface AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarRouteRouteChildren {
  AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarLineItemsRoute: typeof AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarLineItemsRoute
  AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarCostBreakdownIndexRoute: typeof AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarCostBreakdownIndexRoute
  AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarCostBreakdownAssemblyAssemblyIdDemandDemandIdRoute: typeof AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarCostBreakdownAssemblyAssemblyIdDemandDemandIdRoute
}

const AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarRouteRouteChildren: AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarRouteRouteChildren =
  {
    AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarLineItemsRoute:
      AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarLineItemsRoute,
    AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarCostBreakdownIndexRoute:
      AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarCostBreakdownIndexRoute,
    AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarCostBreakdownAssemblyAssemblyIdDemandDemandIdRoute:
      AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarCostBreakdownAssemblyAssemblyIdDemandDemandIdRoute,
  }

const AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarRouteRouteWithChildren =
  AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarRouteRoute._addFileChildren(
    AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedCustomerPortalRouteRoute: typeof AuthenticatedCustomerPortalRouteRouteWithChildren
  AuthenticatedMonitoringRouteRoute: typeof AuthenticatedMonitoringRouteRouteWithChildren
  AuthenticatedNextRouteRoute: typeof AuthenticatedNextRouteRouteWithChildren
  AuthenticatedRiskManagementRouteRoute: typeof AuthenticatedRiskManagementRouteRouteWithChildren
  AuthenticatedSplatRoute: typeof AuthenticatedSplatRoute
  AuthenticatedHomeRoute: typeof AuthenticatedHomeRoute
  AuthenticatedProject_creationRoute: typeof AuthenticatedProject_creationRoute
  AuthenticatedPurchaseOrdersRoute: typeof AuthenticatedPurchaseOrdersRoute
  AuthenticatedRfqsRoute: typeof AuthenticatedRfqsRoute
  AuthenticatedStartRoute: typeof AuthenticatedStartRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedManufacturersSidebarRouteRoute: typeof AuthenticatedManufacturersSidebarRouteRouteWithChildren
  AuthenticatedManufacturingSidebarRouteRoute: typeof AuthenticatedManufacturingSidebarRouteRouteWithChildren
  AuthenticatedPartsSidebarRouteRoute: typeof AuthenticatedPartsSidebarRouteRouteWithChildren
  AuthenticatedSettingsMenuRouteRoute: typeof AuthenticatedSettingsMenuRouteRouteWithChildren
  AuthenticatedSuppliersSidebarRouteRoute: typeof AuthenticatedSuppliersSidebarRouteRouteWithChildren
  AuthenticatedTemplatesSidebarRouteRoute: typeof AuthenticatedTemplatesSidebarRouteRouteWithChildren
  AuthenticatedAppsSplatRoute: typeof AuthenticatedAppsSplatRoute
  AuthenticatedAssembliesAddAssemblyRoute: typeof AuthenticatedAssembliesAddAssemblyRoute
  AuthenticatedComponentsImportRoute: typeof AuthenticatedComponentsImportRoute
  AuthenticatedCustomersCustomerIdRoute: typeof AuthenticatedCustomersCustomerIdRoute
  AuthenticatedCustomersImporterRoute: typeof AuthenticatedCustomersImporterRoute
  AuthenticatedManufacturerSplatRoute: typeof AuthenticatedManufacturerSplatRoute
  AuthenticatedManufacturersManufacturerIdRoute: typeof AuthenticatedManufacturersManufacturerIdRoute
  AuthenticatedManufacturersImporterRoute: typeof AuthenticatedManufacturersImporterRoute
  AuthenticatedManufacturingAddActivityRoute: typeof AuthenticatedManufacturingAddActivityRoute
  AuthenticatedManufacturingAddDriverRoute: typeof AuthenticatedManufacturingAddDriverRoute
  AuthenticatedManufacturingAddExpenseRoute: typeof AuthenticatedManufacturingAddExpenseRoute
  AuthenticatedManufacturingAddResourceRoute: typeof AuthenticatedManufacturingAddResourceRoute
  AuthenticatedNegotiationsCreateRoute: typeof AuthenticatedNegotiationsCreateRoute
  AuthenticatedOffersMpnOfferImporterRoute: typeof AuthenticatedOffersMpnOfferImporterRoute
  AuthenticatedOrdersUploadRoute: typeof AuthenticatedOrdersUploadRoute
  AuthenticatedOrdersChar123OrderIdChar125Route: typeof AuthenticatedOrdersChar123OrderIdChar125Route
  AuthenticatedPartsOffTheShelfPartSearchRoute: typeof AuthenticatedPartsOffTheShelfPartSearchRoute
  AuthenticatedProjectsCreateRoute: typeof AuthenticatedProjectsCreateRoute
  AuthenticatedProjectsNewRoute: typeof AuthenticatedProjectsNewRoute
  AuthenticatedQuoteRequestsExcelImporterRoute: typeof AuthenticatedQuoteRequestsExcelImporterRoute
  AuthenticatedSettingsCompanyRoute: typeof AuthenticatedSettingsCompanyRoute
  AuthenticatedSupplierImporterRoute: typeof AuthenticatedSupplierImporterRoute
  AuthenticatedSuppliersSupplierAndStockLocationIdRoute: typeof AuthenticatedSuppliersSupplierAndStockLocationIdRoute
  AuthenticatedSuppliersImporterRoute: typeof AuthenticatedSuppliersImporterRoute
  AuthenticatedTemplateSplatRoute: typeof AuthenticatedTemplateSplatRoute
  AuthenticatedAssembliesIndexRoute: typeof AuthenticatedAssembliesIndexRoute
  AuthenticatedCustomersIndexRoute: typeof AuthenticatedCustomersIndexRoute
  AuthenticatedManufacturingIndexRoute: typeof AuthenticatedManufacturingIndexRoute
  AuthenticatedNegotiationsIndexRoute: typeof AuthenticatedNegotiationsIndexRoute
  AuthenticatedPartsIndexRoute: typeof AuthenticatedPartsIndexRoute
  AuthenticatedProjectsIndexRoute: typeof AuthenticatedProjectsIndexRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedSupplierPortalIndexRoute: typeof AuthenticatedSupplierPortalIndexRoute
  AuthenticatedTemplatesIndexRoute: typeof AuthenticatedTemplatesIndexRoute
  AuthenticatedAssembliesAssemblyIdPcbRouteRoute: typeof AuthenticatedAssembliesAssemblyIdPcbRouteRouteWithChildren
  AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute: typeof AuthenticatedNegotiationsNegotiationIdSidebarRouteRouteWithChildren
  AuthenticatedPartsDetailsPartIdRouteRoute: typeof AuthenticatedPartsDetailsPartIdRouteRouteWithChildren
  Authenticated3rdpartyDigikeyCallbackRoute: typeof Authenticated3rdpartyDigikeyCallbackRoute
  AuthenticatedAssembliesAssemblyIdDashboardRoute: typeof AuthenticatedAssembliesAssemblyIdDashboardRoute
  AuthenticatedAssembliesAssemblyIdDetailsRoute: typeof AuthenticatedAssembliesAssemblyIdDetailsRoute
  AuthenticatedAssembliesAssemblyIdEditRoute: typeof AuthenticatedAssembliesAssemblyIdEditRoute
  AuthenticatedManufacturingActivitiesCreateRoute: typeof AuthenticatedManufacturingActivitiesCreateRoute
  AuthenticatedManufacturingActivitySplatRoute: typeof AuthenticatedManufacturingActivitySplatRoute
  AuthenticatedManufacturingDriverSplatRoute: typeof AuthenticatedManufacturingDriverSplatRoute
  AuthenticatedManufacturingDriversCreateRoute: typeof AuthenticatedManufacturingDriversCreateRoute
  AuthenticatedManufacturingExpenseSplatRoute: typeof AuthenticatedManufacturingExpenseSplatRoute
  AuthenticatedManufacturingExpensesCreateRoute: typeof AuthenticatedManufacturingExpensesCreateRoute
  AuthenticatedManufacturingResourceSplatRoute: typeof AuthenticatedManufacturingResourceSplatRoute
  AuthenticatedManufacturingResourcesCreateRoute: typeof AuthenticatedManufacturingResourcesCreateRoute
  AuthenticatedManufacturingTemplateSplatRoute: typeof AuthenticatedManufacturingTemplateSplatRoute
  AuthenticatedPartsComponentsComponentImporterRoute: typeof AuthenticatedPartsComponentsComponentImporterRoute
  AuthenticatedPartsComponentsImporterRoute: typeof AuthenticatedPartsComponentsImporterRoute
  AuthenticatedPartsComponentsLinkingRoute: typeof AuthenticatedPartsComponentsLinkingRoute
  AuthenticatedPartsDemandDemandImporterRoute: typeof AuthenticatedPartsDemandDemandImporterRoute
  AuthenticatedPartsOffersAddRoute: typeof AuthenticatedPartsOffersAddRoute
  AuthenticatedPartsOffersCreateRoute: typeof AuthenticatedPartsOffersCreateRoute
  AuthenticatedPartsOffersCsvImporterRoute: typeof AuthenticatedPartsOffersCsvImporterRoute
  AuthenticatedPartsQuoteRequestsExcelImporterRoute: typeof AuthenticatedPartsQuoteRequestsExcelImporterRoute
  AuthenticatedPartsQuoteRequestsImporterRoute: typeof AuthenticatedPartsQuoteRequestsImporterRoute
  AuthenticatedProjectsProjectIdDashboardRoute: typeof AuthenticatedProjectsProjectIdDashboardRoute
  AuthenticatedProjectsProjectIdEditRoute: typeof AuthenticatedProjectsProjectIdEditRoute
  AuthenticatedProjectsProjectIdQuotationRoute: typeof AuthenticatedProjectsProjectIdQuotationRoute
  AuthenticatedSuppliersLineCardRulesImporterRoute: typeof AuthenticatedSuppliersLineCardRulesImporterRoute
  AuthenticatedSuppliersSupplierContactsImporterBulkRoute: typeof AuthenticatedSuppliersSupplierContactsImporterBulkRoute
  AuthenticatedSuppliersSupplierContactsImporterRoute: typeof AuthenticatedSuppliersSupplierContactsImporterRoute
  AuthenticatedTemplatesCalculationAddTemplateRoute: typeof AuthenticatedTemplatesCalculationAddTemplateRoute
  AuthenticatedTemplatesCalculationCreateRoute: typeof AuthenticatedTemplatesCalculationCreateRoute
  AuthenticatedTemplatesFlexibleCalculationNewRoute: typeof AuthenticatedTemplatesFlexibleCalculationNewRoute
  AuthenticatedTemplatesQuotationCreateRoute: typeof AuthenticatedTemplatesQuotationCreateRoute
  AuthenticatedTemplatesQuotationEditRoute: typeof AuthenticatedTemplatesQuotationEditRoute
  AuthenticatedAssembliesAssemblyIdIndexRoute: typeof AuthenticatedAssembliesAssemblyIdIndexRoute
  AuthenticatedNegotiationsNegotiationIdIndexRoute: typeof AuthenticatedNegotiationsNegotiationIdIndexRoute
  AuthenticatedProjectsProjectIdIndexRoute: typeof AuthenticatedProjectsProjectIdIndexRoute
  AuthenticatedPartsComponentsIpnDetailsRouteRoute: typeof AuthenticatedPartsComponentsIpnDetailsRouteRouteWithChildren
  AuthenticatedPartsCustomDetailsCustomPartSpecificationIdRouteRoute: typeof AuthenticatedPartsCustomDetailsCustomPartSpecificationIdRouteRouteWithChildren
  AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute: typeof AuthenticatedProjectsProjectIdSourcingSidebarRouteRouteWithChildren
  AuthenticatedAssembliesAssemblyIdSubassembliesCreateRoute: typeof AuthenticatedAssembliesAssemblyIdSubassembliesCreateRoute
  AuthenticatedManufacturingActivitiesActivityIdDuplicateRoute: typeof AuthenticatedManufacturingActivitiesActivityIdDuplicateRoute
  AuthenticatedManufacturingActivitiesActivityIdEditRoute: typeof AuthenticatedManufacturingActivitiesActivityIdEditRoute
  AuthenticatedManufacturingDriversDriverIdDuplicateRoute: typeof AuthenticatedManufacturingDriversDriverIdDuplicateRoute
  AuthenticatedManufacturingDriversDriverIdEditRoute: typeof AuthenticatedManufacturingDriversDriverIdEditRoute
  AuthenticatedManufacturingExpensesExpenseIdDuplicateRoute: typeof AuthenticatedManufacturingExpensesExpenseIdDuplicateRoute
  AuthenticatedManufacturingExpensesExpenseIdEditRoute: typeof AuthenticatedManufacturingExpensesExpenseIdEditRoute
  AuthenticatedManufacturingResourcesResourceIdDuplicateRoute: typeof AuthenticatedManufacturingResourcesResourceIdDuplicateRoute
  AuthenticatedManufacturingResourcesResourceIdEditRoute: typeof AuthenticatedManufacturingResourcesResourceIdEditRoute
  AuthenticatedPartsOffersOfferIdDuplicateRoute: typeof AuthenticatedPartsOffersOfferIdDuplicateRoute
  AuthenticatedPartsOffersOfferIdEditRoute: typeof AuthenticatedPartsOffersOfferIdEditRoute
  AuthenticatedProjectsProjectIdCalculationPrintRoute: typeof AuthenticatedProjectsProjectIdCalculationPrintRoute
  AuthenticatedProjectsProjectIdFlexibleCalculationFlexibleCalculationIdRoute: typeof AuthenticatedProjectsProjectIdFlexibleCalculationFlexibleCalculationIdRoute
  AuthenticatedProjectsProjectIdOrderConfirmationRoute: typeof AuthenticatedProjectsProjectIdOrderConfirmationRoute
  AuthenticatedProjectsProjectIdSourcingDemandGroupsRoute: typeof AuthenticatedProjectsProjectIdSourcingDemandGroupsRoute
  AuthenticatedSettingsOrganizationPcbPanelPreferenceIdRoute: typeof AuthenticatedSettingsOrganizationPcbPanelPreferenceIdRoute
  AuthenticatedSettingsOrganizationPcbAddPreferenceRoute: typeof AuthenticatedSettingsOrganizationPcbAddPreferenceRoute
  AuthenticatedSettingsOrganizationUsersImporterRoute: typeof AuthenticatedSettingsOrganizationUsersImporterRoute
  AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdExcelImporterRoute: typeof AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdExcelImporterRoute
  AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdImportPdfRoute: typeof AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdImportPdfRoute
  AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdPdfImporterRoute: typeof AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdPdfImporterRoute
  AuthenticatedSuppliersSupplierIdSupplierContactsImporterSplatRoute: typeof AuthenticatedSuppliersSupplierIdSupplierContactsImporterSplatRoute
  AuthenticatedSuppliersSupplierIdSupplierContactsImporterRoute: typeof AuthenticatedSuppliersSupplierIdSupplierContactsImporterRoute
  AuthenticatedTemplatesCalculationTemplateIdEditRoute: typeof AuthenticatedTemplatesCalculationTemplateIdEditRoute
  AuthenticatedTemplatesEmailEmailTemplateIdUpdateRoute: typeof AuthenticatedTemplatesEmailEmailTemplateIdUpdateRoute
  AuthenticatedProjectsProjectIdBomIndexRoute: typeof AuthenticatedProjectsProjectIdBomIndexRoute
  AuthenticatedProjectsProjectIdCalculationIndexRoute: typeof AuthenticatedProjectsProjectIdCalculationIndexRoute
  AuthenticatedProjectsProjectIdFlexibleCalculationIndexRoute: typeof AuthenticatedProjectsProjectIdFlexibleCalculationIndexRoute
  AuthenticatedProjectsProjectIdManufacturingIndexRoute: typeof AuthenticatedProjectsProjectIdManufacturingIndexRoute
  AuthenticatedProjectsProjectIdOrderIndexRoute: typeof AuthenticatedProjectsProjectIdOrderIndexRoute
  AuthenticatedProjectsProjectIdSourcingIndexRoute: typeof AuthenticatedProjectsProjectIdSourcingIndexRoute
  AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdIndexRoute: typeof AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdIndexRoute
  AuthenticatedProjectsProjectIdBomAssemblyAddAssemblyRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAddAssemblyRoute
  AuthenticatedProjectsProjectIdCalculationAssemblyIdCalculationRoute: typeof AuthenticatedProjectsProjectIdCalculationAssemblyIdCalculationRoute
  AuthenticatedProjectsProjectIdCalculationAssembliesAssemblyIdRoute: typeof AuthenticatedProjectsProjectIdCalculationAssembliesAssemblyIdRoute
  AuthenticatedProjectsProjectIdSourcingAssemblyAssemblyIdRoute: typeof AuthenticatedProjectsProjectIdSourcingAssemblyAssemblyIdRoute
  AuthenticatedProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdIndexRoute: typeof AuthenticatedProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdIndexRoute
  AuthenticatedSettingsOrganizationPcbPanelPreferencesIndexRoute: typeof AuthenticatedSettingsOrganizationPcbPanelPreferencesIndexRoute
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRouteWithChildren
  AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarRouteRoute: typeof AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarRouteRouteWithChildren
  AuthenticatedNegotiationsNegotiationIdScenariosSourcingScenarioIdLineSourcingLineItemIdRoute: typeof AuthenticatedNegotiationsNegotiationIdScenariosSourcingScenarioIdLineSourcingLineItemIdRoute
  AuthenticatedPartsComponentsIpnOffersOfferIdDuplicateRoute: typeof AuthenticatedPartsComponentsIpnOffersOfferIdDuplicateRoute
  AuthenticatedPartsComponentsIpnOffersOfferIdEditRoute: typeof AuthenticatedPartsComponentsIpnOffersOfferIdEditRoute
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdDetailsRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdDetailsRoute
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdEditRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdEditRoute
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPnpImporterRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPnpImporterRoute
  AuthenticatedProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdActivityRoute: typeof AuthenticatedProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdActivityRoute
  AuthenticatedProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdExpenseRoute: typeof AuthenticatedProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdExpenseRoute
  AuthenticatedProjectsProjectIdSourcingSourcingScenarioIdLineSourcingLineItemIdRoute: typeof AuthenticatedProjectsProjectIdSourcingSourcingScenarioIdLineSourcingLineItemIdRoute
  AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdPurchaseOrdersRoute: typeof AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdPurchaseOrdersRoute
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdIndexRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdIndexRoute
  AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdIndexRoute: typeof AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdIndexRoute
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdSubassembliesCreateRoute: typeof AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdSubassembliesCreateRoute
  AuthenticatedProjectsProjectIdSourcingOfferCustomPartOfferIdDuplicateRoute: typeof AuthenticatedProjectsProjectIdSourcingOfferCustomPartOfferIdDuplicateRoute
  AuthenticatedProjectsProjectIdSourcingOfferCustomPartOfferIdEditRoute: typeof AuthenticatedProjectsProjectIdSourcingOfferCustomPartOfferIdEditRoute
  AuthenticatedProjectsProjectIdSourcingOfferInternalPartNumberOfferIdDuplicateRoute: typeof AuthenticatedProjectsProjectIdSourcingOfferInternalPartNumberOfferIdDuplicateRoute
  AuthenticatedProjectsProjectIdSourcingOfferInternalPartNumberOfferIdEditRoute: typeof AuthenticatedProjectsProjectIdSourcingOfferInternalPartNumberOfferIdEditRoute
  AuthenticatedProjectsProjectIdSourcingOfferOffTheShelfOfferIdDuplicateRoute: typeof AuthenticatedProjectsProjectIdSourcingOfferOffTheShelfOfferIdDuplicateRoute
  AuthenticatedProjectsProjectIdSourcingOfferOffTheShelfOfferIdEditRoute: typeof AuthenticatedProjectsProjectIdSourcingOfferOffTheShelfOfferIdEditRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedCustomerPortalRouteRoute:
    AuthenticatedCustomerPortalRouteRouteWithChildren,
  AuthenticatedMonitoringRouteRoute:
    AuthenticatedMonitoringRouteRouteWithChildren,
  AuthenticatedNextRouteRoute: AuthenticatedNextRouteRouteWithChildren,
  AuthenticatedRiskManagementRouteRoute:
    AuthenticatedRiskManagementRouteRouteWithChildren,
  AuthenticatedSplatRoute: AuthenticatedSplatRoute,
  AuthenticatedHomeRoute: AuthenticatedHomeRoute,
  AuthenticatedProject_creationRoute: AuthenticatedProject_creationRoute,
  AuthenticatedPurchaseOrdersRoute: AuthenticatedPurchaseOrdersRoute,
  AuthenticatedRfqsRoute: AuthenticatedRfqsRoute,
  AuthenticatedStartRoute: AuthenticatedStartRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedManufacturersSidebarRouteRoute:
    AuthenticatedManufacturersSidebarRouteRouteWithChildren,
  AuthenticatedManufacturingSidebarRouteRoute:
    AuthenticatedManufacturingSidebarRouteRouteWithChildren,
  AuthenticatedPartsSidebarRouteRoute:
    AuthenticatedPartsSidebarRouteRouteWithChildren,
  AuthenticatedSettingsMenuRouteRoute:
    AuthenticatedSettingsMenuRouteRouteWithChildren,
  AuthenticatedSuppliersSidebarRouteRoute:
    AuthenticatedSuppliersSidebarRouteRouteWithChildren,
  AuthenticatedTemplatesSidebarRouteRoute:
    AuthenticatedTemplatesSidebarRouteRouteWithChildren,
  AuthenticatedAppsSplatRoute: AuthenticatedAppsSplatRoute,
  AuthenticatedAssembliesAddAssemblyRoute:
    AuthenticatedAssembliesAddAssemblyRoute,
  AuthenticatedComponentsImportRoute: AuthenticatedComponentsImportRoute,
  AuthenticatedCustomersCustomerIdRoute: AuthenticatedCustomersCustomerIdRoute,
  AuthenticatedCustomersImporterRoute: AuthenticatedCustomersImporterRoute,
  AuthenticatedManufacturerSplatRoute: AuthenticatedManufacturerSplatRoute,
  AuthenticatedManufacturersManufacturerIdRoute:
    AuthenticatedManufacturersManufacturerIdRoute,
  AuthenticatedManufacturersImporterRoute:
    AuthenticatedManufacturersImporterRoute,
  AuthenticatedManufacturingAddActivityRoute:
    AuthenticatedManufacturingAddActivityRoute,
  AuthenticatedManufacturingAddDriverRoute:
    AuthenticatedManufacturingAddDriverRoute,
  AuthenticatedManufacturingAddExpenseRoute:
    AuthenticatedManufacturingAddExpenseRoute,
  AuthenticatedManufacturingAddResourceRoute:
    AuthenticatedManufacturingAddResourceRoute,
  AuthenticatedNegotiationsCreateRoute: AuthenticatedNegotiationsCreateRoute,
  AuthenticatedOffersMpnOfferImporterRoute:
    AuthenticatedOffersMpnOfferImporterRoute,
  AuthenticatedOrdersUploadRoute: AuthenticatedOrdersUploadRoute,
  AuthenticatedOrdersChar123OrderIdChar125Route:
    AuthenticatedOrdersChar123OrderIdChar125Route,
  AuthenticatedPartsOffTheShelfPartSearchRoute:
    AuthenticatedPartsOffTheShelfPartSearchRoute,
  AuthenticatedProjectsCreateRoute: AuthenticatedProjectsCreateRoute,
  AuthenticatedProjectsNewRoute: AuthenticatedProjectsNewRoute,
  AuthenticatedQuoteRequestsExcelImporterRoute:
    AuthenticatedQuoteRequestsExcelImporterRoute,
  AuthenticatedSettingsCompanyRoute: AuthenticatedSettingsCompanyRoute,
  AuthenticatedSupplierImporterRoute: AuthenticatedSupplierImporterRoute,
  AuthenticatedSuppliersSupplierAndStockLocationIdRoute:
    AuthenticatedSuppliersSupplierAndStockLocationIdRoute,
  AuthenticatedSuppliersImporterRoute: AuthenticatedSuppliersImporterRoute,
  AuthenticatedTemplateSplatRoute: AuthenticatedTemplateSplatRoute,
  AuthenticatedAssembliesIndexRoute: AuthenticatedAssembliesIndexRoute,
  AuthenticatedCustomersIndexRoute: AuthenticatedCustomersIndexRoute,
  AuthenticatedManufacturingIndexRoute: AuthenticatedManufacturingIndexRoute,
  AuthenticatedNegotiationsIndexRoute: AuthenticatedNegotiationsIndexRoute,
  AuthenticatedPartsIndexRoute: AuthenticatedPartsIndexRoute,
  AuthenticatedProjectsIndexRoute: AuthenticatedProjectsIndexRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedSupplierPortalIndexRoute: AuthenticatedSupplierPortalIndexRoute,
  AuthenticatedTemplatesIndexRoute: AuthenticatedTemplatesIndexRoute,
  AuthenticatedAssembliesAssemblyIdPcbRouteRoute:
    AuthenticatedAssembliesAssemblyIdPcbRouteRouteWithChildren,
  AuthenticatedNegotiationsNegotiationIdSidebarRouteRoute:
    AuthenticatedNegotiationsNegotiationIdSidebarRouteRouteWithChildren,
  AuthenticatedPartsDetailsPartIdRouteRoute:
    AuthenticatedPartsDetailsPartIdRouteRouteWithChildren,
  Authenticated3rdpartyDigikeyCallbackRoute:
    Authenticated3rdpartyDigikeyCallbackRoute,
  AuthenticatedAssembliesAssemblyIdDashboardRoute:
    AuthenticatedAssembliesAssemblyIdDashboardRoute,
  AuthenticatedAssembliesAssemblyIdDetailsRoute:
    AuthenticatedAssembliesAssemblyIdDetailsRoute,
  AuthenticatedAssembliesAssemblyIdEditRoute:
    AuthenticatedAssembliesAssemblyIdEditRoute,
  AuthenticatedManufacturingActivitiesCreateRoute:
    AuthenticatedManufacturingActivitiesCreateRoute,
  AuthenticatedManufacturingActivitySplatRoute:
    AuthenticatedManufacturingActivitySplatRoute,
  AuthenticatedManufacturingDriverSplatRoute:
    AuthenticatedManufacturingDriverSplatRoute,
  AuthenticatedManufacturingDriversCreateRoute:
    AuthenticatedManufacturingDriversCreateRoute,
  AuthenticatedManufacturingExpenseSplatRoute:
    AuthenticatedManufacturingExpenseSplatRoute,
  AuthenticatedManufacturingExpensesCreateRoute:
    AuthenticatedManufacturingExpensesCreateRoute,
  AuthenticatedManufacturingResourceSplatRoute:
    AuthenticatedManufacturingResourceSplatRoute,
  AuthenticatedManufacturingResourcesCreateRoute:
    AuthenticatedManufacturingResourcesCreateRoute,
  AuthenticatedManufacturingTemplateSplatRoute:
    AuthenticatedManufacturingTemplateSplatRoute,
  AuthenticatedPartsComponentsComponentImporterRoute:
    AuthenticatedPartsComponentsComponentImporterRoute,
  AuthenticatedPartsComponentsImporterRoute:
    AuthenticatedPartsComponentsImporterRoute,
  AuthenticatedPartsComponentsLinkingRoute:
    AuthenticatedPartsComponentsLinkingRoute,
  AuthenticatedPartsDemandDemandImporterRoute:
    AuthenticatedPartsDemandDemandImporterRoute,
  AuthenticatedPartsOffersAddRoute: AuthenticatedPartsOffersAddRoute,
  AuthenticatedPartsOffersCreateRoute: AuthenticatedPartsOffersCreateRoute,
  AuthenticatedPartsOffersCsvImporterRoute:
    AuthenticatedPartsOffersCsvImporterRoute,
  AuthenticatedPartsQuoteRequestsExcelImporterRoute:
    AuthenticatedPartsQuoteRequestsExcelImporterRoute,
  AuthenticatedPartsQuoteRequestsImporterRoute:
    AuthenticatedPartsQuoteRequestsImporterRoute,
  AuthenticatedProjectsProjectIdDashboardRoute:
    AuthenticatedProjectsProjectIdDashboardRoute,
  AuthenticatedProjectsProjectIdEditRoute:
    AuthenticatedProjectsProjectIdEditRoute,
  AuthenticatedProjectsProjectIdQuotationRoute:
    AuthenticatedProjectsProjectIdQuotationRoute,
  AuthenticatedSuppliersLineCardRulesImporterRoute:
    AuthenticatedSuppliersLineCardRulesImporterRoute,
  AuthenticatedSuppliersSupplierContactsImporterBulkRoute:
    AuthenticatedSuppliersSupplierContactsImporterBulkRoute,
  AuthenticatedSuppliersSupplierContactsImporterRoute:
    AuthenticatedSuppliersSupplierContactsImporterRoute,
  AuthenticatedTemplatesCalculationAddTemplateRoute:
    AuthenticatedTemplatesCalculationAddTemplateRoute,
  AuthenticatedTemplatesCalculationCreateRoute:
    AuthenticatedTemplatesCalculationCreateRoute,
  AuthenticatedTemplatesFlexibleCalculationNewRoute:
    AuthenticatedTemplatesFlexibleCalculationNewRoute,
  AuthenticatedTemplatesQuotationCreateRoute:
    AuthenticatedTemplatesQuotationCreateRoute,
  AuthenticatedTemplatesQuotationEditRoute:
    AuthenticatedTemplatesQuotationEditRoute,
  AuthenticatedAssembliesAssemblyIdIndexRoute:
    AuthenticatedAssembliesAssemblyIdIndexRoute,
  AuthenticatedNegotiationsNegotiationIdIndexRoute:
    AuthenticatedNegotiationsNegotiationIdIndexRoute,
  AuthenticatedProjectsProjectIdIndexRoute:
    AuthenticatedProjectsProjectIdIndexRoute,
  AuthenticatedPartsComponentsIpnDetailsRouteRoute:
    AuthenticatedPartsComponentsIpnDetailsRouteRouteWithChildren,
  AuthenticatedPartsCustomDetailsCustomPartSpecificationIdRouteRoute:
    AuthenticatedPartsCustomDetailsCustomPartSpecificationIdRouteRouteWithChildren,
  AuthenticatedProjectsProjectIdSourcingSidebarRouteRoute:
    AuthenticatedProjectsProjectIdSourcingSidebarRouteRouteWithChildren,
  AuthenticatedAssembliesAssemblyIdSubassembliesCreateRoute:
    AuthenticatedAssembliesAssemblyIdSubassembliesCreateRoute,
  AuthenticatedManufacturingActivitiesActivityIdDuplicateRoute:
    AuthenticatedManufacturingActivitiesActivityIdDuplicateRoute,
  AuthenticatedManufacturingActivitiesActivityIdEditRoute:
    AuthenticatedManufacturingActivitiesActivityIdEditRoute,
  AuthenticatedManufacturingDriversDriverIdDuplicateRoute:
    AuthenticatedManufacturingDriversDriverIdDuplicateRoute,
  AuthenticatedManufacturingDriversDriverIdEditRoute:
    AuthenticatedManufacturingDriversDriverIdEditRoute,
  AuthenticatedManufacturingExpensesExpenseIdDuplicateRoute:
    AuthenticatedManufacturingExpensesExpenseIdDuplicateRoute,
  AuthenticatedManufacturingExpensesExpenseIdEditRoute:
    AuthenticatedManufacturingExpensesExpenseIdEditRoute,
  AuthenticatedManufacturingResourcesResourceIdDuplicateRoute:
    AuthenticatedManufacturingResourcesResourceIdDuplicateRoute,
  AuthenticatedManufacturingResourcesResourceIdEditRoute:
    AuthenticatedManufacturingResourcesResourceIdEditRoute,
  AuthenticatedPartsOffersOfferIdDuplicateRoute:
    AuthenticatedPartsOffersOfferIdDuplicateRoute,
  AuthenticatedPartsOffersOfferIdEditRoute:
    AuthenticatedPartsOffersOfferIdEditRoute,
  AuthenticatedProjectsProjectIdCalculationPrintRoute:
    AuthenticatedProjectsProjectIdCalculationPrintRoute,
  AuthenticatedProjectsProjectIdFlexibleCalculationFlexibleCalculationIdRoute:
    AuthenticatedProjectsProjectIdFlexibleCalculationFlexibleCalculationIdRoute,
  AuthenticatedProjectsProjectIdOrderConfirmationRoute:
    AuthenticatedProjectsProjectIdOrderConfirmationRoute,
  AuthenticatedProjectsProjectIdSourcingDemandGroupsRoute:
    AuthenticatedProjectsProjectIdSourcingDemandGroupsRoute,
  AuthenticatedSettingsOrganizationPcbPanelPreferenceIdRoute:
    AuthenticatedSettingsOrganizationPcbPanelPreferenceIdRoute,
  AuthenticatedSettingsOrganizationPcbAddPreferenceRoute:
    AuthenticatedSettingsOrganizationPcbAddPreferenceRoute,
  AuthenticatedSettingsOrganizationUsersImporterRoute:
    AuthenticatedSettingsOrganizationUsersImporterRoute,
  AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdExcelImporterRoute:
    AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdExcelImporterRoute,
  AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdImportPdfRoute:
    AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdImportPdfRoute,
  AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdPdfImporterRoute:
    AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdPdfImporterRoute,
  AuthenticatedSuppliersSupplierIdSupplierContactsImporterSplatRoute:
    AuthenticatedSuppliersSupplierIdSupplierContactsImporterSplatRoute,
  AuthenticatedSuppliersSupplierIdSupplierContactsImporterRoute:
    AuthenticatedSuppliersSupplierIdSupplierContactsImporterRoute,
  AuthenticatedTemplatesCalculationTemplateIdEditRoute:
    AuthenticatedTemplatesCalculationTemplateIdEditRoute,
  AuthenticatedTemplatesEmailEmailTemplateIdUpdateRoute:
    AuthenticatedTemplatesEmailEmailTemplateIdUpdateRoute,
  AuthenticatedProjectsProjectIdBomIndexRoute:
    AuthenticatedProjectsProjectIdBomIndexRoute,
  AuthenticatedProjectsProjectIdCalculationIndexRoute:
    AuthenticatedProjectsProjectIdCalculationIndexRoute,
  AuthenticatedProjectsProjectIdFlexibleCalculationIndexRoute:
    AuthenticatedProjectsProjectIdFlexibleCalculationIndexRoute,
  AuthenticatedProjectsProjectIdManufacturingIndexRoute:
    AuthenticatedProjectsProjectIdManufacturingIndexRoute,
  AuthenticatedProjectsProjectIdOrderIndexRoute:
    AuthenticatedProjectsProjectIdOrderIndexRoute,
  AuthenticatedProjectsProjectIdSourcingIndexRoute:
    AuthenticatedProjectsProjectIdSourcingIndexRoute,
  AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdIndexRoute:
    AuthenticatedSupplierPortalQuoteRequestsQuoteRequestIdIndexRoute,
  AuthenticatedProjectsProjectIdBomAssemblyAddAssemblyRoute:
    AuthenticatedProjectsProjectIdBomAssemblyAddAssemblyRoute,
  AuthenticatedProjectsProjectIdCalculationAssemblyIdCalculationRoute:
    AuthenticatedProjectsProjectIdCalculationAssemblyIdCalculationRoute,
  AuthenticatedProjectsProjectIdCalculationAssembliesAssemblyIdRoute:
    AuthenticatedProjectsProjectIdCalculationAssembliesAssemblyIdRoute,
  AuthenticatedProjectsProjectIdSourcingAssemblyAssemblyIdRoute:
    AuthenticatedProjectsProjectIdSourcingAssemblyAssemblyIdRoute,
  AuthenticatedProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdIndexRoute:
    AuthenticatedProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdIndexRoute,
  AuthenticatedSettingsOrganizationPcbPanelPreferencesIndexRoute:
    AuthenticatedSettingsOrganizationPcbPanelPreferencesIndexRoute,
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRoute:
    AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPcbRouteRouteWithChildren,
  AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarRouteRoute:
    AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdSidebarRouteRouteWithChildren,
  AuthenticatedNegotiationsNegotiationIdScenariosSourcingScenarioIdLineSourcingLineItemIdRoute:
    AuthenticatedNegotiationsNegotiationIdScenariosSourcingScenarioIdLineSourcingLineItemIdRoute,
  AuthenticatedPartsComponentsIpnOffersOfferIdDuplicateRoute:
    AuthenticatedPartsComponentsIpnOffersOfferIdDuplicateRoute,
  AuthenticatedPartsComponentsIpnOffersOfferIdEditRoute:
    AuthenticatedPartsComponentsIpnOffersOfferIdEditRoute,
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdDetailsRoute:
    AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdDetailsRoute,
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdEditRoute:
    AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdEditRoute,
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPnpImporterRoute:
    AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdPnpImporterRoute,
  AuthenticatedProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdActivityRoute:
    AuthenticatedProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdActivityRoute,
  AuthenticatedProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdExpenseRoute:
    AuthenticatedProjectsProjectIdManufacturingManufacturingAssemblyDetailsIdManufacturingScenarioIdExpenseRoute,
  AuthenticatedProjectsProjectIdSourcingSourcingScenarioIdLineSourcingLineItemIdRoute:
    AuthenticatedProjectsProjectIdSourcingSourcingScenarioIdLineSourcingLineItemIdRoute,
  AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdPurchaseOrdersRoute:
    AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdPurchaseOrdersRoute,
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdIndexRoute:
    AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdIndexRoute,
  AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdIndexRoute:
    AuthenticatedProjectsProjectIdSourcingScenariosSourcingScenarioIdIndexRoute,
  AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdSubassembliesCreateRoute:
    AuthenticatedProjectsProjectIdBomAssemblyAssemblyIdSubassembliesCreateRoute,
  AuthenticatedProjectsProjectIdSourcingOfferCustomPartOfferIdDuplicateRoute:
    AuthenticatedProjectsProjectIdSourcingOfferCustomPartOfferIdDuplicateRoute,
  AuthenticatedProjectsProjectIdSourcingOfferCustomPartOfferIdEditRoute:
    AuthenticatedProjectsProjectIdSourcingOfferCustomPartOfferIdEditRoute,
  AuthenticatedProjectsProjectIdSourcingOfferInternalPartNumberOfferIdDuplicateRoute:
    AuthenticatedProjectsProjectIdSourcingOfferInternalPartNumberOfferIdDuplicateRoute,
  AuthenticatedProjectsProjectIdSourcingOfferInternalPartNumberOfferIdEditRoute:
    AuthenticatedProjectsProjectIdSourcingOfferInternalPartNumberOfferIdEditRoute,
  AuthenticatedProjectsProjectIdSourcingOfferOffTheShelfOfferIdDuplicateRoute:
    AuthenticatedProjectsProjectIdSourcingOfferOffTheShelfOfferIdDuplicateRoute,
  AuthenticatedProjectsProjectIdSourcingOfferOffTheShelfOfferIdEditRoute:
    AuthenticatedProjectsProjectIdSourcingOfferOffTheShelfOfferIdEditRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  CallbackRoute: CallbackRoute,
  LandingRoute: LandingRoute,
  AuthEnterEmailRoute: AuthEnterEmailRoute,
  AuthSignupCustomerRoute: AuthSignupCustomerRoute,
  AuthSignupInviteRoute: AuthSignupInviteRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
